import _get from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/get";
import _defineProperty from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

var _zu, _Ur;

var sp = Object.create,
    $r = Object.defineProperty,
    op = Object.getPrototypeOf,
    np = Object.prototype.hasOwnProperty,
    ap = Object.getOwnPropertyNames,
    lp = Object.getOwnPropertyDescriptor;

var C = Object.assign,
    tu = function tu(s) {
  return $r(s, "__esModule", {
    value: !0
  });
};

var Ce = function Ce(s, e) {
  return function () {
    return e || (e = {
      exports: {}
    }, s(e.exports, e)), e.exports;
  };
},
    we = function we(s, e) {
  tu(s);

  for (var t in e) {
    $r(s, t, {
      get: e[t],
      enumerable: !0
    });
  }
},
    cp = function cp(s, e, t) {
  if (tu(s), e && typeof e == "object" || typeof e == "function") {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var i = _step.value;
        !np.call(s, i) && i !== "default" && $r(s, i, {
          get: function get() {
            return e[i];
          },
          enumerable: !(t = lp(e, i)) || t.enumerable
        });
      };

      for (var _iterator = ap(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return s;
},
    Te = function Te(s) {
  return s && s.__esModule ? s : cp($r(s != null ? sp(op(s)) : {}, "default", {
    value: s,
    enumerable: !0
  }), s);
};

var S = function S(s, e, t) {
  return typeof e != "symbol" && (e += ""), e in s ? $r(s, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : s[e] = t;
};

var mt = function mt(s, e, t) {
  return new Promise(function (i, r) {
    var o = function o(l) {
      try {
        a(t.next(l));
      } catch (c) {
        r(c);
      }
    },
        n = function n(l) {
      try {
        a(t.throw(l));
      } catch (c) {
        r(c);
      }
    },
        a = function a(l) {
      return l.done ? i(l.value) : Promise.resolve(l.value).then(o, n);
    };

    a((t = t.apply(s, e)).next());
  });
};

var Qi = Ce(function (wp) {
  we(wp, {
    glGet: function glGet() {
      return Xs;
    },
    webUtils: function webUtils() {
      return Rp;
    }
  });

  var Xs = function Xs(s) {
    var e = {
      preserveDrawingBuffer: !0
    };
    return s.getContext("webgl", e) || s.getContext("experimental-webgl", e);
  },
      Dp = function Dp() {
    var s = Xs(rs()),
        e = s.getParameter(s.MAX_TEXTURE_SIZE),
        t = s.getExtension("WEBGL_lose_context");
    return t && t.loseContext(), e;
  },
      kp = function kp(s, e) {
    if (e instanceof Ks) s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, e.width, e.height, 0, s.RGBA, s.UNSIGNED_BYTE, e.data);else {
      var t = pu(e);
      s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, s.RGBA, s.UNSIGNED_BYTE, t);
    }
  },
      Tp = function Tp(s) {
    return Boolean(s.tagName && s.tagName.toUpperCase() === "IMG");
  },
      Rp = {
    isSupported: function isSupported() {
      return Boolean(Xs(rs()));
    },
    isCanvas: function isCanvas(s) {
      return s.constructor.name === "Canvas" || Boolean(s.tagName && s.tagName.toUpperCase() === "CANVAS");
    },
    isImage: Tp,
    Image: window.Image,
    glMaxTexture: Dp,
    glGet: Xs,
    createCanvas: rs,
    glResize: function glResize(s, e) {
      return s;
    },
    glTexImage: kp
  };
});
var $i = Ce(function (gw, xu) {
  "use strict";

  function Ip(s, e) {
    return Object.prototype.hasOwnProperty.call(s, e);
  }

  xu.exports = function (s, e, t, i) {
    e = e || "&", t = t || "=";
    var r = {};
    if (typeof s != "string" || s.length === 0) return r;
    var o = /\+/g;
    s = s.split(e);
    var n = 1e3;
    i && typeof i.maxKeys == "number" && (n = i.maxKeys);
    var a = s.length;
    n > 0 && a > n && (a = n);

    for (var l = 0; l < a; ++l) {
      var c = s[l].replace(o, "%20"),
          u = c.indexOf(t),
          p,
          h,
          d,
          g;
      u >= 0 ? (p = c.substr(0, u), h = c.substr(u + 1)) : (p = c, h = ""), d = decodeURIComponent(p), g = decodeURIComponent(h), Ip(r, d) ? Array.isArray(r[d]) ? r[d].push(g) : r[d] = [r[d], g] : r[d] = g;
    }

    return r;
  };
});
var Ji = Ce(function (fw, vu) {
  "use strict";

  var ss = function ss(s) {
    switch (typeof s) {
      case "string":
        return s;

      case "boolean":
        return s ? "true" : "false";

      case "number":
        return isFinite(s) ? s : "";

      default:
        return "";
    }
  };

  vu.exports = function (s, e, t, i) {
    return e = e || "&", t = t || "=", s === null && (s = void 0), typeof s == "object" ? Object.keys(s).map(function (r) {
      var o = encodeURIComponent(ss(r)) + t;
      return Array.isArray(s[r]) ? s[r].map(function (n) {
        return o + encodeURIComponent(ss(n));
      }).join(e) : o + encodeURIComponent(ss(s[r]));
    }).join(e) : i ? encodeURIComponent(ss(i)) + t + encodeURIComponent(ss(s)) : "";
  };
});
var er = Ce(function (os) {
  "use strict";

  os.decode = os.parse = $i();
  os.encode = os.stringify = Ji();
});
var ke = Ce(function (Uu, us) {
  (function () {
    var s, e, t, i, r, o;
    typeof performance != "undefined" && performance !== null && performance.now ? us.exports = function () {
      return performance.now();
    } : typeof process != "undefined" && process !== null && process.hrtime ? (us.exports = function () {
      return (s() - r) / 1e6;
    }, e = process.hrtime, s = function s() {
      var n;
      return n = e(), n[0] * 1e9 + n[1];
    }, i = s(), o = process.uptime() * 1e9, r = i - o) : Date.now ? (us.exports = function () {
      return Date.now() - t;
    }, t = Date.now()) : (us.exports = function () {
      return new Date().getTime() - t;
    }, t = new Date().getTime());
  }).call(Uu);
});
var ar = Ce(function (Wk, Xa) {
  var hs = function hs() {
    function s(u) {
      return i.appendChild(u.dom), u;
    }

    function e(u) {
      for (var p = 0; p < i.children.length; p++) {
        i.children[p].style.display = p === u ? "block" : "none";
      }

      t = u;
    }

    var t = 0,
        i = document.createElement("div");
    i.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000", i.addEventListener("click", function (u) {
      u.preventDefault(), e(++t % i.children.length);
    }, !1);
    var r = (performance || Date).now(),
        o = r,
        n = 0,
        a = s(new hs.Panel("FPS", "#0ff", "#002")),
        l = s(new hs.Panel("MS", "#0f0", "#020"));
    if (self.performance && self.performance.memory) var c = s(new hs.Panel("MB", "#f08", "#201"));
    return e(0), {
      REVISION: 16,
      dom: i,
      addPanel: s,
      showPanel: e,
      begin: function begin() {
        r = (performance || Date).now();
      },
      end: function end() {
        n++;
        var u = (performance || Date).now();

        if (l.update(u - r, 200), u > o + 1e3 && (a.update(1e3 * n / (u - o), 100), o = u, n = 0, c)) {
          var p = performance.memory;
          c.update(p.usedJSHeapSize / 1048576, p.jsHeapSizeLimit / 1048576);
        }

        return u;
      },
      update: function update() {
        r = this.end();
      },
      domElement: i,
      setMode: e
    };
  };

  hs.Panel = function (s, e, t) {
    var i = Infinity,
        r = 0,
        o = Math.round,
        n = o(window.devicePixelRatio || 1),
        a = 80 * n,
        l = 48 * n,
        c = 3 * n,
        u = 2 * n,
        p = 3 * n,
        h = 15 * n,
        d = 74 * n,
        g = 30 * n,
        y = document.createElement("canvas");
    y.width = a, y.height = l, y.style.cssText = "width:80px;height:48px";

    var _ = y.getContext("2d");

    return _.font = "bold " + 9 * n + "px Helvetica,Arial,sans-serif", _.textBaseline = "top", _.fillStyle = t, _.fillRect(0, 0, a, l), _.fillStyle = e, _.fillText(s, c, u), _.fillRect(p, h, d, g), _.fillStyle = t, _.globalAlpha = .9, _.fillRect(p, h, d, g), {
      dom: y,
      update: function update(f, v) {
        i = Math.min(i, f), r = Math.max(r, f), _.fillStyle = t, _.globalAlpha = 1, _.fillRect(0, 0, a, h), _.fillStyle = e, _.fillText(o(f) + " " + s + " (" + o(i) + "-" + o(r) + ")", c, u), _.drawImage(y, p + n, h, d - n, g, p, h, d - n, g), _.fillRect(p + d - n, h, n, g), _.fillStyle = t, _.globalAlpha = .9, _.fillRect(p + d - n, h, n, o((1 - f / v) * g));
      }
    };
  };

  typeof Xa == "object" && (Xa.exports = hs);
});
var vr = Ce(function (XO, lh) {
  "use strict";

  lh.exports = function (s) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var t = arguments.length > 2 ? arguments[2] : undefined;
    if (t = C({
      indent: " ",
      includeEmptyLines: !1
    }, t), typeof s != "string") throw new TypeError("Expected `input` to be a `string`, got `".concat(typeof s, "`"));
    if (typeof e != "number") throw new TypeError("Expected `count` to be a `number`, got `".concat(typeof e, "`"));
    if (typeof t.indent != "string") throw new TypeError("Expected `options.indent` to be a `string`, got `".concat(typeof t.indent, "`"));
    if (e === 0) return s;
    var i = t.includeEmptyLines ? /^/gm : /^(?!\s*$)/gm;
    return s.replace(i, t.indent.repeat(e));
  };
});
var Cr = Ce(function () {});
var wr = Ce(function ($O, ch) {
  "use strict";

  var uh = Cr(),
      mh = /\s+at.*(?:\(|\s)(.*)\)?/,
      w_ = /^(?:(?:(?:node|(?:internal\/[\w/]*|.*node_modules\/(?:babel-polyfill|pirates)\/.*)?\w+)\.js:\d+:\d+)|native)/,
      D_ = typeof uh.homedir == "undefined" ? "" : uh.homedir();

  ch.exports = function (s, e) {
    return e = Object.assign({
      pretty: !1
    }, e), s.replace(/\\/g, "/").split("\n").filter(function (t) {
      var i = t.match(mh);
      if (i === null || !i[1]) return !0;
      var r = i[1];
      return r.includes(".app/Contents/Resources/electron.asar") || r.includes(".app/Contents/Resources/default_app.asar") ? !1 : !w_.test(r);
    }).filter(function (t) {
      return t.trim() !== "";
    }).map(function (t) {
      return e.pretty ? t.replace(mh, function (i, r) {
        return i.replace(r, r.replace(D_, "~"));
      }) : t;
    }).join("\n");
  };
});
var Dr = Ce(function (JO, dh) {
  "use strict";

  var k_ = vr(),
      T_ = wr(),
      R_ = function R_(s) {
    return s.replace(/\s+at .*aggregate-error\/index.js:\d+:\d+\)?/g, "");
  },
      hh =
  /*#__PURE__*/
  function (_Error) {
    _inherits(hh, _Error);

    function hh(e) {
      var _this;

      _classCallCheck(this, hh);

      if (!Array.isArray(e)) throw new TypeError("Expected input to be an Array, got ".concat(typeof e));
      e = _toConsumableArray(e).map(function (i) {
        return i instanceof Error ? i : i !== null && typeof i == "object" ? Object.assign(new Error(i.message), i) : new Error(i);
      });
      var t = e.map(function (i) {
        return typeof i.stack == "string" ? R_(T_(i.stack)) : String(i);
      }).join("\n");
      t = "\n" + k_(t, 4), _this = _possibleConstructorReturn(this, _getPrototypeOf(hh).call(this, t)), _this.name = "AggregateError", Object.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_errors", {
        value: e
      });
      return _this;
    }

    _createClass(hh, [{
      key: Symbol.iterator,
      value:
      /*#__PURE__*/
      _regeneratorRuntime.mark(function value() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, e;

        return _regeneratorRuntime.wrap(function value$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 3;
                _iterator2 = this._errors[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context.next = 12;
                  break;
                }

                e = _step2.value;
                _context.next = 9;
                return e;

              case 9:
                _iteratorNormalCompletion2 = true;
                _context.next = 5;
                break;

              case 12:
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 18:
                _context.prev = 18;
                _context.prev = 19;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 21:
                _context.prev = 21;

                if (!_didIteratorError2) {
                  _context.next = 24;
                  break;
                }

                throw _iteratorError2;

              case 24:
                return _context.finish(21);

              case 25:
                return _context.finish(18);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, value, this, [[3, 14, 18, 26], [19,, 21, 25]]);
      })
    }]);

    return hh;
  }(_wrapNativeSuper(Error));

  dh.exports = hh;
});
var Ct = Ce(function (Dc, ph) {
  "use strict";

  var F_ = Dr();

  ph.exports = function (r, o) {
    for (var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      n[_key - 2] = arguments[_key];
    }

    return mt(Dc, [r, o].concat(n),
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(s, e) {
      var _ref,
          _ref$concurrency,
          t,
          _ref$stopOnError,
          i,
          _args3 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {}, _ref$concurrency = _ref.concurrency, t = _ref$concurrency === void 0 ? Infinity : _ref$concurrency, _ref$stopOnError = _ref.stopOnError, i = _ref$stopOnError === void 0 ? !0 : _ref$stopOnError;
              return _context3.abrupt("return", new Promise(function (a, l) {
                if (typeof e != "function") throw new TypeError("Mapper function is required");
                if (!((Number.isSafeInteger(t) || t === Infinity) && t >= 1)) throw new TypeError("Expected `concurrency` to be an integer from 1 and up or `Infinity`, got `".concat(t, "` (").concat(typeof t, ")"));

                var c = [],
                    u = [],
                    p = s[Symbol.iterator](),
                    h = !1,
                    d = !1,
                    g = 0,
                    y = 0,
                    _ = function _() {
                  if (h) return;
                  var f = p.next(),
                      v = y;

                  if (y++, f.done) {
                    d = !0, g === 0 && (!i && u.length !== 0 ? l(new F_(u)) : a(c));
                    return;
                  }

                  g++, function () {
                    return mt(Dc, null,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      var b;
                      return _regeneratorRuntime.wrap(function _callee$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.prev = 0;
                              _context2.next = 3;
                              return f.value;

                            case 3:
                              b = _context2.sent;
                              _context2.next = 6;
                              return e(b, v);

                            case 6:
                              c[v] = _context2.sent;
                              g--;

                              _();

                              _context2.next = 14;
                              break;

                            case 11:
                              _context2.prev = 11;
                              _context2.t0 = _context2["catch"](0);
                              i ? (h = !0, l(_context2.t0)) : (u.push(_context2.t0), g--, _());

                            case 14:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee, null, [[0, 11]]);
                    }));
                  }();
                };

                for (var f = 0; f < t && (_(), !d); f++) {
                  ;
                }
              }));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee2);
    }));
  };
});
var Mr = Ce(function (ry) {
  we(ry, {
    default: function _default() {
      return sy;
    }
  });

  var vn =
  /*#__PURE__*/
  function () {
    function vn(e) {
      _classCallCheck(this, vn);

      this._editor = e;
    }

    _createClass(vn, [{
      key: "serialize",
      value: function serialize() {
        var _ref2;

        return (_ref2 = new xn(this._editor)).serialize.apply(_ref2, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new yn(this._editor, e).deserialize();
      }
    }]);

    return vn;
  }(),
      sy = vn;

  vn.version = "1.0.0";
});
var Lr = Ce(function (oy) {
  we(oy, {
    default: function _default() {
      return ny;
    }
  });

  var Tn =
  /*#__PURE__*/
  function () {
    function Tn(e) {
      _classCallCheck(this, Tn);

      this._editor = e;
    }

    _createClass(Tn, [{
      key: "serialize",
      value: function serialize() {
        var _ref3;

        return (_ref3 = new kn(this._editor)).serialize.apply(_ref3, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new wn(this._editor, e).deserialize();
      }
    }]);

    return Tn;
  }(),
      ny = Tn;

  Tn.version = "1.0.1";
});
var Nr = Ce(function (ly) {
  we(ly, {
    default: function _default() {
      return cy;
    }
  });

  var In =
  /*#__PURE__*/
  function () {
    function In(e) {
      _classCallCheck(this, In);

      this._editor = e;
    }

    _createClass(In, [{
      key: "serialize",
      value: function serialize() {
        var _ref4;

        return (_ref4 = new An(this._editor)).serialize.apply(_ref4, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new En(this._editor, e).deserialize();
      }
    }]);

    return In;
  }(),
      cy = In;

  In.version = "2.0.0";
});
var Gr = Ce(function (uy) {
  we(uy, {
    default: function _default() {
      return my;
    }
  });

  var Un =
  /*#__PURE__*/
  function () {
    function Un(e) {
      _classCallCheck(this, Un);

      this._editor = e;
    }

    _createClass(Un, [{
      key: "serialize",
      value: function serialize() {
        var _ref5;

        return (_ref5 = new zn(this._editor)).serialize.apply(_ref5, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new Pn(this._editor, e).deserialize();
      }
    }]);

    return Un;
  }(),
      my = Un;

  Un.version = "3.0.0";
});
var Wr = Ce(function (dy) {
  we(dy, {
    default: function _default() {
      return hy;
    }
  });

  var Hn =
  /*#__PURE__*/
  function () {
    function Hn(e) {
      _classCallCheck(this, Hn);

      this._editor = e;
    }

    _createClass(Hn, [{
      key: "serialize",
      value: function serialize() {
        var _ref6;

        return (_ref6 = new Vn(this._editor)).serialize.apply(_ref6, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new Gn(this._editor, e).deserialize();
      }
    }]);

    return Hn;
  }(),
      hy = Hn;

  Hn.version = "3.1.0";
});
var Vr = Ce(function (py) {
  we(py, {
    default: function _default() {
      return gy;
    }
  });

  var Xn =
  /*#__PURE__*/
  function () {
    function Xn(e) {
      _classCallCheck(this, Xn);

      this._editor = e;
    }

    _createClass(Xn, [{
      key: "serialize",
      value: function serialize() {
        var _ref7;

        return (_ref7 = new Kn(this._editor)).serialize.apply(_ref7, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new Yn(this._editor, e).deserialize();
      }
    }]);

    return Xn;
  }(),
      gy = Xn;

  Xn.version = "3.2.0";
});
var Hr = Ce(function (fy) {
  we(fy, {
    default: function _default() {
      return _y;
    }
  });

  var ea =
  /*#__PURE__*/
  function () {
    function ea(e) {
      _classCallCheck(this, ea);

      this._editor = e;
    }

    _createClass(ea, [{
      key: "serialize",
      value: function serialize() {
        var _ref8;

        return (_ref8 = new Jn(this._editor)).serialize.apply(_ref8, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new Zn(this._editor, e).deserialize();
      }
    }]);

    return ea;
  }(),
      _y = ea;

  ea.version = "3.4.0";
});
var jr = Ce(function (yy) {
  we(yy, {
    default: function _default() {
      return by;
    }
  });

  var oa =
  /*#__PURE__*/
  function () {
    function oa(e) {
      _classCallCheck(this, oa);

      this._editor = e;
    }

    _createClass(oa, [{
      key: "serialize",
      value: function serialize() {
        var _ref9;

        return (_ref9 = new sa(this._editor)).serialize.apply(_ref9, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new ia(this._editor, e).deserialize();
      }
    }]);

    return oa;
  }(),
      by = oa;

  oa.version = "3.5.0";
});
var Yr = Ce(function (xy) {
  we(xy, {
    default: function _default() {
      return vy;
    }
  });

  var ua =
  /*#__PURE__*/
  function () {
    function ua(e) {
      _classCallCheck(this, ua);

      this._editor = e;
    }

    _createClass(ua, [{
      key: "serialize",
      value: function serialize() {
        var _ref10;

        return (_ref10 = new ca(this._editor)).serialize.apply(_ref10, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new aa(this._editor, e).deserialize();
      }
    }]);

    return ua;
  }(),
      vy = ua;

  ua.version = "3.6.0";
});
var qr = Ce(function (Cy) {
  we(Cy, {
    default: function _default() {
      return wy;
    }
  });

  var ga =
  /*#__PURE__*/
  function () {
    function ga(e) {
      _classCallCheck(this, ga);

      this._editor = e;
    }

    _createClass(ga, [{
      key: "serialize",
      value: function serialize() {
        var _ref11;

        return (_ref11 = new pa(this._editor)).serialize.apply(_ref11, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new da(this._editor, e).deserialize();
      }
    }]);

    return ga;
  }(),
      wy = ga;

  ga.version = "3.7.0";
});
var Kr = Ce(function (Dy) {
  we(Dy, {
    default: function _default() {
      return ky;
    }
  });

  var xa =
  /*#__PURE__*/
  function () {
    function xa(e) {
      _classCallCheck(this, xa);

      this._editor = e;
    }

    _createClass(xa, [{
      key: "serialize",
      value: function serialize() {
        var _ref12;

        return (_ref12 = new ba(this._editor)).serialize.apply(_ref12, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new _a(this._editor, e).deserialize();
      }
    }]);

    return xa;
  }(),
      ky = xa;

  xa.version = "3.8.0";
});
var Xr = Ce(function (Ty) {
  we(Ty, {
    default: function _default() {
      return Ry;
    }
  });

  var wa =
  /*#__PURE__*/
  function () {
    function wa(e) {
      _classCallCheck(this, wa);

      this._editor = e;
    }

    _createClass(wa, [{
      key: "serialize",
      value: function serialize() {
        var _ref13;

        return (_ref13 = new tp(this._editor)).serialize.apply(_ref13, arguments);
      }
    }, {
      key: "deserialize",
      value: function deserialize(e) {
        return new Jh(this._editor, e).deserialize();
      }
    }]);

    return wa;
  }(),
      Ry = wa;

  wa.version = "3.9.0";
});
var iu;

(function (s) {
  s.OBJECT = "object";
})(iu || (iu = {}));

var Jr;

(function (s) {
  s.UNDO = "undo", s.REDO = "redo", s.DELETE = "delete", s.BRING_TO_FRONT = "bringtofront", s.EDIT = "edit", s.DUPLICATE = "duplicate", s.ADD = "add", s.FLIP = "flip", s.INVERT = "invert", s.CLOSE = "close", s.EXPORT = "export";
})(Jr || (Jr = {}));

var Ge;

(function (s) {
  s.LIBRARY = "library", s.ART_FILTER = "artFilter", s.TRANSFORM = "transform", s.FILTER = "filter", s.ADJUSTMENT = "adjustment", s.FOCUS = "focus", s.STICKER = "sticker", s.TEXT = "text", s.TEXT_DESIGN = "textdesign", s.OVERLAY = "overlay", s.FRAME = "frame", s.BRUSH = "brush";
})(Ge || (Ge = {}));

var Ki;

(function (s) {
  s.TEXT = "text", s.CARD = "card";
})(Ki || (Ki = {}));

var ru;

(function (s) {
  s.LARGE = "large", s.MEDIUM = "medium", s.SMALL = "small";
})(ru || (ru = {}));

var su;

(function (s) {
  s.ERROR = "error", s.WARNING = "warning", s.INFO = "info", s.TEXT_EDIT = "textEdit";
})(su || (su = {}));

var Hs;

(function (s) {
  s.IMAGE = "image", s.DATA_URL = "data-url", s.BLOB = "blob", s.MSBLOB = "ms-blob";
})(Hs || (Hs = {}));

var js;

(function (s) {
  s.PNG = "image/png", s.JPEG = "image/jpeg";
})(js || (js = {}));

var ou;

(function (s) {
  s.BMP = "image/bmp", s.GIF = "image/gif", s.ICO = "image/x-icon", s.JPEG = "image/jpeg", s.PNG = "image/png", s.SVG = "image/svg+xml", s.TIFF = "image/tiff", s.WEBP = "image/webp";
})(ou || (ou = {}));

var up = function up() {
  _classCallCheck(this, up);

  this.order = "default";
  this.language = "en";
  this.theme = "dark";
  this.assetBaseUrl = "assets/";
  this.displayResizeWarning = !1;
  this.displayCloseWarning = !0;
  this.displayCanvasRendererWarning = !0;
  this.displayToolControlBarTitle = !0;
  this.forceCrop = !1;
  this.enableZoom = !0;
  this.defaultTool = Ge.FILTER;
};

Ge.FILTER, Ge.FOCUS, Ge.ADJUSTMENT, Ge.LIBRARY, Ge.OVERLAY, Ge.STICKER, Ge.TEXT, Ge.TEXT_DESIGN, Ge.FRAME, Ge.BRUSH, Ge.TRANSFORM;
var ze;

(function (s) {
  s.BRIGHTNESS = "brightness", s.CONTRAST = "contrast", s.SATURATION = "saturation", s.CLARITY = "clarity", s.SHADOWS = "shadows", s.HIGHLIGHTS = "highlights", s.EXPOSURE = "exposure", s.GAMMA = "gamma", s.BLACKS = "blacks", s.WHITES = "whites", s.TEMPERATURE = "temperature", s.SHARPNESS = "sharpness";
})(ze || (ze = {}));

var Ky = Object.values(ze).reduce(function (s, e) {
  return s[e] = !0, s;
}, {});
var P;

(function (s) {
  s.Desert = "imgly_duotone_desert", s.Peach = "imgly_duotone_peach", s.Clash = "imgly_duotone_clash", s.Plum = "imgly_duotone_plum", s.Breezy = "imgly_duotone_breezy", s.DeepBlue = "imgly_duotone_deepblue", s.Frog = "imgly_duotone_frog", s.Sunset = "imgly_duotone_sunset", s.AD1920 = "imgly_lut_ad1920", s.Greyed = "imgly_lut_bw", s.Dusty = "imgly_lut_x400", s.Litho = "imgly_lut_litho", s.Sepia = "imgly_lut_sepiahigh", s.Weathered = "imgly_lut_plate", s.HardStuff = "imgly_lut_sin", s.Polaroid = "imgly_lut_blues", s.Sunny70s = "imgly_lut_front", s.Oldtimer = "imgly_lut_texas", s.Inferno = "imgly_lut_celsius", s.Snappy = "imgly_lut_cool", s.Chestnut = "imgly_lut_chest", s.Softy = "imgly_lut_winter", s.Pebble = "imgly_lut_kdynamic", s.Moss = "imgly_lut_fall", s.Lemon = "imgly_lut_lenin", s.GreenGap = "imgly_lut_pola669", s.Colla = "imgly_lut_elder", s.Solanus = "imgly_lut_orchid", s.Kalmen = "imgly_lut_bleached", s.Joran = "imgly_lut_bleachedblue", s.Levante = "imgly_lut_breeze", s.Zephyr = "imgly_lut_blueshadows", s.Golden = "imgly_lut_sunset", s.LowFire = "imgly_lut_eighties", s.Sunrise = "imgly_lut_evening", s.FlatBlack = "imgly_lut_k2", s.Pumpkin = "imgly_lut_nogreen", s.Ancient = "imgly_lut_ancient", s.Candy = "imgly_lut_cottoncandy", s.Classic = "imgly_lut_classic", s.Colorful = "imgly_lut_colorful", s.Creamy = "imgly_lut_creamy", s.Fixie = "imgly_lut_fixie", s.Food = "imgly_lut_food", s.Fridge = "imgly_lut_fridge", s.Glam = "imgly_lut_glam", s.Gobblin = "imgly_lut_gobblin", s.Hicon = "imgly_lut_highcontrast", s.HighCarb = "imgly_lut_highcarb", s.K1 = "imgly_lut_k1", s.K6 = "imgly_lut_k6", s.Keen = "imgly_lut_keen", s.Lomo = "imgly_lut_lomo", s.Lomo100 = "imgly_lut_lomo100", s.Lucid = "imgly_lut_lucid", s.Mellow = "imgly_lut_mellow", s.Neat = "imgly_lut_neat", s.Pale = "imgly_lut_pale", s.Pitched = "imgly_lut_pitched", s.PolaSX = "imgly_lut_polasx", s.Pro400 = "imgly_lut_pro400", s.Quozi = "imgly_lut_quozi", s.Settled = "imgly_lut_settled", s.Seventies = "imgly_lut_seventies", s.Soft = "imgly_lut_soft", s.Steel = "imgly_lut_steel", s.Summer = "imgly_lut_summer", s.Tender = "imgly_lut_tender", s.Twilight = "imgly_lut_twilight";
})(P || (P = {}));

var Tt;

(function (s) {
  s.DuoTone = "imgly_filter_category_duotone", s.BW = "imgly_filter_category_bw", s.Vintage = "imgly_filter_category_vintage", s.Smooth = "imgly_filter_category_smooth", s.Cold = "imgly_filter_category_cold", s.Warm = "imgly_filter_category_warm", s.Legacy = "imgly_filter_category_legacy";
})(Tt || (Tt = {}));

var vi;

(function (s) {
  s.RADIAL = "radial", s.LINEAR = "linear", s.MIRRORED = "mirrored", s.GAUSSIAN = "gaussian";
})(vi || (vi = {}));

var De;

(function (s) {
  s.NORMAL = "normal", s.OVERLAY = "overlay", s.SOFT_LIGHT = "softLight", s.HARD_LIGHT = "hardLight", s.MULTIPLY = "multiply", s.DARKEN = "darken", s.COLOR_BURN = "colorBurn", s.SCREEN = "screen", s.LIGHTEN = "lighten";
})(De || (De = {}));

var Re;

(function (s) {
  s.Bokeh = "imgly_overlay_bokeh", s.Chop = "imgly_overlay_chop", s.Clouds = "imgly_overlay_clouds", s.Golden = "imgly_overlay_golden", s.Grain = "imgly_overlay_grain", s.Hearts = "imgly_overlay_hearts", s.LightLeak1 = "imgly_overlay_lightleak1", s.LightLeak2 = "imgly_overlay_lightleak2", s.Metal = "imgly_overlay_metal", s.Mosaic = "imgly_overlay_mosaic", s.Painting = "imgly_overlay_painting", s.Paper = "imgly_overlay_paper", s.Rain = "imgly_overlay_rain", s.Vintage = "imgly_overlay_vintage", s.Wall1 = "imgly_overlay_wall1", s.Wall2 = "imgly_overlay_wall2", s.Wood = "imgly_overlay_wood";
})(Re || (Re = {}));

var nu;

(function (s) {
  s.CommonCategory = "imgly_transforms_common", s.FacebookCategory = "imgly_transforms_facebook", s.TwitterCategory = "imgly_transforms_twitter", s.InstagramCategory = "imgly_transforms_instagram", s.Custom = "imgly_transform_common_custom", s.Square = "imgly_transform_common_square", s.ThreeByFour = "imgly_transform_common_3", s.FourByThree = "imgly_transform_common_4", s.NineBySixteen = "imgly_transform_common_9", s.SixteenByNine = "imgly_transform_common_16", s.FacebookPost = "imgly_transform_facebook_post", s.FacebookProfile = "imgly_transform_facebook_profile", s.FacebookTitle = "imgly_transform_facebook_title", s.InstagramLandscape = "imgly_transform_instagram_landscape", s.InstagramPortrait = "imgly_transform_instagram_portrait", s.InstagramSquare = "imgly_transform_instagram_square", s.InstagramStory = "imgly_transform_instagram_story", s.TwitterPost = "imgly_transform_twitter_post", s.TwitterProfile = "imgly_transform_twitter_profile", s.TwitterTitle = "imgly_transform_twitter_title";
})(nu || (nu = {}));

var au;

(function (s) {
  s.EXPORT = "export", s.CLOSE = "close", s.HISTORY_CHANGE = "historyChange", s.EDITOR_READY = "editorReady", s.ERROR_IMAGE_LOADING = "errorImageLoading", s.IMAGE_LOAD = "imageLoad", s.TOOL_ENTER = "toolEnter", s.STICKER_UPLOAD_ADD = "stickerUploadAdd";
})(au || (au = {}));

var ot = {};
we(ot, {
  absoluteToRelativePoint: function absoluteToRelativePoint() {
    return vp;
  },
  absoluteToRelativeSize: function absoluteToRelativeSize() {
    return bp;
  },
  getBaseLocalToWorldMatrix: function getBaseLocalToWorldMatrix() {
    return qs;
  },
  getLocalToParentMatrix: function getLocalToParentMatrix() {
    return du;
  },
  getLocalToWorldMatrix: function getLocalToWorldMatrix() {
    return Xi;
  },
  getPointInWorldSpace: function getPointInWorldSpace() {
    return Ea;
  },
  getRotationBetweenCoordinateSpaces: function getRotationBetweenCoordinateSpaces() {
    return Cp;
  },
  getScalarInWorldSpace: function getScalarInWorldSpace() {
    return fp;
  },
  getSizeInOutputSpace: function getSizeInOutputSpace() {
    return _p;
  },
  getSizeInWorldSpace: function getSizeInWorldSpace() {
    return hu;
  },
  pointFromSpaceToSpace: function pointFromSpaceToSpace() {
    return is;
  },
  rectTransformToAffineTransform: function rectTransformToAffineTransform() {
    return Ra;
  },
  relativeToAbsolutePoint: function relativeToAbsolutePoint() {
    return xp;
  },
  relativeToAbsoluteSize: function relativeToAbsoluteSize() {
    return yp;
  },
  scalarFromSpaceToSpace: function scalarFromSpaceToSpace() {
    return Fa;
  },
  sizeFromSpaceToSpace: function sizeFromSpaceToSpace() {
    return gp;
  }
});
var g0 = new RegExp(/\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68|\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC69(?:\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFE])|\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFC-\uDFFF]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68\u200D(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68|\uD83D\uDC69\u200D\u2764\uFE0F\u200D(?:\uD83D[\uDC68\uDC69])|\uD83E\uDDD1\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC68(?:\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D[\uDC67-\uDC69])\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]\uFE0F)|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83C\uDFF3\uFE0F\u200D\u26A7|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])\uFE0F|(?:\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF]))\u200D[\u2695\u2696\u2708]\uFE0F|\uD83D\uDC69\u200D(?:\uD83D[\uDC67\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83D\uDC3B\u200D\u2744|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDF])\u200D[\u2640\u2642])\uFE0F|\uD83E\uDDD1\u200D[\u2695\u2696\u2708]\uFE0F|(?:\uD83D[\uDC68\uDC69])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D[\u2695\u2696\u2708]\uFE0F)|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC08\u200D\u2B1B|\uD83E\uDDD1\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDC66\uDC67\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC3\uDFC7]|\uD83D[\uDC43\uDC4A-\uDC4C\uDC4F\uDC50\uDC66-\uDC69\uDC6B-\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD7A\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270C\u270D]|\uD83C[\uDFC2\uDFC4\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC46-\uDC49\uDC4D\uDC4E\uDD74\uDD75\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9\u23EA\u23ED-\u23EF\u23F1-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7\u26F8\u26FA\u26FD\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2753\u2757\u2763\u2764\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE1A\uDE2F\uDE37\uDF0D-\uDF0F\uDF15\uDF1C\uDF21\uDF24-\uDF2C\uDF36\uDF78\uDF7D\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFA7\uDFAC-\uDFAE\uDFC6\uDFCD\uDFCE\uDFD4-\uDFE0\uDFED\uDFF3\uDFF5\uDFF7]|\uD83D[\uDC08\uDC15\uDC1F\uDC26\uDC3F\uDC41\uDC53\uDC6A\uDC7D\uDCA3\uDCB0\uDCB3\uDCBB\uDCBF\uDCCB\uDCDA\uDCDF\uDCE4-\uDCE6\uDCEA-\uDCED\uDCF7\uDCF9-\uDCFB\uDCFD\uDD08\uDD0D\uDD12\uDD13\uDD49\uDD4A\uDD50-\uDD67\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDE10\uDE87\uDE8D\uDE91\uDE94\uDE98\uDEAD\uDEB2\uDEB9\uDEBA\uDEBC\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|[\u23E9-\u23F3\u23F8-\u23FA\u25FB-\u25FE\u2614\u2615\u267F\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26C8\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]/g);
var v0 = [{
  identifier: "basics",
  name: "Basics",
  items: [{
    identifier: ze.BRIGHTNESS
  }, {
    identifier: ze.CONTRAST
  }, {
    identifier: ze.SATURATION
  }, {
    identifier: ze.GAMMA
  }]
}, {
  identifier: "refinements",
  name: "Refinements",
  items: [{
    identifier: ze.CLARITY
  }, {
    identifier: ze.SHADOWS
  }, {
    identifier: ze.HIGHLIGHTS
  }, {
    identifier: ze.EXPOSURE
  }, {
    identifier: ze.BLACKS
  }, {
    identifier: ze.WHITES
  }, {
    identifier: ze.TEMPERATURE
  }, {
    identifier: ze.SHARPNESS
  }]
}];
var k0 = [{
  identifier: Tt.DuoTone,
  name: "DuoTone",
  thumbnailURI: "./categories/duotone.jpg",
  items: [{
    identifier: P.Desert,
    name: "Desert",
    thumbnailURI: "./items/imgly_duotone_desert.jpg",
    lightColor: "#e1de9a",
    darkColor: "#cb2129",
    defaultIntensity: .5
  }, {
    identifier: P.Peach,
    name: "Peach",
    thumbnailURI: "./items/imgly_duotone_peach.jpg",
    lightColor: "#e9abb8",
    darkColor: "#0040ff",
    defaultIntensity: .5
  }, {
    identifier: P.Clash,
    name: "Clash",
    thumbnailURI: "./items/imgly_duotone_clash.jpg",
    lightColor: "#f41a0f",
    darkColor: "#23007c",
    defaultIntensity: .5
  }, {
    identifier: P.Plum,
    name: "Plum",
    thumbnailURI: "./items/imgly_duotone_plum.jpg",
    lightColor: "#74d7ff",
    darkColor: "#23007c",
    defaultIntensity: .5
  }, {
    identifier: P.Breezy,
    name: "Breezy",
    thumbnailURI: "./items/imgly_duotone_breezy.jpg",
    lightColor: "#68fdff",
    darkColor: "#c20000",
    defaultIntensity: .5
  }, {
    identifier: P.DeepBlue,
    name: "Deep Blue",
    thumbnailURI: "./items/imgly_duotone_deepblue.jpg",
    lightColor: "#2de9eb",
    darkColor: "#58007c",
    defaultIntensity: .5
  }, {
    identifier: P.Frog,
    name: "Frog",
    thumbnailURI: "./items/imgly_duotone_frog.jpg",
    lightColor: "#5bff60",
    darkColor: "#7f23a9",
    defaultIntensity: .5
  }, {
    identifier: P.Sunset,
    name: "Sunset",
    thumbnailURI: "./items/imgly_duotone_sunset.jpg",
    lightColor: "#f8ea46",
    darkColor: "#c400be",
    defaultIntensity: .5
  }]
}, {
  identifier: Tt.BW,
  name: "B & W",
  thumbnailURI: "./categories/b&w.jpg",
  items: [{
    identifier: P.AD1920,
    name: "1920 A.D.",
    thumbnailURI: "./items/imgly_lut_ad1920.jpg",
    lutURI: "./items/imgly_lut_ad1920_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Greyed,
    name: "Greyed",
    thumbnailURI: "./items/imgly_lut_bw.jpg",
    lutURI: "./items/imgly_lut_bw_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Dusty,
    name: "Dusty",
    thumbnailURI: "./items/imgly_lut_x400.jpg",
    lutURI: "./items/imgly_lut_dusty_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Litho,
    name: "Litho",
    thumbnailURI: "./items/imgly_lut_litho.jpg",
    lutURI: "./items/imgly_lut_litho_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Sepia,
    name: "Sepia",
    thumbnailURI: "./items/imgly_lut_sepiahigh.jpg",
    lutURI: "./items/imgly_lut_sepia_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Weathered,
    name: "Weathered",
    thumbnailURI: "./items/imgly_lut_plate.jpg",
    lutURI: "./items/imgly_lut_weathered_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.HardStuff,
    name: "Hard Stuff",
    thumbnailURI: "./items/imgly_lut_sin.jpg",
    lutURI: "./items/imgly_lut_hard_stuff_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }]
}, {
  identifier: Tt.Vintage,
  name: "Vintage",
  thumbnailURI: "./categories/vintage.jpg",
  items: [{
    identifier: P.Polaroid,
    name: "Polaroid",
    thumbnailURI: "./items/imgly_lut_blues.jpg",
    lutURI: "./items/imgly_lut_polaroid_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Sunny70s,
    name: "Sunny 70s",
    thumbnailURI: "./items/imgly_lut_front.jpg",
    lutURI: "./items/imgly_lut_sunny_70s_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: P.Oldtimer,
    name: "Oldtimer",
    thumbnailURI: "./items/imgly_lut_texas.jpg",
    lutURI: "./items/imgly_lut_oldtimer_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: P.Inferno,
    name: "Inferno",
    thumbnailURI: "./items/imgly_lut_celsius.jpg",
    lutURI: "./items/imgly_lut_inferno_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: P.Snappy,
    name: "Snappy",
    thumbnailURI: "./items/imgly_lut_cool.jpg",
    lutURI: "./items/imgly_lut_snappy_5_5_128.png",
    defaultIntensity: 1
  }]
}, {
  identifier: Tt.Smooth,
  name: "Smooth",
  thumbnailURI: "./categories/smooth.jpg",
  items: [{
    identifier: P.Chestnut,
    name: "Chestnut",
    thumbnailURI: "./items/imgly_lut_chest.jpg",
    lutURI: "./items/imgly_lut_chestnut_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: P.Softy,
    name: "Softy",
    thumbnailURI: "./items/imgly_lut_winter.jpg",
    lutURI: "./items/imgly_lut_softly_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Pebble,
    name: "Pebble",
    thumbnailURI: "./items/imgly_lut_kdynamic.jpg",
    lutURI: "./items/imgly_lut_pebble_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Moss,
    name: "Moss",
    thumbnailURI: "./items/imgly_lut_fall.jpg",
    lutURI: "./items/imgly_lut_moss_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Lemon,
    name: "Lemon",
    thumbnailURI: "./items/imgly_lut_lenin.jpg",
    lutURI: "./items/imgly_lut_lemon_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.GreenGap,
    name: "Green Gap",
    thumbnailURI: "./items/imgly_lut_pola669.jpg",
    lutURI: "./items/imgly_lut_green_gap_5_5_128.png",
    defaultIntensity: 1
  }]
}, {
  identifier: Tt.Cold,
  name: "Cold",
  thumbnailURI: "./categories/cold.jpg",
  items: [{
    identifier: P.Colla,
    name: "Colla",
    thumbnailURI: "./items/imgly_lut_elder.jpg",
    lutURI: "./items/imgly_lut_colla_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Solanus,
    name: "Solanus",
    thumbnailURI: "./items/imgly_lut_orchid.jpg",
    lutURI: "./items/imgly_lut_solanus_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Kalmen,
    name: "Kalmen",
    thumbnailURI: "./items/imgly_lut_bleached.jpg",
    lutURI: "./items/imgly_lut_kalmen_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Joran,
    name: "Joran",
    thumbnailURI: "./items/imgly_lut_bleachedblue.jpg",
    lutURI: "./items/imgly_lut_joran_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Levante,
    name: "Levante",
    thumbnailURI: "./items/imgly_lut_breeze.jpg",
    lutURI: "./items/imgly_lut_levante_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Zephyr,
    name: "Zephyr",
    thumbnailURI: "./items/imgly_lut_blueshadows.jpg",
    lutURI: "./items/imgly_lut_zephyr_5_5_128.png",
    defaultIntensity: 1
  }]
}, {
  identifier: Tt.Warm,
  name: "Warm",
  thumbnailURI: "./categories/warm.jpg",
  items: [{
    identifier: P.Golden,
    name: "Golden",
    thumbnailURI: "./items/imgly_lut_sunset.jpg",
    lutURI: "./items/imgly_lut_golden_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.LowFire,
    name: "Low Fire",
    thumbnailURI: "./items/imgly_lut_eighties.jpg",
    lutURI: "./items/imgly_lut_low_fire_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Sunrise,
    name: "Sunrise",
    thumbnailURI: "./items/imgly_lut_evening.jpg",
    lutURI: "./items/imgly_lut_sunrise_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.FlatBlack,
    name: "Flat Black",
    thumbnailURI: "./items/imgly_lut_k2.jpg",
    lutURI: "./items/imgly_lut_flat_black_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: P.Pumpkin,
    name: "Pumpkin",
    thumbnailURI: "./items/imgly_lut_nogreen.jpg",
    lutURI: "./items/imgly_lut_pumpkin_5_5_128.png",
    defaultIntensity: 1
  }]
}, {
  identifier: Tt.Legacy,
  name: "Legacy",
  thumbnailURI: "./categories/legacy.jpg",
  items: [{
    identifier: P.Ancient,
    name: "Ancient",
    thumbnailURI: "./items/imgly_lut_ancient.jpg",
    lutURI: "./items/imgly_lut_ancient_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Candy,
    name: "Candy",
    thumbnailURI: "./items/imgly_lut_cottoncandy.jpg",
    lutURI: "./items/imgly_lut_cottoncandy_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Classic,
    name: "Classic",
    thumbnailURI: "./items/imgly_lut_classic.jpg",
    lutURI: "./items/imgly_lut_classic_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Colorful,
    name: "Colorful",
    thumbnailURI: "./items/imgly_lut_colorful.jpg",
    lutURI: "./items/imgly_lut_colorful_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Creamy,
    name: "Creamy",
    thumbnailURI: "./items/imgly_lut_creamy.jpg",
    lutURI: "./items/imgly_lut_creamy_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Fixie,
    name: "Fixie",
    thumbnailURI: "./items/imgly_lut_fixie.jpg",
    lutURI: "./items/imgly_lut_fixie_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: P.Food,
    name: "Food",
    thumbnailURI: "./items/imgly_lut_food.jpg",
    lutURI: "./items/imgly_lut_food_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Fridge,
    name: "Fridge",
    thumbnailURI: "./items/imgly_lut_fridge.jpg",
    lutURI: "./items/imgly_lut_fridge_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: P.Glam,
    name: "Glam",
    thumbnailURI: "./items/imgly_lut_glam.jpg",
    lutURI: "./items/imgly_lut_glam_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Gobblin,
    name: "Gobblin",
    thumbnailURI: "./items/imgly_lut_gobblin.jpg",
    lutURI: "./items/imgly_lut_gobblin_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Hicon,
    name: "Hicon",
    thumbnailURI: "./items/imgly_lut_highcontrast.jpg",
    lutURI: "./items/imgly_lut_highcontrast_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.HighCarb,
    name: "High Carb",
    thumbnailURI: "./items/imgly_lut_highcarb.jpg",
    lutURI: "./items/imgly_lut_highcarb_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.K1,
    name: "K1",
    thumbnailURI: "./items/imgly_lut_k1.jpg",
    lutURI: "./items/imgly_lut_k1_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.K6,
    name: "K6",
    thumbnailURI: "./items/imgly_lut_k6.jpg",
    lutURI: "./items/imgly_lut_k6_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Keen,
    name: "Keen",
    thumbnailURI: "./items/imgly_lut_keen.jpg",
    lutURI: "./items/imgly_lut_keen_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Lomo,
    name: "Lomo",
    thumbnailURI: "./items/imgly_lut_lomo.jpg",
    lutURI: "./items/imgly_lut_lomo_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: P.Lomo100,
    name: "Lomo 100",
    thumbnailURI: "./items/imgly_lut_lomo100.jpg",
    lutURI: "./items/imgly_lut_lomo100_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Lucid,
    name: "Lucid",
    thumbnailURI: "./items/imgly_lut_lucid.jpg",
    lutURI: "./items/imgly_lut_lucid_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Mellow,
    name: "Mellow",
    thumbnailURI: "./items/imgly_lut_mellow.jpg",
    lutURI: "./items/imgly_lut_mellow_8_8_512.png",
    defaultIntensity: 1,
    horizontalTileCount: 8,
    verticalTileCount: 8
  }, {
    identifier: P.Neat,
    name: "Neat",
    thumbnailURI: "./items/imgly_lut_neat.jpg",
    lutURI: "./items/imgly_lut_neat_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Pale,
    name: "Pale",
    thumbnailURI: "./items/imgly_lut_pale.jpg",
    lutURI: "./items/imgly_lut_pale_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Pitched,
    name: "Pitched",
    thumbnailURI: "./items/imgly_lut_pitched.jpg",
    lutURI: "./items/imgly_lut_pitched_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.PolaSX,
    name: "Pola SX",
    thumbnailURI: "./items/imgly_lut_polasx.jpg",
    lutURI: "./items/imgly_lut_polasx_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Pro400,
    name: "Pro 400",
    thumbnailURI: "./items/imgly_lut_pro400.jpg",
    lutURI: "./items/imgly_lut_pro400_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Quozi,
    name: "Quozi",
    thumbnailURI: "./items/imgly_lut_quozi.jpg",
    lutURI: "./items/imgly_lut_quozi_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Settled,
    name: "Settled",
    thumbnailURI: "./items/imgly_lut_settled.jpg",
    lutURI: "./items/imgly_lut_settled_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Seventies,
    name: "Seventies",
    thumbnailURI: "./items/imgly_lut_seventies.jpg",
    lutURI: "./items/imgly_lut_seventies_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Soft,
    name: "Soft",
    thumbnailURI: "./items/imgly_lut_soft.jpg",
    lutURI: "./items/imgly_lut_soft_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Steel,
    name: "Steel",
    thumbnailURI: "./items/imgly_lut_steel.jpg",
    lutURI: "./items/imgly_lut_steel_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Summer,
    name: "Summer",
    thumbnailURI: "./items/imgly_lut_summer.jpg",
    lutURI: "./items/imgly_lut_summer_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Tender,
    name: "Tender",
    thumbnailURI: "./items/imgly_lut_tender.jpg",
    lutURI: "./items/imgly_lut_tender_5_5_128.png",
    defaultIntensity: 1
  }, {
    identifier: P.Twilight,
    name: "Twilight",
    thumbnailURI: "./items/imgly_lut_twilight.jpg",
    lutURI: "./items/imgly_lut_twilight_5_5_128.png",
    defaultIntensity: 1
  }]
}];
var E0 = [{
  identifier: vi.RADIAL,
  thumbnailURI: "./items/radial.png"
}, {
  identifier: vi.MIRRORED,
  thumbnailURI: "./items/mirrored.png"
}, {
  identifier: vi.LINEAR,
  thumbnailURI: "./items/linear.png"
}, {
  identifier: vi.GAUSSIAN,
  thumbnailURI: "./items/gaussian.png"
}];
var M0 = [{
  identifier: Re.Golden,
  name: "Golden",
  defaultBlendMode: De.LIGHTEN,
  overlayURI: "./items/imgly_overlay_golden.jpg",
  thumbnailURI: "./items/imgly_overlay_golden_thumb.jpg"
}, {
  identifier: Re.LightLeak1,
  name: "Lightleak",
  defaultBlendMode: De.SCREEN,
  overlayURI: "./items/imgly_overlay_lightleak1.jpg",
  thumbnailURI: "./items/imgly_overlay_lightleak1_thumb.jpg"
}, {
  identifier: Re.Rain,
  name: "Rain",
  defaultBlendMode: De.OVERLAY,
  overlayURI: "./items/imgly_overlay_rain.jpg",
  thumbnailURI: "./items/imgly_overlay_rain_thumb.jpg"
}, {
  identifier: Re.Mosaic,
  name: "Mosaic",
  defaultBlendMode: De.MULTIPLY,
  overlayURI: "./items/imgly_overlay_mosaic.jpg",
  thumbnailURI: "./items/imgly_overlay_mosaic_thumb.jpg"
}, {
  identifier: Re.Vintage,
  name: "Vintage",
  defaultBlendMode: De.DARKEN,
  overlayURI: "./items/imgly_overlay_vintage.jpg",
  thumbnailURI: "./items/imgly_overlay_vintage_thumb.jpg"
}, {
  identifier: Re.Paper,
  name: "Paper",
  defaultBlendMode: De.MULTIPLY,
  overlayURI: "./items/imgly_overlay_paper.jpg",
  thumbnailURI: "./items/imgly_overlay_paper_thumb.jpg"
}, {
  identifier: Re.Bokeh,
  name: "Bokeh",
  defaultBlendMode: De.LIGHTEN,
  overlayURI: "./items/imgly_overlay_bokeh.jpg",
  thumbnailURI: "./items/imgly_overlay_bokeh_thumb.jpg"
}, {
  identifier: Re.Hearts,
  name: "Hearts",
  defaultBlendMode: De.SCREEN,
  overlayURI: "./items/imgly_overlay_hearts.jpg",
  thumbnailURI: "./items/imgly_overlay_hearts_thumb.jpg"
}, {
  identifier: Re.LightLeak2,
  name: "Lightleak 2",
  defaultBlendMode: De.LIGHTEN,
  overlayURI: "./items/imgly_overlay_lightleak2.jpg",
  thumbnailURI: "./items/imgly_overlay_lightleak2_thumb.jpg"
}, {
  identifier: Re.Wood,
  name: "Wood",
  defaultBlendMode: De.MULTIPLY,
  overlayURI: "./items/imgly_overlay_wood.jpg",
  thumbnailURI: "./items/imgly_overlay_wood_thumb.jpg"
}, {
  identifier: Re.Chop,
  name: "Chop",
  defaultBlendMode: De.MULTIPLY,
  overlayURI: "./items/imgly_overlay_chop.jpg",
  thumbnailURI: "./items/imgly_overlay_chop_thumb.jpg"
}, {
  identifier: Re.Metal,
  name: "Metal",
  defaultBlendMode: De.OVERLAY,
  overlayURI: "./items/imgly_overlay_metal.jpg",
  thumbnailURI: "./items/imgly_overlay_metal_thumb.jpg"
}, {
  identifier: Re.Painting,
  name: "Painting",
  defaultBlendMode: De.OVERLAY,
  overlayURI: "./items/imgly_overlay_painting.jpg",
  thumbnailURI: "./items/imgly_overlay_painting_thumb.jpg"
}, {
  identifier: Re.Grain,
  name: "Grain",
  defaultBlendMode: De.OVERLAY,
  overlayURI: "./items/imgly_overlay_grain.jpg",
  thumbnailURI: "./items/imgly_overlay_grain_thumb.jpg"
}, {
  identifier: Re.Clouds,
  name: "Clouds",
  defaultBlendMode: De.SOFT_LIGHT,
  overlayURI: "./items/imgly_overlay_clouds.jpg",
  thumbnailURI: "./items/imgly_overlay_clouds_thumb.jpg"
}, {
  identifier: Re.Wall1,
  name: "Wall",
  defaultBlendMode: De.LIGHTEN,
  overlayURI: "./items/imgly_overlay_wall1.jpg",
  thumbnailURI: "./items/imgly_overlay_wall1_thumb.jpg"
}, {
  identifier: Re.Wall2,
  name: "Wall 2",
  defaultBlendMode: De.OVERLAY,
  overlayURI: "./items/imgly_overlay_wall2.jpg",
  thumbnailURI: "./items/imgly_overlay_wall2_thumb.jpg"
}];
var G0 = [{
  identifier: "imgly_transforms_common",
  name: "Common",
  items: [{
    identifier: "imgly_transform_common_custom",
    name: "Custom",
    thumbnailURI: "",
    ratio: "*"
  }, {
    identifier: "imgly_transform_common_square",
    name: "Square",
    thumbnailURI: "",
    ratio: 1
  }, {
    identifier: "imgly_transform_common_4",
    name: "4:3",
    thumbnailURI: "",
    ratio: 4 / 3
  }, {
    identifier: "imgly_transform_common_16",
    name: "16:9",
    thumbnailURI: "",
    ratio: 16 / 9
  }, {
    identifier: "imgly_transform_common_3",
    name: "3:4",
    thumbnailURI: "",
    ratio: 3 / 4
  }, {
    identifier: "imgly_transform_common_9",
    name: "9:16",
    thumbnailURI: "",
    ratio: 9 / 16
  }]
}, {
  identifier: "imgly_transforms_facebook",
  name: "Facebook",
  items: [{
    identifier: "imgly_transform_facebook_profile",
    name: "Profile",
    thumbnailURI: "",
    dimensions: {
      x: 300,
      y: 300
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_facebook_title",
    name: "Title",
    thumbnailURI: "",
    dimensions: {
      x: 1200,
      y: 627
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_facebook_post",
    name: "Post",
    thumbnailURI: "",
    dimensions: {
      x: 940,
      y: 788
    },
    forceDimensions: !0,
    lockDimensions: !0
  }]
}, {
  identifier: "imgly_transforms_instagram",
  name: "Instagram",
  items: [{
    identifier: "imgly_transform_instagram_landscape",
    name: "Landscape",
    thumbnailURI: "",
    dimensions: {
      x: 1080,
      y: 566
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_instagram_portrait",
    name: "Portrait",
    thumbnailURI: "",
    dimensions: {
      x: 1080,
      y: 1350
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_instagram_square",
    name: "Square",
    thumbnailURI: "",
    dimensions: {
      x: 1080,
      y: 1080
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_instagram_story",
    name: "Story",
    thumbnailURI: "",
    dimensions: {
      x: 1080,
      y: 1920
    },
    forceDimensions: !0,
    lockDimensions: !0
  }]
}, {
  identifier: "imgly_transforms_twitter",
  name: "Twitter",
  items: [{
    identifier: "imgly_transform_twitter_post",
    name: "Post",
    thumbnailURI: "",
    dimensions: {
      x: 1024,
      y: 512
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_twitter_profile",
    name: "Profile",
    thumbnailURI: "",
    dimensions: {
      x: 400,
      y: 400
    },
    forceDimensions: !0,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_twitter_title",
    name: "Title",
    thumbnailURI: "",
    dimensions: {
      x: 1500,
      y: 500
    },
    forceDimensions: !0,
    lockDimensions: !0
  }]
}];

var Ci = {
  imgly_font_bernier_regular: "imgly_font_sancreek",
  imgly_font_cheque_regular: "imgly_font_kumar_one_outline",
  imgly_font_gagalin_regular: "imgly_font_permanent_marker",
  imgly_font_hagin_caps_thin: "imgly_font_nixie_one",
  imgly_font_intro_inline: "imgly_font_bungee_inline",
  imgly_font_nexa_script: "imgly_font_molle",
  imgly_font_panton_blackitalic_caps: "imgly_font_roboto_black_italic",
  imgly_font_panton_lightitalic_caps: "imgly_font_roboto_light_italic",
  imgly_font_perfograma: "imgly_font_codystar",
  imgly_font_panton_black_caps: "imgly_font_roboto_black",
  imgly_font_panton_light_caps: "imgly_font_roboto_light",
  imgly_font_summer_font_light: "imgly_font_sue_ellen_francisco"
},
    es = function es(s) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  return Ci[s] ? (e && console.warn("Font ".concat(s, " was deprecated. Please use ").concat(Ci[s], " instead.")), Ci[s]) : s;
};

function lu() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (s) {
    var e = Math.random() * 16 | 0;
    return (s === "x" ? e : e & 3 | 8).toString(16);
  });
}

var K0 = window.performance.now.bind(window.performance);

var ts =
/*#__PURE__*/
function () {
  function ts(e) {
    _classCallCheck(this, ts);

    this.text = e;
    this.lastOffsetWidth = -1;
    var t = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
    this.element = document.createElement("div"), this.element.setAttribute("aria-hidden", "true"), this.element.appendChild(document.createTextNode(e)), this.collapsible = document.createElement("span"), this.expandable = document.createElement("span"), this.collapsibleInner = document.createElement("span"), this.expandableInner = document.createElement("span"), this.collapsible.style.cssText = t, this.expandable.style.cssText = t, this.expandableInner.style.cssText = t, this.collapsibleInner.style.cssText = "display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;", this.collapsible.appendChild(this.collapsibleInner), this.expandable.appendChild(this.expandableInner), this.element.appendChild(this.collapsible), this.element.appendChild(this.expandable);
  }

  _createClass(ts, [{
    key: "getElement",
    value: function getElement() {
      return this.element;
    }
  }, {
    key: "setFont",
    value: function setFont(e) {
      this.element.style.cssText = "max-width:none;\n      min-width:20px;\n      min-height:20px;\n      display:inline-block;\n      overflow:hidden;\n      position:absolute;\n      width:auto;\n      margin:0;\n      padding:0;\n      top:-999px;\n      white-space:nowrap;\n      font-synthesis:none;\n      font:".concat(e, ";");
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.element.offsetWidth;
    }
  }, {
    key: "setWidth",
    value: function setWidth(e) {
      this.element.style.width = "".concat(e, "px");
    }
  }, {
    key: "onResize",
    value: function onResize(e) {
      var _this2 = this;

      var t = function t() {
        _this2.onScroll(e);
      };

      this.collapsible.addEventListener("scroll", t), this.expandable.addEventListener("scroll", t), this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      var e = this.getWidth(),
          t = e + 100;
      return this.expandableInner.style.width = "".concat(t, "px"), this.expandable.scrollLeft = t, this.collapsible.scrollLeft = this.collapsible.scrollWidth + 100, this.lastOffsetWidth !== e ? (this.lastOffsetWidth = e, !0) : !1;
    }
  }, {
    key: "onScroll",
    value: function onScroll(e) {
      this.reset() && this.element.parentNode !== null && e(this.lastOffsetWidth);
    }
  }]);

  return ts;
}();

var fe =
/*#__PURE__*/
function () {
  _createClass(fe, null, [{
    key: "getUserAgent",
    value: function getUserAgent() {
      return window.navigator.userAgent;
    }
  }, {
    key: "getNavigatorVendor",
    value: function getNavigatorVendor() {
      return window.navigator.vendor;
    }
  }, {
    key: "hasWebKitFallbackBug",
    value: function hasWebKitFallbackBug() {
      if (fe.HAS_WEBKIT_FALLBACK_BUG === null) {
        var e = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(fe.getUserAgent());
        fe.HAS_WEBKIT_FALLBACK_BUG = !!e && (parseInt(e[1], 10) < 536 || parseInt(e[1], 10) === 536 && parseInt(e[2], 10) <= 11);
      }

      return fe.HAS_WEBKIT_FALLBACK_BUG;
    }
  }, {
    key: "hasSafari10Bug",
    value: function hasSafari10Bug() {
      if (fe.HAS_SAFARI_10_BUG === null) if (fe.supportsNativeFontLoading() && /Apple/.test(fe.getNavigatorVendor())) {
        var e = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(fe.getUserAgent());
        fe.HAS_SAFARI_10_BUG = !!e && parseInt(e[1], 10) < 603;
      } else fe.HAS_SAFARI_10_BUG = !1;
      return fe.HAS_SAFARI_10_BUG;
    }
  }, {
    key: "supportsNativeFontLoading",
    value: function supportsNativeFontLoading() {
      return fe.SUPPORTS_NATIVE_FONT_LOADING === null && (fe.SUPPORTS_NATIVE_FONT_LOADING = !!document.fonts), fe.SUPPORTS_NATIVE_FONT_LOADING;
    }
  }, {
    key: "supportsStretch",
    value: function supportsStretch() {
      if (fe.SUPPORTS_STRETCH === null) {
        var e = document.createElement("div");

        try {
          e.style.font = "condensend 100px sans-serif";
        } catch (t) {
          fe.SUPPORTS_STRETCH = !1;
        }

        fe.SUPPORTS_STRETCH = e.style.font !== "";
      }

      return fe.SUPPORTS_STRETCH;
    }
  }]);

  function fe(e) {
    _classCallCheck(this, fe);

    this.font = C({
      fontFamily: "normal",
      fontStyle: "normal",
      fontWeight: "normal",
      fontStretch: "normal"
    }, e);
  }

  _createClass(fe, [{
    key: "load",
    value: function load(e, t) {
      var _this3 = this;

      var i = "BESbswy",
          r = null,
          o = t || fe.DEFAULT_TIMEOUT,
          n = this.getTime();
      return new Promise(function (a, l) {
        if (fe.supportsNativeFontLoading() && !fe.hasSafari10Bug()) {
          var c = new Promise(function (p, h) {
            var d = function d() {
              _this3.getTime() - n >= o ? h(new Error("" + o + "ms timeout exceeded")) : document.fonts.load(_this3.getStyle("\"".concat(_this3.font.fontFamily, "\"")), i).then(function (y) {
                y.length >= 1 ? p() : setTimeout(d, 25);
              }, l);
            };

            d();
          }),
              u = new Promise(function (p, h) {
            r = setTimeout(function () {
              h(new Error("".concat(o, " ms timeout exceeded")));
            }, o);
          });
          Promise.race([u, c]).then(function () {
            clearTimeout(r), a(_this3);
          }, l);
        } else {
          var _c2 = new ts(i),
              _u2 = new ts(i),
              p = new ts(i),
              h = -1,
              _d2 = -1,
              g = -1,
              y = -1,
              _2 = -1,
              f = -1,
              v = document.createElement("div"),
              b = function b() {
            v.parentNode !== null && v.parentNode.removeChild(v);
          },
              D = function D() {
            if ((h !== -1 && _d2 !== -1 || h !== -1 && g !== -1 || _d2 !== -1 && g !== -1) && (h === _d2 || h === g || _d2 === g)) {
              if (fe.hasWebKitFallbackBug() && (h === y && _d2 === y && g === y || h === _2 && _d2 === _2 && g === _2 || h === f && _d2 === f && g === f)) return;
              b(), clearTimeout(r), a(_this3);
            }
          };

          v.dir = "ltr", _c2.setFont(_this3.getStyle("sans-serif")), _u2.setFont(_this3.getStyle("serif")), p.setFont(_this3.getStyle("monospace")), v.appendChild(_c2.getElement()), v.appendChild(_u2.getElement()), v.appendChild(p.getElement()), document.body.appendChild(v), y = _c2.getWidth(), _2 = _u2.getWidth(), f = p.getWidth();

          var O = function O() {
            if (_this3.getTime() - n >= o) b(), l(new Error("".concat(o, " ms timeout exceeded")));else {
              var w = document.hidden;
              (w === !0 || w === void 0) && (h = _c2.getWidth(), _d2 = _u2.getWidth(), g = p.getWidth(), D()), r = setTimeout(O, 50);
            }
          };

          O(), _c2.onResize(function (x) {
            h = x, D();
          }), _c2.setFont(_this3.getStyle("\"".concat(_this3.font.fontFamily, "\",sans-serif"))), _u2.onResize(function (x) {
            _d2 = x, D();
          }), _u2.setFont(_this3.getStyle("\"".concat(_this3.font.fontFamily, "\",serif"))), p.onResize(function (x) {
            g = x, D();
          }), p.setFont(_this3.getStyle("\"".concat(_this3.font.fontFamily, "\",monospace")));
        }
      });
    }
  }, {
    key: "getStyle",
    value: function getStyle(e) {
      return [this.font.fontStyle, this.font.fontWeight, fe.supportsStretch() ? this.font.fontStretch : "", "100px", e].join(" ");
    }
  }, {
    key: "getTime",
    value: function getTime() {
      return new Date().getTime();
    }
  }]);

  return fe;
}(),
    wi = fe;

wi.HAS_WEBKIT_FALLBACK_BUG = null, wi.HAS_SAFARI_10_BUG = null, wi.SUPPORTS_STRETCH = null, wi.SUPPORTS_NATIVE_FONT_LOADING = null, wi.DEFAULT_TIMEOUT = 3e3;

var he =
/*#__PURE__*/
function () {
  _createClass(he, [{
    key: "magnitude",
    get: function get() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }
  }, {
    key: "normalized",
    get: function get() {
      var e = this.magnitude;
      return new he(this.x / e, this.y / e);
    }
  }, {
    key: "floored",
    get: function get() {
      return new he(Math.floor(this.x), Math.floor(this.y));
    }
  }, {
    key: "rounded",
    get: function get() {
      return new he(Math.round(this.x), Math.round(this.y));
    }
  }, {
    key: "min",
    get: function get() {
      return Math.min(this.x, this.y);
    }
  }, {
    key: "max",
    get: function get() {
      return Math.max(this.x, this.y);
    }
  }, {
    key: "abs",
    get: function get() {
      return new he(Math.abs(this.x), Math.abs(this.y));
    }
  }, {
    key: "swapped",
    get: function get() {
      return new he(this.y, this.x);
    }
  }], [{
    key: "fromSize",
    value: function fromSize(e) {
      return new he(e.width, e.height);
    }
  }, {
    key: "distance",
    value: function distance(e, t) {
      var i = t.x - e.x,
          r = t.y - e.y;
      return Math.sqrt(i * i + r * r);
    }
  }, {
    key: "dot",
    value: function dot(e, t) {
      return e.x * t.x + e.y * t.y;
    }
  }, {
    key: "lerp",
    value: function lerp(e, t, i) {
      var r = Math.min(Math.max(i, 0), 1);
      return new he(e.x * r + t.x * (1 - r), e.y * r + t.y * (1 - r));
    }
  }, {
    key: "lerpUnclamped",
    value: function lerpUnclamped(e, t, i) {
      return new he(e.x * i + t.x * (1 - i), e.y * i + t.y * (1 - i));
    }
  }, {
    key: "proportionalFit",
    value: function proportionalFit(e, t) {
      var i = e.x / e.y,
          r = t.x / t.y;
      return i > r ? t.multiply(e.y / t.y) : t.multiply(e.x / t.x);
    }
  }]);

  function he(e, t) {
    _classCallCheck(this, he);

    typeof e == "number" ? (this.x = e, this.y = t) : (this.x = e.x, this.y = e.y);
  }

  _createClass(he, [{
    key: "clone",
    value: function clone() {
      return new he(this.x, this.y);
    }
  }, {
    key: "add",
    value: function add(e, t) {
      return typeof e == "number" ? new he(this.x + e, this.y + t) : new he(this.x + e.x, this.y + e.y);
    }
  }, {
    key: "subtract",
    value: function subtract(e, t) {
      return typeof e == "number" ? new he(this.x - e, this.y - t) : new he(this.x - e.x, this.y - e.y);
    }
  }, {
    key: "multiply",
    value: function multiply(e, t) {
      return typeof e == "number" ? new he(this.x * e, this.y * (t === void 0 ? e : t)) : new he(this.x * e.x, this.y * e.y);
    }
  }, {
    key: "divide",
    value: function divide(e, t) {
      return typeof e == "number" ? new he(this.x / e, this.y / (t === void 0 ? e : t)) : new he(this.x / e.x, this.y / e.y);
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return this.x === e.x && this.y === e.y;
    }
  }, {
    key: "clamp",
    value: function clamp(e, t) {
      var i = Math.max(e.x, Math.min(t.x, this.x)),
          r = Math.max(e.y, Math.min(t.y, this.y));
      return new he(i, r);
    }
  }]);

  return he;
}(),
    ue = he;

ue.ZERO = new he(0, 0), ue.ONE = new he(1, 1), ue.UP = new he(0, 1), ue.DOWN = new he(0, -1), ue.RIGHT = new he(1, 0), ue.LEFT = new he(-1, 0);
var ka;

(function (s) {
  s.BEGAN_IMAGE_DOWNSCALING = "beganImageDownscaling", s.IMAGE_DOWNSCALED = "imageDownscaled";
})(ka || (ka = {}));

var Ys;

(function (s) {
  s[s.EditorContainer = 0] = "EditorContainer", s[s.ToolControlBar = 1] = "ToolControlBar", s[s.ToolControlBarControls = 2] = "ToolControlBarControls", s[s.CanvasContainer = 3] = "CanvasContainer", s[s.Canvas = 4] = "Canvas", s[s.MainBarButtonClose = 5] = "MainBarButtonClose", s[s.Tooltip = 6] = "Tooltip", s[s.Cursor = 7] = "Cursor", s[s.CursorContainer = 8] = "CursorContainer", s[s.NummericInput = 9] = "NummericInput", s[s.BrushSize = 10] = "BrushSize", s[s.BrushHardness = 11] = "BrushHardness", s[s.Dialog = 12] = "Dialog", s[s.DialogBody = 13] = "DialogBody", s[s.CardContainer = 14] = "CardContainer", s[s.CategoryItemsContainer = 15] = "CategoryItemsContainer", s[s.ToolbarItem = 16] = "ToolbarItem", s[s.ColorList = 17] = "ColorList", s[s.NoResult = 18] = "NoResult", s[s.CardLabel = 19] = "CardLabel", s[s.CardAvatar = 20] = "CardAvatar", s[s.Dropdown = 21] = "Dropdown", s[s.DropdownList = 22] = "DropdownList", s[s.TextAlignment = 23] = "TextAlignment", s[s.Sprite = 24] = "Sprite", s[s.SpriteTopLeft = 25] = "SpriteTopLeft", s[s.SpriteTopRight = 26] = "SpriteTopRight", s[s.SpriteBottomLeft = 27] = "SpriteBottomLeft", s[s.SpriteBottomRight = 28] = "SpriteBottomRight", s[s.Knob = 29] = "Knob", s[s.TextWidth = 30] = "TextWidth", s[s.ToolbarWrapper = 31] = "ToolbarWrapper", s[s.MainCanvasActionBar = 32] = "MainCanvasActionBar", s[s.SpriteActions = 33] = "SpriteActions", s[s.CarouselSlider = 34] = "CarouselSlider", s[s.CropMask = 35] = "CropMask", s[s.FlipRotateControls = 36] = "FlipRotateControls", s[s.RotateSlider = 37] = "RotateSlider", s[s.CropTopRight = 38] = "CropTopRight", s[s.CropTopLeft = 39] = "CropTopLeft", s[s.CropBottomRight = 40] = "CropBottomRight", s[s.CropBottomLeft = 41] = "CropBottomLeft", s[s.Watermark = 42] = "Watermark", s[s.Toolbar = 43] = "Toolbar", s[s.CanvasBar = 44] = "CanvasBar", s[s.Checkbox = 45] = "Checkbox", s[s.Focus = 46] = "Focus";
})(Ys || (Ys = {}));

var dp = {};

for (var s in Ys) {
  var e = Ys[s];
  typeof e == "string" && (dp[e] = e);
}

var uu,
    lv = Boolean((uu = window.Cypress) == null ? void 0 : uu.env("pesdk"));

var Ta =
/*#__PURE__*/
function () {
  _createClass(Ta, null, [{
    key: "contains",
    value: function contains(e, t) {
      return t.x >= e.minX && t.x <= e.maxX && t.y >= e.minY && t.y <= e.maxY;
    }
  }]);

  function Ta(e, t, i, r) {
    _classCallCheck(this, Ta);

    if (typeof e == "number") {
      if (typeof t == "number" && i !== void 0 && r !== void 0) this.origin = {
        x: e,
        y: t
      }, this.size = {
        width: i || 0,
        height: r || 0
      };else throw new Error("Invalid arguments passed to Rect. Expected (number, number, number, number)");
    } else {
      if (this.origin = e, typeof t == "number") throw new Error("Invalid arguments passed to Rect. Expected (Float2, Size)");
      this.size = t;
    }
  }

  _createClass(Ta, [{
    key: "minX",
    get: function get() {
      return this.origin.x;
    }
  }, {
    key: "minY",
    get: function get() {
      return this.origin.y;
    }
  }, {
    key: "midX",
    get: function get() {
      return this.origin.x + .5 * this.size.width;
    }
  }, {
    key: "midY",
    get: function get() {
      return this.origin.y + .5 * this.size.height;
    }
  }, {
    key: "maxX",
    get: function get() {
      return this.origin.x + this.size.width;
    }
  }, {
    key: "maxY",
    get: function get() {
      return this.origin.y + this.size.height;
    }
  }, {
    key: "width",
    get: function get() {
      return this.size.width;
    }
  }, {
    key: "height",
    get: function get() {
      return this.size.height;
    }
  }]);

  return Ta;
}(),
    yt = Ta;

yt.ZERO = new Ta({
  x: 0,
  y: 0
}, {
  width: 0,
  height: 0
});

var Ut =
/*#__PURE__*/
function () {
  function Ut(e, t, i, r, o, n) {
    _classCallCheck(this, Ut);

    this.a = e;
    this.b = t;
    this.c = i;
    this.d = r;
    this.tx = o;
    this.ty = n;
  }

  _createClass(Ut, null, [{
    key: "fromScale",
    value: function fromScale(e, t) {
      return new Ut(e, 0, 0, t, 0, 0);
    }
  }, {
    key: "fromRotation",
    value: function fromRotation(e) {
      var t = Math.cos(e),
          i = Math.sin(e);
      return new Ut(t, -i, i, t, 0, 0);
    }
  }, {
    key: "fromRotationDeg",
    value: function fromRotationDeg(e) {
      var t = Math.PI * e / 180;
      return this.fromRotation(t);
    }
  }, {
    key: "fromTranslation",
    value: function fromTranslation(e, t) {
      return new Ut(1, 0, 0, 1, e, t);
    }
  }, {
    key: "fromTRS",
    value: function fromTRS(e, t, i, r, o) {
      var n = Math.cos(i),
          a = Math.sin(i);
      return new Ut(r * n, -o * a, r * a, o * n, e, t);
    }
  }, {
    key: "multiply",
    value: function multiply(e, t) {
      var i = e.a * t.a + e.b * t.c,
          r = e.a * t.b + e.b * t.d,
          o = e.c * t.a + e.d * t.c,
          n = e.c * t.b + e.d * t.d,
          a = e.a * t.tx + e.b * t.ty + e.tx,
          l = e.c * t.tx + e.d * t.ty + e.ty;
      return new Ut(i, r, o, n, a, l);
    }
  }, {
    key: "transformPoint",
    value: function transformPoint(e, t) {
      return {
        x: e.a * t.x + e.b * t.y + e.tx,
        y: e.c * t.x + e.d * t.y + e.ty
      };
    }
  }, {
    key: "getInverted",
    value: function getInverted(e) {
      var t = e.a * e.d - e.b * e.c;
      if (t === 0) return e;
      var i = 1 / t,
          r = i * e.d,
          o = -i * e.b,
          n = -i * e.c,
          a = i * e.a,
          l = i * (e.b * e.ty - e.d * e.tx),
          c = i * (e.c * e.tx - e.a * e.ty);
      return new Ut(r, o, n, a, l, c);
    }
  }]);

  return Ut;
}(),
    Se = Ut;

Se.IDENTITY = Ut.fromScale(1, 1);

function mu(s) {
  return s.x !== void 0;
}

function Ra(s) {
  return Se.fromTRS(s.position.x, s.position.y, s.rotation, s.scale.x, s.scale.y);
}

function pp(s) {
  return s.getBaseLocalToParentMatrix ? s.getBaseLocalToParentMatrix() : Ra(s.getTransform());
}

function qs(s) {
  var e = s.getParent(),
      t = pp(s);
  if (e === void 0) return t;
  var i = qs(e);
  return Se.multiply(i, t);
}

function du(s) {
  return s.getLocalToParentMatrix ? s.getLocalToParentMatrix() : Ra(s.getTransform());
}

function Xi(s) {
  var e = s.getParent(),
      t = du(s);
  if (e === void 0) return t;
  var i = Xi(e);
  return Se.multiply(i, t);
}

function is(s, e, t) {
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  var r = e.type === "output" && i ? qs(e) : Xi(e),
      o = t.type === "output" && i ? qs(t) : Xi(t),
      n = Se.getInverted(o);
  return Se.transformPoint(n, Se.transformPoint(r, s));
}

function Fa(s, e, t) {
  var i = new ue(s, 0),
      r = new ue(is(i, e, t)),
      o = new ue(is(ue.ZERO, e, t));
  return ue.distance(o, r);
}

function gp(s, e, t) {
  var i = mu(s) ? s.x : s.width,
      r = mu(s) ? s.y : s.height,
      o = Fa(i, e, t),
      n = Fa(r, e, t);
  return {
    width: o,
    height: n
  };
}

function Ea(s, e) {
  var t = Xi(e);
  return Se.transformPoint(t, s);
}

function fp(s, e) {
  var t = new ue(s, 0),
      i = new ue(Ea(t, e)),
      r = new ue(Ea(ue.ZERO, e));
  return ue.distance(i, r);
}

function hu(s) {
  var e = Xi(s),
      t = s.getBounds(),
      i = {
    x: t.width,
    y: 0
  },
      r = {
    x: 0,
    y: t.height
  },
      o = new ue(Se.transformPoint(e, ue.ZERO)),
      n = new ue(Se.transformPoint(e, i)),
      a = new ue(Se.transformPoint(e, r)),
      l = ue.distance(o, n),
      c = ue.distance(o, a);
  return {
    width: l,
    height: c
  };
}

function _p(s, e) {
  var t = hu(s),
      i = e.getTransform().scale,
      r = {
    x: 1 / i.x,
    y: 1 / i.y
  };
  return {
    width: t.width * r.x,
    height: t.height * r.y
  };
}

function yp(s, e) {
  var t = e.getBounds();
  return {
    width: s.width * t.width,
    height: s.height * t.height
  };
}

function bp(s, e) {
  var t = e.getBounds();
  return {
    width: s.width / t.width,
    height: s.height / t.height
  };
}

function xp(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var i = e.getBounds();
  return {
    x: s.x * i.width + (t ? 0 : i.minX),
    y: s.y * i.height + (t ? 0 : i.minY)
  };
}

function vp(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var i = e.getBounds();
  return {
    x: (s.x - (t ? 0 : i.minX)) / i.width,
    y: (s.y - (t ? 0 : i.minY)) / i.height
  };
}

function Cp(s, e) {
  var i = is({
    x: 1,
    y: 0
  }, s, e, !0),
      r = is(ue.ZERO, s, e, !0);
  return Math.atan2(i.y - r.y, i.x - r.x);
}

var Xe = {};
we(Xe, {
  FragmentPrecision: function FragmentPrecision() {
    return dt;
  },
  ImageFormat: function ImageFormat() {
    return Di;
  },
  OptionType: function OptionType() {
    return m;
  },
  RenderType: function RenderType() {
    return nt;
  },
  RendererType: function RendererType() {
    return U;
  },
  UniformType: function UniformType() {
    return F;
  }
});
var nt = {
  IMAGE: "image",
  DATAURL: "data-url",
  BUFFER: "buffer",
  BLOB: "blob",
  MSBLOB: "ms-blob"
},
    Di = {
  PNG: "image/png",
  JPEG: "image/jpeg",
  RAW: "raw"
},
    m;

(function (s) {
  s.NUMBER = "number", s.VECTOR2 = "vector2", s.COLOR_MATRIX = "color-matrix", s.COLOR = "color", s.ARRAY = "array", s.OBJECT = "object", s.STRING = "string", s.BOOLEAN = "boolean", s.CONFIGURABLE = "configurable", s.IMAGE = "image", s.FUNCTION = "function", s.TEXTURE = "texture", s.ALL = "*";
})(m || (m = {}));

var F;

(function (s) {
  s.SAMPLER2D = "sampler2d", s.INT = "i", s.INT1 = "1i", s.INT2 = "2i", s.INT3 = "3i", s.INT4 = "4i", s.FLOAT = "f", s.FLOAT1 = "1f", s.FLOAT2 = "2f", s.FLOAT_VECTOR2 = "2fv", s.FLOAT3 = "3f", s.FLOAT4 = "4f", s.MAT3 = "mat3", s.MAT3FV = "mat3fv", s.MAT4 = "mat4";
})(F || (F = {}));

var U;

(function (s) {
  s.WEBGL = "webgl", s.CANVAS = "canvas";
})(U || (U = {}));

var dt;

(function (s) {
  s.High = "highp", s.Medium = "mediump", s.Low = "lowp";
})(dt || (dt = {}));

var gu;

var rs = function rs() {
  return document.createElement("canvas");
},
    pu = function pu(s, e) {
  var t = e || rs();
  t.width = s.width, t.height = s.height;
  var i = t.getContext("2d");
  if (!i) throw new Error("Cannot render context");
  return i.clearRect(0, 0, t.width, t.height), i.drawImage(s, 0, 0, s.width, s.height), t;
};

var Sa = function Sa(e, t, i) {
  _classCallCheck(this, Sa);

  this.width = e;
  this.height = t;
  this.data = i;
},
    Ks = Sa;

gu = Qi().webUtils;

var Ae = gu,
    Zi = function Zi(s) {
  return s._type === U.WEBGL;
},
    Aa = function Aa(s) {
  return Boolean(s && "tagName" in s && s.tagName && s.tagName.toUpperCase() === "CANVAS");
},
    fu = function fu(s) {
  return Boolean("tagName" in s && s.tagName.toUpperCase() === "IMG");
};

var Qs =
/*#__PURE__*/
function () {
  function Qs() {
    _classCallCheck(this, Qs);
  }

  _createClass(Qs, null, [{
    key: "head",
    value: function head(e) {
      return e[0];
    }
  }, {
    key: "tail",
    value: function tail(e) {
      return e.slice(1);
    }
  }, {
    key: "last",
    value: function last(e) {
      return e[e.length - 1];
    }
  }, {
    key: "init",
    value: function init(e) {
      return e.slice(0, e.length - 1);
    }
  }, {
    key: "remove",
    value: function remove(e, t) {
      return e.filter(function (i, r, o) {
        return !t(i, r, o);
      });
    }
  }, {
    key: "findIndex",
    value: function findIndex(e, t) {
      for (var i = 0; i < e.length; i++) {
        if (t(e[i])) return i;
      }

      return -1;
    }
  }, {
    key: "find",
    value: function find(e, t) {
      for (var i = 0; i < e.length; i++) {
        if (t(e[i])) return e[i];
      }
    }
  }, {
    key: "flatten",
    value: function flatten(e) {
      return e.reduce(function (t, i) {
        return t.concat(Array.isArray(i) ? Qs.flatten(i) : i);
      }, []);
    }
  }, {
    key: "range",
    value: function range(e, t) {
      var i = [];
      if (t > e) for (var r = e; r < t; r++) {
        i.push(r);
      }
      return i;
    }
  }, {
    key: "repeat",
    value: function repeat(e, t) {
      var i = [];

      for (var r = 0; r < t; r++) {
        i[r] = e;
      }

      return i;
    }
  }, {
    key: "zip",
    value: function zip(e, t) {
      var i = Math.min(e.length, t.length),
          r = [];

      for (var o = 0; o < i; o++) {
        r[o] = [e[o], t[o]];
      }

      return r;
    }
  }]);

  return Qs;
}(),
    _u = Qs;

var ti = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    Fp = {
  encode: function encode(s) {
    var e = "",
        t,
        i,
        r,
        o,
        n,
        a,
        l,
        c = 0;

    do {
      t = s[c++], i = s[c++], r = s[c++], o = t >> 2, n = (t & 3) << 4 | i >> 4, a = (i & 15) << 2 | r >> 6, l = r & 63, isNaN(i) ? a = l = 64 : isNaN(r) && (l = 64), e = e + ti.charAt(o) + ti.charAt(n) + ti.charAt(a) + ti.charAt(l), t = i = r = "", o = n = a = l = "";
    } while (c < s.length);

    return e;
  },
  decode: function decode(s) {
    var e,
        t,
        i,
        r,
        o,
        n,
        a,
        l = 0,
        c = [];
    if (/[^A-Za-z0-9+/=]/g.exec(s)) throw new Error("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding.");
    s = s.replace(/[^A-Za-z0-9+/=]/g, "");

    do {
      r = ti.indexOf(s.charAt(l++)), o = ti.indexOf(s.charAt(l++)), n = ti.indexOf(s.charAt(l++)), a = ti.indexOf(s.charAt(l++)), e = r << 2 | o >> 4, t = (o & 15) << 4 | n >> 2, i = (n & 3) << 6 | a, c.push(e), n !== 64 && c.push(t), a !== 64 && c.push(i), e = t = i = "", r = o = n = a = "";
    } while (l < s.length);

    return c;
  }
},
    bt = Fp;

var ki =
/*#__PURE__*/
function () {
  function ki() {
    _classCallCheck(this, ki);
  }

  _createClass(ki, null, [{
    key: "mapRange",
    value: function mapRange(e, t, i) {
      return (e - t.getMin()) * i.getLength() / t.getLength() + i.getMin();
    }
  }, {
    key: "isPlainObject",
    value: function isPlainObject(e) {
      if (typeof e != "object" || !e) return !1;

      if (typeof Object.getPrototypeOf == "function") {
        var t = Object.getPrototypeOf(e);
        return t === Object.prototype || t === null;
      }

      return Object.prototype.toString.call(e) === "[object Object]";
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      if (typeof navigator == "undefined") return !1;
      var e = navigator.userAgent || navigator.vendor || window.opera;
      return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4));
    }
  }, {
    key: "isBrowser",
    value: function isBrowser() {
      return typeof window != "undefined";
    }
  }, {
    key: "values",
    value: function values(e) {
      var t = [];

      for (var i in e) {
        t.push(e[i]);
      }

      return t;
    }
  }, {
    key: "generateUUID",
    value: function generateUUID() {
      var e = new Date().getTime();
      return typeof window.performance != "undefined" && typeof window.performance.now == "function" && (e += window.performance.now()), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
        var i = (e + Math.random() * 16) % 16 | 0;
        return e = Math.floor(e / 16), (t === "x" ? i : i & 3 | 8).toString(16);
      });
    }
  }, {
    key: "resizeVectorToFit",
    value: function resizeVectorToFit(e, t) {
      var i = Math.min(t.x / e.x, t.y / e.y);
      return e.clone().multiply(i);
    }
  }, {
    key: "resizeVectorToFill",
    value: function resizeVectorToFill(e, t) {
      var i = e.x / e.y,
          r = t.x / t.y;
      return i > r ? t.clone().set(t.y * i, t.y) : t.clone().set(t.x, t.x / i);
    }
  }, {
    key: "isExtendable",
    value: function isExtendable(e) {
      return typeof e != "undefined" && e !== null && (typeof e == "object" || typeof e == "function");
    }
  }, {
    key: "defaults",
    value: function defaults(e) {
      var i = {};

      for (var r in e) {
        i[r] = e[r];
      }

      for (var _r2 = 0; _r2 < (arguments.length <= 1 ? 0 : arguments.length - 1); _r2++) {
        var o = _r2 + 1 < 1 || arguments.length <= _r2 + 1 ? undefined : arguments[_r2 + 1];

        for (var n in o) {
          typeof i[n] == "undefined" && (i[n] = o[n]);
        }
      }

      return i;
    }
  }, {
    key: "deepMerge",
    value: function deepMerge(e) {
      var i = function i(r, o) {
        if (o === void 0) return i(null, r);
        if (Array.isArray(o)) return _toConsumableArray(o);
        if (!ki.isPlainObject(o)) return o;
        if (!ki.isPlainObject(r)) return C({}, o);
        var n = C({}, r);
        return Object.keys(o).forEach(function (a) {
          var l = o[a];
          l !== void 0 && (n[a] = i(r[a], l));
        }), n;
      };

      for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        t[_key2 - 1] = arguments[_key2];
      }

      return t.reduce(i, e);
    }
  }, {
    key: "deepDefaults",
    value: function deepDefaults(e) {
      for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        t[_key3 - 1] = arguments[_key3];
      }

      var i = [].concat(t).reverse();
      return ki.deepMerge.apply(ki, _toConsumableArray(i).concat([e]));
    }
  }, {
    key: "deepClone",
    value: function deepClone(e) {
      var t = {};

      for (var i in e) {
        ki.isExtendable(e[i]) ? t[i] = ki.deepClone(e[i]) : t[i] = e[i];
      }

      return t;
    }
  }, {
    key: "extend",
    value: function extend(e) {
      var i = {};

      for (var r in e) {
        i[r] = e[r];
      }

      for (var _r3 = 0; _r3 < (arguments.length <= 1 ? 0 : arguments.length - 1); _r3++) {
        var o = _r3 + 1 < 1 || arguments.length <= _r3 + 1 ? undefined : arguments[_r3 + 1];

        for (var n in o) {
          i[n] = o[n];
        }
      }

      return i;
    }
  }, {
    key: "clone",
    value: function clone(e) {
      return this.extend({}, e);
    }
  }, {
    key: "getUUID",
    value: function getUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var t = Math.random() * 16 | 0;
        return (e === "x" ? t : t & 3 | 8).toString(16);
      });
    }
  }, {
    key: "createCanvas",
    value: function createCanvas() {
      return Ae.createCanvas();
    }
  }, {
    key: "isPowerOfTwo",
    value: function isPowerOfTwo(e) {
      return (e.x & e.x - 1) == 0 && (e.y & e.y - 1) == 0;
    }
  }, {
    key: "nextLowestPOT",
    value: function nextLowestPOT(e) {
      for (var t = 1; t < 32; t <<= 1) {
        e |= e >> t;
      }

      return e - (e >> 1);
    }
  }, {
    key: "nextHighestPOT",
    value: function nextHighestPOT(e) {
      e--;

      for (var t = 1; t < 32; t <<= 1) {
        e |= e >> t;
      }

      return e + 1;
    }
  }, {
    key: "moveArrayItem",
    value: function moveArrayItem(e, t, i) {
      if (i >= e.length) {
        var r = i - e.length;

        for (; r-- + 1;) {
          e.push(void 0);
        }
      }

      e.splice(i, 0, e.splice(t, 1)[0]);
    }
  }, {
    key: "ensureCanvasDimensions",
    value: function ensureCanvasDimensions(e, t) {
      return e.width !== t.x || e.height !== t.y ? (e.width = t.x, e.height = t.y, !0) : !1;
    }
  }, {
    key: "byteArrayToString",
    value: function byteArrayToString(e) {
      return e.map(function (t) {
        return String.fromCharCode(t);
      }).join("");
    }
  }, {
    key: "clamp",
    value: function clamp(e, t, i) {
      return Math.max(t, Math.min(e, i));
    }
  }, {
    key: "wildCardMatch",
    value: function wildCardMatch(e, t) {
      return new RegExp("^".concat(t.split("*").join(".*"), "$")).test(e);
    }
  }, {
    key: "flipObject",
    value: function flipObject(e) {
      var t = {};

      for (var i in e) {
        t[e[i]] = i;
      }

      return t;
    }
  }, {
    key: "ISODateString",
    value: function ISODateString(e) {
      function t(i) {
        return i < 10 ? "0".concat(i) : i;
      }

      return "".concat(e.getUTCFullYear(), "-").concat(t(e.getUTCMonth() + 1), "-").concat(t(e.getUTCDate()), "T").concat(t(e.getUTCHours()), ":").concat(t(e.getUTCMinutes()), ":").concat(t(e.getUTCSeconds()), "Z");
    }
  }, {
    key: "getCrossOriginValue",
    value: function getCrossOriginValue(e) {
      if (!e) return "anonymous";
      if (e !== "none") return e;
    }
  }, {
    key: "invariant",
    value: function invariant(e, t) {
      if (!e) throw new Error(t);
    }
  }, {
    key: "executePromises",
    value: function executePromises(e) {
      var t = e.length,
          i = 0,
          r = [],
          o = [];
      return new Promise(function (n, a) {
        var l = function l() {
          i++, i >= t && (o.length <= 0 ? n(r) : a(o));
        },
            c = function c(p) {
          r.push(p), l();
        },
            u = function u(p) {
          o.push(p), l();
        };

        e.forEach(function (p) {
          p.then(c).catch(u);
        });
      });
    }
  }]);

  return ki;
}(),
    Ia = ki;

S(Ia, "Array", _u);
var T = Ia;

var Ep = [{
  name: "trace",
  type: "trace",
  background: "#EEEEEE",
  color: "#AAAAAA"
}, {
  name: "info",
  type: "log",
  background: "#BDE5F8",
  color: "#00529B"
}, {
  name: "warn",
  type: "warn",
  background: "#FEEFB3",
  color: "#9F6000"
}, {
  name: "error",
  type: "error",
  background: "#FFBABA",
  color: "#D8000C"
}, {
  name: "log",
  type: "log",
  background: "#EEEEEE",
  color: "#1f4f6b"
}],
    yu = function yu() {
  return console && console.group && console.groupCollapsed && console.groupEnd;
},
    Sp = function Sp() {
  return typeof navigator != "undefined" && navigator.userAgent.match(/Gecko|WebKit/i) && !navigator.userAgent.match(/Trident/);
},
    Ap = function Ap(s, e) {
  return ["background: #2D7BFF; line-height: 20px; padding: 4px 0", "background: #2B2B2B; color: white; line-height: 20px; padding: 4px 0", "background: #2D7BFF; line-height: 20px; padding: 4px 0", "background: ".concat(s, "; color: ").concat(e, "; line-height: 20px; padding: 4px 0; font-weight: bold"), "background: #2B2B2B; color: white; line-height: 20px; padding: 4px 0", "background: #2D7BFF; line-height: 20px; padding: 4px 0"];
},
    bu =
/*#__PURE__*/
function () {
  function bu() {
    var _this4 = this;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "warn";
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Ep;

    _classCallCheck(this, bu);

    this._levels = _toConsumableArray(t), this._maxLevel = this.getLevelIndexByName(e), this._consoleFuncs = {
      trace: function trace() {
        var _console, _console2;

        yu() ? ((_console = console).groupCollapsed.apply(_console, arguments), console.trace(), console.groupEnd()) : (_console2 = console).trace.apply(_console2, arguments);
      }
    }, this._levels.forEach(function (_ref14) {
      var i = _ref14.name;

      _this4[i] = function (r) {
        for (var _len4 = arguments.length, o = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          o[_key4 - 1] = arguments[_key4];
        }

        _this4._log.apply(_this4, [i, r].concat(o));
      };
    });
  }

  _createClass(bu, [{
    key: "getLevelIndexByName",
    value: function getLevelIndexByName(e) {
      return T.Array.findIndex(this._levels, function (t) {
        return t.name === e;
      });
    }
  }, {
    key: "getLevelObjectByName",
    value: function getLevelObjectByName(e) {
      return T.Array.find(this._levels, function (t) {
        return t.name === e;
      });
    }
  }, {
    key: "canLog",
    value: function canLog(e) {
      var t = this.getLevelIndexByName(e);
      return t < 0 ? !1 : t >= this._maxLevel;
    }
  }, {
    key: "setLevel",
    value: function setLevel(e) {
      var t = this.getLevelIndexByName(e);
      t < 0 || (this._maxLevel = t);
    }
  }, {
    key: "_log",
    value: function _log(e, t) {
      var _console5;

      var r = this.getLevelObjectByName(e);
      if (!r || !this.canLog(e)) return;

      for (var _len5 = arguments.length, i = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        i[_key5 - 2] = arguments[_key5];
      }

      var o = r.name,
          n = r.type,
          a = r.background,
          l = r.color,
          c = i.filter(function (d) {
        return d !== void 0;
      }).map(function (d) {
        return d.toObject ? JSON.parse(JSON.stringify(d.toObject())) : d;
      }),
          u = this._consoleFuncs[n] || console[n] ? function () {
        var _console3;

        return (_console3 = console)[n].apply(_console3, arguments);
      } : function () {
        var _console4;

        return (_console4 = console).log.apply(_console4, arguments);
      },
          p = c.length,
          h = Ap(a, l);

      if (!Sp()) {
        var _d3 = c.length;

        if (_d3 <= 0) {
          u("PhotoEditorSDK | ".concat(t, " "));
          return;
        }

        if (_d3 === 1 && typeof c[0] == "string") {
          u("PhotoEditorSDK | ".concat(t, " | ").concat(c[0]));
          return;
        }

        u.apply(void 0, ["PhotoEditorSDK | ".concat(t, " | ")].concat(_toConsumableArray(c)));
        return;
      }

      if (p <= 0) {
        u.apply(void 0, ["%c  %c PhotoEditorSDK %c  %c ".concat(t, " %c %c  ")].concat(_toConsumableArray(h)));
        return;
      }

      if (p === 1 && typeof c[0] == "string") {
        u.apply(void 0, ["%c  %c PhotoEditorSDK %c  %c ".concat(t, " %c  ").concat(c[0], "  %c  ")].concat(_toConsumableArray(h)));
        return;
      }

      yu() ? ((_console5 = console).groupCollapsed.apply(_console5, ["%c  %c PhotoEditorSDK %c  %c ".concat(t, " %c")].concat(_toConsumableArray(T.Array.init(h)))), u.apply(void 0, _toConsumableArray(c)), console.groupEnd()) : u.apply(void 0, ["%c  %c PhotoEditorSDK %c  %c ".concat(t, " %c")].concat(_toConsumableArray(T.Array.init(h)), _toConsumableArray(c)));
    }
  }, {
    key: "image",
    value: function image() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var t = arguments.length > 1 ? arguments[1] : undefined;
      {
        var i = new window.Image(),
            r = function r() {
          var _i2 = i,
              o = _i2.width,
              _i3 = i,
              n = _i3.height;
          e && console.log(e), console.log("%c+", "\n        font-size: 1px;\n        padding: 0px ".concat(Math.floor(o / 2), "px;\n        line-height: ").concat(n, "px;\n        background: url(").concat(i.src, ");\n        color: transparent;\n        background-repeat: no-repeat;\n        background-size: ").concat(o, "px ").concat(n, "px;"));
        };

        return i.onload = r, t instanceof window.HTMLCanvasElement ? i.src = t.toDataURL() : t instanceof window.Image ? (i = t, r()) : typeof t == "string" ? i.src = t : this.log(e, t), i;
      }
    }
  }, {
    key: "texture",
    value: function texture() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var t = arguments.length > 1 ? arguments[1] : undefined;
      {
        if (!t) {
          this.log(e, "texture: null or undefined");
          return;
        }

        var i = t.getBaseTexture(),
            r = i.getRenderers(),
            o = T.Array.find(r, function (l) {
          return l && l.constructor.type === "webgl";
        }),
            _i$getFrame = i.getFrame(),
            n = _i$getFrame.width,
            a = _i$getFrame.height;

        if (o) {
          var l = o.getContext(),
              c = i.getGLTextureForRenderer(o);
          this.logGlTexture(l, c, n, a, e);
        } else Oa.image(e, i.getSource());
      }
    }
  }, {
    key: "logGlTexture",
    value: function logGlTexture(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 150;
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 150;
      var o = arguments.length > 4 ? arguments[4] : undefined;
      {
        e.bindTexture(e.TEXTURE_2D, t);
        var n = e.createFramebuffer();
        e.bindFramebuffer(e.FRAMEBUFFER, n), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0);
        var a = new Uint8Array(i * r * 4);
        e.readPixels(0, 0, i, r, e.RGBA, e.UNSIGNED_BYTE, a), e.deleteFramebuffer(n);
        var l = document.createElement("canvas");
        l.width = i, l.height = r;
        var c = l.getContext("2d"),
            u = c.createImageData(i, r);
        return u.data.set(a), c.putImageData(u, 0, 0), Oa.image(o, l);
      }
    }
  }]);

  return bu;
}(),
    Oa = new bu("warn"),
    A = Oa;

var Na = {};
we(Na, {
  ImageLoader: function ImageLoader() {
    return at;
  },
  JSONLoader: function JSONLoader() {
    return Rt;
  }
});
var at = {
  load: function load(s) {
    var _this5 = this;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      cors: !0,
      value: "anonymous"
    };
    return function () {
      return Promise.resolve([s, s]);
    }().then(function (_ref15) {
      var _ref16 = _slicedToArray(_ref15, 2),
          i = _ref16[0],
          r = _ref16[1];

      return _this5._createAndLoadImage(i, r, e);
    });
  },
  loadImage: function loadImage(s) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      cors: !0,
      value: "anonymous"
    };
    return this._loadWithoutExif(s, e);
  },
  _loadWithoutExif: function _loadWithoutExif(s) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      cors: !0,
      value: "anonymous"
    };
    return new Promise(function (t, i) {
      var r = new window.Image();
      r.addEventListener("load", function () {
        t(r);
      }), r.addEventListener("error", function () {
        i(new Error("Failed to load image at ".concat(s)));
      }), e.cors && (r.crossOrigin = e.value), r.src = s;
    });
  },
  _createAndLoadImage: function _createAndLoadImage(s, e) {
    var _this6 = this;

    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      cors: !0,
      value: "anonymous"
    };
    return new Promise(function (i, r) {
      {
        var o = _this6._loadWithoutExif(e, t).then(function (a) {
          return i(a);
        }),
            n = new Promise(function (a, l) {
          _this6._loadAsDataURL(e, t).then(function (c) {
            var u = new window.Image();
            u.addEventListener("load", function () {
              a(u);
            }), u.src = c, u.rawSource = c;
          }).catch(function (c) {
            o.then(function (u) {
              return a(u);
            });
          });
        });

        return _this6._stringEndsWith(e, ".svg") ? o.then(function (a) {
          return i(a);
        }) : n.then(function (a) {
          return i(a);
        });
      }
    });
  },
  _stringEndsWith: function _stringEndsWith(s, e) {
    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : s.length;
    return (t === void 0 || t > s.length) && (t = s.length), s.substring(t - e.length, t) === e;
  },
  _loadAsDataURL: function _loadAsDataURL(s) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      cors: !0,
      value: "anonymous"
    };
    return new Promise(function (t, i) {
      var r = new XMLHttpRequest();
      r.onload = function () {
        var o = new FileReader();
        o.onloadend = function () {
          o.error && i(o.error), t(o.result);
        }, o.readAsDataURL(r.response);
      }, r.open("GET", s), r.responseType = "blob", r.withCredentials = e.cors && e.value === "use-credentials", r.send();
    });
  },
  loadXHR: function loadXHR(s, e) {
    return new Promise(function (t, i) {
      var r;
      window.XDomainRequest ? (r = new window.XDomainRequest(), e && r.overrideMimeType(e), r.onload = function () {
        t(r);
      }, r.onerror = function (o) {
        i(o);
      }) : window.XMLHttpRequest && (r = new window.XMLHttpRequest(), e && r.overrideMimeType(e), r.onreadystatechange = function (o) {
        r.readyState === 4 && (r.status === 200 ? t(r) : i(new Error("HTTP Status ".concat(r.status))));
      }), r.open("GET", s, !0), r.send();
    });
  }
};
var Pa = Te(er()),
    Op = /https?|ftp|gopher|file/;

function ns(s) {
  typeof s == "string" && (s = tr(s));

  var e = function (t, i, r) {
    var o = t.auth,
        n = t.hostname,
        a = t.protocol || "",
        l = t.pathname || "",
        c = t.hash || "",
        u = t.query || "",
        p = !1;
    o = o ? encodeURIComponent(o).replace(/%3A/i, ":") + "@" : "", t.host ? p = o + t.host : n && (p = o + (~n.indexOf(":") ? "[" + n + "]" : n), t.port && (p += ":" + t.port)), u && typeof u == "object" && (u = i.encode(u));
    var h = t.search || u && "?" + u || "";
    return a && a.substr(-1) !== ":" && (a += ":"), t.slashes || (!a || r.test(a)) && p !== !1 ? (p = "//" + (p || ""), l && l[0] !== "/" && (l = "/" + l)) : p || (p = ""), c && c[0] !== "#" && (c = "#" + c), h && h[0] !== "?" && (h = "?" + h), {
      protocol: a,
      host: p,
      pathname: l = l.replace(/[?#]/g, encodeURIComponent),
      search: h = h.replace("#", "%23"),
      hash: c
    };
  }(s, Pa.default, Op);

  return "" + e.protocol + e.host + e.pathname + e.search + e.hash;
}

var Ba = "http://",
    Ma = "w.w",
    La = Ba + Ma,
    Pp = /^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,
    Bp = /https?|ftp|gopher|file/;

function Cu(s, e) {
  var t = typeof s == "string" ? tr(s) : s;
  s = typeof s == "object" ? ns(s) : s;
  var i = tr(e),
      r = "";
  t.protocol && !t.slashes && (r = t.protocol, s = s.replace(t.protocol, ""), r += e[0] === "/" || s[0] === "/" ? "/" : ""), r && i.protocol && (r = "", i.slashes || (r = i.protocol, e = e.replace(i.protocol, "")));
  var o = s.match(Pp);
  o && !i.protocol && (s = s.substr((r = o[1] + (o[2] || "")).length), /^\/\/[^/]/.test(e) && (r = r.slice(0, -1)));
  var n = new URL(s, La + "/"),
      a = new URL(e, n).toString().replace(La, ""),
      l = i.protocol || t.protocol;
  return l += t.slashes || i.slashes ? "//" : "", !r && l ? a = a.replace(Ba, l) : r && (a = a.replace(Ba, "")), Bp.test(a) || ~e.indexOf(".") || s.slice(-1) === "/" || e.slice(-1) === "/" || a.slice(-1) !== "/" || (a = a.slice(0, -1)), r && (a = r + (a[0] === "/" ? a.substr(1) : a)), a;
}

function ir() {}

ir.prototype.parse = tr, ir.prototype.format = ns, ir.prototype.resolve = Cu, ir.prototype.resolveObject = Cu;
var za = /^https?|ftp|gopher|file/,
    Mp = /^(.*?)([#?].*)/,
    Lp = /^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,
    zp = /^([a-z0-9.+-]*:)?\/\/\/*/i,
    Up = /^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;

function tr(s, e, t) {
  if (e === void 0 && (e = !1), t === void 0 && (t = !1), s && typeof s == "object" && s instanceof ir) return s;
  var i = (s = s.trim()).match(Mp);
  s = i ? i[1].replace(/\\/g, "/") + i[2] : s.replace(/\\/g, "/"), Up.test(s) && s.slice(-1) !== "/" && (s += "/");
  var r = !/(^javascript)/.test(s) && s.match(Lp),
      o = zp.test(s),
      n = "";
  r && (za.test(r[1]) || (n = r[1].toLowerCase(), s = "" + r[2] + r[3]), r[2] || (o = !1, za.test(r[1]) ? (n = r[1], s = "" + r[3]) : s = "//" + r[3]), r[2].length !== 3 && r[2].length !== 1 || (n = r[1], s = "/" + r[3]));
  var a,
      l = (i ? i[1] : s).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),
      c = l && l[1],
      u = new ir(),
      p = "",
      h = "";

  try {
    a = new URL(s);
  } catch (y) {
    p = y, n || t || !/^\/\//.test(s) || /^\/\/.+[@.]/.test(s) || (h = "/", s = s.substr(1));

    try {
      a = new URL(s, La);
    } catch (_) {
      return u.protocol = n, u.href = n, u;
    }
  }

  u.slashes = o && !h, u.host = a.host === Ma ? "" : a.host, u.hostname = a.hostname === Ma ? "" : a.hostname.replace(/(\[|\])/g, ""), u.protocol = p ? n || null : a.protocol, u.search = a.search.replace(/\\/g, "%5C"), u.hash = a.hash.replace(/\\/g, "%5C");
  var d = s.split("#");
  !u.search && ~d[0].indexOf("?") && (u.search = "?"), u.hash || d[1] !== "" || (u.hash = "#"), u.query = e ? Pa.default.decode(a.search.substr(1)) : u.search.substr(1), u.pathname = h + (r ? function (y) {
    return y.replace(/['^|`]/g, function (_) {
      return "%" + _.charCodeAt().toString(16).toUpperCase();
    }).replace(/((?:%[0-9A-F]{2})+)/g, function (_, f) {
      try {
        return decodeURIComponent(f).split("").map(function (v) {
          var b = v.charCodeAt();
          return b > 256 || /^[a-z0-9]$/i.test(v) ? v : "%" + b.toString(16).toUpperCase();
        }).join("");
      } catch (v) {
        return f;
      }
    });
  }(a.pathname) : a.pathname), u.protocol === "about:" && u.pathname === "blank" && (u.protocol = "", u.pathname = ""), p && s[0] !== "/" && (u.pathname = u.pathname.substr(1)), n && !za.test(n) && s.slice(-1) !== "/" && u.pathname === "/" && (u.pathname = ""), u.path = u.pathname + u.search, u.auth = [a.username, a.password].map(decodeURIComponent).filter(Boolean).join(":"), u.port = a.port, c && !u.host.endsWith(c) && (u.host += c, u.port = c.slice(1)), u.href = h ? "" + u.pathname + u.search + u.hash : ns(u);
  var g = /^(file)/.test(u.href) ? ["host", "hostname"] : [];
  return Object.keys(u).forEach(function (y) {
    ~g.indexOf(y) || (u[y] = u[y] || null);
  }), u;
}

var Np = 5e3,
    as = typeof window != "undefined" ? window : global,
    Ua =
/*#__PURE__*/
function () {
  function Ua(e) {
    _classCallCheck(this, Ua);

    this._url = e, this._parsedUrl = tr(this._url, !0);
  }

  _createClass(Ua, [{
    key: "_isJSONPRequest",
    value: function _isJSONPRequest() {
      var e = this._parsedUrl.query;

      for (var t in e) {
        if (e[t] === "?") return !0;
      }

      return !1;
    }
  }, {
    key: "load",
    value: function load() {
      return this._isJSONPRequest() ? this._loadJSONP() : this._loadJSON();
    }
  }, {
    key: "_loadJSON",
    value: function _loadJSON() {
      var _this7 = this;

      return new Promise(function (e, t) {
        var i;
        as.XDomainRequest ? (i = new as.XDomainRequest(), i.onload = function () {
          var r = JSON.parse(i.responseText);
          e(r);
        }, i.onerror = function (r) {
          t(r);
        }, i.open("GET", _this7._url, !0), i.send()) : as.XMLHttpRequest && (i = new XMLHttpRequest(), i.onreadystatechange = function (r) {
          if (i.readyState === 4) if (i.status === 200) {
            var o = JSON.parse(i.responseText);
            e(o);
          } else t(new Error("HTTP Status ".concat(i.status)));
        }, i.open("GET", _this7._url, !0), i.send());
      });
    }
  }, {
    key: "_loadJSONP",
    value: function _loadJSONP() {
      var _this8 = this;

      var e = !1,
          t = !1,
          i = "pesdk".concat(Math.round(Math.random() * 99999999999999));
      return new Promise(function (r, o) {
        var n = _this8._createJSONPNode(i);

        as[i] = function (a) {
          _this8._removeJSONPNode(n), e || (t = !0, r(a));
        }, as.setTimeout(function () {
          t || (_this8._removeJSONPNode(n), e = !0, o(new Error("Timeout of 5 seconds exceeded.")));
        }, Np);
      });
    }
  }, {
    key: "_createJSONPNode",
    value: function _createJSONPNode(e) {
      var t = this._buildJSONPUrl(e),
          i = document.querySelector("head"),
          r = document.createElement("script");

      return r.src = t, i.appendChild(r), r;
    }
  }, {
    key: "_removeJSONPNode",
    value: function _removeJSONPNode(e) {
      e.parentNode.removeChild(e);
    }
  }, {
    key: "_buildJSONPUrl",
    value: function _buildJSONPUrl(e) {
      var t = this._parsedUrl.query,
          i = null;

      for (var r in t) {
        if (t[r] === "?") {
          i = r;
          break;
        }
      }

      return delete this._parsedUrl.search, t[i] = e, ns(this._parsedUrl);
    }
  }]);

  return Ua;
}(),
    Rt = Ua;

var Qe =
/*#__PURE__*/
function () {
  function Qe(e, t, i) {
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Qe);

    this.r = e, this.g = t, this.b = i, this.a = r;
  }

  _createClass(Qe, [{
    key: "toRGBA",
    value: function toRGBA() {
      return "rgba(".concat([Math.round(this.r * 255), Math.round(this.g * 255), Math.round(this.b * 255), this.a.toFixed(2)].join(","), ")");
    }
  }, {
    key: "set",
    value: function set(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.a;
      return this.r = e, this.g = t, this.b = i, this.a = r, this;
    }
  }, {
    key: "toRGB",
    value: function toRGB() {
      return [Math.round(this.r * 255), Math.round(this.g * 255), Math.round(this.b * 255)];
    }
  }, {
    key: "toHex",
    value: function toHex() {
      return "#".concat([this._componentToHex(Math.round(this.r * 255)), this._componentToHex(Math.round(this.g * 255)), this._componentToHex(Math.round(this.b * 255))].join(""));
    }
  }, {
    key: "toGLColor",
    value: function toGLColor() {
      return [this.r, this.g, this.b, this.a];
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return this.toGLColor();
    }
  }, {
    key: "toRGBGLColor",
    value: function toRGBGLColor() {
      return [this.r, this.g, this.b];
    }
  }, {
    key: "toHSV",
    value: function toHSV() {
      var e = Math.max(this.r, this.g, this.b),
          t = Math.min(this.r, this.g, this.b),
          i,
          r,
          o = e,
          n = e - t;
      if (r = e === 0 ? 0 : n / e, e === t) i = 0;else {
        switch (e) {
          case this.r:
            i = (this.g - this.b) / n, this.g < this.b && (i += 6);
            break;

          case this.g:
            i = (this.b - this.r) / n + 2;
            break;

          case this.b:
            i = (this.r - this.g) / n + 4;
            break;
        }

        i /= 6;
      }
      return [i, r, o];
    }
  }, {
    key: "fromHSV",
    value: function fromHSV(e, t, i) {
      return this.copy(Qe.fromHSV(e, t, i)), this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Qe(this.r, this.g, this.b, this.a);
    }
  }, {
    key: "add",
    value: function add(e) {
      return this.r += e.r, this.g += e.g, this.b += e.b, this.a += e.a, this;
    }
  }, {
    key: "minus",
    value: function minus(e) {
      return this.r -= e.r, this.g -= e.g, this.b -= e.b, this.a -= e.a, this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(e) {
      return this.r *= e, this.g *= e, this.b *= e, this.a *= e, this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(e) {
      return this.r /= e, this.g /= e, this.b /= e, this.a /= e, this;
    }
  }, {
    key: "clamp",
    value: function clamp(e, t) {
      return this.r = Math.min(Math.max(this.r, e), t), this.g = Math.min(Math.max(this.g, e), t), this.b = Math.min(Math.max(this.b, e), t), this.a = Math.min(Math.max(this.a, e), t), this;
    }
  }, {
    key: "mix",
    value: function mix(e, t) {
      return this.r = (1 - t) * this.r + t * e.r, this.g = (1 - t) * this.g + t * e.g, this.b = (1 - t) * this.b + t * e.b, this.a = (1 - t) * this.a + t * e.a, this;
    }
  }, {
    key: "copy",
    value: function copy(e) {
      return this.r = e.r, this.g = e.g, this.b = e.b, this.a = e.a, this;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return this.r === e.r && this.g === e.g && this.b === e.b && this.a === e.a;
    }
  }, {
    key: "_componentToHex",
    value: function _componentToHex(e) {
      var t = e.toString(16);
      return t.length === 1 ? "0".concat(t) : t;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Color(".concat(this.r, ", ").concat(this.g, ", ").concat(this.b, ", ").concat(this.a, ")");
    }
  }], [{
    key: "fromHSV",
    value: function fromHSV(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var _ref17 = [],
          o = _ref17[0],
          n = _ref17[1],
          a = _ref17[2],
          l = Math.floor(e * 6),
          c = e * 6 - l,
          u = i * (1 - t),
          p = i * (1 - c * t),
          h = i * (1 - (1 - c) * t);

      switch (l % 6) {
        case 0:
          o = i, n = h, a = u;
          break;

        case 1:
          o = p, n = i, a = u;
          break;

        case 2:
          o = u, n = i, a = h;
          break;

        case 3:
          o = u, n = p, a = i;
          break;

        case 4:
          o = h, n = u, a = i;
          break;

        case 5:
          o = i, n = u, a = p;
          break;
      }

      return new Qe(o, n, a, r);
    }
  }, {
    key: "fromArray",
    value: function fromArray(e) {
      return new Qe(e[0], e[1], e[2], e[3]);
    }
  }, {
    key: "fromHex",
    value: function fromHex(e) {
      var _e$match = e.match(/[0-9A-fa-f]{1,2}/g),
          _e$match2 = _slicedToArray(_e$match, 3),
          t = _e$match2[0],
          i = _e$match2[1],
          r = _e$match2[2];

      return new Qe(parseInt(t, 16) / 255, parseInt(i, 16) / 255, parseInt(r, 16) / 255, 1);
    }
  }, {
    key: "TRANSPARENT",
    get: function get() {
      return new Qe(0, 0, 0, 0);
    }
  }, {
    key: "WHITE",
    get: function get() {
      return new Qe(1, 1, 1, 1);
    }
  }, {
    key: "BLACK",
    get: function get() {
      return new Qe(0, 0, 0, 1);
    }
  }, {
    key: "RED",
    get: function get() {
      return new Qe(1, 0, 0, 1);
    }
  }, {
    key: "BLUE",
    get: function get() {
      return new Qe(0, 0, 1, 1);
    }
  }, {
    key: "GREEN",
    get: function get() {
      return new Qe(0, 1, 0, 1);
    }
  }]);

  return Qe;
}(),
    R = Qe;

var Gp = 12,
    wu =
/*#__PURE__*/
function () {
  function wu() {
    _classCallCheck(this, wu);

    this._maxListeners = Gp, this._events = {}, this._pipeDestinations = [];
  }

  _createClass(wu, [{
    key: "pipeEvents",
    value: function pipeEvents(e) {
      this._pipeDestinations.push(e);
    }
  }, {
    key: "unpipeEvents",
    value: function unpipeEvents(e) {
      var t = this._pipeDestinations.indexOf(e);

      t !== -1 && this._pipeDestinations.splice(t, 1);
    }
  }, {
    key: "on",
    value: function on(e, t) {
      if (typeof e == "undefined") throw new Error("Invalid event type: `".concat(e, "`"));
      if (typeof t != "function") throw new TypeError();
      var i = this._events[e] || (this._events[e] = []);
      return i.indexOf(t) !== -1 ? this : (i.push(t), this._maxListeners && i.length > this._maxListeners && (A.warn("EventEmitter", "Possible memory leak detected, added ".concat(i.length, " `").concat(e, "` listeners (current limit is ").concat(this._maxListeners, ")")), typeof console != "undefined" && console.trace()), this);
    }
  }, {
    key: "once",
    value: function once(e, t) {
      if (typeof e == "undefined") throw new Error("Invalid event type: `".concat(e, "`"));
      var i = this;

      function r() {
        i.off(e, r), t.apply(null, arguments);
      }

      return this.on(e, r);
    }
  }, {
    key: "off",
    value: function off(e) {
      if (typeof e == "undefined") throw new Error("Invalid event type: `".concat(e, "`"));
      if ((arguments.length <= 1 ? 0 : arguments.length - 1) === 0) return this._events[e] = null, this;
      var i = arguments.length <= 1 ? undefined : arguments[1];
      if (typeof i != "function") throw new TypeError();
      var r = this._events[e];
      if (!r || !r.length) return this;
      var o = r.indexOf(i);
      return o === -1 ? this : (r.splice(o, 1), this);
    }
  }, {
    key: "emit",
    value: function emit(e) {
      for (var _len6 = arguments.length, t = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        t[_key6 - 1] = arguments[_key6];
      }

      if (typeof e == "undefined") throw new Error("Invalid event type: `".concat(e, "`"));

      this._pipeDestinations.forEach(function (r) {
        r.emit.apply(r, [e].concat(t));
      });

      var i = this._events[e];
      return !i || !i.length ? !1 : (i.slice(0).forEach(function (r) {
        return r.apply(null, t);
      }), !0);
    }
  }, {
    key: "setMaxListeners",
    value: function setMaxListeners(e) {
      if (parseInt(e, 10) !== e) throw new TypeError();
      this._maxListeners = e;
    }
  }]);

  return wu;
}(),
    We = wu;

var Ti = {
  checkFramebufferStatus: function checkFramebufferStatus(s, e) {
    var _i4;

    var t = e.checkFramebufferStatus(e.FRAMEBUFFER),
        i = (_i4 = {}, _defineProperty(_i4, e.FRAMEBUFFER_INCOMPLETE_ATTACHMENT, "Incomplete attachment"), _defineProperty(_i4, e.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT, "Missing attachment"), _defineProperty(_i4, e.FRAMEBUFFER_INCOMPLETE_DIMENSIONS, "Incomplete dimensions"), _defineProperty(_i4, e.FRAMEBUFFER_UNSUPPORTED, "Framebuffer unsupported"), _i4);
    t !== e.FRAMEBUFFER_COMPLETE && A.warn(s, "Framebuffer incomplete: ".concat(i[t]));
  },
  determineGPUName: function determineGPUName(s) {
    var e = null,
        t = null;
    s || (t = document.createElement("canvas"), s = t.getContext("experimental-webgl") || t.getContext("webgl"));
    var i = s && s.getExtension("WEBGL_debug_renderer_info");
    return i && (e = s.getParameter(i.UNMASKED_RENDERER_WEBGL), t && t.remove()), e;
  },
  isGPUBlacklisted: function isGPUBlacklisted(s) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return !1;
  }
};

var Zs = function Zs(s) {
  return typeof s == "number";
};

var Wp = function Wp(s) {
  return s instanceof B;
},
    Ri = function Ri(s, e) {
  return Wp(s) ? {
    x: s.x,
    y: s.y
  } : {
    x: s,
    y: Zs(e) ? e : s
  };
},
    $s = function $s(s, e) {
  return function (t, i) {
    var _Ri = Ri(t, i),
        r = _Ri.x,
        o = _Ri.y;

    return s.x = e(s.x, r), s.y = e(s.y, o), s;
  };
},
    B =
/*#__PURE__*/
function () {
  function B() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, B);

    this.add = $s(this, function (e, t) {
      return e + t;
    });
    this.subtract = $s(this, function (e, t) {
      return e - t;
    });
    this.divide = $s(this, function (e, t) {
      return e / t;
    });
    this.multiply = $s(this, function (e, t) {
      return e * t;
    });
    this.x = e, this.y = t;
  }

  _createClass(B, [{
    key: "set",
    value: function set(e, t) {
      var _Ri2 = Ri(e, t),
          i = _Ri2.x,
          r = _Ri2.y;

      return this.x = i, this.y = r, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new B(this.x, this.y);
    }
  }, {
    key: "copy",
    value: function copy(e) {
      return this.x = e.x, this.y = e.y, this;
    }
  }, {
    key: "clamp",
    value: function clamp(e, t) {
      return Zs(e) && (e = new B(e, e)), Zs(t) && (t = new B(t, t)), e && (this.x = Math.max(e.x, this.x), this.y = Math.max(e.y, this.y)), t && (this.x = Math.min(t.x, this.x), this.y = Math.min(t.y, this.y)), this;
    }
  }, {
    key: "dot",
    value: function dot(e, t) {
      var _Ri3 = Ri(e, t),
          i = _Ri3.x,
          r = _Ri3.y;

      return this.x * i + this.y * r;
    }
  }, {
    key: "equals",
    value: function equals(e, t) {
      var _Ri4 = Ri(e, t),
          i = _Ri4.x,
          r = _Ri4.y;

      return i === this.x && r === this.y;
    }
  }, {
    key: "flip",
    value: function flip() {
      var e = this.x;
      return this.x = this.y, this.y = e, this;
    }
  }, {
    key: "round",
    value: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
  }, {
    key: "floor",
    value: function floor() {
      return this.x |= 0, this.y |= 0, this;
    }
  }, {
    key: "abs",
    value: function abs() {
      return this.x = Math.abs(this.x), this.y = Math.abs(this.y), this;
    }
  }, {
    key: "len",
    value: function len() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }
  }, {
    key: "min",
    value: function min() {
      return Math.min(this.x, this.y);
    }
  }, {
    key: "max",
    value: function max() {
      return Math.max(this.x, this.y);
    }
  }, {
    key: "toObject",
    value: function toObject() {
      return {
        x: this.x,
        y: this.y
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Vector2({ x: ".concat(this.x, ", y: ").concat(this.y, " })");
    }
  }, {
    key: "roundDecimal",
    value: function roundDecimal(e) {
      return this.x = parseFloat(this.x.toFixed(e)), this.y = parseFloat(this.y.toFixed(e)), this;
    }
  }, {
    key: "asArray",
    value: function asArray() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return e ? [this.y, this.x] : [this.x, this.y];
    }
  }], [{
    key: "fromObject",
    value: function fromObject(e) {
      return new B(e.x, e.y);
    }
  }, {
    key: "NULL",
    get: function get() {
      return new B(0, 0);
    }
  }]);

  return B;
}();

var Ze =
/*#__PURE__*/
function () {
  function Ze() {
    _classCallCheck(this, Ze);

    this.a = 1;
    this.b = 0;
    this.c = 0;
    this.d = 1;
    this.tx = 0;
    this.ty = 0;
    this.reset();
  }

  _createClass(Ze, [{
    key: "multiply",
    value: function multiply(e) {
      var t, i, r, o, n, a;
      return t = this.a * e.a + this.b * e.c, i = this.a * e.b + this.b * e.d, r = this.c * e.a + this.d * e.c, o = this.c * e.b + this.d * e.d, n = this.tx * e.a + this.ty * e.c + e.tx, a = this.tx * e.b + this.ty * e.d + e.ty, this.a = t, this.b = i, this.c = r, this.d = o, this.tx = n, this.ty = a, this;
    }
  }, {
    key: "applyToVector",
    value: function applyToVector(e) {
      var _e2 = e,
          t = _e2.x,
          i = _e2.y;
      return e = e.clone(), e.x = this.a * t + this.c * i + this.tx, e.y = this.b * t + this.d * i + this.tx, e;
    }
  }, {
    key: "applyInverseToVector",
    value: function applyInverseToVector(e) {
      var t = 1 / (this.a * this.d + this.c * -this.b),
          _e3 = e,
          i = _e3.x,
          r = _e3.y;
      return e = e.clone(), e.x = this.d * t * i + -this.c * t * r + (this.ty * this.c - this.tx * this.d) * t, e.y = this.a * t * r + -this.b * t * i + (-this.ty * this.a + this.tx * this.b) * t, e;
    }
  }, {
    key: "rectangleToCoordinates",
    value: function rectangleToCoordinates(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new B(0, 0);
      var i = e.width * (1 - t.x),
          r = e.width * -t.x,
          o = e.height * (1 - t.y),
          n = e.height * -t.y,
          a = [];
      return a.push(new B(this.a * r + this.c * n + this.tx, this.d * n + this.b * r + this.ty)), a.push(new B(this.a * i + this.c * n + this.tx, this.d * n + this.b * i + this.ty)), a.push(new B(this.a * i + this.c * o + this.tx, this.d * o + this.b * i + this.ty)), a.push(new B(this.a * r + this.c * o + this.tx, this.d * o + this.b * r + this.ty)), a;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var e = [this.a, this.b, 0, this.c, this.d, 0, this.tx, this.ty, 1];
      return typeof Float32Array == "undefined" ? e : new Float32Array(e);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Matrix({ a: ".concat(this.a, ", b: ").concat(this.b, ", c: ").concat(this.c, ", d: ").concat(this.d, ", tx: ").concat(this.tx, ", ty: ").concat(this.ty, " })");
    }
  }], [{
    key: "IDENTITY",
    get: function get() {
      return new Ze();
    }
  }]);

  return Ze;
}();

var le =
/*#__PURE__*/
function () {
  function le() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, le);

    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
    this.x = e, this.y = t, this.width = i, this.height = r;
  }

  _createClass(le, [{
    key: "set",
    value: function set(e, t, i, r) {
      return this.x = e, this.y = t, this.width = i, this.height = r, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new le(this.x, this.y, this.width, this.height);
    }
  }, {
    key: "copy",
    value: function copy(e) {
      return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this;
    }
  }, {
    key: "equals",
    value: function equals(e, t, i, r) {
      return e instanceof le ? e.x === this.x && e.y === this.y && e.width === this.width && e.height === this.height : e === this.x && t === this.y && i === this.width && r === this.height;
    }
  }, {
    key: "translate",
    value: function translate(e, t) {
      var _Ri5 = Ri(e, t),
          i = _Ri5.x,
          r = _Ri5.y;

      return this.x += i, this.y += r, this;
    }
  }, {
    key: "scale",
    value: function scale(e, t) {
      var _Ri6 = Ri(e, t),
          i = _Ri6.x,
          r = _Ri6.y;

      return this.width *= i, this.height *= r, this;
    }
  }, {
    key: "round",
    value: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this.width = Math.round(this.width), this.height = Math.round(this.height), this;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return new B(this.x, this.y);
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return new B(this.width, this.height);
    }
  }, {
    key: "insetBy",
    value: function insetBy(e, t) {
      return this.x += e, this.y += t, this.width -= 2 * e, this.height -= 2 * t, this;
    }
  }, {
    key: "intersects",
    value: function intersects(e) {
      var t = new B(this.x, this.y),
          i = new B(this.x + this.width, this.y + this.height),
          r = new B(e.x, e.y),
          o = new B(e.x + e.width, e.y + e.height);
      return !(r.x > i.x || t.x > o.x || o.y < t.y || i.y < r.y);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Rectangle({ x: ".concat(this.x, ", y: ").concat(this.y, ", width: ").concat(this.width, ", height: ").concat(this.height, " })");
    }
  }], [{
    key: "FromDiagonalPoints",
    value: function FromDiagonalPoints(e, t) {
      var i = !1;
      t.x - e.x < 0 && (i = !0);
      var r = i ? t : e,
          o = i ? e : t,
          n = o.x - r.x,
          a = o.y - r.y;
      return new le(r.x, r.y, n, a);
    }
  }]);

  return le;
}();

var rr = 2e3,
    Vp = 5,
    ii = Vp * 4;

var Fi =
/*#__PURE__*/
function () {
  function Fi() {
    _classCallCheck(this, Fi);

    this._position = new B(0, 0), this._scale = new B(1, 1), this._pivot = new B(0, 0), this._rotation = 0, this._lastRotation = null, this._alpha = 1, this._visible = !0, this._worldTransform = new Ze(), this._parent = null, this._shaders = [], this._boundsNeedUpdate = !0, this._bounds = new le(0, 0, 1, 1), this._localBoundsNeedUpdate = !0, this._localBounds = new le(0, 0, 1, 1), this._filterRectangle = new le(0, 0, 0, 0);
  }

  _createClass(Fi, [{
    key: "renderWebGL",
    value: function renderWebGL(e) {
      A.warn(this.constructor.name, "`renderWebGL` is abstract and not implemented in inherited class");
    }
  }, {
    key: "renderCanvas",
    value: function renderCanvas(e) {
      A.warn(this.constructor.name, "`renderCanvas` is abstract and not implemented in inherited class");
    }
  }, {
    key: "updateTransform",
    value: function updateTransform() {
      var e = this._parent ? this._parent.getWorldTransform() : Ze.IDENTITY,
          t = this._worldTransform,
          i = Math.sin(this._rotation),
          r = Math.cos(this._rotation);
      t.a = r * this._scale.x, t.b = i * this._scale.x, t.c = -i * this._scale.y, t.d = r * this._scale.y, t.tx = this._position.x, t.ty = this._position.y, (this._pivot.x || this._pivot.y) && (t.tx -= this._pivot.x * t.a + this._pivot.y * t.c, t.ty -= this._pivot.x * t.b + this._pivot.y * t.d), t.multiply(e), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
    }
  }, {
    key: "addShader",
    value: function addShader(e) {
      this._shaders.push(e);
    }
  }, {
    key: "removeShader",
    value: function removeShader(e) {
      var t = this._shaders.indexOf(e);

      return t !== -1 ? (this._shaders.splice(t, 1), !0) : !1;
    }
  }, {
    key: "removeShaderAt",
    value: function removeShaderAt(e) {
      return this._shaders[e] ? (this._shaders.splice(e, 1), !0) : !1;
    }
  }, {
    key: "getBounds",
    value: function getBounds() {
      return this._bounds.clone();
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return this._position;
    }
  }, {
    key: "setPosition",
    value: function setPosition(e, t) {
      this._position.set(e, t), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
    }
  }, {
    key: "getScale",
    value: function getScale() {
      return this._scale;
    }
  }, {
    key: "setScale",
    value: function setScale(e, t) {
      this._scale.set(e, t), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
    }
  }, {
    key: "getPivot",
    value: function getPivot() {
      return this._pivot;
    }
  }, {
    key: "setPivot",
    value: function setPivot(e, t) {
      this._pivot.set(e, t), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
    }
  }, {
    key: "getRotation",
    value: function getRotation() {
      return this._rotation;
    }
  }, {
    key: "setRotation",
    value: function setRotation(e) {
      this._rotation = e, this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
    }
  }, {
    key: "getAlpha",
    value: function getAlpha() {
      return this._alpha;
    }
  }, {
    key: "setAlpha",
    value: function setAlpha(e) {
      this._alpha = e;
    }
  }, {
    key: "getWorldAlpha",
    value: function getWorldAlpha() {
      return this._parent ? this._parent.getAlpha() * this._alpha : this._alpha;
    }
  }, {
    key: "getWorldTransform",
    value: function getWorldTransform() {
      return this._worldTransform;
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this._parent;
    }
  }, {
    key: "setParent",
    value: function setParent(e) {
      this._parent = e;
    }
  }, {
    key: "getFilterRectangle",
    value: function getFilterRectangle() {
      return this._filterRectangle;
    }
  }, {
    key: "setFilterRectangle",
    value: function setFilterRectangle(e) {
      this._filterRectangle.copy(e);
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this._visible;
    }
  }, {
    key: "setVisible",
    value: function setVisible(e) {
      this._visible = e;
    }
  }]);

  return Fi;
}();

var Ft =
/*#__PURE__*/
function (_Fi) {
  _inherits(Ft, _Fi);

  function Ft() {
    var _this9;

    _classCallCheck(this, Ft);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(Ft).call(this));
    _this9._children = [], _this9._filters = [];
    return _this9;
  }

  _createClass(Ft, [{
    key: "addFilter",
    value: function addFilter(e) {
      this._filters.push(e);
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(e) {
      var t = this._filters.indexOf(e);

      return t !== -1 ? (this._filters.splice(t, 1), !0) : !1;
    }
  }, {
    key: "setFilters",
    value: function setFilters(e) {
      this._filters = e;
    }
  }, {
    key: "addChild",
    value: function addChild(e) {
      var t = e.getParent();
      t instanceof Ft && t.removeChild(e), e.setParent(this), this._children.push(e);
    }
  }, {
    key: "prependChild",
    value: function prependChild(e) {
      var t = e.getParent();
      t instanceof Ft && t.removeChild(e), e.setParent(this), this._children.unshift(e);
    }
  }, {
    key: "hasChild",
    value: function hasChild(e) {
      return this._children.indexOf(e) !== -1;
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      var t = this._children.indexOf(e);

      t !== -1 ? (this._children.splice(t, 1), e.setParent(null)) : A.info(this.constructor.name, "Tried to remove a child that does not exist");
    }
  }, {
    key: "clearChildren",
    value: function clearChildren() {
      this._children = [];
    }
  }, {
    key: "renderWebGL",
    value: function renderWebGL(e) {
      if (!this._visible) return;
      var t = e.getFilterManager();
      this._filters && this._filters.length && t.pushFilters(this, this._filters), e.getCurrentObjectRenderer().start(), this._renderWebGL(e), this._children.forEach(function (i) {
        i.renderWebGL(e);
      }), e.getCurrentObjectRenderer().flush(), this._filters && this._filters.length && t.popFilters(), e.getCurrentObjectRenderer().start();
    }
  }, {
    key: "_renderWebGL",
    value: function _renderWebGL(e) {}
  }, {
    key: "renderCanvas",
    value: function renderCanvas(e) {
      if (!this._visible) return;
      var t = e.getFilterManager();
      this._filters && this._filters.length && t.pushFilters(this, this._filters), this._renderCanvas(e), this._children.forEach(function (i) {
        i.renderCanvas(e);
      }), this._filters && this._filters.length && t.popFilters();
    }
  }, {
    key: "_renderCanvas",
    value: function _renderCanvas(e) {}
  }, {
    key: "updateTransform",
    value: function updateTransform() {
      _get(_getPrototypeOf(Ft.prototype), "updateTransform", this).call(this), this._children.forEach(function (e) {
        e.updateTransform();
      });
    }
  }, {
    key: "getLocalBounds",
    value: function getLocalBounds() {
      return this._localBoundsNeedUpdate && (this._localBoundsNeedUpdate = !1), this._localBounds.clone();
    }
  }, {
    key: "getBounds",
    value: function getBounds() {
      return this._boundsNeedUpdate && (this._boundsNeedUpdate = !1), this._bounds.clone();
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this._children;
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      return this._filters;
    }
  }, {
    key: "dispose",
    value: function dispose() {}
  }]);

  return Ft;
}(Fi);

var Ya = {};
we(Ya, {
  ColorOverlayFilter: function ColorOverlayFilter() {
    return Au;
  },
  OverlayFilter: function OverlayFilter() {
    return Lu;
  },
  TintFilter: function TintFilter() {
    return Bu;
  },
  UnpremultiplyFilter: function UnpremultiplyFilter() {
    return Eu;
  }
});
"use strict";

var Hp = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259],
    jp = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];

function ku(s, e, t, i, r, o) {
  if (!(isNaN(o) || o < 1)) {
    o |= 0;

    var n = s.data,
        a,
        l,
        c,
        u,
        p,
        h,
        d,
        g,
        y,
        _,
        f,
        v,
        b,
        D,
        O,
        x,
        w,
        z,
        L,
        j,
        X,
        K,
        G,
        ae,
        Ne = o + o + 1,
        Oe = i - 1,
        kt = r - 1,
        Q = o + 1,
        be = Q * (Q + 1) / 2,
        me = new Du(),
        ce,
        J = me;

    for (c = 1; c < Ne; c++) {
      J = J.next = new Du(), c == Q && (ce = J);
    }

    J.next = me;
    var ge = null,
        Le = null;
    d = h = 0;
    var Jt = Hp[o],
        ei = jp[o];

    for (l = 0; l < r; l++) {
      for (x = w = z = L = g = y = _ = f = 0, v = Q * (j = n[h]), b = Q * (X = n[h + 1]), D = Q * (K = n[h + 2]), O = Q * (G = n[h + 3]), g += be * j, y += be * X, _ += be * K, f += be * G, J = me, c = 0; c < Q; c++) {
        J.r = j, J.g = X, J.b = K, J.a = G, J = J.next;
      }

      for (c = 1; c < Q; c++) {
        u = h + ((Oe < c ? Oe : c) << 2), g += (J.r = j = n[u]) * (ae = Q - c), y += (J.g = X = n[u + 1]) * ae, _ += (J.b = K = n[u + 2]) * ae, f += (J.a = G = n[u + 3]) * ae, x += j, w += X, z += K, L += G, J = J.next;
      }

      for (ge = me, Le = ce, a = 0; a < i; a++) {
        n[h + 3] = G = f * Jt >> ei, G !== 0 ? (G = 255 / G, n[h] = (g * Jt >> ei) * G, n[h + 1] = (y * Jt >> ei) * G, n[h + 2] = (_ * Jt >> ei) * G) : n[h] = n[h + 1] = n[h + 2] = 0, g -= v, y -= b, _ -= D, f -= O, v -= ge.r, b -= ge.g, D -= ge.b, O -= ge.a, u = d + ((u = a + o + 1) < Oe ? u : Oe) << 2, x += ge.r = n[u], w += ge.g = n[u + 1], z += ge.b = n[u + 2], L += ge.a = n[u + 3], g += x, y += w, _ += z, f += L, ge = ge.next, v += j = Le.r, b += X = Le.g, D += K = Le.b, O += G = Le.a, x -= j, w -= X, z -= K, L -= G, Le = Le.next, h += 4;
      }

      d += i;
    }

    for (a = 0; a < i; a++) {
      for (w = z = L = x = y = _ = f = g = 0, h = a << 2, v = Q * (j = n[h]), b = Q * (X = n[h + 1]), D = Q * (K = n[h + 2]), O = Q * (G = n[h + 3]), g += be * j, y += be * X, _ += be * K, f += be * G, J = me, c = 0; c < Q; c++) {
        J.r = j, J.g = X, J.b = K, J.a = G, J = J.next;
      }

      for (p = i, c = 1; c <= o; c++) {
        h = p + a << 2, g += (J.r = j = n[h]) * (ae = Q - c), y += (J.g = X = n[h + 1]) * ae, _ += (J.b = K = n[h + 2]) * ae, f += (J.a = G = n[h + 3]) * ae, x += j, w += X, z += K, L += G, J = J.next, c < kt && (p += i);
      }

      for (h = a, ge = me, Le = ce, l = 0; l < r; l++) {
        u = h << 2, n[u + 3] = G = f * Jt >> ei, G > 0 ? (G = 255 / G, n[u] = g * Jt >> ei, n[u + 1] = y * Jt >> ei, n[u + 2] = _ * Jt >> ei) : n[u] = n[u + 1] = n[u + 2] = 0, g -= v, y -= b, _ -= D, f -= O, v -= ge.r, b -= ge.g, D -= ge.b, O -= ge.a, u = a + ((u = l + Q) < kt ? u : kt) * i << 2, g += x += ge.r = n[u], y += w += ge.g = n[u + 1], _ += z += ge.b = n[u + 2], f += L += ge.a = n[u + 3], ge = ge.next, v += j = Le.r, b += X = Le.g, D += K = Le.b, O += G = Le.a, x -= j, w -= X, z -= K, L -= G, Le = Le.next, h += i;
      }
    }
  }
}

function Du() {
  this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
}

var Et =
/*#__PURE__*/
function () {
  function Et() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
    var l = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var c = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    var u = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
    var p = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 0;
    var h = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 0;
    var d = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : 1;
    var g = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : 0;
    var y = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : 0;

    var _ = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : 0;

    var f = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : 0;
    var v = arguments.length > 17 && arguments[17] !== undefined ? arguments[17] : 0;
    var b = arguments.length > 18 && arguments[18] !== undefined ? arguments[18] : 1;
    var D = arguments.length > 19 && arguments[19] !== undefined ? arguments[19] : 0;

    _classCallCheck(this, Et);

    this.set(e, t, i, r, o, n, a, l, c, u, p, h, d, g, y, _, f, v, b, D);
  }

  _createClass(Et, [{
    key: "set",
    value: function set(e, t, i, r, o, n, a, l, c, u, p, h, d, g, y, _, f, v, b, D) {
      this.a = e, this.b = t, this.c = i, this.d = r, this.e = o, this.f = n, this.g = a, this.h = l, this.i = c, this.j = u, this.k = p, this.l = h, this.m = d, this.n = g, this.o = y, this.p = _, this.q = f, this.r = v, this.s = b, this.t = D;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.a = 1, this.b = 0, this.c = 0, this.d = 0, this.e = 0, this.f = 0, this.g = 1, this.h = 0, this.i = 0, this.j = 0, this.k = 0, this.l = 0, this.m = 1, this.n = 0, this.o = 0, this.p = 0, this.q = 0, this.r = 0, this.s = 1, this.t = 0;
    }
  }, {
    key: "apply",
    value: function apply(e) {
      var t = this.a * e.r + this.b * e.g + this.c * e.b + this.d * e.a + this.e,
          i = this.f * e.r + this.g * e.g + this.h * e.b + this.i * e.a + this.j,
          r = this.k * e.r + this.l * e.g + this.m * e.b + this.n * e.a + this.o,
          o = this.p * e.r + this.q * e.g + this.r * e.b + this.s * e.a + this.t;
      return new R(t, i, r, o);
    }
  }, {
    key: "multiply",
    value: function multiply(e) {
      var t,
          i,
          r,
          o,
          n,
          a,
          l,
          c,
          u,
          p,
          h,
          d,
          g,
          y,
          _,
          f,
          v,
          b,
          D,
          O,
          x = e,
          w = this;

      return t = x.a * w.a + x.b * w.f + x.c * w.k + x.d * w.p, i = x.a * w.b + x.b * w.g + x.c * w.l + x.d * w.q, r = x.a * w.c + x.b * w.h + x.c * w.m + x.d * w.r, o = x.a * w.d + x.b * w.i + x.c * w.n + x.d * w.s, a = x.f * w.a + x.g * w.f + x.h * w.k + x.i * w.p, l = x.f * w.b + x.g * w.g + x.h * w.l + x.i * w.q, c = x.f * w.c + x.g * w.h + x.h * w.m + x.i * w.r, u = x.f * w.d + x.g * w.i + x.h * w.n + x.i * w.s, h = x.k * w.a + x.l * w.f + x.m * w.k + x.n * w.p, d = x.k * w.b + x.l * w.g + x.m * w.l + x.n * w.q, g = x.k * w.c + x.l * w.h + x.m * w.m + x.n * w.r, y = x.k * w.d + x.l * w.i + x.m * w.n + x.n * w.s, f = x.p * w.a + x.q * w.f + x.r * w.k + x.s * w.p, v = x.p * w.b + x.q * w.g + x.r * w.l + x.s * w.q, b = x.p * w.c + x.q * w.h + x.r * w.m + x.s * w.r, D = x.p * w.d + x.q * w.i + x.r * w.n + x.s * w.s, n = x.a * w.e + x.b * w.j + x.c * w.o + x.d * w.t + x.e, p = x.f * w.e + x.g * w.j + x.h * w.o + x.i * w.t + x.j, _ = x.k * w.e + x.l * w.j + x.m * w.o + x.n * w.t + x.o, O = x.p * w.e + x.q * w.j + x.r * w.o + x.s * w.t + x.t, this.a = t, this.b = i, this.c = r, this.d = o, this.e = n, this.f = a, this.g = l, this.h = c, this.i = u, this.j = p, this.k = h, this.l = d, this.m = g, this.n = y, this.o = _, this.p = f, this.q = v, this.r = b, this.s = D, this.t = O, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = new Et();
      return e.set(this.a, this.b, this.c, this.d, this.e, this.f, this.g, this.h, this.i, this.j, this.k, this.l, this.m, this.n, this.o, this.p, this.q, this.r, this.s, this.t), e;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return this.a === e.a && this.b === e.b && this.c === e.c && this.d === e.d && this.e === e.e && this.f === e.f && this.g === e.g && this.h === e.h && this.i === e.i && this.j === e.j && this.k === e.k && this.l === e.l && this.m === e.m && this.n === e.n && this.o === e.o && this.p === e.p && this.q === e.q && this.r === e.r && this.s === e.s && this.t === e.t;
    }
  }, {
    key: "getOffsets",
    value: function getOffsets() {
      return [this.e, this.j, this.o, this.t];
    }
  }, {
    key: "toString",
    value: function toString() {
      return "ColorMatrix( ".concat(this.a, ", ").concat(this.b, ", ").concat(this.c, ", ").concat(this.d, ", ").concat(this.e, ",\n      ").concat(this.f, ", ").concat(this.g, ", ").concat(this.h, ", ").concat(this.i, ", ").concat(this.j, ",\n      ").concat(this.k, ", ").concat(this.l, ", ").concat(this.m, ", ").concat(this.n, ", ").concat(this.o, ",\n      ").concat(this.p, ", ").concat(this.q, ", ").concat(this.r, ", ").concat(this.s, ", ").concat(this.t, " )");
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var _this10 = this;

      return "abcdefghijklmnopqrst".split("").map(function (e) {
        return _this10[e];
      });
    }
  }], [{
    key: "createBrightnessMatrix",
    value: function createBrightnessMatrix(e) {
      var t = new Et();
      return t.e = e, t.j = e, t.o = e, t;
    }
  }, {
    key: "createContrastMatrix",
    value: function createContrastMatrix(e) {
      var t = new Et(),
          i = (1 - e) / 2;
      return t.a = t.g = t.m = e, t.e = t.j = t.o = i, t;
    }
  }, {
    key: "createSaturationMatrix",
    value: function createSaturationMatrix() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = new Et(),
          i = 1 - e,
          r = .213 * i,
          o = .715 * i,
          n = .072 * i;
      return t.a = r + e, t.b = o, t.c = n, t.f = r, t.g = o + e, t.h = n, t.k = r, t.l = o, t.m = n + e, t;
    }
  }, {
    key: "createExposureMatrix",
    value: function createExposureMatrix() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = Math.pow(2, e);
      return new Et(t, 0, 0, 0, 0, 0, t, 0, 0, 0, 0, 0, t, 0, 0, 0, 0, 0, 1, 0);
    }
  }, {
    key: "createLinearMatrix",
    value: function createLinearMatrix() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var i = new Et();
      return i.a = i.g = i.m = e, i.e = i.j = i.o = t, i;
    }
  }, {
    key: "IDENTITY",
    get: function get() {
      return new Et();
    }
  }]);

  return Et;
}(),
    ls = Et;

var sr =
/*#__PURE__*/
function (_We) {
  _inherits(sr, _We);

  function sr() {
    var _this11;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, sr);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(sr).call(this));
    _this11.availableOptions = C(C({}, Object.getPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this11))).availableOptions), t), _this11._onConfigurableUpdate = _this11._onConfigurableUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this11))), _this11._initOptions(e);
    return _this11;
  }

  _createClass(sr, [{
    key: "_buildConfigError",
    value: function _buildConfigError(e) {
      var t = "";
      return this.constructor.name && (t = "".concat(this.constructor.name, ": ")), t += e, new Error(t);
    }
  }, {
    key: "_onOptionsChange",
    value: function _onOptionsChange() {}
  }, {
    key: "validateSettings",
    value: function validateSettings() {
      var _this12 = this;

      return new Promise(function (e, t) {
        for (var i in _this12.availableOptions) {
          if (_this12.availableOptions[i].required && typeof _this12._options[i] == "undefined") return t(_this12._buildConfigError("Option `".concat(i, "` is required.")));
        }

        e();
      });
    }
  }, {
    key: "_initOptions",
    value: function _initOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._options = {};
      var t,
          i,
          r,
          o = this;

      for (t in this.availableOptions) {
        if (r = t.charAt(0).toUpperCase() + t.slice(1), i = this.availableOptions[t], [m.STRING, m.NUMBER, m.BOOLEAN, m.OBJECT, m.VECTOR2, m.COLOR, m.CONFIGURABLE, m.COLOR_MATRIX, m.ARRAY, m.IMAGE, m.FUNCTION, m.ALL].indexOf(i.type) === -1) throw this._buildConfigError("Unknown option type: `".concat(i.type, "`"));
        if (function (l) {
          o["set".concat(r)] = function (c, u, p) {
            o.setOption(l, c, u, p);
          }, o["get".concat(r)] = function () {
            return o.getOption(l);
          };
        }(t), i.type === m.CONFIGURABLE && (this._options[t] = new sr(void 0, i.structure || {}), this._options[t].on("update", this._onConfigurableUpdate)), !(t in e) || typeof e[t] == "undefined") if (typeof i.default != "undefined") {
          var a = i.default;
          typeof i.default == "function" && (a = i.default()), this["set".concat(r)](a, !1, !0);
        } else i.type !== m.CONFIGURABLE && (this._options[t] = void 0);
      }

      for (t in e) {
        if (typeof this.availableOptions[t] == "undefined") throw new Error("Invalid option: ".concat(t));
        typeof e[t] != "undefined" && (r = t.charAt(0).toUpperCase() + t.slice(1), this["set".concat(r)](e[t], !1, !0));
      }
    }
  }, {
    key: "set",
    value: function set(e) {
      var _this13 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      Object.keys(e).forEach(function (i) {
        _this13.setOption(i, e[i], !1);
      }), this._onOptionsChange(), t && this.emit("update", this, e);
    }
  }, {
    key: "getOption",
    value: function getOption(e) {
      return this._options[e];
    }
  }, {
    key: "hasOption",
    value: function hasOption(e) {
      return !!this.availableOptions[e];
    }
  }, {
    key: "getOptionDefault",
    value: function getOptionDefault(e) {
      var t = this.availableOptions[e];
      if (!t) throw new Error("Invalid option: ".concat(e));
      return t.default;
    }
  }, {
    key: "resetOptions",
    value: function resetOptions() {
      this.set(this.getDefaultOptions());
    }
  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      var e = {};

      for (var t in this.availableOptions) {
        var i = this.availableOptions[t].default;
        typeof i != "undefined" && (e[t] = i);
      }

      return e;
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return C({}, this._options);
    }
  }, {
    key: "equals",
    value: function equals(e) {
      var t = e.getOptions();
      return this.optionsEqual(t);
    }
  }, {
    key: "optionsEqual",
    value: function optionsEqual(e) {
      for (var t in e) {
        var i = e[t];
        if (!this._optionEquals(t, i)) return !1;
      }

      return !0;
    }
  }, {
    key: "_optionEquals",
    value: function _optionEquals(e, t) {
      if (typeof this.availableOptions[e] == "undefined") throw new Error("Invalid option: ".concat(e));
      var r = this.availableOptions[e].type,
          o = this._options[e];
      if (o === t) return !0;
      if (typeof t == "undefined" || typeof o == "undefined") return !1;

      switch (r) {
        case m.OBJECT:
          return typeof o.optionsEqual == "function" ? o.optionsEqual(t._options) : o === t;

        case m.STRING:
        case m.NUMBER:
        case m.BOOLEAN:
        case m.FUNCTION:
        case "*":
          return o === t;

        case m.VECTOR2:
          return o.equals(t);

        case m.COLOR:
        case m.COLOR_MATRIX:
          return t.equals(o);

        case m.CONFIGURABLE:
          return o.optionsEqual(t);

        case m.ARRAY:
          return this._arrayOptionEquals(e, t);

        case m.IMAGE:
          return o.src === t.src;
      }
    }
  }, {
    key: "_arrayOptionEquals",
    value: function _arrayOptionEquals(e, t) {
      var i = this._options[e];
      if (t.length !== i.length) return !1;
      var r = !0;

      for (var o = 0; o < i.length; o++) {
        var n = i[o],
            a = t[o];

        if (n instanceof sr) {
          if (typeof a == "undefined" || !n.optionsEqual(a)) {
            r = !1;
            break;
          }
        } else if (a !== n) {
          r = !1;
          break;
        }
      }

      return r;
    }
  }, {
    key: "serializeOptions",
    value: function serializeOptions() {
      var _this14 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.keys(this._options);
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = {};
      return e.forEach(function (r) {
        if (typeof _this14.availableOptions[r] == "undefined") return Log.warn("Trying to serialize a key that does not exist: ".concat(r));
        _this14.availableOptions[r].serializable !== !1 && (i[r] = _this14.serializeOption(r, t));
      }), i;
    }
  }, {
    key: "serializeOption",
    value: function serializeOption(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = this.availableOptions[e],
          r = i.type,
          o = this._options[e];
      if (!o) return o;
      if (i.serializable === !1) throw new Error("Option `".concat(e, "` is not serializable."));

      switch (r) {
        case m.STRING:
        case m.NUMBER:
        case m.BOOLEAN:
        case m.OBJECT:
        case m.FUNCTION:
        case m.ALL:
          return o;

        case m.VECTOR2:
          return t ? o.toObject() : o.clone();

        case m.COLOR:
        case m.COLOR_MATRIX:
          return t ? o.toArray() : o.clone();

        case m.CONFIGURABLE:
          return o.serializeOptions(void 0, t);

        case m.ARRAY:
          return o.slice(0);

        case m.IMAGE:
          return t ? o.src : o;
      }
    }
  }, {
    key: "setOption",
    value: function setOption(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = this.availableOptions[e];
      if (!o) throw new Error("Invalid option: ".concat(e));

      if (typeof o.setter != "undefined" && (t = o.setter.call(this, t, r)), typeof o.validation != "undefined" && o.validation(t), t === null || typeof t == "undefined") {
        if (o.required) throw this._buildConfigError("Option `".concat(e, "` is required."));
        this._options[e] = t;
      } else switch (o.type) {
        case m.STRING:
          {
            if (typeof t !== m.STRING) throw this._buildConfigError("Option `".concat(e, "` has to be a string."));
            var n = o.available;
            if (typeof n != "undefined" && n.indexOf(t) === -1) throw this._buildConfigError("Invalid value for `".concat(e, "` (valid values are: ").concat(o.available.join(", "), ")"));
            this._options[e] = t;
            break;
          }

        case m.NUMBER:
          if (typeof t !== m.NUMBER) throw this._buildConfigError("Option `".concat(e, "` has to be a number."));
          this._options[e] = t;
          break;

        case m.BOOLEAN:
          if (typeof t !== m.BOOLEAN) throw this._buildConfigError("Option `".concat(e, "` has to be a boolean."));
          this._options[e] = t;
          break;

        case m.VECTOR2:
          if (!(t instanceof B) && !(typeof t == "object" && "x" in t && "y" in t)) throw this._buildConfigError("Option `".concat(e, "` has to be an instance of Vector2 or an Object holding x and y values."));
          t instanceof B ? this._options[e] = t.clone() : this._options[e] = B.fromObject(t);
          break;

        case m.COLOR:
          if (!(t instanceof R)) throw this._buildConfigError("Option `".concat(e, "` has to be an instance of Color."));
          this._options[e] = t;
          break;

        case m.COLOR_MATRIX:
          if (!(t instanceof ls)) throw this._buildConfigError("Option `".concat(e, "` has to be an instance of ColorMatrix."));
          this._options[e] = t.clone();
          break;

        case m.FUNCTION:
          if (typeof t != "function") throw this._buildConfigError("Option `".concat(e, "` has to be a function."));
          this._options[e] = t;
          break;

        case m.OBJECT:
        case "*":
          this._options[e] = t;
          break;

        case m.IMAGE:
          {
            var _n2 = Ae.Image;

            if (typeof t == "string") {
              var a = new _n2();
              fu(a) && (a.crossOrigin = T.getCrossOriginValue(o.crossOrigin)), a.src = t, this._options[e] = a;
            } else if (t instanceof _n2 || typeof HTMLCanvasElement != "undefined" && t instanceof HTMLCanvasElement || typeof HTMLImageElement != "undefined" && t instanceof HTMLImageElement) this._options[e] = t;else throw this._buildConfigError("Option `".concat(e, "` has to be an Image, Canvas or String."));

            break;
          }

        case m.CONFIGURABLE:
          t instanceof sr ? this._options[e] = t : this._options[e].set(t);
          break;

        case m.ARRAY:
          if (!(t instanceof Array)) throw this._buildConfigError("Option `".concat(e, "` has to be an Array."));
          this._options[e] = t.slice(0);
          break;

        default:
          throw this._buildConfigError("Unknown option type: `".concat(o.type, "`"));
      }

      i && (this._onOptionsChange(), this.emit("update", this, _defineProperty({}, e, t)));
    }
  }, {
    key: "_onConfigurableUpdate",
    value: function _onConfigurableUpdate() {
      for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        e[_key7] = arguments[_key7];
      }

      this.emit.apply(this, ["update"].concat(e));
    }
  }, {
    key: "hasChanges",
    value: function hasChanges() {
      var e = this.getDefaultOptions();
      return !this.optionsEqual(e);
    }
  }]);

  return sr;
}(We),
    V = sr;

var cs =
/*#__PURE__*/
function () {
  function cs(e, t, i) {
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

    _classCallCheck(this, cs);

    this._program = null;
    this._renderer = e, this._vertexSource = t, this._fragmentSource = i, this._uniforms = r, this._uniformLocations = {}, this._attributes = o, this._attributeLocations = {}, this._onContextChange = this._onContextChange.bind(this), this._renderer.on("context", this._onContextChange), this._init();
  }

  _createClass(cs, [{
    key: "_init",
    value: function _init() {
      this._compile(), this._renderer.getContext().useProgram(this._program), this._cacheUniformLocations(), this._cacheAttributeLocations();
    }
  }, {
    key: "_onContextChange",
    value: function _onContextChange() {
      this._init();
    }
  }, {
    key: "setupBuffers",
    value: function setupBuffers(e, t) {
      var i = this._renderer.getContext();

      i.bindBuffer(i.ARRAY_BUFFER, e), i.bindBuffer(i.ELEMENT_ARRAY_BUFFER, t), i.vertexAttribPointer(this._attributeLocations.a_position, 2, i.FLOAT, !1, ii, 0), i.vertexAttribPointer(this._attributeLocations.a_texCoord, 2, i.FLOAT, !1, ii, 2 * 4), i.vertexAttribPointer(this._attributeLocations.a_color, 4, i.UNSIGNED_BYTE, !0, ii, 4 * 4);
    }
  }, {
    key: "syncUniforms",
    value: function syncUniforms() {
      var _this15 = this;

      Object.keys(this._uniforms).forEach(function (e) {
        _this15.syncUniform(e);
      });
    }
  }, {
    key: "syncUniform",
    value: function syncUniform(e) {
      var t = this._renderer.getContext(),
          i = this._uniforms[e],
          r = this._uniformLocations[e];

      switch (i.type) {
        case F.SAMPLER2D:
          t.uniform1i(r, i.value);
          break;

        case F.INT:
        case F.INT1:
          t.uniform1i(r, i.value);
          break;

        case F.INT2:
          t.uniform2i(r, i.value[0], i.value[1]);
          break;

        case F.INT3:
          t.uniform3i(r, i.value[0], i.value[1], i.value[2]);
          break;

        case F.INT4:
          t.uniform4i(r, i.value[0], i.value[1], i.value[2], i.value[3]);
          break;

        case F.FLOAT:
        case F.FLOAT1:
          t.uniform1f(r, i.value);
          break;

        case F.FLOAT2:
          t.uniform2f(r, i.value[0], i.value[1]);
          break;

        case F.FLOAT3:
          t.uniform3f(r, i.value[0], i.value[1], i.value[2]);
          break;

        case F.FLOAT4:
          t.uniform4f(r, i.value[0], i.value[1], i.value[2], i.value[3]);
          break;

        case F.FLOAT_VECTOR2:
          t.uniform2fv(r, i.value);
          break;

        case F.MAT3:
        case F.MAT3FV:
          t.uniformMatrix3fv(r, !1, i.value);
          break;

        case F.MAT4:
          t.uniformMatrix4fv(r, !1, i.value);
          break;

        default:
          A.warn(this.constructor.name, "Unknown uniform type: ".concat(i.type));
      }
    }
  }, {
    key: "_cacheAttributeLocations",
    value: function _cacheAttributeLocations() {
      var _this16 = this;

      var e = this._renderer.getContext();

      this._attributes.forEach(function (t) {
        _this16._program && (_this16._attributeLocations[t] = e.getAttribLocation(_this16._program, t));
      });
    }
  }, {
    key: "_cacheUniformLocations",
    value: function _cacheUniformLocations() {
      var _this17 = this;

      var e = this._renderer.getContext();

      Object.keys(this._uniforms).forEach(function (i) {
        if (_this17._program) {
          var r = e.getUniformLocation(_this17._program, i);
          r && (_this17._uniformLocations[i] = r);
        }
      });
    }
  }, {
    key: "_addPrecisionToSource",
    value: function _addPrecisionToSource(e) {
      var t = this._renderer.getMaxFloatPrecision(),
          i = dt.Medium;

      return T.isMobile() && t === dt.High && (i = dt.High), "precision ".concat(i, " float;\n").concat(e);
    }
  }, {
    key: "_compile",
    value: function _compile() {
      var e = this._renderer.getContext(),
          t = this._compileShader(e.VERTEX_SHADER, this._vertexSource);

      this._vertexShader = t;

      var i = this._addPrecisionToSource(this._fragmentSource),
          r = this._compileShader(e.FRAGMENT_SHADER, i);

      this._fragmentShader = r;
      var o = e.createProgram();
      if (!o) return;
      if (e.attachShader(o, t), e.attachShader(o, r), e.linkProgram(o), e.getProgramParameter(o, e.LINK_STATUS)) this._program = o;else {
        var a = e.getProgramInfoLog(o);
        e.isContextLost() && (a = "WebGL context lost"), e.deleteProgram(o), A.error(this.constructor.name, "WebGL program linking error: ".concat(a));
      }
    }
  }, {
    key: "_compileShader",
    value: function _compileShader(e, t) {
      var i = this._renderer.getContext(),
          r = i.createShader(e);

      if (!r) throw new Error("Cannot create shared: ".concat(JSON.stringify(e)));

      if (i.shaderSource(r, t), i.compileShader(r), !i.getShaderParameter(r, i.COMPILE_STATUS)) {
        var n = i.getShaderInfoLog(r);
        i.isContextLost() && (n = "WebGL context lost"), i.deleteShader(r), A.error(this.constructor.name, "WebGL shader compilation error: ".concat(n));
      }

      return r;
    }
  }, {
    key: "setUniform",
    value: function setUniform(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      this._uniforms[e].value = t, i && this.syncUniform(e);
    }
  }, {
    key: "setUniforms",
    value: function setUniforms(e) {
      var _this18 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      Object.keys(e).forEach(function (i) {
        _this18._uniforms[i].value = e[i], t && _this18.syncUniform(i);
      });
    }
  }, {
    key: "getUniforms",
    value: function getUniforms() {
      return this._uniforms;
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this._attributes;
    }
  }, {
    key: "getAttributeLocations",
    value: function getAttributeLocations() {
      return this._attributeLocations;
    }
  }, {
    key: "getProgram",
    value: function getProgram() {
      return this._program;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var e = this._renderer.getContext();

      e.deleteProgram(this._program), e.deleteShader(this._vertexShader), e.deleteShader(this._fragmentShader), this._renderer.off("context", this._onContextChange);
    }
  }]);

  return cs;
}();

var Tu = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvarying vec4 v_color;\n\nvoid main() {\n  gl_FragColor = texture2D(u_image, v_texCoord) * v_color;\n}\n";
var Ru = "attribute vec2 a_position;\nattribute vec2 a_texCoord;\nattribute vec4 a_color;\nvarying vec2 v_texCoord;\nvarying vec4 v_color;\nuniform mat3 u_projMatrix;\n\nvoid main() {\n  gl_Position = vec4((u_projMatrix * vec3(a_position, 1)).xy, 0, 1);\n  v_texCoord = a_texCoord;\n  v_color = vec4(a_color.rgb * a_color.a, a_color.a);\n}\n";

var Yp = new Ze(),
    Nt = {
  vertexSource: Ru,
  fragmentSource: Tu,
  uniforms: {
    u_image: {
      type: F.SAMPLER2D,
      value: 0
    },
    u_projMatrix: {
      type: F.MAT3,
      value: Yp.toArray()
    }
  },
  attributes: ["a_position", "a_texCoord", "a_color"]
},
    Ga =
/*#__PURE__*/
function (_cs) {
  _inherits(Ga, _cs);

  function Ga(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Nt.vertexSource;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Nt.fragmentSource;

    _classCallCheck(this, Ga);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ga).call(this, e, t, i, Nt.uniforms, Nt.attributes));
  }

  return Ga;
}(cs);

var xt =
/*#__PURE__*/
function (_V) {
  _inherits(xt, _V);

  function xt() {
    var _this19;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, xt);

    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(xt).call(this, e, t));

    _this19._initOptions(e);

    return _this19;
  }

  _createClass(xt, [{
    key: "_initOptions",
    value: function _initOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._shaders = [], this._availableUniforms = Nt.uniforms, this._attributes = Nt.attributes, this._vertexSource = Nt.vertexSource, this._fragmentSource = Nt.fragmentSource, this._initUniforms(), _get(_getPrototypeOf(xt.prototype), "_initOptions", this).call(this, e);
    }
  }, {
    key: "_initUniforms",
    value: function _initUniforms() {
      this._uniforms = {};

      for (var _e4 in this._availableUniforms) {
        var t = this._availableUniforms[_e4];
        this._uniforms[_e4] = {
          type: t.type,
          value: t.default || null
        };
      }

      for (var _e5 in this.availableOptions) {
        var _t2 = this.availableOptions[_e5];
        _t2.uniformType ? this._uniforms["u_".concat(_e5)] = {
          type: _t2.uniformType,
          value: _t2.default || null
        } : A.trace(this.constructor.name, "Option `".concat(_e5, "` is missing a `uniformType`!"));
      }
    }
  }, {
    key: "setOption",
    value: function setOption(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;

      _get(_getPrototypeOf(xt.prototype), "setOption", this).call(this, e, t, i);

      var r = t,
          o = this.availableOptions[e];
      if (!o.uniformType) return;
      var n = "u_".concat(e);

      switch (o.type) {
        case m.COLOR:
          o.uniformType === F.FLOAT4 ? r = t.toGLColor() : o.uniformType === F.FLOAT3 && (r = t.toRGBGLColor());
          break;

        case m.VECTOR2:
          r = [t.x, t.y];
          break;

        case m.COLOR_MATRIX:
          {
            r = [t.a, t.b, t.c, t.d, t.f, t.g, t.h, t.i, t.k, t.l, t.m, t.n, t.p, t.q, t.r, t.s];
            var a = [t.e, t.j, t.o, t.t];
            this._uniforms["".concat(n, "_vec")] = {
              value: a,
              type: F.FLOAT4
            };
          }
      }

      this.setUniform(n, r);
    }
  }, {
    key: "setUniform",
    value: function setUniform(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      this._uniforms[e].value = t;
    }
  }, {
    key: "setUniforms",
    value: function setUniforms(e) {
      var _this20 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      Object.entries(e).forEach(function (_ref18) {
        var _ref19 = _slicedToArray(_ref18, 2),
            i = _ref19[0],
            r = _ref19[1];

        _this20._uniforms[i].value = r, t && _this20.syncUniform(i);
      });
    }
  }, {
    key: "syncUniform",
    value: function syncUniform(e) {
      this._shaders.forEach(function (t) {
        t.syncUniform(e);
      });
    }
  }, {
    key: "syncUniforms",
    value: function syncUniforms() {
      this._shaders.forEach(function (e) {
        e.syncUniforms();
      });
    }
  }, {
    key: "getShaderForRenderer",
    value: function getShaderForRenderer(e) {
      var t = e.id;
      this._shaders || (this._shaders = []);
      var i = this._shaders[t];
      return i || (i = new cs(e, this._vertexSource, this._fragmentSource, this._uniforms, this._attributes), this._shaders[t] = i), i;
    }
  }, {
    key: "apply",
    value: function apply(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      Zi(e) ? this._applyWebGL(e, t, i, r) : this._applyCanvas(e, t, i, r);
    }
  }, {
    key: "_applyWebGL",
    value: function _applyWebGL(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = e.getContext(),
          n = this.getShaderForRenderer(e);
      e.setRenderTarget(i), r && i.clear(), e.setShader(n);
      var a = e.getCurrentRenderTarget().getProjectionMatrix().toArray();
      n.setUniform("u_projMatrix", a), n.syncUniforms(), o.activeTexture(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, t.getTexture()), o.drawElements(o.TRIANGLES, 6, o.UNSIGNED_SHORT, 0);
    }
  }, {
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = i.getContext();
      A.warn(this.constructor.name, "`_applyCanvas` is not implemented. Just copying image data from `inputTarget` to `outputTarget`."), n.clearRect(0, 0, o.width, o.height), n.drawImage(o, 0, 0);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._shaders.forEach(function (e) {
        return e.dispose();
      }), this._shaders = [];
    }
  }, {
    key: "_blurImage",
    value: function _blurImage(e, t, i) {
      var r = 10,
          o = e.getCanvas(),
          n = Math.min(1, r / (i * Math.min(o.width, o.height))),
          a = T.createCanvas();
      a.width = Math.round(o.width * n), a.height = Math.round(o.height * n);
      var l = a.getContext("2d");
      l.drawImage(o, 0, 0, o.width, o.height, 0, 0, a.width, a.height);
      var c = i * Math.min(a.width, a.height),
          u = l.getImageData(0, 0, a.width, a.height);
      ku(u, 0, 0, a.width, a.height, c), l.putImageData(u, 0, 0), t.getContext().drawImage(a, 0, 0, a.width, a.height, 0, 0, o.width, o.height);
    }
  }]);

  return xt;
}(V);

var Fu = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvarying vec4 v_color;\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4(color.a > 0. ? color.rgb / color.a : vec3(0), color.a);\n}\n";

var Wa =
/*#__PURE__*/
function (_xt) {
  _inherits(Wa, _xt);

  function Wa() {
    var _this21;

    _classCallCheck(this, Wa);

    _this21 = _possibleConstructorReturn(this, _getPrototypeOf(Wa).call(this));
    _this21._fragmentSource = Fu;
    return _this21;
  }

  return Wa;
}(xt),
    Eu = Wa;

var Su = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nuniform vec4 u_color;\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4(mix(color.rgb, u_color.rgb, u_color.a), color.a) * color.a;\n}\n";

var qp = Xe.OptionType,
    Kp = Xe.UniformType,
    Va =
/*#__PURE__*/
function (_xt2) {
  _inherits(Va, _xt2);

  function Va() {
    var _getPrototypeOf2;

    var _this22;

    _classCallCheck(this, Va);

    for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      e[_key8] = arguments[_key8];
    }

    _this22 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Va)).call.apply(_getPrototypeOf2, [this].concat(e)));
    _this22._fragmentSource = Su;
    return _this22;
  }

  _createClass(Va, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = this._options.color,
          c = n.getImageData(0, 0, o.width, o.height),
          u = a.getImageData(0, 0, o.width, o.height),
          p = o.width * o.height,
          h = new R(),
          d = new R();

      for (var g = 0; g < p * 4; g += 4) {
        h.set(c.data[g] / 255, c.data[g + 1] / 255, c.data[g + 2] / 255, c.data[g + 3] / 255), d.set(u.data[g] / 255, u.data[g + 1] / 255, u.data[g + 2] / 255, u.data[g + 3] / 255);
        var y = d.r + h.a * (h.r - d.r);
        u.data[g] = (y + h.a * (l.r - y)) * 255;

        var _3 = d.g + h.a * (h.g - d.g);

        u.data[g + 1] = (_3 + h.a * (l.g - _3)) * 255;
        var f = d.b + h.a * (h.b - d.b);
        u.data[g + 2] = (f + h.a * (l.b - f)) * 255;
      }

      a.putImageData(u, 0, 0);
    }
  }]);

  return Va;
}(xt);

Va.prototype.availableOptions = {
  color: {
    type: qp.COLOR,
    default: R.WHITE,
    uniformType: Kp.FLOAT4
  }
};
var Au = Va;
var Iu = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nuniform vec4 u_color;\nuniform int u_mode;\n\nvec3 W = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  if (u_mode == 0) {\n    gl_FragColor = color * color.a;\n  } else if (u_mode == 1) {\n    gl_FragColor = vec4(mix(color.rgb, u_color.rgb, u_color.a), color.a) * color.a;\n  } else if (u_mode == 2) {\n    float luminance = dot(color.rgb, W);\n    vec3 colorized = vec3(luminance) * u_color.rgb;\n    gl_FragColor = vec4(mix(color.rgb, colorized, u_color.a), color.a) * color.a;\n  }\n}\n";

var Ou = Xe.OptionType,
    Pu = Xe.UniformType,
    ri =
/*#__PURE__*/
function (_xt3) {
  _inherits(ri, _xt3);

  function ri() {
    var _getPrototypeOf3;

    var _this23;

    _classCallCheck(this, ri);

    for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      e[_key9] = arguments[_key9];
    }

    _this23 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(ri)).call.apply(_getPrototypeOf3, [this].concat(e)));
    _this23._fragmentSource = Iu;
    return _this23;
  }

  _createClass(ri, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          _this$_options = this._options,
          c = _this$_options.mode,
          u = _this$_options.color,
          p = u.r,
          h = u.g,
          d = u.b,
          g = u.a,
          y = [.2125, .7154, .0721];

      switch (c) {
        case ri.MODES.SOLID:
          for (var _4 = 0; _4 < o.width * o.height; _4++) {
            var f = _4 * 4;
            l.data[f] += (p * 255 - l.data[f]) * g, l.data[f + 1] += (h * 255 - l.data[f + 1]) * g, l.data[f + 2] += (d * 255 - l.data[f + 2]) * g;
          }

          break;

        case ri.MODES.COLORIZED:
          for (var _5 = 0; _5 < o.width * o.height; _5++) {
            var _f2 = _5 * 4,
                v = l.data[_f2] / 255 * y[0] + l.data[_f2 + 1] / 255 * y[1] + l.data[_f2 + 2] / 255 * y[2],
                b = new R(v * p, v * h, v * d);

            l.data[_f2] += (b.r * 255 - l.data[_f2]) * g, l.data[_f2 + 1] += (b.g * 255 - l.data[_f2 + 1]) * g, l.data[_f2 + 2] += (b.b * 255 - l.data[_f2 + 2]) * g;
          }

          break;
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return ri;
}(xt);

ri.MODES = {
  NONE: 0,
  SOLID: 1,
  COLORIZED: 2
};
ri.prototype.availableOptions = {
  color: {
    type: Ou.COLOR,
    default: R.WHITE,
    uniformType: Pu.FLOAT4
  },
  mode: {
    type: Ou.NUMBER,
    default: ri.MODES.NONE,
    uniformType: Pu.INT
  }
};
var Bu = ri;
var Mu = "uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nuniform sampler2D u_overlayImage;\nuniform int u_blendMode;\nuniform float u_alpha;\n\nconst float EPSILON = 0.000001;\n\nvec4 overlay(vec4 a, vec4 b) {\n    vec3 result = mix(\n          1.0 - 2.0 * (1.0 - a.rgb) * (1.0 - b.rgb),\n          2.0 * a.rgb * b.rgb,\n          vec3(a.r < 0.5, a.g < 0.5, a.b < 0.5)\n      );\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 hardLight(vec4 b, vec4 a) {\n    vec3 result = mix(\n          1.0 - 2.0 * (1.0 - a.rgb) * (1.0 - b.rgb),\n          2.0 * a.rgb * b.rgb,\n          vec3(a.r < 0.5, a.g < 0.5, a.b < 0.5)\n      );\n    return mix(b, vec4(result, b.a), u_alpha * a.a);\n}\n\nvec4 softLight(vec4 a, vec4 b) {\n    vec3 result = mix(\n          2.0 * a.rgb * (1.0 - b.rgb) + (2.0 * b.rgb - 1.0) * sqrt(a.rgb),\n          2.0 * a.rgb * b.rgb + a.rgb * a.rgb * (1.0 - 2.0 * b.rgb),\n          vec3(b.r < 0.5, b.g < 0.5, b.b < 0.5)\n      );\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 multiply(vec4 a, vec4 b) {\n    vec3 result = a.rgb * b.rgb;\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 darken(vec4 a, vec4 b) {\n    vec3 result = min(a.rgb, b.rgb);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 lighten(vec4 a, vec4 b) {\n    vec3 result = max(a.rgb, b.rgb);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 screen(vec4 a, vec4 b) {\n    vec3 result = 1.0 - (1.0 - a.rgb) * (1.0 - b.rgb);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 colorBurn(vec4 a, vec4 b) {\n    vec3 result = clamp(1.0 - (1.0 - a.rgb) / max(b.rgb, EPSILON), 0.0, 1.0);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 normal(vec4 a, vec4 b) {\n    return mix(a, vec4(b.rgb, a.a), u_alpha * b.a);\n}\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  vec4 overlayColor = texture2D(u_overlayImage, v_texCoord);\n\n  vec4 resultColor;\n  if (u_blendMode == 0) {\n    resultColor = normal(color, overlayColor);\n  } else if (u_blendMode == 1) {\n    resultColor = overlay(color, overlayColor);\n  } else if (u_blendMode == 2) {\n    resultColor = hardLight(color, overlayColor);\n  } else if (u_blendMode == 3) {\n    resultColor = softLight(color, overlayColor);\n  } else if (u_blendMode == 4) {\n    resultColor = multiply(color, overlayColor);\n  } else if (u_blendMode == 5) {\n    resultColor = darken(color, overlayColor);\n  } else if (u_blendMode == 6) {\n    resultColor = lighten(color, overlayColor);\n  } else if (u_blendMode == 7) {\n    resultColor = screen(color, overlayColor);\n  } else if (u_blendMode == 8) {\n    resultColor = colorBurn(color, overlayColor);\n  }\n  gl_FragColor = vec4(resultColor.rgb * resultColor.a, resultColor.a);\n}\n";

var Js = Xe.OptionType,
    Ha = Xe.UniformType,
    ja = 1e-6,
    Ve =
/*#__PURE__*/
function (_xt4) {
  _inherits(Ve, _xt4);

  function Ve() {
    var _getPrototypeOf4;

    var _this24;

    _classCallCheck(this, Ve);

    for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      e[_key10] = arguments[_key10];
    }

    _this24 = _possibleConstructorReturn(this, (_getPrototypeOf4 = _getPrototypeOf(Ve)).call.apply(_getPrototypeOf4, [this].concat(e)));
    _this24._fragmentSource = Mu, _this24._lastImage = null;
    return _this24;
  }

  _createClass(Ve, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      var o = this._options.overlayTexture.getRenderTarget().getContext(),
          n = t.getCanvas(),
          a = t.getContext(),
          l = i.getContext(),
          c = a.getImageData(0, 0, n.width, n.height),
          u = o.getImageData(0, 0, n.width, n.height),
          _this$_options2 = this._options,
          p = _this$_options2.blendMode,
          h = _this$_options2.alpha,
          d = new R(),
          g = new R(),
          y = new R();

      for (var _6 = 0; _6 < n.width * n.height * 4; _6 += 4) {
        d.set(c.data[_6] / 255, c.data[_6 + 1] / 255, c.data[_6 + 2] / 255, c.data[_6 + 3] / 255), g.set(u.data[_6] / 255, u.data[_6 + 1] / 255, u.data[_6 + 2] / 255, u.data[_6 + 3] / 255);
        var f = void 0,
            v = void 0,
            b = void 0,
            D = void 0,
            O = void 0,
            x = void 0,
            w = void 0,
            z = void 0,
            L = void 0;

        switch (p) {
          case Ve.BLEND_MODES.NORMAL:
            y.set(d.r + g.a * h * (g.r - d.r), d.g + g.a * h * (g.g - d.g), d.b + g.a * h * (g.b - d.b), d.a);
            break;

          case Ve.BLEND_MODES.OVERLAY:
            f = 1 - 2 * (1 - d.r) * (1 - g.r), v = 2 * d.r * g.r, b = f + (d.r < .5 ? 1 : 0) * (v - f), D = 1 - 2 * (1 - d.g) * (1 - g.g), O = 2 * d.g * g.g, x = D + (d.g < .5 ? 1 : 0) * (O - D), w = 1 - 2 * (1 - d.b) * (1 - g.b), z = 2 * d.b * g.b, L = w + (d.b < .5 ? 1 : 0) * (z - w), y.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (x - d.g), d.b + g.a * h * (L - d.b), d.a);
            break;

          case Ve.BLEND_MODES.HARD_LIGHT:
            f = 1 - 2 * (1 - g.r) * (1 - d.r), v = 2 * g.r * d.r, b = f + (g.r < .5 ? 1 : 0) * (v - f), D = 1 - 2 * (1 - g.g) * (1 - d.g), O = 2 * g.g * d.g, x = D + (g.g < .5 ? 1 : 0) * (O - D), w = 1 - 2 * (1 - g.b) * (1 - d.b), z = 2 * g.b * d.b, L = w + (g.b < .5 ? 1 : 0) * (z - w), y.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (x - d.g), d.b + g.a * h * (L - d.b), d.a);
            break;

          case Ve.BLEND_MODES.SOFT_LIGHT:
            f = 2 * d.r * (1 - g.r) + (2 * g.r - 1) * Math.sqrt(d.r), v = 2 * d.r * g.r + d.r * d.r * (1 - 2 * g.r), b = f + (g.r < .5 ? 1 : 0) * (v - f), D = 2 * d.g * (1 - g.g) + (2 * g.g - 1) * Math.sqrt(d.g), O = 2 * d.g * g.g + d.g * d.g * (1 - 2 * g.g), x = D + (g.g < .5 ? 1 : 0) * (O - D), w = 2 * d.b * (1 - g.b) + (2 * g.b - 1) * Math.sqrt(d.b), z = 2 * d.b * g.b + d.b * d.b * (1 - 2 * g.b), L = w + (g.b < .5 ? 1 : 0) * (z - w), y.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (x - d.g), d.b + g.a * h * (L - d.b), d.a);
            break;

          case Ve.BLEND_MODES.MULTIPLY:
            b = d.r * g.r, x = d.g * g.g, L = d.b * g.b, y.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (x - d.g), d.b + g.a * h * (L - d.b), d.a);
            break;

          case Ve.BLEND_MODES.DARKEN:
            b = Math.min(d.r, g.r), x = Math.min(d.g, g.g), L = Math.min(d.b, g.b), y.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (x - d.g), d.b + g.a * h * (L - d.b), d.a);
            break;

          case Ve.BLEND_MODES.LIGHTEN:
            b = Math.max(d.r, g.r), x = Math.max(d.g, g.g), L = Math.max(d.b, g.b), y.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (x - d.g), d.b + g.a * h * (L - d.b), d.a);
            break;

          case Ve.BLEND_MODES.SCREEN:
            b = 1 - (1 - d.r) * (1 - g.r), x = 1 - (1 - d.g) * (1 - g.g), L = 1 - (1 - d.b) * (1 - g.b), y.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (x - d.g), d.b + g.a * h * (L - d.b), d.a);
            break;

          case Ve.BLEND_MODES.COLOR_BURN:
            b = Math.max(0, Math.min(1, 1 - (1 - d.r) / Math.max(g.r, ja))), x = Math.max(0, Math.min(1, 1 - (1 - d.g) / Math.max(g.g, ja))), L = Math.max(0, Math.min(1, 1 - (1 - d.b) / Math.max(g.b, ja))), y.set(d.r + g.a * h * (b - d.r), d.g + g.a * h * (x - d.g), d.b + g.a * h * (L - d.b), d.a);
            break;
        }

        c.data[_6] = y.r * 255, c.data[_6 + 1] = y.g * 255, c.data[_6 + 2] = y.b * 255, c.data[_6 + 3] = y.a * 255;
      }

      l.putImageData(c, 0, 0);
    }
  }]);

  return Ve;
}(xt);

Ve.BLEND_MODES = {
  NORMAL: 0,
  OVERLAY: 1,
  HARD_LIGHT: 2,
  SOFT_LIGHT: 3,
  MULTIPLY: 4,
  DARKEN: 5,
  LIGHTEN: 6,
  SCREEN: 7,
  COLOR_BURN: 8
};
Ve.prototype.availableOptions = {
  blendMode: {
    type: Js.NUMBER,
    default: Ve.BLEND_MODES.NORMAL,
    uniformType: Ha.INT
  },
  overlayImage: {
    type: Js.NUMBER,
    required: !0,
    uniformType: Ha.SAMPLER2D
  },
  overlayTexture: {
    type: Js.OBJECT,
    required: !0
  },
  alpha: {
    type: Js.NUMBER,
    default: 1,
    uniformType: Ha.FLOAT
  }
};
var Lu = Ve;
var ht;

(function (s) {
  s[s.Nearest = 0] = "Nearest", s[s.Linear = 1] = "Linear", s[s.Bilinear = 2] = "Bilinear", s[s.Trilinear = 3] = "Trilinear";
})(ht || (ht = {}));

var si;

(function (s) {
  s[s.ClampToEdge = 0] = "ClampToEdge", s[s.Repeat = 1] = "Repeat", s[s.MirroredRepeat = 2] = "MirroredRepeat";
})(si || (si = {}));

var zu = (_zu = {}, _defineProperty(_zu, 1, "LINEAR"), _defineProperty(_zu, 0, "NEAREST"), _defineProperty(_zu, 2, "LINEAR_MIPMAP_NEAREST"), _defineProperty(_zu, 3, "LINEAR_MIPMAP_LINEAR"), _zu),
    or =
/*#__PURE__*/
function (_We2) {
  _inherits(or, _We2);

  function or(e) {
    var _this25;

    _classCallCheck(this, or);

    _this25 = _possibleConstructorReturn(this, _getPrototypeOf(or).call(this));
    _this25._renderers = [];
    _this25._glTextures = {};
    _this25._dirty = !0;
    _this25._mipMapping = !1;
    _this25._glUnit = 0;
    _this25._magFilter = or.DefaultMagFilter;
    _this25._minFilter = or.DefaultMinFilter;
    _this25._repeatX = 0;
    _this25._repeatY = 0;
    _this25._pixelRatio = 1;
    _this25._loaded = !1;
    _this25._frame = new le(0, 0, 100, 100);
    _this25._onSourceLoaded = _this25._onSourceLoaded.bind(_assertThisInitialized(_assertThisInitialized(_this25))), _this25._source = e, _this25._loadSource();
    return _this25;
  }

  _createClass(or, [{
    key: "resizeTo",
    value: function resizeTo(e) {
      this._frame.width === e.x && this._frame.height === e.y || (this._frame.width = e.x, this._frame.height = e.y, this._dirty = !0);
    }
  }, {
    key: "_loadSource",
    value: function _loadSource() {
      var e = this._source;

      if (!!e) {
        if (Ae.isCanvas(e)) return this._onSourceLoaded();
        if (e.complete) return this._onSourceLoaded();
        e.addEventListener && e.addEventListener("load", this._onSourceLoaded);
      }
    }
  }, {
    key: "_onSourceLoaded",
    value: function _onSourceLoaded() {
      this._loaded = !0, this.emit("loaded"), this.update();
    }
  }, {
    key: "_updateGLFilters",
    value: function _updateGLFilters() {
      if (!this._source) return;
      var e = new B(this._source.width, this._source.height);
      T.isPowerOfTwo(e) ? (A.info(this.constructor.name, "Mip-mapping enabled"), this._minFilter = or.TrilinearFilter, this._mipMapping = !0) : (this._minFilter = or.LinearFilter, this._mipMapping = !1);
    }
  }, {
    key: "update",
    value: function update() {
      !this._source || ((this._frame.width !== this._source.width || this._frame.height !== this._source.height) && (this._frame = new le(0, 0, this._source.width, this._source.height), this._dirty = !0), this._updateGLFilters(), this.emit("update"));
    }
  }, {
    key: "getRenderers",
    value: function getRenderers() {
      return _toConsumableArray(this._renderers);
    }
  }, {
    key: "getGLFilter",
    value: function getGLFilter(e, t) {
      switch (t) {
        case "min":
          return e[zu[this._minFilter]];

        case "mag":
          return e[zu[this._magFilter]];
      }
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return this._loaded;
    }
  }, {
    key: "setLoaded",
    value: function setLoaded(e) {
      this._loaded = e;
    }
  }, {
    key: "getSource",
    value: function getSource() {
      return this._source;
    }
  }, {
    key: "setSource",
    value: function setSource(e) {
      this._source = e;
    }
  }, {
    key: "getGLTextureForRenderer",
    value: function getGLTextureForRenderer(e) {
      return this._glTextures[e.id];
    }
  }, {
    key: "setGLTextureForRenderer",
    value: function setGLTextureForRenderer(e, t) {
      this._renderers[t.id] = t, this._glTextures[t.id] = e;
    }
  }, {
    key: "getFrame",
    value: function getFrame() {
      return this._frame;
    }
  }, {
    key: "setFrame",
    value: function setFrame(e) {
      this._frame = e;
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return new B(this._frame.width, this._frame.height);
    }
  }, {
    key: "getPixelRatio",
    value: function getPixelRatio() {
      return this._pixelRatio;
    }
  }, {
    key: "setPixelRatio",
    value: function setPixelRatio(e) {
      this._pixelRatio = e;
    }
  }, {
    key: "getGLUnit",
    value: function getGLUnit() {
      return this._glUnit;
    }
  }, {
    key: "setGLUnit",
    value: function setGLUnit(e) {
      this._glUnit = e;
    }
  }, {
    key: "setMinFilter",
    value: function setMinFilter(e) {
      this._minFilter = e;
    }
  }, {
    key: "getMinFilter",
    value: function getMinFilter() {
      return this._minFilter;
    }
  }, {
    key: "setMagFilter",
    value: function setMagFilter(e) {
      this._magFilter = e;
    }
  }, {
    key: "getMagFilter",
    value: function getMagFilter() {
      return this._magFilter;
    }
  }, {
    key: "setRepeatX",
    value: function setRepeatX(e) {
      this._repeatX = e;
    }
  }, {
    key: "getRepeatX",
    value: function getRepeatX() {
      return this._repeatX;
    }
  }, {
    key: "setRepeatY",
    value: function setRepeatY(e) {
      this._repeatY = e;
    }
  }, {
    key: "getRepeatY",
    value: function getRepeatY() {
      return this._repeatY;
    }
  }, {
    key: "getGLRepeat",
    value: function getGLRepeat(e, t) {
      switch (t === "x" ? this.getRepeatX() : this.getRepeatY()) {
        case 0:
          return e.CLAMP_TO_EDGE;

        case 1:
          return e.REPEAT;

        case 2:
          return e.MIRRORED_REPEAT;

        default:
          return 0;
      }
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      return this._dirty;
    }
  }, {
    key: "setDirty",
    value: function setDirty(e) {
      this._dirty = e;
    }
  }, {
    key: "disposeGLTextures",
    value: function disposeGLTextures() {
      var _this26 = this;

      this._renderers.forEach(function (e) {
        Zi(e) && _this26.disposeGLTexturesForRenderer(e);
      });
    }
  }, {
    key: "disposeGLTexturesForRenderer",
    value: function disposeGLTexturesForRenderer(e) {
      if (!this._glTextures[e.id]) return;
      e.getContext().deleteTexture(this._glTextures[e.id]), delete this._glTextures[e.id], this._renderers[e.id] || delete this._renderers[e.id];
    }
  }, {
    key: "isMipMappingEnabled",
    value: function isMipMappingEnabled() {
      return this._mipMapping;
    }
  }, {
    key: "setMipMappingEnabled",
    value: function setMipMappingEnabled(e) {
      this._mipMapping = e;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposeGLTextures(), this._source = void 0;
    }
  }]);

  return or;
}(We),
    xe = or;

xe.NearestFilter = 0, xe.LinearFilter = 1, xe.BilinearFilter = 2, xe.TrilinearFilter = 3, xe.DefaultMagFilter = 0, xe.DefaultMinFilter = 1, xe.Repeat = 1, xe._id = 0;

var Gt =
/*#__PURE__*/
function () {
  function Gt(e, t, i) {
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Ae.createCanvas();
    var o = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, Gt);

    this._width = e, this._height = t, this._pixelRatio = i, this._baseTexture = new xe(), this._canvas = r;

    var n = o || this._canvas.getContext("2d");

    if (!n) throw new Error("Cannot get canvas context");
    this._context = n, this._baseTexture.setSource(this._canvas), this._canvas.width = this._width * this._pixelRatio, this._canvas.height = this._height * this._pixelRatio, this._filterStack = [{
      renderTarget: this,
      filters: []
    }];
  }

  _createClass(Gt, [{
    key: "clear",
    value: function clear() {
      var e = this._context;
      e.setTransform(1, 0, 0, 1, 0, 0), e.clearRect(0, 0, this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
  }, {
    key: "resizeTo",
    value: function resizeTo(e) {
      this._baseTexture.resizeTo(e), this._width !== e.x && (this._width = e.x, this._canvas.width = this._width * this._pixelRatio), this._height !== e.y && (this._height = e.y, this._canvas.height = this._height * this._pixelRatio);
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this._canvas;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this._context;
    }
  }, {
    key: "getFilterStack",
    value: function getFilterStack() {
      return this._filterStack;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this._width;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this._height;
    }
  }, {
    key: "getPixelRatio",
    value: function getPixelRatio() {
      return this._pixelRatio;
    }
  }, {
    key: "setPixelRatio",
    value: function setPixelRatio(e) {
      this._pixelRatio = e;
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return new B(this._width, this._height);
    }
  }, {
    key: "getBaseTexture",
    value: function getBaseTexture() {
      return this._baseTexture;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      delete this._canvas, delete this._context, this._baseTexture.dispose();
    }
  }]);

  return Gt;
}();

var Ei =
/*#__PURE__*/
function () {
  function Ei(e) {
    _classCallCheck(this, Ei);

    this._renderer = e, this._filterStack = [{
      renderTarget: e.getCurrentRenderTarget(),
      filters: []
    }], this._textures = [], this._textureFrame = new le(0, 0, e.getWidth(), e.getHeight());
  }

  _createClass(Ei, [{
    key: "resizeTo",
    value: function resizeTo(e) {
      this._textureFrame.width = e.x, this._textureFrame.height = e.y, this._textures.forEach(function (t) {
        return t.resizeTo(e);
      });
    }
  }, {
    key: "pushFilters",
    value: function pushFilters(e, t) {
      this._currentFrame = e.getBounds();

      var i = this._getOrCreateRenderTarget();

      this._renderer.setRenderTarget(i), this._filterStack.push({
        renderTarget: i,
        filters: t
      }), i.clear();
    }
  }, {
    key: "popFilters",
    value: function popFilters() {
      var e = this._filterStack.pop();

      if (!e) return;
      var t = e.filters,
          i = e.renderTarget,
          r = this._filterStack[this._filterStack.length - 1],
          o = i,
          n = r.renderTarget;
      return t.length === 1 ? (t[0].apply(this._renderer, o, n), this._textures.push(o)) : this._applyFilters(t, o, n), t;
    }
  }, {
    key: "_applyFilters",
    value: function _applyFilters(e, t, i) {
      var _this27 = this;

      var r = t,
          o = this._getOrCreateRenderTarget(!0),
          n = e[e.length - 1];

      e.forEach(function (a) {
        if (a === n) a.apply(_this27._renderer, r, i);else {
          a.apply(_this27._renderer, r, o);
          var _c3 = r;
          r = o, o = _c3;
        }
      }), this._textures.push(r), this._textures.push(o);
    }
  }, {
    key: "_getOrCreateRenderTarget",
    value: function _getOrCreateRenderTarget() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

      var t = this._textures.pop();

      return t || (t = new Gt(this._textureFrame.width, this._textureFrame.height, 1)), e && t.clear(), t;
    }
  }, {
    key: "setFilterStack",
    value: function setFilterStack(e) {
      this._filterStack = e;
    }
  }, {
    key: "dispose",
    value: function dispose() {}
  }]);

  return Ei;
}();

var Nu = typeof window != "undefined" && window.performance && window.performance.now ? window.performance.now.bind(window.performance) : ke(),
    Gu =
/*#__PURE__*/
function () {
  function Gu(e) {
    var _this28 = this;

    _classCallCheck(this, Gu);

    this._context = e, this._tracking = !1;
    var t = this;

    var _loop2 = function _loop2(i) {
      typeof e[i] == "function" ? _this28[i] = function () {
        for (var _len11 = arguments.length, o = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          o[_key11] = arguments[_key11];
        }

        var n = e[i];
        if (!t._tracking) return n.apply(e, o);
        var a = Nu(),
            l = n.apply(e, o),
            c = Nu() - a,
            u = {
          functionName: i,
          arguments: o,
          duration: c
        };
        return t._trackedCalls.push(u), l;
      } : _this28._makePropertyWrapper(i);
    };

    for (var i in e) {
      _loop2(i);
    }
  }

  _createClass(Gu, [{
    key: "_makePropertyWrapper",
    value: function _makePropertyWrapper(e) {
      if (["_context", "_trackedCalls", "_tracking"].indexOf(e) !== -1) return;
      var i = this._context;
      this.__defineGetter__(e, function () {
        return i[e];
      }), this.__defineSetter__(e, function (r) {
        i[e] = r;
      });
    }
  }, {
    key: "startFrame",
    value: function startFrame() {
      this._tracking = !0, this._trackedCalls = [];
    }
  }, {
    key: "endFrame",
    value: function endFrame() {
      var e = "Rendering";
      A.log(e, "Frame rendering results:"), A.log(e, "Context calls: ".concat(this._trackedCalls.length));
      var t = {};

      this._trackedCalls.forEach(function (_ref20) {
        var r = _ref20.functionName,
            o = _ref20.duration;
        t[r] = t[r] || {
          totalDuration: 0,
          calls: 0
        }, t[r].totalDuration += o, t[r].calls++;
      });

      var i = [];

      for (var r in t) {
        var _o2 = t[r];
        _o2.averageDuration = _o2.totalDuration / _o2.calls, i.push({
          functionName: r,
          data: _o2
        });
      }

      i.sort(function (r, o) {
        return o.data.totalDuration - r.data.totalDuration;
      }), i = i.slice(0, 3), i.forEach(function (r) {
        A.log(e, "".concat(r.functionName, ": ").concat(r.data.calls, " calls, ").concat(r.data.totalDuration.toFixed(2), "ms"));
      });
    }
  }]);

  return Gu;
}(),
    eo = Gu;

var ms =
/*#__PURE__*/
function (_We3) {
  _inherits(ms, _We3);

  function ms() {
    var _this29;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 800;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
    var i = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, ms);

    _this29 = _possibleConstructorReturn(this, _getPrototypeOf(ms).call(this));
    _this29._maxTextureSize = null;
    _this29._options = C(C({
      debug: !1
    }, i), {
      pixelRatio: 1,
      transparent: !1,
      clearColor: R.BLACK
    }), _this29.setMaxListeners(0), _this29._width = e, _this29._height = t, _this29._dimensions = new B(_this29._width, _this29._height), _this29._maxTextureSize = null, _this29._pixelRatio = _this29._options.pixelRatio, _this29._canvas = _this29._options.canvas, _this29._clearColor = _this29._options.transparent ? R.TRANSPARENT : _this29._options.clearColor || R.BLACK;
    return _this29;
  }

  _createClass(ms, [{
    key: "setCanvas",
    value: function setCanvas(e) {
      var t = this._canvas;
      this._canvas = e, t !== e && (this._createContext(), this._onBeforeContext(), this._setupContext()), this.resizeTo(new B(this._width, this._height));
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this._canvas;
    }
  }, {
    key: "_onBeforeContext",
    value: function _onBeforeContext() {}
  }, {
    key: "resizeTo",
    value: function resizeTo(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      this._width = e.x * this._pixelRatio, this._height = e.y * this._pixelRatio, t && this._canvas && (this._canvas.width = this._width, this._canvas.height = this._height, "style" in this._canvas && (this._canvas.style.width = "".concat(this._width / this._pixelRatio, "px"), this._canvas.style.height = "".concat(this._height / this._pixelRatio, "px"))), this._dimensions = e.clone();
    }
  }, {
    key: "_createContext",
    value: function _createContext() {
      A.warn(this.constructor.name, "`_createContext` is abstract and not implemented in inherited class");
    }
  }, {
    key: "_setupContext",
    value: function _setupContext() {
      A.warn(this.constructor.name, "`_setupContext` is abstract and not implemented in inherited class");
    }
  }, {
    key: "render",
    value: function render(e) {
      A.warn(this.constructor.name, "`render` is abstract and not implemented in inherited class");
    }
  }, {
    key: "getMaxDimensions",
    value: function getMaxDimensions() {
      return null;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this._context;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this._dimensions.x;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this._dimensions.y;
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return this._dimensions;
    }
  }, {
    key: "getPixelRatio",
    value: function getPixelRatio() {
      return this._pixelRatio;
    }
  }, {
    key: "setPixelRatio",
    value: function setPixelRatio(e) {
      this._pixelRatio = e, this._defaultRenderTarget && this._defaultRenderTarget.setPixelRatio(e);
    }
  }, {
    key: "getMaxTextureSize",
    value: function getMaxTextureSize() {
      return this._maxTextureSize;
    }
  }, {
    key: "getFilterManager",
    value: function getFilterManager() {
      return this._filterManager;
    }
  }, {
    key: "setFilterManager",
    value: function setFilterManager(e) {
      this._filterManager = e;
    }
  }, {
    key: "isOfType",
    value: function isOfType(e) {
      return this._type === e;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      A.warn(this.constructor.name, "`dispose` is abstract and not implemented in inherited class");
    }
  }]);

  return ms;
}(We);

var Wu = Xe.RendererType,
    qa =
/*#__PURE__*/
function (_ms) {
  _inherits(qa, _ms);

  function qa() {
    var _this30;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 800;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
    var i = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, qa);

    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(qa).call(this, e, t, C({}, i)));
    _this30.id = 0;
    _this30.setCanvas((i == null ? void 0 : i.canvas) || Ae.createCanvas()), _this30._type = Wu.CANVAS;
    return _this30;
  }

  _createClass(qa, [{
    key: "_createContext",
    value: function _createContext() {
      var t = this._canvas.getContext("2d");

      if (!!t) return this._options.debug && (t = new eo(t)), this.id = qa.contextId++, this._context = t, this.emit("context", t), t;
    }
  }, {
    key: "_setupContext",
    value: function _setupContext() {
      var e = this._context;
      "imageSmoothingEnabled" in e ? e.imageSmoothingEnabled = !0 : ["moz", "webkit", "ms"].forEach(function (t) {
        e[t] && (e[t] = !0);
      }), this._defaultRenderTarget = new Gt(this._width, this._height, this._pixelRatio, this._canvas, this._context), this.setRenderTarget(this._defaultRenderTarget), this._filterManager = new Ei(this);
    }
  }, {
    key: "render",
    value: function render(e) {
      var t = this._renderTarget.getContext(),
          i = e.getParent();

      e.setParent(new Fi()), e.updateTransform(), i && e.setParent(i), t.setTransform(1, 0, 0, 1, 0, 0), t.globalAlpha = 1;
      var _this$_canvas = this._canvas,
          r = _this$_canvas.width,
          o = _this$_canvas.height;
      t.clearRect(0, 0, r, o), this._clearColor.a !== 0 && (t.save(), t.fillStyle = this._clearColor.toRGBA(), t.fillRect(0, 0, r, o), t.restore()), this.renderDisplayObject(e, this._renderTarget);
    }
  }, {
    key: "renderDisplayObject",
    value: function renderDisplayObject(e, t) {
      var i = this._renderTarget;
      this._filterManager.setFilterStack(t.getFilterStack()), this.setRenderTarget(t), e.renderCanvas(this), this.setRenderTarget(i);
    }
  }, {
    key: "getCurrentRenderTarget",
    value: function getCurrentRenderTarget() {
      return this._renderTarget;
    }
  }, {
    key: "setRenderTarget",
    value: function setRenderTarget(e) {
      this._renderTarget = e;
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this._renderTarget.getContext();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._filterManager.dispose();
    }
  }]);

  return qa;
}(ms),
    nr = qa;

nr.contextId = 0, nr.type = Wu.CANVAS;

var Vu = function Vu(s) {
  if (typeof window != "undefined") {
    var _window = window,
        _e6 = _window.WebGLDebugUtils;

    if (_e6) {
      var _t3 = function _t3(i, r) {
        console.error("gl.".concat(i, "(").concat(_e6.glFunctionArgsToString(i, r), ")"));
      };

      s = _e6.makeDebugContext(s, null, _t3);
    }
  }

  return s;
};

var Ka =
/*#__PURE__*/
function () {
  function Ka(e) {
    _classCallCheck(this, Ka);

    this.vertices = new Float32Array([0, 0, 100, 0, 100, 100, 0, 100]);
    this.uvs = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
    this.indices = new Uint16Array([0, 1, 2, 0, 3, 2]);
    this.colors = new Float32Array([1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]);
    this.vertexBuffer = null;
    this.indexBuffer = null;
    this.gl = e, this.initBuffers(), this.uploadBuffers();
  }

  _createClass(Ka, [{
    key: "map",
    value: function map(e, t) {
      var i = t.x,
          r = t.y;
      this.uvs[2] = t.width / e.width, this.uvs[4] = this.uvs[2], this.uvs[5] = t.height / e.height, this.uvs[7] = this.uvs[5], this.vertices[0] = i, this.vertices[1] = r, this.vertices[2] = i + t.width, this.vertices[3] = r, this.vertices[4] = this.vertices[2], this.vertices[5] = r + t.height, this.vertices[6] = i, this.vertices[7] = this.vertices[5], this.uploadBuffers();
    }
  }, {
    key: "getVertexBuffer",
    value: function getVertexBuffer() {
      return this.vertexBuffer;
    }
  }, {
    key: "getIndexBuffer",
    value: function getIndexBuffer() {
      return this.indexBuffer;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.cleanBuffer();
    }
  }, {
    key: "initBuffers",
    value: function initBuffers() {
      var e = this.gl;
      this.cleanBuffer(), this.vertexBuffer = e.createBuffer(), e.bindBuffer(e.ARRAY_BUFFER, this.vertexBuffer), e.bufferData(e.ARRAY_BUFFER, (8 + 8 + 16) * 4, e.DYNAMIC_DRAW), this.indexBuffer = e.createBuffer(), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this.indexBuffer), e.bufferData(e.ELEMENT_ARRAY_BUFFER, this.indices, e.STATIC_DRAW);
    }
  }, {
    key: "uploadBuffers",
    value: function uploadBuffers() {
      var e = this.gl;
      e.bindBuffer(e.ARRAY_BUFFER, this.vertexBuffer), e.bufferSubData(e.ARRAY_BUFFER, 0, this.vertices), e.bufferSubData(e.ARRAY_BUFFER, 8 * 4, this.uvs), e.bufferSubData(e.ARRAY_BUFFER, (8 + 8) * 4, this.colors);
    }
  }, {
    key: "cleanBuffer",
    value: function cleanBuffer() {
      var e = this.gl;
      e.deleteBuffer(this.vertexBuffer), e.deleteBuffer(this.indexBuffer);
    }
  }]);

  return Ka;
}();

var Wt =
/*#__PURE__*/
function () {
  function Wt(e, t, i, r) {
    var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;

    _classCallCheck(this, Wt);

    this._renderer = e, this._gl = e.getContext(), this._width = t, this._height = i, this._frame = null, this._pixelRatio = r, this._projectionMatrix = new Ze(), this._mipMapping = !1, this._baseTexture = new xe();

    var n = this._baseTexture.getFrame();

    n.width = t, n.height = i, this._baseTexture.setPixelRatio(r), this._baseTexture.setLoaded(!0), this._framebuffer = null, this._isRoot = o, this._filterStack = [{
      renderTarget: this,
      filters: []
    }], o || this._initFrameBuffer();
  }

  _createClass(Wt, [{
    key: "resizeTo",
    value: function resizeTo(e) {
      this._width = e.x | 0, this._height = e.y | 0, this._baseTexture.resizeTo(e), this._isRoot || this._resizeTexture(), this._baseTexture.setMinFilter(this._getMinFilter()), this._baseTexture.setMagFilter(this._getMagFilter()), this._calculateProjectionMatrix();
    }
  }, {
    key: "_getMinFilter",
    value: function _getMinFilter() {
      var e = xe.DefaultMinFilter;
      return this._mipMapping && (e = xe.TrilinearFilter), e;
    }
  }, {
    key: "_getMagFilter",
    value: function _getMagFilter() {
      return xe.DefaultMagFilter;
    }
  }, {
    key: "_resizeTexture",
    value: function _resizeTexture() {
      var e = this._gl,
          t = this._width * this._pixelRatio,
          i = this._height * this._pixelRatio;
      this._texture && (e.deleteTexture(this._texture), this._texture = null), this._texture = e.createTexture(), e.bindTexture(e.TEXTURE_2D, this._texture), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, t, i, 0, e.RGBA, e.UNSIGNED_BYTE, null), e.bindFramebuffer(e.FRAMEBUFFER, this._framebuffer), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, this._texture, 0), this._texture && this._baseTexture.setGLTextureForRenderer(this._texture, this._renderer), this._renderer._options.debug && Ti.checkFramebufferStatus("WebGLRenderTarget#_initFramebuffer", e);
      var r = new B(this._width, this._height);
      T.isPowerOfTwo(r) ? (A.info("WebGLRenderTarget", "Mip-mapping enabled"), this._mipMapping = !0) : this._mipMapping = !1, this._baseTexture.setMipMappingEnabled(this._mipMapping);
    }
  }, {
    key: "activate",
    value: function activate() {
      var e = this._gl;
      e.bindFramebuffer(e.FRAMEBUFFER, this._framebuffer), this._calculateProjectionMatrix(), e.viewport(0, 0, this._width * this._pixelRatio, this._height * this._pixelRatio), e.disable(e.STENCIL_TEST);
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : R.TRANSPARENT;
      var t = this._gl;
      t.bindFramebuffer(t.FRAMEBUFFER, this._framebuffer), this._renderer._options.debug && Ti.checkFramebufferStatus("WebGLRenderTarget#clear", t), t.clearColor.apply(t, e.toGLColor()), t.clear(t.COLOR_BUFFER_BIT);
    }
  }, {
    key: "_calculateProjectionMatrix",
    value: function _calculateProjectionMatrix() {
      var e = this._projectionMatrix;
      e.reset();
      var t = this._frame || new le(0, 0, this._width, this._height),
          i = t.x,
          r = t.y;
      this._isRoot ? (e.a = 1 / this._width * 2, e.d = -1 / this._height * 2, e.tx = -1 - i * e.a, e.ty = 1 - r * e.d) : (e.a = 1 / this._width * 2, e.d = 1 / this._height * 2, e.tx = -1 - i * e.a, e.ty = -1 - r * e.d);
    }
  }, {
    key: "_initFrameBuffer",
    value: function _initFrameBuffer() {
      var e = this._gl;
      this._framebuffer && (e.deleteFramebuffer(this._framebuffer), this._framebuffer = null), this._texture && (e.deleteTexture(this._texture), this._texture = null), this._framebuffer = e.createFramebuffer(), this._texture = e.createTexture(), e.bindTexture(e.TEXTURE_2D, this._texture), e.bindFramebuffer(e.FRAMEBUFFER, this._framebuffer), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, this._texture, 0), this._texture && this._baseTexture.setGLTextureForRenderer(this._texture, this._renderer), this.resizeTo(new B(this._width, this._height)), this._renderer._options.debug && Ti.checkFramebufferStatus("WebGLRenderTarget#_initFramebuffer", e);
    }
  }, {
    key: "getProjectionMatrix",
    value: function getProjectionMatrix() {
      return this._projectionMatrix;
    }
  }, {
    key: "getTexture",
    value: function getTexture() {
      return this._texture;
    }
  }, {
    key: "getFrame",
    value: function getFrame() {
      return this._frame;
    }
  }, {
    key: "setFrame",
    value: function setFrame(e) {
      this._frame = e;
    }
  }, {
    key: "getFilterStack",
    value: function getFilterStack() {
      return this._filterStack;
    }
  }, {
    key: "getPixelRatio",
    value: function getPixelRatio() {
      return this._pixelRatio;
    }
  }, {
    key: "setPixelRatio",
    value: function setPixelRatio(e) {
      this._pixelRatio = e, this._isRoot || this._resizeTexture();
    }
  }, {
    key: "getBaseTexture",
    value: function getBaseTexture() {
      return this._baseTexture;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var e = this._gl;
      this._baseTexture.dispose(), this._framebuffer && (e.deleteFramebuffer(this._framebuffer), this._framebuffer = null), this._texture && (e.deleteTexture(this._texture), this._texture = null);
    }
  }]);

  return Wt;
}();

var ds =
/*#__PURE__*/
function () {
  function ds(e) {
    _classCallCheck(this, ds);

    this._renderer = e, this._filterStack = [], this._currentFrame = null, this._renderTargets = [], this._textureFrame = new le(0, 0, e.getWidth(), e.getHeight()), this._onContextChange = this._onContextChange.bind(this), this._renderer.on("context", this._onContextChange), this._onContextChange();
  }

  _createClass(ds, [{
    key: "resizeTo",
    value: function resizeTo(e) {
      this._textureFrame.width = e.x, this._textureFrame.height = e.y, this._renderTargets.forEach(function (t) {
        return t.resizeTo(e);
      });
    }
  }, {
    key: "getFilterStack",
    value: function getFilterStack() {
      return this._filterStack;
    }
  }, {
    key: "setFilterStack",
    value: function setFilterStack(e) {
      this._filterStack = e;
    }
  }, {
    key: "_getOrCreateRenderTarget",
    value: function _getOrCreateRenderTarget() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

      var t = this._renderTargets.pop();

      return t || (t = new Wt(this._renderer, this._textureFrame.width, this._textureFrame.height, 1)), this._currentFrame && t.setFrame(this._currentFrame), e && t.clear(), t;
    }
  }, {
    key: "pushFilters",
    value: function pushFilters(e, t) {
      var i = e.getBounds();
      this._currentFrame = i;
      var r = e.getFilterRectangle();
      r.width > 0 && r.height > 0 && (this._currentFrame = r);

      var o = this._getOrCreateRenderTarget();

      this._renderer.setRenderTarget(o), o.clear(), this._filterStack.push({
        renderTarget: o,
        filters: t
      });
    }
  }, {
    key: "popFilters",
    value: function popFilters() {
      var e = this._filterStack.pop();

      if (!e) return;
      var t = e.filters,
          i = e.renderTarget,
          r = this._filterStack[this._filterStack.length - 1],
          o = i,
          n = r.renderTarget,
          a = o.getFrame();
      a && this._quad.map(this._textureFrame, a);

      var l = t[0].getShaderForRenderer(this._renderer),
          c = this._quad.getVertexBuffer(),
          u = this._quad.getIndexBuffer(),
          p = this._renderer.getContext();

      p.bindBuffer(p.ARRAY_BUFFER, c), p.bindBuffer(p.ELEMENT_ARRAY_BUFFER, u);
      var h = l.getAttributeLocations();
      return p.vertexAttribPointer(h.a_position, 2, p.FLOAT, !1, 0, 0), p.vertexAttribPointer(h.a_texCoord, 2, p.FLOAT, !1, 0, 2 * 4 * 4), p.vertexAttribPointer(h.a_color, 4, p.FLOAT, !1, 0, 4 * 4 * 4), this._renderer.updateTexture(o.getBaseTexture(), !1), t.length === 1 ? (t[0].apply(this._renderer, o, n), this._renderTargets.push(o)) : this._applyFilters(t, o, n), t;
    }
  }, {
    key: "_applyFilters",
    value: function _applyFilters(e, t, i) {
      var _this31 = this;

      var r = t,
          o = this._getOrCreateRenderTarget(!0);

      this._renderer.updateTexture(o.getBaseTexture(), !1);

      var n = e[e.length - 1];
      e.forEach(function (a) {
        if (a === n) a.apply(_this31._renderer, r, i, !0);else {
          a.apply(_this31._renderer, r, o, !0);
          var _c4 = r;
          r = o, o = _c4;
        }
      }), this._renderTargets.push(r), this._renderTargets.push(o);
    }
  }, {
    key: "_onContextChange",
    value: function _onContextChange() {
      this._renderTargets.length = 0, Zi(this._renderer) && (this._quad && this._quad.dispose(), this._quad = new Ka(this._renderer.getContext()));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._renderer.off("context", this._onContextChange), this._quad && this._quad.dispose(), this._renderTargets.forEach(function (e) {
        e.dispose();
      });
    }
  }]);

  return ds;
}();

var oi = Te(ar()),
    Qa =
/*#__PURE__*/
function () {
  function Qa(e) {
    _classCallCheck(this, Qa);

    this._context = e, this._domAvailable = typeof document != "undefined", this._hookIntoContext(), this._textures = {}, this._framebuffers = {}, this._programs = {}, this._shaders = {}, this._buffers = {}, this._boundTexture = null, this._id = 0, this._enums = {}, this._setupStats(), this._createEnumMap(), this._updateMemoryStats = this._updateMemoryStats.bind(this), this._updateMemoryStats();
  }

  _createClass(Qa, [{
    key: "_createEnumMap",
    value: function _createEnumMap() {
      for (var _e7 in this._context) {
        var _t4 = this._context[_e7];
        typeof _t4 == "number" && (this._enums[_t4] = _e7);
      }
    }
  }, {
    key: "_enumValueToString",
    value: function _enumValueToString(e) {
      var t = this._enums[e];
      return typeof t == "undefined" ? e : t;
    }
  }, {
    key: "_setupStats",
    value: function _setupStats() {
      !this._domAvailable || (this._stats = new oi.default(), this._stats.showPanel(3), this._memPanel = this._stats.addPanel(new oi.default.Panel("MB [WebGL]", "#43ADEB", "#282828")), this._texPanel = this._stats.addPanel(new oi.default.Panel("Textures", "#43ADEB", "#282828")), this._bufPanel = this._stats.addPanel(new oi.default.Panel("Buffers", "#43ADEB", "#282828")), this._fboPanel = this._stats.addPanel(new oi.default.Panel("FBOs", "#43ADEB", "#282828")), this._prgPanel = this._stats.addPanel(new oi.default.Panel("Programs", "#43ADEB", "#282828")), this._shdPanel = this._stats.addPanel(new oi.default.Panel("Shaders", "#43ADEB", "#282828")));
    }
  }, {
    key: "_updatePanel",
    value: function _updatePanel(e) {
      if (!!this._domAvailable) {
        switch (this._stats.begin(), e) {
          case "tex":
            this._texPanel.update(this.getTexturesCount(), 50);

            break;

          case "buf":
            this._bufPanel.update(this.getBuffersCount(), 50);

            break;

          case "fbo":
            this._fboPanel.update(this.getFBOCount(), 50);

            break;

          case "prg":
            this._prgPanel.update(this.getProgramCount(), 50);

            break;

          case "shd":
            this._shdPanel.update(this.getShaderCount(), 50);

            break;
        }

        this._stats.end();
      }
    }
  }, {
    key: "getTexturesCount",
    value: function getTexturesCount() {
      return Object.keys(this._textures).length;
    }
  }, {
    key: "getBuffersCount",
    value: function getBuffersCount() {
      return Object.keys(this._buffers).length;
    }
  }, {
    key: "getFBOCount",
    value: function getFBOCount() {
      return Object.keys(this._framebuffers).length;
    }
  }, {
    key: "getProgramCount",
    value: function getProgramCount() {
      return Object.keys(this._programs).length;
    }
  }, {
    key: "getShaderCount",
    value: function getShaderCount() {
      return Object.keys(this._shaders).length;
    }
  }, {
    key: "_updateMemoryStats",
    value: function _updateMemoryStats() {
      if (!this._domAvailable) return;
      var e = this._getMemoryUsage() / 1e3 / 1e3;
      this._memPanel.update(e, 400), setTimeout(this._updateMemoryStats, 1e3);
    }
  }, {
    key: "_getMemoryUsage",
    value: function _getMemoryUsage() {
      var e = 0;

      for (var _t5 in this._textures) {
        e += this._textures[_t5].memory;
      }

      for (var _t6 in this._buffers) {
        e += this._buffers[_t6].memory;
      }

      return e;
    }
  }, {
    key: "_hookIntoContext",
    value: function _hookIntoContext() {
      var _this32 = this;

      var _loop3 = function _loop3(_e8) {
        typeof _this32._context[_e8] == "function" ? _this32[_e8] = function () {
          var r = this._context[_e8];

          for (var _len12 = arguments.length, i = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
            i[_key12] = arguments[_key12];
          }

          return this._trackGLCall(r, _e8, i);
        } : _this32._makePropertyWrapper(_e8);
      };

      for (var _e8 in this._context) {
        _loop3(_e8);
      }
    }
  }, {
    key: "_makePropertyWrapper",
    value: function _makePropertyWrapper(e) {
      if (["_context"].indexOf(e) !== -1) return;
      var i = this._context;
      this.__defineGetter__(e, function () {
        return i[e];
      }), this.__defineSetter__(e, function (r) {
        i[e] = r;
      });
    }
  }, {
    key: "_trackGLCall",
    value: function _trackGLCall(e, t, i) {
      var r = ["texImage2D", "bindTexture", "createTexture", "deleteTexture", "createBuffer", "bindBuffer", "bufferData", "deleteBuffer", "createFramebuffer", "deleteFramebuffer", "createProgram", "deleteProgram", "createShader", "deleteShader"],
          o;
      r.indexOf(t) !== -1 ? o = this["_".concat(t)](i) : o = e.apply(this._context, i);

      var n = this._context.getError();

      if (n !== 0) {
        var a = i.join(", ");
        a.length > 100 && (a = "".concat(a.substr(0, 100), "...")), console.error(new Error("WebGL Error ".concat(this._enumValueToString(n), " in ").concat(t, "(").concat(a, ")")));
      }

      return o;
    }
  }, {
    key: "_createProgram",
    value: function _createProgram() {
      var e = this._context.createProgram();

      return e._wmmId = this._id++, this._programs[e._wmmId] = e, this._updatePanel("prg"), e;
    }
  }, {
    key: "_deleteProgram",
    value: function _deleteProgram(_ref21) {
      var _ref22 = _slicedToArray(_ref21, 1),
          e = _ref22[0];

      !e || !this._programs[e._wmmId] || (delete this._programs[e._wmmId], this._context.deleteProgram(e), this._updatePanel("prg"));
    }
  }, {
    key: "_createShader",
    value: function _createShader(_ref23) {
      var _ref24 = _slicedToArray(_ref23, 1),
          e = _ref24[0];

      var t = this._context.createShader(e);

      return t._wmmId = this._id++, this._shaders[t._wmmId] = t, this._updatePanel("shd"), t;
    }
  }, {
    key: "_deleteShader",
    value: function _deleteShader(_ref25) {
      var _ref26 = _slicedToArray(_ref25, 1),
          e = _ref26[0];

      !e || !this._shaders[e._wmmId] || (delete this._shaders[e._wmmId], this._context.deleteShader(e), this._updatePanel("shd"));
    }
  }, {
    key: "_createFramebuffer",
    value: function _createFramebuffer() {
      var e = this._context.createFramebuffer();

      return e._wmmId = this._id++, this._framebuffers[e._wmmId] = e, this._updatePanel("fbo"), e;
    }
  }, {
    key: "_deleteFramebuffer",
    value: function _deleteFramebuffer(_ref27) {
      var _ref28 = _slicedToArray(_ref27, 1),
          e = _ref28[0];

      !e || !this._framebuffers[e._wmmId] || (delete this._framebuffers[e._wmmId], this._context.deleteFramebuffer(e), this._updatePanel("fbo"));
    }
  }, {
    key: "_createBuffer",
    value: function _createBuffer() {
      var e = this._context.createBuffer();

      return e._wmmId = this._id++, this._buffers[e._wmmId] = {
        buffer: e,
        memory: 0
      }, this._updatePanel("buf"), e;
    }
  }, {
    key: "_bindBuffer",
    value: function _bindBuffer(_ref29) {
      var _ref30 = _slicedToArray(_ref29, 2),
          e = _ref30[0],
          t = _ref30[1];

      this._context.bindBuffer(e, t), this._boundBuffer = t._wmmId;
    }
  }, {
    key: "_bufferData",
    value: function _bufferData(_ref31) {
      var _ref32 = _slicedToArray(_ref31, 3),
          e = _ref32[0],
          t = _ref32[1],
          i = _ref32[2];

      this._context.bufferData(e, t, i);

      var r;
      typeof t == "number" ? r = t : "byteLength" in t ? r = t.byteLength : "length" in t && (r = t.length), this._buffers[this._boundBuffer].memory = r;
    }
  }, {
    key: "_deleteBuffer",
    value: function _deleteBuffer(_ref33) {
      var _ref34 = _slicedToArray(_ref33, 1),
          e = _ref34[0];

      !e || !this._buffers[e._wmmId] || (delete this._buffers[e._wmmId], this._context.deleteBuffer(e), this._updatePanel("buf"));
    }
  }, {
    key: "_createTexture",
    value: function _createTexture() {
      var e = this._context.createTexture();

      return e._wmmId = this._id++, this._textures[e._wmmId] = {
        texture: e,
        memory: 0
      }, this._updatePanel("tex"), e;
    }
  }, {
    key: "_deleteTexture",
    value: function _deleteTexture(_ref35) {
      var _ref36 = _slicedToArray(_ref35, 1),
          e = _ref36[0];

      !e || !this._textures[e._wmmId] || (delete this._textures[e._wmmId], this._context.deleteTexture(e), this._updatePanel("tex"));
    }
  }, {
    key: "_bindTexture",
    value: function _bindTexture(_ref37) {
      var _ref38 = _slicedToArray(_ref37, 2),
          e = _ref38[0],
          t = _ref38[1];

      this._context.bindTexture(e, t), this._boundTexture = t._wmmId;
    }
  }, {
    key: "_texImage2D",
    value: function _texImage2D(e) {
      var _e9 = _slicedToArray(e, 9),
          t = _e9[2],
          i = _e9[3],
          r = _e9[4],
          o = _e9[5],
          n = _e9[8];

      typeof n == "undefined" && (n = o), this._context.texImage2D.apply(this._context, e);

      var a = this._calculateByteCountForTexture(t, i, r, n);

      this._textures[this._boundTexture].memory = a;
    }
  }, {
    key: "_calculateByteCountForTexture",
    value: function _calculateByteCountForTexture(e, t, i, r) {
      if (r !== null) if ("width" in r) t = r.width, i = r.height;else return r.length;
      var o = 1;

      switch (e) {
        case this._context.ALPHA:
          o = 1;
          break;

        case this._context.RGB:
          o = 3;
          break;

        case this._context.RGBA:
          o = 4;
          break;
      }

      return t * i * o;
    }
  }]);

  return Qa;
}(),
    Hu = Qa;

var ps =
/*#__PURE__*/
function () {
  function ps(e) {
    _classCallCheck(this, ps);

    this._renderer = e, this._onContextChange = this._onContextChange.bind(this), this._renderer.on("context", this._onContextChange);
  }

  _createClass(ps, [{
    key: "_onContextChange",
    value: function _onContextChange() {}
  }, {
    key: "start",
    value: function start() {}
  }, {
    key: "stop",
    value: function stop() {
      this.flush();
    }
  }, {
    key: "flush",
    value: function flush() {}
  }, {
    key: "dispose",
    value: function dispose() {
      this._renderer.off("context", this._onContextChange), delete this._renderer;
    }
  }]);

  return ps;
}();

var Za =
/*#__PURE__*/
function (_ps) {
  _inherits(Za, _ps);

  function Za(e) {
    var _this33;

    _classCallCheck(this, Za);

    _this33 = _possibleConstructorReturn(this, _getPrototypeOf(Za).call(this, e));
    _this33._vertexBuffer = null;
    _this33._indexBuffer = null;
    _this33._maxBatchSize = rr, _this33._vertices = new ArrayBuffer(rr * 4 * ii), _this33._positions = new Float32Array(_this33._vertices), _this33._colors = new Uint32Array(_this33._vertices), _this33._indices = new Uint16Array(rr * 6);

    for (var _t7 = 0, i = 0; _t7 < rr * 6; _t7 += 6, i += 4) {
      _this33._indices[_t7 + 0] = i + 0, _this33._indices[_t7 + 1] = i + 1, _this33._indices[_t7 + 2] = i + 2, _this33._indices[_t7 + 3] = i + 0, _this33._indices[_t7 + 4] = i + 2, _this33._indices[_t7 + 5] = i + 3;
    }

    _this33._sprites = [], _this33._currentBatchSize = 0, _this33._onContextChange();
    return _this33;
  }

  _createClass(Za, [{
    key: "render",
    value: function render(e) {
      var t = e.getTexture();
      if (!t) return;
      var i = t.getFrame(),
          r = t.getBaseTexture();
      this._currentBatchSize >= this._maxBatchSize && this.flush();
      var o = t.getUVs();
      if (!o) return;
      var n = this._currentBatchSize * ii;
      this._addVertexCoordinates(e, n, i), this._addTextureUVs(e, n, o), this._addColors(e, n), this._sprites[this._currentBatchSize] = e, this._currentBatchSize++;
    }
  }, {
    key: "_addColors",
    value: function _addColors(e, t) {
      var i = this._colors,
          r = 16777215,
          o = (r >> 16) + (r & 65280) + ((r & 255) << 16) + (e.getWorldAlpha() * 255 << 24);
      i[t + 4] = i[t + 9] = i[t + 14] = i[t + 19] = o;
    }
  }, {
    key: "_addTextureUVs",
    value: function _addTextureUVs(e, t, i) {
      var r = this._positions,
          _i5 = _slicedToArray(i, 4),
          o = _i5[0],
          n = _i5[1],
          a = _i5[2],
          l = _i5[3];

      r[t + 2] = o.x, r[t + 3] = o.y, r[t + 7] = n.x, r[t + 8] = n.y, r[t + 12] = a.x, r[t + 13] = a.y, r[t + 17] = l.x, r[t + 18] = l.y;
    }
  }, {
    key: "_addVertexCoordinates",
    value: function _addVertexCoordinates(e, t, i) {
      var r = this._positions,
          o = e.getWorldTransform(),
          n = e.getAnchor(),
          a = o.rectangleToCoordinates(i, n),
          l = 5;

      for (var _c5 = 0; _c5 < 4; _c5++) {
        r[t + _c5 * l] = a[_c5].x, r[t + _c5 * l + 1] = a[_c5].y;
      }
    }
  }, {
    key: "_onContextChange",
    value: function _onContextChange() {
      var e = this._renderer.getContext();

      this._shader = this._renderer.shaders.default, this._vertexBuffer && (this._vertexBuffer = null), this._indexBuffer && (this._indexBuffer = null), this._vertexBuffer = e.createBuffer(), this._indexBuffer = e.createBuffer(), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this._indexBuffer), e.bufferData(e.ELEMENT_ARRAY_BUFFER, this._indices, e.STATIC_DRAW), e.bindBuffer(e.ARRAY_BUFFER, this._vertexBuffer), e.bufferData(e.ARRAY_BUFFER, this._vertices, e.DYNAMIC_DRAW);
    }
  }, {
    key: "start",
    value: function start() {
      this._vertexBuffer && this._indexBuffer && this._shader.setupBuffers(this._vertexBuffer, this._indexBuffer);
    }
  }, {
    key: "flush",
    value: function flush() {
      var h;
      var e = this._renderer,
          t = e.getContext();
      if (this._currentBatchSize === 0) return;
      if (this._currentBatchSize > rr * .5) t.bufferSubData(t.ARRAY_BUFFER, 0, this._vertices);else {
        var _d4 = this._positions.subarray(0, this._currentBatchSize * ii);

        t.bufferSubData(t.ARRAY_BUFFER, 0, _d4);
      }
      var i = 0,
          r = null,
          o = null,
          n = null,
          a = null,
          l = !1,
          c = !1,
          u = null,
          p = 0;

      for (var _d5 = 0, _g2 = this._currentBatchSize; _d5 < _g2; _d5++) {
        if (u = this._sprites[_d5], o = (h = u.getTexture()) == null ? void 0 : h.getBaseTexture(), a = u.getShader() || this._shader, l = n !== a, c = r !== o, (c || l) && (r && this._renderBatch(r, i, p), p = _d5, i = 0, r = o, l)) {
          n = a, e.setShader(n);

          var _7 = e.getCurrentRenderTarget().getProjectionMatrix().toArray();

          n.setUniform("u_projMatrix", _7), n.syncUniforms(), t.activeTexture(t.TEXTURE0);
        }

        i++;
      }

      r && this._renderBatch(r, i, p), this._currentBatchSize = 0, this._sprites = [];
    }
  }, {
    key: "_renderBatch",
    value: function _renderBatch(e, t, i) {
      if (t === 0) return;
      var r = this._renderer,
          o = r.getContext(),
          n = e.getGLTextureForRenderer(r);
      n || (n = r.getOrCreateGLTexture(e)), e.isDirty() && (r.updateTexture(e), e.setDirty(!1)), o.activeTexture(o.TEXTURE0 + e.getGLUnit()), o.bindTexture(o.TEXTURE_2D, n);
      var a = t * 6,
          l = i * 6 * 2;
      o.drawElements(o.TRIANGLES, a, o.UNSIGNED_SHORT, l);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var t = this._renderer.getContext();

      this._sprites.forEach(function (i) {
        i.dispose();
      }), this._vertexBuffer && (t.deleteBuffer(this._vertexBuffer), this._vertexBuffer = null), this._indexBuffer && (t.deleteBuffer(this._indexBuffer), this._indexBuffer = null), delete this._vertices, delete this._positions, delete this._colors, delete this._indices, _get(_getPrototypeOf(Za.prototype), "dispose", this).call(this);
    }
  }]);

  return Za;
}(ps);

var $a =
/*#__PURE__*/
function (_ms2) {
  _inherits($a, _ms2);

  function $a() {
    var _this34;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 800;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
    var i = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, $a);

    _this34 = _possibleConstructorReturn(this, _getPrototypeOf($a).call(this, e, t, i));
    _this34.type = U.WEBGL;
    _this34.maxTextureDimensions = null;
    _this34._type = U.WEBGL, _this34._onContextLost = _this34._onContextLost.bind(_assertThisInitialized(_assertThisInitialized(_this34))), _this34._onContextRestored = _this34._onContextRestored.bind(_assertThisInitialized(_assertThisInitialized(_this34))), _this34.setCanvas(_this34._options.canvas || Ae.createCanvas()), _this34.shaders = {
      default: new Ga(_assertThisInitialized(_assertThisInitialized(_this34)), void 0, void 0)
    }, _this34.renderers = {
      sprite: new Za(_assertThisInitialized(_assertThisInitialized(_this34)))
    };
    return _this34;
  }

  _createClass($a, [{
    key: "_onContextLost",
    value: function _onContextLost(e) {
      e.preventDefault(), A.warn(this.constructor.name, "WebGL context has been lost - trying to restore.");
    }
  }, {
    key: "_onContextCreationError",
    value: function _onContextCreationError(e) {
      e.preventDefault(), A.warn(this.constructor.name, "Failed to create WebGL context: ".concat(e.statusMessage || "Unknown error"));
    }
  }, {
    key: "_onContextRestored",
    value: function _onContextRestored() {
      A.warn(this.constructor.name, "WebGL context has been restored. Clearing all textures."), this._createContext(), this._setupContext(), this.emit("context-restored");
    }
  }, {
    key: "_onBeforeContext",
    value: function _onBeforeContext() {
      this._filterManager && this._filterManager.dispose(), this._filterManager = new ds(this), this._currentObjectRenderer = new ps(this);
    }
  }, {
    key: "setShader",
    value: function setShader(e) {
      this._currentShader = e, this._context.useProgram(e.getProgram()), this._setAttributesForShader(e);
    }
  }, {
    key: "setCanvas",
    value: function setCanvas(e) {
      this._canvas && this._removeContextEventListeners(), _get(_getPrototypeOf($a.prototype), "setCanvas", this).call(this, e), this._addContextEventListeners();
    }
  }, {
    key: "_addContextEventListeners",
    value: function _addContextEventListeners() {
      Aa(this._canvas) && (this._canvas.addEventListener("webglcontextlost", this._onContextLost), this._canvas.addEventListener("webglcontextrestored", this._onContextRestored), this._canvas.addEventListener("webglcontextcreationerror", this._onContextCreationError));
    }
  }, {
    key: "_removeContextEventListeners",
    value: function _removeContextEventListeners() {
      Aa(this._canvas) && (this._canvas.removeEventListener("webglcontextlost", this._onContextLost), this._canvas.removeEventListener("webglcontextrestored", this._onContextRestored), this._canvas.removeEventListener("webglcontextcreationerror", this._onContextCreationError));
    }
  }, {
    key: "_setAttributesForShader",
    value: function _setAttributesForShader(e) {
      if (!this._canvas) return;
      var t = this._context,
          i = e.getAttributes(),
          r = e.getAttributeLocations();
      i.forEach(function (o) {
        var n = r[o];
        t.enableVertexAttribArray(n);
      });
    }
  }, {
    key: "_createContext",
    value: function _createContext() {
      if (!this._canvas) return;
      var e = Ae.glGet(this._canvas);
      return this._options.debug && Vu(e), this._options.debug && (e = new eo(e), e = new Hu(e)), this.id = $a.contextId++, this._context = e, this._maxTextureSize = e.getParameter(e.MAX_TEXTURE_SIZE), this.emit("context", e), e;
    }
  }, {
    key: "_setupContext",
    value: function _setupContext() {
      var e = this._context;
      e.disable(e.DEPTH_TEST), e.disable(e.CULL_FACE), e.enable(e.BLEND), e.blendFunc(e.ONE, e.ONE_MINUS_SRC_ALPHA), this._defaultRenderTarget = new Wt(this, this._width, this._height, this._pixelRatio, !0), this.setRenderTarget(this._defaultRenderTarget), this._getMaxPrecision();
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this._context;
    }
  }, {
    key: "_getMaxPrecision",
    value: function _getMaxPrecision() {
      var e = this._context,
          t = e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT);
      this._maxFloatPrecision = (t == null ? void 0 : t.precision) !== 0 ? dt.High : dt.Medium;
      var i = e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_INT);
      this._maxIntPrecision = (i == null ? void 0 : i.rangeMax) !== 0 ? dt.High : dt.Low;
    }
  }, {
    key: "resizeTo",
    value: function resizeTo(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      _get(_getPrototypeOf($a.prototype), "resizeTo", this).call(this, e, t), this._currentRenderTarget && this._currentRenderTarget.resizeTo(e), this._context = Ae.glResize(this._context, e);
    }
  }, {
    key: "setRenderTarget",
    value: function setRenderTarget() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._defaultRenderTarget;
      this._currentRenderTarget = e, this._currentRenderTarget.activate();
    }
  }, {
    key: "setObjectRenderer",
    value: function setObjectRenderer(e) {
      this._currentObjectRenderer.stop(), this._currentObjectRenderer = e, this._currentObjectRenderer.start();
    }
  }, {
    key: "render",
    value: function render(e) {
      this.setRenderTarget(this._defaultRenderTarget), this._defaultRenderTarget.clear(this._clearColor);
      var t = e.getParent();
      e.setParent(new Fi()), e.updateTransform(), t && e.setParent(t), this.renderDisplayObject(e, this._defaultRenderTarget);
    }
  }, {
    key: "renderDisplayObject",
    value: function renderDisplayObject(e, t) {
      this.setRenderTarget(t), this._filterManager.setFilterStack(t.getFilterStack()), e.renderWebGL(this), this._currentObjectRenderer.flush();
    }
  }, {
    key: "clear",
    value: function clear() {
      var e = this._context;
      e.clearColor.apply(e, this._clearColor.toGLColor), e.clear(e.COLOR_BUFFER_BIT);
    }
  }, {
    key: "save",
    value: function save() {
      return {
        renderTarget: this._currentRenderTarget,
        objectRenderer: this._currentObjectRenderer,
        filterStack: this._filterManager.getFilterStack()
      };
    }
  }, {
    key: "restore",
    value: function restore(e) {
      this.setRenderTarget(e.renderTarget), this._filterManager.setFilterStack(e.filterStack), this._currentObjectRenderer = e.objectRenderer;
    }
  }, {
    key: "getOrCreateGLTexture",
    value: function getOrCreateGLTexture(e) {
      var t = this._context,
          i = e.getGLTextureForRenderer(this);
      return i || (i = t.createTexture(), e.setGLTextureForRenderer(i, this)), i;
    }
  }, {
    key: "updateTexture",
    value: function updateTexture(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = e.getSource(),
          r = this._context,
          o = e.getGLUnit(),
          n = this.getOrCreateGLTexture(e);
      r.activeTexture(r.TEXTURE0 + o), r.bindTexture(r.TEXTURE_2D, n), r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), t && i && Ae.glTexImage(r, i), e.isMipMappingEnabled() ? r.generateMipmap(r.TEXTURE_2D) : (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, e.getGLRepeat(r, "x")), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, e.getGLRepeat(r, "y"))), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, e.getGLFilter(r, "min")), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, e.getGLFilter(r, "mag")), r.activeTexture(r.TEXTURE0);
    }
  }, {
    key: "getMaxDimensions",
    value: function getMaxDimensions() {
      return this.maxTextureDimensions || (this.maxTextureDimensions = Ae.glMaxTexture(this._context)), this.maxTextureDimensions;
    }
  }, {
    key: "getCurrentRenderTarget",
    value: function getCurrentRenderTarget() {
      return this._currentRenderTarget;
    }
  }, {
    key: "getCurrentObjectRenderer",
    value: function getCurrentObjectRenderer() {
      return this._currentObjectRenderer;
    }
  }, {
    key: "getMaxFloatPrecision",
    value: function getMaxFloatPrecision() {
      return this._maxFloatPrecision;
    }
  }, {
    key: "getMaxIntPrecision",
    value: function getMaxIntPrecision() {
      return this._maxIntPrecision;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._filterManager.dispose(), this._currentObjectRenderer.dispose(), this._defaultRenderTarget.dispose();

      for (var i in this.shaders) {
        this.shaders[i].dispose(), delete this.shaders[i];
      }

      this._removeContextEventListeners();

      var t = this._context.getExtension("WEBGL_lose_context");

      t && t.loseContext();
    }
  }]);

  return $a;
}(ms),
    to = $a;

to.contextId = 0;

var Xp = function Xp() {
  return [new B(0, 0), new B(1, 0), new B(1, 1), new B(0, 1)];
},
    Qp = function Qp(s, e, t) {
  var _s2 = _slicedToArray(s, 4),
      i = _s2[0],
      r = _s2[1],
      o = _s2[2],
      n = _s2[3];

  return i.x = e.x / t.width, i.y = e.y / t.height, r.x = (e.x + e.width) / t.width, r.y = e.y / t.height, o.x = (e.x + e.width) / t.width, o.y = (e.y + e.height) / t.height, n.x = e.x / t.width, n.y = (e.y + e.height) / t.height, s;
},
    Ja = {
  create: Xp,
  updateViaFrames: Qp
};

var ni =
/*#__PURE__*/
function (_We4) {
  _inherits(ni, _We4);

  function ni(e, t) {
    var _this35;

    _classCallCheck(this, ni);

    _this35 = _possibleConstructorReturn(this, _getPrototypeOf(ni).call(this));
    if (!(e instanceof xe)) throw new Error("`baseTexture` should be an instance of BaseTexture");
    _this35._uvs = Ja.create(), _this35._frame = t ? t.clone() : new le(0, 0, 1, 1), _this35._frameLocked = Boolean(t), _this35._onBaseTextureLoaded = _this35._onBaseTextureLoaded.bind(_assertThisInitialized(_assertThisInitialized(_this35))), _this35._onBaseTextureUpdated = _this35._onBaseTextureUpdated.bind(_assertThisInitialized(_assertThisInitialized(_this35))), _this35.setBaseTexture(e);
    return _this35;
  }

  _createClass(ni, [{
    key: "_onBaseTextureLoaded",
    value: function _onBaseTextureLoaded() {
      if (!this._frameLocked) {
        var _e10 = this._baseTexture.getFrame().clone();

        this.setFrame(_e10);
      }

      this._baseTexture.on("update", this._onBaseTextureUpdated);
    }
  }, {
    key: "_onBaseTextureUpdated",
    value: function _onBaseTextureUpdated() {
      var _this$_baseTexture$ge = this._baseTexture.getFrame(),
          e = _this$_baseTexture$ge.width,
          t = _this$_baseTexture$ge.height;

      this._frame.width = e, this._frame.height = t, this.emit("update");
    }
  }, {
    key: "_updateUVs",
    value: function _updateUVs() {
      this._uvs = Ja.updateViaFrames(this._uvs, this._frame, this._baseTexture.getFrame());
    }
  }, {
    key: "getBaseTexture",
    value: function getBaseTexture() {
      return this._baseTexture;
    }
  }, {
    key: "setBaseTexture",
    value: function setBaseTexture(e) {
      if (this._baseTexture = e, !this._baseTexture.isLoaded()) this._baseTexture.once("loaded", this._onBaseTextureLoaded);else {
        var _e$getFrame = e.getFrame(),
            _t8 = _e$getFrame.width,
            i = _e$getFrame.height;

        this._frameLocked || (this._frame = new le(0, 0, _t8, i)), this._onBaseTextureLoaded();
      }
    }
  }, {
    key: "getFrame",
    value: function getFrame() {
      return this._frame;
    }
  }, {
    key: "setFrame",
    value: function setFrame(e) {
      this._frame = e, this._updateUVs();
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this._frame.width;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this._frame.height;
    }
  }, {
    key: "getUVs",
    value: function getUVs() {
      return this._uvs;
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return new B(this._frame.width, this._frame.height);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      e && this._baseTexture.dispose();
    }
  }], [{
    key: "fromImage",
    value: function fromImage(e) {
      var t = new xe(e);
      return new ni(t);
    }
  }, {
    key: "fromCanvas",
    value: function fromCanvas(e) {
      var t = new xe(e);
      return new ni(t);
    }
  }]);

  return ni;
}(We);

var gs = function gs(s) {
  return s._type === U.WEBGL;
},
    fs =
/*#__PURE__*/
function (_ni) {
  _inherits(fs, _ni);

  function fs(e) {
    var _this36;

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, fs);

    _this36 = _possibleConstructorReturn(this, _getPrototypeOf(fs).call(this, new xe(), new le(0, 0, t, i)));
    _this36._loaded = !0, _this36._width = t, _this36._height = i, _this36._pixelRatio = r, _this36._renderer = e, _this36._setupFilterManager(), _this36._setupBuffer(), _this36.setBaseTexture(_this36._renderTarget.getBaseTexture()), _this36._updateUVs();
    return _this36;
  }

  _createClass(fs, [{
    key: "_setupFilterManager",
    value: function _setupFilterManager() {
      this._filterManager && this._filterManager.dispose(), gs(this._renderer) ? this._filterManager = new ds(this._renderer) : this._filterManager = new Ei(this._renderer), this._filterManager.resizeTo(new B(this._width, this._height));
    }
  }, {
    key: "_setupBuffer",
    value: function _setupBuffer() {
      this._renderTarget && this._renderTarget.dispose(), gs(this._renderer) ? this._renderTarget = new Wt(this._renderer, this._width, this._height, this._pixelRatio) : this._renderTarget = new Gt(this._width, this._height, this._pixelRatio);
    }
  }, {
    key: "clear",
    value: function clear(e) {
      this._renderTarget.clear(e);
    }
  }, {
    key: "resizeTo",
    value: function resizeTo(e) {
      this._width === e.x && this._height === e.y || (this._width = e.x, this._height = e.y, this._frame.width = e.x, this._frame.height = e.y, this._renderTarget.resizeTo(e), this._filterManager.resizeTo(e));
    }
  }, {
    key: "render",
    value: function render(e) {
      gs(this._renderer) ? this._renderWebGL(e) : this._renderCanvas(e);
    }
  }, {
    key: "_renderWebGL",
    value: function _renderWebGL(e) {
      if (!gs(this._renderer)) return;
      this._renderTarget.activate(), e.getWorldTransform().reset(), e.getChildren().forEach(function (i) {
        i.updateTransform();
      });

      var t = this._renderer.getFilterManager();

      this._renderer.setFilterManager(this._filterManager), this._renderer.renderDisplayObject(e, this._renderTarget), this._renderer.setFilterManager(t);
    }
  }, {
    key: "_renderCanvas",
    value: function _renderCanvas(e) {
      if (gs(this._renderer)) return;
      e.getWorldTransform().reset(), e.getChildren().forEach(function (i) {
        i.updateTransform();
      });

      var t = this._renderer.getFilterManager();

      this._renderer.setFilterManager(this._filterManager), this._renderer.renderDisplayObject(e, this._renderTarget), this._renderer.setFilterManager(t);
    }
  }, {
    key: "getRenderTarget",
    value: function getRenderTarget() {
      return this._renderTarget;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._renderTarget.dispose(), this._filterManager.dispose(), _get(_getPrototypeOf(fs.prototype), "dispose", this).call(this);
    }
  }]);

  return fs;
}(ni);

var ys = {};
we(ys, {
  Base64: function Base64() {
    return bt;
  },
  Color: function Color() {
    return R;
  },
  ColorMatrix: function ColorMatrix() {
    return ls;
  },
  Configurable: function Configurable() {
    return V;
  },
  Constants: function Constants() {
    return Xe;
  },
  CubicBezierCurve: function CubicBezierCurve() {
    return nl;
  },
  Engine: function Engine() {
    return k;
  },
  EventEmitter: function EventEmitter() {
    return We;
  },
  Events: function Events() {
    return lr;
  },
  FreeLicenseChecker: function FreeLicenseChecker() {
    return ol;
  },
  GLUtils: function GLUtils() {
    return Ti;
  },
  LicenseChecker: function LicenseChecker() {
    return so;
  },
  Log: function Log() {
    return A;
  },
  Matrix: function Matrix() {
    return Ze;
  },
  Range: function Range() {
    return al;
  },
  Rectangle: function Rectangle() {
    return le;
  },
  Utils: function Utils() {
    return T;
  },
  Vector2: function Vector2() {
    return B;
  },
  Vector3: function Vector3() {
    return ll;
  },
  cancelAnimationFrame: function cancelAnimationFrame() {
    return ci;
  },
  requestAnimationFrame: function requestAnimationFrame() {
    return Ht;
  }
});
var lr = {
  EXPORT: "export",
  CLOSE: "close",
  OPERATION_CREATED: "operation:created",
  OPERATION_UPDATED: "operation:updated",
  OPERATION_REMOVED: "operation:removed",
  EDITOR_READY: "editor:ready",
  WINDOW_RESIZE: "window:resize",
  ZOOM_DONE: "editor:zoom_done",
  HISTORY_UNDO: "history:undo",
  HISTORY_UPDATED: "history:update",
  FEATURES_DISABLED: "editor:features:disabled",
  FEATURES_ENABLED: "editor:features:enabled",
  FEATURES_UPDATED: "editor:features:updated",
  TRANSFORM_REAPPLY_RATIO: "transform:reapply_ratio"
};
var Vt = {
  DEFAULTS: {
    FILTERS: [{
      identifier: "imgly_filters_duotone",
      defaultName: "DuoTone",
      assetFileName: "duotone",
      filters: [{
        identifier: "imgly_duotone_desert",
        defaultName: "Desert",
        lightColor: "#e1de9a",
        darkColor: "#cb2129"
      }, {
        identifier: "imgly_duotone_peach",
        defaultName: "Peach",
        lightColor: "#e9abb8",
        darkColor: "#0040ff"
      }, {
        identifier: "imgly_duotone_clash",
        defaultName: "Clash",
        lightColor: "#f41a0f",
        darkColor: "#23007c"
      }, {
        identifier: "imgly_duotone_plum",
        defaultName: "Plum",
        lightColor: "#74d7ff",
        darkColor: "#23007c"
      }, {
        identifier: "imgly_duotone_breezy",
        defaultName: "Breezy",
        lightColor: "#68fdff",
        darkColor: "#c20000"
      }, {
        identifier: "imgly_duotone_deepblue",
        defaultName: "Deep Blue",
        lightColor: "#2de9eb",
        darkColor: "#58007c"
      }, {
        identifier: "imgly_duotone_frog",
        defaultName: "Frog",
        lightColor: "#5bff60",
        darkColor: "#7f23a9"
      }, {
        identifier: "imgly_duotone_sunset",
        defaultName: "Sunset",
        lightColor: "#f8ea46",
        darkColor: "#c400be"
      }]
    }, {
      identifier: "imgly_filters_bw",
      assetFileName: "b&w",
      defaultName: "Black & White",
      filters: [{
        identifier: "imgly_lut_ad1920",
        defaultName: "1920 A.D.",
        lutImage: "filters/imgly_lut_ad1920_5_5_128.png"
      }, {
        identifier: "imgly_lut_bw",
        defaultName: "Greyed",
        lutImage: "filters/imgly_lut_bw_5_5_128.png"
      }, {
        identifier: "imgly_lut_x400",
        defaultName: "Dusty",
        lutImage: "filters/imgly_lut_dusty_5_5_128.png"
      }, {
        identifier: "imgly_lut_litho",
        defaultName: "Litho",
        lutImage: "filters/imgly_lut_litho_5_5_128.png"
      }, {
        identifier: "imgly_lut_sepiahigh",
        defaultName: "Sepia",
        lutImage: "filters/imgly_lut_sepia_5_5_128.png"
      }, {
        identifier: "imgly_lut_plate",
        defaultName: "Weathered",
        lutImage: "filters/imgly_lut_weathered_5_5_128.png"
      }, {
        identifier: "imgly_lut_sin",
        defaultName: "Hard Stuff",
        lutImage: "filters/imgly_lut_hard_stuff_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }]
    }, {
      identifier: "imgly_filters_retro",
      assetFileName: "vintage",
      defaultName: "Vintage",
      filters: [{
        identifier: "imgly_lut_blues",
        defaultName: "Polaroid",
        lutImage: "filters/imgly_lut_polaroid_5_5_128.png"
      }, {
        identifier: "imgly_lut_front",
        defaultName: "Sunny 70s",
        lutImage: "filters/imgly_lut_sunny_70s_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }, {
        identifier: "imgly_lut_texas",
        defaultName: "Oldtimer",
        lutImage: "filters/imgly_lut_oldtimer_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }, {
        identifier: "imgly_lut_celsius",
        defaultName: "Inferno",
        lutImage: "filters/imgly_lut_inferno_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }, {
        identifier: "imgly_lut_cool",
        defaultName: "Snappy",
        lutImage: "filters/imgly_lut_snappy_5_5_128.png"
      }]
    }, {
      identifier: "imgly_filters_analog",
      assetFileName: "smooth",
      defaultName: "Smooth",
      filters: [{
        identifier: "imgly_lut_chest",
        defaultName: "Chestnut",
        lutImage: "filters/imgly_lut_chestnut_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }, {
        identifier: "imgly_lut_winter",
        defaultName: "Softly",
        lutImage: "filters/imgly_lut_softly_5_5_128.png"
      }, {
        identifier: "imgly_lut_kdynamic",
        defaultName: "Pebble",
        lutImage: "filters/imgly_lut_pebble_5_5_128.png"
      }, {
        identifier: "imgly_lut_fall",
        defaultName: "Moss",
        lutImage: "filters/imgly_lut_moss_5_5_128.png"
      }, {
        identifier: "imgly_lut_lenin",
        defaultName: "Lemon",
        lutImage: "filters/imgly_lut_lemon_5_5_128.png"
      }, {
        identifier: "imgly_lut_pola669",
        defaultName: "Green Gap",
        lutImage: "filters/imgly_lut_green_gap_5_5_128.png"
      }]
    }, {
      identifier: "imgly_filters_winter",
      assetFileName: "cold",
      defaultName: "Cold",
      filters: [{
        identifier: "imgly_lut_elder",
        defaultName: "Colla",
        lutImage: "filters/imgly_lut_colla_5_5_128.png"
      }, {
        identifier: "imgly_lut_orchid",
        defaultName: "Solanus",
        lutImage: "filters/imgly_lut_solanus_5_5_128.png"
      }, {
        identifier: "imgly_lut_bleached",
        defaultName: "Kalmen",
        lutImage: "filters/imgly_lut_kalmen_5_5_128.png"
      }, {
        identifier: "imgly_lut_bleachedblue",
        defaultName: "Joran",
        lutImage: "filters/imgly_lut_joran_5_5_128.png"
      }, {
        identifier: "imgly_lut_breeze",
        defaultName: "Levante",
        lutImage: "filters/imgly_lut_levante_5_5_128.png"
      }, {
        identifier: "imgly_lut_blueshadows",
        defaultName: "Zephyr",
        lutImage: "filters/imgly_lut_zephyr_5_5_128.png"
      }]
    }, {
      identifier: "imgly_filters_summer",
      assetFileName: "warm",
      defaultName: "Warm",
      filters: [{
        identifier: "imgly_lut_sunset",
        defaultName: "Golden",
        lutImage: "filters/imgly_lut_golden_5_5_128.png"
      }, {
        identifier: "imgly_lut_eighties",
        defaultName: "Low Fire",
        lutImage: "filters/imgly_lut_low_fire_5_5_128.png"
      }, {
        identifier: "imgly_lut_evening",
        defaultName: "Sunrise",
        lutImage: "filters/imgly_lut_sunrise_5_5_128.png"
      }, {
        identifier: "imgly_lut_k2",
        defaultName: "Flat Black",
        lutImage: "filters/imgly_lut_flat_black_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }, {
        identifier: "imgly_lut_nogreen",
        defaultName: "Pumpkin",
        lutImage: "filters/imgly_lut_pumpkin_5_5_128.png"
      }]
    }, {
      identifier: "imgly_filters_legacy",
      defaultName: "Legacy",
      assetFileName: "legacy",
      filters: [{
        identifier: "imgly_lut_ancient",
        defaultName: "Ancient",
        lutImage: "filters/imgly_lut_ancient_5_5_128.png"
      }, {
        identifier: "imgly_lut_cottoncandy",
        defaultName: "Candy",
        lutImage: "filters/imgly_lut_cottoncandy_5_5_128.png"
      }, {
        identifier: "imgly_lut_classic",
        defaultName: "Classic",
        lutImage: "filters/imgly_lut_classic_5_5_128.png"
      }, {
        identifier: "imgly_lut_colorful",
        defaultName: "Colorful",
        lutImage: "filters/imgly_lut_colorful_5_5_128.png"
      }, {
        identifier: "imgly_lut_creamy",
        defaultName: "Creamy",
        lutImage: "filters/imgly_lut_creamy_5_5_128.png"
      }, {
        identifier: "imgly_lut_fixie",
        defaultName: "Fixie",
        lutImage: "filters/imgly_lut_fixie_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }, {
        identifier: "imgly_lut_food",
        defaultName: "Food",
        lutImage: "filters/imgly_lut_food_5_5_128.png"
      }, {
        identifier: "imgly_lut_fridge",
        defaultName: "Fridge",
        lutImage: "filters/imgly_lut_fridge_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }, {
        identifier: "imgly_lut_glam",
        defaultName: "Glam",
        lutImage: "filters/imgly_lut_glam_5_5_128.png"
      }, {
        identifier: "imgly_lut_gobblin",
        defaultName: "Gobblin",
        lutImage: "filters/imgly_lut_gobblin_5_5_128.png"
      }, {
        identifier: "imgly_lut_highcontrast",
        defaultName: "Hicon",
        lutImage: "filters/imgly_lut_highcontrast_5_5_128.png"
      }, {
        identifier: "imgly_lut_highcarb",
        defaultName: "High Carb",
        lutImage: "filters/imgly_lut_highcarb_5_5_128.png"
      }, {
        identifier: "imgly_lut_k1",
        defaultName: "K1",
        lutImage: "filters/imgly_lut_k1_5_5_128.png"
      }, {
        identifier: "imgly_lut_k6",
        defaultName: "K6",
        lutImage: "filters/imgly_lut_k6_5_5_128.png"
      }, {
        identifier: "imgly_lut_keen",
        defaultName: "Keen",
        lutImage: "filters/imgly_lut_keen_5_5_128.png"
      }, {
        identifier: "imgly_lut_lomo",
        defaultName: "Lomo",
        lutImage: "filters/imgly_lut_lomo_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }, {
        identifier: "imgly_lut_lomo100",
        defaultName: "Lomo 100",
        lutImage: "filters/imgly_lut_lomo100_5_5_128.png"
      }, {
        identifier: "imgly_lut_lucid",
        defaultName: "Lucid",
        lutImage: "filters/imgly_lut_lucid_5_5_128.png"
      }, {
        identifier: "imgly_lut_mellow",
        defaultName: "Mellow",
        lutImage: "filters/imgly_lut_mellow_8_8_512.png",
        resolution: 512,
        horizontalTileCount: 8,
        verticalTileCount: 8
      }, {
        identifier: "imgly_lut_neat",
        defaultName: "Neat",
        lutImage: "filters/imgly_lut_neat_5_5_128.png"
      }, {
        identifier: "imgly_lut_pale",
        defaultName: "Pale",
        lutImage: "filters/imgly_lut_pale_5_5_128.png"
      }, {
        identifier: "imgly_lut_pitched",
        defaultName: "Pitched",
        lutImage: "filters/imgly_lut_pitched_5_5_128.png"
      }, {
        identifier: "imgly_lut_polasx",
        defaultName: "Pola SX",
        lutImage: "filters/imgly_lut_polasx_5_5_128.png"
      }, {
        identifier: "imgly_lut_pro400",
        defaultName: "Pro 400",
        lutImage: "filters/imgly_lut_pro400_5_5_128.png"
      }, {
        identifier: "imgly_lut_quozi",
        defaultName: "Quozi",
        lutImage: "filters/imgly_lut_quozi_5_5_128.png"
      }, {
        identifier: "imgly_lut_settled",
        defaultName: "Settled",
        lutImage: "filters/imgly_lut_settled_5_5_128.png"
      }, {
        identifier: "imgly_lut_seventies",
        defaultName: "Seventies",
        lutImage: "filters/imgly_lut_seventies_5_5_128.png"
      }, {
        identifier: "imgly_lut_soft",
        defaultName: "Soft",
        lutImage: "filters/imgly_lut_soft_5_5_128.png"
      }, {
        identifier: "imgly_lut_steel",
        defaultName: "Steel",
        lutImage: "filters/imgly_lut_steel_5_5_128.png"
      }, {
        identifier: "imgly_lut_summer",
        defaultName: "Summer",
        lutImage: "filters/imgly_lut_summer_5_5_128.png"
      }, {
        identifier: "imgly_lut_tender",
        defaultName: "Tender",
        lutImage: "filters/imgly_lut_tender_5_5_128.png"
      }, {
        identifier: "imgly_lut_twilight",
        defaultName: "Twilight",
        lutImage: "filters/imgly_lut_twilight_5_5_128.png"
      }]
    }],
    OVERLAYS: [{
      identifier: "imgly_overlay_golden",
      defaultName: "Golden",
      image: "overlays/imgly_overlay_golden.jpg",
      thumbnail: "overlays/imgly_overlay_golden_thumb.jpg",
      blendMode: "lighten"
    }, {
      identifier: "imgly_overlay_bokeh",
      defaultName: "Bokeh",
      image: "overlays/imgly_overlay_bokeh.jpg",
      thumbnail: "overlays/imgly_overlay_bokeh_thumb.jpg",
      blendMode: "lighten"
    }, {
      identifier: "imgly_overlay_hearts",
      defaultName: "Hearts",
      image: "overlays/imgly_overlay_hearts.jpg",
      thumbnail: "overlays/imgly_overlay_hearts_thumb.jpg",
      blendMode: "screen"
    }, {
      identifier: "imgly_overlay_lightleak1",
      defaultName: "Light Leak",
      image: "overlays/imgly_overlay_lightleak1.jpg",
      thumbnail: "overlays/imgly_overlay_lightleak1_thumb.jpg",
      blendMode: "screen"
    }, {
      identifier: "imgly_overlay_lightleak2",
      defaultName: "Light Leak 2",
      image: "overlays/imgly_overlay_lightleak2.jpg",
      thumbnail: "overlays/imgly_overlay_lightleak2_thumb.jpg",
      blendMode: "lighten"
    }, {
      identifier: "imgly_overlay_rain",
      defaultName: "Rain",
      image: "overlays/imgly_overlay_rain.jpg",
      thumbnail: "overlays/imgly_overlay_rain_thumb.jpg",
      blendMode: "overlay"
    }, {
      identifier: "imgly_overlay_wood",
      defaultName: "Wood",
      image: "overlays/imgly_overlay_wood.jpg",
      thumbnail: "overlays/imgly_overlay_wood_thumb.jpg",
      blendMode: "multiply"
    }, {
      identifier: "imgly_overlay_mosaic",
      defaultName: "Mosaic",
      image: "overlays/imgly_overlay_mosaic.jpg",
      thumbnail: "overlays/imgly_overlay_mosaic_thumb.jpg",
      blendMode: "multiply"
    }, {
      identifier: "imgly_overlay_chop",
      defaultName: "Chop",
      image: "overlays/imgly_overlay_chop.jpg",
      thumbnail: "overlays/imgly_overlay_chop_thumb.jpg",
      blendMode: "multiply"
    }, {
      identifier: "imgly_overlay_vintage",
      defaultName: "Vintage",
      image: "overlays/imgly_overlay_vintage.jpg",
      thumbnail: "overlays/imgly_overlay_vintage_thumb.jpg",
      blendMode: "darken"
    }, {
      identifier: "imgly_overlay_metal",
      defaultName: "Metal",
      image: "overlays/imgly_overlay_metal.jpg",
      thumbnail: "overlays/imgly_overlay_metal_thumb.jpg",
      blendMode: "overlay"
    }, {
      identifier: "imgly_overlay_paper",
      defaultName: "Paper",
      image: "overlays/imgly_overlay_paper.jpg",
      thumbnail: "overlays/imgly_overlay_paper_thumb.jpg",
      blendMode: "multiply"
    }, {
      identifier: "imgly_overlay_painting",
      defaultName: "Painting",
      image: "overlays/imgly_overlay_painting.jpg",
      thumbnail: "overlays/imgly_overlay_painting_thumb.jpg",
      blendMode: "overlay"
    }, {
      identifier: "imgly_overlay_grain",
      defaultName: "Grain",
      image: "overlays/imgly_overlay_grain.jpg",
      thumbnail: "overlays/imgly_overlay_grain_thumb.jpg",
      blendMode: "overlay"
    }, {
      identifier: "imgly_overlay_clouds",
      defaultName: "Clouds",
      image: "overlays/imgly_overlay_clouds.jpg",
      thumbnail: "overlays/imgly_overlay_clouds_thumb.jpg",
      blendMode: "softLight"
    }, {
      identifier: "imgly_overlay_wall1",
      defaultName: "Wall",
      image: "overlays/imgly_overlay_wall1.jpg",
      thumbnail: "overlays/imgly_overlay_wall1_thumb.jpg",
      blendMode: "lighten"
    }, {
      identifier: "imgly_overlay_wall2",
      defaultName: "Wall 2",
      image: "overlays/imgly_overlay_wall2.jpg",
      thumbnail: "overlays/imgly_overlay_wall2_thumb.jpg",
      blendMode: "overlay"
    }],
    FRAME_CATEGORIES: [{
      identifier: "imgly_frame_generic",
      defaultName: "Generic",
      metaData: {
        backgroundImage: "frames/generic.png"
      },
      frames: [{
        identifier: "imgly_frame_dia",
        defaultName: "Dia",
        layoutMode: "horizontal-inside",
        thumbnail: "frames/imgly_frame_dia/imgly_frame_dia_thumb.png",
        imageGroups: {
          top: {
            mid: {
              image: "frames/imgly_frame_dia/imgly_frame_dia_top.png",
              mode: "repeat"
            }
          },
          left: {
            start: "frames/imgly_frame_dia/imgly_frame_dia_top_corner_left.png",
            mid: "frames/imgly_frame_dia/imgly_frame_dia_left.png",
            end: "frames/imgly_frame_dia/imgly_frame_dia_bottom_corner_left.png"
          },
          right: {
            start: "frames/imgly_frame_dia/imgly_frame_dia_top_corner_right.png",
            mid: "frames/imgly_frame_dia/imgly_frame_dia_right.png",
            end: "frames/imgly_frame_dia/imgly_frame_dia_bottom_corner_right.png"
          },
          bottom: {
            mid: {
              image: "frames/imgly_frame_dia/imgly_frame_dia_bottom.png",
              mode: "repeat"
            }
          }
        }
      }, {
        identifier: "imgly_frame_art_decor",
        defaultName: "Art Decor",
        tintable: !0,
        layoutMode: "horizontal-inside",
        thumbnail: "frames/imgly_frame_art_decor/imgly_frame_art_decor_thumb.png",
        imageGroups: {
          top: {
            start: "frames/imgly_frame_art_decor/imgly_frame_art_decor_top_corner_left.png",
            mid: {
              image: "frames/imgly_frame_art_decor/imgly_frame_art_decor_top.png",
              mode: "stretch"
            },
            end: "frames/imgly_frame_art_decor/imgly_frame_art_decor_top_corner_right.png"
          },
          left: {
            mid: {
              image: "frames/imgly_frame_art_decor/imgly_frame_art_decor_left.png",
              mode: "stretch"
            }
          },
          right: {
            mid: {
              image: "frames/imgly_frame_art_decor/imgly_frame_art_decor_right.png",
              mode: "stretch"
            }
          },
          bottom: {
            start: "frames/imgly_frame_art_decor/imgly_frame_art_decor_bottom_corner_left.png",
            mid: {
              image: "frames/imgly_frame_art_decor/imgly_frame_art_decor_bottom.png",
              mode: "stretch"
            },
            end: "frames/imgly_frame_art_decor/imgly_frame_art_decor_bottom_corner_right.png"
          }
        }
      }, {
        identifier: "imgly_frame_black_passepartout",
        defaultName: "Black Passepartout",
        layoutMode: "horizontal-inside",
        thumbnail: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_thumb.png",
        imageGroups: {
          top: {
            start: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top_corner_left.png",
            mid: {
              image: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top.png",
              mode: "stretch"
            },
            end: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top_corner_right.png"
          },
          left: {
            mid: {
              image: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_left.png",
              mode: "stretch"
            }
          },
          right: {
            mid: {
              image: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_right.png",
              mode: "stretch"
            }
          },
          bottom: {
            start: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom_corner_left.png",
            mid: {
              image: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom.png",
              mode: "stretch"
            },
            end: "frames/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom_corner_right.png"
          }
        }
      }, {
        identifier: "imgly_frame_lowpoly_shadow",
        defaultName: "Low Poly",
        layoutMode: "horizontal-inside",
        thumbnail: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_thumb.png",
        imageGroups: {
          top: {
            start: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top_corner_left.png",
            mid: {
              image: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top.png",
              mode: "stretch"
            },
            end: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top_corner_right.png"
          },
          left: {
            mid: {
              image: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_left.png",
              mode: "stretch"
            }
          },
          right: {
            mid: {
              image: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_right.png",
              mode: "stretch"
            }
          },
          bottom: {
            start: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom_corner_left.png",
            mid: {
              image: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom.png",
              mode: "stretch"
            },
            end: "frames/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom_corner_right.png"
          }
        }
      }, {
        identifier: "imgly_frame_wood_passepartout",
        defaultName: "Wood Passepartout",
        layoutMode: "horizontal-inside",
        thumbnail: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_thumb.png",
        imageGroups: {
          top: {
            start: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top_corner_left.png",
            mid: {
              image: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top.png",
              mode: "stretch"
            },
            end: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top_corner_right.png"
          },
          left: {
            mid: {
              image: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_left.png",
              mode: "stretch"
            }
          },
          right: {
            mid: {
              image: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_right.png",
              mode: "stretch"
            }
          },
          bottom: {
            start: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom_corner_left.png",
            mid: {
              image: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom.png",
              mode: "stretch"
            },
            end: "frames/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom_corner_right.png"
          }
        }
      }]
    }],
    STICKER_CATEGORIES: [{
      identifier: "imgly_sticker_emoticons",
      defaultName: "Emoticons",
      metaData: {
        backgroundImage: "stickers/emoticons/background.png"
      },
      stickers: [{
        identifier: "imgly_sticker_emoticons_alien",
        defaultName: "Alien",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_alien.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_alien.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_alien.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_alien.png"],
            width: 1e3,
            height: 935
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_angel",
        defaultName: "Angel",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_angel.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_angel.png"],
            width: 62,
            height: 64
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_angel.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_angel.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_angry",
        defaultName: "Angry",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_angry.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_angry.png"],
            width: 62,
            height: 62
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_angry.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_angry.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_anxious",
        defaultName: "Anxious",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_anxious.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_anxious.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_anxious.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_anxious.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_asleep",
        defaultName: "Asleep",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_asleep.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_asleep.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_asleep.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_asleep.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_attention",
        defaultName: "Attention",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_attention.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_attention.png"],
            width: 62,
            height: 60
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_attention.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_attention.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_baby_chicken",
        defaultName: "Baby Chicken",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_baby_chicken.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_baby_chicken.png"],
            width: 61,
            height: 42
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_baby_chicken.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_baby_chicken.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_batman",
        defaultName: "Batman",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_batman.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_batman.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_batman.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_batman.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_beer",
        defaultName: "Beer",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_beer.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_beer.png"],
            width: 62,
            height: 59
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_beer.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_beer.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_blush",
        defaultName: "Blush",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_blush.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_blush.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_blush.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_blush.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_boxer",
        defaultName: "Boxer",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_boxer.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_boxer.png"],
            width: 62,
            height: 62
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_boxer.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_boxer.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_business",
        defaultName: "Business",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_business.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_business.png"],
            width: 60,
            height: 63
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_business.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_business.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_chicken",
        defaultName: "Chicken",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_chicken.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_chicken.png"],
            width: 63,
            height: 55
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_chicken.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_chicken.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_cool",
        defaultName: "Cool",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_cool.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_cool.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_cool.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_cool.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_cry",
        defaultName: "Cry",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_cry.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_cry.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_cry.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_cry.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_deceased",
        defaultName: "Deceased",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_deceased.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_deceased.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_deceased.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_deceased.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_devil",
        defaultName: "Devil",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_devil.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_devil.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_devil.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_devil.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_duckface",
        defaultName: "Duckface",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_duckface.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_duckface.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_duckface.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_duckface.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_furious",
        defaultName: "Furious",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_furious.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_furious.png"],
            width: 62,
            height: 61
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_furious.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_furious.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_grin",
        defaultName: "Grin",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_grin.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_grin.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_grin.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_grin.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_guitar",
        defaultName: "Guitar",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_guitar.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_guitar.png"],
            width: 64,
            height: 60
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_guitar.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_guitar.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_harry_potter",
        defaultName: "Harry Potter",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_harry_potter.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_harry_potter.png"],
            width: 64,
            height: 62
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_harry_potter.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_harry_potter.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_hippie",
        defaultName: "Hippie",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_hippie.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_hippie.png"],
            width: 62,
            height: 62
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_hippie.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_hippie.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_hitman",
        defaultName: "Hitman",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_hitman.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_hitman.png"],
            width: 64,
            height: 60
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_hitman.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_hitman.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_humourous",
        defaultName: "Humourous",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_humourous.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_humourous.png"],
            width: 64,
            height: 64
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_humourous.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_humourous.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_idea",
        defaultName: "Idea",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_idea.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_idea.png"],
            width: 64,
            height: 62
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_idea.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_idea.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_impatient",
        defaultName: "Impatient",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_impatient.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_impatient.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_impatient.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_impatient.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_kiss",
        defaultName: "Kiss",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_kiss.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_kiss.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_kiss.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_kiss.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_kisses",
        defaultName: "Kisses",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_kisses.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_kisses.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_kisses.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_kisses.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_laugh",
        defaultName: "Laugh",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_laugh.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_laugh.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_laugh.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_laugh.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_loud_cry",
        defaultName: "Loud Cry",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_loud_cry.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_loud_cry.png"],
            width: 64,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_loud_cry.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_loud_cry.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_loving",
        defaultName: "Loving",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_loving.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_loving.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_loving.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_loving.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_masked",
        defaultName: "Masked",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_masked.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_masked.png"],
            width: 62,
            height: 62
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_masked.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_masked.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_music",
        defaultName: "Music",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_music.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_music.png"],
            width: 62,
            height: 54
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_music.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_music.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_nerd",
        defaultName: "Nerd",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_nerd.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_nerd.png"]
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_nerd.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_nerd.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_ninja",
        defaultName: "Ninja",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_ninja.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_ninja.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_ninja.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_ninja.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_not_speaking_to_you",
        defaultName: "Not Speaking To You",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_not_speaking_to_you.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_not_speaking_to_you.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_not_speaking_to_you.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_not_speaking_to_you.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_pig",
        defaultName: "Pig",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_pig.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_pig.png"],
            width: 63,
            height: 41
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_pig.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_pig.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_pumpkin",
        defaultName: "Pumpkin",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_pumpkin.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_pumpkin.png"],
            width: 62,
            height: 60
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_pumpkin.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_pumpkin.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_question",
        defaultName: "Question",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_question.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_question.png"],
            width: 62,
            height: 62
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_question.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_question.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_rabbit",
        defaultName: "Rabbit",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_rabbit.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_rabbit.png"],
            width: 65,
            height: 47
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_rabbit.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_rabbit.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_sad",
        defaultName: "Sad",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sad.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sad.png"]
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sad.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sad.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_sick",
        defaultName: "Sick",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sick.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sick.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sick.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sick.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_skateboard",
        defaultName: "Skateboard",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_skateboard.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_skateboard.png"],
            width: 62,
            height: 64
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_skateboard.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_skateboard.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_skull",
        defaultName: "Skull",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_skull.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_skull.png"],
            width: 62,
            height: 62
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_skull.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_skull.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_sleepy",
        defaultName: "Sleepy",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sleepy.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sleepy.png"],
            width: 62,
            height: 60
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sleepy.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sleepy.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_smile",
        defaultName: "Smile",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_smile.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_smile.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_smile.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_smile.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_smoking",
        defaultName: "Smoking",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_smoking.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_smoking.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_smoking.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_smoking.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_sobbing",
        defaultName: "Sobbing",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sobbing.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sobbing.png"],
            width: 62,
            height: 59
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sobbing.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sobbing.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_star",
        defaultName: "Star",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_star.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_star.png"],
            width: 64,
            height: 64
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_star.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_star.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_steaming_furious",
        defaultName: "Steaming Furious",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_steaming_furious.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_steaming_furious.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_steaming_furious.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_steaming_furious.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_sunbathing",
        defaultName: "Sunbathing",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sunbathing.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_sunbathing.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_sunbathing.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_sunbathing.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_tired",
        defaultName: "Tired",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_tired.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_tired.png"],
            width: 62,
            height: 60
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_tired.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_tired.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_tongue_out_wink",
        defaultName: "Tongue Out Wink",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_tongue_out_wink.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_tongue_out_wink.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_tongue_out_wink.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_tongue_out_wink.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_wave",
        defaultName: "Wave",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wave.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_wave.png"],
            width: 62,
            height: 60
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wave.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_wave.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_wide_grin",
        defaultName: "Wide Grin",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wide_grin.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_wide_grin.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wide_grin.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_wide_grin.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_wink",
        defaultName: "Wink",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wink.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_wink.png"],
            width: 62,
            height: 58
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wink.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_wink.png"]
          }
        }
      }, {
        identifier: "imgly_sticker_emoticons_wrestler",
        defaultName: "Wrestler",
        images: {
          mediaThumb: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wrestler.svg", "stickers/emoticons/stickers/thumbs/imgly_sticker_emoticons_wrestler.png"],
            width: 62,
            height: 60
          },
          mediaBase: {
            uris: ["stickers/emoticons/stickers/imgly_sticker_emoticons_wrestler.svg", "stickers/emoticons/stickers/base/imgly_sticker_emoticons_wrestler.png"]
          }
        }
      }]
    }, {
      identifier: "imgly_sticker_shapes",
      defaultName: "Shapes",
      metaData: {
        backgroundImage: "stickers/shapes/background.png"
      },
      stickers: [{
        identifier: "imgly_sticker_shapes_arrow_02",
        defaultName: "Arrow 1",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_arrow_02.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_arrow_02.png"],
            width: 2e3,
            height: 1236
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_arrow_02.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_arrow_02.png"],
            width: 2e3,
            height: 1236
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_arrow_03",
        defaultName: "Arrow 2",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_arrow_03.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_arrow_03.png"],
            width: 2e3,
            height: 2e3
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_arrow_03.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_arrow_03.png"],
            width: 2e3,
            height: 2e3
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_01",
        defaultName: "Badge 1",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_01.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_01.png"],
            width: 2e3,
            height: 2e3
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_01.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_01.png"],
            width: 2e3,
            height: 2e3
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_04",
        defaultName: "Badge 2",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_04.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_04.png"],
            width: 2e3,
            height: 1589
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_04.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_04.png"],
            width: 2e3,
            height: 1589
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_06",
        defaultName: "Badge 3",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_06.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_06.png"],
            width: 2e3,
            height: 1733
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_06.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_06.png"],
            width: 2e3,
            height: 1733
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_08",
        defaultName: "Badge 4",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_08.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_08.png"],
            width: 2e3,
            height: 2e3
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_08.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_08.png"],
            width: 2e3,
            height: 2e3
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_11",
        defaultName: "Badge 5",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_11.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_11.png"],
            width: 2e3,
            height: 2e3
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_11.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_11.png"],
            width: 2e3,
            height: 2e3
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_12",
        defaultName: "Badge 6",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_12.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_12.png"],
            width: 2001,
            height: 1903
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_12.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_12.png"],
            width: 2001,
            height: 1903
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_13",
        defaultName: "Badge 7",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_13.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_13.png"],
            width: 2e3,
            height: 1718
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_13.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_13.png"],
            width: 2e3,
            height: 1718
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_15",
        defaultName: "Badge 8",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_15.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_15.png"],
            width: 1618,
            height: 2e3
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_15.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_15.png"],
            width: 1618,
            height: 2e3
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_18",
        defaultName: "Badge 9",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_18.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_18.png"],
            width: 1198,
            height: 2e3
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_18.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_18.png"],
            width: 1198,
            height: 2e3
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_19",
        defaultName: "Badge 10",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_19.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_19.png"],
            width: 2127,
            height: 481
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_19.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_19.png"],
            width: 2127,
            height: 481
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_20",
        defaultName: "Badge 11",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_20.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_20.png"],
            width: 2e3,
            height: 1404
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_20.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_20.png"],
            width: 2e3,
            height: 1404
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_28",
        defaultName: "Badge 12",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_28.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_28.png"],
            width: 2e3,
            height: 2e3
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_28.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_28.png"],
            width: 2e3,
            height: 2e3
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_32",
        defaultName: "Badge 13",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_32.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_32.png"],
            width: 1960,
            height: 2e3
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_32.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_32.png"],
            width: 1960,
            height: 2e3
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_35",
        defaultName: "Badge 14",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_35.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_35.png"],
            width: 2e3,
            height: 2002
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_35.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_35.png"],
            width: 2e3,
            height: 2002
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_badge_36",
        defaultName: "Badge 15",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_36.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_badge_36.png"],
            width: 2e3,
            height: 1668
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_badge_36.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_badge_36.png"],
            width: 2e3,
            height: 1668
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_spray_01",
        defaultName: "Spray 1",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_01.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_spray_01.png"],
            width: 1912,
            height: 2039
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_01.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_spray_01.png"],
            width: 1912,
            height: 2039
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_spray_03",
        defaultName: "Spray 2",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_03.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_spray_03.png"],
            width: 1681,
            height: 1779
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_03.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_spray_03.png"],
            width: 1681,
            height: 1779
          }
        }
      }, {
        identifier: "imgly_sticker_shapes_spray_04",
        defaultName: "Spray 3",
        tintMode: "solid",
        images: {
          mediaThumb: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_04.svg", "stickers/shapes/stickers/thumbs/imgly_sticker_shapes_spray_04.png"],
            width: 1407,
            height: 2248
          },
          mediaBase: {
            uris: ["stickers/shapes/stickers/imgly_sticker_shapes_spray_04.svg", "stickers/shapes/stickers/base/imgly_sticker_shapes_spray_04.png"],
            width: 1407,
            height: 2248
          }
        }
      }]
    }]
  }
};
var el = {};
el = window.navigator;
var ai,
    Zp = 244837814094590,
    ju = (Zp & 16777215) == 15715070;

function E(s, e, t) {
  s != null && (typeof s == "number" ? this.fromNumber(s, e, t) : e == null && typeof s != "string" ? this.fromString(s, 256) : this.fromString(s, e));
}

function te() {
  return new E(null);
}

function $p(s, e, t, i, r, o) {
  for (; --o >= 0;) {
    var n = e * this[s++] + t[i] + r;
    r = Math.floor(n / 67108864), t[i++] = n & 67108863;
  }

  return r;
}

function Jp(s, e, t, i, r, o) {
  for (var n = e & 32767, a = e >> 15; --o >= 0;) {
    var l = this[s] & 32767,
        c = this[s++] >> 15,
        u = a * l + c * n;
    l = n * l + ((u & 32767) << 15) + t[i] + (r & 1073741823), r = (l >>> 30) + (u >>> 15) + a * c + (r >>> 30), t[i++] = l & 1073741823;
  }

  return r;
}

function eg(s, e, t, i, r, o) {
  for (var n = e & 16383, a = e >> 14; --o >= 0;) {
    var l = this[s] & 16383,
        c = this[s++] >> 14,
        u = a * l + c * n;
    l = n * l + ((u & 16383) << 14) + t[i] + r, r = (l >> 28) + (u >> 14) + a * c, t[i++] = l & 268435455;
  }

  return r;
}

ju && el.appName == "Microsoft Internet Explorer" ? (E.prototype.am = Jp, ai = 30) : ju && el.appName != "Netscape" ? (E.prototype.am = $p, ai = 26) : (E.prototype.am = eg, ai = 28);
E.prototype.DB = ai;
E.prototype.DM = (1 << ai) - 1;
E.prototype.DV = 1 << ai;
var tl = 52;
E.prototype.FV = Math.pow(2, tl);
E.prototype.F1 = tl - ai;
E.prototype.F2 = 2 * ai - tl;
var tg = "0123456789abcdefghijklmnopqrstuvwxyz",
    io = new Array(),
    cr,
    pt;
cr = "0".charCodeAt(0);

for (pt = 0; pt <= 9; ++pt) {
  io[cr++] = pt;
}

cr = "a".charCodeAt(0);

for (pt = 10; pt < 36; ++pt) {
  io[cr++] = pt;
}

cr = "A".charCodeAt(0);

for (pt = 10; pt < 36; ++pt) {
  io[cr++] = pt;
}

function Yu(s) {
  return tg.charAt(s);
}

function qu(s, e) {
  var t = io[s.charCodeAt(e)];
  return t == null ? -1 : t;
}

function ig(s) {
  for (var e = this.t - 1; e >= 0; --e) {
    s[e] = this[e];
  }

  s.t = this.t, s.s = this.s;
}

function rg(s) {
  this.t = 1, this.s = s < 0 ? -1 : 0, s > 0 ? this[0] = s : s < -1 ? this[0] = s + this.DV : this.t = 0;
}

function li(s) {
  var e = te();
  return e.fromInt(s), e;
}

function sg(s, e) {
  var t;
  if (e == 16) t = 4;else if (e == 8) t = 3;else if (e == 256) t = 8;else if (e == 2) t = 1;else if (e == 32) t = 5;else if (e == 4) t = 2;else {
    this.fromRadix(s, e);
    return;
  }
  this.t = 0, this.s = 0;

  for (var i = s.length, r = !1, o = 0; --i >= 0;) {
    var n = t == 8 ? s[i] & 255 : qu(s, i);

    if (n < 0) {
      s.charAt(i) == "-" && (r = !0);
      continue;
    }

    r = !1, o == 0 ? this[this.t++] = n : o + t > this.DB ? (this[this.t - 1] |= (n & (1 << this.DB - o) - 1) << o, this[this.t++] = n >> this.DB - o) : this[this.t - 1] |= n << o, o += t, o >= this.DB && (o -= this.DB);
  }

  t == 8 && (s[0] & 128) != 0 && (this.s = -1, o > 0 && (this[this.t - 1] |= (1 << this.DB - o) - 1 << o)), this.clamp(), r && E.ZERO.subTo(this, this);
}

function og() {
  for (var s = this.s & this.DM; this.t > 0 && this[this.t - 1] == s;) {
    --this.t;
  }
}

function ng(s) {
  if (this.s < 0) return "-" + this.negate().toString(s);
  var e;
  if (s == 16) e = 4;else if (s == 8) e = 3;else if (s == 2) e = 1;else if (s == 32) e = 5;else if (s == 4) e = 2;else return this.toRadix(s);
  var t = (1 << e) - 1,
      i,
      r = !1,
      o = "",
      n = this.t,
      a = this.DB - n * this.DB % e;
  if (n-- > 0) for (a < this.DB && (i = this[n] >> a) > 0 && (r = !0, o = Yu(i)); n >= 0;) {
    a < e ? (i = (this[n] & (1 << a) - 1) << e - a, i |= this[--n] >> (a += this.DB - e)) : (i = this[n] >> (a -= e) & t, a <= 0 && (a += this.DB, --n)), i > 0 && (r = !0), r && (o += Yu(i));
  }
  return r ? o : "0";
}

function ag() {
  var s = te();
  return E.ZERO.subTo(this, s), s;
}

function lg() {
  return this.s < 0 ? this.negate() : this;
}

function cg(s) {
  var e = this.s - s.s;
  if (e != 0) return e;
  var t = this.t;
  if (e = t - s.t, e != 0) return this.s < 0 ? -e : e;

  for (; --t >= 0;) {
    if ((e = this[t] - s[t]) != 0) return e;
  }

  return 0;
}

function ro(s) {
  var e = 1,
      t;
  return (t = s >>> 16) != 0 && (s = t, e += 16), (t = s >> 8) != 0 && (s = t, e += 8), (t = s >> 4) != 0 && (s = t, e += 4), (t = s >> 2) != 0 && (s = t, e += 2), (t = s >> 1) != 0 && (s = t, e += 1), e;
}

function ug() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + ro(this[this.t - 1] ^ this.s & this.DM);
}

function mg(s, e) {
  var t;

  for (t = this.t - 1; t >= 0; --t) {
    e[t + s] = this[t];
  }

  for (t = s - 1; t >= 0; --t) {
    e[t] = 0;
  }

  e.t = this.t + s, e.s = this.s;
}

function dg(s, e) {
  for (var t = s; t < this.t; ++t) {
    e[t - s] = this[t];
  }

  e.t = Math.max(this.t - s, 0), e.s = this.s;
}

function hg(s, e) {
  var t = s % this.DB,
      i = this.DB - t,
      r = (1 << i) - 1,
      o = Math.floor(s / this.DB),
      n = this.s << t & this.DM,
      a;

  for (a = this.t - 1; a >= 0; --a) {
    e[a + o + 1] = this[a] >> i | n, n = (this[a] & r) << t;
  }

  for (a = o - 1; a >= 0; --a) {
    e[a] = 0;
  }

  e[o] = n, e.t = this.t + o + 1, e.s = this.s, e.clamp();
}

function pg(s, e) {
  e.s = this.s;
  var t = Math.floor(s / this.DB);

  if (t >= this.t) {
    e.t = 0;
    return;
  }

  var i = s % this.DB,
      r = this.DB - i,
      o = (1 << i) - 1;
  e[0] = this[t] >> i;

  for (var n = t + 1; n < this.t; ++n) {
    e[n - t - 1] |= (this[n] & o) << r, e[n - t] = this[n] >> i;
  }

  i > 0 && (e[this.t - t - 1] |= (this.s & o) << r), e.t = this.t - t, e.clamp();
}

function gg(s, e) {
  for (var t = 0, i = 0, r = Math.min(s.t, this.t); t < r;) {
    i += this[t] - s[t], e[t++] = i & this.DM, i >>= this.DB;
  }

  if (s.t < this.t) {
    for (i -= s.s; t < this.t;) {
      i += this[t], e[t++] = i & this.DM, i >>= this.DB;
    }

    i += this.s;
  } else {
    for (i += this.s; t < s.t;) {
      i -= s[t], e[t++] = i & this.DM, i >>= this.DB;
    }

    i -= s.s;
  }

  e.s = i < 0 ? -1 : 0, i < -1 ? e[t++] = this.DV + i : i > 0 && (e[t++] = i), e.t = t, e.clamp();
}

function fg(s, e) {
  var t = this.abs(),
      i = s.abs(),
      r = t.t;

  for (e.t = r + i.t; --r >= 0;) {
    e[r] = 0;
  }

  for (r = 0; r < i.t; ++r) {
    e[r + t.t] = t.am(0, i[r], e, r, 0, t.t);
  }

  e.s = 0, e.clamp(), this.s != s.s && E.ZERO.subTo(e, e);
}

function _g(s) {
  for (var e = this.abs(), t = s.t = 2 * e.t; --t >= 0;) {
    s[t] = 0;
  }

  for (t = 0; t < e.t - 1; ++t) {
    var i = e.am(t, e[t], s, 2 * t, 0, 1);
    (s[t + e.t] += e.am(t + 1, 2 * e[t], s, 2 * t + 1, i, e.t - t - 1)) >= e.DV && (s[t + e.t] -= e.DV, s[t + e.t + 1] = 1);
  }

  s.t > 0 && (s[s.t - 1] += e.am(t, e[t], s, 2 * t, 0, 1)), s.s = 0, s.clamp();
}

function yg(s, e, t) {
  var i = s.abs();

  if (!(i.t <= 0)) {
    var r = this.abs();

    if (r.t < i.t) {
      e != null && e.fromInt(0), t != null && this.copyTo(t);
      return;
    }

    t == null && (t = te());
    var o = te(),
        n = this.s,
        a = s.s,
        l = this.DB - ro(i[i.t - 1]);
    l > 0 ? (i.lShiftTo(l, o), r.lShiftTo(l, t)) : (i.copyTo(o), r.copyTo(t));
    var c = o.t,
        u = o[c - 1];

    if (u != 0) {
      var p = u * (1 << this.F1) + (c > 1 ? o[c - 2] >> this.F2 : 0),
          h = this.FV / p,
          d = (1 << this.F1) / p,
          g = 1 << this.F2,
          y = t.t,
          _ = y - c,
          f = e == null ? te() : e;

      for (o.dlShiftTo(_, f), t.compareTo(f) >= 0 && (t[t.t++] = 1, t.subTo(f, t)), E.ONE.dlShiftTo(c, f), f.subTo(o, o); o.t < c;) {
        o[o.t++] = 0;
      }

      for (; --_ >= 0;) {
        var v = t[--y] == u ? this.DM : Math.floor(t[y] * h + (t[y - 1] + g) * d);
        if ((t[y] += o.am(0, v, t, _, 0, c)) < v) for (o.dlShiftTo(_, f), t.subTo(f, t); t[y] < --v;) {
          t.subTo(f, t);
        }
      }

      e != null && (t.drShiftTo(c, e), n != a && E.ZERO.subTo(e, e)), t.t = c, t.clamp(), l > 0 && t.rShiftTo(l, t), n < 0 && E.ZERO.subTo(t, t);
    }
  }
}

function bg(s) {
  var e = te();
  return this.abs().divRemTo(s, null, e), this.s < 0 && e.compareTo(E.ZERO) > 0 && s.subTo(e, e), e;
}

function Si(s) {
  this.m = s;
}

function xg(s) {
  return s.s < 0 || s.compareTo(this.m) >= 0 ? s.mod(this.m) : s;
}

function vg(s) {
  return s;
}

function Cg(s) {
  s.divRemTo(this.m, null, s);
}

function wg(s, e, t) {
  s.multiplyTo(e, t), this.reduce(t);
}

function Dg(s, e) {
  s.squareTo(e), this.reduce(e);
}

Si.prototype.convert = xg;
Si.prototype.revert = vg;
Si.prototype.reduce = Cg;
Si.prototype.mulTo = wg;
Si.prototype.sqrTo = Dg;

function kg() {
  if (this.t < 1) return 0;
  var s = this[0];
  if ((s & 1) == 0) return 0;
  var e = s & 3;
  return e = e * (2 - (s & 15) * e) & 15, e = e * (2 - (s & 255) * e) & 255, e = e * (2 - ((s & 65535) * e & 65535)) & 65535, e = e * (2 - s * e % this.DV) % this.DV, e > 0 ? this.DV - e : -e;
}

function Ai(s) {
  this.m = s, this.mp = s.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << s.DB - 15) - 1, this.mt2 = 2 * s.t;
}

function Tg(s) {
  var e = te();
  return s.abs().dlShiftTo(this.m.t, e), e.divRemTo(this.m, null, e), s.s < 0 && e.compareTo(E.ZERO) > 0 && this.m.subTo(e, e), e;
}

function Rg(s) {
  var e = te();
  return s.copyTo(e), this.reduce(e), e;
}

function Fg(s) {
  for (; s.t <= this.mt2;) {
    s[s.t++] = 0;
  }

  for (var e = 0; e < this.m.t; ++e) {
    var t = s[e] & 32767,
        i = t * this.mpl + ((t * this.mph + (s[e] >> 15) * this.mpl & this.um) << 15) & s.DM;

    for (t = e + this.m.t, s[t] += this.m.am(0, i, s, e, 0, this.m.t); s[t] >= s.DV;) {
      s[t] -= s.DV, s[++t]++;
    }
  }

  s.clamp(), s.drShiftTo(this.m.t, s), s.compareTo(this.m) >= 0 && s.subTo(this.m, s);
}

function Eg(s, e) {
  s.squareTo(e), this.reduce(e);
}

function Sg(s, e, t) {
  s.multiplyTo(e, t), this.reduce(t);
}

Ai.prototype.convert = Tg;
Ai.prototype.revert = Rg;
Ai.prototype.reduce = Fg;
Ai.prototype.mulTo = Sg;
Ai.prototype.sqrTo = Eg;

function Ag() {
  return (this.t > 0 ? this[0] & 1 : this.s) == 0;
}

function Ig(s, e) {
  if (s > 4294967295 || s < 1) return E.ONE;
  var t = te(),
      i = te(),
      r = e.convert(this),
      o = ro(s) - 1;

  for (r.copyTo(t); --o >= 0;) {
    if (e.sqrTo(t, i), (s & 1 << o) > 0) e.mulTo(i, r, t);else {
      var n = t;
      t = i, i = n;
    }
  }

  return e.revert(t);
}

function Og(s, e) {
  var t;
  return s < 256 || e.isEven() ? t = new Si(e) : t = new Ai(e), this.exp(s, t);
}

E.prototype.copyTo = ig;
E.prototype.fromInt = rg;
E.prototype.fromString = sg;
E.prototype.clamp = og;
E.prototype.dlShiftTo = mg;
E.prototype.drShiftTo = dg;
E.prototype.lShiftTo = hg;
E.prototype.rShiftTo = pg;
E.prototype.subTo = gg;
E.prototype.multiplyTo = fg;
E.prototype.squareTo = _g;
E.prototype.divRemTo = yg;
E.prototype.invDigit = kg;
E.prototype.isEven = Ag;
E.prototype.exp = Ig;
E.prototype.toString = ng;
E.prototype.negate = ag;
E.prototype.abs = lg;
E.prototype.compareTo = cg;
E.prototype.bitLength = ug;
E.prototype.mod = bg;
E.prototype.modPowInt = Og;
E.ZERO = li(0);
E.ONE = li(1);

function Pg() {
  var s = te();
  return this.copyTo(s), s;
}

function Bg() {
  if (this.s < 0) {
    if (this.t == 1) return this[0] - this.DV;
    if (this.t == 0) return -1;
  } else {
    if (this.t == 1) return this[0];
    if (this.t == 0) return 0;
  }

  return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
}

function Mg() {
  return this.t == 0 ? this.s : this[0] << 24 >> 24;
}

function Lg() {
  return this.t == 0 ? this.s : this[0] << 16 >> 16;
}

function zg(s) {
  return Math.floor(Math.LN2 * this.DB / Math.log(s));
}

function Ug() {
  return this.s < 0 ? -1 : this.t <= 0 || this.t == 1 && this[0] <= 0 ? 0 : 1;
}

function Ng(s) {
  if (s == null && (s = 10), this.signum() == 0 || s < 2 || s > 36) return "0";
  var e = this.chunkSize(s),
      t = Math.pow(s, e),
      i = li(t),
      r = te(),
      o = te(),
      n = "";

  for (this.divRemTo(i, r, o); r.signum() > 0;) {
    n = (t + o.intValue()).toString(s).substr(1) + n, r.divRemTo(i, r, o);
  }

  return o.intValue().toString(s) + n;
}

function Gg(s, e) {
  this.fromInt(0), e == null && (e = 10);

  for (var t = this.chunkSize(e), i = Math.pow(e, t), r = !1, o = 0, n = 0, a = 0; a < s.length; ++a) {
    var l = qu(s, a);

    if (l < 0) {
      s.charAt(a) == "-" && this.signum() == 0 && (r = !0);
      continue;
    }

    n = e * n + l, ++o >= t && (this.dMultiply(i), this.dAddOffset(n, 0), o = 0, n = 0);
  }

  o > 0 && (this.dMultiply(Math.pow(e, o)), this.dAddOffset(n, 0)), r && E.ZERO.subTo(this, this);
}

function Wg(s, e, t) {
  if (typeof e == "number") {
    if (s < 2) this.fromInt(1);else for (this.fromNumber(s, t), this.testBit(s - 1) || this.bitwiseTo(E.ONE.shiftLeft(s - 1), il, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(e);) {
      this.dAddOffset(2, 0), this.bitLength() > s && this.subTo(E.ONE.shiftLeft(s - 1), this);
    }
  } else {
    var i = new Array(),
        r = s & 7;
    i.length = (s >> 3) + 1, e.nextBytes(i), r > 0 ? i[0] &= (1 << r) - 1 : i[0] = 0, this.fromString(i, 256);
  }
}

function Vg() {
  var s = this.t,
      e = new Array();
  e[0] = this.s;
  var t = this.DB - s * this.DB % 8,
      i,
      r = 0;
  if (s-- > 0) for (t < this.DB && (i = this[s] >> t) != (this.s & this.DM) >> t && (e[r++] = i | this.s << this.DB - t); s >= 0;) {
    t < 8 ? (i = (this[s] & (1 << t) - 1) << 8 - t, i |= this[--s] >> (t += this.DB - 8)) : (i = this[s] >> (t -= 8) & 255, t <= 0 && (t += this.DB, --s)), (i & 128) != 0 && (i |= -256), r == 0 && (this.s & 128) != (i & 128) && ++r, (r > 0 || i != this.s) && (e[r++] = i);
  }
  return e;
}

function Hg(s) {
  return this.compareTo(s) == 0;
}

function jg(s) {
  return this.compareTo(s) < 0 ? this : s;
}

function Yg(s) {
  return this.compareTo(s) > 0 ? this : s;
}

function qg(s, e, t) {
  var i,
      r,
      o = Math.min(s.t, this.t);

  for (i = 0; i < o; ++i) {
    t[i] = e(this[i], s[i]);
  }

  if (s.t < this.t) {
    for (r = s.s & this.DM, i = o; i < this.t; ++i) {
      t[i] = e(this[i], r);
    }

    t.t = this.t;
  } else {
    for (r = this.s & this.DM, i = o; i < s.t; ++i) {
      t[i] = e(r, s[i]);
    }

    t.t = s.t;
  }

  t.s = e(this.s, s.s), t.clamp();
}

function Kg(s, e) {
  return s & e;
}

function Xg(s) {
  var e = te();
  return this.bitwiseTo(s, Kg, e), e;
}

function il(s, e) {
  return s | e;
}

function Qg(s) {
  var e = te();
  return this.bitwiseTo(s, il, e), e;
}

function Ku(s, e) {
  return s ^ e;
}

function Zg(s) {
  var e = te();
  return this.bitwiseTo(s, Ku, e), e;
}

function Xu(s, e) {
  return s & ~e;
}

function $g(s) {
  var e = te();
  return this.bitwiseTo(s, Xu, e), e;
}

function Jg() {
  for (var s = te(), e = 0; e < this.t; ++e) {
    s[e] = this.DM & ~this[e];
  }

  return s.t = this.t, s.s = ~this.s, s;
}

function ef(s) {
  var e = te();
  return s < 0 ? this.rShiftTo(-s, e) : this.lShiftTo(s, e), e;
}

function tf(s) {
  var e = te();
  return s < 0 ? this.lShiftTo(-s, e) : this.rShiftTo(s, e), e;
}

function rf(s) {
  if (s == 0) return -1;
  var e = 0;
  return (s & 65535) == 0 && (s >>= 16, e += 16), (s & 255) == 0 && (s >>= 8, e += 8), (s & 15) == 0 && (s >>= 4, e += 4), (s & 3) == 0 && (s >>= 2, e += 2), (s & 1) == 0 && ++e, e;
}

function sf() {
  for (var s = 0; s < this.t; ++s) {
    if (this[s] != 0) return s * this.DB + rf(this[s]);
  }

  return this.s < 0 ? this.t * this.DB : -1;
}

function of(s) {
  for (var e = 0; s != 0;) {
    s &= s - 1, ++e;
  }

  return e;
}

function nf() {
  for (var s = 0, e = this.s & this.DM, t = 0; t < this.t; ++t) {
    s += of(this[t] ^ e);
  }

  return s;
}

function af(s) {
  var e = Math.floor(s / this.DB);
  return e >= this.t ? this.s != 0 : (this[e] & 1 << s % this.DB) != 0;
}

function lf(s, e) {
  var t = E.ONE.shiftLeft(s);
  return this.bitwiseTo(t, e, t), t;
}

function cf(s) {
  return this.changeBit(s, il);
}

function uf(s) {
  return this.changeBit(s, Xu);
}

function mf(s) {
  return this.changeBit(s, Ku);
}

function df(s, e) {
  for (var t = 0, i = 0, r = Math.min(s.t, this.t); t < r;) {
    i += this[t] + s[t], e[t++] = i & this.DM, i >>= this.DB;
  }

  if (s.t < this.t) {
    for (i += s.s; t < this.t;) {
      i += this[t], e[t++] = i & this.DM, i >>= this.DB;
    }

    i += this.s;
  } else {
    for (i += this.s; t < s.t;) {
      i += s[t], e[t++] = i & this.DM, i >>= this.DB;
    }

    i += s.s;
  }

  e.s = i < 0 ? -1 : 0, i > 0 ? e[t++] = i : i < -1 && (e[t++] = this.DV + i), e.t = t, e.clamp();
}

function hf(s) {
  var e = te();
  return this.addTo(s, e), e;
}

function pf(s) {
  var e = te();
  return this.subTo(s, e), e;
}

function gf(s) {
  var e = te();
  return this.multiplyTo(s, e), e;
}

function ff() {
  var s = te();
  return this.squareTo(s), s;
}

function _f(s) {
  var e = te();
  return this.divRemTo(s, e, null), e;
}

function yf(s) {
  var e = te();
  return this.divRemTo(s, null, e), e;
}

function bf(s) {
  var e = te(),
      t = te();
  return this.divRemTo(s, e, t), new Array(e, t);
}

function xf(s) {
  this[this.t] = this.am(0, s - 1, this, 0, 0, this.t), ++this.t, this.clamp();
}

function vf(s, e) {
  if (s != 0) {
    for (; this.t <= e;) {
      this[this.t++] = 0;
    }

    for (this[e] += s; this[e] >= this.DV;) {
      this[e] -= this.DV, ++e >= this.t && (this[this.t++] = 0), ++this[e];
    }
  }
}

function _s() {}

function Qu(s) {
  return s;
}

function Cf(s, e, t) {
  s.multiplyTo(e, t);
}

function wf(s, e) {
  s.squareTo(e);
}

_s.prototype.convert = Qu;
_s.prototype.revert = Qu;
_s.prototype.mulTo = Cf;
_s.prototype.sqrTo = wf;

function Df(s) {
  return this.exp(s, new _s());
}

function kf(s, e, t) {
  var i = Math.min(this.t + s.t, e);

  for (t.s = 0, t.t = i; i > 0;) {
    t[--i] = 0;
  }

  var r;

  for (r = t.t - this.t; i < r; ++i) {
    t[i + this.t] = this.am(0, s[i], t, i, 0, this.t);
  }

  for (r = Math.min(s.t, e); i < r; ++i) {
    this.am(0, s[i], t, i, 0, e - i);
  }

  t.clamp();
}

function Tf(s, e, t) {
  --e;
  var i = t.t = this.t + s.t - e;

  for (t.s = 0; --i >= 0;) {
    t[i] = 0;
  }

  for (i = Math.max(e - this.t, 0); i < s.t; ++i) {
    t[this.t + i - e] = this.am(e - i, s[i], t, 0, 0, this.t + i - e);
  }

  t.clamp(), t.drShiftTo(1, t);
}

function ur(s) {
  this.r2 = te(), this.q3 = te(), E.ONE.dlShiftTo(2 * s.t, this.r2), this.mu = this.r2.divide(s), this.m = s;
}

function Rf(s) {
  if (s.s < 0 || s.t > 2 * this.m.t) return s.mod(this.m);
  if (s.compareTo(this.m) < 0) return s;
  var e = te();
  return s.copyTo(e), this.reduce(e), e;
}

function Ff(s) {
  return s;
}

function Ef(s) {
  for (s.drShiftTo(this.m.t - 1, this.r2), s.t > this.m.t + 1 && (s.t = this.m.t + 1, s.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); s.compareTo(this.r2) < 0;) {
    s.dAddOffset(1, this.m.t + 1);
  }

  for (s.subTo(this.r2, s); s.compareTo(this.m) >= 0;) {
    s.subTo(this.m, s);
  }
}

function Sf(s, e) {
  s.squareTo(e), this.reduce(e);
}

function Af(s, e, t) {
  s.multiplyTo(e, t), this.reduce(t);
}

ur.prototype.convert = Rf;
ur.prototype.revert = Ff;
ur.prototype.reduce = Ef;
ur.prototype.mulTo = Af;
ur.prototype.sqrTo = Sf;

function If(s, e) {
  var t = s.bitLength(),
      i,
      r = li(1),
      o;
  if (t <= 0) return r;
  t < 18 ? i = 1 : t < 48 ? i = 3 : t < 144 ? i = 4 : t < 768 ? i = 5 : i = 6, t < 8 ? o = new Si(e) : e.isEven() ? o = new ur(e) : o = new Ai(e);
  var n = new Array(),
      a = 3,
      l = i - 1,
      c = (1 << i) - 1;

  if (n[1] = o.convert(this), i > 1) {
    var u = te();

    for (o.sqrTo(n[1], u); a <= c;) {
      n[a] = te(), o.mulTo(u, n[a - 2], n[a]), a += 2;
    }
  }

  var p = s.t - 1,
      h,
      d = !0,
      g = te(),
      y;

  for (t = ro(s[p]) - 1; p >= 0;) {
    for (t >= l ? h = s[p] >> t - l & c : (h = (s[p] & (1 << t + 1) - 1) << l - t, p > 0 && (h |= s[p - 1] >> this.DB + t - l)), a = i; (h & 1) == 0;) {
      h >>= 1, --a;
    }

    if ((t -= a) < 0 && (t += this.DB, --p), d) n[h].copyTo(r), d = !1;else {
      for (; a > 1;) {
        o.sqrTo(r, g), o.sqrTo(g, r), a -= 2;
      }

      a > 0 ? o.sqrTo(r, g) : (y = r, r = g, g = y), o.mulTo(g, n[h], r);
    }

    for (; p >= 0 && (s[p] & 1 << t) == 0;) {
      o.sqrTo(r, g), y = r, r = g, g = y, --t < 0 && (t = this.DB - 1, --p);
    }
  }

  return o.revert(r);
}

function Of(s) {
  var e = this.s < 0 ? this.negate() : this.clone(),
      t = s.s < 0 ? s.negate() : s.clone();

  if (e.compareTo(t) < 0) {
    var i = e;
    e = t, t = i;
  }

  var r = e.getLowestSetBit(),
      o = t.getLowestSetBit();
  if (o < 0) return e;

  for (r < o && (o = r), o > 0 && (e.rShiftTo(o, e), t.rShiftTo(o, t)); e.signum() > 0;) {
    (r = e.getLowestSetBit()) > 0 && e.rShiftTo(r, e), (r = t.getLowestSetBit()) > 0 && t.rShiftTo(r, t), e.compareTo(t) >= 0 ? (e.subTo(t, e), e.rShiftTo(1, e)) : (t.subTo(e, t), t.rShiftTo(1, t));
  }

  return o > 0 && t.lShiftTo(o, t), t;
}

function Pf(s) {
  if (s <= 0) return 0;
  var e = this.DV % s,
      t = this.s < 0 ? s - 1 : 0;
  if (this.t > 0) if (e == 0) t = this[0] % s;else for (var i = this.t - 1; i >= 0; --i) {
    t = (e * t + this[i]) % s;
  }
  return t;
}

function Bf(s) {
  var e = s.isEven();
  if (this.isEven() && e || s.signum() == 0) return E.ZERO;

  for (var t = s.clone(), i = this.clone(), r = li(1), o = li(0), n = li(0), a = li(1); t.signum() != 0;) {
    for (; t.isEven();) {
      t.rShiftTo(1, t), e ? ((!r.isEven() || !o.isEven()) && (r.addTo(this, r), o.subTo(s, o)), r.rShiftTo(1, r)) : o.isEven() || o.subTo(s, o), o.rShiftTo(1, o);
    }

    for (; i.isEven();) {
      i.rShiftTo(1, i), e ? ((!n.isEven() || !a.isEven()) && (n.addTo(this, n), a.subTo(s, a)), n.rShiftTo(1, n)) : a.isEven() || a.subTo(s, a), a.rShiftTo(1, a);
    }

    t.compareTo(i) >= 0 ? (t.subTo(i, t), e && r.subTo(n, r), o.subTo(a, o)) : (i.subTo(t, i), e && n.subTo(r, n), a.subTo(o, a));
  }

  if (i.compareTo(E.ONE) != 0) return E.ZERO;
  if (a.compareTo(s) >= 0) return a.subtract(s);
  if (a.signum() < 0) a.addTo(s, a);else return a;
  return a.signum() < 0 ? a.add(s) : a;
}

var He = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997],
    Mf = (1 << 26) / He[He.length - 1];

function Lf(s) {
  var e,
      t = this.abs();

  if (t.t == 1 && t[0] <= He[He.length - 1]) {
    for (e = 0; e < He.length; ++e) {
      if (t[0] == He[e]) return !0;
    }

    return !1;
  }

  if (t.isEven()) return !1;

  for (e = 1; e < He.length;) {
    for (var i = He[e], r = e + 1; r < He.length && i < Mf;) {
      i *= He[r++];
    }

    for (i = t.modInt(i); e < r;) {
      if (i % He[e++] == 0) return !1;
    }
  }

  return t.millerRabin(s);
}

function zf(s) {
  var e = this.subtract(E.ONE),
      t = e.getLowestSetBit();
  if (t <= 0) return !1;
  var i = e.shiftRight(t);
  s = s + 1 >> 1, s > He.length && (s = He.length);

  for (var r = te(), o = 0; o < s; ++o) {
    r.fromInt(He[Math.floor(Math.random() * He.length)]);
    var n = r.modPow(i, this);

    if (n.compareTo(E.ONE) != 0 && n.compareTo(e) != 0) {
      for (var a = 1; a++ < t && n.compareTo(e) != 0;) {
        if (n = n.modPowInt(2, this), n.compareTo(E.ONE) == 0) return !1;
      }

      if (n.compareTo(e) != 0) return !1;
    }
  }

  return !0;
}

E.prototype.chunkSize = zg;
E.prototype.toRadix = Ng;
E.prototype.fromRadix = Gg;
E.prototype.fromNumber = Wg;
E.prototype.bitwiseTo = qg;
E.prototype.changeBit = lf;
E.prototype.addTo = df;
E.prototype.dMultiply = xf;
E.prototype.dAddOffset = vf;
E.prototype.multiplyLowerTo = kf;
E.prototype.multiplyUpperTo = Tf;
E.prototype.modInt = Pf;
E.prototype.millerRabin = zf;
E.prototype.clone = Pg;
E.prototype.intValue = Bg;
E.prototype.byteValue = Mg;
E.prototype.shortValue = Lg;
E.prototype.signum = Ug;
E.prototype.toByteArray = Vg;
E.prototype.equals = Hg;
E.prototype.min = jg;
E.prototype.max = Yg;
E.prototype.and = Xg;
E.prototype.or = Qg;
E.prototype.xor = Zg;
E.prototype.andNot = $g;
E.prototype.not = Jg;
E.prototype.shiftLeft = ef;
E.prototype.shiftRight = tf;
E.prototype.getLowestSetBit = sf;
E.prototype.bitCount = nf;
E.prototype.testBit = af;
E.prototype.setBit = cf;
E.prototype.clearBit = uf;
E.prototype.flipBit = mf;
E.prototype.add = hf;
E.prototype.subtract = pf;
E.prototype.multiply = gf;
E.prototype.divide = _f;
E.prototype.remainder = yf;
E.prototype.divideAndRemainder = bf;
E.prototype.modPow = If;
E.prototype.modInverse = Bf;
E.prototype.pow = Df;
E.prototype.gcd = Of;
E.prototype.isProbablePrime = Lf;
E.prototype.square = ff;
var Zu = E;

function $u(s) {
  var e = 8,
      t = 0;

  function i(_, f) {
    var v = (_ & 65535) + (f & 65535),
        b = (_ >> 16) + (f >> 16) + (v >> 16);
    return b << 16 | v & 65535;
  }

  function r(_, f) {
    return _ >>> f | _ << 32 - f;
  }

  function o(_, f) {
    return _ >>> f;
  }

  function n(_, f, v) {
    return _ & f ^ ~_ & v;
  }

  function a(_, f, v) {
    return _ & f ^ _ & v ^ f & v;
  }

  function l(_) {
    return r(_, 2) ^ r(_, 13) ^ r(_, 22);
  }

  function c(_) {
    return r(_, 6) ^ r(_, 11) ^ r(_, 25);
  }

  function u(_) {
    return r(_, 7) ^ r(_, 18) ^ o(_, 3);
  }

  function p(_) {
    return r(_, 17) ^ r(_, 19) ^ o(_, 10);
  }

  function h(_, f) {
    var v = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298),
        b = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225),
        D = new Array(64),
        O,
        x,
        w,
        z,
        L,
        j,
        X,
        K,
        G,
        ae,
        Ne,
        Oe;
    _[f >> 5] |= 128 << 24 - f % 32, _[(f + 64 >> 9 << 4) + 15] = f;

    for (var G = 0; G < _.length; G += 16) {
      O = b[0], x = b[1], w = b[2], z = b[3], L = b[4], j = b[5], X = b[6], K = b[7];

      for (var ae = 0; ae < 64; ae++) {
        ae < 16 ? D[ae] = _[ae + G] : D[ae] = i(i(i(p(D[ae - 2]), D[ae - 7]), u(D[ae - 15])), D[ae - 16]), Ne = i(i(i(i(K, c(L)), n(L, j, X)), v[ae]), D[ae]), Oe = i(l(O), a(O, x, w)), K = X, X = j, j = L, L = i(z, Ne), z = w, w = x, x = O, O = i(Ne, Oe);
      }

      b[0] = i(O, b[0]), b[1] = i(x, b[1]), b[2] = i(w, b[2]), b[3] = i(z, b[3]), b[4] = i(L, b[4]), b[5] = i(j, b[5]), b[6] = i(X, b[6]), b[7] = i(K, b[7]);
    }

    return b;
  }

  function d(_) {
    for (var f = Array(), v = (1 << e) - 1, b = 0; b < _.length * e; b += e) {
      f[b >> 5] |= (_.charCodeAt(b / e) & v) << 24 - b % 32;
    }

    return f;
  }

  function g(_) {
    _ = _.replace(/\r\n/g, "\n");

    for (var f = "", v = 0; v < _.length; v++) {
      var b = _.charCodeAt(v);

      b < 128 ? f += String.fromCharCode(b) : b > 127 && b < 2048 ? (f += String.fromCharCode(b >> 6 | 192), f += String.fromCharCode(b & 63 | 128)) : (f += String.fromCharCode(b >> 12 | 224), f += String.fromCharCode(b >> 6 & 63 | 128), f += String.fromCharCode(b & 63 | 128));
    }

    return f;
  }

  function y(_) {
    for (var f = t ? "0123456789ABCDEF" : "0123456789abcdef", v = "", b = 0; b < _.length * 4; b++) {
      v += f.charAt(_[b >> 2] >> (3 - b % 4) * 8 + 4 & 15) + f.charAt(_[b >> 2] >> (3 - b % 4) * 8 & 15);
    }

    return v;
  }

  return s = g(s), y(h(d(s), s.length * e));
}

var Uf = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/g,
    Nf = /^(0|[1-9]\d*)\.(0|[1-9]\d*)(\.(0|[1-9]\d*))?(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/g,
    Ii =
/*#__PURE__*/
function () {
  _createClass(Ii, [{
    key: "major",
    get: function get() {
      return this._major;
    }
  }, {
    key: "minor",
    get: function get() {
      return this._minor;
    }
  }, {
    key: "patch",
    get: function get() {
      return this._patch;
    }
  }]);

  function Ii(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

    _classCallCheck(this, Ii);

    var i = t ? Nf : Uf,
        r = i.exec(e);
    i.lastIndex = 0, this._major = r[1], this._minor = r[2], this._patch = r[3] || 0;
  }

  _createClass(Ii, [{
    key: "equals",
    value: function equals(e) {
      return this._major === e._major && this._minor === e._minor && this._patch === e._patch;
    }
  }, {
    key: "isMoreRecentThan",
    value: function isMoreRecentThan(e) {
      if (this._major < e.major) return !1;
      if (this._major > e.major) return !0;
      if (this._minor < e.minor) return !1;
      if (this._minor > e.minor) return !0;
      if (this._patch <= e.patch) return !1;
      if (this._patch > e.patch) return !0;
    }
  }]);

  return Ii;
}();

var Pe = function Pe(s) {
  return T.byteArrayToString(bt.decode(s));
};

function Gf(s) {
  return s.map(function (e) {
    return "0".concat((e & 255).toString(16)).slice(-2);
  }).join("");
}

var Wf = "TDNSeVlXTnJQMkZ3YVV0bGVUMD0=",
    Vf = "ZW50ZXJwcmlzZV9saWNlbnNl",
    Ju = "YXBwX2lkZW50aWZpZXJz",
    Hf = "cGxhdGZvcm0=",
    em = "ZmVhdHVyZXM=",
    rl = "ZXhwaXJlc19hdA==",
    jf = "ZG9tYWlucw==",
    Yf = "YXBpX3Rva2Vu",
    sl = "c2lnbmF0dXJl",
    qf = "dmVyc2lvbg==",
    tm =
/*#__PURE__*/
function () {
  function tm(e) {
    _classCallCheck(this, tm);

    this._version = "2.4", this._l = typeof e == "string" ? e.trim() : e, this._e = this._parseBigInt("65537", 10), this._n = this._parseBigInt("681984042382424091378806337544846672160292647422517223678775230983366046720611873368204040735766698395282492937192783016867164773742859209434481353888637963692711665138989982680829529436715362566735813634679619274059040232728883894511099669775400556584329435375723951309340934658571478665059403241851229195311069345899870108307225910988692123234379186643268583453907260879685992156955936561142314233983397819356937109343127504441076920088455337597736475086676246750168976219763398350254797168313954762459542746440628077261880980924552698138857743609502132632199713575442848784271304503226045319991689413234228439044522583790713890093165912455428688507463773064216328753265963237930998706891042679105987175588970202082466871461192706070321938250462103821558100761330890228135620208935801286878657384108721268761878694436895194628411397454202904351577771506916746612289964053490210990342857409030179406810634136188751670648983222653319056818302012063874664196648868156305696644664362171542503665321455971335955948698828939948786720193132672749776162913092000667953299803216404664087988046584107737900256954976744353601826341965438148646041640662195744770544094748295945844184507459808803114917301124088082458306086473490516969815873631", 10), this._parseLicense();
  }

  _createClass(tm, [{
    key: "v",
    value: function v() {
      return this._sigValid() && !this.isExp();
    }
  }, {
    key: "_jsonValid",
    value: function _jsonValid() {
      try {
        this._decLic = JSON.parse(this._l);
      } catch (e) {
        return this._decLic = {}, !1;
      }

      return !0;
    }
  }, {
    key: "_hostnameValid",
    value: function _hostnameValid() {
      if (typeof window == "undefined" || !this._decLic[Pe(Ju)].length) return !0;
      var e = window.location.hostname,
          t = !1;
      return this._decLic[Pe(Ju)].forEach(function (i) {
        T.wildCardMatch(e, i) && (t = !0);
      }), t;
    }
  }, {
    key: "_platformValid",
    value: function _platformValid() {
      var e = this._decLic[Pe(Hf)];

      return "HTML5" === e;
    }
  }, {
    key: "c",
    value: function c() {
      var _this37 = this;

      return new Promise(function (e, t) {
        var i = _this37._validateError();

        i !== null && t(i), e();
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      return this._validateError() === null;
    }
  }, {
    key: "_validateError",
    value: function _validateError() {
      if (typeof this._l !== "string" || !this._jsonValid()) {
        var _t9 = new Error();

        return _t9.code = "ELICINVFMT", _t9;
      }

      if (!this._sigValid()) {
        var _t10 = new Error();

        return _t10.code = "ELICINV", _t10;
      }

      if (!this._hostnameValid()) {
        var _t11 = new Error();

        return _t11.code = "ELICINVHOST", _t11;
      }

      if (!this._platformValid()) {
        var _t12 = new Error();

        return _t12.code = "ELICINVPLAT", _t12;
      }

      if (this.isExp()) {
        var _t13 = new Error();

        return _t13.code = "ELICEXP", _t13;
      }

      return null;
    }
  }, {
    key: "isToolAllowed",
    value: function isToolAllowed(e) {
      return this._includesFeature(e);
    }
  }, {
    key: "isWhiteLabel",
    value: function isWhiteLabel() {
      return this._includesFeature("whitelabel", new Ii("2.4", !0));
    }
  }, {
    key: "areCustomAssetsAllowed",
    value: function areCustomAssetsAllowed() {
      return this._includesFeature("customassets", new Ii("2.4", !0));
    }
  }, {
    key: "t",
    value: function t() {
      if (this._decLic.enterprise_license || this._includesFeature("noexporttracking", new Ii("2.4", !0))) return Promise.resolve();

      var e = this._decLic[Pe(jf)][0] + Pe(Pe(Wf)) + this._decLic[Pe(Yf)];

      return new Rt(e).load();
    }
  }, {
    key: "isENT",
    value: function isENT() {
      return this._decLic ? this._decLic[Pe(Vf)] : !1;
    }
  }, {
    key: "_sigValid",
    value: function _sigValid() {
      return this._verify(this._message, this._sig);
    }
  }, {
    key: "exp",
    value: function exp() {
      return !!this._decLic[Pe(rl)];
    }
  }, {
    key: "dl",
    value: function dl() {
      return Math.ceil((this._expAt() - Date.now()) / (60 * 60 * 24 * 1e3));
    }
  }, {
    key: "isExp",
    value: function isExp() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
      return this._decLic[Pe(rl)] === null ? !1 : e > this._expAt();
    }
  }, {
    key: "_expAt",
    value: function _expAt() {
      return this._decLic[Pe(rl)] * 1e3;
    }
  }, {
    key: "_verify",
    value: function _verify(e, t) {
      var i, r;
      return r = this._encodeMessage(e), i = this._decodeSignature(t), i = i.substr(-64), r === i;
    }
  }, {
    key: "_encodeMessage",
    value: function _encodeMessage(e) {
      return $u(e);
    }
  }, {
    key: "_decodeSignature",
    value: function _decodeSignature(e) {
      var t;
      return e = bt.decode(e), e = Gf(e), e = this._parseBigInt(e, 16), t = e.modPowInt(this._e, this._n), t = t.toString(16), t;
    }
  }, {
    key: "_parseBigInt",
    value: function _parseBigInt(e, t) {
      return new Zu(e, t);
    }
  }, {
    key: "_parseLicense",
    value: function _parseLicense() {
      typeof this._l == "string" && (!this._jsonValid() || (this._sig = this._decLic[Pe(sl)] || "", delete this._decLic[Pe(sl)], this._sig = this._sig.replace(/[^A-Za-z0-9+/=]/g, ""), this._message = this._l.replace(new RegExp(",\"".concat(Pe(sl), "\":\"([^\"]*)\"")), "")));
    }
  }, {
    key: "_includesFeature",
    value: function _includesFeature(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Ii("1.0", !0);
      var i = new Ii(this._decLic[Pe(qf)], !0);
      return t.isMoreRecentThan(i) ? !0 : this._decLic[Pe(em)] && this._decLic[Pe(em)].indexOf(e) !== -1;
    }
  }]);

  return tm;
}(),
    ol =
/*#__PURE__*/
function () {
  function ol() {
    _classCallCheck(this, ol);
  }

  _createClass(ol, [{
    key: "v",
    value: function v() {
      return !0;
    }
  }, {
    key: "c",
    value: function c() {
      return Promise.resolve();
    }
  }, {
    key: "isToolAllowed",
    value: function isToolAllowed(e) {
      return !0;
    }
  }, {
    key: "isWhiteLabel",
    value: function isWhiteLabel() {
      return !1;
    }
  }, {
    key: "areCustomAssetsAllowed",
    value: function areCustomAssetsAllowed() {
      return !0;
    }
  }, {
    key: "t",
    value: function t() {
      return Promise.resolve();
    }
  }, {
    key: "isENT",
    value: function isENT() {
      return !1;
    }
  }, {
    key: "exp",
    value: function exp() {
      return !1;
    }
  }, {
    key: "dl",
    value: function dl() {
      return 0;
    }
  }, {
    key: "isExp",
    value: function isExp() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
      return !1;
    }
  }]);

  return ol;
}(),
    so = tm;

var Oi = typeof window == "undefined" ? global : window,
    Ht = Oi.requestAnimationFrame,
    ci = Oi.cancelAnimationFrame,
    im = 0,
    oo = ["ms", "moz", "webkit", "o"];

for (var _s3 = 0; _s3 < oo.length && !Ht; ++_s3) {
  Ht = Oi["".concat(oo[_s3], "RequestAnimationFrame")], ci = Oi["".concat(oo[_s3], "CancelAnimationFrame")] || Oi["".concat(oo[_s3], "CancelRequestAnimationFrame")];
}

Ht && (Ht = Ht.bind(Oi));
ci && (ci = ci.bind(Oi));
Ht || (Ht = function Ht(s, e) {
  var t = new Date().getTime(),
      i = Math.max(0, 16 - (t - im)),
      r = setTimeout(function () {
    s(t + i);
  }, i);
  return im = t + i, r;
});
ci || (ci = function ci(s) {
  clearTimeout(s);
});
var I = {};
we(I, {
  ColorMatrix: function ColorMatrix() {
    return ls;
  },
  CubicBezierCurve: function CubicBezierCurve() {
    return nl;
  },
  Matrix: function Matrix() {
    return Ze;
  },
  Range: function Range() {
    return al;
  },
  Rectangle: function Rectangle() {
    return le;
  },
  Vector2: function Vector2() {
    return B;
  },
  Vector3: function Vector3() {
    return ll;
  }
});

var rm =
/*#__PURE__*/
function () {
  function rm() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new B(0, 0);
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new B(1, 1);
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new B(2, -1);
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new B(2, 0);

    _classCallCheck(this, rm);

    this._p0 = e.clone(), this._p1 = t.clone(), this._p2 = i.clone(), this._p3 = r.clone(), this._segments = [], this._length = -1, this._sample = [];
  }

  _createClass(rm, [{
    key: "set",
    value: function set() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new B(0, 0);
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new B(1, 1);
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new B(2, 1);
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new B(2, 0);
      this._p0 = e.clone(), this._p1 = t.clone(), this._p2 = i.clone(), this._p3 = r.clone();
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this._length;
    }
  }, {
    key: "calculateSegments",
    value: function calculateSegments() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;

      var t = 0,
          i = 0,
          r = [],
          o = 1 / e,
          n = this._p0.clone();

      for (var a = 1; a <= e; a++) {
        var _l2 = [];
        _l2.push({
          t: t,
          s: i,
          point: n
        }), t += o, t = Math.min(t, 1);

        var _c6 = this.evalAt(t);

        i += _c6.clone().subtract(n).len(), _l2.push({
          t: t,
          s: i,
          point: _c6
        }), r.push(_l2), n = _c6;
      }

      return this._segments = r, this._length = i, i;
    }
  }, {
    key: "evalAt",
    value: function evalAt(e) {
      e = this.normalizeParameter(e);

      var t = this._p0.clone().multiply(Math.pow(1 - e, 3)),
          i = this._p1.clone().multiply(3 * (1 - e) * (1 - e) * e),
          r = this._p2.clone().multiply(3 * (1 - e) * e * e),
          o = this._p3.clone().multiply(e * e * e);

      return t.add(i).add(r).add(o);
    }
  }, {
    key: "isInSegment",
    value: function isInSegment(e, t) {
      return e = this.normalizeArcLength(e), e >= t[0].s && e <= t[1].s;
    }
  }, {
    key: "getArcLengthSegment",
    value: function getArcLengthSegment(e) {
      e = this.normalizeArcLength(e);

      for (var _t14 = 0; _t14 < this._segments.length; _t14++) {
        var i = this._segments[_t14];
        if (this.isInSegment(e, i)) return i;
      }

      return null;
    }
  }, {
    key: "normalizeArcLength",
    value: function normalizeArcLength(e) {
      return Math.max(Math.min(this._length, e), 0);
    }
  }, {
    key: "normalizeParameter",
    value: function normalizeParameter(e) {
      return Math.max(Math.min(1, e), 0);
    }
  }, {
    key: "getParameterForArcLength",
    value: function getParameterForArcLength(e) {
      var t = this.normalizeArcLength(e),
          i = this.getArcLengthSegment(t);
      if (!i) return A.warn("CubicBezierCurve#getParameterForArcLength", "Segment not found."), -1;
      var r = (t - i[1].s) / (i[0].s - i[1].s);
      return r * i[0].t + (1 - r) * i[1].t;
    }
  }, {
    key: "evalAtArcLength",
    value: function evalAtArcLength(e) {
      return this.evalAt(this.getParameterForArcLength(e));
    }
  }, {
    key: "approximateAtArcLength",
    value: function approximateAtArcLength(e) {
      var t = this.normalizeArcLength(e),
          i = this.getArcLengthSegment(t);
      if (!i) return -1;
      var r = (t - i[1].s) / (i[0].s - i[1].s);
      return i[0].point.clone().multiply(r).add(i[1].point.clone().multiply(1 - r));
    }
  }, {
    key: "parameterSample",
    value: function parameterSample() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
      var t = 1 / e,
          i = [],
          r = 0;

      for (var _o3 = 0; _o3 <= e + 1; _o3++) {
        i.push(this.evalAt(r)), r += t;
      }

      return this._sample = i, [].concat(i);
    }
  }, {
    key: "arcLengthApproxSample",
    value: function arcLengthApproxSample() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var r = this._length / e,
          o = [],
          n = 0;

      for (var a = t ? 1 : 0; a < e + 1; a++) {
        o.push(this.approximateAtArcLength(n)), n += r;
      }

      return i && o.pop(), this._sample = o, [].concat(o);
    }
  }]);

  return rm;
}(),
    nl = rm;

var sm =
/*#__PURE__*/
function () {
  function sm(e, t) {
    _classCallCheck(this, sm);

    this.min = e, this.max = t;
  }

  _createClass(sm, [{
    key: "getMin",
    value: function getMin() {
      return this.min;
    }
  }, {
    key: "getMax",
    value: function getMax() {
      return this.max;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.max - this.min;
    }
  }, {
    key: "contains",
    value: function contains(e) {
      return this.min <= e && e <= this.max;
    }
  }]);

  return sm;
}(),
    al = sm;

var je =
/*#__PURE__*/
function () {
  function je(e, t, i) {
    _classCallCheck(this, je);

    this.x = e, this.y = t, this.z = i, typeof this.x == "undefined" && (this.x = 0), typeof this.y == "undefined" && (this.y = 0), typeof this.z == "undefined" && (this.z = 0);
  }

  _createClass(je, [{
    key: "set",
    value: function set(e, t, i) {
      return this.x = e, this.y = t, this.z = i, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new je(this.x, this.y, this.z);
    }
  }, {
    key: "copy",
    value: function copy(e) {
      return this.x = e.x, this.y = e.y, this.z = e.z, this;
    }
  }, {
    key: "clamp",
    value: function clamp(e, t) {
      var i = e !== null && typeof e != "undefined",
          r = t !== null && typeof t != "undefined";
      return !(e instanceof je) && i && (e = new je(e, e, e)), !(t instanceof je) && r && (t = new je(t, t, t)), i && (this.x = Math.max(e.x, this.x), this.y = Math.max(e.y, this.y), this.z = Math.max(e.z, this.z)), r && (this.x = Math.min(t.x, this.x), this.y = Math.min(t.y, this.y), this.z = Math.min(t.z, this.z)), this;
    }
  }, {
    key: "divide",
    value: function divide(e) {
      return e instanceof je ? (this.x /= e.x, this.y /= e.y, this.z /= e.z) : (this.x /= e, this.y /= e, this.z /= e), this;
    }
  }, {
    key: "subtract",
    value: function subtract(e) {
      return e instanceof je ? (this.x -= e.x, this.y -= e.y, this.z -= e.z) : (this.x -= e, this.y -= e, this.z -= e), this;
    }
  }, {
    key: "multiply",
    value: function multiply(e) {
      return e instanceof je ? (this.x *= e.x, this.y *= e.y, this.z *= e.z) : (this.x *= e, this.y *= e, this.z *= e), this;
    }
  }, {
    key: "add",
    value: function add(e) {
      return e instanceof je ? (this.x += e.x, this.y += e.y, this.z += e.z) : (this.x += e, this.y += e, this.z += e), this;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return e instanceof je ? e.x === this.x && e.y === this.y && e.z === this.z : e === this.x && e === this.y && e === this.z;
    }
  }, {
    key: "round",
    value: function round() {
      return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
  }, {
    key: "floor",
    value: function floor() {
      return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
  }, {
    key: "fract",
    value: function fract() {
      return this.x %= 1, this.y %= 1, this.z %= 1, this;
    }
  }, {
    key: "toInt",
    value: function toInt() {
      return this.x |= 0, this.y |= 0, this.z |= 0, this;
    }
  }, {
    key: "abs",
    value: function abs() {
      return this.x = Math.abs(this.x), this.y = Math.abs(this.y), this.z = Math.abs(this.z), this;
    }
  }, {
    key: "len",
    value: function len() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
  }, {
    key: "min",
    value: function min() {
      return Math.min(Math.min(this.x, this.y), this.z);
    }
  }, {
    key: "max",
    value: function max() {
      return Math.max(Math.max(this.x, this.y), this.z);
    }
  }, {
    key: "toObject",
    value: function toObject() {
      return {
        x: this.x,
        y: this.y,
        z: this.z
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Vector3({ x: ".concat(this.x, ", y: ").concat(this.y, ", z: ").concat(this.z, " })");
    }
  }, {
    key: "roundDecimal",
    value: function roundDecimal(e) {
      return this.x = parseFloat(this.x.toFixed(e)), this.y = parseFloat(this.y.toFixed(e)), this.z = parseFloat(this.z.toFixed(e)), this;
    }
  }], [{
    key: "fromObject",
    value: function fromObject(e) {
      return new je(e.x, e.y, e.z);
    }
  }, {
    key: "NULL",
    get: function get() {
      return new je(0, 0, 0);
    }
  }]);

  return je;
}(),
    ll = je;

var cl =
/*#__PURE__*/
function () {
  function cl() {
    _classCallCheck(this, cl);

    this._container = new Ft();
    this._sprite = new bs();

    this._container.addChild(this._sprite);
  }

  _createClass(cl, [{
    key: "render",
    value: function render(e, t, i) {
      var r = i.getDimensions(),
          o = this._getNextHighestPOT(r);

      this._renderTexture ? this._renderTexture.resizeTo(o) : this._renderTexture = new fs(e, o.x, o.y);

      var n = this._renderTexture.getDimensions();

      this._sprite.setTexture(i), this._sprite.updateTransform(), this._renderTexture.clear(), this._renderTexture.render(this._container), this._updateSprite(e, t, r, n);
    }
  }, {
    key: "_updateSprite",
    value: function _updateSprite(e, t, i, r) {
      t.setTexture(this._renderTexture), this._renderTexture.setFrame(new le(0, 0, i.x, i.y));
    }
  }, {
    key: "_getNextHighestPOT",
    value: function _getNextHighestPOT(e) {
      return new B(T.nextHighestPOT(e.x), T.nextHighestPOT(e.y));
    }
  }, {
    key: "getRenderTexture",
    value: function getRenderTexture() {
      return this._renderTexture;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      !this._renderTexture || (this._renderTexture.dispose(), delete this._renderTexture);
    }
  }]);

  return cl;
}();

var bs =
/*#__PURE__*/
function (_Ft) {
  _inherits(bs, _Ft);

  function bs(e) {
    var _this38;

    _classCallCheck(this, bs);

    _this38 = _possibleConstructorReturn(this, _getPrototypeOf(bs).call(this));
    _this38._shader = null;
    _this38._width = 0;
    _this38._height = 0;
    _this38._anchor = new B(0, 0);
    _this38._canvasSmoothingEnabled = !0;
    _this38._smoothDownscaling = !1;
    _this38._onTextureUpdate = _this38._onTextureUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this38))), _this38.setTexture(e);
    return _this38;
  }

  _createClass(bs, [{
    key: "_onTextureUpdate",
    value: function _onTextureUpdate() {
      this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
    }
  }, {
    key: "_renderWebGL",
    value: function _renderWebGL(e) {
      var t = e.save();
      this._smoothDownscaling && (this._potRenderer || (this._potRenderer = new cl()), this._texture && this._potRenderer.render(e, this, this._texture)), e.restore(t), e.setObjectRenderer(e.renderers.sprite), e.renderers.sprite.render(this);
    }
  }, {
    key: "_renderCanvas",
    value: function _renderCanvas(e) {
      if (!this._texture) return;

      var t = this._worldTransform,
          i = this._texture.getFrame(),
          r = i.width,
          o = i.height,
          n = e.getCurrentRenderTarget().getPixelRatio(),
          a = this._anchor.x * -r | 0,
          l = this._anchor.y * -o | 0,
          c = e.getContext();

      if (c.setTransform(t.a, t.b, t.c, t.d, t.tx * n, t.ty * n), c.globalAlpha = this.getWorldAlpha(), !this._texture) return;

      var u = this._texture.getBaseTexture(),
          p = u.getPixelRatio(),
          h = u.getSource();

      c.imageSmoothingEnabled = this._canvasSmoothingEnabled, "beforeDraw" in e && e.beforeDraw(c), c.drawImage(h, 0, 0, (h.naturalWidth || r) * p, (h.naturalHeight || o) * p, a * n, l * n, r * n, o * n);
    }
  }, {
    key: "isAtPosition",
    value: function isAtPosition(e) {
      if (!this._texture) return;

      var t = this._worldTransform.applyInverseToVector(e),
          i = this._texture.getFrame(),
          r = i.width,
          o = i.height,
          n = new B(-r, -o);

      n.multiply(this._anchor);
      var a = n.clone().add(r, o);
      return !(t.x < n.x || t.x > a.x || t.y < n.y || t.y > a.y);
    }
  }, {
    key: "getLocalBounds",
    value: function getLocalBounds() {
      if (this._localBoundsNeedUpdate && this._texture) {
        var _e11 = this._localBounds,
            _t15 = this._texture.getFrame();

        _e11.x = -_t15.width * this._anchor.x, _e11.y = -_t15.height * this._anchor.y, _e11.width = _t15.width, _e11.height = _t15.height, this._localBoundsNeedUpdate = !1;
      }

      return this._localBounds.clone();
    }
  }, {
    key: "getBounds",
    value: function getBounds() {
      if (this._boundsNeedUpdate && this._texture) {
        var _e12 = this._bounds,
            _t16 = this._texture.getFrame(),
            i = this._worldTransform,
            r = this._anchor,
            _o4 = i.rectangleToCoordinates(_t16, r),
            _n3 = _o4[0].x,
            a = _o4[0].y,
            _l3 = _n3,
            _c7 = a;

        _o4.forEach(function (_ref39) {
          var u = _ref39.x,
              p = _ref39.y;
          _n3 = Math.min(_n3, u), a = Math.min(a, p), _l3 = Math.max(_l3, u), _c7 = Math.max(_c7, p);
        }), _e12.x = _n3, _e12.width = Math.abs(_l3 - _n3), _e12.y = a, _e12.height = Math.abs(_c7 - a), this._boundsNeedUpdate = !1;
      }

      return this._bounds.clone();
    }
  }, {
    key: "getTexture",
    value: function getTexture() {
      return this._texture;
    }
  }, {
    key: "clearTexture",
    value: function clearTexture() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      !this._texture || (this._texture.off("update", this._onTextureUpdate), e && this._texture.dispose(), this._texture = null, this._potRenderer && (e && this._potRenderer.dispose(), delete this._potRenderer));
    }
  }, {
    key: "setTexture",
    value: function setTexture(e) {
      !e || (this._texture && this._texture.off("update", this._onTextureUpdate), this._potRenderer && this._potRenderer.getRenderTexture().getBaseTexture().setDirty(!0), this._texture = e, e.getBaseTexture().isLoaded() && this._onTextureUpdate(), e.on("update", this._onTextureUpdate));
    }
  }, {
    key: "getShader",
    value: function getShader() {
      return this._shader;
    }
  }, {
    key: "setShader",
    value: function setShader(e) {
      this._shader = e;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this._width;
    }
  }, {
    key: "setWidth",
    value: function setWidth(e) {
      !this._texture || (this._scale.x = e / this._texture.getFrame().width, this._width = e, this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0);
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this._height;
    }
  }, {
    key: "setHeight",
    value: function setHeight(e) {
      !this._texture || (this._scale.y = e / this._texture.getFrame().height, this._height = e, this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0);
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return new B(this._width, this._height);
    }
  }, {
    key: "getAnchor",
    value: function getAnchor() {
      return this._anchor;
    }
  }, {
    key: "setAnchor",
    value: function setAnchor(e, t) {
      this._anchor.set(e, t), this._boundsNeedUpdate = !0, this._localBoundsNeedUpdate = !0;
    }
  }, {
    key: "isSmoothDownscaling",
    value: function isSmoothDownscaling() {
      return this._smoothDownscaling;
    }
  }, {
    key: "setSmoothDownscaling",
    value: function setSmoothDownscaling(e) {
      this._smoothDownscaling = e;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      this._texture && this._texture.off("update", this._onTextureUpdate), (e || t) && this._texture && this._texture.dispose(t), this._potRenderer && this._potRenderer.dispose();
    }
  }]);

  return bs;
}(Ft);

var Kf = {
  CanvasFilterManager: Ei,
  Container: Ft,
  BaseTexture: xe,
  Texture: ni,
  RenderTexture: fs,
  WebGLRenderTarget: Wt,
  CanvasRenderTarget: Gt,
  Sprite: bs,
  Filter: xt,
  Filters: Ya,
  PixelArrayImage: Ks,
  autoDetectRenderer: function autoDetectRenderer(s, e) {
    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return Ae.isSupported() ? new to(s, e, t) : new nr(s, e, t);
  },
  canvasRenderer: function canvasRenderer(s, e) {
    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return new nr(s, e, t);
  }
},
    k = Kf;

var om =
/*#__PURE__*/
function () {
  function om() {
    _classCallCheck(this, om);
  }

  _createClass(om, null, [{
    key: "current",
    value: function current() {
      return process.env.ENV;
    }
  }, {
    key: "isTest",
    value: function isTest() {
      return process.env.ENV === "test";
    }
  }, {
    key: "isDevelopment",
    value: function isDevelopment() {
      return process.env.ENV === "development";
    }
  }, {
    key: "isProduction",
    value: function isProduction() {
      return process.env.ENV === "production" || !this.isTest() && !this.isDevelopment();
    }
  }]);

  return om;
}(),
    nm = om;

var am =
/*#__PURE__*/
function () {
  function am(e) {
    _classCallCheck(this, am);

    this._head = 0, this._buf = e;
  }

  _createClass(am, [{
    key: "peekInt8",
    value: function peekInt8() {
      return this._buf[this._head];
    }
  }, {
    key: "peekInt16",
    value: function peekInt16() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this._buf[this._head],
          i = this._buf[this._head + 1];
      return e ? (i << 8) + t : (t << 8) + i;
    }
  }, {
    key: "peekInt24",
    value: function peekInt24() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this._buf[this._head],
          i = this._buf[this._head + 1],
          r = this._buf[this._head + 2];
      return e ? (r << 16) + (i << 8) + t : (t << 16) + (i << 8) + r;
    }
  }, {
    key: "peekInt32",
    value: function peekInt32() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this._buf[this._head],
          i = this._buf[this._head + 1],
          r = this._buf[this._head + 2],
          o = this._buf[this._head + 3];
      return e ? (o << 32) + (r << 16) + (i << 8) + t : (t << 32) + (i << 16) + (r << 8) + o;
    }
  }, {
    key: "writeInt8",
    value: function writeInt8(e) {
      this._buf[this._head] = e & 255;
    }
  }, {
    key: "writeInt16",
    value: function writeInt16(e) {
      this._buf[this._head] = e >> 8, this._buf[this._head + 1] = e & 255;
    }
  }, {
    key: "readInt8",
    value: function readInt8() {
      var e = this.peekInt8();
      return this._head += 1, e;
    }
  }, {
    key: "readInt16",
    value: function readInt16() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this.peekInt16(e);
      return this._head += 2, t;
    }
  }, {
    key: "readInt24",
    value: function readInt24() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this.peekInt24(e);
      return this._head += 3, t;
    }
  }, {
    key: "readInt32",
    value: function readInt32() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this.peekInt32(e);
      return this._head += 4, t;
    }
  }, {
    key: "readString",
    value: function readString(e) {
      var t = "";

      for (var i = 0; i < e; i++) {
        var r = this.readInt8();
        t += String.fromCharCode(r);
      }

      return t;
    }
  }, {
    key: "getHead",
    value: function getHead() {
      return this._head;
    }
  }, {
    key: "setHead",
    value: function setHead(e) {
      this._head = e;
    }
  }]);

  return am;
}(),
    Pi = am;

var Xf = {
  SOI: 65496,
  SOS: 65498,
  APP0: 65504,
  APP1: 65505,
  JFIF: 65504,
  EXIF: 65505
},
    Qf = {
  256: "ImageWidth",
  257: "ImageHeight",
  34665: "ExifIFDPointer",
  34853: "GPSInfoIFDPointer",
  40965: "InteroperabilityIFDPointer",
  258: "BitsPerSample",
  259: "Compression",
  262: "PhotometricInterpretation",
  274: "Orientation",
  277: "SamplesPerPixel",
  284: "PlanarConfiguration",
  530: "YCbCrSubSampling",
  531: "YCbCrPositioning",
  282: "XResolution",
  283: "YResolution",
  296: "ResolutionUnit",
  273: "StripOffsets",
  278: "RowsPerStrip",
  279: "StripByteCounts",
  513: "JPEGInterchangeFormat",
  514: "JPEGInterchangeFormatLength",
  301: "TransferFunction",
  318: "WhitePoint",
  319: "PrimaryChromaticities",
  529: "YCbCrCoefficients",
  532: "ReferenceBlackWhite",
  306: "DateTime",
  270: "ImageDescription",
  271: "Make",
  272: "Model",
  305: "Software",
  315: "Artist",
  33432: "Copyright"
},
    mr = {
  MARKERS: Xf,
  EXIF_TAGS: Qf
};

var ul = T.invariant,
    Zf = mr.MARKERS,
    lm = mr.EXIF_TAGS,
    cm =
/*#__PURE__*/
function () {
  function cm(e) {
    _classCallCheck(this, cm);

    this._buf = e, this._stream = new Pi(this._buf), this._stream.setHead(0), this._parse(), this._bigEndian = !1;
  }

  _createClass(cm, [{
    key: "isValid",
    value: function isValid() {
      return this._stream.setHead(0), !(this._stream.readInt16() !== Zf.EXIF || !(this._stream.readInt16() > 0) || this._stream.readString(4) !== "Exif");
    }
  }, {
    key: "_parse",
    value: function _parse() {
      if (!this.isValid()) return;

      this._stream.setHead(10);

      var e = this._stream.getHead();

      this._bigEndian = !1;

      var t = this._stream.readInt16();

      t === 18761 ? this._bigEndian = !1 : t === 19789 ? this._bigEndian = !0 : ul(!1, "Invalid TIFF data: No endian type found"), ul(this._stream.readInt16(!this._bigEndian) === 42, "Invalid TIFF data: No 0x002A");

      var i = this._stream.readInt32(!this._bigEndian);

      ul(i >= 8, "Invalid TIFF data: First IFD offset < 8");

      var r = e + i,
          o = this._readTags(this._stream, e, r, this._bigEndian);

      this._tags = o.tags, this._tagData = o.tagData;
    }
  }, {
    key: "getTags",
    value: function getTags() {
      return this._tags;
    }
  }, {
    key: "getTagData",
    value: function getTagData() {
      return this._tagData;
    }
  }, {
    key: "setOrientation",
    value: function setOrientation(e) {
      if (this._tagData.Orientation) {
        var _t17 = this._tagData.Orientation.entryOffset;
        this._stream.setHead(_t17 + 8), this._stream.writeInt16(this._bigEndian ? e : (e & 255) << 8 | e >> 8 & 255);
      }
    }
  }, {
    key: "_readTags",
    value: function _readTags(e, t, i, r) {
      e.setHead(i);
      var o = e.readInt16(!r),
          n = {},
          a = [];

      for (var _l4 = 0; _l4 < o; _l4++) {
        var _c8 = i + _l4 * 12 + 2;

        e.setHead(_c8);

        var _u3 = e.readInt16(!r),
            _p2 = void 0,
            _h2 = void 0,
            _d6 = void 0;

        if (lm[_u3]) {
          _u3 = lm[_u3], _p2 = e.readInt16(!r), _h2 = e.readInt32(!r), _d6 = e.readInt32(!r) + t;
          var _g3 = null;

          switch (_p2) {
            case 1:
            case 7:
              if (_h2 === 1) _g3 = e.readInt8(!r);else {
                _g3 = [];

                for (var _y2 = 0; _y2 < _h2; _y2++) {
                  _g3.push(e.readInt8(!r));
                }
              }
              break;

            case 2:
              e.setHead(_h2 > 4 ? _d6 : _c8 + 8), _g3 = e.readString(_h2);
              break;

            case 3:
              if (e.setHead(_h2 > 2 ? _d6 : _c8 + 8), _h2 === 1) _g3 = e.readInt16(!r);else {
                _g3 = [];

                for (var _y3 = 0; _y3 < _h2; _y3++) {
                  _g3.push(e.readInt16(!r));
                }
              }
              break;

            case 4:
            case 9:
              if (e.setHead(_h2 > 1 ? _d6 : _c8 + 8), _h2 === 1) _g3 = e.readInt32(!r);else {
                _g3 = [];

                for (var _y4 = 0; _y4 < _h2; _y4++) {
                  _g3.push(e.readInt32(!r));
                }
              }
              break;

            case 5:
            case 10:
              if (e.setHead(_d6), _h2 === 1) {
                var _y5 = e.readInt32(!r),
                    _8 = e.readInt32(!r);

                _g3 = _y5 / _8;
              } else {
                _g3 = [];

                for (var _y6 = 0; _y6 < _h2; _y6++) {
                  var _9 = e.readInt32(!r),
                      f = e.readInt32(!r),
                      v = _9 / f;

                  _g3.push(v);
                }
              }

              break;
          }

          n[_u3] = _g3, a[_u3] = {
            value: _g3,
            numValues: _h2,
            entryOffset: _c8,
            valueOffset: _d6,
            type: _p2
          };
        }
      }

      return {
        tags: n,
        tagData: a
      };
    }
  }, {
    key: "getBuffer",
    value: function getBuffer() {
      return this._buf;
    }
  }]);

  return cm;
}(),
    um = cm;

var $f = mr.MARKERS,
    mm =
/*#__PURE__*/
function () {
  function mm(e) {
    _classCallCheck(this, mm);

    this._buf = e, this._stream = new Pi(this._buf), this._stream.setHead(0);
  }

  _createClass(mm, [{
    key: "isValid",
    value: function isValid() {
      if (this._stream.setHead(0), this._stream.readInt16() !== $f.APP0 || !(this._stream.readInt16() >= 16)) return !1;

      var i = this._stream.readString(4),
          r = this._stream.readInt8();

      return !(i !== "JFIF" || r !== 0);
    }
  }, {
    key: "setUnitDensity",
    value: function setUnitDensity(e) {
      this._stream.setHead(11), this._stream.writeInt8(e);
    }
  }, {
    key: "setDensityX",
    value: function setDensityX(e) {
      this._stream.setHead(12), this._stream.writeInt16(e);
    }
  }, {
    key: "setDensityY",
    value: function setDensityY(e) {
      this._stream.setHead(14), this._stream.writeInt16(e);
    }
  }, {
    key: "getUnitDensity",
    value: function getUnitDensity() {
      return this._stream.setHead(11), this._stream.readInt8();
    }
  }, {
    key: "getDensityX",
    value: function getDensityX() {
      return this._stream.setHead(12), this._stream.readInt16();
    }
  }, {
    key: "getDensityY",
    value: function getDensityY() {
      return this._stream.setHead(14), this._stream.readInt16();
    }
  }, {
    key: "getBuffer",
    value: function getBuffer() {
      return this._buf;
    }
  }]);

  return mm;
}(),
    ml = mm;

var xs = mr.MARKERS,
    no = "data:image/jpeg;base64,",
    Jf = new RegExp("^".concat(no), "i"),
    St =
/*#__PURE__*/
function () {
  function St(e) {
    _classCallCheck(this, St);

    this._buf = e, this._stream = new Pi(this._buf), this._stream.setHead(0), this._segments = this._sliceIntoSegments(this._buf), this._exifData = new um(this._getMarkerBuffer(xs.EXIF)), this._jfifData = new ml(this._getMarkerBuffer(xs.JFIF));
  }

  _createClass(St, [{
    key: "restoreSegmentsInArray",
    value: function restoreSegmentsInArray(e) {
      return e = this.restoreExifTagsToImageData(e), this.restoreJfifSegmentToImageData(e);
    }
  }, {
    key: "restoreSegments",
    value: function restoreSegments(e) {
      var t = St.fromDataURL(e);
      return t = this.restoreSegmentsInArray(t), St.toDataURL(t);
    }
  }, {
    key: "restoreExifTagsToImageData",
    value: function restoreExifTagsToImageData(e) {
      if (!this._exifData.isValid()) return e;

      var i = this._sliceIntoSegments(e)[1][0],
          r = e.slice(0, i),
          o = e.slice(i),
          n = r.concat(this._exifData.getBuffer());

      return n = n.concat(o), n;
    }
  }, {
    key: "restoreJfifSegmentToImageData",
    value: function restoreJfifSegmentToImageData(e) {
      if (!this._jfifData.isValid()) return e;

      var t = this._sliceIntoSegments(e),
          i = this._findSegment(xs.JFIF, t),
          r = [];

      if (i) {
        var _o5 = i[0],
            _n4 = i[1],
            _a2 = e.slice(0, _o5),
            _l5 = e.slice(_o5, _n4),
            _c9 = e.slice(_n4),
            _u4 = new ml(_l5);

        _u4.setDensityX(this._jfifData.getDensityX()), _u4.setDensityY(this._jfifData.getDensityY()), _u4.setUnitDensity(this._jfifData.getUnitDensity()), r = _a2.concat(_l5).concat(_c9);
      } else return e;

      return r;
    }
  }, {
    key: "restoreExifTags",
    value: function restoreExifTags(e) {
      var t = St.fromDataURL(e),
          i = this.restoreExifTagsToImageData(t);
      return St.toDataURL(i);
    }
  }, {
    key: "restoreJfifSegment",
    value: function restoreJfifSegment(e) {
      if (!this._jfifData.isValid()) return e;
      var t = St.fromDataURL(e),
          i = this.restoreJfifSegmentToImageData(t);
      return St.toDataURL(i);
    }
  }, {
    key: "setOrientation",
    value: function setOrientation(e) {
      return this._exifData.setOrientation(e);
    }
  }, {
    key: "_findSegment",
    value: function _findSegment(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._segments;

      for (var _i6 = 0; _i6 < t.length; _i6++) {
        var r = t[_i6][0],
            _o6 = t[_i6][1];
        if (this._stream.setHead(r), this._stream.peekInt16() === e) return [r, _o6];
      }

      return !1;
    }
  }, {
    key: "_getLastSegment",
    value: function _getLastSegment() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._segments;
      return e[e.length - 1];
    }
  }, {
    key: "_getMarkerBuffer",
    value: function _getMarkerBuffer(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._segments;

      var i = this._findSegment(e, t);

      if (i) {
        var r = i[0],
            _o7 = i[1];
        return this._buf.slice(r, _o7);
      }

      return !1;
    }
  }, {
    key: "_sliceIntoSegments",
    value: function _sliceIntoSegments(e) {
      var t = new Pi(e),
          i = [];

      for (; t.getHead() < e.length;) {
        var r = t.readInt16();

        if (r !== xs.SOI) {
          if (r === xs.SOS) break;

          if (r >= 65280 && r <= 65535) {
            var _o8 = t.readInt16(),
                _n5 = t.getHead() + _o8 - 2;

            i.push([t.getHead() - 4, _n5]), t.setHead(_n5);
          } else throw new Error("Invalid marker: 0x".concat(r.toString(16)));
        }
      }

      return this._stream.setHead(0), i;
    }
  }, {
    key: "getTags",
    value: function getTags() {
      return this._exifData.getTags();
    }
  }, {
    key: "getTagData",
    value: function getTagData() {
      return this._exifData.getTagData();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._buf = [], this._segments = [];
    }
  }], [{
    key: "toDataURL",
    value: function toDataURL(e) {
      return no + bt.encode(e);
    }
  }, {
    key: "fromDataURL",
    value: function fromDataURL(e) {
      var t = e.replace(no, "");
      return bt.decode(t);
    }
  }, {
    key: "isJPEG",
    value: function isJPEG(e) {
      return Jf.test(e);
    }
  }, {
    key: "bufferIsJPEG",
    value: function bufferIsJPEG(e) {
      return e[0] === 255 && e[1] === 216 && e[2] === 255;
    }
  }, {
    key: "fromBase64String",
    value: function fromBase64String(e) {
      var t = e.replace(no, ""),
          i = bt.decode(t);
      return new St(i);
    }
  }]);

  return St;
}(),
    vs = St;

var dm;
dm = window.Image;
var $e = dm;

var ao =
/*#__PURE__*/
function (_We5) {
  _inherits(ao, _We5);

  function ao() {
    var _this39;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, ao);

    _this39 = _possibleConstructorReturn(this, _getPrototypeOf(ao).call(this));
    _this39._onOperationUpdate = _this39._onOperationUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this39))), _this39._cacheEnabled = !0, _this39._stack = e, _this39._stack.forEach(function (t) {
      t.on("update", _this39._onOperationUpdate);
    });
    return _this39;
  }

  _createClass(ao, [{
    key: "clear",
    value: function clear() {
      var _this40 = this;

      this.forEach(function (e) {
        return _this40.remove(e);
      }), this._stack = [];
    }
  }, {
    key: "hasChanges",
    value: function hasChanges() {
      return this._stack.filter(function (e) {
        return !!e;
      }).some(function (e) {
        return e.hasChanges();
      });
    }
  }, {
    key: "_onOperationUpdate",
    value: function _onOperationUpdate(e, t) {
      this.emit(lr.OPERATION_UPDATED, e, t);
    }
  }, {
    key: "enableCache",
    value: function enableCache() {
      this._cacheEnabled = !0;
    }
  }, {
    key: "disableCache",
    value: function disableCache() {
      this._cacheEnabled = !1;
    }
  }, {
    key: "forEach",
    value: function forEach(e) {
      return this._stack.filter(function (t) {
        return !!t;
      }).forEach(e);
    }
  }, {
    key: "render",
    value: function render(e, t) {
      var _this41 = this;

      var i = t,
          r = this._stack.filter(function (c) {
        return !!c;
      }).filter(function (c) {
        return c.getEnabled();
      });

      r.reverse();
      var o = r.filter(function (c) {
        return !c.isDirtyForRenderer(e.getRenderer());
      })[0],
          n = r.indexOf(o);
      r.reverse();
      var a = 0;
      n !== -1 && (a = r.length - n - 1);

      for (var _c10 = 0; _c10 < a; _c10++) {
        A.info(this.constructor.name, "Skipping ".concat(r[_c10].constructor.name));
      }

      var l = Promise.resolve(i);

      var _loop4 = function _loop4(_c11) {
        var u = r[_c11],
            p = void 0,
            h = void 0;
        l = l.then(function (d) {
          return u.render(d).then(function (g) {
            return p && g !== p && !_this41._cacheEnabled && h.disposeRenderTextures(), p = g, h = u, g;
          });
        });
      };

      for (var _c11 = a; _c11 < r.length; _c11++) {
        _loop4(_c11);
      }

      return l.then(function (c) {
        var u = !r.some(function (p) {
          return p.isDirtyForRenderer(e.getRenderer());
        });
        return {
          outputTexture: c,
          renderDone: u
        };
      });
    }
  }, {
    key: "validateSettings",
    value: function validateSettings() {
      return Promise.all(this._stack.filter(function (e) {
        return !!e;
      }).map(function (e) {
        return e.validateSettings();
      }));
    }
  }, {
    key: "setAllToDirty",
    value: function setAllToDirty() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      this.forEach(function (t) {
        return t.setDirty(!0, e);
      });
    }
  }, {
    key: "updateDirtinessForRenderer",
    value: function updateDirtinessForRenderer(e) {
      var t = !1;

      for (var _i7 = 0; _i7 < this._stack.length; _i7++) {
        var r = this._stack[_i7];
        !r || (r.isDirtyForRenderer(e) && (t = !0), t && r.setDirtyForRenderer(!0, e));
      }
    }
  }, {
    key: "push",
    value: function push(e) {
      this._stack.push(e), e.on("update", this._onOperationUpdate);
    }
  }, {
    key: "pop",
    value: function pop() {
      var e = this._stack.pop();

      e && (e.off("update", this._onOperationUpdate), e.dispose());
    }
  }, {
    key: "unshift",
    value: function unshift(e) {
      this._stack.unshift(e), e.on("update", this._onOperationUpdate);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new ao(this._stack.slice(0));
    }
  }, {
    key: "get",
    value: function get(e) {
      return this._stack[e];
    }
  }, {
    key: "getByIdentifier",
    value: function getByIdentifier(e) {
      return T.Array.find(this._stack, function (t) {
        return t && t.constructor.identifier === e;
      });
    }
  }, {
    key: "getIndexByIdentifier",
    value: function getIndexByIdentifier(e) {
      return T.Array.findIndex(this._stack, function (t) {
        return t && t.constructor.identifier === e;
      });
    }
  }, {
    key: "moveToTop",
    value: function moveToTop(e) {
      var t = T.Array.findIndex(this._stack, function (r) {
        return r && r.constructor.identifier === e;
      });
      if (t < 0 || t === this._stack.length - 1) return;
      var i = this.getByIdentifier(e);
      this._stack.splice(t, 1), this._stack[this._stack.length] = i;
    }
  }, {
    key: "set",
    value: function set(e, t) {
      this._stack[e] && (this._stack[e].off("update", this._onOperationUpdate), this._stack[e].dispose()), this._stack[e] = t, t.on("update", this._onOperationUpdate);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this._stack.indexOf(e);

      t !== -1 && (this._stack[t] && (this._stack[t].off("update", this._onOperationUpdate), this._stack[t].dispose()), this._stack.splice(t, 1));
    }
  }, {
    key: "removeAt",
    value: function removeAt(e) {
      this._stack[e] && (this._stack[e].off("update", this._onOperationUpdate), this._stack[e].dispose()), delete this._stack[e];
    }
  }, {
    key: "getStack",
    value: function getStack() {
      return this._stack;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.forEach(function (e) {
        e.dispose();
      });
    }
  }]);

  return ao;
}(We),
    lo = ao;

var dr = {};
we(dr, {
  ExifOrientationOperation: function ExifOrientationOperation() {
    return gm;
  }
});

var hm = typeof window != "undefined" && window.performance && window.performance.now ? window.performance.now.bind(window.performance) : ke(),
    pm =
/*#__PURE__*/
function () {
  function pm(e, t) {
    _classCallCheck(this, pm);

    this._tag = e, this._name = t, this._start = hm();
  }

  _createClass(pm, [{
    key: "stop",
    value: function stop() {
      var t = hm() - this._start,
          i = Math.round(1e3 / t);

      A.info(this._tag, "".concat(this._name, " took ").concat(t.toFixed(2), "ms (").concat(i, " FPS)"));
    }
  }]);

  return pm;
}(),
    co = pm;

var dl =
/*#__PURE__*/
function (_V2) {
  _inherits(dl, _V2);

  function dl(e) {
    var _this42;

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, dl);

    _this42 = _possibleConstructorReturn(this, _getPrototypeOf(dl).call(this, t, {
      enabled: {
        type: m.BOOLEAN,
        default: !0,
        serializable: !1
      }
    }));
    _this42._sdk = e, _this42._cacheEnabled = !1, _this42._dirtiness = {}, _this42._sprite = new k.Sprite(), _this42._container = new k.Container(), _this42._container.addChild(_this42._sprite);
    return _this42;
  }

  _createClass(dl, [{
    key: "_onOptionsChange",
    value: function _onOptionsChange() {
      this.setDirty(!0);
    }
  }, {
    key: "render",
    value: function render(e) {
      var _this43 = this;

      if (!this.getEnabled()) return A.info(this.constructor.name, "Disabled - skipping"), Promise.resolve(e);

      if (!this._renderTexture) {
        var _o9 = e.getDimensions().floor();

        this._renderTexture = new k.RenderTexture(this._sdk.getRenderer(), _o9.x, _o9.y);
      }

      var t = this._sdk.getRenderer(),
          i,
          r;

      if (A.canLog("info") && (r = new co(this.constructor.name, "Rendering")), this.isDirtyForRenderer(t)) {
        this._sprite.setTexture(e);

        var _o10 = this.getNewDimensions(e.getDimensions()).floor();

        this._renderTexture.resizeTo(_o10), this._renderTexture.clear(), i = this._render(e).then(function () {
          var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          return _this43.setDirtyForRenderer(n, t), _this43._renderTexture;
        });
      } else A.info(this.constructor.name, "Rendering from cache"), i = Promise.resolve(this._renderTexture);

      return i.then(function (o) {
        return r && r.stop(), o;
      });
    }
  }, {
    key: "_render",
    value: function _render(e) {
      var t;
      return this._sdk.getRenderer().isOfType(U.WEBGL) ? t = this._renderWebGL.bind(this) : t = this._renderCanvas.bind(this), t(e);
    }
  }, {
    key: "_renderWebGL",
    value: function _renderWebGL(e) {
      throw new Error("Operation#_renderWebGL is abstract and not implemented in inherited class.");
    }
  }, {
    key: "_renderCanvas",
    value: function _renderCanvas(e) {
      throw new Error("Operation#_renderCanvas is abstract and not implemented in inherited class.");
    }
  }, {
    key: "getNewDimensions",
    value: function getNewDimensions(e) {
      return e.clone();
    }
  }, {
    key: "onBeforeExport",
    value: function onBeforeExport() {
      this.transform && this._tempTransformChange && this.transform(this._tempTransformChange), this._onBeforeExport();
    }
  }, {
    key: "onAfterExport",
    value: function onAfterExport() {
      this.transform && this._tempInverseTransformChange && this.transform(this._tempInverseTransformChange), this._onAfterExport();
    }
  }, {
    key: "_onBeforeExport",
    value: function _onBeforeExport() {}
  }, {
    key: "_onAfterExport",
    value: function _onAfterExport() {}
  }, {
    key: "setTemporaryTransformChange",
    value: function setTemporaryTransformChange(e, t) {
      this._tempTransformChange = e, this._tempInverseTransformChange = t;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._dirty = !0, this._glslPrograms = {};
    }
  }, {
    key: "isDirtyForRenderer",
    value: function isDirtyForRenderer(e) {
      var t = this._dirtiness[e.id];
      return typeof t == "undefined" ? !0 : t;
    }
  }, {
    key: "setDirtyForRenderer",
    value: function setDirtyForRenderer(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      this._dirtiness[t.id] = e;
    }
  }, {
    key: "setDirty",
    value: function setDirty(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      for (var _i8 in this._dirtiness) {
        this.setDirtyForRenderer(e, {
          id: _i8
        }, t);
      }
    }
  }, {
    key: "getSDK",
    value: function getSDK() {
      return this._sdk;
    }
  }, {
    key: "getInputDimensions",
    value: function getInputDimensions() {
      var _this44 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;

      var t = this._sdk.getInputDimensions();

      e && t.multiply(this._sdk.getZoom()).floor();
      var i;
      return this._sdk.getOperationsStack().forEach(function (r) {
        if (!i) {
          if (r === _this44) {
            i = !0;
            return;
          }

          t = r.getNewDimensions(t);
        }
      }), t.floor();
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = this.constructor;
      return new e(this._sdk, this.serializeOptions());
    }
  }, {
    key: "disposeRenderTextures",
    value: function disposeRenderTextures() {
      this._renderTexture && this._renderTexture.dispose(), this._renderTexture = null;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposeRenderTextures(), this._sprite.dispose();
    }
  }]);

  return dl;
}(V);

dl.identifier = null;
var ee = dl;

var e_ = Xe.OptionType,
    uo =
/*#__PURE__*/
function (_ee) {
  _inherits(uo, _ee);

  function uo() {
    _classCallCheck(this, uo);

    return _possibleConstructorReturn(this, _getPrototypeOf(uo).apply(this, arguments));
  }

  _createClass(uo, [{
    key: "getRotation",
    value: function getRotation() {
      var e = 0;

      switch (this.getTags().Orientation) {
        case 7:
        case 8:
          e = -90;
          break;

        case 3:
        case 4:
          e = -180;
          break;

        case 5:
        case 6:
          e = 90;
          break;
      }

      return e;
    }
  }, {
    key: "_getFlipVertically",
    value: function _getFlipVertically() {
      var _this$getTags = this.getTags(),
          e = _this$getTags.Orientation;

      return [5, 7].indexOf(e) !== -1;
    }
  }, {
    key: "_getFlipHorizontally",
    value: function _getFlipHorizontally() {
      var _this$getTags2 = this.getTags(),
          e = _this$getTags2.Orientation;

      return [2, 4].indexOf(e) !== -1;
    }
  }, {
    key: "_getFinalOptions",
    value: function _getFinalOptions() {
      return {
        rotation: this.getRotation(),
        flipVertically: this._getFlipVertically(),
        flipHorizontally: this._getFlipHorizontally()
      };
    }
  }, {
    key: "_render",
    value: function _render(e) {
      var t = this._getFinalOptions(),
          r = t.rotation % 360 * (Math.PI / 180);

      this._sprite.setScale(t.flipHorizontally ? -1 : 1, t.flipVertically ? -1 : 1), this._sprite.setRotation(r), this._sprite.setAnchor(.5, .5), this._sprite.updateTransform();

      var o = this._sprite.getBounds();

      return this._renderTexture.resizeTo(new B(o.width, o.height)), this._sprite.setPosition(this._renderTexture.getDimensions().divide(2)), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "getNewDimensions",
    value: function getNewDimensions(e) {
      var t = this._getFinalOptions();

      return e = e.clone(), t.rotation % 180 && e.flip(), e;
    }
  }, {
    key: "applyTo",
    value: function applyTo(e) {
      var t = this._getFinalOptions(),
          i = T.createCanvas();

      Math.abs(t.rotation % 180) === 90 ? (i.width = e.height, i.height = e.width) : (i.width = e.width, i.height = e.height);
      var r = i.getContext("2d"),
          o = t.rotation * Math.PI / 180,
          n = .5 * (i.width - e.width),
          a = .5 * (i.height - e.height);
      return r.translate(n, a), r.translate(.5 * e.width, .5 * e.height), r.rotate(o), r.translate(-.5 * e.width, -.5 * e.height), t.flipVertically && (r.translate(0, e.height), r.scale(1, -1)), t.flipHorizontally && (r.translate(e.width, 0), r.scale(-1, 1)), r.drawImage(e, 0, 0), i;
    }
  }]);

  return uo;
}(ee);

uo.identifier = "exif-orientation";
uo.prototype.availableOptions = {
  tags: {
    type: e_.OBJECT,
    default: {}
  }
};
var gm = uo;

var hl =
/*#__PURE__*/
function (_V3) {
  _inherits(hl, _V3);

  function hl(e) {
    var _this45;

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, hl);

    _this45 = _possibleConstructorReturn(this, _getPrototypeOf(hl).call(this, t));
    _this45._sdk = e;
    return _this45;
  }

  _createClass(hl, [{
    key: "export",
    value: function _export() {
      var _this46 = this;

      var e = this._options.imageFormat,
          t = function t(i) {
        return i.renderDone ? i : _this46._sdk.render().then(function (r) {
          return t(r);
        });
      };

      return this.validateSettings().then(function () {
        return _this46._prepareSDK().then(function (i) {
          return t(i);
        });
      }).then(function (i) {
        var r = i.outputTexture,
            o = i.renderDone,
            n = _this46._sdk.getRenderer(),
            a = n.getCanvas();

        return n.isOfType(U.WEBGL) && (a = _this46._createCanvasFromTexture(r)), _this46._encodeImageFormat(a);
      }).then(function (i) {
        return _this46._restoreExifMetadata(i, e);
      }).then(function (i) {
        return _this46._restoreSDK().then(function () {
          return i;
        });
      });
    }
  }, {
    key: "_restoreExifMetadata",
    value: function _restoreExifMetadata(e, t, i) {
      if (t === Di.JPEG) {
        var r = this._sdk.getExif();

        r && typeof e == "string" && (e = r.restoreSegments(e));
      }

      return Promise.resolve(e);
    }
  }, {
    key: "_encodeAsDataURL",
    value: function _encodeAsDataURL(e, t, i) {
      return T.isBrowser ? Promise.resolve(e.toDataURL(t, i)) : new Promise(function (r, o) {
        e.toDataURL(t, i, function (n, a) {
          n ? o(n) : r(a);
        });
      });
    }
  }, {
    key: "_encodeAsHTMLImage",
    value: function _encodeAsHTMLImage(e, t, i) {
      return this._encodeAsDataURL(e, t, i).then(function (r) {
        var o = new $e();
        return o.src = r, Promise.resolve(o);
      });
    }
  }, {
    key: "_encodeAsBuffer",
    value: function _encodeAsBuffer(e, t, i) {
      return Promise.reject(new Error("Unsupported platform for RenderType"));
    }
  }, {
    key: "_encodeAsMSBlob",
    value: function _encodeAsMSBlob(e, t, i) {
      return Promise.resolve(e.msToBlob());
    }
  }, {
    key: "_encodeAsBLOB",
    value: function _encodeAsBLOB(e, t, i) {
      return new Promise(function (r, o) {
        e.toBlob(function (n) {
          r(n);
        }, t, i);
      });
    }
  }, {
    key: "_encodeImageFormat",
    value: function _encodeImageFormat(e) {
      var _this$_options3 = this._options,
          t = _this$_options3.imageFormat,
          i = _this$_options3.quality,
          r = this._options.renderType;

      switch (r === nt.BLOB && e.msToBlob && !e.toBlob && (r = nt.MSBLOB), r) {
        case nt.IMAGE:
          return this._encodeAsHTMLImage(e, t, i);

        case nt.DATAURL:
          return this._encodeAsDataURL(e, t, i);

        case nt.BUFFER:
          return this._encodeAsBuffer(e, t, i);

        case nt.MSBLOB:
          return this._encodeAsMSBlob(e, t, i);

        case nt.BLOB:
          return this._encodeAsBLOB(e, t, i);
      }

      return Promise.reject(new Error("Unsupported RenderType: ".concat(r, "!")));
    }
  }, {
    key: "_prepareSDK",
    value: function _prepareSDK() {
      var e = this._sdk.getRenderer();

      this._sdkSettings = {
        dimensions: e.getDimensions().clone(),
        textureQuality: this._sdk.getTextureQuality(),
        pixelRatio: this._sdk.getPixelRatio(),
        renderMode: this._sdk.getRenderMode()
      }, this._sdk.setRenderMode("export"), this._sdk.setTextureQuality(1);
      var t = e.isOfType(U.CANVAS);
      e.setPixelRatio(1), e.resizeTo(this._sdk.getFinalDimensions(), t), this._sdk.setAllOperationsToDirty(!0);

      var i = this._sdk.getOperationsStack();

      return i.forEach(function (r) {
        r.disposeRenderTextures();
      }), i.disableCache(), this._sdk.render();
    }
  }, {
    key: "_restoreSDK",
    value: function _restoreSDK() {
      this._sdk.getOperationsStack().enableCache(), this._sdk.setRenderMode(this._sdkSettings.renderMode);

      var t = this._sdk.getRenderer(),
          i = t.isOfType(U.CANVAS);

      return t.setPixelRatio(this._sdkSettings.pixelRatio), t.resizeTo(this._sdkSettings.dimensions, i), this._sdk.setTextureQuality(this._sdkSettings.textureQuality), this._sdk.setAllOperationsToDirty(!0), this._sdk.render();
    }
  }, {
    key: "_createCanvasFromTexture",
    value: function _createCanvasFromTexture(e) {
      var t = this._sdk.getRenderer(),
          i = this._sdk.getFinalDimensions(),
          r = this._sdk.getRenderer().getContext(),
          o = r.createFramebuffer();

      r.bindFramebuffer(r.FRAMEBUFFER, o);
      var n = e.getBaseTexture().getGLTextureForRenderer(t);
      r.framebufferTexture2D(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.TEXTURE_2D, n, 0);
      var a = new Uint8Array(i.x * i.y * 4);
      r.readPixels(0, 0, i.x, i.y, r.RGBA, r.UNSIGNED_BYTE, a);

      var l = this._checkPixelsForTransparency(a),
          c;

      if (l) {
        var _d7 = new k.Sprite(e);

        _d7.setFilters([new k.Filters.UnpremultiplyFilter()]);

        var _g4 = new k.Container();

        _g4.addChild(_d7), c = new k.RenderTexture(t, i.x, i.y), c.render(_g4);

        var _y7 = c.getBaseTexture().getGLTextureForRenderer(t);

        r.framebufferTexture2D(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.TEXTURE_2D, _y7, 0), r.readPixels(0, 0, i.x, i.y, r.RGBA, r.UNSIGNED_BYTE, a), t.setRenderTarget(), c.dispose();
      }

      var u = T.createCanvas();
      u.width = i.x, u.height = i.y;
      var p = u.getContext("2d"),
          h = p.createImageData(i.x, i.y);
      return h.data.set(a), p.putImageData(h, 0, 0), r.deleteFramebuffer(o), u;
    }
  }, {
    key: "_checkPixelsForTransparency",
    value: function _checkPixelsForTransparency(e) {
      var t = this._sdk.getFinalDimensions(),
          i = t.x * t.y * 4,
          r;

      for (var _o11 = 3; _o11 < i; _o11 += 4) {
        if (r = e[_o11], r !== 255) return !0;
      }

      return !1;
    }
  }]);

  return hl;
}(V);

hl.prototype.availableOptions = {
  renderType: {
    type: m.STRING,
    available: T.values(nt),
    default: nt.IMAGE
  },
  imageFormat: {
    type: m.STRING,
    available: T.values(Di),
    default: Di.PNG
  },
  quality: {
    type: m.NUMBER,
    default: .8
  }
};
var fm = hl;

var t_ = ys.Rectangle,
    i_ = ys.Constants,
    gt = ys.Engine,
    _m = ys.Utils,
    r_ = ys.EventEmitter,
    pl = ys.Events,
    gl = ys.Vector2,
    vt = ys.Log,
    s_ = ys.Base64,
    o_ = ys.Color,
    se = function se(s) {
  return _m.byteArrayToString(s_.decode(s));
},
    n_ = i_.RenderType,
    a_ = i_.ImageFormat,
    ym = i_.RendererType,
    bm =
/*#__PURE__*/
function (_r_) {
  _inherits(bm, _r_);

  function bm(e) {
    var _this47;

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, bm);

    _this47 = _possibleConstructorReturn(this, _getPrototypeOf(bm).call(this));
    if (_this47._onOperationUpdate = _this47._onOperationUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this47))), _this47._onContextRestored = _this47._onContextRestored.bind(_assertThisInitialized(_assertThisInitialized(_this47))), _this47.version = "3.9.0", _this47[se("VG04Z1lHRndhVXRsZVdBZ2IzQjBhVzl1SUdkcGRtVnU=")] = !0, _this47._preferredRenderer = e, _this47._options = C(C({}, t), {
      extensions: {},
      renderMode: "dynamic",
      versionCheck: !0,
      displayWelcomeMessage: !0,
      image: null,
      canvas: null,
      transparent: !1,
      clearColor: o_.TRANSPARENT,
      textureQuality: 1,
      zoom: 1,
      spriteScale: 1,
      rotation: 0,
      smoothDownscaling: !1,
      smoothUpscaling: !1,
      crossOrigin: "anonymous",
      logLevel: "warn",
      pixelRatio: typeof window != "undefined" && window.devicePixelRatio || 1
    }), _this47._options.smoothUpscaling && (gt.BaseTexture.DefaultMagFilter = gt.BaseTexture.LinearFilter), _this47._options.extensions = Object.assign(_this47._options.extensions, {
      operations: [],
      controls: [],
      languages: []
    }), vt.setLevel(_this47._options.logLevel), _this47[se("Wm5KbFpVeHBZMlZ1YzAxdlpHVT0=")] = !1, !_this47[se("X29wdGlvbnM=")][se("bGljZW5zZQ==")]) _this47[se("Wm5KbFpVeHBZMlZ1YzAxdlpHVT0=")] = !0, _this47._l = new ys[se("RnJlZUxpY2Vuc2VDaGVja2Vy")]();else {
      if (!_this47._v()) return _possibleConstructorReturn(_this47);
      var r = ys[se("TGljZW5zZUNoZWNrZXI=")];
      _this47._l = new r(_this47[se("X29wdGlvbnM=")][se("bGljZW5zZQ==")]), _this47._cv(!0).then(function () {
        _this47._ct();
      }).catch(function (o) {
        vt.error(se("TGljZW5zaW5n"), o.message);
      });
    }
    _this47._defaultRenderMode = _this47._options.renderMode, _this47._renderMode = _this47._options.renderMode, _this47._textureQuality = _this47._options.textureQuality, _this47._offset = new gl(), _this47._zoom = _this47._options.zoom, _this47._spriteScale = _this47._options.spriteScale, _this47._rotation = _this47._options.rotation, _this47._operations = {}, _this47._operationsStack = null, _this47.setOperationsStack(new lo()), _this47._container = new gt.Container(), _this47._sprite = new gt.Sprite(), _this47._container.addChild(_this47._sprite), _this47._inputTexture = _this47._options.inputTexture, _this47._currentInputTexture = null, _this47._currentTexture = null, _this47._resizedTexture = null, _this47._resizedContainer = new gt.Container(), _this47._resizedSprite = new gt.Sprite(), _this47._resizedContainer.addChild(_this47._resizedSprite), _this47._texturesToDispose = [], _this47.setSmoothDownscaling(_this47._options.smoothDownscaling), _this47._registerOperations(), _this47._initRenderer();
    var i = _this47._renderer.constructor.type;
    _this47._options.displayWelcomeMessage, _this47[se("Wm5KbFpVeHBZMlZ1YzAxdlpHVT0=")] && vt.log(se("VGhlIFBob3RvRWRpdG9yIFNESyBpcyBhIGNvbW1lcmNpYWwgcHJvZHVjdC4gQmVmb3JlIGJlaW5nIGFibGUgdG8gdXNlIGl0IHdpdGhvdXQgbGltaXRhdGlvbnMsIHlvdSBuZWVkIHRvIHVubG9jayB0aGUgU0RLIHdpdGggYSBsaWNlbnNlIGZpbGUuIFlvdSBjYW4gb2J0YWluIGEgdGltZS1saW1pdGVkIGV2YWx1YXRpb24gbGljZW5zZSBieSBzdGFydGluZyBhIHRyaWFsIGF0IGh0dHBzOi8vd3d3LnBob3RvZWRpdG9yc2RrLmNvbS9zaWdudXAgb3IgeW91IGNhbiBwdXJjaGFzZSBhIGxpY2Vuc2UgYnkgcmVxdWVzdGluZyBhIHF1b3RlIGF0IGh0dHBzOi8vd3d3LnBob3RvZWRpdG9yc2RrLmNvbS9wcmljaW5nLgoKQmVjYXVzZSB5b3UgZGlkIG5vdCBzcGVjaWZ5IGEgbGljZW5zZSBmaWxlIHlldCwgdGhlIFNESyB3aWxsIG5vdyBkaXNwbGF5IGEgd2F0ZXJtYXJrIGltYWdlIG9uIHRvcCBvZiBhbnkgcGhvdG9zIHlvdSBkaXNwbGF5IG9yIGV4cG9ydCB3aXRoIGl0LiBGb3IgaW5zdHJ1Y3Rpb25zIGZvciBob3cgdG8gdW5sb2NrIHRoZSBTREssIHBsZWFzZSB2aXNpdCBodHRwczovL2RvY3MucGhvdG9lZGl0b3JzZGsuY29tL2d1aWRlcy9odG1sNS92NV84L2ludHJvZHVjdGlvbi9nZXR0aW5nX3N0YXJ0ZWQu")), _this47._options.image && _this47.setImage(_this47._options.image, _this47._options.exif);
    return _this47;
  }

  _createClass(bm, [{
    key: "_v",
    value: function _v() {
      return this[se("X29wdGlvbnM=")][se("bGljZW5zZQ==")] ? !0 : (vt.error(se("TGljZW5zaW5n"), se("Tm8gYGxpY2Vuc2VgIG9wdGlvbiBnaXZlbi4=")), vt.error(se("TGljZW5zaW5n"), se("SW4gY2FzZSB5b3UgZG9uJ3QgaGF2ZSBhIGxpY2Vuc2UgeWV0LCBwbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tIHRvIG9idGFpbiBhIGxpY2Vuc2Ugb3IgbG9nIGluIHRvIHlvdXIgY3VzdG9tZXIgZGFzaGJvYXJkLg==")), !1);
    }
  }, {
    key: "_ct",
    value: function _ct() {
      this._l.exp() && (this._l.isExp() ? vt.error(se("TGljZW5zaW5n"), se("WW91ciB0cmlhbCBsaWNlbnNlIGhhcyBleHBpcmVkLiBQbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tLg==")) : vt.warn(se("TGljZW5zaW5n"), se("WW91ciB0cmlhbCBsaWNlbnNlIHdpbGwgZXhwaXJlIGluICVkIGRheXMu").replace("%d", this._l.dl())));
    }
  }, {
    key: "_cv",
    value: function _cv() {
      var _this48 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this._l.c().catch(function (t) {
        _this48[se("VG04Z1lHRndhVXRsZVdBZ2IzQjBhVzl1SUdkcGRtVnU=")] = !1;
        var i = se("SW52YWxpZCBsaWNlbnNlLg==");
        throw e && (t.code === "ELICEXP" ? i = se("WW91ciB0cmlhbCBsaWNlbnNlIGhhcyBleHBpcmVkLiBQbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tLg==") : t.code === "ELICINVHOST" ? i = se("VGhlIGJ1bmRsZSBpZGVudGlmaWVycyB0aGF0IHlvdSBzcGVjaWZpZWQgaW4geW91ciBsaWNlbnNlIGZpbGUgZG8gbm90IG1hdGNoIHRoZSBhcHAncyBidW5kbGUgaWRlbnRpZmllci4gUGxlYXNlIHVwZGF0ZSBhbmQgcmVkb3dubG9hZCB5b3VyIGxpY2Vuc2UgZnJvbSB5b3VyIGN1c3RvbWVyIGRhc2hib2FyZCBhdCBodHRwczovL3d3dy5waG90b2VkaXRvcnNkay5jb20vbG9naW4u") : t.code === "ELICINVPLAT" ? i = se("VGhlIGxpY2Vuc2UgdGhhdCB5b3Ugc3BlY2lmaWVkIGlzIGZvciBhbm90aGVyIHBsYXRmb3JtLiBQbGVhc2UgZG93bmxvYWQgeW91ciBsaWNlbnNlIGZvciB0aGUgd2ViIHBsYXRmb3JtIGZyb20geW91ciBjdXN0b21lciBkYXNoYm9hcmQgYXQgaHR0cHM6Ly93d3cucGhvdG9lZGl0b3JzZGsuY29tL2xvZ2luLg==") : t.code === "ELICINVFMT" ? i = se("SW52YWxpZCBsaWNlbnNlIGZvcm1hdC4gUGxlYXNlIG1ha2Ugc3VyZSB5b3UncmUgcGFzc2luZyB5b3VyIGxpY2Vuc2UgYXMgYSBzdHJpbmcsIG5vdCBhcyBgJGZvcm1hdGAu").replace("$format", typeof _this48._options.license) : t.code === "ELICINV" ? i = se("VGhlIHNpZ25hdHVyZSBvZiB5b3VyIGxpY2Vuc2UgaXMgbm90IHZhbGlkLiBQbGVhc2UgdHJ5IHRvIHJlZG93bmxvYWQgeW91ciBsaWNlbnNlIGZyb20geW91ciBjdXN0b21lciBkYXNoYm9hcmQgYXQgaHR0cHM6Ly93d3cucGhvdG9lZGl0b3JzZGsuY29tL2xvZ2luLg==") : i = se("SW4gY2FzZSB5b3UgZG9uJ3QgaGF2ZSBhIGxpY2Vuc2UgeWV0LCBwbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tIHRvIG9idGFpbiBhIGxpY2Vuc2Ugb3IgbG9nIGluIHRvIHlvdXIgY3VzdG9tZXIgZGFzaGJvYXJkLg==")), t.message = i, new Error(t);
      });
    }
  }, {
    key: "_t",
    value: function _t() {
      this._l.t();
    }
  }, {
    key: "_fl",
    value: function _fl() {
      return this[se("Wm5KbFpVeHBZMlZ1YzAxdlpHVT0=")];
    }
  }, {
    key: "_onOperationUpdate",
    value: function _onOperationUpdate() {
      for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        e[_key13] = arguments[_key13];
      }

      this.emit.apply(this, [pl.OPERATION_UPDATED].concat(e));
    }
  }, {
    key: "_onContextRestored",
    value: function _onContextRestored() {
      vt.warn(this.constructor.name, "Trying to re-render after WebGL context has been restored."), this.setAllOperationsToDirty(), this._operationsStack.forEach(function (e) {
        e.disposeRenderTextures();
      }), this.render();
    }
  }, {
    key: "export",
    value: function _export() {
      var _this49 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : n_.DATAURL;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : a_.PNG;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .8;
      return this._cv(!0).then(function () {
        return _this49.hasChanges() && _this49._t(), _this49._operationsStack.forEach(function (o) {
          o.onBeforeExport();
        }), new fm(_this49, {
          renderType: e,
          imageFormat: t,
          quality: i
        }).export().then(function (o) {
          return _this49._operationsStack.forEach(function (n) {
            n.onAfterExport();
          }), Promise.resolve(o);
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this50 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      if (!this._inputTexture) throw new Error("You need to set an image before calling PhotoEditorSDK#render.");

      var t = this._renderer.getContext();

      t.startFrame && t.startFrame();
      var i;
      vt.canLog("info") && (i = new co("\u26A1\u26A1\u26A1", "Frame rendering")), vt.info("\u26A1\u26A1\u26A1", "Rendering starts");
      var r = this._operationsStack;
      return r.updateDirtinessForRenderer(this._renderer), this._prepareTexture().then(function (o) {
        _this50._renderMode === "export" && (o = _this50._inputTexture), _this50._currentTexture = o, _this50._sprite.setTexture(o), _this50._container.updateTransform();
      }).then(function () {
        return r.validateSettings();
      }).then(function () {
        return (_this50._fl() || !_this50[se("VG04Z1lHRndhVXRsZVdBZ2IzQjBhVzl1SUdkcGRtVnU=")]) && (r.getByIdentifier("license-watermark") ? r.moveToTop("license-watermark") : _this50.createOperation("license-watermark")), r.render(_this50, _this50._currentTexture);
      }).then(function (o) {
        var n = o.outputTexture;

        switch (_this50._currentTexture = n, _this50._sprite.setTexture(_this50._currentTexture), _this50._renderMode) {
          case "dynamic":
            {
              var _a3 = _this50._renderer.getDimensions().clone().divide(2).add(_this50._offset);

              _this50._container.setScale(_this50._zoom / _this50.getTextureScale(), _this50._zoom / _this50.getTextureScale()), _this50._container.setPosition(_a3), _this50._sprite.setAnchor(.5, .5), _this50._sprite.setScale(_this50._spriteScale, _this50._spriteScale), _this50._sprite.setRotation(_this50._rotation);
              break;
            }

          case "export":
            _this50._container.setScale(1, 1), _this50._container.setPosition(0, 0), _this50._sprite.setAnchor(0, 0), _this50._sprite.setPosition(0, 0), _this50._sprite.setScale(_this50._spriteScale, _this50._spriteScale), _this50._sprite.setRotation(0);
            break;

          case "adapter":
            _this50._container.setScale(1, 1), _this50._container.setPosition(0, 0), _this50._sprite.setAnchor(0, 0), _this50._sprite.setPosition(0, 0), _this50._sprite.setScale(1, 1), _this50._sprite.setRotation(0);
            break;
        }

        return e && _this50._renderer.render(_this50._container), o;
      }).then(function (o) {
        return i && i.stop(), t.endFrame && t.endFrame(), _this50._disposeTextures(), o;
      });
    }
  }, {
    key: "getTextureScale",
    value: function getTextureScale() {
      return Math.min(1, this._textureQuality * this._options.pixelRatio);
    }
  }, {
    key: "_prepareTexture",
    value: function _prepareTexture() {
      var _this51 = this;

      return new Promise(function (e, t) {
        var i = _this51.getTextureScale();

        if (_this51._textureQuality === 1) return e(_this51._inputTexture);

        var r = _this51.getInputDimensions().multiply(i).floor(),
            o;

        _this51._resizedTexture ? _this51._resizedTexture.getDimensions().equals(r) || (_this51._resizedTexture.resizeTo(r), o = !0) : (_this51._resizedTexture = new gt.RenderTexture(_this51._renderer, r.x, r.y), o = !0), o && (_this51._resizedSprite.setScale(i, i), _this51._resizedSprite.setTexture(_this51._inputTexture), _this51._resizedTexture.render(_this51._resizedContainer)), e(_this51._resizedTexture);
      });
    }
  }, {
    key: "_registerOperations",
    value: function _registerOperations() {
      this._operations = {};

      for (var _e13 in dr) {
        var _t18 = dr[_e13];
        this._operations[_t18.identifier] = _t18;
      }

      this._operations = C(C({}, this._operations), this._options.extensions.operations);
    }
  }, {
    key: "registerOperations",
    value: function registerOperations(e) {
      var _this52 = this;

      e.forEach(function (t) {
        _this52._operations[t.identifier] = t;
      });
    }
  }, {
    key: "setAllOperationsToDirty",
    value: function setAllOperationsToDirty() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

      this._operationsStack.setAllToDirty(e);
    }
  }, {
    key: "createOperation",
    value: function createOperation(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var r = this._operations[e];
      if (!r) throw new Error("No operation with identifier `".concat(e, "` found."));
      var o = new r(this, t);
      return i && this.addOperation(o), o;
    }
  }, {
    key: "addOperation",
    value: function addOperation(e) {
      this._operationsStack.push(e);
    }
  }, {
    key: "removeOperation",
    value: function removeOperation(e) {
      this._operationsStack.remove(e);
    }
  }, {
    key: "getInputDimensions",
    value: function getInputDimensions() {
      var e = this._inputTexture.getFrame();

      return new gl(e.width, e.height);
    }
  }, {
    key: "getFinalDimensions",
    value: function getFinalDimensions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this.getInputDimensions();
      return this._operationsStack.forEach(function (r) {
        !r.getEnabled() || (t = r.getNewDimensions(t));
      }), e && t.multiply(this._spriteScale), t.floor();
    }
  }, {
    key: "getOutputDimensions",
    value: function getOutputDimensions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this.getFinalDimensions(e).clone().multiply(this._zoom).floor();
    }
  }, {
    key: "getOutputTextureDimensions",
    value: function getOutputTextureDimensions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this.getTextureScale(),
          i = this.getInputDimensions().multiply(t).floor();
      return this._operationsStack.forEach(function (r) {
        i = r.getNewDimensions(i);
      }), i;
    }
  }, {
    key: "getCrossOrigin",
    value: function getCrossOrigin() {
      return _m.getCrossOrigin(this._options.crossOrigin || "Anonymous");
    }
  }, {
    key: "_initRenderer",
    value: function _initRenderer() {
      var e = {
        canvas: this._options.canvas,
        pixelRatio: this._options.pixelRatio,
        debug: this._options.debug,
        transparent: this._options.transparent,
        clearColor: this._options.clearColor
      },
          t,
          i;

      if (this._renderMode !== "export" && this._options.canvas) {
        var r = this._options.canvas;
        t = r.width, i = r.height;
      } else if (this._inputTexture) {
        var _r4 = this.getFinalDimensions();

        t = _r4.x, i = _r4.y;
      } else t = 1, i = 1;

      switch (this._preferredRenderer) {
        case ym.WEBGL:
          this._renderer = gt.autoDetectRenderer(t, i, e), this._renderer.on("context-restored", this._onContextRestored);
          break;

        case ym.CANVAS:
          this._renderer = gt.canvasRenderer(t, i, e), this._renderer.on("context-restored", this._onContextRestored);
          break;

        default:
          vt.warn("PhotoEditorSDK", "PhotoEditorSDK Error: Renderer `".concat(this._preferredRenderer, "` not supported. Falling back to automatically detected renderer.")), this._renderer = gt.autoDetectRenderer(t, i, e);
      }
    }
  }, {
    key: "resizeTo",
    value: function resizeTo(e) {
      this._renderer.resizeTo(e, !0);
    }
  }, {
    key: "reset",
    value: function reset() {
      this._operationsStack.clear();
    }
  }, {
    key: "parseExif",
    value: function parseExif(e) {
      if (!e) return;
      var t = e.src,
          i = !1,
          r = null;

      if (i = vs.isJPEG(t), r = t, i) {
        var _o12 = null;

        try {
          _o12 = vs.fromBase64String(r);
        } catch (n) {}

        return _o12 || void 0;
      }
    }
  }, {
    key: "_handleExifOrientation",
    value: function _handleExifOrientation() {
      var e = this._exif.getTags();

      if (e && e.Orientation) {
        var _t19 = e.Orientation !== 1 && e.Orientation !== 2,
            _i9 = [2, 4, 5, 7].indexOf(e.Orientation) !== -1;

        if (_t19 || _i9) {
          if (typeof navigator == "undefined") this._exifOperation || (this._exifOperation = this.createOperation("exif-orientation")), this._exifOperation.setTags(e);else {
            var r = window && window.navigator && window.navigator.userAgent || "";
            (!!r.match(/msie|trident/i) || r.indexOf("Edge") !== -1 || !CSS.supports("image-orientation", "from-image")) && (this._exifOperation || (this._exifOperation = this.createOperation("exif-orientation")), this._exifOperation.setTags(e));
          }

          this._exif.setOrientation(1);
        }
      }
    }
  }, {
    key: "correctExifOrientation",
    value: function correctExifOrientation(e) {
      var t = this.parseExif(e);
      if (!t) return e;
      var i = t.getTags();

      if (i && i.Orientation) {
        var r = i.Orientation !== 1 && i.Orientation !== 2,
            _o13 = [2, 4, 5, 7].indexOf(i.Orientation) !== -1;

        if (r || _o13) {
          if (typeof navigator == "undefined") {
            var _n6 = this.createOperation("exif-orientation", {}, !1);

            _n6.setTags(i), e = _n6.applyTo(e);
          } else {
            var _n7 = window && window.navigator && window.navigator.userAgent || "";

            if (!!_n7.match(/msie|trident/i) || _n7.indexOf("Edge") !== -1 || !CSS.supports("image-orientation", "from-image")) {
              var _a4 = this.createOperation("exif-orientation", {}, !1);

              _a4.setTags(i), e = _a4.applyTo(e);
            }
          }

          return t.setOrientation(1), i.Orientation = 1, e;
        }
      }

      return e;
    }
  }, {
    key: "hasImage",
    value: function hasImage() {
      return this._image !== null && typeof this._image != "undefined";
    }
  }, {
    key: "getImage",
    value: function getImage() {
      return this._image;
    }
  }, {
    key: "disposeTexture",
    value: function disposeTexture(e) {
      this._texturesToDispose.push(e);
    }
  }, {
    key: "_disposeTextures",
    value: function _disposeTextures() {
      for (var _e14 = 0; _e14 < this._texturesToDispose.length; _e14++) {
        this._texturesToDispose[_e14].dispose();
      }

      this._texturesToDispose = [];
    }
  }, {
    key: "setImage",
    value: function setImage(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this._disposeTextures(), this._exifOperation && (this.removeOperation(this._exifOperation), this._exifOperation = null), this._options.image = e, this._image = e, this._exif = t || this.parseExif(e), this._exif && this._handleExifOrientation();
      var r = new gt.BaseTexture(this._image),
          o = new t_(0, 0, this._image.naturalWidth || this._image.width, this._image.naturalHeight || this._image.height);
      i && (o.width = i.x, o.height = i.y), this._resizedTexture && this._resizedTexture.dispose(), this._resizedTexture = null, this._inputTexture && this.disposeTexture(this._inputTexture.getBaseTexture()), this._inputTexture = new gt.Texture(r, o), this._currentTexture = this._inputTexture, this._sprite.clearTexture(!1), this._sprite.setTexture(this._inputTexture), this.emit("new-image"), this.setAllOperationsToDirty(!0);
    }
  }, {
    key: "setInputTexture",
    value: function setInputTexture(e) {
      this._inputTexture = e;
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this._renderer.getCanvas();
    }
  }, {
    key: "setCanvas",
    value: function setCanvas(e) {
      this._renderer.setCanvas(e);
    }
  }, {
    key: "getSprite",
    value: function getSprite() {
      return this._sprite;
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this._container;
    }
  }, {
    key: "getOperationsStack",
    value: function getOperationsStack() {
      return this._operationsStack;
    }
  }, {
    key: "setOperationsStack",
    value: function setOperationsStack(e) {
      this._operationsStack && this._operationsStack.off(pl.OPERATION_UPDATED, this._onOperationUpdate), this._operationsStack = e, this._operationsStack.on(pl.OPERATION_UPDATED, this._onOperationUpdate);
    }
  }, {
    key: "getOperations",
    value: function getOperations() {
      return this._operations;
    }
  }, {
    key: "getRenderer",
    value: function getRenderer() {
      return this._renderer;
    }
  }, {
    key: "getOffset",
    value: function getOffset() {
      return this._offset;
    }
  }, {
    key: "setOffset",
    value: function setOffset(e, t) {
      e instanceof gl ? this._offset.copy(e) : this._offset.set(e, t);
    }
  }, {
    key: "getRenderMode",
    value: function getRenderMode() {
      return this._renderMode;
    }
  }, {
    key: "setRenderMode",
    value: function setRenderMode(e) {
      this._renderMode = e;
    }
  }, {
    key: "getZoom",
    value: function getZoom() {
      return this._zoom;
    }
  }, {
    key: "setZoom",
    value: function setZoom(e) {
      this._zoom = e, this._container.setScale(this._zoom, this._zoom), this._container.updateTransform();
    }
  }, {
    key: "getTextureQuality",
    value: function getTextureQuality() {
      return this._renderMode === "export" ? 1 : this._textureQuality;
    }
  }, {
    key: "setTextureQuality",
    value: function setTextureQuality(e) {
      e !== this._textureQuality && this.setAllOperationsToDirty(!0), this._textureQuality = Math.min(1, e), this._textureQuality === 1 && this._resizedTexture && (this._resizedTexture.dispose(), this._resizedTexture = null);
    }
  }, {
    key: "getSpriteScale",
    value: function getSpriteScale() {
      return this._spriteScale;
    }
  }, {
    key: "setSpriteScale",
    value: function setSpriteScale(e) {
      this._spriteScale = e, this._sprite.setScale(e, e), this._sprite.updateTransform();
    }
  }, {
    key: "getPixelRatio",
    value: function getPixelRatio() {
      return this._options.pixelRatio;
    }
  }, {
    key: "getExif",
    value: function getExif() {
      return this._exif;
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this._options;
    }
  }, {
    key: "getInputTexture",
    value: function getInputTexture() {
      return this._inputTexture;
    }
  }, {
    key: "setSmoothDownscaling",
    value: function setSmoothDownscaling(e) {
      this._options.smoothDownscaling = e, this._sprite.setSmoothDownscaling(e), this._resizedSprite.setSmoothDownscaling(e);
    }
  }, {
    key: "setRotation",
    value: function setRotation(e) {
      this._rotation = e;
    }
  }, {
    key: "getRotation",
    value: function getRotation() {
      return this._rotation;
    }
  }, {
    key: "hasChanges",
    value: function hasChanges() {
      return this.getOperationsStack().hasChanges();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._operationsStack.dispose(), this._renderer.dispose(), this._exif && this._exif.dispose(), this._resizedTexture && this._resizedTexture.dispose();
    }
  }]);

  return bm;
}(r_),
    _e = bm;

_e.version = "3.9.0";
_e.Math = I;
_e.Operations = dr;
_e.Engine = k;
_e.Color = R;
_e.LicenseChecker = so;
_e.Operation = ee;
_e.EventEmitter = We;
_e.Utils = T;
_e.Env = nm;
_e.OperationsStack = lo;
_e.EXIF = vs;
_e.Image = $e;
_e.Configurable = V;
_e.Log = A;
_e.Loaders = Na;
_e.RenderType = nt;
_e.ImageFormat = Di;
_e.OptionType = m;
_e.RendererType = U;
_e.UniformType = F;
_e.Base64 = bt;
var l_ = {};
_e.UI = l_;
var N = _e;
var xm = "precision highp float;\n\nvarying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nuniform float u_gamma;\nuniform float u_shadows;\nuniform float u_highlights;\nuniform float u_whites;\nuniform float u_blacks;\n\nuniform mat4 u_colorMatrix;\nuniform vec4 u_colorOffset;\n\nconst float EPSILON = 0.0000001;\n\nfloat calculateLuminance(vec3 rgb) {\n    // This is the luminance calculation part of the RGB to HSL formular.\n    vec4 p = mix(\n        vec4(rgb.gb, 0.0, -1.0 / 3.0),\n        vec4(rgb.bg, -1.0, 2.0 / 3.0),\n        vec4(rgb.g < rgb.b)\n    );\n\n    vec4 q = mix(\n        vec4(rgb.r, p.yzx),\n        vec4(p.xyw, rgb.r),\n        vec4(rgb.r < p.x)\n    );\n\n    float croma = q.x - min(q.w, q.y);\n    float luminance = q.x - croma * 0.5;\n    return luminance;\n}\n\nvec3 map(vec3 x, float in_min, float in_max, float out_min, float out_max){\n  return (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;\n}\n\nvoid main() {\n\n  vec4 color = clamp(texture2D(u_image, v_texCoord), 0.0, 1.0);\n  color.rgb /= max(color.a, EPSILON); // Revert premultiplied alpha\n\n  // Apply gamma\n  if (u_gamma != 1.0) {\n    color.rgb = pow(color.rgb, vec3(1.0 / max(u_gamma, EPSILON)));\n  }\n\n  // Apply shadows and highlights\n  float luminance = calculateLuminance(color.rgb);\n\n  float shadow = u_shadows >= 0.0\n    ? clamp(\n          pow(luminance, 1.0 / (u_shadows + 1.0))\n          + pow(luminance, 2.0 / (u_shadows + 1.0)) * -0.76\n          - luminance\n    , 0.0, max(u_shadows, 1.0))\n    : -clamp(\n          pow(luminance, 1.0 / (-u_shadows + 1.0))\n          + pow(luminance, 2.0 / (-u_shadows + 1.0)) * -0.76\n          - luminance\n    , 0.0, max(-u_shadows, 1.0));\n\n  float highlight = u_highlights < 0.0\n    ? clamp(\n          1.0\n          - pow(1.0 - luminance, 1.0 / (1.0 - u_highlights))\n          - pow(1.0 - luminance, 2.0 / (1.0 - u_highlights)) * -0.8\n          - luminance\n     , -1.0, 0.0)\n    : -clamp(\n          1.0\n          - pow(1.0 - luminance, 1.0 / (1.0 + u_highlights))\n          - pow(1.0 - luminance, 2.0 / (1.0 + u_highlights)) * -0.8\n          - luminance\n     , -1.0, 0.0);\n\n  // Bright color need more contrast and dark color need more brightness.\n  // This is to keep saturatation because the color information of a dark colors is lost.\n  float shadowContrast   = shadow * luminance * luminance;\n  float shadowBrightness = shadow - shadowContrast;\n\n  float offset = luminance + shadowContrast + highlight;\n  color.rgb = clamp(offset * ((color.rgb + shadowBrightness) / max(luminance, EPSILON)), 0.0, 1.0);\n  \n  // Apply Color Matrix\n  color.rgb = clamp(color * u_colorMatrix + u_colorOffset, 0.0, 1.0).rgb;\n  color.rgb = map(color.rgb, 0.0, 1.0, u_blacks / 2.0, 1.0 + u_whites / 2.0);\n  color = clamp(color, 0.0, 1.0);\n  color.rgb *= color.a; // Reset premultiplied alpha\n\n  gl_FragColor = color;\n}\n";
var c_ = I.ColorMatrix,
    hr = 1e-7;

function fl(s, e, t, i, r) {
  return (s - e) * (r - i) / (t - e) + i;
}

var u_ = function u_(s) {
  var e = Math.max(s.r, s.g, s.b),
      t = Math.min(s.r, s.g, s.b);
  return (e + t) / 2;
},
    _l =
/*#__PURE__*/
function (_k$Filter) {
  _inherits(_l, _k$Filter);

  function _l() {
    var _this53;

    _classCallCheck(this, _l);

    _this53 = _possibleConstructorReturn(this, _getPrototypeOf(_l).call(this));
    _this53._fragmentSource = xm;
    return _this53;
  }

  _createClass(_l, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          _this$_options4 = this._options,
          c = _this$_options4.colorMatrix,
          u = _this$_options4.gamma,
          p = _this$_options4.shadows,
          h = _this$_options4.highlights,
          d = _this$_options4.whites,
          g = _this$_options4.blacks,
          y = u !== 1,
          _ = p !== 0 || h !== 0,
          f = new R(0, 0, 0, 0);

      for (var v = 0; v < o.width * o.height; v++) {
        var b = v * 4;

        if (f.r = l.data[b] / 255, f.g = l.data[b + 1] / 255, f.b = l.data[b + 2] / 255, y && (f.r = Math.pow(f.r, 1 / Math.max(u, hr)), f.g = Math.pow(f.g, 1 / Math.max(u, hr)), f.b = Math.pow(f.b, 1 / Math.max(u, hr))), _) {
          var D = u_(f),
              O = p >= 0 ? T.clamp(Math.pow(D, 1 / (p + 1)) + Math.pow(D, 2 / (p + 1)) * -.76 - D, 0, Math.max(p, 1)) : -T.clamp(Math.pow(D, 1 / (-p + 1)) + Math.pow(D, 2 / (-p + 1)) * -.76 - D, 0, Math.max(-p, 1)),
              x = h < 0 ? T.clamp(1 - Math.pow(1 - D, 1 / (1 - h)) - Math.pow(1 - D, 2 / (1 - h)) * -.8 - D, -1, 0) : -T.clamp(1 - Math.pow(1 - D, 1 / (1 + h)) - Math.pow(1 - D, 2 / (1 + h)) * -.8 - D, -1, 0),
              w = O * D * D,
              z = O - w,
              L = D + w + x;
          f.r = T.clamp(L * ((f.r + z) / Math.max(D, hr)), 0, 1), f.g = T.clamp(L * ((f.g + z) / Math.max(D, hr)), 0, 1), f.b = T.clamp(L * ((f.b + z) / Math.max(D, hr)), 0, 1);
        }

        f = c.apply(f).clamp(0, 1), f.r = fl(f.r, 0, 1, g / 2, 1 + d / 2), f.g = fl(f.g, 0, 1, g / 2, 1 + d / 2), f.b = fl(f.b, 0, 1, g / 2, 1 + d / 2), l.data[b] = f.r * 255, l.data[b + 1] = f.g * 255, l.data[b + 2] = f.b * 255;
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return _l;
}(k.Filter);

_l.prototype.availableOptions = {
  gamma: {
    type: m.NUMBER,
    default: 1,
    uniformType: F.FLOAT
  },
  shadows: {
    type: m.NUMBER,
    default: 0,
    uniformType: F.FLOAT
  },
  highlights: {
    type: m.NUMBER,
    default: 1,
    uniformType: F.FLOAT
  },
  whites: {
    type: m.NUMBER,
    default: 0,
    uniformType: F.FLOAT
  },
  blacks: {
    type: m.NUMBER,
    default: 0,
    uniformType: F.FLOAT
  },
  colorMatrix: {
    type: m.COLOR_MATRIX,
    default: new c_(),
    uniformType: F.MAT4
  },
  colorOffset: {
    type: m.ARRAY,
    default: [],
    uniformType: F.FLOAT4
  }
};
var mo = _l;
var vm = "precision mediump float;\n\n// Input Image with config WRAP_S and WRAP_T: CLAMP_TO_EDGE\nuniform sampler2D u_image;\n\n// Size of one pixel == vec2(1.0 / u_image.width, 1.0 / u_image.height)\nuniform vec2 u_pixelDimension;\n\n// Range (-1.0 - 1.0)\nuniform float u_clarity;\n\nvarying vec2 v_texCoord;\n\nuniform mat4 u_colorMatrix;\nuniform vec4 u_colorOffset;\n\nconst float EPSILON = 0.000001;\n\nvec4 unpremultiply(vec4 col) {\n    col.rgb /= max(col.a, EPSILON);\n    return col;\n}\n\nvoid main() {\n    vec4 color = texture2D(u_image, v_texCoord);\n    color = unpremultiply(color);\n\n    // L = Left, R = Right, C = Center, T = Top, B = Bottom\n    vec4 colLB = texture2D(u_image, v_texCoord + vec2(-u_pixelDimension.x, -u_pixelDimension.y));\n    vec4 colLC = texture2D(u_image, v_texCoord + vec2(-u_pixelDimension.x,                 0.0));\n    vec4 colLT = texture2D(u_image, v_texCoord + vec2(-u_pixelDimension.x,  u_pixelDimension.y));\n\n    vec4 colCL = texture2D(u_image, v_texCoord + vec2(                0.0, -u_pixelDimension.y));\n    vec4 colCR = texture2D(u_image, v_texCoord + vec2(                0.0,  u_pixelDimension.y));\n    \n    vec4 colRB = texture2D(u_image, v_texCoord + vec2( u_pixelDimension.x, -u_pixelDimension.y));\n    vec4 colRC = texture2D(u_image, v_texCoord + vec2( u_pixelDimension.x,                 0.0));\n    vec4 colRT = texture2D(u_image, v_texCoord + vec2( u_pixelDimension.x,  u_pixelDimension.y));\n\n    vec4 mergedColor = color;\n    mergedColor.rgb += unpremultiply(colLB).rgb + unpremultiply(colLC).rgb + unpremultiply(colLT).rgb;\n    mergedColor.rgb += unpremultiply(colCL).rgb + unpremultiply(colCR).rgb;\n    mergedColor.rgb += unpremultiply(colRB).rgb + unpremultiply(colRC).rgb + unpremultiply(colRT).rgb;\n\n    mergedColor /= 9.0;\n\n    float grayValue = clamp(color.r * 0.3 + color.g * 0.59 + color.b * 0.1, 0.111111, 0.999999);\n    // 1.0 and 0.0 result in white not black, therefore we clamp\n\n    // Here we create a function that will map values below 0.1 to 0. Values above 0.2 will be mapped to 1,\n    // and for values between 0.1 and 0.2 it will produce a gradient.\n    // The funtion is mirror at 0.5, meaning values between 0.8 and 0.9 will result in a decending gradient.\n    // And values above 0.9 will be mapped to 0.\n    float frequenceFactor = min(smoothstep(1.0 - grayValue, 0.0, 0.11), smoothstep(grayValue, 0.0, 0.11));\n\n    // here we apply the high pass filter. Its strength is determined by the uniform ,\n    // and the frequence factor. That means the only the mid tones are affected by this filter.\n    // Clarity input is ranging from -1 to 1. But we want to strengthen the effect.\n    // Therefore we see this little magic number '3.7'.\n    color.rgb = clamp(color + clamp((color - mergedColor) * u_clarity * 3.7 * frequenceFactor, 0.0, 10.0), 0.0, 1.0).rgb;\n\n    // apply exposure but only to the mid tones.\n    color.rgb = color.rgb * pow(2.0, u_clarity * 0.27 * frequenceFactor);\n\n    // apply contrast and desaturation matrix\n    color.rgb = clamp(color * u_colorMatrix + u_colorOffset, 0.0, 1.0).rgb;\n\n    color.rgb *= color.a; // Premultiply alpha\n\n    gl_FragColor = clamp(color, 0.0, 1.0);\n}\n";

var m_ = I.Vector2,
    d_ = I.ColorMatrix,
    yl =
/*#__PURE__*/
function (_k$Filter2) {
  _inherits(yl, _k$Filter2);

  function yl() {
    var _this54;

    _classCallCheck(this, yl);

    _this54 = _possibleConstructorReturn(this, _getPrototypeOf(yl).call(this));
    _this54._fragmentSource = vm;
    return _this54;
  }

  _createClass(yl, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = i.getContext(),
          n = t.getCanvas(),
          a = t.getContext(),
          l = this._options.clarity,
          c = this._options.colorMatrix,
          u = new R(this._options.colorOffset[0], this._options.colorOffset[1], this._options.colorOffset[2], this._options.colorOffset[3]),
          p = n.width,
          h = n.height,
          d = a.getImageData(0, 0, p, h),
          g = o.createImageData(p, h);
      this.canvasShader(d, g, l, c, u), o.putImageData(g, 0, 0);
    }
  }, {
    key: "canvasShader",
    value: function canvasShader(e, t, i, r, o) {
      var n = function n(f, v, b) {
        return Math.min(Math.max(f, v), b);
      },
          a = function a(f, v, b) {
        var D = n((b - f) / (v - f), 0, 1);
        return D * D * (3 - 2 * D);
      },
          l = e.width * 4,
          c = e.data.length,
          u = c - 1,
          p = 0,
          h = e.data,
          d = t.data,
          g = new R(),
          y = 255 * 9,
          _ = function _(f) {
        return f = f < p ? p : f, f = f > u ? u : f, h[f];
      };

      for (var f = 0; f < c; f += 4) {
        var v = _(f + 0),
            b = _(f + 1),
            D = _(f + 2),
            O = _(f + 3),
            x = (v + _(f - 4 - l + 0) + _(f - 4 + 0) + _(f - 4 + l + 0) + _(f - l + 0) + _(f + l + 0) + _(f + 4 - l + 0) + _(f + 4 + 0) + _(f + 4 + l)) / y,
            w = (b + _(f - 4 - l + 1) + _(f - 4 + 1) + _(f - 4 + l + 1) + _(f - l + 1) + _(f + l + 1) + _(f + 4 - l + 1) + _(f + 4 + 1) + _(f + 4 + l + 1)) / y,
            z = (D + _(f - 4 - l + 2) + _(f - 4 + 2) + _(f - 4 + l + 2) + _(f - l + 2) + _(f + l + 2) + _(f + 4 - l + 2) + _(f + 4 + 2) + _(f + 4 + l + 2)) / y,
            L = (O + _(f - 4 - l + 3) + _(f - 4 + 3) + _(f - 4 + l + 3) + _(f - l + 3) + _(f + l + 3) + _(f + 4 - l + 3) + _(f + 4 + 3) + _(f + 4 + l + 3)) / y;

        v /= 255, b /= 255, D /= 255, O /= 255;
        var j = n(v * .3 + b * .59 + D * .1, .111111, .999999),
            X = Math.min(a(1 - j, 0, .11), a(j, 0, .11)),
            K = i * 3.7 * X,
            G = Math.pow(2, i * .27 * X),
            ae = n(v + n((v - x) * K, 0, 10), 0, 1) * G,
            Ne = n(b + n((b - w) * K, 0, 10), 0, 1) * G,
            Oe = n(D + n((D - z) * K, 0, 10), 0, 1) * G,
            kt = n(O + n((O - L) * K, 0, 10), 0, 1);
        g.set(ae, Ne, Oe, kt);
        var Q = r.apply(g).clamp(0, 1);
        d[f + 0] = Q.r * 255, d[f + 1] = Q.g * 255, d[f + 2] = Q.b * 255, d[f + 3] = Q.a * 255;
      }
    }
  }]);

  return yl;
}(k.Filter);

yl.prototype.availableOptions = {
  clarity: {
    type: m.NUMBER,
    default: 0,
    uniformType: F.FLOAT
  },
  pixelDimension: {
    type: m.VECTOR2,
    default: new m_(100, 100),
    uniformType: F.FLOAT2
  },
  colorMatrix: {
    type: m.COLOR_MATRIX,
    default: new d_(),
    uniformType: F.MAT4
  },
  colorOffset: {
    type: m.ARRAY,
    default: [],
    uniformType: F.FLOAT4
  }
};
var Cm = yl;
var wm = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform vec2 u_pixelDimension;\nuniform float u_sharpness;\n \nconst float EPSILON = 0.000001;\n \nvoid main() {\n    vec4 color = clamp(texture2D(u_image, v_texCoord), 0.0, 1.0);\n\n    float factor        = mix(0.2, -1.0, float(u_sharpness > 0.0));\n    vec4 sharpenedColor = mix(0.2,  5.0, float(u_sharpness > 0.0)) * color;\n \n    sharpenedColor += factor * clamp(texture2D(u_image, v_texCoord + u_pixelDimension * vec2(-1.0,  0.0)), 0.0, 1.0);\n    sharpenedColor += factor * clamp(texture2D(u_image, v_texCoord + u_pixelDimension * vec2( 0.0, -1.0)), 0.0, 1.0);\n    sharpenedColor += factor * clamp(texture2D(u_image, v_texCoord + u_pixelDimension * vec2( 0.0,  1.0)), 0.0, 1.0);\n    sharpenedColor += factor * clamp(texture2D(u_image, v_texCoord + u_pixelDimension * vec2( 1.0,  0.0)), 0.0, 1.0);\n \n    color.rgb /= max(color.a, EPSILON); // unpremultiply\n    sharpenedColor.rgb /= max(sharpenedColor.a, EPSILON); // unpremultiply\n \n    sharpenedColor = clamp(sharpenedColor, 0.0, 1.0);\n \n    color = clamp(mix(color, sharpenedColor, abs(u_sharpness)), 0.0, 1.0);\n      \n    gl_FragColor = vec4(color.rgb * color.a, color.a); // premultiply\n}";

var h_ = I.Vector2,
    bl =
/*#__PURE__*/
function (_k$Filter3) {
  _inherits(bl, _k$Filter3);

  function bl() {
    var _this55;

    _classCallCheck(this, bl);

    _this55 = _possibleConstructorReturn(this, _getPrototypeOf(bl).call(this));
    _this55._fragmentSource = wm;
    return _this55;
  }

  _createClass(bl, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = i.getContext(),
          n = t.getCanvas(),
          a = t.getContext(),
          l = this._options.sharpness,
          c = n.width,
          u = n.height,
          p = a.getImageData(0, 0, c, u),
          h = o.createImageData(c, u);
      this.canvasShader(p, h, l), o.putImageData(h, 0, 0);
    }
  }, {
    key: "canvasShader",
    value: function canvasShader(e, t, i) {
      var r = function r(D, O, x) {
        return Math.min(Math.max(D, O), x);
      },
          o = 1e-6,
          n = e.width,
          a = e.height,
          l = e.data,
          c = t.data,
          u = function u(D, O, x) {
        return D * (1 - x) + O * x;
      },
          p = function p(D) {
        return r(l[D] / 255, 0, 1);
      },
          h = function h(D, O) {
        var x = r(D, 0, n - 1),
            w = r(O, 0, a - 1);
        return 4 * (x + n * w);
      },
          d = [],
          g = [],
          y = [-1, 0, 0, 1],
          _ = [0, -1, 1, 0],
          f = i > 0 ? -1 : .2,
          v = i > 0 ? 5 : .2,
          b = Math.abs(i);

      for (var D = 0; D < n; D++) {
        for (var O = 0; O < a; O++) {
          var x = h(D, O);
          d[0] = p(x + 0), d[1] = p(x + 1), d[2] = p(x + 2), d[3] = p(x + 3), g[0] = v * d[0] * d[3], g[1] = v * d[1] * d[3], g[2] = v * d[2] * d[3], g[3] = v * d[3];

          for (var w = 0; w < 4; w++) {
            var z = y[w],
                L = _[w],
                j = h(D + z, O + L),
                X = p(j + 3);
            g[3] += f * X;

            for (var K = 0; K < 3; K++) {
              g[K] += f * p(j + K) * X;
            }
          }

          for (var _w = 0; _w < 3; _w++) {
            g[_w] /= Math.max(g[3], o), g[_w] = r(g[_w], 0, 1);
          }

          g[3] = r(g[3], 0, 1);

          for (var _w2 = 0; _w2 < 4; _w2++) {
            d[_w2] = r(u(d[_w2], g[_w2], b), 0, 1), c[x + _w2] = d[_w2] * 255;
          }
        }
      }
    }
  }]);

  return bl;
}(k.Filter);

bl.prototype.availableOptions = {
  sharpness: {
    type: m.NUMBER,
    default: 0,
    uniformType: F.FLOAT
  },
  pixelDimension: {
    type: m.VECTOR2,
    default: new h_(100, 100),
    uniformType: F.FLOAT2
  }
};
var Dm = bl;
var km = "precision mediump float;\n\n// Input Image with config WRAP_S and WRAP_T: CLAMP_TO_EDGE\nuniform sampler2D u_image;\n\n// Range (-1.0 - 1.0)\nuniform float u_temperature;\n\nconst lowp vec3 warmFilter = vec3(0.93, 0.54, 0.0);\n\nconst mediump mat3 RGBtoYIQ = mat3(0.299, 0.587, 0.114, 0.596, -0.274, -0.322, 0.212, -0.523, 0.311);\nconst mediump mat3 YIQtoRGB = mat3(1.0, 0.956, 0.621, 1.0, -0.272, -0.647, 1.0, -1.105, 1.702);\n\nconst float EPSILON = 0.0000001;\n\nvarying vec2 v_texCoord;\nvoid main() {\n  float temperature = u_temperature;\n  const float tint = 0.0;\n  vec4 source = texture2D(u_image, v_texCoord);\n\n  source.rgb /= max(source.a, EPSILON);   // Revert premultiplied alpha\n\n  vec3 yiq = RGBtoYIQ * source.rgb;\n  yiq.b = clamp(yiq.b + tint*0.5226*0.1, -0.5226, 0.5226);\n  vec3 rgb = YIQtoRGB * yiq;\n\n  vec3 processed = mix(\n    (1.0 - 2.0 * (1.0 - rgb) * (1.0 - warmFilter)),\n    (2.0 * rgb * warmFilter),\n    vec3(rgb.r < 0.5, rgb.g < 0.5, rgb.b < 0.5)\n  );\n\n  vec4 color = vec4(mix(rgb, processed, temperature), source.a);\n\n  color.rgb *= color.a;   // Premultiply alpha again\n\n  gl_FragColor = color;\n}\n";

var xl =
/*#__PURE__*/
function (_k$Filter4) {
  _inherits(xl, _k$Filter4);

  function xl() {
    var _this56;

    _classCallCheck(this, xl);

    _this56 = _possibleConstructorReturn(this, _getPrototypeOf(xl).call(this));
    _this56._fragmentSource = km;
    return _this56;
  }

  _createClass(xl, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = i.getContext(),
          n = t.getCanvas(),
          a = t.getContext(),
          l = this._options.temperature,
          c = n.width,
          u = n.height,
          p = a.getImageData(0, 0, c, u),
          h = o.createImageData(c, u);
      this.canvasShader(p, h, l), o.putImageData(h, 0, 0);
    }
  }, {
    key: "canvasShader",
    value: function canvasShader(e, t, i) {
      var r = function r(f, v, b) {
        return Math.min(Math.max(f, v), b);
      },
          o = function o(f, v, b) {
        return f * (1 - b) + v * b;
      },
          n = function n(f, v) {
        var b = f[0] * v[0] + f[3] * v[1] + f[6] * v[2],
            D = f[1] * v[0] + f[4] * v[1] + f[7] * v[2],
            O = f[2] * v[0] + f[5] * v[1] + f[8] * v[2];
        return [b, D, O];
      },
          a = e.data.length,
          l = a - 1,
          c = 0,
          u = e.data,
          p = t.data,
          h = function h(f) {
        return f = f < c ? c : f, f = f > l ? l : f, u[f];
      },
          d = [.93, .54, 0],
          g = [.299, .587, .114, .596, -.274, -.322, .212, -.523, .311],
          y = [1, .956, .621, 1, -.272, -.647, 1, -1.105, 1.702],
          _ = 0;

      for (var _f3 = 0; _f3 < a; _f3 += 4) {
        var _v2 = h(_f3 + 0) / 255,
            _b = h(_f3 + 1) / 255,
            D = h(_f3 + 2) / 255,
            O = h(_f3 + 3) / 255,
            w = n(g, [_v2, _b, D]);

        w.z = r(w.z + _ * .5226 * .1, -.5226, .5226);
        var z = n(y, w),
            L = [z[0] < .5 ? 2 * z[0] * d[0] : 1 - 2 * (1 - z[0]) * (1 - d[0]), z[1] < .5 ? 2 * z[1] * d[1] : 1 - 2 * (1 - z[1]) * (1 - d[1]), z[2] < .5 ? 2 * z[2] * d[2] : 1 - 2 * (1 - z[2]) * (1 - d[2])];
        p[_f3 + 0] = o(z[0], L[0], i) * 255, p[_f3 + 1] = o(z[1], L[1], i) * 255, p[_f3 + 2] = o(z[2], L[2], i) * 255, p[_f3 + 3] = O * 255;
      }
    }
  }]);

  return xl;
}(k.Filter);

xl.prototype.availableOptions = {
  temperature: {
    type: m.NUMBER,
    default: 0,
    uniformType: F.FLOAT
  }
};
var Tm = xl;

var ui = I.ColorMatrix,
    Cs =
/*#__PURE__*/
function (_ee2) {
  _inherits(Cs, _ee2);

  function Cs() {
    var _getPrototypeOf5;

    var _this57;

    _classCallCheck(this, Cs);

    for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      e[_key14] = arguments[_key14];
    }

    _this57 = _possibleConstructorReturn(this, (_getPrototypeOf5 = _getPrototypeOf(Cs)).call.apply(_getPrototypeOf5, [this].concat(e)));
    _this57._clarityFilter = new Cm(), _this57._temperatureFilter = new Tm(), _this57._sharpnessFilter = new Dm(), _this57._filter = new mo(), _this57._sprite.setFilters([_this57._clarityFilter, _this57._temperatureFilter, _this57._filter]);
    return _this57;
  }

  _createClass(Cs, [{
    key: "_render",
    value: function _render(e) {
      var t = e.getDimensions();
      t.x = 1 / t.x, t.y = 1 / t.y;
      var i = new ui();
      i.multiply(ui.createSaturationMatrix(-.3 * this._options.clarity + 1)), i.multiply(ui.createContrastMatrix(.1 * this._options.clarity + 1)), this._clarityFilter.set({
        clarity: this._options.clarity,
        pixelDimension: t,
        colorMatrix: i,
        colorOffset: i.getOffsets()
      }), this._temperatureFilter.set({
        temperature: this._options.temperature
      }), this._sharpnessFilter.set({
        sharpness: this._options.sharpness,
        pixelDimension: t
      });
      var r = new ui();
      r.multiply(ui.createExposureMatrix(this._options.exposure)), r.multiply(ui.createSaturationMatrix(this._options.saturation + 1)), r.multiply(ui.createContrastMatrix((this._options.contrast > 0 ? this._options.contrast * 2 : this._options.contrast) + 1)), r.multiply(ui.createBrightnessMatrix(this._options.brightness)), this._filter.set({
        gamma: this._options.gamma,
        shadows: this._options.shadows,
        highlights: this._options.highlights,
        whites: this._options.whites,
        blacks: this._options.blacks,
        colorMatrix: r,
        colorOffset: r.getOffsets()
      });
      var o = [];
      return this._options.clarity !== 0 && o.push(this._clarityFilter), this._options.sharpness !== 0 && o.push(this._sharpnessFilter), this._options.temperature !== 0 && o.push(this._temperatureFilter), o.push(this._filter), this._sprite.setFilters(o), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Cs.prototype), "dispose", this).call(this), this._filter.dispose(), this._clarityFilter.dispose(), this._temperatureFilter.dispose(), this._sharpnessFilter.dispose();
    }
  }]);

  return Cs;
}(ee);

Cs.identifier = "adjustments";
Cs.prototype.availableOptions = {
  brightness: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  },
  saturation: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  },
  contrast: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  },
  gamma: {
    type: m.NUMBER,
    default: 1,
    minValue: .5,
    midValue: 1,
    maxValue: 2
  },
  exposure: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  },
  shadows: {
    type: m.NUMBER,
    default: 0,
    minValue: -2,
    midValue: 0,
    maxValue: 2
  },
  highlights: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  },
  clarity: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  },
  whites: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  },
  blacks: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  },
  temperature: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  },
  sharpness: {
    type: m.NUMBER,
    default: 0,
    minValue: -1,
    midValue: 0,
    maxValue: 1
  }
};
N.Operations.AdjustmentsOperation = Cs;
var Rm = Cs;
var Fm = "/*\n * Based on evanw's glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n * @license\n */\n\nuniform sampler2D u_image;\nuniform float u_blurRadius;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n    float radius = u_blurRadius;\n\n    const float steps = 30.0;\n\n    for (float t = -steps; t <= steps; t++) {\n        float percent = (t + offset - 0.5) / steps;\n        float weight = 1.0 - abs(percent);\n\n        // Somehow `sample` is a keyword in headless-gl\n        vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n        color += _sample * weight;\n        total += weight;\n    }\n\n    gl_FragColor = color / total;\n}\n";

var ho = I.Vector2,
    vl =
/*#__PURE__*/
function (_k$Filter5) {
  _inherits(vl, _k$Filter5);

  function vl() {
    var _getPrototypeOf6;

    var _this58;

    _classCallCheck(this, vl);

    for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      e[_key15] = arguments[_key15];
    }

    _this58 = _possibleConstructorReturn(this, (_getPrototypeOf6 = _getPrototypeOf(vl)).call.apply(_getPrototypeOf6, [this].concat(e)));
    _this58._fragmentSource = Fm, _this58._lastBlurRadius = null, _this58._lastDimensions = new ho(0, 0), _this58._blurredRenderTarget = new k.CanvasRenderTarget(100, 100, 1);
    return _this58;
  }

  _createClass(vl, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      if (this._options.blurQuality === "low") {
        this._renderLQBlur(e, t, i, r);

        return;
      }

      var n = t.getCanvas(),
          a = t.getContext(),
          l = i.getContext();
      this._lastBlurRadius === this._options.blurRadius && l.drawImage(n, 0, 0);
      var c = a.getImageData(0, 0, n.width, n.height),
          u = l.getImageData(0, 0, n.width, n.height),
          p = this._options.blurRadius,
          h = this._options.delta,
          d = 30;

      for (var _g5 = 0; _g5 < n.width; _g5++) {
        for (var _y8 = 0; _y8 < n.height; _y8++) {
          var _f4 = (_g5 + _y8 * n.width) * 4,
              _v3 = 0,
              _b2 = 0,
              D = 0,
              O = 0,
              x = 0;

          o && (p = o(_g5 / n.width, _y8 / n.height));

          var w = this._random(_g5, 1 - _y8 / n.height);

          for (var z = -d; z <= d; z++) {
            var L = (z + w - .5) / d,
                j = 1 - Math.abs(L),
                X = h.x * L * p,
                K = h.y * L * p,
                G = Math.max(Math.min(_g5 + X, n.width - 1), 0),
                ae = Math.max(Math.min(_y8 + K, n.height - 1), 0),
                Ne = (Math.round(ae) * n.width + Math.round(G)) * 4,
                Oe = c.data[Ne + 3],
                kt = Oe * c.data[Ne],
                Q = Oe * c.data[Ne + 1],
                be = Oe * c.data[Ne + 2];
            _v3 += kt * j, _b2 += Q * j, D += be * j, O += Oe * j, x += j;
          }

          _v3 /= x, _b2 /= x, D /= x, O /= x, u.data[_f4] = _v3 / O, u.data[_f4 + 1] = _b2 / O, u.data[_f4 + 2] = D / O, u.data[_f4 + 3] = O;
        }
      }

      l.putImageData(u, 0, 0), this._lastDimensions.copy(new ho(n.width, n.height));
    }
  }, {
    key: "_renderLQBlur",
    value: function _renderLQBlur(e, t, i, r) {
      var o = t.getDimensions(),
          n = !this._lastDimensions.equals(o);
      this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()), this._blurredRenderTarget.resizeTo(t.getDimensions()), i.setPixelRatio(t.getPixelRatio()), i.resizeTo(t.getDimensions()), (this._lastBlurRadius !== this._options.blurRadius || n) && (this._blurImage(t, this._blurredRenderTarget, this._options.blurRadius), this._lastBlurRadius = this._options.blurRadius), i.getContext().drawImage(this._blurredRenderTarget.getCanvas(), 0, 0), this._lastDimensions.copy(o);
    }
  }, {
    key: "_random",
    value: function _random(e, t) {
      var i = 12.9898,
          r = 78.233,
          o = 43758.5453,
          n = e * i + t * r,
          a = n - 3.14 * Math.floor(n / 3.14),
          l = Math.sin(a) * o;
      return l - Math.floor(l);
    }
  }]);

  return vl;
}(k.Filter);

vl.prototype.availableOptions = {
  blurRadius: {
    type: m.NUMBER,
    default: 30,
    uniformType: F.FLOAT
  },
  delta: {
    type: m.VECTOR2,
    default: new ho(1, 1),
    uniformType: F.FLOAT2
  },
  texSize: {
    type: m.VECTOR2,
    default: new ho(100, 100),
    uniformType: F.FLOAT2
  },
  blurQuality: {
    type: m.STRING,
    default: "low"
  }
};
var Je = vl;

var Em = I.Vector2,
    ws =
/*#__PURE__*/
function (_ee3) {
  _inherits(ws, _ee3);

  function ws() {
    var _getPrototypeOf7;

    var _this59;

    _classCallCheck(this, ws);

    for (var _len16 = arguments.length, e = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      e[_key16] = arguments[_key16];
    }

    _this59 = _possibleConstructorReturn(this, (_getPrototypeOf7 = _getPrototypeOf(ws)).call.apply(_getPrototypeOf7, [this].concat(e)));
    _this59._lastBlurRadius = _this59._options.blurRadius;
    var t = {
      blurQuality: {
        type: m.STRING
      }
    };
    _this59._horizontalFilter = new Je({}, t), _this59._verticalFilter = new Je({}, t), _this59._sprite.setFilters([_this59._horizontalFilter, _this59._verticalFilter]), _this59._horizontalFilter.setDelta(new Em(.5, .5)), _this59._verticalFilter.setDelta(new Em(-.5, .5)), _this59._filter = new Je({}, t);
    return _this59;
  }

  _createClass(ws, [{
    key: "_renderWebGL",
    value: function _renderWebGL(e) {
      return this._renderBlur(e);
    }
  }, {
    key: "_renderCanvas",
    value: function _renderCanvas(e) {
      return this._options.highQualityCanvasBlur ? this._renderBlur(e) : this._renderLQCanvasBlur(e);
    }
  }, {
    key: "_renderBlur",
    value: function _renderBlur(e) {
      var t = e.getDimensions(),
          i = t.min(),
          r = this._options.blurRadius,
          o = {
        blurRadius: r * i,
        texSize: t,
        blurQuality: "high"
      };
      return this._horizontalFilter.set(o), this._verticalFilter.set(o), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "_renderLQCanvasBlur",
    value: function _renderLQCanvasBlur(e) {
      var t = this._options.blurRadius,
          i = e.getDimensions();
      return this._filter.set({
        blurRadius: t,
        texSize: i,
        blurQuality: "low"
      }), this._sprite.setFilters([this._filter]), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "transform",
    value: function transform(e) {
      var t = this.getBlurRadius(),
          i = e.applyToRelativeSize(t);
      this.set({
        blurRadius: i
      }, !1);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ws.prototype), "dispose", this).call(this), this._filter.dispose(), this._verticalFilter.dispose(), this._horizontalFilter.dispose();
    }
  }, {
    key: "hasChanges",
    value: function hasChanges() {
      return !0;
    }
  }]);

  return ws;
}(ee);

ws.identifier = "blur";
ws.prototype.availableOptions = {
  blurRadius: {
    type: m.NUMBER,
    default: .025
  },
  highQualityCanvasBlur: {
    type: m.BOOLEAN,
    default: !1
  }
};
N.Operations.BlurOperation = ws;
var Sm = ws;
var gc = {};
we(gc, {
  A15Filter: function A15Filter() {
    return nd;
  },
  BWFilter: function BWFilter() {
    return ld;
  },
  BWHardFilter: function BWHardFilter() {
    return cd;
  },
  BreezeFilter: function BreezeFilter() {
    return ad;
  },
  CelsiusFilter: function CelsiusFilter() {
    return ud;
  },
  ChestFilter: function ChestFilter() {
    return md;
  },
  DuoToneFilter: function DuoToneFilter() {
    return dd;
  },
  FixieFilter: function FixieFilter() {
    return hd;
  },
  FoodFilter: function FoodFilter() {
    return pd;
  },
  FridgeFilter: function FridgeFilter() {
    return gd;
  },
  FrontFilter: function FrontFilter() {
    return fd;
  },
  GlamFilter: function GlamFilter() {
    return _d;
  },
  GobblinFilter: function GobblinFilter() {
    return yd;
  },
  IdentityFilter: function IdentityFilter() {
    return Po;
  },
  K1Filter: function K1Filter() {
    return bd;
  },
  K2Filter: function K2Filter() {
    return xd;
  },
  K6Filter: function K6Filter() {
    return vd;
  },
  KDynamicFilter: function KDynamicFilter() {
    return Cd;
  },
  LUTFilter: function LUTFilter() {
    return Md;
  },
  LeninFilter: function LeninFilter() {
    return wd;
  },
  LomoFilter: function LomoFilter() {
    return Dd;
  },
  MellowFilter: function MellowFilter() {
    return kd;
  },
  MetalFilter: function MetalFilter() {
    return Td;
  },
  MorningFilter: function MorningFilter() {
    return Rd;
  },
  OrchidFilter: function OrchidFilter() {
    return Fd;
  },
  Pola669Filter: function Pola669Filter() {
    return Sd;
  },
  PolaFilter: function PolaFilter() {
    return Ed;
  },
  QuoziFilter: function QuoziFilter() {
    return Ad;
  },
  SemiredFilter: function SemiredFilter() {
    return Id;
  },
  SunnyFilter: function SunnyFilter() {
    return Od;
  },
  TexasFilter: function TexasFilter() {
    return Pd;
  },
  ThreeDLUTFilter: function ThreeDLUTFilter() {
    return Ld;
  },
  X400Filter: function X400Filter() {
    return Bd;
  }
});
var Am = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_filteredImage;\nuniform float u_intensity;\n\nvoid main() {\n  vec4 color0 = texture2D(u_image, v_texCoord);\n  vec4 color1 = texture2D(u_filteredImage, v_texCoord);\n  gl_FragColor = mix(color0, color1, u_intensity);\n}\n";

var Cl =
/*#__PURE__*/
function (_k$Filter6) {
  _inherits(Cl, _k$Filter6);

  function Cl() {
    var _this60;

    _classCallCheck(this, Cl);

    _this60 = _possibleConstructorReturn(this, _getPrototypeOf(Cl).call(this));
    _this60._fragmentSource = Am;
    return _this60;
  }

  _createClass(Cl, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = i.getContext(),
          a = this._options.filteredCanvas;
      n.save(), n.globalAlpha = 1 - this._options.intensity, n.drawImage(o, 0, 0), n.globalAlpha = this._options.intensity, n.drawImage(a, 0, 0), n.restore();
    }
  }]);

  return Cl;
}(k.Filter);

Cl.prototype.availableOptions = {
  filteredImage: {
    type: m.NUMBER,
    default: 1,
    uniformType: F.INT
  },
  filteredCanvas: {
    type: m.OBJECT,
    default: null
  },
  intensity: {
    type: m.NUMBER,
    default: 1,
    uniformType: F.FLOAT
  }
};

var Im =
/*#__PURE__*/
function () {
  function Im() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    _classCallCheck(this, Im);

    this._intensity = e, this._stack = [], this._dirtiness = {}, this._renderTextures = {}, this._container = new k.Container(), this._sprite = new k.Sprite(), this._container.addChild(this._sprite), this._blendFilter = new Cl();
  }

  _createClass(Im, [{
    key: "push",
    value: function push(e) {
      this._stack.push(e);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._stack = [];
    }
  }, {
    key: "render",
    value: function render(e, t, i) {
      if (this.isEmpty()) return Promise.resolve();
      var r = e.getRenderer();

      this._sprite.setTexture(t);

      var o = this._renderTextures[r.id];

      if (!o) {
        var _l6 = e.getSprite().getTexture().getFrame();

        o = new k.RenderTexture(e.getRenderer(), _l6.width, _l6.height), this._renderTextures[r.id] = o;
      }

      var n = i.getDimensions();
      o.resizeTo(n);
      var a = this.isDirtyForRenderer(r);

      if (a) {
        this._stack.forEach(function (c) {
          c.update(e);
        });

        var _l7 = this._stack.map(function (c) {
          return c.getFilter();
        });

        this._sprite.setFilters(_l7), o.render(this._container), this.setDirtyForRenderer(!1, r);
      }

      if (this._blendFilter.setIntensity(this._intensity), r.isOfType(U.CANVAS)) this._blendFilter.setFilteredCanvas(o.getRenderTarget().getCanvas());else if (r.isOfType(U.WEBGL)) {
        var _l8 = o.getBaseTexture();

        _l8.setGLUnit(this._blendFilter.getFilteredImage()), r.updateTexture(_l8, !1);
      }
      return this._sprite.setFilters([this._blendFilter]), i.clear(R.TRANSPARENT), i.render(this._container), a && this.disposeRenderTextures(), Promise.resolve();
    }
  }, {
    key: "setIntensity",
    value: function setIntensity(e) {
      this._intensity = e;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._stack.length === 0;
    }
  }, {
    key: "isDirtyForRenderer",
    value: function isDirtyForRenderer(e) {
      return e.id in this._dirtiness || (this._dirtiness[e.id] = !0), this._dirtiness[e.id];
    }
  }, {
    key: "setDirtyForRenderer",
    value: function setDirtyForRenderer(e, t) {
      this._dirtiness[t.id] = e;
    }
  }, {
    key: "setDirty",
    value: function setDirty(e) {
      for (var _t20 in this._dirtiness) {
        this._dirtiness[_t20] = e;
      }
    }
  }, {
    key: "disposeRenderTextures",
    value: function disposeRenderTextures() {
      for (var _e15 in this._renderTextures) {
        this._renderTextures[_e15].dispose(), delete this._renderTextures[_e15];
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposeRenderTextures(), this._stack.forEach(function (e) {
        return e.dispose();
      }), this._stack = [], this._blendFilter.dispose(), this._sprite.dispose();
    }
  }]);

  return Im;
}(),
    wl = Im;

var pr =
/*#__PURE__*/
function (_V4) {
  _inherits(pr, _V4);

  function pr() {
    var _this61;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, pr);

    _this61 = _possibleConstructorReturn(this, _getPrototypeOf(pr).call(this, e, C({
      intensity: {
        type: m.NUMBER,
        default: 1,
        setter: function setter(i) {
          return this._stack && this._stack.setIntensity(i), i;
        }
      },
      dirty: {
        type: m.BOOLEAN,
        default: !0
      }
    }, t)));
    _this61._stack = new wl(_this61._options.intensity);
    return _this61;
  }

  _createClass(pr, [{
    key: "render",
    value: function render(e, t, i) {
      var _this62 = this;

      return this._stack.render(e, t, i).then(function (r) {
        return _this62.setDirty(!1), r;
      });
    }
  }, {
    key: "setDirtyForRenderer",
    value: function setDirtyForRenderer(e, t) {
      this._stack.setDirtyForRenderer(e, t);
    }
  }, {
    key: "disposeRenderTextures",
    value: function disposeRenderTextures() {
      this._stack.disposeRenderTextures();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._stack.dispose();
    }
  }]);

  return pr;
}(V);

pr.identifier = null;
pr.isIdentity = !1;
pr.displayName = null;
pr.PrimitivesStack = wl;
var M = pr;
var Ul = {};
we(Ul, {
  Brightness: function Brightness() {
    return Bi;
  },
  ColorMatrixPrimitive: function ColorMatrixPrimitive() {
    return _o;
  },
  Contrast: function Contrast() {
    return et;
  },
  Desaturation: function Desaturation() {
    return At;
  },
  DuoTone: function DuoTone() {
    return xo;
  },
  Gamma: function Gamma() {
    return Co;
  },
  Glow: function Glow() {
    return gr;
  },
  Gobblin: function Gobblin() {
    return Do;
  },
  Grayscale: function Grayscale() {
    return fr;
  },
  LookupTable: function LookupTable() {
    return ko;
  },
  LookupTableImage: function LookupTableImage() {
    return To;
  },
  Saturation: function Saturation() {
    return tt;
  },
  SoftColorOverlay: function SoftColorOverlay() {
    return Eo;
  },
  ThreeDLookupTableImage: function ThreeDLookupTableImage() {
    return Io;
  },
  ToneCurve: function ToneCurve() {
    return q;
  },
  X400: function X400() {
    return So;
  }
});
var Om = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_brightness;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4((texColor.rgb + vec3(u_brightness) * texColor.a), texColor.a);;\n}\n";

var Pm =
/*#__PURE__*/
function (_V5) {
  _inherits(Pm, _V5);

  function Pm() {
    _classCallCheck(this, Pm);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pm).apply(this, arguments));
  }

  _createClass(Pm, [{
    key: "update",
    value: function update() {}
  }, {
    key: "getFilter",
    value: function getFilter() {
      return this._filter;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._filter && (this._filter.dispose(), this._filter = null);
    }
  }]);

  return Pm;
}(V),
    ne = Pm;

var po =
/*#__PURE__*/
function (_k$Filter7) {
  _inherits(po, _k$Filter7);

  function po() {
    var _this63;

    _classCallCheck(this, po);

    _this63 = _possibleConstructorReturn(this, _getPrototypeOf(po).call(this));
    _this63._fragmentSource = Om;
    return _this63;
  }

  _createClass(po, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          c = this._options.brightness;

      if (c === 0) {
        a.putImageData(l, 0, 0);
        return;
      }

      c *= 255;

      for (var _u5 = 0; _u5 < o.width * o.height; _u5++) {
        var _p3 = _u5 * 4;

        l.data[_p3] += c, l.data[_p3 + 1] += c, l.data[_p3 + 2] += c;
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return po;
}(k.Filter);

po.prototype.availableOptions = {
  brightness: {
    type: m.NUMBER,
    default: 0,
    uniformType: F.FLOAT
  }
};

var Dl =
/*#__PURE__*/
function (_ne) {
  _inherits(Dl, _ne);

  function Dl() {
    var _getPrototypeOf8;

    var _this64;

    _classCallCheck(this, Dl);

    for (var _len17 = arguments.length, e = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
      e[_key17] = arguments[_key17];
    }

    _this64 = _possibleConstructorReturn(this, (_getPrototypeOf8 = _getPrototypeOf(Dl)).call.apply(_getPrototypeOf8, [this].concat(e)));
    _this64._filter = new po();
    return _this64;
  }

  _createClass(Dl, [{
    key: "update",
    value: function update() {
      this._filter.setBrightness(this._options.brightness);
    }
  }]);

  return Dl;
}(ne);

Dl.prototype.availableOptions = po.prototype.availableOptions;
var Bi = Dl;
var Bm = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_contrast;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4(((texColor.rgb - vec3(0.5)) * u_contrast + vec3(0.5) * texColor.a), texColor.a);\n}\n";

var go =
/*#__PURE__*/
function (_k$Filter8) {
  _inherits(go, _k$Filter8);

  function go() {
    var _this65;

    _classCallCheck(this, go);

    _this65 = _possibleConstructorReturn(this, _getPrototypeOf(go).call(this));
    _this65._fragmentSource = Bm;
    return _this65;
  }

  _createClass(go, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          c = this._options.contrast;

      if (c !== 1) {
        for (var _u6 = 0; _u6 < o.width * o.height; _u6++) {
          var _p4 = _u6 * 4;

          l.data[_p4] = (l.data[_p4] - 127) * c + 127, l.data[_p4 + 1] = (l.data[_p4 + 1] - 127) * c + 127, l.data[_p4 + 2] = (l.data[_p4 + 2] - 127) * c + 127;
        }

        a.putImageData(l, 0, 0);
      }
    }
  }]);

  return go;
}(k.Filter);

go.prototype.availableOptions = {
  contrast: {
    type: m.NUMBER,
    default: 1,
    uniformType: F.FLOAT
  }
};

var kl =
/*#__PURE__*/
function (_ne2) {
  _inherits(kl, _ne2);

  function kl() {
    var _getPrototypeOf9;

    var _this66;

    _classCallCheck(this, kl);

    for (var _len18 = arguments.length, e = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
      e[_key18] = arguments[_key18];
    }

    _this66 = _possibleConstructorReturn(this, (_getPrototypeOf9 = _getPrototypeOf(kl)).call.apply(_getPrototypeOf9, [this].concat(e)));
    _this66._filter = new go();
    return _this66;
  }

  _createClass(kl, [{
    key: "update",
    value: function update() {
      this._filter.setContrast(this._options.contrast);
    }
  }]);

  return kl;
}(ne);

kl.prototype.availableOptions = go.prototype.availableOptions;
var et = kl;
var Mm = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform mat4 u_colorMatrix;\nuniform vec4 u_colorMatrixOffset;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = texColor * u_colorMatrix + u_colorMatrixOffset;\n}\n";

var p_ = I.ColorMatrix,
    fo =
/*#__PURE__*/
function (_k$Filter9) {
  _inherits(fo, _k$Filter9);

  function fo() {
    var _this67;

    _classCallCheck(this, fo);

    _this67 = _possibleConstructorReturn(this, _getPrototypeOf(fo).call(this));
    _this67._fragmentSource = Mm;
    return _this67;
  }

  _createClass(fo, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          c = this._options.colorMatrix,
          u = new R(0, 0, 0, 0);

      for (var _p5 = 0; _p5 < o.width * o.height; _p5++) {
        var _h3 = _p5 * 4;

        u.r = l.data[_h3] / 255, u.g = l.data[_h3 + 1] / 255, u.b = l.data[_h3 + 2] / 255, u = c.apply(u), l.data[_h3] = u.r * 255, l.data[_h3 + 1] = u.g * 255, l.data[_h3 + 2] = u.b * 255;
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return fo;
}(k.Filter);

fo.prototype.availableOptions = {
  colorMatrix: {
    type: m.COLOR_MATRIX,
    default: new p_(),
    uniformType: F.MAT4
  },
  colorMatrixOffset: {
    type: m.ARRAY,
    default: [],
    uniformType: F.FLOAT4
  }
};

var Tl =
/*#__PURE__*/
function (_ne3) {
  _inherits(Tl, _ne3);

  function Tl() {
    var _getPrototypeOf10;

    var _this68;

    _classCallCheck(this, Tl);

    for (var _len19 = arguments.length, e = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
      e[_key19] = arguments[_key19];
    }

    _this68 = _possibleConstructorReturn(this, (_getPrototypeOf10 = _getPrototypeOf(Tl)).call.apply(_getPrototypeOf10, [this].concat(e)));
    _this68._filter = new fo();
    return _this68;
  }

  _createClass(Tl, [{
    key: "update",
    value: function update() {
      this._filter.setColorMatrix(this._options.colorMatrix);
    }
  }]);

  return Tl;
}(ne);

Tl.prototype.availableOptions = fo.prototype.availableOptions;
var _o = Tl;
var Lm = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_desaturation;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec3 grayXfer = vec3(0.3, 0.59, 0.11);\n  vec3 gray = vec3(dot(grayXfer, texColor.xyz));\n  gl_FragColor = vec4(mix(texColor.xyz, gray, u_desaturation) * texColor.a, texColor.a);\n}\n";

var yo =
/*#__PURE__*/
function (_k$Filter10) {
  _inherits(yo, _k$Filter10);

  function yo() {
    var _this69;

    _classCallCheck(this, yo);

    _this69 = _possibleConstructorReturn(this, _getPrototypeOf(yo).call(this));
    _this69._fragmentSource = Lm;
    return _this69;
  }

  _createClass(yo, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          c = [.3, .59, .11],
          u = this._options.desaturation;

      for (var _p6 = 0; _p6 < o.width * o.height; _p6++) {
        var _h4 = _p6 * 4,
            _d8 = c[0] * l.data[_h4] / 255 + c[1] * l.data[_h4 + 1] / 255 + c[2] * l.data[_h4 + 2] / 255;

        l.data[_h4] += (_d8 * 255 - l.data[_h4]) * u, l.data[_h4 + 1] += (_d8 * 255 - l.data[_h4 + 1]) * u, l.data[_h4 + 2] += (_d8 * 255 - l.data[_h4 + 2]) * u;
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return yo;
}(k.Filter);

yo.prototype.availableOptions = {
  desaturation: {
    type: m.NUMBER,
    default: 1,
    uniformType: F.FLOAT
  }
};

var Rl =
/*#__PURE__*/
function (_ne4) {
  _inherits(Rl, _ne4);

  function Rl() {
    var _getPrototypeOf11;

    var _this70;

    _classCallCheck(this, Rl);

    for (var _len20 = arguments.length, e = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
      e[_key20] = arguments[_key20];
    }

    _this70 = _possibleConstructorReturn(this, (_getPrototypeOf11 = _getPrototypeOf(Rl)).call.apply(_getPrototypeOf11, [this].concat(e)));
    _this70._filter = new yo();
    return _this70;
  }

  _createClass(Rl, [{
    key: "update",
    value: function update() {
      this._filter.setDesaturation(this._options.desaturation);
    }
  }]);

  return Rl;
}(ne);

Rl.prototype.availableOptions = yo.prototype.availableOptions;
var At = Rl;
var zm = "precision highp float;\n\nuniform sampler2D u_image;\nuniform vec4 u_lightColor;\nuniform vec4 u_darkColor;\nuniform float u_intensity;\nvarying vec2 v_texCoord;\n\nconst float EPSILON = 0.0000001;\nconst vec3 GRAYSCALE_WEIGHTS = vec3(0.2126, 0.7152, 0.0722);\n\nvec4 duotoneKernel(vec4 sampledCol, vec4 light, vec4 dark, float intensity) {\n  vec4 color = clamp(sampledCol, 0.0, 1.0);\n  color.rgb /= max(color.a, EPSILON);\n  color = clamp(color, 0.0, 1.0); // necessary to get rid of all extended sRGB issues with OpenGL ES\n \n  // Apply intensity as \"symmetric gamma\"\n  if (intensity > 0.0) {\n    color.rgb = 1.0 - pow(1.0 - color.rgb, vec3(max(intensity + 1.0, EPSILON)));\n  } else {\n    color.rgb = pow(color.rgb, vec3(max(-intensity + 1.0, EPSILON)));\n  }\n \n  // Colorimetric (perceptual luminance-preserving) RGB to grayscale conversion\n  // https://en.wikipedia.org/wiki/Grayscale#Colorimetric_(perceptual_luminance-preserving)_conversion_to_grayscale\n  float luminance = dot(GRAYSCALE_WEIGHTS, color.rgb);\n \n  // Apply DuoTone\n  vec4 duotone = mix(dark, light, clamp(luminance, 0.0, 1.0));\n  duotone.a *= color.a;\n  \n  duotone.rgb *= duotone.a;\n\n  return duotone;\n}\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = duotoneKernel(texColor, u_lightColor, u_darkColor, u_intensity);\n}";

var bo =
/*#__PURE__*/
function (_k$Filter11) {
  _inherits(bo, _k$Filter11);

  function bo() {
    var _this71;

    _classCallCheck(this, bo);

    _this71 = _possibleConstructorReturn(this, _getPrototypeOf(bo).call(this));
    _this71._fragmentSource = zm;
    return _this71;
  }

  _createClass(bo, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          _this$_options5 = this._options,
          c = _this$_options5.lightColor,
          u = _this$_options5.darkColor,
          p = _this$_options5.intensity;

      for (var _h5 = 0; _h5 < o.width * o.height; _h5++) {
        var _d9 = _h5 * 4,
            _g6 = l.data[_d9] / 255,
            _y9 = l.data[_d9 + 1] / 255,
            _10 = l.data[_d9 + 2] / 255,
            _f5 = l.data[_d9 + 3] / 255,
            _v4 = new R(_g6, _y9, _10, _f5),
            _b3 = this._duoToneKernel(_v4, c, u, p);

        l.data[_d9] = _b3.r * 255, l.data[_d9 + 1] = _b3.g * 255, l.data[_d9 + 2] = _b3.b * 255, l.data[_d9 + 3] = _b3.a * 255;
      }

      a.putImageData(l, 0, 0);
    }
  }, {
    key: "_duoToneKernel",
    value: function _duoToneKernel(e, t, i, r) {
      var o = 1e-7;

      if (e.clone().clamp(0, 1), r > 0) {
        var _c12 = Math.max(r + 1, o);

        e.r = 1 - Math.pow(1 - e.r, _c12), e.g = 1 - Math.pow(1 - e.g, _c12), e.b = 1 - Math.pow(1 - e.b, _c12);
      } else {
        var _c13 = Math.max(-r + 1, o);

        e.r = Math.pow(e.r, _c13), e.g = Math.pow(e.g, _c13), e.b = Math.pow(e.b, _c13);
      }

      var n = .2126 * e.r + .7152 * e.g + .0722 * e.b,
          a = Math.min(Math.max(n, 0), 1),
          l = i.clone().mix(t, a);
      return l.a *= e.a, l;
    }
  }]);

  return bo;
}(k.Filter);

bo.prototype.availableOptions = {
  lightColor: {
    type: m.COLOR,
    default: R.RED,
    uniformType: F.FLOAT4
  },
  darkColor: {
    type: m.COLOR,
    default: R.BLACK,
    uniformType: F.FLOAT4
  },
  intensity: {
    type: m.NUMBER,
    default: .5,
    uniformType: F.FLOAT
  }
};

var Fl =
/*#__PURE__*/
function (_ne5) {
  _inherits(Fl, _ne5);

  function Fl() {
    var _getPrototypeOf12;

    var _this72;

    _classCallCheck(this, Fl);

    for (var _len21 = arguments.length, e = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      e[_key21] = arguments[_key21];
    }

    _this72 = _possibleConstructorReturn(this, (_getPrototypeOf12 = _getPrototypeOf(Fl)).call.apply(_getPrototypeOf12, [this].concat(e)));
    _this72._filter = new bo();
    return _this72;
  }

  _createClass(Fl, [{
    key: "update",
    value: function update() {
      this._filter.setLightColor(this._options.lightColor), this._filter.setDarkColor(this._options.darkColor);
      var e = 2 * this._options.intensity - 1;

      this._filter.setIntensity(e);
    }
  }]);

  return Fl;
}(ne);

Fl.prototype.availableOptions = bo.prototype.availableOptions;
var xo = Fl;
var Um = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform vec3 u_gamma;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec3 rgb = vec3(texColor.r, texColor.g, texColor.b);\n  rgb = pow(rgb, u_gamma);\n  gl_FragColor = vec4(rgb * texColor.a, texColor.a);;\n}\n";

var vo =
/*#__PURE__*/
function (_k$Filter12) {
  _inherits(vo, _k$Filter12);

  function vo() {
    var _this73;

    _classCallCheck(this, vo);

    _this73 = _possibleConstructorReturn(this, _getPrototypeOf(vo).call(this));
    _this73._fragmentSource = Um;
    return _this73;
  }

  _createClass(vo, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          c = this._options.gamma,
          u = new Float32Array(256);

      for (var _d10 = 0; _d10 < 256; _d10++) {
        u[_d10] = 255 * Math.pow(_d10 / 255, c.r);
      }

      var p = new Float32Array(256);

      for (var _d11 = 0; _d11 < 256; _d11++) {
        p[_d11] = 255 * Math.pow(_d11 / 255, c.g);
      }

      var h = new Float32Array(256);

      for (var _d12 = 0; _d12 < 256; _d12++) {
        h[_d12] = 255 * Math.pow(_d12 / 255, c.b);
      }

      for (var _d13 = 0; _d13 < o.width * o.height; _d13++) {
        var _g7 = _d13 * 4;

        l.data[_g7] = u[l.data[_g7]], l.data[_g7 + 1] = p[l.data[_g7 + 1]], l.data[_g7 + 2] = h[l.data[_g7 + 2]];
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return vo;
}(k.Filter);

vo.prototype.availableOptions = {
  gamma: {
    type: m.COLOR,
    default: R.WHITE,
    uniformType: F.FLOAT3
  }
};

var El =
/*#__PURE__*/
function (_ne6) {
  _inherits(El, _ne6);

  function El() {
    var _getPrototypeOf13;

    var _this74;

    _classCallCheck(this, El);

    for (var _len22 = arguments.length, e = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
      e[_key22] = arguments[_key22];
    }

    _this74 = _possibleConstructorReturn(this, (_getPrototypeOf13 = _getPrototypeOf(El)).call.apply(_getPrototypeOf13, [this].concat(e)));
    _this74._filter = new vo();
    return _this74;
  }

  _createClass(El, [{
    key: "update",
    value: function update() {
      this._filter.setGamma(this._options.gamma);
    }
  }]);

  return El;
}(ne);

El.prototype.availableOptions = vo.prototype.availableOptions;
var Co = El;
var Nm = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nuniform vec3 u_color;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n\n  vec2 textureCoord = v_texCoord - vec2(0.5, 0.5);\n  textureCoord /= 0.75;\n\n  float d = 1.0 - dot(textureCoord, textureCoord);\n  d = clamp(d, 0.2, 1.0);\n  vec3 newColor = texColor.rgb * d * u_color.rgb;\n  gl_FragColor = vec4(vec3(newColor) * texColor.a, texColor.a);\n}\n";

var wo =
/*#__PURE__*/
function (_k$Filter13) {
  _inherits(wo, _k$Filter13);

  function wo() {
    var _this75;

    _classCallCheck(this, wo);

    _this75 = _possibleConstructorReturn(this, _getPrototypeOf(wo).call(this));
    _this75._fragmentSource = Nm;
    return _this75;
  }

  _createClass(wo, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          c = this._options.color,
          u;

      for (var _p7 = 0; _p7 < o.width; _p7++) {
        for (var _h6 = 0; _h6 < o.height; _h6++) {
          var _d14 = (o.width * _h6 + _p7) * 4,
              _g8 = _p7 / o.width,
              _y10 = _h6 / o.height,
              _11 = (_g8 - .5) / .75,
              _f6 = (_y10 - .5) / .75,
              _v5 = _11 * _11,
              _b4 = _f6 * _f6;

          u = 1 - (_v5 + _b4), u = Math.min(Math.max(u, .1), 1), l.data[_d14] *= u * c.r, l.data[_d14 + 1] = l.data[_d14 + 1] * (u * c.g), l.data[_d14 + 2] = l.data[_d14 + 2] * (u * c.b), l.data[_d14 + 3] = 255;
        }
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return wo;
}(k.Filter);

wo.prototype.availableOptions = {
  color: {
    type: m.COLOR,
    default: R.WHITE,
    uniformType: F.FLOAT3
  }
};

var Sl =
/*#__PURE__*/
function (_ne7) {
  _inherits(Sl, _ne7);

  function Sl() {
    var _getPrototypeOf14;

    var _this76;

    _classCallCheck(this, Sl);

    for (var _len23 = arguments.length, e = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
      e[_key23] = arguments[_key23];
    }

    _this76 = _possibleConstructorReturn(this, (_getPrototypeOf14 = _getPrototypeOf(Sl)).call.apply(_getPrototypeOf14, [this].concat(e)));
    _this76._filter = new wo();
    return _this76;
  }

  _createClass(Sl, [{
    key: "update",
    value: function update() {
      this._filter.setColor(this._options.color);
    }
  }]);

  return Sl;
}(ne);

Sl.prototype.availableOptions = wo.prototype.availableOptions;
var gr = Sl;
var Gm = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  texColor.b = texColor.g * 0.33;\n  texColor.r = texColor.r * 0.6;\n  texColor.b += texColor.r * 0.33;\n  texColor.g = texColor.g * 0.7;\n  gl_FragColor = texColor;\n}\n";

var Wm =
/*#__PURE__*/
function (_k$Filter14) {
  _inherits(Wm, _k$Filter14);

  function Wm() {
    var _this77;

    _classCallCheck(this, Wm);

    _this77 = _possibleConstructorReturn(this, _getPrototypeOf(Wm).call(this));
    _this77._fragmentSource = Gm;
    return _this77;
  }

  _createClass(Wm, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height);

      for (var _c14 = 0; _c14 < o.width; _c14++) {
        for (var _u7 = 0; _u7 < o.height; _u7++) {
          var _p8 = (o.width * _u7 + _c14) * 4;

          l.data[_p8 + 2] = l.data[_p8 + 1] * .33, l.data[_p8] *= .6, l.data[_p8 + 2] += l.data[_p8] * .33, l.data[_p8 + 1] = l.data[_p8 + 1] * .7, l.data[_p8 + 3] = 255;
        }
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return Wm;
}(k.Filter),
    Vm =
/*#__PURE__*/
function (_ne8) {
  _inherits(Vm, _ne8);

  function Vm() {
    var _getPrototypeOf15;

    var _this78;

    _classCallCheck(this, Vm);

    for (var _len24 = arguments.length, e = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
      e[_key24] = arguments[_key24];
    }

    _this78 = _possibleConstructorReturn(this, (_getPrototypeOf15 = _getPrototypeOf(Vm)).call.apply(_getPrototypeOf15, [this].concat(e)));
    _this78._filter = new Wm();
    return _this78;
  }

  return Vm;
}(ne),
    Do = Vm;

var Hm = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nvec3 W = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float luminance = dot(texColor.rgb, W);\n  gl_FragColor = vec4(vec3(luminance) * texColor.a, texColor.a);\n}\n";

var jm =
/*#__PURE__*/
function (_k$Filter15) {
  _inherits(jm, _k$Filter15);

  function jm() {
    var _this79;

    _classCallCheck(this, jm);

    _this79 = _possibleConstructorReturn(this, _getPrototypeOf(jm).call(this));
    _this79._fragmentSource = Hm;
    return _this79;
  }

  _createClass(jm, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height);

      for (var _c15 = 0; _c15 < o.width; _c15++) {
        for (var _u8 = 0; _u8 < o.height; _u8++) {
          var _p9 = (o.width * _u8 + _c15) * 4,
              _h7 = l.data[_p9] * .2125 + l.data[_p9 + 1] * .7154 + l.data[_p9 + 2] * .0721;

          l.data[_p9] = _h7, l.data[_p9 + 1] = _h7, l.data[_p9 + 2] = _h7;
        }
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return jm;
}(k.Filter),
    Ym =
/*#__PURE__*/
function (_ne9) {
  _inherits(Ym, _ne9);

  function Ym() {
    var _getPrototypeOf16;

    var _this80;

    _classCallCheck(this, Ym);

    for (var _len25 = arguments.length, e = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
      e[_key25] = arguments[_key25];
    }

    _this80 = _possibleConstructorReturn(this, (_getPrototypeOf16 = _getPrototypeOf(Ym)).call.apply(_getPrototypeOf16, [this].concat(e)));
    _this80._filter = new jm();
    return _this80;
  }

  return Ym;
}(ne),
    fr = Ym;

var qm = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_lookupTable;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float r = texture2D(u_lookupTable, vec2(texColor.r, 0.0)).r;\n  float g = texture2D(u_lookupTable, vec2(texColor.g, 0.0)).g;\n  float b = texture2D(u_lookupTable, vec2(texColor.b, 0.0)).b;\n\n  gl_FragColor = vec4(vec3(r, g, b) * texColor.a, texColor.a);\n}\n";

var Al =
/*#__PURE__*/
function (_k$Filter16) {
  _inherits(Al, _k$Filter16);

  function Al() {
    var _getPrototypeOf17;

    var _this81;

    _classCallCheck(this, Al);

    for (var _len26 = arguments.length, e = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
      e[_key26] = arguments[_key26];
    }

    _this81 = _possibleConstructorReturn(this, (_getPrototypeOf17 = _getPrototypeOf(Al)).call.apply(_getPrototypeOf17, [this].concat(e)));
    _this81._fragmentSource = qm;
    return _this81;
  }

  _createClass(Al, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          c = this._options.lookupTableData;

      for (var _u9 = 0; _u9 < o.width * o.height; _u9++) {
        var _p10 = _u9 * 4,
            _h8 = l.data[_p10];

        l.data[_p10] = c[_h8 * 4];
        var _d15 = l.data[_p10 + 1];
        l.data[_p10 + 1] = c[1 + _d15 * 4];
        var _g9 = l.data[_p10 + 2];
        l.data[_p10 + 2] = c[2 + _g9 * 4];
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return Al;
}(k.Filter);

Al.prototype.availableOptions = {
  lookupTable: {
    type: m.NUMBER,
    default: 1,
    uniformType: F.INT
  },
  lookupTableData: {
    type: m.ARRAY,
    default: []
  }
};

var Km =
/*#__PURE__*/
function (_ne10) {
  _inherits(Km, _ne10);

  function Km() {
    var _getPrototypeOf18;

    var _this82;

    _classCallCheck(this, Km);

    for (var _len27 = arguments.length, e = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
      e[_key27] = arguments[_key27];
    }

    _this82 = _possibleConstructorReturn(this, (_getPrototypeOf18 = _getPrototypeOf(Km)).call.apply(_getPrototypeOf18, [this].concat(e)));
    _this82._filter = new Al({
      lookupTable: _this82._options.textureGLUnit
    }), _this82._textures = {}, _this82._renderers = {};
    return _this82;
  }

  _createClass(Km, [{
    key: "update",
    value: function update(e) {
      var t = e.getRenderer();
      t.isOfType(U.WEBGL) ? this._updateWebGLTexture(e) : t.isOfType(U.CANVAS) && this._filter.setLookupTableData(this._options.data);
    }
  }, {
    key: "_updateWebGLTexture",
    value: function _updateWebGLTexture(e) {
      if (typeof this._options.data == "undefined") throw new Error("LookupTable: No data specified.");
      var t = new Uint8Array(this._options.data),
          i = e.getRenderer(),
          r = i.id;
      this._renderers[r] = i, this._textures[r] || (this._textures[r] = new k.BaseTexture());
      var o = this._textures[r],
          n = new k.PixelArrayImage(256, 1, t);
      o.setSource(n), o.setGLUnit(this._options.textureGLUnit), i.isOfType(U.WEBGL) && i.updateTexture(o);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Km.prototype), "dispose", this).call(this);

      for (var _e16 in this._textures) {
        this._textures[_e16].dispose(), delete this._textures[_e16];
      }

      delete this._options.data;
    }
  }]);

  return Km;
}(ne),
    ko = Km;

var Xm = "/**\n * Based off of GPUImage's LookupFilter:\n * https://github.com/BradLarson/GPUImage/blob/master/framework/Source/GPUImageLookupFilter.m\n */\n\nvarying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_lookupTable;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float blueColor = texColor.b * 63.0;\n\n  vec2 quad1;\n  quad1.y = floor(floor(blueColor) / 8.0);\n  quad1.x = floor(blueColor) - (quad1.y * 8.0);\n\n  vec2 quad2;\n  quad2.y = floor(ceil(blueColor) / 8.0);\n  quad2.x = ceil(blueColor) - (quad2.y * 8.0);\n\n  vec2 texCoord1;\n  texCoord1.x = (quad1.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.r);\n  texCoord1.y = (quad1.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.g);\n\n  vec2 texCoord2;\n  texCoord2.x = (quad2.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.r);\n  texCoord2.y = (quad2.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.g);\n\n  vec4 newColor1 = texture2D(u_lookupTable, texCoord1);\n  vec4 newColor2 = texture2D(u_lookupTable, texCoord2);\n\n  vec4 newColor = mix(newColor1, newColor2, fract(blueColor));\n  gl_FragColor = mix(texColor, vec4(newColor.rgb, texColor.w), texColor.a);\n}\n";

var Qm = I.Vector2,
    Zm = 3,
    Il =
/*#__PURE__*/
function (_k$Filter17) {
  _inherits(Il, _k$Filter17);

  function Il() {
    var _this83;

    _classCallCheck(this, Il);

    _this83 = _possibleConstructorReturn(this, _getPrototypeOf(Il).call(this));
    _this83._precomputeQuads(), _this83._fragmentSource = Xm;
    return _this83;
  }

  _createClass(Il, [{
    key: "_precomputeQuads",
    value: function _precomputeQuads() {
      this._quads = [];

      for (var _e17 = 0; _e17 < 256; _e17++) {
        var _t21 = _e17 / 255 * 63,
            _i10 = new Qm();

        _i10.y = (_t21 | 0) * .125 | 0, _i10.x = (_t21 | 0) - _i10.y * 8, this._quads.push(_i10);
      }
    }
  }, {
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = this._options.lookupTableImage,
          u = this._createImageCanvas(l).getContext("2d"),
          p = n.getImageData(0, 0, o.width, o.height),
          h = u.getImageData(0, 0, l.width, l.height),
          d = new Qm();

      for (var _g10 = 0; _g10 < o.width * o.height * 4; _g10 += 4) {
        var _y11 = p.data[_g10],
            _12 = p.data[_g10 + 1],
            _f7 = p.data[_g10 + 2],
            _v6 = p.data[_g10 + 3] / 255,
            _b5 = this._quads[_f7],
            D = 64;

        d.x = _b5.x * D, d.y = _b5.y * D, d.x += Math.floor(_y11 / 4), d.y += Math.floor(_12 / 4);
        var O = (l.width * d.y + d.x) * 4 | 0,
            x = h.data[O];
        x = _y11 * (1 - _v6) + x * _v6;
        var w = h.data[O + 1];
        w = _12 * (1 - _v6) + w * _v6;
        var z = h.data[O + 2];
        z = _f7 * (1 - _v6) + z * _v6, p.data[_g10] = x, p.data[_g10 + 1] = w, p.data[_g10 + 2] = z;
      }

      a.putImageData(p, 0, 0);
    }
  }, {
    key: "_createImageCanvas",
    value: function _createImageCanvas(e) {
      var t = T.createCanvas();
      return t.width = e.width, t.height = e.height, t.getContext("2d").drawImage(e, 0, 0), t;
    }
  }]);

  return Il;
}(k.Filter);

Il.prototype.availableOptions = {
  lookupTable: {
    type: m.NUMBER,
    default: Zm,
    uniformType: F.INT
  },
  lookupTableImage: {
    type: m.IMAGE,
    uniformType: null
  }
};

var Ol =
/*#__PURE__*/
function (_ne11) {
  _inherits(Ol, _ne11);

  function Ol() {
    var _getPrototypeOf19;

    var _this84;

    _classCallCheck(this, Ol);

    for (var _len28 = arguments.length, e = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
      e[_key28] = arguments[_key28];
    }

    _this84 = _possibleConstructorReturn(this, (_getPrototypeOf19 = _getPrototypeOf(Ol)).call.apply(_getPrototypeOf19, [this].concat(e)));
    _this84._filter = new Il(), _this84._textures = {};
    return _this84;
  }

  _createClass(Ol, [{
    key: "update",
    value: function update(e) {
      var t = e.getRenderer();
      t.isOfType(U.WEBGL) ? this._updateWebGLTexture(e) : t.isOfType(U.CANVAS) && this._filter.setLookupTableImage(this._options.image);
    }
  }, {
    key: "_updateWebGLTexture",
    value: function _updateWebGLTexture(e) {
      var t = e.getRenderer(),
          i = t.id;
      this._textures[i] || (this._textures[i] = new k.BaseTexture());
      var r = this._textures[i];
      r.setSource(this._options.image), r.setGLUnit(Zm), t.updateTexture(r);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Ol.prototype), "dispose", this).call(this);

      for (var _e18 in this._textures) {
        delete this._textures[_e18];
      }
    }
  }]);

  return Ol;
}(ne);

Ol.prototype.availableOptions = {
  image: {
    type: m.IMAGE
  }
};
var To = Ol;
var $m = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_saturation;\n\nconst vec3 luminanceWeighting = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float luminance = dot(texColor.rgb, luminanceWeighting);\n\n  vec3 greyScaleColor = vec3(luminance);\n\n  gl_FragColor = vec4(mix(greyScaleColor, texColor.rgb, u_saturation) * texColor.a, texColor.a);\n}\n";

var Ro =
/*#__PURE__*/
function (_k$Filter18) {
  _inherits(Ro, _k$Filter18);

  function Ro() {
    var _this85;

    _classCallCheck(this, Ro);

    _this85 = _possibleConstructorReturn(this, _getPrototypeOf(Ro).call(this));
    _this85._fragmentSource = $m;
    return _this85;
  }

  _createClass(Ro, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height),
          c = this._options.saturation;

      for (var _u10 = 0; _u10 < o.width; _u10++) {
        for (var _p11 = 0; _p11 < o.height; _p11++) {
          var _h9 = (o.width * _p11 + _u10) * 4,
              _d16 = l.data[_h9] * .2125 + l.data[_h9 + 1] * .7154 + l.data[_h9 + 2] * .0721;

          l.data[_h9] = _d16 * (1 - c) + l.data[_h9] * c, l.data[_h9 + 1] = _d16 * (1 - c) + l.data[_h9 + 1] * c, l.data[_h9 + 2] = _d16 * (1 - c) + l.data[_h9 + 2] * c;
        }
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return Ro;
}(k.Filter);

Ro.prototype.availableOptions = {
  saturation: {
    type: m.NUMBER,
    default: 0,
    uniformType: F.FLOAT
  }
};

var Pl =
/*#__PURE__*/
function (_ne12) {
  _inherits(Pl, _ne12);

  function Pl() {
    var _getPrototypeOf20;

    var _this86;

    _classCallCheck(this, Pl);

    for (var _len29 = arguments.length, e = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
      e[_key29] = arguments[_key29];
    }

    _this86 = _possibleConstructorReturn(this, (_getPrototypeOf20 = _getPrototypeOf(Pl)).call.apply(_getPrototypeOf20, [this].concat(e)));
    _this86._filter = new Ro();
    return _this86;
  }

  _createClass(Pl, [{
    key: "update",
    value: function update() {
      this._filter.setSaturation(this._options.saturation);
    }
  }]);

  return Pl;
}(ne);

Pl.prototype.availableOptions = Ro.prototype.availableOptions;
var tt = Pl;
var Jm = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform vec3 u_color;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec4 overlayVec4 = vec4(u_color, texColor.a);\n  gl_FragColor = max(overlayVec4 * texColor.a, texColor);\n}\n";

var Fo =
/*#__PURE__*/
function (_k$Filter19) {
  _inherits(Fo, _k$Filter19);

  function Fo() {
    var _this87;

    _classCallCheck(this, Fo);

    _this87 = _possibleConstructorReturn(this, _getPrototypeOf(Fo).call(this));
    _this87._fragmentSource = Jm;
    return _this87;
  }

  _createClass(Fo, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height);

      for (var _c16 = 0; _c16 < o.width; _c16++) {
        for (var _u11 = 0; _u11 < o.height; _u11++) {
          var _p12 = (o.width * _u11 + _c16) * 4;

          l.data[_p12] = Math.max(this._options.color.r * 255, l.data[_p12]), l.data[_p12 + 1] = Math.max(this._options.color.g * 255, l.data[_p12 + 1]), l.data[_p12 + 2] = Math.max(this._options.color.b * 255, l.data[_p12 + 2]);
        }
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return Fo;
}(k.Filter);

Fo.prototype.availableOptions = {
  color: {
    type: m.COLOR,
    default: R.WHITE,
    uniformType: F.FLOAT3
  }
};

var Bl =
/*#__PURE__*/
function (_ne13) {
  _inherits(Bl, _ne13);

  function Bl() {
    var _getPrototypeOf21;

    var _this88;

    _classCallCheck(this, Bl);

    for (var _len30 = arguments.length, e = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
      e[_key30] = arguments[_key30];
    }

    _this88 = _possibleConstructorReturn(this, (_getPrototypeOf21 = _getPrototypeOf(Bl)).call.apply(_getPrototypeOf21, [this].concat(e)));
    _this88._filter = new Fo();
    return _this88;
  }

  _createClass(Bl, [{
    key: "update",
    value: function update() {
      this._filter.setColor(this._options.color);
    }
  }]);

  return Bl;
}(ne);

Bl.prototype.availableOptions = Fo.prototype.availableOptions;
var Eo = Bl;

var Ml =
/*#__PURE__*/
function (_ko) {
  _inherits(Ml, _ko);

  function Ml() {
    var _getPrototypeOf22;

    var _this89;

    _classCallCheck(this, Ml);

    for (var _len31 = arguments.length, e = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
      e[_key31] = arguments[_key31];
    }

    _this89 = _possibleConstructorReturn(this, (_getPrototypeOf22 = _getPrototypeOf(Ml)).call.apply(_getPrototypeOf22, [this].concat(e)));
    _this89._options.rgbControlPoints || (_this89._options.rgbControlPoints = {
      red: _this89._options.controlPoints,
      green: _this89._options.controlPoints,
      blue: _this89._options.controlPoints
    }), _this89._updateLookupTable();
    return _this89;
  }

  _createClass(Ml, [{
    key: "_updateLookupTable",
    value: function _updateLookupTable() {
      var e = this._calculateSplineCurve(this._options.rgbControlPoints.red),
          t = this._calculateSplineCurve(this._options.rgbControlPoints.green),
          i = this._calculateSplineCurve(this._options.rgbControlPoints.blue);

      this._options.data = this._buildLookupTable(e, t, i);
    }
  }, {
    key: "_buildLookupTable",
    value: function _buildLookupTable(e, t, i) {
      var r = [];

      for (var _o14 = 0; _o14 < 256; _o14++) {
        r.push(Math.min(Math.max(_o14 + e[_o14], 0), 255)), r.push(Math.min(Math.max(_o14 + t[_o14], 0), 255)), r.push(Math.min(Math.max(_o14 + i[_o14], 0), 255)), r.push(255);
      }

      return r;
    }
  }, {
    key: "_calculateSplineCurve",
    value: function _calculateSplineCurve(e) {
      e = e.sort(function (n, a) {
        return n[0] > a[0];
      });

      var t = this._getSplineCurve(e),
          i = t[0],
          r;

      if (i[0] > 0) for (r = 0; r < i[0]; r++) {
        t.unshift([0, 0]);
      }
      var o = [];

      for (r = 0; r < t.length; r++) {
        var _n8 = t[r],
            _a5 = [_n8[0], _n8[0]],
            _l9 = Math.sqrt(Math.pow(_a5[0] - _n8[0], 2) + Math.pow(_a5[1] - _n8[1], 2));

        _a5[1] > _n8[1] && (_l9 = -_l9), o.push(_l9);
      }

      return o;
    }
  }, {
    key: "_getSplineCurve",
    value: function _getSplineCurve(e) {
      var t = this._secondDerivative(e),
          i = t.length,
          r = [],
          o;

      for (o = 0; o < i; o++) {
        r[o] = t[o];
      }

      var n = [];

      for (o = 0; o < i - 1; o++) {
        var _a6 = e[o],
            _l10 = e[o + 1];

        for (var _c17 = _a6[0]; _c17 < _l10[0]; _c17++) {
          var _u12 = (_c17 - _a6[0]) / (_l10[0] - _a6[0]),
              _p13 = 1 - _u12,
              _h10 = _u12,
              _d17 = _l10[0] - _a6[0],
              _g11 = _p13 * _a6[1] + _h10 * _l10[1] + _d17 * _d17 / 6 * ((_p13 * _p13 * _p13 - _p13) * r[o] + (_h10 * _h10 * _h10 - _h10) * r[o + 1]);

          _g11 > 255 ? _g11 = 255 : _g11 < 0 && (_g11 = 0), n.push([_c17, _g11]);
        }
      }

      return n.length === 255 && n.push(e[e.length - 1]), n;
    }
  }, {
    key: "_secondDerivative",
    value: function _secondDerivative(e) {
      var t = e.length;
      if (t <= 0 || t === 1) return null;
      var i = [],
          r = [],
          o,
          n;

      for (i[0] = [0, 1, 0], o = 1; o < t - 1; o++) {
        var _l11 = e[o - 1],
            _c18 = e[o],
            _u13 = e[o + 1];
        i[o] = i[o] || [], i[o][0] = (_c18[0] - _l11[0]) / 6, i[o][1] = (_u13[0] - _l11[0]) / 3, i[o][2] = (_u13[0] - _c18[0]) / 6, r[o] = (_u13[1] - _c18[1]) / (_u13[0] - _c18[0]) - (_c18[1] - _l11[1]) / (_c18[0] - _l11[0]);
      }

      for (r[0] = 0, r[t - 1] = 0, i[t - 1] = [0, 1, 0], o = 1; o < t; o++) {
        n = i[1][0] / i[o - 1][1], i[o][1] -= n * i[o - 1][2], i[o][0] = 0, r[o] -= n * r[o - 1];
      }

      for (o = t - 2; o > 0; o--) {
        n = i[o][2] / i[o + 1][1], i[o][1] -= n * i[o + 1][0], i[o][2] = 0, r[o] -= n * r[o + 1];
      }

      var a = [];

      for (o = 0; o < t; o++) {
        a[o] = r[o] / i[o][1];
      }

      return a;
    }
  }]);

  return Ml;
}(ko);

Ml.prototype.availableOptions = {
  rgbControlPoints: {
    type: m.OBJECT
  },
  controlPoints: {
    type: m.ARRAY,
    default: []
  },
  textureGLUnit: {
    type: m.NUMBER,
    default: 1
  }
};
var q = Ml;
var ed = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float gray = texColor.r * 0.3 + texColor.g * 0.3 + texColor.b * 0.3;\n  gray -= 0.2;\n  gray = clamp(gray, 0.0, 1.0);\n  gray += 0.15;\n  gray *= 1.4;\n  gl_FragColor = vec4(vec3(gray) * texColor.a, texColor.a);\n}\n";

var td =
/*#__PURE__*/
function (_k$Filter20) {
  _inherits(td, _k$Filter20);

  function td() {
    var _this90;

    _classCallCheck(this, td);

    _this90 = _possibleConstructorReturn(this, _getPrototypeOf(td).call(this));
    _this90._fragmentSource = ed;
    return _this90;
  }

  _createClass(td, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = n.getImageData(0, 0, o.width, o.height);

      for (var _c19 = 0; _c19 < o.width; _c19++) {
        for (var _u14 = 0; _u14 < o.height; _u14++) {
          var _p14 = (o.width * _u14 + _c19) * 4,
              _h11 = l.data[_p14] / 255 * .3 + l.data[_p14 + 1] / 255 * .3 + l.data[_p14 + 2] / 255 * .3;

          _h11 -= .2, _h11 = Math.max(0, Math.min(1, _h11)), _h11 += .15, _h11 *= 1.4, _h11 *= 255, l.data[_p14] = _h11, l.data[_p14 + 1] = _h11, l.data[_p14 + 2] = _h11;
        }
      }

      a.putImageData(l, 0, 0);
    }
  }]);

  return td;
}(k.Filter),
    id =
/*#__PURE__*/
function (_ne14) {
  _inherits(id, _ne14);

  function id() {
    var _getPrototypeOf23;

    var _this91;

    _classCallCheck(this, id);

    for (var _len32 = arguments.length, e = new Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
      e[_key32] = arguments[_key32];
    }

    _this91 = _possibleConstructorReturn(this, (_getPrototypeOf23 = _getPrototypeOf(id)).call.apply(_getPrototypeOf23, [this].concat(e)));
    _this91._filter = new td();
    return _this91;
  }

  return id;
}(ne),
    So = id;

var rd = "precision highp float;\n\nuniform sampler2D u_image;\n\nuniform sampler2D u_lookupTable;\n\nuniform float u_resolution;     // Texture-Resolution, must be power of 2: 64, 128, 256, 512, 1024, 2048, 4096\nuniform float u_horizontalTileCount; // Horizontal Blue Tiles\nuniform float u_verticalTileCount; // Vertical Blue Tiles\n\nvarying vec2 v_texCoord;\n\nconst float EPSILON = 0.000001;\n\n// Try to get the exact pixel of the lut map image\nvec3 lutColor(int texPosX, int texPosY) {\n    return texture2D(u_lookupTable, (0.5 / u_resolution) + vec2(float(texPosX), float(texPosY)) / u_resolution).rgb;\n}\n\nvec3 bilinearInterpolate(vec3 cRfGf, vec3 cRfGc, vec3 cRcGf, vec3 cRcGc, float redFract, float greenFract) {\n    return mix(mix(cRfGf, cRcGf, redFract), mix(cRfGc, cRcGc, redFract), greenFract);\n}\n\nvoid main() {\n    vec4 inputColor = clamp(texture2D(u_image, v_texCoord.xy), 0.0, 1.0);\n\n    vec3 sourceColor = vec3(inputColor.rgb / max(inputColor.a, EPSILON)); \n\n    vec3 ranges = vec3(\n        floor(u_resolution / u_horizontalTileCount - 1.0),\n        floor(u_resolution / u_verticalTileCount - 1.0),\n        floor(u_horizontalTileCount * u_horizontalTileCount - 1.0)\n    );\n    \n    vec3 tmp = sourceColor * ranges;\n    ivec3 floors = ivec3(tmp);\n    ivec3 ceils = ivec3(ceil(tmp));\n    vec3 fracts = fract(tmp);\n\n    // Map tile index to tile pixel pos.\n    ivec2 pixelsPerTile = ivec2(\n        u_resolution / u_horizontalTileCount, \n        u_resolution / u_verticalTileCount\n      );\n\n    ivec2 tileFloor; // Blue tile index\n    tileFloor.y = floors.z / int(u_horizontalTileCount);\n    tileFloor.x = (floors.z - (tileFloor.y * int(u_horizontalTileCount)));\n\n    ivec2 tileCeil; // Blue tile index\n    tileCeil.y = ceils.z / int(u_horizontalTileCount);\n    tileCeil.x = (ceils.z - (tileCeil.y * int(u_horizontalTileCount)));\n    \n    tileFloor *= pixelsPerTile;\n    tileCeil *= pixelsPerTile; \n    \n    \n    // Interpolate between red and green\n    vec3 lutColorFB = bilinearInterpolate(\n        lutColor(tileFloor.x + floors.x, tileFloor.y + floors.y),\n        lutColor(tileFloor.x + floors.x, tileFloor.y + ceils.y),\n        lutColor(tileFloor.x + ceils.x,  tileFloor.y + floors.y),\n        lutColor(tileFloor.x + ceils.x,  tileFloor.y + ceils.y),\n        fracts.x, fracts.y\n    );\n    vec3 lutColorCB = bilinearInterpolate(\n        lutColor(tileCeil.x + floors.x, tileCeil.y + floors.y),\n        lutColor(tileCeil.x + floors.x, tileCeil.y + ceils.y),\n        lutColor(tileCeil.x + ceils.x,  tileCeil.y + floors.y),\n        lutColor(tileCeil.x + ceils.x,  tileCeil.y + ceils.y),\n        fracts.x, fracts.y\n    );\n\n    // Interpolate between the blue values\n    vec3 interpolation = mix(lutColorFB, lutColorCB, fracts.z);\n\n    // Round Color Values to prevent that for ex. 254.999999 is cutting to 254 instead of 255;\n    interpolation = clamp(floor(interpolation * 255. + .5) / 255., 0.0, 1.0);\n\n    gl_FragColor = vec4(interpolation.rgb * inputColor.a, inputColor.a);\n}\n";

var Ao = I.Vector2,
    sd = I.Vector3,
    od = 3,
    Ll =
/*#__PURE__*/
function (_k$Filter21) {
  _inherits(Ll, _k$Filter21);

  function Ll() {
    var _this92;

    _classCallCheck(this, Ll);

    _this92 = _possibleConstructorReturn(this, _getPrototypeOf(Ll).call(this));
    _this92._precomputeQuads(), _this92._fragmentSource = rd;
    return _this92;
  }

  _createClass(Ll, [{
    key: "_precomputeQuads",
    value: function _precomputeQuads() {
      this._quads = [];

      for (var _e19 = 0; _e19 < 256; _e19++) {
        var _t22 = _e19 / 255 * 63,
            _i11 = new Ao();

        _i11.y = (_t22 | 0) * .125 | 0, _i11.x = (_t22 | 0) - _i11.y * 8, this._quads.push(_i11);
      }
    }
  }, {
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      var _this$_options6 = this._options,
          o = _this$_options6.resolution,
          n = _this$_options6.horizontalTileCount,
          a = _this$_options6.verticalTileCount,
          l = t.getCanvas(),
          c = t.getContext(),
          u = i.getContext(),
          p = this._options.lookupTableImage,
          d = this._createImageCanvas(p).getContext("2d"),
          g = {
        width: 128,
        height: 128
      };

      o ? g = {
        width: o,
        height: o
      } : p.width && p.height && (g = {
        width: p.width,
        height: p.height
      });

      var y = c.getImageData(0, 0, l.width, l.height),
          _ = d.getImageData(0, 0, g.width, g.height),
          f = new sd(g.width / n - 1 | 0, g.height / a - 1 | 0, n * a - 1 | 0),
          v = new R(),
          b = new R(),
          D = new R(),
          O = new R(),
          x = new R(),
          w = new R(),
          z = new R(),
          L = new R(),
          j = new Ao(),
          X = new Ao(),
          K = function K(Q, be, me, ce) {
        Q.r = be.r * (1 - ce) + me.r * ce, Q.g = be.g * (1 - ce) + me.g * ce, Q.b = be.b * (1 - ce) + me.b * ce;
      },
          G = function G(Q, be, me) {
        be = .5 + be | 0, me = .5 + me | 0;
        var ce = (me * g.width + be) * 4;
        Q.r = _.data[ce] / 255, Q.g = _.data[ce + 1] / 255, Q.b = _.data[ce + 2] / 255, Q.a = _.data[ce + 3] / 255;
      },
          ae = new R(),
          Ne = new R(),
          Oe = function Oe(Q, be, me, ce, J, ge, Le) {
        K(ae, be, ce, ge), K(Ne, me, J, ge), K(Q, ae, Ne, Le);
      },
          kt = new Ao(g.width, g.height).divide(n, a).floor();

      for (var Q = 0; Q < l.width * l.height * 4; Q += 4) {
        v.set(y.data[Q] / 255, y.data[Q + 1] / 255, y.data[Q + 2] / 255, y.data[Q + 3] / 255);
        var be = new sd(v.r * f.x, v.g * f.y, v.b * f.z),
            me = be.clone().floor().toInt(),
            ce = be.clone().ceil().toInt(),
            J = be.clone().fract();
        j.y = me.z / n | 0, j.x = me.z - j.y * n | 0, X.y = ce.z / n | 0, X.x = ce.z - X.y * n | 0, j.multiply(kt), X.multiply(kt), G(x, j.x + me.x, j.y + me.y), G(w, j.x + me.x, j.y + ce.y), G(z, j.x + ce.x, j.y + me.y), G(L, j.x + ce.x, j.y + ce.y), Oe(D, x, w, z, L, J.x, J.y), G(x, X.x + me.x, X.y + me.y), G(w, X.x + me.x, X.y + ce.y), G(z, X.x + ce.x, X.y + me.y), G(L, X.x + ce.x, X.y + ce.y), Oe(O, x, w, z, L, J.x, J.y), K(b, D, O, J.z), y.data[Q] = Math.ceil(b.r * 255), y.data[Q + 1] = Math.ceil(b.g * 255), y.data[Q + 2] = Math.ceil(b.b * 255);
      }

      u.putImageData(y, 0, 0);
    }
  }, {
    key: "_createImageCanvas",
    value: function _createImageCanvas(e) {
      var t = T.createCanvas();
      return t.width = e.width, t.height = e.height, t.getContext("2d").drawImage(e, 0, 0), t;
    }
  }]);

  return Ll;
}(k.Filter);

Ll.prototype.availableOptions = {
  lookupTable: {
    type: m.NUMBER,
    default: od,
    uniformType: F.INT
  },
  lookupTableImage: {
    type: m.IMAGE,
    uniformType: null
  },
  resolution: {
    type: m.NUMBER,
    uniformType: F.FLOAT
  },
  horizontalTileCount: {
    type: m.NUMBER,
    default: 5,
    uniformType: F.FLOAT
  },
  verticalTileCount: {
    type: m.NUMBER,
    default: 5,
    uniformType: F.FLOAT
  }
};

var zl =
/*#__PURE__*/
function (_ne15) {
  _inherits(zl, _ne15);

  function zl() {
    var _getPrototypeOf24;

    var _this93;

    _classCallCheck(this, zl);

    for (var _len33 = arguments.length, e = new Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {
      e[_key33] = arguments[_key33];
    }

    _this93 = _possibleConstructorReturn(this, (_getPrototypeOf24 = _getPrototypeOf(zl)).call.apply(_getPrototypeOf24, [this].concat(e)));
    _this93._filter = new Ll(), _this93._textures = {};
    return _this93;
  }

  _createClass(zl, [{
    key: "update",
    value: function update(e) {
      var t = e.getRenderer();
      t.isOfType(U.WEBGL) ? this._updateWebGLTexture(e) : t.isOfType(U.CANVAS) && this._filter.setLookupTableImage(this._options.image);
      var _this$_options7 = this._options,
          i = _this$_options7.resolution,
          r = _this$_options7.verticalTileCount,
          o = _this$_options7.horizontalTileCount,
          n = _this$_options7.image;

      this._filter.set({
        resolution: i || n.width,
        verticalTileCount: r,
        horizontalTileCount: o
      });
    }
  }, {
    key: "_updateWebGLTexture",
    value: function _updateWebGLTexture(e) {
      var t = e.getRenderer(),
          i = t.id;
      this._textures[i] || (this._textures[i] = new k.BaseTexture());
      var r = this._textures[i];
      r.setSource(this._options.image), r.setGLUnit(od), r.setMinFilter(k.BaseTexture.NearestFilter), t.updateTexture(r);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(zl.prototype), "dispose", this).call(this);

      for (var _e20 in this._textures) {
        delete this._textures[_e20];
      }
    }
  }]);

  return zl;
}(ne);

zl.prototype.availableOptions = {
  image: {
    type: m.IMAGE
  },
  resolution: {
    type: m.NUMBER
  },
  horizontalTileCount: {
    type: m.NUMBER,
    default: 5
  },
  verticalTileCount: {
    type: m.NUMBER,
    default: 5
  }
};
var Io = zl;

var Oo =
/*#__PURE__*/
function (_M) {
  _inherits(Oo, _M);

  function Oo() {
    var _getPrototypeOf25;

    var _this94;

    _classCallCheck(this, Oo);

    for (var _len34 = arguments.length, e = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
      e[_key34] = arguments[_key34];
    }

    _this94 = _possibleConstructorReturn(this, (_getPrototypeOf25 = _getPrototypeOf(Oo)).call.apply(_getPrototypeOf25, [this].concat(e)));

    _this94._stack.push(new Bi({
      brightness: 0
    }));

    return _this94;
  }

  _createClass(Oo, [{
    key: "render",
    value: function render(e, t, i) {
      return this._stack.isEmpty() && this._stack.push(new Bi({
        brightness: 0
      })), _get(_getPrototypeOf(Oo.prototype), "render", this).call(this, e, t, i);
    }
  }]);

  return Oo;
}(M);

Oo.isIdentity = !0;
Oo.identifier = "identity";
var Po = Oo;

var Nl =
/*#__PURE__*/
function (_M2) {
  _inherits(Nl, _M2);

  function Nl() {
    var _getPrototypeOf26;

    var _this95;

    _classCallCheck(this, Nl);

    for (var _len35 = arguments.length, e = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
      e[_key35] = arguments[_key35];
    }

    _this95 = _possibleConstructorReturn(this, (_getPrototypeOf26 = _getPrototypeOf(Nl)).call.apply(_getPrototypeOf26, [this].concat(e)));
    _this95._stack.push(new et({
      contrast: .63
    })), _this95._stack.push(new Bi({
      brightness: .12
    })), _this95._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 38], [94, 94], [148, 142], [175, 187], [255, 255]],
        green: [[0, 0], [77, 53], [171, 190], [255, 255]],
        blue: [[0, 10], [48, 85], [174, 228], [255, 255]]
      }
    }));
    return _this95;
  }

  return Nl;
}(M);

Nl.identifier = "a15";
var nd = Nl;

var Gl =
/*#__PURE__*/
function (_M3) {
  _inherits(Gl, _M3);

  function Gl() {
    var _getPrototypeOf27;

    var _this96;

    _classCallCheck(this, Gl);

    for (var _len36 = arguments.length, e = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
      e[_key36] = arguments[_key36];
    }

    _this96 = _possibleConstructorReturn(this, (_getPrototypeOf27 = _getPrototypeOf(Gl)).call.apply(_getPrototypeOf27, [this].concat(e)));
    _this96._stack.push(new At({
      desaturation: .5
    })), _this96._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 0], [170, 170], [212, 219], [234, 242], [255, 255]],
        green: [[0, 0], [170, 168], [234, 231], [255, 255]],
        blue: [[0, 0], [170, 170], [212, 208], [255, 255]]
      }
    }));
    return _this96;
  }

  return Gl;
}(M);

Gl.identifier = "breeze";
var ad = Gl;

var Wl =
/*#__PURE__*/
function (_M4) {
  _inherits(Wl, _M4);

  function Wl() {
    var _getPrototypeOf28;

    var _this97;

    _classCallCheck(this, Wl);

    for (var _len37 = arguments.length, e = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
      e[_key37] = arguments[_key37];
    }

    _this97 = _possibleConstructorReturn(this, (_getPrototypeOf28 = _getPrototypeOf(Wl)).call.apply(_getPrototypeOf28, [this].concat(e)));

    _this97._stack.push(new fr());

    return _this97;
  }

  return Wl;
}(M);

Wl.identifier = "bw";
var ld = Wl;

var Vl =
/*#__PURE__*/
function (_M5) {
  _inherits(Vl, _M5);

  function Vl() {
    var _getPrototypeOf29;

    var _this98;

    _classCallCheck(this, Vl);

    for (var _len38 = arguments.length, e = new Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {
      e[_key38] = arguments[_key38];
    }

    _this98 = _possibleConstructorReturn(this, (_getPrototypeOf29 = _getPrototypeOf(Vl)).call.apply(_getPrototypeOf29, [this].concat(e)));
    _this98._stack.push(new fr()), _this98._stack.push(new et({
      contrast: 1.5
    }));
    return _this98;
  }

  return Vl;
}(M);

Vl.identifier = "bwhard";
var cd = Vl;

var Hl =
/*#__PURE__*/
function (_M6) {
  _inherits(Hl, _M6);

  function Hl() {
    var _getPrototypeOf30;

    var _this99;

    _classCallCheck(this, Hl);

    for (var _len39 = arguments.length, e = new Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {
      e[_key39] = arguments[_key39];
    }

    _this99 = _possibleConstructorReturn(this, (_getPrototypeOf30 = _getPrototypeOf(Hl)).call.apply(_getPrototypeOf30, [this].concat(e)));

    _this99._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 69], [55, 110], [202, 230], [255, 255]],
        green: [[0, 44], [89, 93], [185, 141], [255, 189]],
        blue: [[0, 76], [39, 82], [218, 138], [255, 171]]
      }
    }));

    return _this99;
  }

  return Hl;
}(M);

Hl.identifier = "celsius";
var ud = Hl;

var jl =
/*#__PURE__*/
function (_M7) {
  _inherits(jl, _M7);

  function jl() {
    var _getPrototypeOf31;

    var _this100;

    _classCallCheck(this, jl);

    for (var _len40 = arguments.length, e = new Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {
      e[_key40] = arguments[_key40];
    }

    _this100 = _possibleConstructorReturn(this, (_getPrototypeOf31 = _getPrototypeOf(jl)).call.apply(_getPrototypeOf31, [this].concat(e)));

    _this100._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 0], [44, 44], [124, 143], [221, 204], [255, 255]],
        green: [[0, 0], [130, 127], [213, 199], [255, 255]],
        blue: [[0, 0], [51, 52], [219, 204], [255, 255]]
      }
    }));

    return _this100;
  }

  return jl;
}(M);

jl.identifier = "chest";
var md = jl;

var Bo =
/*#__PURE__*/
function (_M8) {
  _inherits(Bo, _M8);

  function Bo() {
    var _getPrototypeOf32;

    var _this101;

    _classCallCheck(this, Bo);

    for (var _len41 = arguments.length, e = new Array(_len41), _key41 = 0; _key41 < _len41; _key41++) {
      e[_key41] = arguments[_key41];
    }

    _this101 = _possibleConstructorReturn(this, (_getPrototypeOf32 = _getPrototypeOf(Bo)).call.apply(_getPrototypeOf32, [this].concat(e, [{
      intensity: {
        type: m.NUMBER,
        default: .5,
        required: !0,
        setter: function setter(t) {
          return this._filterPrimitive && (this._filterPrimitive.setIntensity(t), this._stack.setIntensity(1)), this._dirty = !0, t;
        }
      }
    }])));
    _this101._filterPrimitive = new xo({
      lightColor: _this101._options.lightColor || R.WHITE,
      darkColor: _this101._options.darkColor || R.BLACK,
      intensity: _this101._options.intensity || .5
    }), _this101._stack.push(_this101._filterPrimitive);
    return _this101;
  }

  return Bo;
}(M);

Bo.prototype.availableOptions = {
  lightColor: {
    type: m.COLOR,
    default: R.WHITE,
    required: !0,
    setter: function setter(s) {
      return this._filterPrimitive && this._filterPrimitive.setLightColor(s), this.setDirty && this.setDirty(!0), s;
    }
  },
  darkColor: {
    type: m.COLOR,
    default: R.BLACK,
    required: !0,
    setter: function setter(s) {
      return this._filterPrimitive && this._filterPrimitive.setDarkColor(s), this.setDirty && this.setDirty(!0), s;
    }
  },
  intensity: {
    type: m.NUMBER,
    default: .5,
    required: !0
  }
};
Bo.identifier = "duotone";
var dd = Bo;

var Yl =
/*#__PURE__*/
function (_M9) {
  _inherits(Yl, _M9);

  function Yl() {
    var _getPrototypeOf33;

    var _this102;

    _classCallCheck(this, Yl);

    for (var _len42 = arguments.length, e = new Array(_len42), _key42 = 0; _key42 < _len42; _key42++) {
      e[_key42] = arguments[_key42];
    }

    _this102 = _possibleConstructorReturn(this, (_getPrototypeOf33 = _getPrototypeOf(Yl)).call.apply(_getPrototypeOf33, [this].concat(e)));

    _this102._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 0], [44, 28], [63, 48], [128, 132], [235, 248], [255, 255]],
        green: [[0, 0], [20, 10], [60, 45], [190, 209], [211, 231], [255, 255]],
        blue: [[0, 31], [41, 62], [150, 142], [234, 212], [255, 224]]
      }
    }));

    return _this102;
  }

  return Yl;
}(M);

Yl.identifier = "fixie";
var hd = Yl;

var ql =
/*#__PURE__*/
function (_M10) {
  _inherits(ql, _M10);

  function ql() {
    var _getPrototypeOf34;

    var _this103;

    _classCallCheck(this, ql);

    for (var _len43 = arguments.length, e = new Array(_len43), _key43 = 0; _key43 < _len43; _key43++) {
      e[_key43] = arguments[_key43];
    }

    _this103 = _possibleConstructorReturn(this, (_getPrototypeOf34 = _getPrototypeOf(ql)).call.apply(_getPrototypeOf34, [this].concat(e)));
    _this103._stack.push(new tt({
      saturation: 1.35
    })), _this103._stack.push(new et({
      contrast: 1.1
    }));
    return _this103;
  }

  return ql;
}(M);

ql.identifier = "food";
var pd = ql;

var Kl =
/*#__PURE__*/
function (_M11) {
  _inherits(Kl, _M11);

  function Kl() {
    var _getPrototypeOf35;

    var _this104;

    _classCallCheck(this, Kl);

    for (var _len44 = arguments.length, e = new Array(_len44), _key44 = 0; _key44 < _len44; _key44++) {
      e[_key44] = arguments[_key44];
    }

    _this104 = _possibleConstructorReturn(this, (_getPrototypeOf35 = _getPrototypeOf(Kl)).call.apply(_getPrototypeOf35, [this].concat(e)));

    _this104._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 9], [21, 11], [45, 24], [255, 220]],
        green: [[0, 12], [21, 21], [42, 42], [150, 150], [170, 173], [255, 210]],
        blue: [[0, 28], [43, 72], [128, 185], [255, 220]]
      }
    }));

    return _this104;
  }

  return Kl;
}(M);

Kl.identifier = "fridge";
var gd = Kl;

var Xl =
/*#__PURE__*/
function (_M12) {
  _inherits(Xl, _M12);

  function Xl() {
    var _getPrototypeOf36;

    var _this105;

    _classCallCheck(this, Xl);

    for (var _len45 = arguments.length, e = new Array(_len45), _key45 = 0; _key45 < _len45; _key45++) {
      e[_key45] = arguments[_key45];
    }

    _this105 = _possibleConstructorReturn(this, (_getPrototypeOf36 = _getPrototypeOf(Xl)).call.apply(_getPrototypeOf36, [this].concat(e)));

    _this105._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 65], [28, 67], [67, 113], [125, 183], [187, 217], [255, 229]],
        green: [[0, 52], [42, 59], [104, 134], [169, 209], [255, 240]],
        blue: [[0, 52], [65, 68], [93, 104], [150, 153], [255, 198]]
      }
    }));

    return _this105;
  }

  return Xl;
}(M);

Xl.identifier = "front";
var fd = Xl;

var Ql =
/*#__PURE__*/
function (_M13) {
  _inherits(Ql, _M13);

  function Ql() {
    var _getPrototypeOf37;

    var _this106;

    _classCallCheck(this, Ql);

    for (var _len46 = arguments.length, e = new Array(_len46), _key46 = 0; _key46 < _len46; _key46++) {
      e[_key46] = arguments[_key46];
    }

    _this106 = _possibleConstructorReturn(this, (_getPrototypeOf37 = _getPrototypeOf(Ql)).call.apply(_getPrototypeOf37, [this].concat(e)));
    _this106._stack.push(new et({
      contrast: 1.1
    })), _this106._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 0], [94, 74], [181, 205], [255, 255]],
        green: [[0, 0], [127, 127], [255, 255]],
        blue: [[0, 0], [102, 73], [227, 213], [255, 255]]
      }
    }));
    return _this106;
  }

  return Ql;
}(M);

Ql.identifier = "glam";
var _d = Ql;

var Zl =
/*#__PURE__*/
function (_M14) {
  _inherits(Zl, _M14);

  function Zl() {
    var _getPrototypeOf38;

    var _this107;

    _classCallCheck(this, Zl);

    for (var _len47 = arguments.length, e = new Array(_len47), _key47 = 0; _key47 < _len47; _key47++) {
      e[_key47] = arguments[_key47];
    }

    _this107 = _possibleConstructorReturn(this, (_getPrototypeOf38 = _getPrototypeOf(Zl)).call.apply(_getPrototypeOf38, [this].concat(e)));

    _this107._stack.push(new Do());

    return _this107;
  }

  return Zl;
}(M);

Zl.identifier = "gobblin";
var yd = Zl;

var $l =
/*#__PURE__*/
function (_M15) {
  _inherits($l, _M15);

  function $l() {
    var _getPrototypeOf39;

    var _this108;

    _classCallCheck(this, $l);

    for (var _len48 = arguments.length, e = new Array(_len48), _key48 = 0; _key48 < _len48; _key48++) {
      e[_key48] = arguments[_key48];
    }

    _this108 = _possibleConstructorReturn(this, (_getPrototypeOf39 = _getPrototypeOf($l)).call.apply(_getPrototypeOf39, [this].concat(e)));
    _this108._stack.push(new q({
      controlPoints: [[0, 0], [53, 32], [91, 80], [176, 205], [255, 255]]
    })), _this108._stack.push(new tt({
      saturation: .9
    }));
    return _this108;
  }

  return $l;
}(M);

$l.identifier = "k1";
var bd = $l;

var Jl =
/*#__PURE__*/
function (_M16) {
  _inherits(Jl, _M16);

  function Jl() {
    var _getPrototypeOf40;

    var _this109;

    _classCallCheck(this, Jl);

    for (var _len49 = arguments.length, e = new Array(_len49), _key49 = 0; _key49 < _len49; _key49++) {
      e[_key49] = arguments[_key49];
    }

    _this109 = _possibleConstructorReturn(this, (_getPrototypeOf40 = _getPrototypeOf(Jl)).call.apply(_getPrototypeOf40, [this].concat(e)));
    _this109._stack.push(new q({
      controlPoints: [[0, 0], [54, 33], [77, 82], [94, 103], [122, 126], [177, 193], [229, 232], [255, 255]]
    })), _this109._stack.push(new Eo({
      color: new R(40 / 255, 40 / 255, 40 / 255)
    }));
    return _this109;
  }

  return Jl;
}(M);

Jl.identifier = "k2";
var xd = Jl;

var ec =
/*#__PURE__*/
function (_M17) {
  _inherits(ec, _M17);

  function ec() {
    var _getPrototypeOf41;

    var _this110;

    _classCallCheck(this, ec);

    for (var _len50 = arguments.length, e = new Array(_len50), _key50 = 0; _key50 < _len50; _key50++) {
      e[_key50] = arguments[_key50];
    }

    _this110 = _possibleConstructorReturn(this, (_getPrototypeOf41 = _getPrototypeOf(ec)).call.apply(_getPrototypeOf41, [this].concat(e)));

    _this110._stack.push(new tt({
      saturation: .5
    }));

    return _this110;
  }

  return ec;
}(M);

ec.identifier = "k6";
var vd = ec;

var tc =
/*#__PURE__*/
function (_M18) {
  _inherits(tc, _M18);

  function tc() {
    var _getPrototypeOf42;

    var _this111;

    _classCallCheck(this, tc);

    for (var _len51 = arguments.length, e = new Array(_len51), _key51 = 0; _key51 < _len51; _key51++) {
      e[_key51] = arguments[_key51];
    }

    _this111 = _possibleConstructorReturn(this, (_getPrototypeOf42 = _getPrototypeOf(tc)).call.apply(_getPrototypeOf42, [this].concat(e)));
    _this111._stack.push(new q({
      controlPoints: [[0, 0], [17, 27], [46, 69], [90, 112], [156, 200], [203, 243], [255, 255]]
    })), _this111._stack.push(new tt({
      saturation: .7
    }));
    return _this111;
  }

  return tc;
}(M);

tc.identifier = "kdynamic";
var Cd = tc;

var ic =
/*#__PURE__*/
function (_M19) {
  _inherits(ic, _M19);

  function ic() {
    var _getPrototypeOf43;

    var _this112;

    _classCallCheck(this, ic);

    for (var _len52 = arguments.length, e = new Array(_len52), _key52 = 0; _key52 < _len52; _key52++) {
      e[_key52] = arguments[_key52];
    }

    _this112 = _possibleConstructorReturn(this, (_getPrototypeOf43 = _getPrototypeOf(ic)).call.apply(_getPrototypeOf43, [this].concat(e)));
    _this112._stack.push(new At({
      desaturation: .4
    })), _this112._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 20], [40, 20], [106, 111], [129, 153], [190, 223], [255, 255]],
        green: [[0, 20], [40, 20], [62, 41], [106, 108], [132, 159], [203, 237], [255, 255]],
        blue: [[0, 40], [40, 40], [73, 60], [133, 160], [191, 297], [203, 237], [237, 239], [255, 255]]
      }
    }));
    return _this112;
  }

  return ic;
}(M);

ic.identifier = "lenin";
var wd = ic;

var rc =
/*#__PURE__*/
function (_M20) {
  _inherits(rc, _M20);

  function rc() {
    var _getPrototypeOf44;

    var _this113;

    _classCallCheck(this, rc);

    for (var _len53 = arguments.length, e = new Array(_len53), _key53 = 0; _key53 < _len53; _key53++) {
      e[_key53] = arguments[_key53];
    }

    _this113 = _possibleConstructorReturn(this, (_getPrototypeOf44 = _getPrototypeOf(rc)).call.apply(_getPrototypeOf44, [this].concat(e)));

    _this113._stack.push(new q({
      controlPoints: [[0, 0], [87, 20], [131, 156], [183, 205], [255, 200]]
    }));

    return _this113;
  }

  return rc;
}(M);

rc.identifier = "lomo";
var Dd = rc;

var sc =
/*#__PURE__*/
function (_M21) {
  _inherits(sc, _M21);

  function sc() {
    var _getPrototypeOf45;

    var _this114;

    _classCallCheck(this, sc);

    for (var _len54 = arguments.length, e = new Array(_len54), _key54 = 0; _key54 < _len54; _key54++) {
      e[_key54] = arguments[_key54];
    }

    _this114 = _possibleConstructorReturn(this, (_getPrototypeOf45 = _getPrototypeOf(sc)).call.apply(_getPrototypeOf45, [this].concat(e)));

    _this114._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 0], [41, 84], [87, 134], [255, 255]],
        green: [[0, 0], [255, 216]],
        blue: [[0, 0], [255, 131]]
      }
    }));

    return _this114;
  }

  return sc;
}(M);

sc.identifier = "mellow";
var kd = sc;

var g_ = I.ColorMatrix,
    oc =
/*#__PURE__*/
function (_M22) {
  _inherits(oc, _M22);

  function oc() {
    var _getPrototypeOf46;

    var _this115;

    _classCallCheck(this, oc);

    for (var _len55 = arguments.length, e = new Array(_len55), _key55 = 0; _key55 < _len55; _key55++) {
      e[_key55] = arguments[_key55];
    }

    _this115 = _possibleConstructorReturn(this, (_getPrototypeOf46 = _getPrototypeOf(oc)).call.apply(_getPrototypeOf46, [this].concat(e)));
    var t = new g_(.8158218291630716, 0, 0, 0, -.01779810181190647, 0, .8098360655737704, 0, 0, .0916393442622953, 0, 0, .4596336773932402, 0, .12760574782432707, 0, 0, 0, 1, 0);

    _this115._stack.push(new _o({
      colorMatrix: t
    }));

    var i = new R(.8, .6, .9);

    _this115._stack.push(new Co({
      gamma: i
    }));

    return _this115;
  }

  return oc;
}(M);

oc.identifier = "metal";
var Td = oc;

var nc =
/*#__PURE__*/
function (_M23) {
  _inherits(nc, _M23);

  function nc() {
    var _getPrototypeOf47;

    var _this116;

    _classCallCheck(this, nc);

    for (var _len56 = arguments.length, e = new Array(_len56), _key56 = 0; _key56 < _len56; _key56++) {
      e[_key56] = arguments[_key56];
    }

    _this116 = _possibleConstructorReturn(this, (_getPrototypeOf47 = _getPrototypeOf(nc)).call.apply(_getPrototypeOf47, [this].concat(e)));
    _this116._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 40], [255, 230]],
        green: [[0, 10], [255, 225]],
        blue: [[0, 20], [255, 181]]
      }
    })), _this116._stack.push(new gr());
    return _this116;
  }

  return nc;
}(M);

nc.identifier = "morning";
var Rd = nc;

var ac =
/*#__PURE__*/
function (_M24) {
  _inherits(ac, _M24);

  function ac() {
    var _getPrototypeOf48;

    var _this117;

    _classCallCheck(this, ac);

    for (var _len57 = arguments.length, e = new Array(_len57), _key57 = 0; _key57 < _len57; _key57++) {
      e[_key57] = arguments[_key57];
    }

    _this117 = _possibleConstructorReturn(this, (_getPrototypeOf48 = _getPrototypeOf(ac)).call.apply(_getPrototypeOf48, [this].concat(e)));
    _this117._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 0], [115, 130], [195, 215], [255, 255]],
        green: [[0, 0], [148, 153], [172, 215], [255, 255]],
        blue: [[0, 46], [58, 75], [178, 205], [255, 255]]
      },
      textureGLUnit: 2
    })), _this117._stack.push(new q({
      controlPoints: [[0, 0], [117, 151], [189, 217], [255, 255]],
      textureGLUnit: 3
    })), _this117._stack.push(new At({
      desaturation: .65
    }));
    return _this117;
  }

  return ac;
}(M);

ac.identifier = "orchid";
var Fd = ac;

var lc =
/*#__PURE__*/
function (_M25) {
  _inherits(lc, _M25);

  function lc() {
    var _getPrototypeOf49;

    var _this118;

    _classCallCheck(this, lc);

    for (var _len58 = arguments.length, e = new Array(_len58), _key58 = 0; _key58 < _len58; _key58++) {
      e[_key58] = arguments[_key58];
    }

    _this118 = _possibleConstructorReturn(this, (_getPrototypeOf49 = _getPrototypeOf(lc)).call.apply(_getPrototypeOf49, [this].concat(e)));
    _this118._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 0], [94, 74], [181, 205], [255, 255]],
        green: [[0, 0], [34, 34], [99, 76], [176, 190], [255, 255]],
        blue: [[0, 0], [102, 73], [227, 213], [255, 255]]
      }
    })), _this118._stack.push(new tt({
      saturation: .8
    })), _this118._stack.push(new et({
      contrast: 1.5
    }));
    return _this118;
  }

  return lc;
}(M);

lc.identifier = "pola";
var Ed = lc;

var cc =
/*#__PURE__*/
function (_M26) {
  _inherits(cc, _M26);

  function cc() {
    var _getPrototypeOf50;

    var _this119;

    _classCallCheck(this, cc);

    for (var _len59 = arguments.length, e = new Array(_len59), _key59 = 0; _key59 < _len59; _key59++) {
      e[_key59] = arguments[_key59];
    }

    _this119 = _possibleConstructorReturn(this, (_getPrototypeOf50 = _getPrototypeOf(cc)).call.apply(_getPrototypeOf50, [this].concat(e)));
    _this119._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 0], [56, 18], [196, 209], [255, 255]],
        green: [[0, 38], [71, 84], [255, 255]],
        blue: [[0, 0], [131, 133], [204, 211], [255, 255]]
      }
    })), _this119._stack.push(new tt({
      saturation: .8
    })), _this119._stack.push(new et({
      contrast: 1.5
    }));
    return _this119;
  }

  return cc;
}(M);

cc.identifier = "pola669";
var Sd = cc;

var uc =
/*#__PURE__*/
function (_M27) {
  _inherits(uc, _M27);

  function uc() {
    var _getPrototypeOf51;

    var _this120;

    _classCallCheck(this, uc);

    for (var _len60 = arguments.length, e = new Array(_len60), _key60 = 0; _key60 < _len60; _key60++) {
      e[_key60] = arguments[_key60];
    }

    _this120 = _possibleConstructorReturn(this, (_getPrototypeOf51 = _getPrototypeOf(uc)).call.apply(_getPrototypeOf51, [this].concat(e)));
    _this120._stack.push(new At({
      desaturation: .65
    })), _this120._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 50], [40, 78], [118, 170], [181, 211], [255, 255]],
        green: [[0, 27], [28, 45], [109, 157], [157, 195], [179, 208], [206, 212], [255, 240]],
        blue: [[0, 50], [12, 55], [46, 103], [103, 162], [194, 182], [241, 201], [255, 219]]
      }
    }));
    return _this120;
  }

  return uc;
}(M);

uc.identifier = "quozi";
var Ad = uc;

var mc =
/*#__PURE__*/
function (_M28) {
  _inherits(mc, _M28);

  function mc() {
    var _getPrototypeOf52;

    var _this121;

    _classCallCheck(this, mc);

    for (var _len61 = arguments.length, e = new Array(_len61), _key61 = 0; _key61 < _len61; _key61++) {
      e[_key61] = arguments[_key61];
    }

    _this121 = _possibleConstructorReturn(this, (_getPrototypeOf52 = _getPrototypeOf(mc)).call.apply(_getPrototypeOf52, [this].concat(e)));
    _this121._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 129], [75, 153], [181, 227], [255, 255]],
        green: [[0, 8], [111, 85], [212, 158], [255, 226]],
        blue: [[0, 5], [75, 22], [193, 90], [255, 229]]
      }
    })), _this121._stack.push(new gr());
    return _this121;
  }

  return mc;
}(M);

mc.identifier = "semired";
var Id = mc;

var dc =
/*#__PURE__*/
function (_M29) {
  _inherits(dc, _M29);

  function dc() {
    var _getPrototypeOf53;

    var _this122;

    _classCallCheck(this, dc);

    for (var _len62 = arguments.length, e = new Array(_len62), _key62 = 0; _key62 < _len62; _key62++) {
      e[_key62] = arguments[_key62];
    }

    _this122 = _possibleConstructorReturn(this, (_getPrototypeOf53 = _getPrototypeOf(dc)).call.apply(_getPrototypeOf53, [this].concat(e)));
    _this122._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 0], [62, 82], [141, 154], [255, 255]],
        green: [[0, 39], [56, 96], [192, 176], [255, 255]],
        blue: [[0, 0], [174, 99], [255, 235]]
      },
      textureGLUnit: 2
    })), _this122._stack.push(new q({
      controlPoints: [[0, 0], [55, 20], [158, 191], [255, 255]],
      textureGLUnit: 3
    }));
    return _this122;
  }

  return dc;
}(M);

dc.identifier = "sunny";
var Od = dc;

var hc =
/*#__PURE__*/
function (_M30) {
  _inherits(hc, _M30);

  function hc() {
    var _getPrototypeOf54;

    var _this123;

    _classCallCheck(this, hc);

    for (var _len63 = arguments.length, e = new Array(_len63), _key63 = 0; _key63 < _len63; _key63++) {
      e[_key63] = arguments[_key63];
    }

    _this123 = _possibleConstructorReturn(this, (_getPrototypeOf54 = _getPrototypeOf(hc)).call.apply(_getPrototypeOf54, [this].concat(e)));

    _this123._stack.push(new q({
      rgbControlPoints: {
        red: [[0, 72], [89, 99], [176, 212], [255, 237]],
        green: [[0, 49], [255, 192]],
        blue: [[0, 72], [255, 151]]
      }
    }));

    return _this123;
  }

  return hc;
}(M);

hc.identifier = "texas";
var Pd = hc;

var pc =
/*#__PURE__*/
function (_M31) {
  _inherits(pc, _M31);

  function pc() {
    var _getPrototypeOf55;

    var _this124;

    _classCallCheck(this, pc);

    for (var _len64 = arguments.length, e = new Array(_len64), _key64 = 0; _key64 < _len64; _key64++) {
      e[_key64] = arguments[_key64];
    }

    _this124 = _possibleConstructorReturn(this, (_getPrototypeOf55 = _getPrototypeOf(pc)).call.apply(_getPrototypeOf55, [this].concat(e)));

    _this124._stack.push(new So());

    return _this124;
  }

  return pc;
}(M);

pc.identifier = "x400";
var Bd = pc;

var Mo =
/*#__PURE__*/
function (_M32) {
  _inherits(Mo, _M32);

  function Mo() {
    var _getPrototypeOf56;

    var _this125;

    _classCallCheck(this, Mo);

    for (var _len65 = arguments.length, e = new Array(_len65), _key65 = 0; _key65 < _len65; _key65++) {
      e[_key65] = arguments[_key65];
    }

    _this125 = _possibleConstructorReturn(this, (_getPrototypeOf56 = _getPrototypeOf(Mo)).call.apply(_getPrototypeOf56, [this].concat(e)));
    _this125._lutPrimitive = new To({
      image: _this125._options.image
    }), _this125._stack.push(_this125._lutPrimitive);
    return _this125;
  }

  return Mo;
}(M);

Mo.prototype.availableOptions = {
  image: {
    type: m.IMAGE,
    required: !0,
    setter: function setter(s) {
      return this._lutPrimitive && this._lutPrimitive.setImage(s), this.setDirty(!0), s;
    }
  }
};
Mo.identifier = "lut";
var Md = Mo;

var Lo =
/*#__PURE__*/
function (_M33) {
  _inherits(Lo, _M33);

  function Lo() {
    var _getPrototypeOf57;

    var _this126;

    _classCallCheck(this, Lo);

    for (var _len66 = arguments.length, e = new Array(_len66), _key66 = 0; _key66 < _len66; _key66++) {
      e[_key66] = arguments[_key66];
    }

    _this126 = _possibleConstructorReturn(this, (_getPrototypeOf57 = _getPrototypeOf(Lo)).call.apply(_getPrototypeOf57, [this].concat(e)));
    var _this126$_options = _this126._options,
        t = _this126$_options.image,
        i = _this126$_options.resolution,
        r = _this126$_options.verticalTileCount,
        o = _this126$_options.horizontalTileCount;
    _this126._lutPrimitive = new Io({
      image: t,
      resolution: i,
      verticalTileCount: r,
      horizontalTileCount: o
    }), _this126._stack.push(_this126._lutPrimitive);
    return _this126;
  }

  return Lo;
}(M);

Lo.prototype.availableOptions = {
  image: {
    type: m.IMAGE,
    required: !0,
    setter: function setter(s) {
      return this._lutPrimitive && this._lutPrimitive.setImage(s), this.setDirty(!0), s;
    }
  },
  resolution: {
    type: m.NUMBER
  },
  horizontalTileCount: {
    type: m.NUMBER,
    default: 5
  },
  verticalTileCount: {
    type: m.NUMBER,
    default: 5
  }
};
Lo.identifier = "3d-lut";
var Ld = Lo;

var mi =
/*#__PURE__*/
function (_ee4) {
  _inherits(mi, _ee4);

  function mi() {
    _classCallCheck(this, mi);

    return _possibleConstructorReturn(this, _getPrototypeOf(mi).apply(this, arguments));
  }

  _createClass(mi, [{
    key: "_render",
    value: function _render(e) {
      return this._selectedFilter.render(this._sdk, e, this._renderTexture);
    }
  }, {
    key: "render",
    value: function render(e) {
      return this._selectedFilter.getDirty() && this.setDirty(!0), this.getEnabled() ? _get(_getPrototypeOf(mi.prototype), "render", this).call(this, e) : (this.setDirtyForRenderer(!1, this._sdk.getRenderer()), Promise.resolve(e));
    }
  }, {
    key: "setDirtyForRenderer",
    value: function setDirtyForRenderer(e, t) {
      _get(_getPrototypeOf(mi.prototype), "setDirtyForRenderer", this).call(this, e, t), this._selectedFilter.setDirtyForRenderer(e, t);
    }
  }, {
    key: "disposeRenderTextures",
    value: function disposeRenderTextures() {
      _get(_getPrototypeOf(mi.prototype), "disposeRenderTextures", this).call(this), this._selectedFilter && this._selectedFilter.disposeRenderTextures();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(mi.prototype), "dispose", this).call(this), this._selectedFilter && this._selectedFilter.dispose();
    }
  }, {
    key: "restoreSnapshot",
    value: function restoreSnapshot(e) {
      var t = C({}, e);

      if (delete t.filter, e.filter) {
        var _i12 = e.filter.constructor;
        _i12.identifier === "3d-lut" ? this.setFilter(new _i12({
          image: e.filter.getImage(),
          resolution: e.filter.getResolution(),
          horizontalTileCount: e.filter.getHorizontalTileCount(),
          verticalTileCount: e.filter.getVerticalTileCount()
        })) : _i12.identifier === "duotone" ? this.setFilter(new _i12({
          lightColor: e.filter.getLightColor(),
          darkColor: e.filter.getDarkColor(),
          intensity: e.filter.getIntensity()
        })) : this.setFilter(new _i12());
      }

      this.set(t);
    }
  }, {
    key: "resetToDefaultFilterIntensity",
    value: function resetToDefaultFilterIntensity() {
      var e = this._selectedFilter && this._selectedFilter.availableOptions,
          t = e && e.intensity.default;
      this.setIntensity(t || 1);
    }
  }]);

  return mi;
}(ee);

mi.identifier = "filter";
mi.prototype.availableOptions = {
  identifier: {
    type: m.STRING,
    default: "identity"
  },
  intensity: {
    type: m.NUMBER,
    default: 1,
    setter: function setter(s) {
      return this._selectedFilter && this._selectedFilter.setIntensity(s), s;
    }
  },
  filter: {
    type: m.OBJECT,
    default: new Po(),
    setter: function setter(s) {
      return this._selectedFilter && (this._selectedFilter.dispose(), this._selectedFilter = null), this._selectedFilter = s, typeof this._options.intensity != "undefined" && this._selectedFilter.set({
        intensity: this._options.intensity
      }), s;
    }
  }
};
mi.FilterPrimitives = Ul;
mi.Filters = gc;
mi.Filter = M;
N.Operations.FilterOperation = mi;
var zd = mi;

var Ds =
/*#__PURE__*/
function (_ee5) {
  _inherits(Ds, _ee5);

  function Ds() {
    var _getPrototypeOf58;

    var _this127;

    _classCallCheck(this, Ds);

    for (var _len67 = arguments.length, e = new Array(_len67), _key67 = 0; _key67 < _len67; _key67++) {
      e[_key67] = arguments[_key67];
    }

    _this127 = _possibleConstructorReturn(this, (_getPrototypeOf58 = _getPrototypeOf(Ds)).call.apply(_getPrototypeOf58, [this].concat(e)));
    _this127._flipContainer = new k.Container();
    return _this127;
  }

  _createClass(Ds, [{
    key: "_render",
    value: function _render(e) {
      var _this$_options8 = this._options,
          t = _this$_options8.outputResolution,
          i = _this$_options8.flipHorizontally,
          r = _this$_options8.flipVertically;

      if (i || r) {
        var _o15 = e.getDimensions();

        this._flipRenderTexture ? this._flipRenderTexture.resizeTo(_o15) : (this._flipRenderTexture = new k.RenderTexture(this._sdk.getRenderer(), _o15.x, _o15.y), this._flipSprite = new k.Sprite(this._flipRenderTexture), this._flipContainer.addChild(this._flipSprite));

        var _n9 = i ? -1 : 1,
            _a7 = r ? -1 : 1;

        this._flipSprite.setScale(_n9, _a7), this._flipSprite.setPivot(0, 0), this._flipSprite.setPosition(_o15.x * (1 - _n9) * .5, _o15.y * (1 - _a7) * .5), this._flipRenderTexture.clear(), this._flipRenderTexture.render(this._container), this._renderTexture.render(this._flipContainer);
      } else this._renderTexture.render(this._container);

      return Promise.resolve();
    }
  }]);

  return Ds;
}(ee);

Ds.identifier = "flip";
Ds.prototype.availableOptions = {
  flipHorizontally: {
    type: m.BOOLEAN,
    default: !1
  },
  flipVertically: {
    type: m.BOOLEAN,
    default: !1
  }
};
N.Operations.FlipOperation = Ds;
var Ud = Ds;

var _r = I.Vector2,
    yr =
/*#__PURE__*/
function (_ee6) {
  _inherits(yr, _ee6);

  function yr() {
    var _getPrototypeOf59;

    var _this128;

    _classCallCheck(this, yr);

    for (var _len68 = arguments.length, e = new Array(_len68), _key68 = 0; _key68 < _len68; _key68++) {
      e[_key68] = arguments[_key68];
    }

    _this128 = _possibleConstructorReturn(this, (_getPrototypeOf59 = _getPrototypeOf(yr)).call.apply(_getPrototypeOf59, [this].concat(e)));
    _this128._colorOverlayFilter = new k.Filters.ColorOverlayFilter({
      color: _this128.getTintColor()
    }), _this128._frameContainer = new k.Container(), _this128._resetSprites(), _this128._options.frame && _this128._createSpritesForFrame(_this128._options.frame);
    return _this128;
  }

  _createClass(yr, [{
    key: "_resetSprites",
    value: function _resetSprites() {
      this._spriteGroups = {
        top: {},
        left: {},
        right: {},
        bottom: {}
      }, this._sprites = [], this._repeatSprites = {
        top: [],
        left: [],
        right: [],
        bottom: []
      };
    }
  }, {
    key: "_createSpritesForFrame",
    value: function _createSpritesForFrame(e) {
      var _this129 = this;

      if (!e) return this._disposeSprites();
      var t = e.imageGroups,
          i = e.layoutMode;
      this._layoutMode = i || "horizontal-inside", this._disposeSprites(), ["top", "left", "right", "bottom"].forEach(function (r) {
        typeof t[r] != "undefined" && ["start", "mid", "end"].forEach(function (o) {
          if (typeof t[r][o] == "undefined") return;
          var n = t[r][o];
          "image" in n && (n = n.image);
          var a = k.Texture.fromImage(n),
              l = new k.Sprite(a);
          _this129._spriteGroups[r][o] = l, _this129._sprites.push(l), _this129._frameContainer.addChild(l);
        });
      });
    }
  }, {
    key: "_render",
    value: function _render(e) {
      var t = this._renderTexture.getDimensions();

      return this._options.frame && (this._colorOverlayFilter.setColor(this.getTintColor()), this._updateSprites(e)), this._frameRenderTexture ? this._frameRenderTexture.resizeTo(t) : (this._frameRenderTexture = new k.RenderTexture(this._sdk.getRenderer(), t.x, t.y), this._frameSprite = new k.Sprite(this._frameRenderTexture), this._container.addChild(this._frameSprite)), this._frameSprite.setAlpha(this._options.alpha), this._options.frame && this._options.frame.tintable ? this._frameSprite.setFilters([this._colorOverlayFilter]) : this._frameSprite.setFilters([]), this._frameRenderTexture.clear(), this._frameRenderTexture.render(this._frameContainer), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "_updateSprites",
    value: function _updateSprites(e) {
      var t = e.getDimensions();
      this._frameWidth = Math.ceil(e.getDimensions().min() * this._options.scale), this._updateHorizontalSpriteGroup(e, "top", 0), this._updateHorizontalSpriteGroup(e, "bottom", t.y - this._frameWidth), this._updateVerticalSpriteGroup(e, "left", 0), this._updateVerticalSpriteGroup(e, "right", t.x - this._frameWidth);
    }
  }, {
    key: "_updateHorizontalSpriteGroup",
    value: function _updateHorizontalSpriteGroup(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var r = e.getDimensions(),
          o = this._layoutMode === "vertical-inside",
          n = this._spriteGroups[t].start,
          a = this._spriteGroups[t].mid,
          l = this._spriteGroups[t].end,
          c = 0,
          u = 0,
          p,
          h;

      if (n) {
        p = n.getTexture().getDimensions(), h = p.y / p.x, c = Math.floor(this._frameWidth / h);

        var _d18 = new _r(0, i);

        _d18.x = o ? this._frameWidth : 0, n.setPosition(_d18), n.setHeight(this._frameWidth), n.setWidth(c);
      }

      if (l) {
        p = l.getTexture().getDimensions(), h = p.y / p.x, u = Math.floor(this._frameWidth * h);

        var _d19 = new _r(r.x - u, i);

        _d19.x -= o ? this._frameWidth : 0, l.setPosition(_d19), l.setHeight(this._frameWidth), l.setWidth(u);
      }

      if (a) {
        p = a.getTexture().getDimensions(), h = p.y / p.x;

        var _d20 = new _r(c, i),
            _g12 = r.x - c - u;

        if (o && (_d20.x += this._frameWidth, _g12 -= this._frameWidth * 2), a.setPosition(_d20), a.setWidth(_g12), a.setHeight(this._frameWidth), this._options.frame.imageGroups[t].mid.mode === "repeat") {
          var _y12 = this._frameWidth / h,
              _13 = Math.ceil(_g12 / _y12),
              _f8 = 0;

          if (_13 !== -1) {
            var _v7 = Math.round(_g12 / _13);

            a.setWidth(_v7), _f8 += _v7, this._ensureRepeatSpritesExist(_13 - 1, t, a);

            for (var _b6 = 0; _b6 < _13 - 1; _b6++) {
              _v7 = Math.round((_g12 - _f8) / (_13 - _b6 - 1));

              var _D = this._repeatSprites[t][_b6],
                  _O = _d20.clone().add(_f8, 0).floor();

              _D.setPosition(_O), _D.setWidth(_v7), _D.setHeight(this._frameWidth), _f8 += _v7;
            }
          }
        }
      }
    }
  }, {
    key: "_ensureRepeatSpritesExist",
    value: function _ensureRepeatSpritesExist(e, t, i) {
      var _this130 = this;

      i.getTexture().setMaxListeners(e + 1);
      var r = this._repeatSprites[t].length;

      if (e > r) {
        var _o16 = e - r;

        for (var _n10 = 0; _n10 < _o16; _n10++) {
          var _a8 = new k.Sprite(i.getTexture());

          this._repeatSprites[t].push(_a8), this._frameContainer.addChild(_a8), this._sprites.push(_a8);
        }
      } else e < r && this._repeatSprites[t].splice(e).forEach(function (n) {
        var a = _this130._sprites.indexOf(n);

        a !== -1 && (_this130._sprites.splice(a, 1), _this130._frameContainer.removeChild(n), n.dispose());
      });
    }
  }, {
    key: "_updateVerticalSpriteGroup",
    value: function _updateVerticalSpriteGroup(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var r = e.getDimensions(),
          o = this._layoutMode === "horizontal-inside",
          n = this._spriteGroups[t].start,
          a = this._spriteGroups[t].mid,
          l = this._spriteGroups[t].end,
          c = 0,
          u = 0,
          p,
          h;

      if (n) {
        p = n.getTexture().getDimensions(), h = p.y / p.x, c = Math.floor(this._frameWidth * h);

        var _d21 = new _r(i, 0);

        _d21.y = o ? this._frameWidth : 0, n.setPosition(_d21), n.setWidth(this._frameWidth), n.setHeight(c);
      }

      if (l) {
        p = l.getTexture().getDimensions(), h = p.y / p.x, u = Math.floor(this._frameWidth * h);

        var _d22 = new _r(i, r.y - u);

        _d22.y -= o ? this._frameWidth : 0, l.setPosition(_d22), l.setWidth(this._frameWidth), l.setHeight(u);
      }

      if (a) {
        p = a.getTexture().getDimensions(), h = p.y / p.x;

        var _d23 = new _r(i, c),
            _g13 = r.y - c - u;

        if (o && (_d23.y += this._frameWidth, _g13 -= this._frameWidth * 2), a.setPosition(_d23), a.setHeight(_g13), a.setWidth(this._frameWidth), this._options.frame.imageGroups[t].mid.mode === "repeat") {
          var _y13 = this._frameWidth * h,
              _14 = Math.ceil(_g13 / _y13),
              _f9 = 0;

          if (_14 !== -1) {
            var _v8 = Math.round(_g13 / _14);

            a.setHeight(_v8), _f9 += _v8, this._ensureRepeatSpritesExist(_14 - 1, t, a);

            for (var _b7 = 0; _b7 < _14 - 1; _b7++) {
              _v8 = Math.round((_g13 - _f9) / (_14 - _b7 - 1));

              var _D2 = this._repeatSprites[t][_b7],
                  _O2 = _d23.clone().add(0, _f9).floor();

              _D2.setPosition(_O2), _D2.setHeight(_v8), _D2.setWidth(this._frameWidth), _f9 += _v8;
            }
          }
        }
      }
    }
  }, {
    key: "_disposeSprites",
    value: function _disposeSprites() {
      var _this131 = this;

      this._sprites.forEach(function (e) {
        _this131._frameContainer.removeChild(e), e.getTexture().dispose(), e.dispose();
      }), this._resetSprites();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(yr.prototype), "dispose", this).call(this), this._disposeSprites(), this._colorOverlayFilter && this._colorOverlayFilter.dispose(), this._frameRenderTexture && this._frameRenderTexture.dispose();
    }
  }], [{
    key: "validateFrame",
    value: function validateFrame(e) {
      if (!e) return;
      var t = e.imageGroups,
          i = e.layoutMode;
      if (typeof e.identifier != "string") throw new Error("Frame needs a property `identifier` of type String.");
      if (typeof e.imageGroups != "object") throw new Error("Frame needs a property `imageGroups` of type Object.");

      var r = function r(o) {
        var _t$o = t[o],
            n = _t$o.start,
            a = _t$o.end,
            l = _t$o.mid;

        if (typeof t[o] != "undefined") {
          if (typeof t[o] != "object") throw new Error("Frame: `imageGroups.".concat(o, "` needs to be of type Object."));
          if (typeof n != "undefined" && !(n instanceof $e || typeof HTMLImageElement != "undefined" && n instanceof HTMLImageElement)) throw new Error("Frame: `imageGroups.".concat(o, ".start` needs to be of type Image."));
          if (typeof l != "undefined" && !(n instanceof $e || typeof HTMLImageElement != "undefined" && n instanceof HTMLImageElement) && typeof l != "object") throw new Error("Frame: `imageGroups.".concat(o, ".mid` needs to be of type Image or Object."));
          if (typeof a != "undefined" && !(a instanceof $e || typeof HTMLImageElement != "undefined" && a instanceof HTMLImageElement)) throw new Error("Frame: `imageGroups.".concat(o, ".end` needs to be of type Image."));
        }
      };

      if (typeof i != "undefined" && ["vertical-inside", "horizontal-inside"].indexOf(i) === -1) throw new Error("Frame: `layoutMode` must be one of vertical-inside, horizontal-inside");
      if (typeof tintable != "undefined" && typeof tintable != "boolean") throw new Error("Frame: `tintable` needs to be of type Boolean.");
      r("top"), r("left"), r("right"), r("bottom");
    }
  }]);

  return yr;
}(ee);

yr.identifier = "frame";
yr.prototype.availableOptions = {
  frame: {
    type: m.OBJECT,
    validation: yr.validateFrame,
    setter: function setter(s, e) {
      return e || this._createSpritesForFrame(s), s;
    },
    default: null
  },
  alpha: {
    type: m.NUMBER,
    default: 1
  },
  tintColor: {
    type: m.COLOR,
    default: new R(1, 1, 1, 0)
  },
  scale: {
    type: m.NUMBER,
    default: .1
  }
};
N.Operations.FrameOperation = yr;
var Nd = yr;
var f_ = "data:image/png;base64,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",
    Gd = f_;
var Wd = "uniform sampler2D u_image;\nuniform sampler2D u_watermarkTex;\n\nvarying vec2 v_texCoord;\n\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  vec4 watermarkColor = texture2D(u_watermarkTex, v_texCoord);\n\n  if (watermarkColor.r > 0.8) {\n    gl_FragColor = mix(color, watermarkColor, 0.3);\n  } else {\n    gl_FragColor = color;\n  }\n}\n";

var fc =
/*#__PURE__*/
function (_k$Filter22) {
  _inherits(fc, _k$Filter22);

  function fc() {
    var _getPrototypeOf60;

    var _this132;

    _classCallCheck(this, fc);

    for (var _len69 = arguments.length, e = new Array(_len69), _key69 = 0; _key69 < _len69; _key69++) {
      e[_key69] = arguments[_key69];
    }

    _this132 = _possibleConstructorReturn(this, (_getPrototypeOf60 = _getPrototypeOf(fc)).call.apply(_getPrototypeOf60, [this].concat(e)));
    _this132._fragmentSource = Wd;
    return _this132;
  }

  _createClass(fc, [{
    key: "_applyWebGL",
    value: function _applyWebGL(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = e.getContext(),
          n = o.canvas,
          a = this.getShaderForRenderer(e),
          l = t.getFrame(),
          c = this._watermarkCanvas;
      (!c || l.width !== c.width || l.height !== c.height) && this._createWatermarkCanvas(l.width, l.height);
      var u = k.Texture.fromCanvas(this._watermarkCanvas),
          p = u.getBaseTexture();
      e.updateTexture(p), p.setGLUnit(1), e.setRenderTarget(i), r && i.clear(), e.setShader(a);
      var h = e.getCurrentRenderTarget().getProjectionMatrix().toArray();
      a.setUniform("u_projMatrix", h), a.syncUniforms(), o.uniform1i(o.getUniformLocation(a.getProgram(), "u_watermarkTex"), 1), o.activeTexture(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, t.getTexture()), o.activeTexture(o.TEXTURE1), o.bindTexture(o.TEXTURE_2D, p.getGLTextureForRenderer(e)), o.drawElements(o.TRIANGLES, 6, o.UNSIGNED_SHORT, 0), u.dispose();
    }
  }, {
    key: "_createWatermarkCanvas",
    value: function _createWatermarkCanvas(e, t) {
      var i = this._options.watermarkImage,
          r = T.createCanvas();
      r.width = e, r.height = t;
      var o = r.getContext("2d"),
          n,
          a,
          l,
          c,
          u;
      e > t ? (n = e / i.width, l = (t - i.height * n) / 2, a = 0) : (n = t / i.height, l = 0, a = (e - i.width * n) / 2), o.drawImage(i, 0, 0, i.width, i.height, a, l, i.width * n, i.height * n), this._watermarkCanvas = r, this._watermarkContext = o;
    }
  }, {
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          l = this._options.watermarkImage;

      this._createWatermarkCanvas(o.width, o.height);

      var c = n.getImageData(0, 0, o.width, o.height),
          u = this._watermarkContext.getImageData(0, 0, o.width, o.height),
          p = new R(),
          h = new R(),
          d = new R();

      for (var _g14 = 0; _g14 < o.width * o.height * 4; _g14 += 4) {
        p.set(c.data[_g14] / 255, c.data[_g14 + 1] / 255, c.data[_g14 + 2] / 255, c.data[_g14 + 3] / 255), h.set(u.data[_g14] / 255, u.data[_g14 + 1] / 255, u.data[_g14 + 2] / 255, u.data[_g14 + 3] / 255), h.r > .8 ? d.copy(p.clone().mix(h, .3)) : d.copy(p), c.data[_g14] = d.r * 255, c.data[_g14 + 1] = d.g * 255, c.data[_g14 + 2] = d.b * 255, c.data[_g14 + 3] = d.a * 255;
      }

      a.putImageData(c, 0, 0);
    }
  }]);

  return fc;
}(k.Filter);

fc.prototype.availableOptions = {
  watermarkImage: {
    type: m.OBJECT,
    required: !0
  }
};
var Vd = fc;

var ks =
/*#__PURE__*/
function (_ee7) {
  _inherits(ks, _ee7);

  function ks() {
    var _getPrototypeOf61;

    var _this133;

    _classCallCheck(this, ks);

    for (var _len70 = arguments.length, e = new Array(_len70), _key70 = 0; _key70 < _len70; _key70++) {
      e[_key70] = arguments[_key70];
    }

    _this133 = _possibleConstructorReturn(this, (_getPrototypeOf61 = _getPrototypeOf(ks)).call.apply(_getPrototypeOf61, [this].concat(e)));
    S(_assertThisInitialized(_assertThisInitialized(_this133)), "_applyWatermarkFilter", function () {
      return _this133._watermarkFilter || (_this133._watermarkFilter = new Vd({
        watermarkImage: _this133._watermarkImage
      })), _this133._sprite.setFilters([_this133._watermarkFilter]), _this133._renderTexture.render(_this133._container), Promise.resolve();
    });
    S(_assertThisInitialized(_assertThisInitialized(_this133)), "_loadWatermarkImage", function () {
      return _this133._watermarkImage ? Promise.resolve() : new Promise(function (e, t) {
        _this133._watermarkImage = new $e(), _this133._watermarkImage.onload = e, _this133._watermarkImage.src = Gd;
      });
    });
    _this133._watermarkFilter = null, _this133._watermarkImage = null;
    return _this133;
  }

  _createClass(ks, [{
    key: "_render",
    value: function _render(e) {
      return this._loadWatermarkImage().then(this._applyWatermarkFilter);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._watermarkFilter && this._watermarkFilter.dispose(), _get(_getPrototypeOf(ks.prototype), "dispose", this).call(this);
    }
  }]);

  return ks;
}(ee);

ks.identifier = "license-watermark";
ks.prototype.availableOptions = {};
N.Operations.LicenseWatermarkOperation = ks;
var Hd = ks;
var jd = "/*!\n * Based on evanw's glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n */\n\nuniform sampler2D u_image;\nuniform float u_blurRadius;\nuniform vec2 u_controlPoint1;\nuniform vec2 u_controlPoint2;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    vec2 vector = u_controlPoint2 - u_controlPoint1;\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n\n    float radius = smoothstep(0.0, 1.0,\n      abs(\n        clamp(dot(v_texCoord - u_controlPoint1, vector) / dot(vector, vector), 0.0, 1.0)\n      )\n    ) * u_blurRadius;\n\n    for (float t = -30.0; t <= 30.0; t++) {\n      float percent = (t + offset - 0.5) / 30.0;\n      float weight = 1.0 - abs(percent);\n      vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n      color += _sample * weight;\n      total += weight;\n    }\n\n    gl_FragColor = color / total;\n}\n";

var jt = I.Vector2,
    _c =
/*#__PURE__*/
function (_k$Filter23) {
  _inherits(_c, _k$Filter23);

  function _c() {
    var _getPrototypeOf62;

    var _this134;

    _classCallCheck(this, _c);

    for (var _len71 = arguments.length, e = new Array(_len71), _key71 = 0; _key71 < _len71; _key71++) {
      e[_key71] = arguments[_key71];
    }

    _this134 = _possibleConstructorReturn(this, (_getPrototypeOf62 = _getPrototypeOf(_c)).call.apply(_getPrototypeOf62, [this].concat(e)));
    _this134._fragmentSource = jd, _this134._lastBlurRadius = null, _this134._lastControlPoint1 = new jt(), _this134._lastControlPoint2 = new jt(), _this134._blurFilter = new Je(), _this134._blurredRenderTarget = new k.CanvasRenderTarget(100, 100, 1), _this134._maskRenderTarget = new k.CanvasRenderTarget(100, 100, 1);
    return _this134;
  }

  _createClass(_c, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var _this135 = this;

      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      if (this._options.blurQuality === "low") {
        this._renderLQBlur(e, t, i, r);

        return;
      }

      var o = t.getDimensions(),
          n = !i.getDimensions().equals(o);

      if (t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || n) {
        var _l12 = new jt(this._options.delta.x, this._options.delta.y);

        this._blurFilter.setDelta(_l12);

        var _c20 = {
          blurRadius: this._options.blurRadius,
          texSize: o
        },
            _u15 = function _u15(y, _, f) {
          return Math.min(Math.max(y, _), f);
        },
            _p15 = function _p15(y, _, f) {
          var v = _u15((f - y) / (_ - y), 0, 1);

          return v * v * (3 - 2 * v);
        },
            _h12 = this._options.controlPoint2.clone().subtract(this._options.controlPoint1.clone()),
            _d24 = this._options.blurRadius,
            _g15 = function _g15(y, _) {
          return _p15(0, 1, Math.abs(_u15(new jt(y, _).subtract(_this135._options.controlPoint1).dot(_h12) / _h12.dot(_h12), 0, 1))) * _d24;
        };

        this._blurFilter.set(_c20), this._blurFilter._applyCanvas(e, t, i, r, _g15), this._lastBlurRadius = this._options.blurRadius;
      }
    }
  }, {
    key: "_renderLQBlur",
    value: function _renderLQBlur(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getDimensions(),
          n = !this._blurredRenderTarget.getDimensions().equals(o);
      this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()), this._blurredRenderTarget.resizeTo(t.getDimensions()), this._maskRenderTarget.setPixelRatio(t.getPixelRatio()), this._maskRenderTarget.resizeTo(t.getDimensions());
      var a = !this._lastControlPoint1.equals(this._options.controlPoint1) || !this._lastControlPoint2.equals(this._options.controlPoint2) || n,
          l = t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || n;
      a && (this._renderMask(), this._lastControlPoint1 = this._options.controlPoint1.clone(), this._lastControlPoint2 = this._options.controlPoint2.clone()), l && (this._blurImage(t, this._blurredRenderTarget, this._options.blurRadius), this._lastBlurRadius = this._options.blurRadius), this._applyMask(t, i);
    }
  }, {
    key: "_renderMask",
    value: function _renderMask() {
      var e = this._maskRenderTarget.getCanvas(),
          t = this._maskRenderTarget.getContext(),
          i = new jt(e.width, e.height),
          r = this._options.controlPoint1.clone().multiply(i),
          o = this._options.controlPoint2.clone().multiply(i),
          n = t.createLinearGradient(r.x, r.y, o.x, o.y);

      n.addColorStop(0, "#FFFFFF"), n.addColorStop(1, "#000000"), t.fillStyle = n, t.fillRect(0, 0, e.width, e.height);
    }
  }, {
    key: "_applyMask",
    value: function _applyMask(e, t) {
      var i = t.getContext(),
          r = e.getCanvas(),
          o = e.getContext(),
          n = this._blurredRenderTarget.getContext(),
          a = this._maskRenderTarget.getContext(),
          l = o.getImageData(0, 0, r.width, r.height),
          c = l.data,
          u = n.getImageData(0, 0, r.width, r.height).data,
          p = a.getImageData(0, 0, r.width, r.height).data,
          h;

      for (var _d25 = 0; _d25 < r.width * r.height * 4; _d25 += 4) {
        h = p[_d25] / 255, c[_d25] = h * c[_d25] + (1 - h) * u[_d25], c[_d25 + 1] = h * c[_d25 + 1] + (1 - h) * u[_d25 + 1], c[_d25 + 2] = h * c[_d25 + 2] + (1 - h) * u[_d25 + 2];
      }

      i.putImageData(l, 0, 0);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(_c.prototype), "dispose", this).call(this), this._blurFilter.dispose(), this._blurredRenderTarget.dispose(), this._maskRenderTarget.dispose();
    }
  }]);

  return _c;
}(k.Filter);

_c.prototype.availableOptions = {
  blurRadius: {
    type: m.NUMBER,
    default: 30,
    uniformType: F.FLOAT
  },
  controlPoint1: {
    type: m.VECTOR2,
    default: new jt(0, .5),
    uniformType: F.FLOAT2
  },
  controlPoint2: {
    type: m.VECTOR2,
    default: new jt(1, .5),
    uniformType: F.FLOAT2
  },
  delta: {
    type: m.VECTOR2,
    default: new jt(1, 1),
    uniformType: F.FLOAT2
  },
  texSize: {
    type: m.VECTOR2,
    default: new jt(100, 100),
    uniformType: F.FLOAT2
  }
};
var zo = _c;

var Uo = I.Vector2,
    Ts =
/*#__PURE__*/
function (_ee8) {
  _inherits(Ts, _ee8);

  function Ts() {
    var _getPrototypeOf63;

    var _this136;

    _classCallCheck(this, Ts);

    for (var _len72 = arguments.length, e = new Array(_len72), _key72 = 0; _key72 < _len72; _key72++) {
      e[_key72] = arguments[_key72];
    }

    _this136 = _possibleConstructorReturn(this, (_getPrototypeOf63 = _getPrototypeOf(Ts)).call.apply(_getPrototypeOf63, [this].concat(e)));
    _this136._lastBlurRadius = _this136._options.blurRadius, _this136._lastControlPoint1 = _this136._options.controlPoint1.clone(), _this136._lastControlPoint2 = _this136._options.controlPoint2.clone();
    var t = {
      blurQuality: {
        type: m.STRING
      }
    };
    _this136._horizontalFilter = new zo({}, t), _this136._verticalFilter = new zo({}, t), _this136._sprite.setFilters([_this136._horizontalFilter, _this136._verticalFilter]), _this136._horizontalFilter.setDelta(new Uo(.5, .5)), _this136._verticalFilter.setDelta(new Uo(-.5, .5)), _this136._filter = new zo({}, t);
    return _this136;
  }

  _createClass(Ts, [{
    key: "rotate",
    value: function rotate(e) {
      var t = this._options.controlPoint1,
          i = this._options.controlPoint2;
      e === 90 ? (t.flip(), t.x = 1 - t.x, i.flip(), i.x = 1 - i.x) : e === -90 && (t.flip(), t.y = 1 - t.y, i.flip(), i.y = 1 - i.y), this.set({
        controlPoint1: t,
        controlPoint2: i
      });
    }
  }, {
    key: "flip",
    value: function flip(e) {
      var t = this._options.controlPoint1,
          i = this._options.controlPoint2;

      switch (e) {
        case "horizontal":
          t.x = 1 - t.x, i.x = 1 - i.x;
          break;

        case "vertical":
          t.y = 1 - t.y, i.y = 1 - i.y;
          break;
      }

      this.set({
        controlPoint1: t,
        controlPoint2: i
      });
    }
  }, {
    key: "transform",
    value: function transform(e) {
      var _this137 = this;

      var t = {};
      ["controlPoint1", "controlPoint2"].forEach(function (i) {
        var r = _this137.getOption(i);

        t[i] = e.applyToRelativePoint(r);
      }), ["blurRadius"].forEach(function (i) {
        var r = _this137.getOption(i);

        t[i] = e.applyToRelativeSize(r);
      }), this.set(t, !1);
    }
  }, {
    key: "_renderWebGL",
    value: function _renderWebGL(e) {
      return this._renderBlur(e);
    }
  }, {
    key: "_renderCanvas",
    value: function _renderCanvas(e) {
      return this._options.highQualityCanvasBlur ? this._renderBlur(e) : this._renderLQCanvasBlur(e);
    }
  }, {
    key: "_renderBlur",
    value: function _renderBlur(e) {
      var t = e.getDimensions(),
          i = t.min(),
          _this$_options9 = this._options,
          r = _this$_options9.blurRadius,
          o = _this$_options9.controlPoint1,
          n = _this$_options9.controlPoint2,
          a = {
        blurRadius: r * i,
        controlPoint1: o.clone(),
        controlPoint2: n.clone(),
        texSize: t,
        blurQuality: "high"
      };
      return this._horizontalFilter.set(a), this._verticalFilter.set(a), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "_renderLQCanvasBlur",
    value: function _renderLQCanvasBlur(e) {
      var t = e.getDimensions(),
          _this$_options10 = this._options,
          i = _this$_options10.blurRadius,
          r = _this$_options10.controlPoint1,
          o = _this$_options10.controlPoint2;
      return this._filter.set({
        blurRadius: i,
        controlPoint1: r.clone(),
        controlPoint2: o.clone(),
        texSize: t,
        blurQuality: "low"
      }), this._sprite.setFilters([this._filter]), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Ts.prototype), "dispose", this).call(this), this._filter.dispose(), this._verticalFilter.dispose(), this._horizontalFilter.dispose();
    }
  }, {
    key: "hasChanges",
    value: function hasChanges() {
      return !0;
    }
  }]);

  return Ts;
}(ee);

Ts.identifier = "linear-focus";
Ts.prototype.availableOptions = {
  controlPoint1: {
    type: m.VECTOR2,
    default: new Uo(0, .5)
  },
  controlPoint2: {
    type: m.VECTOR2,
    default: new Uo(1, .5)
  },
  blurRadius: {
    type: m.NUMBER,
    default: .025
  },
  highQualityCanvasBlur: {
    type: m.BOOLEAN,
    default: !1
  }
};
N.Operations.LinearFocusOperation = Ts;
var Yd = Ts;
var qd = "/*\n * Based on evanw's glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n * @license\n */\n\nuniform sampler2D u_image;\nuniform float u_blurRadius;\nuniform float u_gradientSize;\nuniform float u_size;\nuniform vec2 u_start;\nuniform vec2 u_end;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n\n    vec2 normal = normalize(vec2(u_start.y - u_end.y, u_end.x - u_start.x));\n    float radius = smoothstep(0.0, 1.0,\n      (abs(\n        dot(v_texCoord * u_texSize - u_start, normal)\n      ) - u_size) / u_gradientSize\n    ) * u_blurRadius;\n\n    for (float t = -30.0; t <= 30.0; t++) {\n        float percent = (t + offset - 0.5) / 30.0;\n        float weight = 1.0 - abs(percent);\n        vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n        color += _sample * weight;\n        total += weight;\n    }\n\n    gl_FragColor = color / total;\n}\n";

var Yt = I.Vector2,
    yc =
/*#__PURE__*/
function (_k$Filter24) {
  _inherits(yc, _k$Filter24);

  function yc() {
    var _getPrototypeOf64;

    var _this138;

    _classCallCheck(this, yc);

    for (var _len73 = arguments.length, e = new Array(_len73), _key73 = 0; _key73 < _len73; _key73++) {
      e[_key73] = arguments[_key73];
    }

    _this138 = _possibleConstructorReturn(this, (_getPrototypeOf64 = _getPrototypeOf(yc)).call.apply(_getPrototypeOf64, [this].concat(e)));
    _this138._fragmentSource = qd, _this138._lastBlurRadius = null, _this138._lastGradientRadius = null, _this138._lastStart = new Yt(), _this138._lastEnd = new Yt(), _this138._blurFilter = new Je(), _this138._blurredRenderTarget = new k.CanvasRenderTarget(100, 100, 1), _this138._maskRenderTarget = new k.CanvasRenderTarget(100, 100, 1);
    return _this138;
  }

  _createClass(yc, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      if (this._options.blurQuality === "low") {
        this._renderLQBlur(e, t, i, r);

        return;
      }

      var o = t.getDimensions(),
          n = !i.getDimensions().equals(o);

      if (t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || n) {
        var _l13 = new Yt(this._options.delta.x, this._options.delta.y);

        this._blurFilter.setDelta(_l13);

        var _c21 = {
          blurRadius: this._options.blurRadius,
          texSize: o
        },
            _u16 = function _u16(D, O, x) {
          return Math.min(Math.max(D, O), x);
        },
            _p16 = function _p16(D, O, x) {
          var w = _u16((x - D) / (O - D), 0, 1);

          return w * w * (3 - 2 * w);
        },
            _this$_options11 = this._options,
            _h13 = _this$_options11.blurRadius,
            _d26 = _this$_options11.gradientSize,
            _g16 = _this$_options11.size,
            _y14 = _this$_options11.start,
            _15 = _this$_options11.end,
            _f10 = _this$_options11.texSize,
            _v9 = new Yt(_y14.y - _15.y, _15.x - _y14.x);

        _v9.divide(_v9.len());

        var _b8 = function _b8(D, O) {
          return _p16(0, 1, (Math.abs(_f10.clone().multiply(D, O).subtract(_y14).dot(_v9)) - _g16) / _d26) * _h13;
        };

        this._blurFilter.set(_c21), this._blurFilter._applyCanvas(e, t, i, r, _b8), this._lastBlurRadius = this._options.blurRadius;
      }
    }
  }, {
    key: "_renderLQBlur",
    value: function _renderLQBlur(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getDimensions(),
          n = !this._blurredRenderTarget.getDimensions().equals(o);
      this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()), this._blurredRenderTarget.resizeTo(t.getDimensions()), this._maskRenderTarget.setPixelRatio(t.getPixelRatio()), this._maskRenderTarget.resizeTo(t.getDimensions());
      var a = !this._lastStart.equals(this._options.start) || !this._lastEnd.equals(this._options.end) || this._lastGradientRadius !== this._options.size || n,
          l = t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || n;
      a && (this._renderMask(), this._lastStart = this._options.start.clone(), this._lastEnd = this._options.end.clone(), this._lastGradientRadius = this._options.size), l && (this._blurImage(t, this._blurredRenderTarget, this._options.blurRadius), this._lastBlurRadius = this._options.blurRadius), this._applyMask(t, i);
    }
  }, {
    key: "_renderMask",
    value: function _renderMask() {
      var e = this._maskRenderTarget.getCanvas(),
          t = this._maskRenderTarget.getContext(),
          i = this._maskRenderTarget.getPixelRatio(),
          r = new Yt(e.width, e.height),
          o = this._options.size * r.min() * i,
          n = this._options.gradientSize * r.min() * i,
          a = this._options.start.clone().multiply(r),
          c = this._options.end.clone().multiply(r).clone().subtract(a),
          u = a.clone().add(c.clone().divide(2)),
          p = c.len(),
          h = c.clone().divide(p),
          d = u.clone().add((o + n) * h.y, -(o + n) * h.x),
          g = u.clone().add(-(o + n) * h.y, (o + n) * h.x),
          y = t.createLinearGradient(d.x, d.y, g.x, g.y),
          _ = g.clone().subtract(d).len();

      y.addColorStop(0, "#000000"), y.addColorStop(n / 2 / _, "#FFFFFF"), y.addColorStop(1 - n / 2 / _, "#FFFFFF"), y.addColorStop(1, "#000000"), t.fillStyle = y, t.fillRect(0, 0, e.width, e.height);
    }
  }, {
    key: "_applyMask",
    value: function _applyMask(e, t) {
      var i = t.getContext(),
          r = e.getCanvas(),
          o = e.getContext(),
          n = this._blurredRenderTarget.getContext(),
          a = this._maskRenderTarget.getContext(),
          l = o.getImageData(0, 0, r.width, r.height),
          c = l.data,
          u = n.getImageData(0, 0, r.width, r.height).data,
          p = a.getImageData(0, 0, r.width, r.height).data,
          h;

      for (var _d27 = 0; _d27 < r.width * r.height * 4; _d27 += 4) {
        h = p[_d27] / 255, c[_d27] = h * c[_d27] + (1 - h) * u[_d27], c[_d27 + 1] = h * c[_d27 + 1] + (1 - h) * u[_d27 + 1], c[_d27 + 2] = h * c[_d27 + 2] + (1 - h) * u[_d27 + 2];
      }

      i.putImageData(l, 0, 0);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(yc.prototype), "dispose", this).call(this), this._blurFilter.dispose();
    }
  }]);

  return yc;
}(k.Filter);

yc.prototype.availableOptions = {
  blurRadius: {
    type: m.NUMBER,
    default: 30,
    uniformType: F.FLOAT
  },
  size: {
    type: m.NUMBER,
    default: 50,
    uniformType: F.FLOAT
  },
  gradientSize: {
    type: m.NUMBER,
    default: 50,
    uniformType: F.FLOAT
  },
  start: {
    type: m.VECTOR2,
    default: new Yt(0, .5),
    uniformType: F.FLOAT2
  },
  end: {
    type: m.VECTOR2,
    default: new Yt(1, .5),
    uniformType: F.FLOAT2
  },
  delta: {
    type: m.VECTOR2,
    default: new Yt(1, 1),
    uniformType: F.FLOAT2
  },
  texSize: {
    type: m.VECTOR2,
    default: new Yt(100, 100),
    uniformType: F.FLOAT2
  }
};
var No = yc;

var Go = I.Vector2,
    Rs =
/*#__PURE__*/
function (_ee9) {
  _inherits(Rs, _ee9);

  function Rs() {
    var _getPrototypeOf65;

    var _this139;

    _classCallCheck(this, Rs);

    for (var _len74 = arguments.length, e = new Array(_len74), _key74 = 0; _key74 < _len74; _key74++) {
      e[_key74] = arguments[_key74];
    }

    _this139 = _possibleConstructorReturn(this, (_getPrototypeOf65 = _getPrototypeOf(Rs)).call.apply(_getPrototypeOf65, [this].concat(e)));
    _this139._lastBlurRadius = _this139._options.blurRadius, _this139._lastSize = _this139._options.size, _this139._lastGradientSize = _this139._options.gradientSize;
    var t = {
      blurQuality: {
        type: m.STRING
      }
    };
    _this139._horizontalFilter = new No({}, t), _this139._verticalFilter = new No({}, t), _this139._sprite.setFilters([_this139._horizontalFilter, _this139._verticalFilter]), _this139._horizontalFilter.setDelta(new Go(.5, .5)), _this139._verticalFilter.setDelta(new Go(-.5, .5)), _this139._filter = new No({}, t), _this139._renderBlur.bind(_assertThisInitialized(_assertThisInitialized(_this139)));
    return _this139;
  }

  _createClass(Rs, [{
    key: "rotate",
    value: function rotate(e) {
      var t = this._options.start,
          i = this._options.end;
      e === 90 ? (t.flip(), t.x = 1 - t.x, i.flip(), i.x = 1 - i.x) : e === -90 && (t.flip(), t.y = 1 - t.y, i.flip(), i.y = 1 - i.y), this.set({
        start: t,
        end: i
      });
    }
  }, {
    key: "flip",
    value: function flip(e) {
      var t = this._options.start,
          i = this._options.end;

      switch (e) {
        case "horizontal":
          t.x = 1 - t.x, i.x = 1 - i.x;
          break;

        case "vertical":
          t.y = 1 - t.y, i.y = 1 - i.y;
          break;
      }

      this.set({
        start: t,
        end: i
      });
    }
  }, {
    key: "transform",
    value: function transform(e) {
      var _this140 = this;

      var t = {};
      ["start", "end"].forEach(function (i) {
        var r = _this140.getOption(i);

        t[i] = e.applyToRelativePoint(r);
      }), ["blurRadius", "size", "gradientSize"].forEach(function (i) {
        var r = _this140.getOption(i);

        t[i] = e.applyToRelativeSize(r);
      }), this.set(t, !1);
    }
  }, {
    key: "_renderWebGL",
    value: function _renderWebGL(e) {
      return this._renderBlur(e);
    }
  }, {
    key: "_renderCanvas",
    value: function _renderCanvas(e) {
      return this._options.highQualityCanvasBlur ? this._renderBlur(e) : this._renderLQCanvasBlur(e);
    }
  }, {
    key: "_renderBlur",
    value: function _renderBlur(e) {
      var t = e.getDimensions(),
          i = t.min(),
          r = this._options.start.clone(),
          o = this._options.end.clone(),
          _this$_options12 = this._options,
          n = _this$_options12.blurRadius,
          a = _this$_options12.size,
          l = _this$_options12.gradientSize,
          c = {
        blurRadius: n * i,
        size: a * i,
        gradientSize: l * i,
        start: r.clone().multiply(t),
        end: o.clone().multiply(t),
        texSize: t,
        blurQuality: "high"
      };

      return this._horizontalFilter.set(c), this._verticalFilter.set(c), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "_renderLQCanvasBlur",
    value: function _renderLQCanvasBlur(e) {
      var t = e.getDimensions(),
          _this$_options13 = this._options,
          i = _this$_options13.blurRadius,
          r = _this$_options13.size,
          o = _this$_options13.gradientSize,
          n = _this$_options13.start,
          a = _this$_options13.end;
      return this._filter.set({
        blurRadius: i,
        gradientSize: o,
        size: r,
        start: n.clone(),
        end: a.clone(),
        texSize: t,
        blurQuality: "low"
      }), this._sprite.setFilters([this._filter]), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Rs.prototype), "dispose", this).call(this), this._filter.dispose(), this._verticalFilter.dispose(), this._horizontalFilter.dispose();
    }
  }, {
    key: "hasChanges",
    value: function hasChanges() {
      return !0;
    }
  }]);

  return Rs;
}(ee);

Rs.identifier = "mirrored-focus";
Rs.prototype.availableOptions = {
  start: {
    type: m.VECTOR2,
    default: new Go(0, .5)
  },
  end: {
    type: m.VECTOR2,
    default: new Go(1, .5)
  },
  blurRadius: {
    type: m.NUMBER,
    default: .025
  },
  size: {
    type: m.NUMBER,
    default: .1
  },
  gradientSize: {
    type: m.NUMBER,
    default: .1
  },
  highQualityCanvasBlur: {
    type: m.BOOLEAN,
    default: !1
  }
};
N.Operations.MirroredFocusOperation = Rs;
var Kd = Rs;

var __ = I.Vector2,
    Fs =
/*#__PURE__*/
function (_ee10) {
  _inherits(Fs, _ee10);

  function Fs() {
    _classCallCheck(this, Fs);

    return _possibleConstructorReturn(this, _getPrototypeOf(Fs).apply(this, arguments));
  }

  _createClass(Fs, [{
    key: "_render",
    value: function _render(e) {
      var t = this._options.rotation % 360,
          i = t * (Math.PI / 180),
          r = t === 90 || t === 270,
          o = this._options.flipHorizontally !== this._options.flipVertically,
          n = r && o ? !this._options.flipVertically : this._options.flipVertically,
          a = r && o ? !this._options.flipHorizontally : this._options.flipHorizontally;
      this._sprite.setScale(a ? -1 : 1, n ? -1 : 1), this._sprite.setRotation(i), this._sprite.setAnchor(.5, .5), this._sprite.updateTransform();

      var l = this._sprite.getBounds();

      return this._renderTexture.resizeTo(new __(l.width, l.height)), this._sprite.setPosition(this._renderTexture.getDimensions().divide(2).round()), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "getNewDimensions",
    value: function getNewDimensions(e) {
      return e = e.clone(), this._options.rotation % 180 && e.flip(), e;
    }
  }, {
    key: "flip",
    value: function flip(e) {
      var t = this._options.rotation;

      switch ((t === 90 || t === 270) && (e === "vertical" ? e = "horizontal" : e = "vertical"), e) {
        case "vertical":
          this.setFlipVertically(!this.getFlipVertically());
          break;

        case "horizontal":
          this.setFlipHorizontally(!this.getFlipHorizontally());
          break;
      }
    }
  }]);

  return Fs;
}(ee);

Fs.identifier = "orientation";
Fs.prototype.availableOptions = {
  rotation: {
    type: m.NUMBER,
    default: 0,
    validation: function validation(s) {
      if (s % 90 != 0) throw new Error("OrientationOperation: `rotation` has to be a multiple of 90.");
    },
    setter: function setter(s) {
      return (s + 360) % 360;
    }
  },
  flipVertically: {
    type: m.BOOLEAN,
    default: !1
  },
  flipHorizontally: {
    type: m.BOOLEAN,
    default: !1
  }
};
N.Operations.OrientationOperation = Fs;
var Xd = Fs;

var Wo = I.Vector2,
    Es =
/*#__PURE__*/
function (_ee11) {
  _inherits(Es, _ee11);

  function Es() {
    var _getPrototypeOf66;

    var _this141;

    _classCallCheck(this, Es);

    for (var _len75 = arguments.length, e = new Array(_len75), _key75 = 0; _key75 < _len75; _key75++) {
      e[_key75] = arguments[_key75];
    }

    _this141 = _possibleConstructorReturn(this, (_getPrototypeOf66 = _getPrototypeOf(Es)).call.apply(_getPrototypeOf66, [this].concat(e)));
    _this141._flipContainer = new k.Container();
    return _this141;
  }

  _createClass(Es, [{
    key: "_render",
    value: function _render(e) {
      var _this$_options14 = this._options,
          t = _this$_options14.position,
          i = _this$_options14.rotation,
          r = _this$_options14.scale,
          o = _this$_options14.pivot,
          n = _this$_options14.outputResolution,
          a = this._sdk.getTextureScale(),
          l = n.clone().multiply(a).ceil();

      return this._renderTexture.resizeTo(l), this._sprite.setRotation(i), this._sprite.setPosition(t), this._sprite.setPivot(o), this._sprite.setScale(r), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "getNewDimensions",
    value: function getNewDimensions(e) {
      var t = this._sdk.getTextureScale();

      return this._options.outputResolution.clone().multiply(t).ceil();
    }
  }]);

  return Es;
}(ee);

Es.identifier = "output";
Es.prototype.availableOptions = {
  position: {
    type: m.VECTOR2,
    default: new Wo(0, 0)
  },
  rotation: {
    type: m.NUMBER,
    default: 0
  },
  scale: {
    type: m.VECTOR2,
    default: new Wo(1, 1)
  },
  pivot: {
    type: m.VECTOR2,
    default: new Wo(0, 0)
  },
  outputResolution: {
    type: m.VECTOR2,
    default: new Wo(100, 100)
  }
};
N.Operations.OutputOperation = Es;
var Qd = Es;

var Vo = k.Filters.OverlayFilter,
    Zd = I.Vector2,
    y_ = 4,
    br =
/*#__PURE__*/
function (_ee12) {
  _inherits(br, _ee12);

  function br() {
    var _getPrototypeOf67;

    var _this142;

    _classCallCheck(this, br);

    for (var _len76 = arguments.length, e = new Array(_len76), _key76 = 0; _key76 < _len76; _key76++) {
      e[_key76] = arguments[_key76];
    }

    _this142 = _possibleConstructorReturn(this, (_getPrototypeOf67 = _getPrototypeOf(br)).call.apply(_getPrototypeOf67, [this].concat(e)));
    _this142._overlayTexture = k.Texture.fromImage(_this142._options.image), _this142._overlayContainer = new k.Container(), _this142._overlaySprite = new k.Sprite(), _this142._overlaySprite.setTexture(_this142._overlayTexture), _this142._overlaySprite.setAnchor(0, 0), _this142._overlayContainer.addChild(_this142._overlaySprite), _this142._overlayFilter = new k.Filters.OverlayFilter({
      overlayImage: _this142._overlayTexture.getBaseTexture().getGLUnit(),
      overlayTexture: _this142._overlayTexture
    }), _this142._sprite.setFilters([_this142._overlayFilter]), _this142._renderedOverlaySprite = new k.Sprite(), _this142._renderedOverlayContainer = new k.Container(), _this142._renderedOverlayContainer.addChild(_this142._renderedOverlaySprite), _this142._overlayRendered = !1, _this142._lastInputDimensions = new Zd(0, 0);
    return _this142;
  }

  _createClass(br, [{
    key: "setOption",
    value: function setOption(e, t) {
      if (_get(_getPrototypeOf(br.prototype), "setOption", this).call(this, e, t), e === "image" && t && this._sdk) {
        var _i13 = this._sdk.getRenderer(),
            _r5 = this._overlayTexture.getBaseTexture();

        _r5.setSource(t), _i13.isOfType(U.WEBGL) && _i13.updateTexture(_r5), this._overlayRendered = !1;
      }
    }
  }, {
    key: "_render",
    value: function _render(e) {
      var t = e.getDimensions(),
          _this$_options15 = this._options,
          i = _this$_options15.image,
          r = _this$_options15.alpha,
          o = _this$_options15.blendMode;
      return i ? ((!this._overlayRendered || !this._lastInputDimensions.equals(t)) && (this._renderOverlayToRenderTexture(e), this._overlayRendered = !0, this._lastInputDimensions.copy(t)), this._overlayFilter.set({
        blendMode: o,
        overlayImage: this._overlayRenderTexture.getBaseTexture().getGLUnit(),
        overlayTexture: this._overlayRenderTexture,
        alpha: r
      }), this._sprite.setFilters([this._overlayFilter]), this._renderTexture.render(this._container), Promise.resolve()) : (this._sprite.setFilters([]), this._renderTexture.render(this._container), Promise.resolve());
    }
  }, {
    key: "_renderOverlayToRenderTexture",
    value: function _renderOverlayToRenderTexture(e) {
      var t = this._sdk.getRenderer(),
          i = e.getDimensions();

      this._overlayRenderTexture || (this._overlayRenderTexture = new k.RenderTexture(t, i.x, i.y), this._renderedOverlaySprite.setTexture(this._overlayRenderTexture));
      var _this$_options$image = this._options.image,
          r = _this$_options$image.width,
          o = _this$_options$image.height,
          n = T.resizeVectorToFill(new Zd(r, o), i),
          _this$_options16 = this._options,
          a = _this$_options16.flipHorizontally,
          l = _this$_options16.flipVertically,
          c = a ? -1 : 1,
          u = l ? -1 : 1;
      this._overlaySprite.setWidth(n.x * c), this._overlaySprite.setHeight(n.y * u), this._overlaySprite.setPosition(i.x * (1 - c) * .5, i.y * (1 - u) * .5);

      var p = this._overlayRenderTexture.getBaseTexture();

      this._overlayRenderTexture.resizeTo(i), t.isOfType(U.WEBGL) && (p.setGLUnit(y_), t.updateTexture(p, !1)), this._overlayRenderTexture.render(this._overlayContainer);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(br.prototype), "dispose", this).call(this), this._overlaySprite && this._overlaySprite.dispose(), this._overlayRenderTexture && this._renderedOverlaySprite.dispose(), this._overlayFilter && this._overlayFilter.dispose(), this._overlayTexture && this._overlayTexture.dispose(), this._overlayRenderTexture && this._overlayRenderTexture.dispose(), this._renderedOverlaySprite && this._renderedOverlaySprite.dispose();
    }
  }]);

  return br;
}(ee);

br.identifier = "overlay";
br.BLEND_MODES = Vo.BLEND_MODES;
br.prototype.availableOptions = {
  identifier: {
    type: m.STRING
  },
  image: {
    type: m.IMAGE
  },
  blendMode: {
    type: m.NUMBER,
    default: Vo.BLEND_MODES.MULTIPLY,
    available: Object.keys(Vo.BLEND_MODES).map(function (s) {
      return Vo.BLEND_MODES[s];
    })
  },
  alpha: {
    type: m.NUMBER,
    default: 1
  },
  flipHorizontally: {
    type: m.BOOLEAN,
    default: !1
  },
  flipVertically: {
    type: m.BOOLEAN,
    default: !1
  }
};
N.Operations.OverlayOperation = br;
var $d = br;
var Jd = "/*\n * Based on evanw's glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n * @license\n */\n\nuniform sampler2D u_image;\nuniform float u_radius;\nuniform float u_blurRadius;\nuniform float u_gradientRadius;\nuniform vec2 u_position;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nconst float blurSteps = 30.0;\nconst float EPSILON = 0.000000001;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    vec2 coord = v_texCoord * u_texSize;\n    vec2 diff = coord - u_position;\n    float dist = sqrt(diff.x * diff.x + diff.y * diff.y);\n\n    float blurPercentage = smoothstep( \n      0.0, 1.0,\n      (abs(dist) - u_radius) / u_gradientRadius\n    );\n\n    float radius = blurPercentage * u_blurRadius;\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n\n    for (float t = -blurSteps; t <= blurSteps; t++) {\n        float percent = (t + offset - 0.5) / blurSteps;\n        float weight = 1.0 - abs(percent);\n        vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n        color += _sample * weight;\n        total += weight;\n    }\n\n    gl_FragColor = color / max(total, EPSILON);\n}\n";

var xr = I.Vector2,
    bc =
/*#__PURE__*/
function (_k$Filter25) {
  _inherits(bc, _k$Filter25);

  function bc() {
    var _getPrototypeOf68;

    var _this143;

    _classCallCheck(this, bc);

    for (var _len77 = arguments.length, e = new Array(_len77), _key77 = 0; _key77 < _len77; _key77++) {
      e[_key77] = arguments[_key77];
    }

    _this143 = _possibleConstructorReturn(this, (_getPrototypeOf68 = _getPrototypeOf(bc)).call.apply(_getPrototypeOf68, [this].concat(e)));
    _this143._fragmentSource = Jd, _this143._lastBlurRadius = null, _this143._lastGradientRadius = null, _this143._lastPosition = new xr(), _this143._blurFilter = new Je(), _this143._blurredRenderTarget = new k.CanvasRenderTarget(100, 100, 1), _this143._maskRenderTarget = new k.CanvasRenderTarget(100, 100, 1);
    return _this143;
  }

  _createClass(bc, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var _this144 = this;

      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      if (this._options.blurQuality === "low") {
        this._renderLQBlur(e, t, i, r);

        return;
      }

      var o = t.getDimensions(),
          n = !i.getDimensions().equals(o),
          _this$_options17 = this._options,
          a = _this$_options17.blurRadius,
          l = _this$_options17.position,
          c = _this$_options17.texSize,
          u = _this$_options17.gradientRadius;

      if (t.getBaseTexture().isDirty() || this._lastBlurRadius !== a || n) {
        var _h14 = new xr(this._options.delta.x, this._options.delta.y);

        this._blurFilter.setDelta(_h14);

        var _d28 = {
          blurRadius: a,
          texSize: o
        },
            _g17 = function _g17(f, v, b) {
          return Math.min(Math.max(f, v), b);
        },
            _y15 = function _y15(f, v, b) {
          var D = _g17((b - f) / (v - f), 0, 1);

          return D * D * (3 - 2 * D);
        },
            _16 = function _16(f, v) {
          return _y15(0, 1, (Math.abs(c.clone().multiply(f, v).subtract(l).len()) - _this144._options.radius) / (u * 2)) * a;
        };

        this._blurFilter.set(_d28), this._blurFilter._applyCanvas(e, t, i, r, _16), this._lastBlurRadius = a;
      }
    }
  }, {
    key: "_renderLQBlur",
    value: function _renderLQBlur(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var o = t.getDimensions(),
          n = !this._blurredRenderTarget.getDimensions().equals(o);
      this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()), this._blurredRenderTarget.resizeTo(t.getDimensions()), this._maskRenderTarget.setPixelRatio(t.getPixelRatio()), this._maskRenderTarget.resizeTo(t.getDimensions());
      var a = !this._lastPosition.equals(this._options.position) || this._lastGradientRadius !== this._options.gradientRadius || n,
          l = t.getBaseTexture().isDirty() || this._lastBlurRadius !== this._options.blurRadius || n;
      a && (this._renderMask(), this._lastPosition = this._options.position.clone(), this._lastGradientRadius = this._options.gradientRadius), l && (this._blurImage(t, this._blurredRenderTarget, this._options.blurRadius), this._lastBlurRadius = this._options.blurRadius), this._applyMask(t, i);
    }
  }, {
    key: "_renderMask",
    value: function _renderMask() {
      var e = this._maskRenderTarget.getCanvas(),
          t = this._maskRenderTarget.getContext(),
          i = new xr(e.width, e.height),
          r = this._maskRenderTarget.getPixelRatio(),
          o = this._options.position.clone().multiply(i),
          _this$_options18 = this._options,
          n = _this$_options18.radius,
          a = _this$_options18.gradientRadius;

      n *= e.height, a *= e.height;
      var l = t.createRadialGradient(o.x, o.y, 0, o.x, o.y, (n + a) * r);
      l.addColorStop(0, "#FFFFFF"), l.addColorStop(n / (n + a), "#FFFFFF"), l.addColorStop(1, "#000000"), t.fillStyle = l, t.fillRect(0, 0, i.x, i.y);
    }
  }, {
    key: "_applyMask",
    value: function _applyMask(e, t) {
      var i = t.getContext(),
          r = e.getCanvas(),
          o = e.getContext(),
          n = this._blurredRenderTarget.getContext(),
          a = this._maskRenderTarget.getContext(),
          l = o.getImageData(0, 0, r.width, r.height),
          c = l.data,
          u = n.getImageData(0, 0, r.width, r.height).data,
          p = a.getImageData(0, 0, r.width, r.height).data,
          h;

      for (var _d29 = 0; _d29 < r.width * r.height * 4; _d29 += 4) {
        h = p[_d29] / 255, c[_d29] = h * c[_d29] + (1 - h) * u[_d29], c[_d29 + 1] = h * c[_d29 + 1] + (1 - h) * u[_d29 + 1], c[_d29 + 2] = h * c[_d29 + 2] + (1 - h) * u[_d29 + 2];
      }

      i.putImageData(l, 0, 0);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(bc.prototype), "dispose", this).call(this), this._blurFilter.dispose(), this._blurredRenderTarget.dispose(), this._maskRenderTarget.dispose();
    }
  }]);

  return bc;
}(k.Filter);

bc.prototype.availableOptions = {
  blurRadius: {
    type: m.NUMBER,
    default: 30,
    uniformType: F.FLOAT
  },
  radius: {
    type: m.NUMBER,
    default: 50,
    uniformType: F.FLOAT
  },
  gradientRadius: {
    type: m.NUMBER,
    default: 25,
    uniformType: F.FLOAT
  },
  position: {
    type: m.VECTOR2,
    default: new xr(.5, .5),
    uniformType: F.FLOAT2
  },
  delta: {
    type: m.VECTOR2,
    default: new xr(1, 1),
    uniformType: F.FLOAT2
  },
  texSize: {
    type: m.VECTOR2,
    default: new xr(100, 100),
    uniformType: F.FLOAT2
  }
};
var Ho = bc;

var xc = I.Vector2,
    Ss =
/*#__PURE__*/
function (_ee13) {
  _inherits(Ss, _ee13);

  function Ss() {
    var _getPrototypeOf69;

    var _this145;

    _classCallCheck(this, Ss);

    for (var _len78 = arguments.length, e = new Array(_len78), _key78 = 0; _key78 < _len78; _key78++) {
      e[_key78] = arguments[_key78];
    }

    _this145 = _possibleConstructorReturn(this, (_getPrototypeOf69 = _getPrototypeOf(Ss)).call.apply(_getPrototypeOf69, [this].concat(e)));
    _this145._lastBlurRadius = _this145._options.blurRadius, _this145._lastGradientRadius = _this145._options.gradientRadius;
    var t = {
      blurQuality: {
        type: m.STRING
      }
    };
    _this145._horizontalFilter = new Ho({}, t), _this145._verticalFilter = new Ho({}, t), _this145._sprite.setFilters([_this145._horizontalFilter, _this145._verticalFilter]), _this145._horizontalFilter.setDelta(new xc(.5, .5)), _this145._verticalFilter.setDelta(new xc(-.5, .5)), _this145._filter = new Ho({}, t);
    return _this145;
  }

  _createClass(Ss, [{
    key: "rotate",
    value: function rotate(e) {
      var t = this._options.position;
      e === 90 ? (t.flip(), t.x = 1 - t.x) : e === -90 && (t.flip(), t.y = 1 - t.y), this.set({
        position: t
      });
    }
  }, {
    key: "flip",
    value: function flip(e) {
      var t = this._options.position;

      switch (e) {
        case "horizontal":
          t.x = 1 - t.x;
          break;

        case "vertical":
          t.y = 1 - t.y;
          break;
      }

      this.set({
        position: t
      });
    }
  }, {
    key: "transform",
    value: function transform(e) {
      var _this146 = this;

      var t = {},
          i = this.getPosition();
      t.position = e.applyToRelativePoint(i), ["radius", "blurRadius", "gradientRadius"].forEach(function (r) {
        var o = _this146.getOption(r);

        t[r] = e.applyToRelativeSize(o);
      }), this.set(t, !1);
    }
  }, {
    key: "_renderWebGL",
    value: function _renderWebGL(e) {
      return this._renderBlur(e);
    }
  }, {
    key: "_renderCanvas",
    value: function _renderCanvas(e) {
      return this._options.highQualityCanvasBlur ? this._renderBlur(e) : this._renderLQCanvasBlur(e);
    }
  }, {
    key: "_renderBlur",
    value: function _renderBlur(e) {
      var t = e.getDimensions(),
          i = t.min(),
          _this$_options19 = this._options,
          r = _this$_options19.position,
          o = _this$_options19.blurRadius,
          n = _this$_options19.radius,
          a = _this$_options19.gradientRadius,
          l = {
        blurRadius: o * i,
        radius: n * i,
        gradientRadius: a * i,
        position: r.clone().multiply(t),
        texSize: t,
        blurQuality: "high"
      };
      return this._horizontalFilter.set(l), this._verticalFilter.set(l), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "_renderLQCanvasBlur",
    value: function _renderLQCanvasBlur(e) {
      var _this$_options20 = this._options,
          t = _this$_options20.blurRadius,
          i = _this$_options20.radius,
          r = _this$_options20.gradientRadius,
          o = _this$_options20.position,
          n = e.getDimensions();
      return this._filter.set({
        blurRadius: t,
        radius: i,
        gradientRadius: r,
        position: o,
        texSize: n,
        blurQuality: "low"
      }), this._sprite.setFilters([this._filter]), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Ss.prototype), "dispose", this).call(this), this._filter.dispose(), this._verticalFilter.dispose(), this._horizontalFilter.dispose();
    }
  }, {
    key: "hasChanges",
    value: function hasChanges() {
      return !0;
    }
  }]);

  return Ss;
}(ee);

Ss.identifier = "radial-focus";
Ss.prototype.availableOptions = {
  position: {
    type: m.VECTOR2,
    default: new xc(.5, .5)
  },
  radius: {
    type: m.NUMBER,
    default: .25
  },
  gradientRadius: {
    type: m.NUMBER,
    default: .125
  },
  blurRadius: {
    type: m.NUMBER,
    default: .025
  },
  highQualityCanvasBlur: {
    type: m.BOOLEAN,
    default: !1
  }
};
N.Operations.RadialFocusOperation = Ss;
var eh = Ss;
var th = "varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_filterImage;\nuniform sampler2D u_maskImage;\n\nvoid main() {\n  vec4 color0 = texture2D(u_image, v_texCoord);\n  vec4 color1 = texture2D(u_filterImage, v_texCoord);\n  vec4 mask = texture2D(u_maskImage, v_texCoord);\n  gl_FragColor = mix(color0, color1, mask);\n}\n";

var vc =
/*#__PURE__*/
function (_k$Filter26) {
  _inherits(vc, _k$Filter26);

  function vc() {
    var _this147;

    _classCallCheck(this, vc);

    _this147 = _possibleConstructorReturn(this, _getPrototypeOf(vc).call(this));
    _this147._fragmentSource = th;
    return _this147;
  }

  _createClass(vc, [{
    key: "_applyCanvas",
    value: function _applyCanvas(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

      var o = t.getCanvas(),
          n = t.getContext(),
          a = i.getContext(),
          _this$_options21 = this._options,
          l = _this$_options21.maskCanvas,
          c = _this$_options21.filterCanvas,
          u = l.getContext("2d"),
          p = c.getContext("2d"),
          h = u.getImageData(0, 0, o.width, o.height).data,
          d = n.getImageData(0, 0, o.width, o.height),
          g = d.data,
          y = p.getImageData(0, 0, o.width, o.height).data,
          _;

      for (var _f11 = 0; _f11 < o.width * o.height * 4; _f11 += 4) {
        _ = h[_f11] / 255, g[_f11] = _ * y[_f11] + (1 - _) * g[_f11], g[_f11 + 1] = _ * y[_f11 + 1] + (1 - _) * g[_f11 + 1], g[_f11 + 2] = _ * y[_f11 + 2] + (1 - _) * g[_f11 + 2];
      }

      a.putImageData(d, 0, 0);
    }
  }]);

  return vc;
}(k.Filter);

vc.prototype.availableOptions = {
  maskImage: {
    type: m.NUMBER,
    default: 1,
    uniformType: F.INT
  },
  maskCanvas: {
    type: m.OBJECT,
    default: null
  },
  filterImage: {
    type: m.NUMBER,
    default: 2,
    uniformType: F.INT
  },
  filterCanvas: {
    type: m.OBJECT,
    default: null
  }
};
var ih = vc;

var jo = I.Vector2,
    rh =
/*#__PURE__*/
function (_V6) {
  _inherits(rh, _V6);

  function rh(e, t) {
    var _this148;

    _classCallCheck(this, rh);

    _this148 = _possibleConstructorReturn(this, _getPrototypeOf(rh).call(this, t));
    _this148._isDisposed = !1, _this148._operation = e, _this148._dirtiness = {}, _this148.id = T.getUUID(), _this148._renderTextures = {}, _this148._identitySprite = new k.Sprite(), _this148._sprite = new k.Sprite(), _this148._hitTestSprite = new k.Sprite(), _this148._renderers = [];
    return _this148;
  }

  _createClass(rh, [{
    key: "applyScale",
    value: function applyScale(e) {}
  }, {
    key: "applyRotation",
    value: function applyRotation(e) {
      var t = this._operation.getInputDimensions(),
          i = this.getRotation() * 180 / Math.PI;

      i += e, this.setRotation(i * Math.PI / 180);

      var o = (e + 360) % 360 * Math.PI / 180,
          n = Math.cos(o),
          a = Math.sin(o),
          l = this._options.position.clone().subtract(.5).multiply(t),
          c = new jo(l.x * n - l.y * a, l.x * a + l.y * n).divide(t.clone().flip());

      this.setPosition(new jo(.5, .5).add(c));
    }
  }, {
    key: "applyFlip",
    value: function applyFlip(e) {
      var t = this.getPosition().clone();

      switch (e) {
        case "horizontal":
          t.x = 1 - this._options.position.x;
          break;

        case "vertical":
          t.y = 1 - this._options.position.y;
          break;
      }

      this.setPosition(t);
    }
  }, {
    key: "applyTransform",
    value: function applyTransform(e) {
      var t = {};
      t.rotation = e.applyToRotation(this.getRotation()), t.position = e.applyToRelativePoint(this.getPosition()), this._options.dimensions && (t.dimensions = e.applyToDimensions(this.getDimensions())), this.set(t, !1);
    }
  }, {
    key: "getDisplayObject",
    value: function getDisplayObject() {
      return this._sprite;
    }
  }, {
    key: "getHitTestDisplayObject",
    value: function getHitTestDisplayObject() {
      return this._sprite;
    }
  }, {
    key: "_getTexture",
    value: function _getTexture() {
      throw new Error("Sprite#_getTexture is abstract and not implemented in child class.");
    }
  }, {
    key: "_prepareRenderTexture",
    value: function _prepareRenderTexture(e) {
      if (this._renderTexture) this._renderTexture.clear();else {
        var _t23 = this._getTexture();

        this._renderTextureContainer = new k.Container(), this._renderTextureSprite = new k.Sprite(_t23), this._renderTextureContainer.addChild(this._renderTextureSprite), this._renderTexture = this._getRenderTexture(e.getRenderer(), _t23.getDimensions());
      }
    }
  }, {
    key: "_rendersToRenderTexture",
    value: function _rendersToRenderTexture(e) {
      return e.getOptions().smoothDownscaling && e.getRenderer().isOfType(U.WEBGL);
    }
  }, {
    key: "_optionEquals",
    value: function _optionEquals(e, t) {
      return e === "type" ? !0 : _get(_getPrototypeOf(rh.prototype), "_optionEquals", this).call(this, e, t);
    }
  }, {
    key: "update",
    value: function update(e, t) {
      this._isDisposed || (this._rendersToRenderTexture(e) && (this._prepareRenderTexture(e), this._renderToRenderTexture(e)), this._updateSprite(t));
    }
  }, {
    key: "_updateSprite",
    value: function _updateSprite(e) {
      var _this149 = this;

      [this._sprite, this._hitTestSprite].forEach(function (i) {
        if (!i.getTexture()) return;
        i.setAnchor(_this149._options.anchor), i.setPosition(_this149._options.position.clone().multiply(e)), typeof _this149._options.alpha != "undefined" && i.setAlpha(_this149._options.alpha);
        var r = _this149._options.dimensions;
        r && (r = r.clone().multiply(_this149._operation.getSDK().getTextureScale()), i.setWidth(r.x), i.setHeight(r.y)), i.updateTransform();
        var o = i.getTexture().getFrame(),
            n = new jo(o.width, o.height);
        i.setPivot(_this149._options.pivot.clone().multiply(n)), i.setRotation(_this149._options.rotation), i.updateTransform();
      });
    }
  }, {
    key: "_renderToRenderTexture",
    value: function _renderToRenderTexture(e) {
      var t = this._getTexture().getDimensions(),
          i = this._getRenderTexture(e.getRenderer(), t),
          r = t.clone();

      if (this._options.smoothDownscaling && (r.x = T.nextHighestPOT(r.x), r.y = T.nextHighestPOT(r.y)), this._renderTexture.resizeTo(r), this._renderTexture.render(this._renderTextureContainer), this._options.smoothDownscaling) {
        var _o17 = r.clone().subtract(t.x, t.y).divide(r),
            _n11 = i.getUVs().getUVs();

        _n11[0].x = _n11[3].x = 0, _n11[1].x = _n11[2].x = 1 - _o17.x, _n11[0].y = _n11[1].y = 0, _n11[2].y = _n11[3].y = 1 - _o17.y;
      }

      this._sprite.setTexture(i);
    }
  }, {
    key: "isDirtyForRenderer",
    value: function isDirtyForRenderer(e) {
      return e.id in this._dirtiness || (this._dirtiness[e.id] = !0), this._dirtiness[e.id];
    }
  }, {
    key: "setDirtyForRenderer",
    value: function setDirtyForRenderer(e, t) {
      this._renderers[t.id] = t, this._dirtiness[t.id] = e;
    }
  }, {
    key: "setDirty",
    value: function setDirty(e) {
      for (var _t24 in this._dirtiness) {
        this.setDirtyForRenderer(e, this._renderers[_t24]);
      }
    }
  }, {
    key: "_getRenderTexture",
    value: function _getRenderTexture(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new jo(100, 100);
      return this._renderTextures[e.id] || (this._renderTextures[e.id] = new k.RenderTexture(e, t.x, t.y, 1)), this._renderTextures[e.id];
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._isDisposed = !0;

      for (var _e21 in this._renderTextures) {
        this._renderTextures[_e21].dispose();
      }
    }
  }, {
    key: "canBeDuplicated",
    value: function canBeDuplicated() {
      return !0;
    }
  }, {
    key: "canBeDeleted",
    value: function canBeDeleted() {
      return !0;
    }
  }, {
    key: "canMaskCanvas",
    value: function canMaskCanvas() {
      return !1;
    }
  }, {
    key: "canAdjustPadding",
    value: function canAdjustPadding() {
      return !1;
    }
  }, {
    key: "canBeTakenToFront",
    value: function canBeTakenToFront() {
      return !0;
    }
  }, {
    key: "canBeFlippedHorizontally",
    value: function canBeFlippedHorizontally() {
      return !0;
    }
  }]);

  return rh;
}(V),
    It = rh;

var b_ = I.Vector2,
    Yo =
/*#__PURE__*/
function (_V7) {
  _inherits(Yo, _V7);

  function Yo() {
    var _getPrototypeOf70;

    var _this150;

    _classCallCheck(this, Yo);

    for (var _len79 = arguments.length, e = new Array(_len79), _key79 = 0; _key79 < _len79; _key79++) {
      e[_key79] = arguments[_key79];
    }

    _this150 = _possibleConstructorReturn(this, (_getPrototypeOf70 = _getPrototypeOf(Yo)).call.apply(_getPrototypeOf70, [this].concat(e)));
    _this150._lastOptions = {}, _this150._lastInputDimensions = new b_(0, 0), _this150._brush = null;
    return _this150;
  }

  _createClass(Yo, [{
    key: "getBrushImage",
    value: function getBrushImage(e) {
      if (this._brush && this.optionsEqual(this._lastOptions) && e.equals(this._lastInputDimensions)) return this._brush;
      var _this$_options22 = this._options,
          t = _this$_options22.image,
          i = _this$_options22.size;
      t.width = t.height = Math.ceil(i * e.min());
      var r = T.createCanvas();
      r.width = t.width, r.height = t.height;
      var o = r.getContext("2d");
      o.drawImage(t, 0, 0, r.width, r.height);

      var n = this._tintImageData(o.getImageData(0, 0, r.width, r.height), r.width, r.height);

      return o.putImageData(n, 0, 0), this._lastOptions = this.serializeOptions(["size", "color"]), this._brush = r, this._lastInputDimensions = e.clone(), r;
    }
  }, {
    key: "_tintImageData",
    value: function _tintImageData(e) {
      var t = this._options.color;

      for (var _i14 = 0; _i14 < e.data.length; _i14 += 4) {
        e.data[_i14] += (t.r * 255 - e.data[_i14]) * t.a, e.data[_i14 + 1] += (t.g * 255 - e.data[_i14 + 1]) * t.a, e.data[_i14 + 2] += (t.b * 255 - e.data[_i14 + 2]) * t.a;
      }

      return e;
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = this.constructor;
      return new e(this._options);
    }
  }]);

  return Yo;
}(V),
    As = Yo;

Yo.prototype.availableOptions = {
  identifier: {
    type: m.STRING
  },
  image: {
    type: m.IMAGE
  },
  size: {
    type: m.NUMBER,
    default: .05
  },
  color: {
    type: m.COLOR,
    default: R.RED
  }
};

var Is =
/*#__PURE__*/
function (_As) {
  _inherits(Is, _As);

  function Is() {
    _classCallCheck(this, Is);

    return _possibleConstructorReturn(this, _getPrototypeOf(Is).apply(this, arguments));
  }

  _createClass(Is, [{
    key: "getBrushImage",
    value: function getBrushImage(e) {
      if (this._brush && this.optionsEqual(this._lastOptions) && e.equals(this._lastInputDimensions)) return this._brush;
      var _this$_options23 = this._options,
          t = _this$_options23.size,
          i = _this$_options23.hardness,
          r = _this$_options23.color,
          o = T.createCanvas();
      o.width = o.height = Math.ceil(t * e.min());
      var n = o.getContext("2d");
      if (r = r.clone(), r.a = 1, o.width === 1) n.fillStyle = r.toRGBA(), n.fillRect(0, 0, 1, 1);else {
        var _a9 = n.createRadialGradient(o.width / 2, o.height / 2, Math.min(o.width / 2 - 1, o.width / 2 * i), o.width / 2, o.height / 2, o.width / 2);

        _a9.addColorStop(0, r.toRGBA());

        var _l14 = r.clone();

        _l14.a = 0, _a9.addColorStop(1, _l14.toRGBA()), n.fillStyle = _a9, n.fillRect(0, 0, o.width, o.height);
      }
      return this._lastOptions = this.serializeOptions(["size", "color", "hardness"]), this._brush = o, this._lastInputDimensions = e.clone(), o;
    }
  }]);

  return Is;
}(As),
    Cc = Is;

Is.identifier = "imgly_brush_radial";
Is.prototype.availableOptions = C(C({}, As.prototype.availableOptions), {
  hardness: {
    type: m.NUMBER,
    default: 1
  }
});

var x_ = I.Vector2,
    v_ = I.CubicBezierCurve,
    sh =
/*#__PURE__*/
function () {
  function sh(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;

    _classCallCheck(this, sh);

    this._path = e, this._drawnCanvases = [], this._position = t, this._smooth = i;
  }

  _createClass(sh, [{
    key: "getBezierCurve",
    value: function getBezierCurve(e, t, i, r) {
      if (!t) return null;
      var o, n;
      r ? (o = (r.x - t.x) / this._smooth, n = (r.y - t.y) / this._smooth) : (o = (i.x - t.x) / this._smooth, n = (i.y - t.y) / this._smooth);
      var a, l;
      e ? (a = (i.x - e.x) / this._smooth, l = (i.y - e.y) / this._smooth) : (a = (i.x - t.x) / this._smooth, l = (i.y - t.y) / this._smooth);
      var c = t.clone().add(a, l),
          u = i.clone().subtract(o, n);
      return new v_(t, c, u, i);
    }
  }, {
    key: "renderToCanvas",
    value: function renderToCanvas(e, t, i, r, o) {
      var n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
      if (this._drawnCanvases.indexOf(t) !== -1) return;

      var a = new x_(t.width, t.height),
          l = t.getContext("2d"),
          c = this._position.clone().multiply(a),
          u = r ? r.getPosition().clone().multiply(a) : null,
          p = i ? i.getPosition().clone().multiply(a) : null,
          h = o ? o.getPosition().clone().multiply(a) : null,
          d = c.clone().subtract(u).len(),
          g = e.width / 10,
          y = this.getBezierCurve(p, u, c, h),
          _;

      if (!y) _ = [c];else {
        y.calculateSegments(20);

        var _f12 = y.getLength();

        _ = y.arcLengthApproxSample(Math.ceil(_f12 / g));
      }

      for (var _f13 = 0; _f13 < _.length; _f13++) {
        var _v10 = _[_f13],
            _b9 = e.width * .5 / (g * 2);

        _b9 *= 1 - n, _b9 = 1 / (1 + _b9), l.globalAlpha = _b9, l.drawImage(e, _v10.x - e.width / 2, _v10.y - e.height / 2, e.width, e.height);
      }

      l.globalAlpha = 1, this._drawnCanvases.push(t);
    }
  }, {
    key: "setPosition",
    value: function setPosition(e) {
      this._position = e;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return this._position.clone();
    }
  }, {
    key: "setDirty",
    value: function setDirty() {
      this._drawnCanvases = [];
    }
  }]);

  return sh;
}(),
    oh = sh;

var wc =
/*#__PURE__*/
function (_V8) {
  _inherits(wc, _V8);

  function wc(e, t, i) {
    var _this151;

    _classCallCheck(this, wc);

    _this151 = _possibleConstructorReturn(this, _getPrototypeOf(wc).call(this, t));
    _this151._operation = e, _this151._canvas = i || T.createCanvas(), _this151._context = _this151._canvas.getContext("2d");
    return _this151;
  }

  _createClass(wc, [{
    key: "serializeOption",
    value: function serializeOption(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return e === "controlPoints" ? this._options.controlPoints.map(function (i) {
        var r = i.getPosition();
        return t ? r.toObject() : r.clone();
      }) : _get(_getPrototypeOf(wc.prototype), "serializeOption", this).call(this, e, t);
    }
  }, {
    key: "_optionEquals",
    value: function _optionEquals(e, t) {
      if (e === "controlPoints") {
        var _i15 = this._options.controlPoints;

        for (var _r6 = 0, _o18 = _i15.length; _r6 < _o18; _r6++) {
          if (!_i15[_r6].getPosition().equals(t[_r6])) return !1;
        }

        return !0;
      }

      return _get(_getPrototypeOf(wc.prototype), "_optionEquals", this).call(this, e, t);
    }
  }, {
    key: "render",
    value: function render(e) {
      var _this$_options24 = this._options,
          t = _this$_options24.controlPoints,
          i = _this$_options24.size;
      if (t.length < 2) return;
      var r = this.getBrush(),
          o = r && r.getHardness ? r.getHardness() : 1;
      T.ensureCanvasDimensions(this._canvas, e), (!this._brush || this._lastBrushSize !== i || !e.equals(this._brushInputDimensions)) && (this._brushInputDimensions = e.clone(), this._lastBrushSize = i);
      var n, a, l, c;

      for (var _u17 = 0; _u17 < t.length; _u17++) {
        n = t[_u17 - 2], a = t[_u17 - 1], l = t[_u17], c = t[_u17 + 1], l.renderToCanvas(this._options.brush.getBrushImage(e), this._canvas, n, a, c, o);
      }
    }
  }, {
    key: "_createBrush",
    value: function _createBrush(e) {
      var _this$_options25 = this._options,
          t = _this$_options25.size,
          i = _this$_options25.hardness,
          r = _this$_options25.color,
          o = T.createCanvas();
      o.width = o.height = Math.ceil(t * e.min());
      var n = o.getContext("2d");
      if (r = r.clone(), r.a = 1, o.width === 1) n.fillStyle = r.toRGBA(), n.fillRect(0, 0, 1, 1);else {
        var _a10 = n.createRadialGradient(o.width / 2, o.height / 2, Math.min(o.width / 2 - 1, o.width / 2 * i), o.width / 2, o.height / 2, o.width / 2);

        _a10.addColorStop(0, r.toRGBA());

        var _l15 = r.clone();

        _l15.a = 0, _a10.addColorStop(1, _l15.toRGBA()), n.fillStyle = _a10, n.fillRect(0, 0, o.width, o.height);
      }
      return o;
    }
  }, {
    key: "addControlPoint",
    value: function addControlPoint(e) {
      var t = new oh(this, e);
      this._options.controlPoints.push(t), this.emit("update", this);
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this._canvas;
    }
  }, {
    key: "setCanvas",
    value: function setCanvas(e) {
      this._canvas = e, this._context = e.getContext("2d");
    }
  }, {
    key: "setDirty",
    value: function setDirty() {
      this._context.clearRect(0, 0, this._canvas.width, this._canvas.height), this._options.controlPoints.forEach(function (e) {
        e.setDirty();
      });
    }
  }, {
    key: "forEachControlPoint",
    value: function forEachControlPoint(e) {
      this._options.controlPoints.forEach(e);
    }
  }, {
    key: "renderToCanvas",
    value: function renderToCanvas(e) {
      var t = e.getContext("2d");
      t.save(), t.globalAlpha = this._options.brush.getColor().a, t.drawImage(this._canvas, 0, 0), t.restore();
    }
  }, {
    key: "getCanvasDimensions",
    value: function getCanvasDimensions() {
      return this._canvasDimensions;
    }
  }]);

  return wc;
}(V);

wc.prototype.availableOptions = {
  id: {
    type: m.STRING,
    default: function _default() {
      return T.getUUID();
    }
  },
  brush: {
    type: m.OBJECT,
    required: !0
  },
  controlPoints: {
    type: m.ARRAY,
    default: []
  },
  closed: {
    type: m.BOOLEAN,
    default: !1
  }
};
var Os = wc;

var qo = I.Vector2,
    Mi =
/*#__PURE__*/
function (_It) {
  _inherits(Mi, _It);

  function Mi() {
    var _getPrototypeOf71;

    var _this152;

    _classCallCheck(this, Mi);

    for (var _len80 = arguments.length, e = new Array(_len80), _key80 = 0; _key80 < _len80; _key80++) {
      e[_key80] = arguments[_key80];
    }

    _this152 = _possibleConstructorReturn(this, (_getPrototypeOf71 = _getPrototypeOf(Mi)).call.apply(_getPrototypeOf71, [this].concat(e)));
    _this152._persistedPaths = [], _this152._outputCanvasDirty = !0, _this152._outputCanvas = T.createCanvas(), _this152._outputContext = _this152._outputCanvas.getContext("2d"), _this152._persistCanvas = T.createCanvas(), _this152._persistContext = _this152._persistCanvas.getContext("2d"), _this152._nextCanvas = T.createCanvas(), _this152._texture = k.Texture.fromCanvas(_this152._outputCanvas), _this152._sprite.setTexture(_this152._texture), _this152._onPathUpdate = _this152._onPathUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this152)));
    return _this152;
  }

  _createClass(Mi, [{
    key: "applyFlip",
    value: function applyFlip(e) {
      this._options.paths.forEach(function (t) {
        t.forEachControlPoint(function (i) {
          var r = i.getPosition().clone();

          switch (e) {
            case "horizontal":
              r.x = 1 - r.x;
              break;

            case "vertical":
              r.y = 1 - r.y;
              break;
          }

          i.setPosition(r);
        }), t.setDirty(!0);
      }), this._reset();
    }
  }, {
    key: "applyRotation",
    value: function applyRotation(e) {
      this._options.paths.forEach(function (t) {
        t.forEachControlPoint(function (i) {
          var r = i.getPosition().clone();
          e === 90 ? (r.flip(), r.x = 1 - r.x) : e === -90 && (r.flip(), r.y = 1 - r.y), i.setPosition(r);
        }), t.setDirty(!0);
      }), this._reset();
    }
  }, {
    key: "applyTransform",
    value: function applyTransform(e) {
      var t = null;
      this._options.paths.forEach(function (i) {
        i.forEachControlPoint(function (o) {
          o.setPosition(e.applyToRelativePoint(o.getPosition()));
        });
        var r = i.getBrush();
        r !== t && (r.setSize(e.applyToRelativeSize(r.getSize())), t = r), i.setDirty(!0);
      }), this._reset();
    }
  }, {
    key: "clearCanvas",
    value: function clearCanvas() {
      if (!this._outputCanvas) return;
      this._outputCanvasDirty = !0;
      var _this$_outputCanvas = this._outputCanvas,
          e = _this$_outputCanvas.width,
          t = _this$_outputCanvas.height;

      this._outputContext.clearRect(0, 0, e, t);
    }
  }, {
    key: "clearPersistCanvas",
    value: function clearPersistCanvas() {
      if (!this._persistCanvas) return;
      var _this$_persistCanvas = this._persistCanvas,
          e = _this$_persistCanvas.width,
          t = _this$_persistCanvas.height;

      this._persistContext.clearRect(0, 0, e, t);
    }
  }, {
    key: "serializeOptions",
    value: function serializeOptions(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      var i = _get(_getPrototypeOf(Mi.prototype), "serializeOptions", this).call(this, e, t);

      return e || (i.type = "brush"), i;
    }
  }, {
    key: "serializeOption",
    value: function serializeOption(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return e === "paths" ? this._options.paths.map(function (i) {
        return i.serializeOptions(void 0, t);
      }) : _get(_getPrototypeOf(Mi.prototype), "serializeOption", this).call(this, e, t);
    }
  }, {
    key: "createPath",
    value: function createPath(e) {
      var t = new Os(this._operation, {
        brush: e
      }, this._nextCanvas);
      return t.on("update", this._onPathUpdate), this._options.paths.push(t), this.setDirty(!0), t;
    }
  }, {
    key: "_onPathUpdate",
    value: function _onPathUpdate() {
      this._operation.setDirty(!0), this.setDirty(!0);
    }
  }, {
    key: "_onPathPersist",
    value: function _onPathPersist(e) {
      e.renderToCanvas(this._persistCanvas), this._nextCanvas = e.getCanvas(), this._nextCanvas.getContext("2d").clearRect(0, 0, this._nextCanvas.width, this._nextCanvas.height), this._persistedPaths.push(e);
    }
  }, {
    key: "_getTexture",
    value: function _getTexture() {
      return this._texture;
    }
  }, {
    key: "setDirtyForRenderer",
    value: function setDirtyForRenderer(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      _get(_getPrototypeOf(Mi.prototype), "setDirtyForRenderer", this).call(this, e, t, i), e && i && (this._persistedPaths = [], this.clearPersistCanvas(), this._options.paths.forEach(function (r) {
        r.setDirty(!0);
      }));
    }
  }, {
    key: "setDirty",
    value: function setDirty(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      for (var _i16 in this._dirtiness) {
        this.setDirtyForRenderer(e, this._renderers[_i16], t);
      }
    }
  }, {
    key: "render",
    value: function render(e) {
      var _this153 = this;

      var t = this._operation.getSDK().getRenderer();

      !this.isDirtyForRenderer(t) || (T.ensureCanvasDimensions(this._outputCanvas, e), T.ensureCanvasDimensions(this._persistCanvas, e), this._options.paths.forEach(function (i) {
        i.render(e), i.getClosed() && _this153._persistedPaths.indexOf(i) === -1 && _this153._onPathPersist(i);
      }), this.clearCanvas(), this._outputContext.drawImage(this._persistCanvas, 0, 0), this._options.paths.forEach(function (i) {
        i.getClosed() || i.renderToCanvas(_this153._outputCanvas);
      }), this.setDirtyForRenderer(!1, t));
    }
  }, {
    key: "update",
    value: function update(e, t) {
      t && (T.ensureCanvasDimensions(this._outputCanvas, t), T.ensureCanvasDimensions(this._persistCanvas, t), this._texture.getBaseTexture().update()), this.render(t);
      var i = e.getRenderer();
      i.isOfType(U.WEBGL) && i.updateTexture(this._texture.getBaseTexture()), _get(_getPrototypeOf(Mi.prototype), "update", this).call(this, e, t);
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this._persistedPaths = [], this._operation && this._operation.setDirty(!0), this.setDirty(!0), this.clearCanvas(), this.clearPersistCanvas();
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      return this._outputCanvas;
    }
  }, {
    key: "_createRadialBrush",
    value: function _createRadialBrush() {
      return new Cc();
    }
  }, {
    key: "_getTempCanvas",
    value: function _getTempCanvas() {
      return this._nextCanvas;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Mi.prototype), "dispose", this).call(this), this._texture && this._texture.getBaseTexture().dispose();
    }
  }]);

  return Mi;
}(It);

Mi.prototype.availableOptions = {
  id: {
    type: m.STRING,
    default: function _default() {
      return T.getUUID();
    }
  },
  position: {
    type: m.VECTOR2,
    default: new qo(0, 0)
  },
  scale: {
    type: m.VECTOR2,
    default: new qo(1, 1)
  },
  anchor: {
    type: m.VECTOR2,
    default: new qo(0, 0)
  },
  pivot: {
    type: m.VECTOR2,
    default: new qo(0, 0)
  },
  rotation: {
    type: m.NUMBER,
    default: 0
  },
  paths: {
    type: m.ARRAY,
    default: [],
    setter: function setter(s) {
      var _this154 = this;

      return s = s.map(function (e) {
        if (e instanceof Os) return e;
        var t = e.brush,
            i = e.closed,
            r = new Os(_this154._operation, {
          brush: t,
          closed: i
        }, _this154._nextCanvas);
        return e.controlPoints.forEach(function (o) {
          r.addControlPoint(o);
        }), r;
      }), this._reset(), s;
    }
  }
};
Mi.type = "brush";
Mi.Brush = As;
Mi.Path = Os;
Mi.Brushes = {
  RadialBrush: Cc
};
var Li = Mi;

var nh = I.Vector2,
    Ps =
/*#__PURE__*/
function (_ee14) {
  _inherits(Ps, _ee14);

  function Ps() {
    var _getPrototypeOf72;

    var _this155;

    _classCallCheck(this, Ps);

    for (var _len81 = arguments.length, e = new Array(_len81), _key81 = 0; _key81 < _len81; _key81++) {
      e[_key81] = arguments[_key81];
    }

    _this155 = _possibleConstructorReturn(this, (_getPrototypeOf72 = _getPrototypeOf(Ps)).call.apply(_getPrototypeOf72, [this].concat(e)));

    var t = _this155._sdk.getRenderer();

    _this155._lastBlurRadius = null, _this155._blurredRenderTexture = new k.RenderTexture(t, 100, 100, 1), _this155._maskRenderTexture = new k.RenderTexture(t, 100, 100, 1), _this155._brushSprite = new Li(_assertThisInitialized(_assertThisInitialized(_this155))), _this155._brushSpriteContainer = new k.Container();

    var i = _this155._brushSprite.getDisplayObject();

    if (_this155._brushSpriteContainer.addChild(i), _this155._outputSprite = new k.Sprite(), _this155._outputContainer = new k.Container(), _this155._outputContainer.addChild(_this155._outputSprite), _this155._maskFilter = new ih(), t.isOfType(U.WEBGL)) {
      _this155._horizontalFilter = new Je(), _this155._verticalFilter = new Je(), _this155._sprite.setFilters([_this155._horizontalFilter, _this155._verticalFilter]), _this155._horizontalFilter.setDelta(new nh(1, 1)), _this155._verticalFilter.setDelta(new nh(-1, 1));

      var _r7 = _this155._maskRenderTexture.getBaseTexture();

      _r7.setGLUnit(_this155._maskFilter.getMaskImage()), t.updateTexture(_r7, !1), _r7 = _this155._blurredRenderTexture.getBaseTexture(), _r7.setGLUnit(_this155._maskFilter.getFilterImage()), t.updateTexture(_r7, !1);
    } else t.isOfType(U.CANVAS) && (_this155._blurFilter = new Je(), _this155._sprite.setFilters([_this155._blurFilter]), _this155._maskFilter.setMaskCanvas(_this155._maskRenderTexture.getRenderTarget().getCanvas()), _this155._maskFilter.setFilterCanvas(_this155._blurredRenderTexture.getRenderTarget().getCanvas()));

    _this155._outputSprite.setFilters([_this155._maskFilter]);

    return _this155;
  }

  _createClass(Ps, [{
    key: "flip",
    value: function flip(e) {
      this._brushSprite.applyFlip(e), this.setDirty(!0, !0), this._lastBlurRadius = null;
    }
  }, {
    key: "rotate",
    value: function rotate(e) {
      this._brushSprite.applyRotation(e), this.setDirty(!0, !0), this._lastBlurRadius = null;
    }
  }, {
    key: "transform",
    value: function transform(e, t) {
      this._brushSprite.applyTransform(e, t), this.setDirty(!0, !0), this._lastBlurRadius = null;
    }
  }, {
    key: "_render",
    value: function _render(e) {
      return this._renderBlur(e), this._renderMask(e), this._outputSprite.setTexture(e), this._renderTexture.render(this._outputContainer), Promise.resolve();
    }
  }, {
    key: "_renderMask",
    value: function _renderMask(e) {
      var t = e.getDimensions();
      this._maskRenderTexture.getDimensions().equals(t) || this._maskRenderTexture.resizeTo(t), this._brushSprite.update(this._sdk, t), this._maskRenderTexture.clear(R.BLACK), this._maskRenderTexture.render(this._brushSpriteContainer);

      var r = this._sdk.getRenderer();

      r.isOfType(U.WEBGL) && r.updateTexture(this._maskRenderTexture.getBaseTexture(), !1);
    }
  }, {
    key: "_renderBlur",
    value: function _renderBlur(e) {
      var t = e.getDimensions(),
          i = this._blurredRenderTexture.getDimensions();

      i.equals(t) || this._blurredRenderTexture.resizeTo(t);
      var r = this._options.blurRadius;

      if (this._lastBlurRadius !== r || !i.equals(t)) {
        var _n12 = this._sdk.getRenderer(),
            _a11;

        if (_n12.isOfType(U.WEBGL)) {
          var _l16 = t.min();

          _a11 = {
            blurRadius: r * _l16,
            texSize: t
          }, this._horizontalFilter.set(_a11), this._verticalFilter.set(_a11);
        } else _n12.isOfType(U.CANVAS) && (_a11 = {
          blurRadius: r
        }, this._blurFilter.set(_a11));

        this._blurredRenderTexture.render(this._container), this._lastBlurRadius = r;
      }

      var o = this._sdk.getRenderer();

      o.isOfType(U.WEBGL) && o.updateTexture(this._blurredRenderTexture.getBaseTexture(), !1);
    }
  }, {
    key: "getBrush",
    value: function getBrush() {
      return this._brushSprite;
    }
  }, {
    key: "createPath",
    value: function createPath(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var i = new Li.Brushes.RadialBrush({
        size: e,
        hardness: t,
        color: R.WHITE
      }),
          r = this._brushSprite.createPath(i);

      return this._options.paths.push(r), this.setDirty(!0), r;
    }
  }, {
    key: "setDirtyForRenderer",
    value: function setDirtyForRenderer(e, t, i) {
      _get(_getPrototypeOf(Ps.prototype), "setDirtyForRenderer", this).call(this, e, t, i), this._brushSprite.setDirtyForRenderer(e, t, i);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Ps.prototype), "dispose", this).call(this), this._sdk.getRenderer().isOfType(U.WEBGL) ? (this._verticalFilter.dispose(), this._horizontalFilter.dispose()) : this._blurFilter.dispose(), this._brushSprite.dispose(), this._maskFilter.dispose(), this._blurredRenderTexture.dispose(), this._maskRenderTexture.dispose();
    }
  }, {
    key: "hasChanges",
    value: function hasChanges() {
      return !0;
    }
  }]);

  return Ps;
}(ee);

Ps.identifier = "selective-blur";
Ps.prototype.availableOptions = {
  blurRadius: {
    type: m.NUMBER,
    default: .05
  },
  paths: {
    type: m.ARRAY,
    default: [],
    setter: function setter(s) {
      return this._brushSprite && this._brushSprite.setPaths(s), s;
    }
  }
};
N.Operations.SelectiveBlurOperation = Ps;
var ah = Ps;

var zi = I.Vector2,
    Ko = I.ColorMatrix,
    Xo =
/*#__PURE__*/
function (_It2) {
  _inherits(Xo, _It2);

  function Xo() {
    var _getPrototypeOf73;

    var _this156;

    _classCallCheck(this, Xo);

    for (var _len82 = arguments.length, e = new Array(_len82), _key82 = 0; _key82 < _len82; _key82++) {
      e[_key82] = arguments[_key82];
    }

    _this156 = _possibleConstructorReturn(this, (_getPrototypeOf73 = _getPrototypeOf(Xo)).call.apply(_getPrototypeOf73, [this].concat(e)));
    var t = _this156._options.image,
        i = t.src || t.filePath || t.toDataUrl && t.toDataURL();
    _this156._isSVG = i && (!!i.match(/\w+\.svg(?=\?|$)/i) || i.match(/data:image\/svg/i)), _this156._isSVG && (_this156._canvas = T.createCanvas(), _this156._context = _this156._canvas.getContext("2d"), _this156._options.smoothDownscaling = !1), t && _this156._onImageUpdate(), _this156._tintFilter = new k.Filters.TintFilter(), _this156._adjustmentsFilter = new mo(), _this156._lastRenderedDimensions = zi.NULL, _this156._lastRenderedInputDimensions = zi.NULL, _this156._onOptionsChange = _this156._onOptionsChange.bind(_assertThisInitialized(_assertThisInitialized(_this156))), _this156._options.adjustments.on("update", _this156._onOptionsChange);
    return _this156;
  }

  _createClass(Xo, [{
    key: "applyScale",
    value: function applyScale(e) {
      this.setDimensions(this.getDimensions().multiply(e));
    }
  }, {
    key: "serializeOptions",
    value: function serializeOptions(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      var i = _get(_getPrototypeOf(Xo.prototype), "serializeOptions", this).call(this, e, t);

      return e || (i.type = "sticker"), i;
    }
  }, {
    key: "_rendersToRenderTexture",
    value: function _rendersToRenderTexture(e) {
      return this._options.smoothDownscaling && !this._isSVG && e.getRenderer().isOfType(U.WEBGL) || this._hasAdjustments() || this._options.tintMode !== "none";
    }
  }, {
    key: "_getTexture",
    value: function _getTexture() {
      return this._inputTexture;
    }
  }, {
    key: "update",
    value: function update(e, t) {
      var _this$_options26 = this._options,
          i = _this$_options26.dimensions,
          r = _this$_options26.image;

      if (i.equals(zi.NULL) && i.set(r.width, r.height), this._sprite.setSmoothDownscaling(this._isSVG ? !1 : this.getSmoothDownscaling()), (!this._lastRenderedInputDimensions.equals(t) || !this._lastRenderedDimensions.equals(i) || this._lastRenderedImage !== r) && this._isSVG && e.getRenderer().isOfType(U.WEBGL)) {
        r.width = Math.round(i.x), r.height = Math.round(i.y);

        var _a12 = 4096,
            _l17 = r.width / r.height;

        r.width > _a12 && (r.width = _a12, r.height = Math.round(r.width / _l17)), r.height > _a12 && (r.height = _a12, r.width = Math.round(r.height * _l17)), this._canvas.width = r.width, this._canvas.height = r.height, this._context.clearRect(0, 0, r.width, r.height), this._context.drawImage(r, 0, 0, r.width, r.height), this._inputTexture.getBaseTexture().update();
      }

      this._rendersToRenderTexture(e) && this._prepareRenderTexture(e);
      var n = [];

      if (this._rendersToRenderTexture(e)) {
        if (this._hasAdjustments()) {
          n.push(this._adjustmentsFilter);

          var _a13 = this._options.adjustments,
              _l18 = new Ko();

          _l18.multiply(Ko.createBrightnessMatrix(_a13.getBrightness())), _l18.multiply(Ko.createSaturationMatrix(_a13.getSaturation())), _l18.multiply(Ko.createContrastMatrix(_a13.getContrast())), this._adjustmentsFilter.set({
            colorMatrix: _l18
          });
        }

        this._options.tintMode && this._options.tintMode !== "none" && (n.push(this._tintFilter), this._tintFilter.set({
          mode: k.Filters.TintFilter.MODES[this._options.tintMode.toUpperCase()],
          color: this._options.tintColor
        }), this._sprite.getTexture() && this._sprite.getTexture()._baseTexture && this._sprite.getTexture()._baseTexture.setDirty(!0)), this._renderTextureSprite.setFilters(n);
      }

      this._rendersToRenderTexture(e) ? this._renderToRenderTexture(e) : this._sprite.setTexture(this._inputTexture), this._updateSprite(t), this._applyFlip(), this._lastRenderedDimensions.copy(i), this._lastRenderedInputDimensions.copy(t), this._lastRenderedImage = r;
    }
  }, {
    key: "_applyFlip",
    value: function _applyFlip() {
      var e = this._sprite.getScale(),
          _this$_options27 = this._options,
          t = _this$_options27.flipHorizontally,
          i = _this$_options27.flipVertically;

      (t && e.x > 0 || !t && e.x < 0) && (e.x *= -1), (i && e.y > 0 || !i && e.y < 0) && (e.y *= -1), this._sprite.setScale(e);
    }
  }, {
    key: "applyFlip",
    value: function applyFlip(e) {
      _get(_getPrototypeOf(Xo.prototype), "applyFlip", this).call(this, e);

      var t = {
        rotation: this._options.rotation
      },
          r = t.rotation / Math.PI * 180 * -1;

      switch (t.rotation = r * Math.PI / 180, e) {
        case "horizontal":
          t.flipHorizontally = !this._options.flipHorizontally, this.set(t);
          break;

        case "vertical":
          t.flipVertically = !this._options.flipVertically, this.set(t);
          break;
      }
    }
  }, {
    key: "_hasAdjustments",
    value: function _hasAdjustments() {
      var e = this._options.adjustments;
      return e.getBrightness() !== 0 || e.getSaturation() !== 1 || e.getContrast() !== 1;
    }
  }, {
    key: "_onImageUpdate",
    value: function _onImageUpdate() {
      var e = this._options.image,
          t = this._operation.getSDK().getRenderer();

      this._isSVG && t.isOfType(U.WEBGL) && (e = this._canvas), this._inputTexture && (this._inputTexture.dispose(), this._inputTexture = null), this._inputTexture = k.Texture.fromImage(e), this._identitySprite.setTexture(this._inputTexture), this._sprite.setTexture(this._inputTexture), this._renderTexture && (this._renderTextureSprite.setTexture(this._inputTexture), this._renderTexture.resizeTo(this._inputTexture.getDimensions())), this.setDirty(!0);
    }
  }, {
    key: "scalesUniformly",
    value: function scalesUniformly() {
      return this._options.resizeMode === "keepAspect";
    }
  }, {
    key: "setOption",
    value: function setOption(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      _get(_getPrototypeOf(Xo.prototype), "setOption", this).call(this, e, t, i), e === "image" && this._identitySprite && this._onImageUpdate();
    }
  }, {
    key: "_onOptionsChange",
    value: function _onOptionsChange() {
      var e = this._dirtiness;

      for (var _t25 in e) {
        e[_t25] = !0;
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Xo.prototype), "dispose", this).call(this), this._inputTexture && (this._inputTexture.dispose(), this._inputTexture = null), this._tintFilter.dispose(), this._adjustmentsFilter.dispose(), this._options.adjustments.off("updated", this._onOptionsChange);
    }
  }]);

  return Xo;
}(It);

Xo.prototype.availableOptions = {
  id: {
    type: m.STRING,
    default: function _default() {
      return T.getUUID();
    }
  },
  identifier: {
    type: m.STRING,
    default: ""
  },
  image: {
    type: m.IMAGE,
    required: !0
  },
  position: {
    type: m.VECTOR2,
    default: zi.NULL
  },
  dimensions: {
    type: m.VECTOR2,
    default: zi.NULL
  },
  anchor: {
    type: m.VECTOR2,
    default: new zi(0, 0)
  },
  pivot: {
    type: m.VECTOR2,
    default: new zi(.5, .5)
  },
  rotation: {
    type: m.NUMBER,
    default: 0
  },
  flipHorizontally: {
    type: m.BOOLEAN,
    default: !1
  },
  flipVertically: {
    type: m.BOOLEAN,
    default: !1
  },
  smoothDownscaling: {
    type: m.BOOLEAN,
    default: !1
  },
  tintColor: {
    type: m.COLOR,
    default: R.WHITE
  },
  tintMode: {
    type: m.STRING,
    default: "none",
    available: ["none", "solid", "colorized"]
  },
  resizeMode: {
    type: m.STRING,
    default: "keepAspect",
    available: ["keepAspect", "unrestricted"]
  },
  alpha: {
    type: m.NUMBER,
    default: 1
  },
  adjustments: {
    type: m.CONFIGURABLE,
    structure: {
      brightness: {
        type: m.NUMBER,
        default: 0
      },
      saturation: {
        type: m.NUMBER,
        default: 1
      },
      contrast: {
        type: m.NUMBER,
        default: 1
      }
    }
  }
};
Xo.type = "sticker";
var Qo = Xo;

var Ot =
/*#__PURE__*/
function () {
  function Ot(e) {
    _classCallCheck(this, Ot);

    this._seed = e === void 0 ? Ot.TimeSeed() : e;
  }

  _createClass(Ot, [{
    key: "seed",
    value: function seed(e) {
      this._seed = e === void 0 ? Ot.TimeSeed() : e;
    }
  }, {
    key: "next",
    value: function next() {
      var e = this._seed | 0,
          t = e / Ot.SEED_DIVIDER | 0,
          i = e % Ot.SEED_DIVIDER | 0;
      return e = Ot.SEED_LOW_MULTIPLY * i - Ot.SEED_HIGH_MULTIPLY * t, e <= 0 && (e += Ot.MAX), e === -1 && (e = Ot.MAX - 1), this._seed = e, e;
    }
  }, {
    key: "nextInRange",
    value: function nextInRange(e, t) {
      return t === void 0 && (t = e, e = 0), e + this.next() % (t - e + 1);
    }
  }, {
    key: "nextBool",
    value: function nextBool() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return this.nextInRange(e + t - 1) >= e;
    }
  }, {
    key: "pickNext",
    value: function pickNext(e) {
      return Array.isArray(e) ? e[this.next() % e.length] : null;
    }
  }], [{
    key: "TimeSeed",
    value: function TimeSeed() {
      return Date.now();
    }
  }]);

  return Ot;
}(),
    Z = Ot;

S(Z, "MAX", 2147483647), S(Z, "SEED_DIVIDER", 127773), S(Z, "SEED_LOW_MULTIPLY", 16807), S(Z, "SEED_HIGH_MULTIPLY", 2836);

var C_ = I.Rectangle,
    pe =
/*#__PURE__*/
function () {
  function pe() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, pe);

    this.width = e, this.height = t;
  }

  _createClass(pe, [{
    key: "set",
    value: function set(e, t) {
      this.width = e, this.height = t;
    }
  }, {
    key: "aspect",
    value: function aspect() {
      return this.width / this.height;
    }
  }, {
    key: "rectangle",
    value: function rectangle(e, t) {
      return new C_(e, t, this.width, this.height);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new pe(this.width, this.height);
    }
  }, {
    key: "scale",
    value: function scale(e, t) {
      return t === void 0 && (t = e), this.width *= e, this.height *= t, this;
    }
  }, {
    key: "copy",
    value: function copy(e) {
      return this.width = e.width, this.height = e.height, this;
    }
  }, {
    key: "fitInWidthWithOther",
    value: function fitInWidthWithOther(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new pe();
      return this.copy(pe.fitTwoInWidth(e, this, t)[0]), this;
    }
  }], [{
    key: "fitTwoInWidth",
    value: function fitTwoInWidth(e, t, i) {
      var r = t.width * i.height + t.height * i.width,
          o = i.height * e / r,
          n = t.width * o,
          a = t.height * o;
      return [new pe(n, a), new pe(e - n, a)];
    }
  }]);

  return pe;
}();

var gh = Te(Ct()),
    kc =
/*#__PURE__*/
function (_V9) {
  _inherits(kc, _V9);

  function kc() {
    _classCallCheck(this, kc);

    return _possibleConstructorReturn(this, _getPrototypeOf(kc).apply(this, arguments));
  }

  _createClass(kc, [{
    key: "loadImages",
    value: function loadImages(e) {
      return mt(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this157 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", gh.default(e, function (t) {
                  return mt(_this157, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee3() {
                    return _regeneratorRuntime.wrap(function _callee3$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            return _context4.abrupt("return", this.addImage(t.path, t.fullPath, t.image));

                          case 1:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee3, this);
                  }));
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4);
      }));
    }
  }, {
    key: "addImage",
    value: function addImage(e, t, i) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "anonymous";
      var o = this.getImages();
      return i ? (o[e] = {
        fullPath: t,
        image: i
      }, Promise.resolve({
        fullPath: t,
        image: i
      })) : new Promise(function (n, a) {
        i = new $e(), i.onload = function () {
          o[e] = {
            fullPath: t,
            image: i
          }, n({
            fullPath: t,
            image: i
          });
        }, i.crossOrigin = T.getCrossOriginValue(r), i.onerror = a, i.src = t;
      });
    }
  }, {
    key: "getImage",
    value: function getImage(e) {
      var i = this.getImages()[e];
      return i ? i.image : null;
    }
  }, {
    key: "getVariation",
    value: function getVariation(e) {
      return this.getFonts()[e];
    }
  }, {
    key: "addFont",
    value: function addFont(e, t) {
      var i = this.getFonts();
      return i[e] = t, t;
    }
  }]);

  return kc;
}(V);

kc.prototype.availableOptions = {
  images: {
    type: m.OBJECT,
    default: {}
  },
  fonts: {
    type: m.OBJECT,
    default: {}
  }
};
var re = new kc();

var E_ = function E_(s, e, t, i) {
  var r = t * (i * 4) + e * 4;
  return {
    r: s[r],
    g: s[r + 1],
    b: s[r + 2],
    a: s[r + 3]
  };
},
    S_ = function S_(s) {
  return s.a <= 254;
},
    fh = function fh(s, e, t) {
  var i = !0;

  for (var _r8 = 0; _r8 < t; _r8++) {
    var _o19 = E_(s, _r8, e, t);

    if (!S_(_o19)) {
      i = !1;
      break;
    }
  }

  return i;
},
    A_ = function A_(s, e, t, i) {
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
  var o = 0;

  for (var _n13 = i + 1; _n13 < t; _n13++) {
    if (!fh(s, _n13, e)) o = _n13 - i + 1;else if (r) break;
  }

  return o;
},
    I_ = function I_(s, e, t, i) {
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
  var o = 0;

  for (var _n14 = i - 1; _n14 >= 0; _n14--) {
    if (!fh(s, _n14, e)) o = i - _n14;else if (r) break;
  }

  return o;
},
    O_ = function O_(s, e, t, i, r) {
  s.beginPath(), s.moveTo(e, t), s.lineTo(i, r), s.stroke();
},
    P_ = function P_(s, e, t, i) {
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "red";
  s.save(), s.strokeStyle = r, O_(s, t, e, i, e), s.restore();
},
    B_ = function B_(s, e, t, i, r) {
  var o = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "blue";
  s.save(), s.strokeStyle = o, s.strokeRect(e, t, i, r), s.restore();
},
    Ye =
/*#__PURE__*/
function (_V10) {
  _inherits(Ye, _V10);

  function Ye(e) {
    var _this158;

    _classCallCheck(this, Ye);

    _this158 = _possibleConstructorReturn(this, _getPrototypeOf(Ye).call(this, e));
    var t = re.getVariation(_this158.getFontIdentifier());
    t || A.warn("TextDesignFont: Unable to find font '".concat(_this158._fontIdentifier, "'")), _this158.set({
      fontVariation: t
    }), _this158._metrics = null, _this158._canvas = T.createCanvas(), _this158._context = _this158._canvas.getContext("2d"), _this158._isDirty = !0;
    return _this158;
  }

  _createClass(Ye, [{
    key: "_onOptionsChange",
    value: function _onOptionsChange() {
      this._isDirty = !0;
    }
  }, {
    key: "setOption",
    value: function setOption(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      _get(_getPrototypeOf(Ye.prototype), "setOption", this).call(this, e, t, i, r), e === "fontIdentifier" && !r && this.updateFontVariation();
    }
  }, {
    key: "updateFontVariation",
    value: function updateFontVariation() {
      var e = re.getVariation(this.getFontIdentifier());
      return e || A.warn("TextDesignFont: Unable to find font '".concat(this._fontIdentifier, "'")), this.setFontVariation(e), e;
    }
  }, {
    key: "setOptions",
    value: function setOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._options = C(C({}, this._options), e), this._isDirty = !0;
    }
  }, {
    key: "_applyTextOptions",
    value: function _applyTextOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._context;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _C = C(C({}, this._options), t),
          i = _C.fontSize,
          r = _C.fontVariation,
          o = _C.lineHeight,
          n = _C.textColor,
          a = _C.alignment,
          _r$serializeOptions = r.serializeOptions(),
          l = _r$serializeOptions.fontStyle,
          c = _r$serializeOptions.fontWeight,
          u = _r$serializeOptions.fontFamily;

      e.font = "".concat(l, " ").concat(c, " ").concat(i, "px / ").concat(o, " ").concat(u), e.fillStyle = n, e.textBaseline = "alphabetic", e.textAlign = a || "left";
    }
  }, {
    key: "getTextMetrics",
    value: function getTextMetrics() {
      return (!this._metrics || this._isDirty) && this._calculateTextMetrics(), C({}, this._metrics);
    }
  }, {
    key: "getSizeValue",
    value: function getSizeValue() {
      return (!this._metrics || this._isDirty) && this._calculateTextMetrics(), new pe(this._metrics.width, this._metrics.height);
    }
  }, {
    key: "fitWidth",
    value: function fitWidth(e) {
      if (!this.getFontVariation()) {
        A.warn("TextDesignFont#fitText: missing font variation");
        return;
      }

      this._applyTextOptions(this._context, {
        fontSize: 50
      });

      var i = this._context.measureText(this.getText()).width,
          r = e / i,
          o = Math.floor(r * 50);

      return this.setFontSize(o), this._calculateTextMetrics(), this.getTextMetrics();
    }
  }, {
    key: "fitHeight",
    value: function fitHeight(e) {
      if (!this.getFontVariation()) {
        A.warn("TextDesignFont#fitText: missing font variation");
        return;
      }

      var i = this._calculateTextMetrics({
        fontSize: 50
      }).height,
          r = e / i,
          o = Math.floor(r * 50);

      return this.setFontSize(o), this._calculateTextMetrics(), this.getTextMetrics();
    }
  }, {
    key: "_calculateTextMetrics",
    value: function _calculateTextMetrics() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = this._canvas,
          i = this._context,
          r = C(C({}, this._options), e),
          o = this.getText();

      this._applyTextOptions(i, r);

      var n = Math.ceil(i.measureText(o).width),
          a = Math.floor(n + r.fontSize * 2),
          l = Math.floor(r.fontSize * 3);
      t.width = a, t.height = l;
      var c = Math.floor(r.fontSize),
          u = Math.floor(l * (3 / 5));
      this._applyTextOptions(i, r), i.fillText(o, c, u);
      var p = i.getImageData(0, 0, t.width, t.height).data,
          h = I_(p, a, l, u, this._options.excludeAccents),
          d = A_(p, a, l, u, this._options.excludeAccents),
          g = n,
          y = h + d;
      return this._metrics = {
        width: g,
        height: y,
        ascender: h,
        descender: d
      }, this._isDirty = !1, C({}, this._metrics);
    }
  }, {
    key: "draw",
    value: function draw() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._context;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var r = arguments.length > 3 ? arguments[3] : undefined;
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
      e.save(), (!this._metrics || this._isDirty) && this._calculateTextMetrics(), this._applyTextOptions(e, r), e.fillText(this.getText(), t, i + this._metrics.ascender), o && (B_(e, t, i, this._metrics.width, this._metrics.height), P_(e, i + this._metrics.ascender, t, t + this._metrics.width)), e.restore();
    }
  }]);

  return Ye;
}(V);

Ye.prototype.availableOptions = {
  text: {
    type: m.STRING,
    default: ""
  },
  fontIdentifier: {
    type: m.STRING,
    default: "imgly_font_open_sans_bold"
  },
  fontVariation: {
    type: m.OBJECT,
    default: null
  },
  lineHeight: {
    type: m.NUMBER,
    default: 1
  },
  fontSize: {
    type: m.NUMBER,
    default: 22
  },
  textColor: {
    type: m.STRING,
    default: "black"
  },
  strokeStyle: {
    type: m.STRING,
    default: "black"
  },
  outlineWidth: {
    type: m.NUMBER,
    default: 0
  },
  textBaseline: {
    type: m.STRING,
    default: "alphabetic"
  },
  excludeAccents: {
    type: m.BOOLEAN,
    default: !1
  }
};

var qe =
/*#__PURE__*/
function (_V11) {
  _inherits(qe, _V11);

  function qe() {
    _classCallCheck(this, qe);

    return _possibleConstructorReturn(this, _getPrototypeOf(qe).apply(this, arguments));
  }

  return qe;
}(V);

qe.prototype.availableOptions = {
  text: {
    type: m.STRING,
    default: ""
  },
  frame: {
    type: m.OBJECT,
    default: null
  },
  font: {
    type: m.OBJECT,
    default: null
  }
};

var ft =
/*#__PURE__*/
function (_V12) {
  _inherits(ft, _V12);

  function ft() {
    _classCallCheck(this, ft);

    return _possibleConstructorReturn(this, _getPrototypeOf(ft).apply(this, arguments));
  }

  return ft;
}(V);

ft.prototype.availableOptions = {
  tintColor: {
    type: m.COLOR,
    default: R.BLACK
  },
  textColor: {
    type: m.COLOR,
    default: R.BLACK
  },
  alignment: {
    type: m.STRING,
    default: "left",
    available: ["left", "center", "right"]
  },
  lineSpacing: {
    type: m.NUMBER,
    default: 1
  },
  fontIdentifier: {
    type: m.STRING,
    default: "imgly_font_open_sans_bold"
  }
};

var M_ = I.Rectangle,
    it =
/*#__PURE__*/
function (_V13) {
  _inherits(it, _V13);

  function it(e) {
    var _this159;

    _classCallCheck(this, it);

    _this159 = _possibleConstructorReturn(this, _getPrototypeOf(it).call(this, e));
    _this159.setSize(new pe(_this159.getWidth(), 0)), _this159.serverImageSmoothingFix = !1;
    return _this159;
  }

  _createClass(it, [{
    key: "_getFrame",
    value: function _getFrame() {
      var e = this.getSize();
      return new M_(0, 0, e.width, e.height);
    }
  }, {
    key: "_getTextFrame",
    value: function _getTextFrame() {
      return this._getFrame();
    }
  }, {
    key: "_getTextFrameForElement",
    value: function _getTextFrameForElement(e) {
      return e.getFrame().clone();
    }
  }, {
    key: "_calculateLayoutElements",
    value: function _calculateLayoutElements() {
      A.warn("TextDesignRow is an abstract class.");
    }
  }, {
    key: "_getLayoutElements",
    value: function _getLayoutElements() {
      return this._options.elements.length <= 0 && this.layout(), this.getElements();
    }
  }, {
    key: "_fontSize",
    value: function _fontSize(e) {
      return A.warn("TextDesignRow#_fontSize not implemented. @TODO: Is it necessary?"), 0;
    }
  }, {
    key: "layout",
    value: function layout() {
      return this.setElements(this._calculateLayoutElements()), this;
    }
  }, {
    key: "textFrame",
    value: function textFrame(e, t) {
      return e.getFrame().clone();
    }
  }, {
    key: "willRender",
    value: function willRender(e) {}
  }, {
    key: "didRender",
    value: function didRender(e) {}
  }, {
    key: "render",
    value: function render(e) {
      var _this160 = this;

      e.save(), this._getLayoutElements().forEach(function (t) {
        var _t$serializeOptions = t.serializeOptions(),
            i = _t$serializeOptions.text,
            r = _t$serializeOptions.frame,
            o = _t$serializeOptions.font,
            n = _this160.getAttributes();

        o.draw(e, r.x, r.y, {
          textColor: n.getTextColor().toRGBA(),
          alignment: n.getAlignment()
        });
      }), e.restore();
    }
  }]);

  return it;
}(V);

it.prototype.availableOptions = {
  words: {
    type: m.OBJECT,
    default: null
  },
  width: {
    type: m.NUMBER,
    default: 100
  },
  attributes: {
    type: m.CONFIGURABLE,
    default: new ft()
  },
  shearingAngle: {
    type: m.NUMBER,
    default: 0
  },
  elements: {
    type: m.ARRAY,
    default: []
  },
  size: {
    type: m.OBJECT,
    default: null
  }
};

var L_ = I.Rectangle,
    Bs =
/*#__PURE__*/
function (_it) {
  _inherits(Bs, _it);

  function Bs() {
    _classCallCheck(this, Bs);

    return _possibleConstructorReturn(this, _getPrototypeOf(Bs).apply(this, arguments));
  }

  _createClass(Bs, [{
    key: "_calculateLayoutElements",
    value: function _calculateLayoutElements() {
      if (this.getWords().size() <= 0) return [];

      var _this$serializeOption = this.serializeOptions(),
          e = _this$serializeOption.orientation,
          t = _this$serializeOption.width,
          i = _this$serializeOption.size,
          r = _this$serializeOption.relativeRowOffset,
          o = _this$serializeOption.attributes,
          n = o.fontIdentifier,
          a = this.getWords().joined(3),
          l = e === Bs.Orientations.Left ? [a[0], a[1], a[2]] : [a[1], a[2], a[0]],
          c = T.Array.range(0, 2).map(function (K) {
        return new Ye({
          text: l[K],
          fontIdentifier: n,
          fontSize: 60
        });
      }),
          u = c.map(function (K) {
        return K.getSizeValue();
      }),
          p = u[0].width > u[1].width ? 0 : 1,
          h = (p + 1) % 2;

      c[h].fitWidth(u[p].width), u[h] = c[h].getSizeValue();
      var d = (u[h].height + u[p].height) / (1 - r),
          g = new Ye({
        text: l[2],
        fontIdentifier: n
      });
      g.fitHeight(d);
      var y = g.getSizeValue().width,
          _ = u[p].width,
          f = t / (y + _),
          v = f * y,
          b = f * _,
          D = f * d,
          O = r * D;
      i.set(t, D);
      var x = T.Array.range(0, 3).map(function (K) {
        return new Ye({
          text: l[K],
          fontIdentifier: n
        });
      });
      x[0].fitWidth(b), x[1].fitWidth(b), x[2].fitWidth(v);
      var w = e === Bs.Orientations.Left ? 0 : v,
          z = e === Bs.Orientations.Left ? b : 0,
          L = [w, w, z],
          j = [0, x[0].getSizeValue().height + O, 0],
          X = x.map(function (K, G) {
        return new L_(L[G], j[G], K.getSizeValue().width, K.getSizeValue().height);
      });
      return x.map(function (K, G) {
        return new qe({
          text: l[G],
          font: x[G],
          frame: X[G]
        });
      });
    }
  }]);

  return Bs;
}(it),
    wt = Bs;

S(wt, "Orientations", {
  Right: "RIGHT",
  Left: "LEFT"
});
wt.prototype.availableOptions = C(C({}, it.prototype.availableOptions), {
  orientation: {
    type: m.STRING,
    default: wt.Orientations.Left,
    available: [wt.Orientations.Right, wt.Orientations.Left]
  },
  relativeRowOffset: {
    type: m.NUMBER,
    default: .05
  }
});

var z_ = I.Rectangle,
    Y =
/*#__PURE__*/
function () {
  function Y() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, Y);

    this.top = e, this.left = t, this.bottom = i, this.right = r;
  }

  _createClass(Y, [{
    key: "multiply",
    value: function multiply(e) {
      this.top *= e, this.left *= e, this.bottom *= e, this.right *= e;
    }
  }, {
    key: "toObject",
    value: function toObject() {
      return C({}, this);
    }
  }, {
    key: "equals",
    value: function equals(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return Math.abs(e.top - this.top) <= t && Math.abs(e.left - this.left) <= t && Math.abs(e.bottom - this.bottom) <= t && Math.abs(e.right - this.right) <= t;
    }
  }, {
    key: "scale",
    value: function scale() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      return t === void 0 && (t = e), this.top *= t, this.bottom *= t, this.left *= e, this.right *= e, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Y(this.top, this.left, this.bottom, this.right);
    }
  }, {
    key: "applyToRectangle",
    value: function applyToRectangle(e) {
      return new z_(e.x + this.left, e.y + this.top, e.width - this.left - this.right, e.height - this.top - this.bottom);
    }
  }], [{
    key: "ZERO",
    get: function get() {
      return new Y(0, 0, 0, 0);
    }
  }]);

  return Y;
}();

var ye =
/*#__PURE__*/
function (_it2) {
  _inherits(ye, _it2);

  function ye() {
    _classCallCheck(this, ye);

    return _possibleConstructorReturn(this, _getPrototypeOf(ye).apply(this, arguments));
  }

  _createClass(ye, [{
    key: "_calculateLayoutElements",
    value: function _calculateLayoutElements() {
      var _this$serializeOption2 = this.serializeOptions(),
          e = _this$serializeOption2.attributes,
          t = _this$serializeOption2.imageInsets,
          i = _this$serializeOption2.size,
          r = _this$serializeOption2.width,
          o = this.getWords().joined(1)[0] || "",
          n = e.fontIdentifier,
          a = new Ye({
        text: o,
        fontIdentifier: n
      });

      a.fitWidth(this._getTextFrame().width);
      var l = a.getTextMetrics().height + t.top + t.bottom;
      i.height = l;

      var c = this._getTextFrame();

      return [new qe({
        text: o,
        frame: c,
        font: a
      })];
    }
  }]);

  return ye;
}(it);

ye.prototype.availableOptions = C(C({}, it.prototype.availableOptions), {
  imageInsets: {
    type: m.OBJECT,
    default: new Y()
  }
});

var qt = I.Rectangle,
    Ue = I.Vector2,
    Tc = function Tc(s, e, t, i) {
  s.drawImage(e, t.x, t.y, t.width, t.height, i.x, i.y, i.width, i.height);
},
    _t = function _t(s, e, t) {
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "source-over";
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
  s.save(), s.fillStyle = t.toRGBA(), s.globalCompositeOperation = i, s.fillRect(e.x, e.y, e.width, e.height), r && (s.strokeStyle = t.toRGBA(), s.strokeWith = 1, s.strokeRect(e.x, e.y, e.width, e.height)), s.restore();
},
    Zo = function Zo(s, e, t, i) {
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "source-over";
  var o = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
  s.save(), s.fillStyle = i.toRGBA(), s.globalCompositeOperation = r, t = Math.min(Math.max(t, 0), Math.min(e.height, e.width) * .5);
  var n = e.x,
      a = e.x + e.width,
      l = e.y,
      c = e.y + e.height;
  s.beginPath(), s.moveTo(n + t, l), s.arcTo(a, l, a, c, t), s.arcTo(a, c, n, c, t), s.arcTo(n, c, n, l, t), s.arcTo(n, l, a, l, t), s.closePath(), s.fill(), o && s.stroke(), s.restore();
},
    kr = function kr(s, e, t) {
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 4;
  s.save(), s.strokeStyle = t.toRGBA(), s.lineWidth = i, s.strokeRect(e.x, e.y, e.width, e.height), s.restore();
},
    Rc = function Rc(s, e, t) {
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "source-over";
  s.save();
  var r = e.height / 2,
      o = e.y + r,
      n = e.x + r,
      a = e.x + e.width;

  for (s.fillStyle = t.toRGBA(), s.globalCompositeOperation = i; n < a;) {
    s.beginPath(), s.arc(n, o, r, 0, 2 * Math.PI), s.fill(), n += r * 4;
  }

  s.restore();
},
    _h = function _h(s, e) {
  var t = e.applyToRectangle(s),
      i = s.x,
      r = s.y,
      o = s.width,
      n = s.height,
      a = [qt.FromDiagonalPoints(new Ue(0, 0), new Ue(t.x, t.y)), qt.FromDiagonalPoints(new Ue(0, t.y + t.height), new Ue(t.x, n)), qt.FromDiagonalPoints(new Ue(t.x + t.width, t.y + t.height), new Ue(o, n)), qt.FromDiagonalPoints(new Ue(t.x + t.width, 0), new Ue(o, t.y))].map(function (c) {
    return c.translate(i, r);
  }),
      l = [qt.FromDiagonalPoints(new Ue(t.x, 0), new Ue(t.x + t.width, t.y)), qt.FromDiagonalPoints(new Ue(0, t.y), new Ue(t.x, t.y + t.height)), qt.FromDiagonalPoints(new Ue(t.x, t.y + t.height), new Ue(t.x + t.width, n)), qt.FromDiagonalPoints(new Ue(t.x + t.width, t.y), new Ue(o, t.y + t.height))].map(function (c) {
    return c.translate(i, r);
  });
  return {
    corners: a,
    bars: l,
    center: t
  };
},
    yh = function yh(s, e, t, i) {
  var r = e.naturalWidth || e.width,
      o = e.naturalHeight || e.height,
      n = _h(new qt(0, 0, r, o), i),
      a = _h(t, i);

  Tc(s, e, n.center, a.center), T.Array.zip(n.corners, a.corners).forEach(function (_ref40) {
    var _ref41 = _slicedToArray(_ref40, 2),
        l = _ref41[0],
        c = _ref41[1];

    return Tc(s, e, l, c);
  }), T.Array.zip(n.bars, a.bars).forEach(function (_ref42) {
    var _ref43 = _slicedToArray(_ref42, 2),
        l = _ref43[0],
        c = _ref43[1];

    return Tc(s, e, l, c);
  });
},
    Kt = function Kt(s, e, t, i) {
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "source-atop";

  if (s.save(), i && (s.globalAlpha = i.a), s.drawImage(e, t.x, t.y, t.width, t.height), i && (s.globalAlpha = 1), i) {
    var _o20 = i.clone();

    _o20.a = 1, _t(s, t, _o20, r);
  }

  s.restore();
};

var Xt =
/*#__PURE__*/
function (_ye) {
  _inherits(Xt, _ye);

  function Xt() {
    _classCallCheck(this, Xt);

    return _possibleConstructorReturn(this, _getPrototypeOf(Xt).apply(this, arguments));
  }

  _createClass(Xt, [{
    key: "_getTextColor",
    value: function _getTextColor() {
      return this.getAutoAdjustTextColor() && !this.getIsMasked() ? this.getBackgroundColor().equals(R.WHITE) ? R.BLACK : R.WHITE : this.getAttributes().getTextColor().clone();
    }
  }, {
    key: "_getTextFrame",
    value: function _getTextFrame() {
      return this.getImageInsets().applyToRectangle(this._getFrame());
    }
  }, {
    key: "_getTextFrameForElement",
    value: function _getTextFrameForElement(e) {
      var t = _get(_getPrototypeOf(Xt.prototype), "_getTextFrameForElement", this).call(this, e),
          i = this.getImageInsets();

      return (this.getIsMasked() || this.getIsUsedInInvertedLayout()) && (t.y -= i.top), t;
    }
  }, {
    key: "willRender",
    value: function willRender(e) {
      this.getAttributes().setTextColor(this._getTextColor());
      var i = this.getImage();

      if (i) {
        var _r9 = this.getCapInsets(),
            _o21 = this._getFrame();

        _r9 && !_r9.equals(Y.ZERO) ? yh(e, i, _o21, _r9) : e.drawImage(i, _o21.x, _o21.y, _o21.width, _o21.height), _t(e, _o21, this.getBackgroundColor(), "source-atop", !0);
      }

      (this.getIsMasked() || this.getIsUsedInInvertedLayout()) && i && (e.save(), e.globalCompositeOperation = "destination-out");
    }
  }, {
    key: "didRender",
    value: function didRender(e) {
      _get(_getPrototypeOf(Xt.prototype), "didRender", this).call(this, e), (this.getIsMasked() || this.getIsUsedInInvertedLayout()) && e.restore();
    }
  }]);

  return Xt;
}(ye);

Xt.prototype.availableOptions = C(C({}, ye.prototype.availableOptions), {
  image: {
    type: m.IMAGE,
    default: null
  },
  capInsets: {
    type: m.OBJECT,
    default: new Y()
  },
  backgroundColor: {
    type: m.COLOR,
    default: R.WHITE
  },
  autoAdjustTextColor: {
    type: m.BOOLEAN,
    default: !0
  },
  isMasked: {
    type: m.BOOLEAN,
    default: !0
  },
  isUsedInInvertedLayout: {
    type: m.BOOLEAN,
    default: !1
  }
});

var lt =
/*#__PURE__*/
function (_V14) {
  _inherits(lt, _V14);

  function lt() {
    _classCallCheck(this, lt);

    return _possibleConstructorReturn(this, _getPrototypeOf(lt).apply(this, arguments));
  }

  _createClass(lt, [{
    key: "insetsForWidth",
    value: function insetsForWidth(e) {
      return this.getRelativeInsets().clone().scale(e);
    }
  }], [{
    key: "Small",
    get: function get() {
      return new lt({
        imagePath: "text-design/images/imgly_text_design_asset_banderole_small.png",
        fontIdentifier: "imgly_font_campton_bold",
        relativeInsets: new Y(.05, .2, .05, .2)
      });
    }
  }, {
    key: "Rectangle",
    get: function get() {
      return new lt({
        imagePath: "text-design/images/imgly_text_design_asset_black_background.png",
        fontIdentifier: "imgly_font_campton_bold",
        relativeInsets: new Y(.05, .05, .05, .05),
        needsImageSmoothingFix: !0
      });
    }
  }, {
    key: "Celebrate1",
    get: function get() {
      return new lt({
        imagePath: "text-design/images/imgly_text_design_asset_celebrate_01.png",
        fontIdentifier: "imgly_font_rasa_500",
        relativeInsets: new Y(.05, .2, .05, .2)
      });
    }
  }, {
    key: "Celebrate2",
    get: function get() {
      return new lt({
        imagePath: "text-design/images/imgly_text_design_asset_celebrate_02.png",
        fontIdentifier: "imgly_font_rasa_500",
        relativeInsets: new Y(.05, .2, .05, .2)
      });
    }
  }]);

  return lt;
}(V);

lt.prototype.availableOptions = {
  image: {
    type: m.IMAGE,
    default: null
  },
  imagePath: {
    type: m.STRING,
    default: null
  },
  relativeInsets: {
    type: m.OBJECT,
    default: new Y()
  },
  fontIdentifier: {
    type: m.STRING,
    default: "imgly_font_open_sans_bold"
  },
  needsImageSmoothingFix: {
    type: m.BOOLEAN,
    default: !1
  }
};

var $o =
/*#__PURE__*/
function (_V15) {
  _inherits($o, _V15);

  function $o() {
    _classCallCheck(this, $o);

    return _possibleConstructorReturn(this, _getPrototypeOf($o).apply(this, arguments));
  }

  _createClass($o, [{
    key: "getSize",
    value: function getSize() {
      var e = this.getRows(),
          t = this.getWidth(),
          i = e.length - 1,
          r = e.reduce(function (n, a) {
        return n + a.getSize().height;
      }, 0);
      r += (i + 1) * this.getRelativeLineSpacing() * t;
      var o = this.getRelativeInsets().clone().scale(t);
      return r += o.top + o.bottom, new pe(t, r);
    }
  }]);

  return $o;
}(V);

$o.prototype.availableOptions = {
  text: {
    type: m.STRING,
    default: ""
  },
  lines: {
    type: m.ARRAY,
    default: []
  },
  relativeInsets: {
    type: m.OBJECT,
    default: new Y()
  },
  relativeLineSpacing: {
    type: m.NUMBER,
    default: 0
  },
  rows: {
    type: m.OBJECT,
    default: []
  },
  background: {
    type: m.OBJECT,
    default: null
  },
  width: {
    type: m.NUMBER,
    default: 0
  }
};

var Be =
/*#__PURE__*/
function () {
  function Be(e) {
    _classCallCheck(this, Be);

    this.words = [], e && this.splitIntoWords(e);
  }

  _createClass(Be, [{
    key: "splitIntoWords",
    value: function splitIntoWords(e) {
      return this.words = e.match(/\S+/g) || [], _toConsumableArray(this.words);
    }
  }, {
    key: "get",
    value: function get() {
      return _toConsumableArray(this.words);
    }
  }, {
    key: "getWord",
    value: function getWord(e) {
      return this.words[e];
    }
  }, {
    key: "set",
    value: function set(e) {
      return this.words = _toConsumableArray(e), this;
    }
  }, {
    key: "slice",
    value: function slice(e, t) {
      return Be.fromWords(this.words.slice(e, t));
    }
  }, {
    key: "getLowerCase",
    value: function getLowerCase() {
      return this.words.map(function (e) {
        return e.toLowerCase();
      });
    }
  }, {
    key: "getUpperCase",
    value: function getUpperCase() {
      return this.words.map(function (e) {
        return e.toUpperCase();
      });
    }
  }, {
    key: "size",
    value: function size() {
      return this.words.length;
    }
  }, {
    key: "countNumberOfCharacters",
    value: function countNumberOfCharacters() {
      return this.words.reduce(function (e, t) {
        return e + t.length;
      }, 0);
    }
  }, {
    key: "joined",
    value: function joined(e) {
      var _this161 = this;

      var t = this.size(),
          i = Math.floor(t / e),
          r = t % e,
          o = 0,
          n = 0;
      return T.Array.range(0, e).map(function (a) {
        o = n;
        var l = i + (a < r ? 1 : 0);
        return n = Math.min(o + l, t), T.Array.range(o, n).reduce(function (c, u) {
          return c + (u === o ? "" : " ") + _this161.words[u];
        }, "");
      });
    }
  }], [{
    key: "fromWords",
    value: function fromWords(e) {
      var t = new Be();
      return t.words = _toConsumableArray(e), t;
    }
  }]);

  return Be;
}();

var U_ = 10,
    N_ = 4,
    G_ = .4,
    Fe =
/*#__PURE__*/
function (_V16) {
  _inherits(Fe, _V16);

  function Fe(e) {
    var _this162;

    _classCallCheck(this, Fe);

    _this162 = _possibleConstructorReturn(this, _getPrototypeOf(Fe).call(this, e));
    _this162._relativeInsets = new Y(), _this162._background = null, _this162._fontRandomizer = new Z(0), _this162._lineNumberRandomizer = new Z(0), _this162._wordsPerLineRandomizer = new Z(0), _this162._seedPool = [_this162._fontRandomizer, _this162._lineNumberRandomizer, _this162._wordsPerLineRandomizer];
    return _this162;
  }

  _createClass(Fe, [{
    key: "seed",
    value: function seed(e) {
      this._seedPool.forEach(function (t) {
        return t.seed(e);
      });
    }
  }, {
    key: "getImagePaths",
    value: function getImagePaths() {
      return [];
    }
  }, {
    key: "onImagesLoaded",
    value: function onImagesLoaded() {}
  }, {
    key: "getMaximumNumberOfTries",
    value: function getMaximumNumberOfTries() {
      return U_;
    }
  }, {
    key: "getMinLineCountOfRandom",
    value: function getMinLineCountOfRandom() {
      return N_;
    }
  }, {
    key: "getRandomAdditionalLinePercentage",
    value: function getRandomAdditionalLinePercentage() {
      return G_;
    }
  }, {
    key: "_fontForRow",
    value: function _fontForRow(e, t) {
      return this._fontRandomizer.pickNext(this.getFontIdentifiers());
    }
  }, {
    key: "_modifiedText",
    value: function _modifiedText(e) {
      return e.replace("\n", " ").replace("	", " ");
    }
  }, {
    key: "_minimumNumberOfLines",
    value: function _minimumNumberOfLines(e) {
      return Math.ceil(Math.sqrt(e.size()));
    }
  }, {
    key: "_maximumNumberOfLines",
    value: function _maximumNumberOfLines(e) {
      return e.size();
    }
  }, {
    key: "_calculatedNumberOfLines",
    value: function _calculatedNumberOfLines(e) {
      var t = this._minimumNumberOfLines(e);

      if (e.size() >= this.getMinLineCountOfRandom()) {
        var _i17 = Math.floor(Math.max(1, t * this.getRandomAdditionalLinePercentage()));

        t += this._lineNumberRandomizer.nextInRange(0, _i17);
      }

      return Math.min(t, this._maximumNumberOfLines(e));
    }
  }, {
    key: "_randomizedNumberOfWordsPerLine",
    value: function _randomizedNumberOfWordsPerLine(e, t) {
      var _this163 = this;

      if (e > t) return A.warn("TextDesign#_randomizedNumberOfWordsPerLine: Invalid number of lines"), t;
      var i = T.Array.repeat(1, e);
      return T.Array.range(e, t).forEach(function (r) {
        var o = _this163._wordsPerLineRandomizer.nextInRange(0, e - 1);

        i[o] += 1;
      }), i;
    }
  }, {
    key: "_textLines",
    value: function _textLines(e) {
      var t = new Be(e),
          i = this._calculatedNumberOfLines(t);

      return this._randomizedNumberOfWordsPerLine(i, t.size()).reduce(function (o, n) {
        return {
          index: o.index + n,
          lines: [].concat(_toConsumableArray(o.lines), [t.slice(o.index, Math.min(o.index + n, t.size()))])
        };
      }, {
        index: 0,
        lines: []
      }).lines;
    }
  }, {
    key: "_validTextLines",
    value: function _validTextLines(e) {
      var t = this._textLines(e),
          i = 0;

      do {
        if (i = T.Array.findIndex(t, function (r) {
          return r.countNumberOfCharacters() < 3;
        }), i >= 0) {
          var _r10 = t[i - 1],
              _o22 = t[i + 1],
              _n15 = _r10 ? _r10.countNumberOfCharacters() : Number.MAX_SAFE_INTEGER,
              _a14 = _o22 ? _o22.countNumberOfCharacters() : Number.MAX_SAFE_INTEGER;

          _n15 < _a14 && _r10 ? (_r10.words = [].concat(_toConsumableArray(_r10.words), _toConsumableArray(t[i].words)), t = [].concat(_toConsumableArray(t.slice(0, i)), _toConsumableArray(t.slice(i + 1)))) : _o22 && (_o22.words = [].concat(_toConsumableArray(t[i].words), _toConsumableArray(_o22.words)), t = [].concat(_toConsumableArray(t.slice(0, i)), _toConsumableArray(t.slice(i + 1))));
        }
      } while (i > -1 && t.length > 1);

      return t;
    }
  }, {
    key: "_modifiedLines",
    value: function _modifiedLines(e) {
      return e;
    }
  }, {
    key: "_getBackground",
    value: function _getBackground() {
      return this._background;
    }
  }, {
    key: "generateLayoutData",
    value: function generateLayoutData(e, t) {
      var i = this._modifiedText(e),
          r = this._modifiedLines(this._validTextLines(i)),
          o = t * (1 - this._relativeInsets.left - this._relativeInsets.right),
          n = this._layoutRows(r, o);

      return new $o({
        text: i,
        relativeInsets: this._relativeInsets.clone(),
        relativeLineSpacing: this.getRelativeLineSpacing(),
        background: this._background || this._getBackground(),
        lines: r,
        rows: n,
        width: t
      });
    }
  }, {
    key: "_layoutRows",
    value: function _layoutRows(e, t) {
      var _this164 = this;

      return e.map(function (i, r) {
        return _this164._randomLayoutRow(i, r, t, new ft({
          fontIdentifier: _this164._fontForRow(r, i)
        })).layout();
      });
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      return new ye({
        words: e,
        width: i,
        attributes: r
      });
    }
  }]);

  return Fe;
}(V);

S(Fe, "defaultFontIdentifiers", []), S(Fe, "identifier", "textdesign");
Fe.prototype.availableOptions = {
  fontIdentifiers: {
    type: m.ARRAY,
    default: []
  },
  relativeLineSpacing: {
    type: m.NUMBER,
    default: 0
  }
};

var Ie =
/*#__PURE__*/
function (_Fe) {
  _inherits(Ie, _Fe);

  function Ie() {
    var _getPrototypeOf74;

    var _this165;

    _classCallCheck(this, Ie);

    for (var _len83 = arguments.length, e = new Array(_len83), _key83 = 0; _key83 < _len83; _key83++) {
      e[_key83] = arguments[_key83];
    }

    _this165 = _possibleConstructorReturn(this, (_getPrototypeOf74 = _getPrototypeOf(Ie)).call.apply(_getPrototypeOf74, [this].concat(e)));
    S(_assertThisInitialized(_assertThisInitialized(_this165)), "getImagePaths", function () {
      var e = _this165.getBanderoles();

      return e && e.map(function (t) {
        return t.getImagePath();
      }) || [];
    });
    S(_assertThisInitialized(_assertThisInitialized(_this165)), "onImagesLoaded", function () {
      var e = _this165.getBanderoles();

      e && e.forEach(function (t) {
        var i = re.getImage(t.getImagePath());

        if (!i) {
          A.warn("TextDesignBlocks#onImagesLoaded: Image not found '".concat(t.getImagePath(), "'"));
          return;
        }

        t.setImage(i);
      });
    });
    _this165._rowTypeLessThan3WordsRandomizer = new Z(0), _this165._rowTypeMoreThan3WordsRandomizer = new Z(0), _this165._banderolesRandomizer = new Z(0), _this165._seedPool = [].concat(_toConsumableArray(_this165._seedPool), [_this165._rowTypeLessThan3WordsRandomizer, _this165._rowTypeMoreThan3WordsRandomizer, _this165._banderolesRandomizer]);
    return _this165;
  }

  _createClass(Ie, [{
    key: "_modifiedText",
    value: function _modifiedText(e) {
      return _get(_getPrototypeOf(Ie.prototype), "_modifiedText", this).call(this, e).toUpperCase();
    }
  }, {
    key: "generateLayoutData",
    value: function generateLayoutData(e, t) {
      return this._options.hasMaskedText = !1, _get(_getPrototypeOf(Ie.prototype), "generateLayoutData", this).call(this, e, t);
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      if (e.size() < 3) {
        var _n16 = this._rowTypeLessThan3WordsRandomizer.nextInRange(0, 2) === 0;

        return this._layoutRow(e, i, r, _n16);
      }

      var o = this._rowTypeMoreThan3WordsRandomizer.nextInRange(0, 3);

      switch (o) {
        case 0:
          return new wt({
            words: e,
            width: i,
            attributes: r,
            orientation: wt.Orientations.Left
          });

        case 1:
          return new wt({
            words: e,
            width: i,
            attributes: r,
            orientation: wt.Orientations.Right
          });

        case 2:
          return this._layoutRow(e, i, r, !0);

        case 3:
          return new ye({
            words: e,
            width: i,
            attributes: r
          });

        default:
          throw new Error("TextDesignBlocks#_randomLayoutRow: Invalid randomValue generated: ".concat(o, "."));
      }
    }
  }, {
    key: "_layoutRow",
    value: function _layoutRow(e, t, i, r) {
      if (this.getHasMaskedText() && (r = !1), r) {
        this.setHasMaskedText(!0);

        var _o23 = this._banderolesRandomizer.pickNext(this.getBanderoles()),
            _n17 = new Xt({
          words: e,
          width: t,
          attributes: new ft({
            alignment: "left",
            fontIdentifier: _o23.getFontIdentifier()
          }),
          image: _o23.getImage(),
          imageInsets: _o23.insetsForWidth(t),
          capInsets: null,
          backgroundColor: R.WHITE
        });

        return _o23.getNeedsImageSmoothingFix() && (_n17.serverImageSmoothingFix = !0), _n17;
      }

      return new ye({
        words: e,
        width: t,
        attributes: i
      });
    }
  }]);

  return Ie;
}(Fe);

S(Ie, "defaultFontIdentifiers", ["imgly_font_campton_bold"]), S(Ie, "identifier", "imgly_text_design_blocks"), S(Ie, "defaultBanderoles", [lt.Rectangle, lt.Small]);
Ie.prototype.availableOptions = C(C({}, Fe.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Ie.defaultFontIdentifiers
  },
  relativeLineSpacing: {
    type: m.NUMBER,
    default: .025 / 3
  },
  hasMaskedText: {
    type: m.BOOLEAN,
    default: !1
  },
  banderoles: {
    type: m.ARRAY,
    default: Ie.defaultBanderoles
  }
});

var Ui =
/*#__PURE__*/
function (_Ie) {
  _inherits(Ui, _Ie);

  function Ui() {
    var _getPrototypeOf75;

    var _this166;

    _classCallCheck(this, Ui);

    for (var _len84 = arguments.length, e = new Array(_len84), _key84 = 0; _key84 < _len84; _key84++) {
      e[_key84] = arguments[_key84];
    }

    _this166 = _possibleConstructorReturn(this, (_getPrototypeOf75 = _getPrototypeOf(Ui)).call.apply(_getPrototypeOf75, [this].concat(e)));
    _this166._exclusiveFont = null;
    return _this166;
  }

  _createClass(Ui, [{
    key: "generateLayoutData",
    value: function generateLayoutData(e, t) {
      return this._exclusiveFont = this._fontRandomizer.pickNext(this.getFontIdentifiers()), _get(_getPrototypeOf(Ui.prototype), "generateLayoutData", this).call(this, e, t);
    }
  }, {
    key: "_fontForRow",
    value: function _fontForRow(e, t) {
      return this._exclusiveFont || _get(_getPrototypeOf(Ui.prototype), "_fontForRow", this).call(this, e, t);
    }
  }, {
    key: "_layoutRow",
    value: function _layoutRow(e, t, i, r) {
      return new ye({
        words: e,
        width: t,
        attributes: i
      });
    }
  }]);

  return Ui;
}(Ie);

S(Ui, "defaultFontIdentifiers", ["imgly_font_ostrich_sans_heavy", "imgly_font_ostrich_sans_bold", "imgly_font_ostrich_sans_black"]), S(Ui, "identifier", "imgly_text_design_blocks_condensed");
Ui.prototype.availableOptions = C(C({}, Ie.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Ui.defaultFontIdentifiers
  }
});

var Ms = I.Rectangle,
    di =
/*#__PURE__*/
function (_it3) {
  _inherits(di, _it3);

  function di() {
    var _getPrototypeOf76;

    var _this167;

    _classCallCheck(this, di);

    for (var _len85 = arguments.length, e = new Array(_len85), _key85 = 0; _key85 < _len85; _key85++) {
      e[_key85] = arguments[_key85];
    }

    _this167 = _possibleConstructorReturn(this, (_getPrototypeOf76 = _getPrototypeOf(di)).call.apply(_getPrototypeOf76, [this].concat(e)));

    _this167.setSize(new pe(_this167.getWidth(), _this167.getHeight()));

    return _this167;
  }

  _createClass(di, [{
    key: "_calculateLayoutElements",
    value: function _calculateLayoutElements() {
      return [new qe({
        frame: this._getTextFrame()
      })];
    }
  }, {
    key: "render",
    value: function render(e) {
      var t = this._getFrame(),
          i = this.getType(),
          o = this.getAttributes().getTextColor(),
          n = t.height / 3,
          a = new Ms(t.x, t.y, t.width, n),
          l = new Ms(t.x, t.y + n * 2, t.width, n);

      switch (i) {
        case di.FormType.Rect:
          _t(e, t, o);

          break;

        case di.FormType.DoubleRect:
          _t(e, a, o), _t(e, l, o);
          break;

        case di.FormType.DoubleRectFirstPunctuated:
          Rc(e, a, o), _t(e, l, o);
          break;

        case di.FormType.DoubleRectSecondPunctuated:
          _t(e, a, o), Rc(e, l, o);
          break;

        case di.FormType.LongLine:
          {
            var _c22 = t.height / 2,
                _u18 = new Ms(t.x, t.y, t.width, _c22);

            Zo(e, _u18, _u18.height * .5, o);
            break;
          }

        case di.FormType.LongAndShortLine:
          {
            var _c23 = t.height * .2,
                _u19 = _c23 * .75;

            a = new Ms(t.x, t.y + _c23, t.width, _c23);

            var _p17 = t.x + t.width * .25,
                _h15 = t.y + t.height - _u19;

            l = new Ms(_p17, _h15, t.width * .5, _u19), Zo(e, a, a.height * .5, o), Zo(e, l, l.height * .5, o);
            break;
          }

        default:
          break;
      }
    }
  }]);

  return di;
}(it),
    rt = di;

S(rt, "FormType", {
  Rect: "RECT",
  DoubleRect: "DOUBLE_RECT",
  DoubleRectFirstPunctuated: "DOUBLE_RECT_FIRST_PUNCTUATED",
  DoubleRectSecondPunctuated: "DOUBLE_RECT_SECOND_PUNCTUATED",
  LongLine: "LONG_LINE",
  LongAndShortLine: "LONG_AND_SHORT_LINE"
});
rt.prototype.availableOptions = C(C({}, it.prototype.availableOptions), {
  height: {
    type: m.NUMBER,
    default: 100
  },
  type: {
    type: m.STRING,
    default: rt.FormType.Rect,
    available: T.values(rt.FormType)
  }
});

var Pt =
/*#__PURE__*/
function (_Ie2) {
  _inherits(Pt, _Ie2);

  function Pt() {
    _classCallCheck(this, Pt);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pt).apply(this, arguments));
  }

  _createClass(Pt, [{
    key: "_layoutRow",
    value: function _layoutRow(e, t, i, r) {
      return new ye({
        words: e,
        width: t,
        attributes: i
      });
    }
  }, {
    key: "_layoutRows",
    value: function _layoutRows(e, t) {
      var i = _get(_getPrototypeOf(Pt.prototype), "_layoutRows", this).call(this, e, t),
          r = .032 * t,
          o = .08 * t,
          n = new rt({
        width: t,
        height: r,
        type: rt.FormType.LongLine,
        shearingAngle: 0
      }).layout(),
          a = new rt({
        width: t,
        height: o,
        type: rt.FormType.LongAndShortLine,
        shearingAngle: 0
      }).layout();

      return [n].concat(_toConsumableArray(i), [a]);
    }
  }]);

  return Pt;
}(Ie);

S(Pt, "defaultFontIdentifiers", ["imgly_font_sue_ellen_francisco"]), S(Pt, "identifier", "imgly_text_design_blocks_light");
Pt.prototype.availableOptions = C(C({}, Ie.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Pt.defaultFontIdentifiers
  }
});

var Ni =
/*#__PURE__*/
function (_Pt) {
  _inherits(Ni, _Pt);

  function Ni() {
    _classCallCheck(this, Ni);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ni).apply(this, arguments));
  }

  _createClass(Ni, [{
    key: "_layoutRows",
    value: function _layoutRows(e, t) {
      var _this168 = this;

      return e.map(function (i, r) {
        return _this168._randomLayoutRow(i, r, t, new ft({
          fontIdentifier: _this168._fontForRow(r, i)
        })).layout();
      });
    }
  }, {
    key: "_layoutRow",
    value: function _layoutRow(e, t, i, r) {
      return new ye({
        words: e,
        width: t,
        attributes: i
      });
    }
  }]);

  return Ni;
}(Pt);

S(Ni, "defaultFontIdentifiers", ["imgly_font_sue_ellen_francisco"]), S(Ni, "identifier", "imgly_text_design_blocks_light-v3_1_0");
Ni.prototype.availableOptions = C(C({}, Pt.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Ni.defaultFontIdentifiers
  }
});

var W_ = I.Rectangle,
    Jo =
/*#__PURE__*/
function (_ye2) {
  _inherits(Jo, _ye2);

  function Jo() {
    _classCallCheck(this, Jo);

    return _possibleConstructorReturn(this, _getPrototypeOf(Jo).apply(this, arguments));
  }

  _createClass(Jo, [{
    key: "getImageSize",
    value: function getImageSize() {
      var e = this.getLeftImage(),
          t = this.getRightImage(),
          i = this.getWords(),
          o = this.getAttributes().getFontIdentifier(),
          n = e ? new pe(e.width, e.height) : new pe(),
          a = i.joined(1)[0];
      if (!a) return n;
      var c = new Ye({
        text: a,
        fontIdentifier: o,
        fontSize: 50
      }).getSizeValue(),
          u = t ? 2 : 1;
      n.scale(u, 1);
      var p = n.clone().fitInWidthWithOther(this._getFrame().width, c);
      return p.scale(1 / u, 1), p;
    }
  }, {
    key: "_getTextFrame",
    value: function _getTextFrame() {
      var e = _get(_getPrototypeOf(Jo.prototype), "_getTextFrame", this).call(this).clone(),
          t = this.getImageSize(),
          i = this.getRightImage(),
          r = this.getImagePosition();

      return i ? (e.x += t.width, e.width -= 2 * t.width) : r === Jo.ImagePosition.Left && (e.x += t.width), e;
    }
  }, {
    key: "_calculateLayoutElements",
    value: function _calculateLayoutElements() {
      var e = _get(_getPrototypeOf(Jo.prototype), "_calculateLayoutElements", this).call(this),
          t = this._getFrame(),
          i = this.getRightImage(),
          r = this.getImageSize(),
          o = this.getImagePosition(),
          n = this._getTextFrame(),
          l = this.getAttributes().getFontIdentifier(),
          c = new Ye({
        text: "stickerClock",
        fontIdentifier: l
      });

      c.fitWidth(this._getTextFrame().width);
      var u = new W_().set(t.x, t.y, r.width, r.height);

      if (!i && o === Jo.ImagePosition.Right && (u.x += n.width), e.push(new qe({
        text: "stickerClock",
        frame: u,
        font: c
      })), i) {
        var _p18 = e[0];

        if (_p18) {
          var _h16 = u.clone();

          _h16.translate(_p18.getFrame().width + _h16.width, 0), e.push(new qe({
            text: "stickerClock",
            frame: _h16,
            font: c
          }));
        }
      }

      return e;
    }
  }, {
    key: "render",
    value: function render(e) {
      var t = this._getLayoutElements(),
          i = this.getAttributes(),
          r = i.getTextColor(),
          o = this.getLeftImage(),
          n = this.getRightImage(),
          a = t[0],
          l = t[1],
          _a$serializeOptions = a.serializeOptions(),
          c = _a$serializeOptions.font,
          u = this._getTextFrameForElement(a);

      if (c.draw(e, u.x, u.y, {
        textColor: i.getTextColor().toRGBA(),
        alignment: i.getAlignment()
      }), o) {
        var _p19 = l.getFrame();

        e.drawImage(o, _p19.x, _p19.y, _p19.width, _p19.height), _t(e, _p19, r, "source-atop");
      }

      if (t.length > 2) {
        var _h17 = t[2].getFrame().clone();

        e.drawImage(n, _h17.x, _h17.y, _h17.width, _h17.height), _t(e, _h17, r, "source-atop");
      }
    }
  }]);

  return Jo;
}(ye),
    Bt = Jo;

S(Bt, "ImagePosition", {
  Left: "LEFT",
  right: "RIGHT"
});
Bt.prototype.availableOptions = C(C({}, ye.prototype.availableOptions), {
  leftImage: {
    type: m.IMAGE,
    default: null
  },
  rightImage: {
    type: m.IMAGE,
    default: null
  },
  imagePosition: {
    type: m.STRING,
    default: Bt.ImagePosition.Left,
    available: [Bt.ImagePosition.Left, Bt.ImagePosition.Right]
  }
});

var Ls =
/*#__PURE__*/
function (_Ie3) {
  _inherits(Ls, _Ie3);

  function Ls() {
    _classCallCheck(this, Ls);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ls).apply(this, arguments));
  }

  _createClass(Ls, [{
    key: "_fontForRow",
    value: function _fontForRow(e, t) {
      var i = this.getFontIdentifiers();
      return i[e % i.length];
    }
  }, {
    key: "_minimumNumberOfLines",
    value: function _minimumNumberOfLines(e) {
      return Math.max(Math.floor(_get(_getPrototypeOf(Ls.prototype), "_minimumNumberOfLines", this).call(this, e) * .7), 1);
    }
  }, {
    key: "_maximumNumberOfLines",
    value: function _maximumNumberOfLines(e) {
      return Math.max(Math.floor(e.countNumberOfCharacters() / 5), 1);
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      return this._createSingleRow(Ls.RowType.Single, e, i, r);
    }
  }, {
    key: "_createSingleRow",
    value: function _createSingleRow(e, t, i, r) {
      var o = r.getFontIdentifier(),
          n = o === "imgly_font_amberlight" || o === "imgly_font_handycheera_regular" ? new Be().set(t.getLowerCase()) : t;

      switch (e) {
        case Ls.RowType.Single:
          return new ye({
            words: n,
            width: i,
            attributes: r
          });

        case Ls.RowType.SingleImage:
          return new Bt({
            words: n,
            width: i,
            attributes: r
          });

        default:
          return A.warn("TextDesignCelebrate#_createSingleRow: Invalid row type '".concat(e, "'")), null;
      }
    }
  }]);

  return Ls;
}(Ie),
    ct = Ls;

S(ct, "defaultFontIdentifiers", ["imgly_font_handycheera_regular", "imgly_font_rasa_regular"]), S(ct, "defaultBanderoles", [lt.Celebrate1, lt.Celebrate2]), S(ct, "identifier", "imgly_text_design_celebrate"), S(ct, "RowType", {
  Single: "SINGLE",
  SingleImage: "SINGLE_IMAGE"
});
ct.prototype.availableOptions = C(C({}, Ie.prototype.availableOptions), {
  relativeLineSpacing: {
    type: m.NUMBER,
    default: .01875
  },
  fontIdentifiers: {
    type: m.ARRAY,
    default: ct.defaultFontIdentifiers
  },
  banderoles: {
    type: m.ARRAY,
    default: ct.defaultBanderoles
  }
});

var Ee =
/*#__PURE__*/
function (_it4) {
  _inherits(Ee, _it4);

  function Ee() {
    var _getPrototypeOf77;

    var _this169;

    _classCallCheck(this, Ee);

    for (var _len86 = arguments.length, e = new Array(_len86), _key86 = 0; _key86 < _len86; _key86++) {
      e[_key86] = arguments[_key86];
    }

    _this169 = _possibleConstructorReturn(this, (_getPrototypeOf77 = _getPrototypeOf(Ee)).call.apply(_getPrototypeOf77, [this].concat(e)));

    _this169.setSize(new pe(_this169.getWidth(), _this169.getHeight()));

    return _this169;
  }

  _createClass(Ee, [{
    key: "_getImageFrame",
    value: function _getImageFrame() {
      var e = this._getTextFrame().clone(),
          t = this.getImage();

      if (this.getDrawingModeAspectFit() && t) {
        var _i18 = Math.min(e.width / t.width, e.height / t.height),
            _r11 = t.width * _i18,
            _o24 = t.height * _i18;

        e.x += (e.width - _r11) / 2, e.y += (e.height - _o24) / 2, e.width = _r11, e.height = _o24;
      }

      return e;
    }
  }, {
    key: "_calculateLayoutElements",
    value: function _calculateLayoutElements() {
      return [new qe({
        text: "",
        frame: this._getImageFrame(),
        font: new Ye()
      })];
    }
  }, {
    key: "render",
    value: function render(e) {
      var t = this.getImage(),
          i = this._getImageFrame(),
          o = this.getAttributes().getTextColor();

      Kt(e, t, i, o);
    }
  }]);

  return Ee;
}(it);

S(Ee, "RowImages", {
  decorative1: "text-design/images/imgly_text_design_asset_decorative_01.png",
  decorative2: "text-design/images/imgly_text_design_asset_decorative_02.png",
  decorative3: "text-design/images/imgly_text_design_asset_decorative_05.png",
  decorative4: "text-design/images/imgly_text_design_asset_decorative_06.png",
  celebrate1: "text-design/images/imgly_text_design_asset_celebrate_03.png",
  celebrate2: "text-design/images/imgly_text_design_asset_celebrate_04.png",
  celebrate3: "text-design/images/imgly_text_design_asset_celebrate_05.png"
});
Ee.prototype.availableOptions = C(C({}, it.prototype.availableOptions), {
  words: {
    type: m.OBJECT,
    default: new Be()
  },
  height: {
    type: m.NUMBER,
    default: 0
  },
  image: {
    type: m.IMAGE,
    default: null
  },
  imagePath: {
    type: m.STRING,
    default: Ee.RowImages.decorative1
  },
  drawingModeAspectFit: {
    type: m.BOOLEAN,
    default: !1
  },
  attributes: {
    type: m.CONFIGURABLE,
    default: new ft()
  }
});

var Gi =
/*#__PURE__*/
function (_ct2) {
  _inherits(Gi, _ct2);

  function Gi() {
    var _getPrototypeOf78;

    var _this170;

    _classCallCheck(this, Gi);

    for (var _len87 = arguments.length, e = new Array(_len87), _key87 = 0; _key87 < _len87; _key87++) {
      e[_key87] = arguments[_key87];
    }

    _this170 = _possibleConstructorReturn(this, (_getPrototypeOf78 = _getPrototypeOf(Gi)).call.apply(_getPrototypeOf78, [this].concat(e)));
    S(_assertThisInitialized(_assertThisInitialized(_this170)), "getImagePaths", function () {
      var e = _this170.getBanderoles();

      return [].concat(_toConsumableArray(e && e.map(function (t) {
        return t.getImagePath();
      }) || []), _toConsumableArray(_this170._celebrateTypes));
    });
    S(_assertThisInitialized(_assertThisInitialized(_this170)), "onImagesLoaded", function () {
      var e = _this170.getBanderoles();

      e && e.forEach(function (t) {
        var i = re.getImage(t.getImagePath());

        if (!i) {
          A.warn("TextDesignBlocks#onImagesLoaded: Image not found '".concat(t.getImagePath(), "'"));
          return;
        }

        t.setImage(i);
      });
    });
    _this170._celebrateTypes = [Ee.RowImages.celebrate1, Ee.RowImages.celebrate2, Ee.RowImages.celebrate3], _this170._exclusiveFont = null, _this170._typeRandomizer = new Z(0), _this170._useMaskedRandomizer = new Z(0), _this170._seedPool.push(_this170._typeRandomizer), _this170._seedPool.push(_this170._useMaskedRandomizer);
    return _this170;
  }

  _createClass(Gi, [{
    key: "_fontForRow",
    value: function _fontForRow(e, t) {
      var i = this.getFontIdentifiers();
      return i[e % (i.length - 1)];
    }
  }, {
    key: "_layoutRows",
    value: function _layoutRows(e, t) {
      var i = this._typeRandomizer.pickNext(this._celebrateTypes),
          r = re.getImage(i);

      r || A.warn("TextDesignCelebrateSimple#_layoutRows: Image not fount '".concat(i, "'"));

      var o = new Ee({
        width: t,
        height: t * .5,
        drawingModeAspectFit: !0,
        image: r
      }).layout(),
          n = _get(_getPrototypeOf(Gi.prototype), "_layoutRows", this).call(this, e, t);

      return [o].concat(_toConsumableArray(n));
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      var o = e.countNumberOfCharacters(),
          n = 13;
      o < 4 && r.setFontIdentifier("imgly_font_rasa_regular");

      var l = this._useMaskedRandomizer.nextBool(2, 1);

      return o < n && l && !this.getHasMaskedText() ? this._layoutRow(e, i, r, !0) : _get(_getPrototypeOf(Gi.prototype), "_randomLayoutRow", this).call(this, e, t, i, r);
    }
  }]);

  return Gi;
}(ct);

S(Gi, "identifier", "imgly_text_design_celebrate_simple"), S(Gi, "defaultFontIdentifiers", ["imgly_font_amberlight", "imgly_font_rasa_regular", "imgly_font_rasa_500"]);
Gi.prototype.availableOptions = C(C({}, ct.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Gi.defaultFontIdentifiers
  }
});

var Wi =
/*#__PURE__*/
function (_V17) {
  _inherits(Wi, _V17);

  function Wi() {
    _classCallCheck(this, Wi);

    return _possibleConstructorReturn(this, _getPrototypeOf(Wi).apply(this, arguments));
  }

  _createClass(Wi, [{
    key: "render",
    value: function render(e, t, i, r, o) {
      A.warn("TextDesignBackground#render: Abstract class");
    }
  }]);

  return Wi;
}(V);

Wi.prototype.availableOptions = {};

var en = I.Rectangle,
    Mt =
/*#__PURE__*/
function (_Wi) {
  _inherits(Mt, _Wi);

  function Mt() {
    _classCallCheck(this, Mt);

    return _possibleConstructorReturn(this, _getPrototypeOf(Mt).apply(this, arguments));
  }

  _createClass(Mt, [{
    key: "getImagePaths",
    value: function getImagePaths() {
      var _this$_options28 = this._options,
          e = _this$_options28.topImagePath,
          t = _this$_options28.bottomImagePath,
          i = _this$_options28.leftImagePath,
          r = _this$_options28.rightImagePath;
      return [e, t, i, r].filter(function (o) {
        return o !== "";
      });
    }
  }, {
    key: "render",
    value: function render(e, t, i, r, o) {
      var n = i.clone().scale(t.width),
          a = t.rectangle(0, 0),
          l = re.getImage(this.getTopImagePath()),
          c = re.getImage(this.getLeftImagePath()),
          u = re.getImage(this.getRightImagePath()),
          p = re.getImage(this.getBottomImagePath());

      if (l) {
        var _h18 = l.width / l.height,
            _d30 = n.top * this.getTopImageFillRate(),
            _g18 = _d30 * _h18,
            _17 = a.width / 2 - _g18 / 2,
            _f14 = new en(_17, 0, _g18, _d30);

        Kt(e, l, _f14, r);
      }

      if (p) {
        var _h19 = p.width / p.height,
            _d31 = n.bottom * this.getBottomImageFillRate(),
            _g19 = _d31 * _h19,
            _18 = a.width / 2 - _g19 / 2,
            _f15 = new en(_18, a.height - _d31, _g19, _d31);

        Kt(e, p, _f15, r);
      }

      if (c) {
        var _h20 = c.width / c.height,
            _d32 = n.left * this.getLeftImageFillRate(),
            _g20 = _d32 / _h20,
            _19 = a.height / 2 - _g20 / 2,
            _f16 = new en(0, _19, _d32, _g20);

        Kt(e, c, _f16, r);
      }

      if (u) {
        var _h21 = u.width / u.height,
            _d33 = n.right * this.getRightImageFillRate(),
            _g21 = _d33 / _h21,
            _20 = a.height / 2 - _g21 / 2,
            _f17 = new en(a.width - _d33, _20, _d33, _g21);

        Kt(e, u, _f17, r);
      }
    }
  }]);

  return Mt;
}(Wi);

Mt.prototype.availableOptions = {
  topImagePath: {
    type: m.STRING,
    default: ""
  },
  leftImagePath: {
    type: m.STRING,
    default: ""
  },
  bottomImagePath: {
    type: m.STRING,
    default: ""
  },
  rightImagePath: {
    type: m.STRING,
    default: ""
  },
  topImageFillRate: {
    type: m.NUMBER,
    default: 1
  },
  leftImageFillRate: {
    type: m.NUMBER,
    default: 1
  },
  bottomImageFillRate: {
    type: m.NUMBER,
    default: 1
  },
  rightImageFillRate: {
    type: m.NUMBER,
    default: 1
  }
};
Mt.Backgrounds = [new Mt({
  topImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background1_1.png",
  leftImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background1_2.png",
  rightImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background1_2.png",
  bottomImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background1_3.png",
  topImageFillRate: .8,
  leftImageFillRate: .6,
  rightImageFillRate: .6,
  bottomImageFillRate: .8
}), new Mt({
  leftImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background2_1.png",
  rightImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background2_1.png",
  bottomImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background2_2.png",
  leftImageFillRate: .6,
  rightImageFillRate: .6,
  bottomImageFillRate: .6
}), new Mt({
  topImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background3_1.png",
  bottomImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background3_2.png",
  topImageFillRate: .6,
  bottomImageFillRate: .6
}), new Mt({
  topImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background4_1.png",
  leftImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background4_3.png",
  rightImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background4_3.png",
  bottomImagePath: "text-design/images/imgly_xib_image_text_design_equal_width_background4_2.png",
  topImageFillRate: .1,
  leftImageFillRate: .6,
  rightImageFillRate: .6,
  bottomImageFillRate: .6
})];

var Lt =
/*#__PURE__*/
function (_Fe2) {
  _inherits(Lt, _Fe2);

  function Lt() {
    var _getPrototypeOf79;

    var _this171;

    _classCallCheck(this, Lt);

    for (var _len88 = arguments.length, e = new Array(_len88), _key88 = 0; _key88 < _len88; _key88++) {
      e[_key88] = arguments[_key88];
    }

    _this171 = _possibleConstructorReturn(this, (_getPrototypeOf79 = _getPrototypeOf(Lt)).call.apply(_getPrototypeOf79, [this].concat(e)));
    _this171._relativeInsets = new Y(.1, .1, .1, .1), _this171._alreadyContainsARowWithScriptFont = !1, _this171._backgroundsRandomizer = new Z(0), _this171._seedPool.push(_this171._backgroundsRandomizer);
    return _this171;
  }

  _createClass(Lt, [{
    key: "getImagePaths",
    value: function getImagePaths() {
      return T.Array.flatten(Mt.Backgrounds.map(function (e) {
        return e.getImagePaths();
      }));
    }
  }, {
    key: "_getBackground",
    value: function _getBackground() {
      return this._backgroundsRandomizer.pickNext(Mt.Backgrounds);
    }
  }, {
    key: "generateLayoutData",
    value: function generateLayoutData(e, t) {
      return this._alreadyContainsARowWithScriptFont = !1, this._background = this._getBackground(), _get(_getPrototypeOf(Lt.prototype), "generateLayoutData", this).call(this, e, t);
    }
  }, {
    key: "_modifiedText",
    value: function _modifiedText(e) {
      return _get(_getPrototypeOf(Lt.prototype), "_modifiedText", this).call(this, e).toUpperCase();
    }
  }, {
    key: "_fontForRow",
    value: function _fontForRow(e, t) {
      var i = _get(_getPrototypeOf(Lt.prototype), "_fontForRow", this).call(this, e, t);

      return i === "imgly_font_petit_formal_script" && (this._alreadyContainsARowWithScriptFont && (i = "imgly_font_bungee_inline"), this._alreadyContainsARowWithScriptFont = !0), i;
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      var o = r.getFontIdentifier() === "imgly_font_petit_formal_script";
      return new ye({
        words: o ? new Be().set(e.getLowerCase()) : e,
        width: i,
        attributes: r
      });
    }
  }]);

  return Lt;
}(Fe);

S(Lt, "identifier", "imgly_text_design_equal_width"), S(Lt, "defaultFontIdentifiers", ["imgly_font_ultra", "imgly_font_bungee_inline", "imgly_font_petit_formal_script"]);
Lt.prototype.availableOptions = C(C({}, Fe.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Lt.defaultFontIdentifiers
  },
  relativeLineSpacing: {
    type: m.NUMBER,
    default: .025
  }
});

var Vi =
/*#__PURE__*/
function (_Lt) {
  _inherits(Vi, _Lt);

  function Vi() {
    var _getPrototypeOf80;

    var _this172;

    _classCallCheck(this, Vi);

    for (var _len89 = arguments.length, e = new Array(_len89), _key89 = 0; _key89 < _len89; _key89++) {
      e[_key89] = arguments[_key89];
    }

    _this172 = _possibleConstructorReturn(this, (_getPrototypeOf80 = _getPrototypeOf(Vi)).call.apply(_getPrototypeOf80, [this].concat(e)));
    _this172._relativeInsets = new Y();
    return _this172;
  }

  _createClass(Vi, [{
    key: "_getBackground",
    value: function _getBackground() {
      return null;
    }
  }]);

  return Vi;
}(Lt);

S(Vi, "defaultFontIdentifiers", ["imgly_font_ultra"]), S(Vi, "identifier", "imgly_text_design_equal_width_fat");
Vi.prototype.availableOptions = C(C({}, Lt.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Vi.defaultFontIdentifiers
  }
});

var H =
/*#__PURE__*/
function (_V18) {
  _inherits(H, _V18);

  function H() {
    _classCallCheck(this, H);

    return _possibleConstructorReturn(this, _getPrototypeOf(H).apply(this, arguments));
  }

  _createClass(H, [{
    key: "insetsForWidth",
    value: function insetsForWidth(e) {
      return this.getRelativeInsets().clone().scale(e);
    }
  }]);

  return H;
}(V);

H.prototype.availableOptions = {
  imagePath: {
    type: m.STRING,
    default: ""
  },
  minimumHeightRatio: {
    type: m.NUMBER,
    default: 0
  },
  sizeToFitContent: {
    type: m.BOOLEAN,
    default: !0
  },
  capInsets: {
    type: m.OBJECT,
    default: new Y()
  },
  relativeInsets: {
    type: m.OBJECT,
    default: new Y()
  }
};
H.Box = new H({
  imagePath: "text-design/images/imgly_text_design_asset_black_background.png",
  relativeInsets: new Y(.1, .1, .1, .1)
});
H.Badge1 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_badge1.png",
  relativeInsets: new Y(.3, .18, .2, .18)
});
H.Badge2 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_badge2.png",
  relativeInsets: new Y(.3, .18, .2, .18)
});
H.Badge3 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_badge3.png",
  relativeInsets: new Y(.3, .18, .2, .18)
});
H.Badge4 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_badge4.png",
  relativeInsets: new Y(.3, .18, .2, .18)
});
H.SpeechBubble1 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_speech_bubble_small2.png",
  relativeInsets: new Y(.04, .07, .12, .07),
  capInsets: new Y(19 * 3, 57 * 3, 41 * 3, 17 * 3)
});
H.SpeechBubble2 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_speech_bubble3.png",
  relativeInsets: new Y(.04, .07, .12, .07),
  capInsets: new Y(2 * 3, 35 * 3, 29 * 3, 5 * 3)
});
H.SpeechBubble3 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_speech_bubble_small.png",
  relativeInsets: new Y(.165664675, .2, .165664675, .2),
  minimumHeightRatio: .7
});
H.SpeechBubble4 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_speech_bubble4.png",
  relativeInsets: new Y(.124800224, .2, .291200523, .2),
  minimumHeightRatio: .7
});
H.SpeechBubble5 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_speech_bubble5.png",
  relativeInsets: new Y(.114892823, .27, .15984926, .27)
});
H.Watercolor1 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_watercolor_01.png",
  minimumHeightRatio: .7,
  relativeInsets: new Y(.2, .25, .2, .25)
});
H.Watercolor2 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_watercolor_02.png",
  minimumHeightRatio: .7,
  relativeInsets: new Y(.08, .25, .3, .25)
});
H.Watercolor3 = new H({
  imagePath: "text-design/images/imgly_text_design_asset_watercolor_03.png",
  minimumHeightRatio: .7,
  relativeInsets: new Y(.1, .2, .15, .2)
});

var bh =
/*#__PURE__*/
function () {
  function bh(e) {
    _classCallCheck(this, bh);

    this._context = e, this._lastFontStyle = {};
  }

  _createClass(bh, [{
    key: "getLines",
    value: function getLines() {
      var _this173 = this;

      var e = [],
          t = [],
          i = this._lines.length;

      for (var _r12 = 0; _r12 < i; _r12++) {
        var _o25 = this._lines[_r12],
            _n18 = this._buildWords(_o25),
            _a15 = _n18.length;

        for (var _l19 = 0; _l19 < _a15; _l19++) {
          var _c24 = _n18[_l19],
              _u20 = t.concat(_c24).join("").replace(/\s+$/i, "");

          if (this._getWidth(_u20) > this._maxWidth) {
            t.length > 0 && (e.push(t.join("")), t = [_c24]);

            var _h22 = _c24.replace(/\s+$/i, "");

            if (this._getWidth(_h22) > this._maxWidth) {
              var _d34 = this._splitWord(_c24);

              e = e.concat(_d34.lines), _d34.rest && (t = [_d34.rest]);
            }
          } else t.push(_c24);
        }

        e.push(t.join("")), t = [];
      }

      return e.map(function (r) {
        return _this173._trimLine(r, _this173._context.textAlign);
      });
    }
  }, {
    key: "_trimLine",
    value: function _trimLine(e, t) {
      return e;
    }
  }, {
    key: "_buildWords",
    value: function _buildWords(e) {
      var t = [],
          i = "",
          r = e.length;

      for (var _o26 = 0; _o26 < r; _o26++) {
        var _n19 = e[_o26];
        i += _n19, (_n19 === " " || _n19 === "-" || _o26 === r - 1) && (t.push(i), i = "");
      }

      return t;
    }
  }, {
    key: "_splitWord",
    value: function _splitWord(e) {
      var t = {
        lines: [],
        rest: null
      },
          i = e.length,
          r = [];

      for (var _o27 = 0; _o27 < i; _o27++) {
        var _n20 = e[_o27];
        this._getWidth(r.concat(_n20).join("")) > this._maxWidth ? (r.length > 0 && t.lines.push(r.join("")), r = [_n20]) : r.push(_n20), _o27 === i - 1 && r.length > 0 && (t.rest = r.join(""));
      }

      return t;
    }
  }, {
    key: "_fontStyleChanged",
    value: function _fontStyleChanged() {
      return this._context.font !== this._lastFontStyle ? (this._lastFontStyle = this._context.font, !0) : !1;
    }
  }, {
    key: "_getWidth",
    value: function _getWidth(e) {
      return this._context.measureText(e).width;
    }
  }, {
    key: "setText",
    value: function setText(e) {
      this._text = e, this._lines = e.split("\n");
    }
  }, {
    key: "setMaxWidth",
    value: function setMaxWidth(e) {
      this._maxWidth = e;
    }
  }]);

  return bh;
}(),
    tn = bh;

var Fc = I.Vector2,
    xh =
/*#__PURE__*/
function () {
  function xh(e, t) {
    _classCallCheck(this, xh);

    this._text = e, this._operation = t, this._textOptions = {}, this.rotation = 0, this._createCanvas(), this._createTexture();
  }

  _createClass(xh, [{
    key: "_createCanvas",
    value: function _createCanvas() {
      this._canvas = T.createCanvas(), this._context = this._canvas.getContext("2d"), this._textSplitter = new tn(this._context), this._finalCanvas = T.createCanvas(), this._finalContext = this._finalCanvas.getContext("2d");
    }
  }, {
    key: "_createTexture",
    value: function _createTexture() {
      this._texture = k.Texture.fromCanvas(this._canvas), this._finalTexture = k.Texture.fromCanvas(this._finalCanvas);
    }
  }, {
    key: "_applyTextOptions",
    value: function _applyTextOptions(e, t) {
      t.font = "".concat(this._text.getFontStyle(), " ").concat(this._text.getFontWeight(), " ").concat(e.fontSize, "px \"").concat(this._text.getFontFamily(), "\""), this._text.getTextMetrics() ? t.textBaseline = "alphabetic" : t.textBaseline = "top", t.textAlign = this._text.getAlignment(), t.fillStyle = this._text.getColor().toRGBA(), t.strokeStyle = this._text.getOutlineColor().toRGBA();

      var i = this._text.getOutlineWidth();

      i > 0 && (t.lineWidth = i);
    }
  }, {
    key: "_buildOutputLines",
    value: function _buildOutputLines(e) {
      return this._textSplitter.setText(this._text.getText()), this._textSplitter.setMaxWidth(e), this._textSplitter.getLines().map(function (t) {
        return t.replace(/\s+$/i, "");
      });
    }
  }, {
    key: "_renderTextLine",
    value: function _renderTextLine(e, t, i) {
      var r = this._text.getAlignment(),
          o = new Fc(0, t);

      switch (r) {
        case "left":
          o.x = i;
          break;

        case "center":
          o.x = this._canvas.width / 2;
          break;

        case "right":
          o.x = this._canvas.width - i;
          break;
      }

      this._context.save(), this._context.translate(o.x, o.y), this._context.fillText(e, 0, 0), this._context.restore(), this._text.getOutlineWidth() > 0 && (this._context.miterLimit = 2, this._context.strokeText(e, o.x, o.y));
    }
  }, {
    key: "update",
    value: function update(e, t) {
      var i = this.calculateFontStyles(e, t);

      if (i) {
        var _this$_calculateText = this._calculateText(e, i, t),
            _r13 = _this$_calculateText.dimensions,
            _o28 = _this$_calculateText.lines;

        this._renderText(e, _r13, _o28, i, t), this._updateFinalTexture();
      }
    }
  }, {
    key: "_updateFinalTexture",
    value: function _updateFinalTexture() {
      var _this$_canvas2 = this._canvas,
          e = _this$_canvas2.width,
          t = _this$_canvas2.height,
          i = this.rotation,
          r = Math.cos(i),
          o = Math.sin(i),
          n = new Fc(Math.abs(e * r) + Math.abs(t * o), Math.abs(e * o) + Math.abs(t * r));
      this._finalCanvas.width = n.x, this._finalCanvas.height = n.y, this._finalContext.save(), this._finalContext.translate(this._finalCanvas.width / 2, this._finalCanvas.height / 2), this._finalContext.rotate(i), this._finalContext.drawImage(this._canvas, -e / 2, -t / 2), this._finalContext.restore();
    }
  }, {
    key: "_renderText",
    value: function _renderText(e, t, i, r, o) {
      this._canvas.width = t.x, this._canvas.height = t.y, this._text.getMaxHeight() && (this._canvas.height = Math.min(this._text.getMaxHeight() * o.y, this._canvas.height)), this._context = this._canvas.getContext("2d"), this._context.fillStyle = this._text.getBackgroundColor().toRGBA(), this._context.fillRect(0, 0, t.x, t.y), this._applyTextOptions(r, this._context);

      var n = this._padding(o),
          a = this._text.getTextMetrics(),
          l = this._text.getFontSize() * o.y,
          c = 1 / a.unitsPerEm * l,
          u = a.ascender * c;

      for (var _p20 = 0; _p20 < i.length; _p20++) {
        var _h23 = i[_p20];

        this._renderTextLine(_h23, r.topPadding + r.lineHeight * _p20 + n + u, n);
      }
    }
  }, {
    key: "calculateFontStyles",
    value: function calculateFontStyles(e, t) {
      var i = this._text.getFontFamily(),
          r = this._text.getFontSize() * t.y,
          o = this._text.getAbsoluteTextHeight(t),
          n = o * this._text.getLineHeight(),
          a = o * (this._text.getLineHeight() - 1) / 2,
          l = {
        fontFamily: i,
        fontSize: r,
        lineHeight: n,
        topPadding: a
      };

      return (this._textOptions.fontFamily !== i || this._textOptions.fontSize !== r || this._textOptions.lineHeight !== n) && (this._textOptions = l), l;
    }
  }, {
    key: "_calculateText",
    value: function _calculateText(e, t, i) {
      var r = this._text.getMaxWidth() * i.x;

      this._applyTextOptions(t, this._context);

      var o = new Fc(),
          n = this._text.getText().split("\n");

      typeof r != "undefined" && (o.x = r, n = this._buildOutputLines(r));

      for (var _c25 = 0; _c25 < n.length; _c25++) {
        var _u21 = n[_c25];
        o.x = Math.max(o.x, this._context.measureText(_u21).width);
      }

      var a = t.lineHeight;
      o.y = n.length * a;

      var l = this._padding(i);

      return o.y += l * 2, o.x += l * 2, {
        dimensions: o,
        lines: n
      };
    }
  }, {
    key: "_padding",
    value: function _padding(e) {
      return this._text.getAbsoluteTextHeight(e) * .2;
    }
  }, {
    key: "getTexture",
    value: function getTexture() {
      return this._texture;
    }
  }, {
    key: "getFinalTexture",
    value: function getFinalTexture() {
      return this._finalTexture;
    }
  }, {
    key: "getDimensions",
    value: function getDimensions(e, t) {
      var i = this.calculateFontStyles(e, t),
          _this$_calculateText2 = this._calculateText(e, i, t),
          r = _this$_calculateText2.dimensions;

      return r;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._measurementElement && document.body.removeChild(this._measurementElement), this._texture && (this._texture.dispose(), this._texture = null), this._finalTexture && (this._finalTexture.dispose(), this._finalTexture = null);
    }
  }]);

  return xh;
}(),
    vh = xh;

var Ch = I.Vector2,
    zs =
/*#__PURE__*/
function (_V19) {
  _inherits(zs, _V19);

  function zs(e) {
    var _this174;

    _classCallCheck(this, zs);

    _this174 = _possibleConstructorReturn(this, _getPrototypeOf(zs).call(this, e));
    _this174._textOptions = {}, _this174._createCanvas();
    return _this174;
  }

  _createClass(zs, [{
    key: "_createCanvas",
    value: function _createCanvas() {
      this._canvas = T.createCanvas(), this._context = this._canvas.getContext("2d"), this._textSplitter = new tn(this._context), this._finalCanvas = T.createCanvas(), this._finalContext = this._finalCanvas.getContext("2d"), this.updateFontVariation();
    }
  }, {
    key: "setOption",
    value: function setOption(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      _get(_getPrototypeOf(zs.prototype), "setOption", this).call(this, e, t, i, r), e === "fontIdentifier" && !r && this.updateFontVariation();
    }
  }, {
    key: "updateFontVariation",
    value: function updateFontVariation() {
      var e = re.getVariation(this.getFontIdentifier());
      return e || A.warn("TextDesignFont: Unable to find font '".concat(this._fontIdentifier, "'")), this.setFontVariation(e), e;
    }
  }, {
    key: "_applyTextOptions",
    value: function _applyTextOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._context;

      var _C2 = C(C({}, this._options), e),
          i = _C2.fontSize,
          r = _C2.fontVariation,
          o = _C2.lineHeight,
          n = _C2.textColor,
          a = _C2.alignment,
          _r$serializeOptions2 = r.serializeOptions(),
          l = _r$serializeOptions2.fontStyle,
          c = _r$serializeOptions2.fontWeight,
          u = _r$serializeOptions2.fontFamily;

      t.font = "".concat(l, " ").concat(c, " ").concat(i, "px \"").concat(u, "\""), t.fillStyle = n, t.textBaseline = "top", t.textAlign = a || "left";
    }
  }, {
    key: "_buildOutputLines",
    value: function _buildOutputLines(e) {
      return this._textSplitter.setText(this.getText()), this._textSplitter.setMaxWidth(e), this._textSplitter.getLines();
    }
  }, {
    key: "_renderTextLine",
    value: function _renderTextLine(e, t) {
      var i = this.getAlignment(),
          r = new Ch(0, t);

      switch (i) {
        case "center":
          r.x = this._canvas.width / 2;
          break;

        case "right":
          r.x = this._canvas.width;
          break;
      }

      this._context.fillText(e, r.x, r.y);
    }
  }, {
    key: "update",
    value: function update() {
      var e = this.calculateFontStyles();

      if (e) {
        var _this$_calculateText3 = this._calculateText(e),
            _t26 = _this$_calculateText3.dimensions,
            _i19 = _this$_calculateText3.lines;

        this._dimensions = _t26, this._renderText(_t26, _i19, e);
      }
    }
  }, {
    key: "draw",
    value: function draw(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      this.update(), e.drawImage(this._canvas, t, i, this._dimensions.x, this._dimensions.y);
    }
  }, {
    key: "_renderText",
    value: function _renderText(e, t, i) {
      this._canvas.width = e.x, this._canvas.height = e.y, this._context = this._canvas.getContext("2d"), this._applyTextOptions(i, this._context);

      for (var _r14 = 0; _r14 < t.length; _r14++) {
        var _o29 = t[_r14];

        this._renderTextLine(_o29, i.topPadding + i.lineHeight * _r14);
      }
    }
  }, {
    key: "getFontFamily",
    value: function getFontFamily() {
      return this.getFontVariation().getFontFamily();
    }
  }, {
    key: "calculateFontStyles",
    value: function calculateFontStyles() {
      var e = this.getFontFamily(),
          t = this.getFontSize(),
          i = this.getAbsoluteTextHeight(),
          r = i * this.getLineHeight(),
          o = i * (this.getLineHeight() - 1) / 2,
          n = {
        fontFamily: e,
        fontSize: t,
        textHeight: i,
        lineHeight: r,
        topPadding: o
      };
      return this._textOptions = C({}, n), n;
    }
  }, {
    key: "getTextMetrics",
    value: function getTextMetrics() {
      return this.getFontVariation().getTextMetrics();
    }
  }, {
    key: "getAbsoluteTextHeight",
    value: function getAbsoluteTextHeight() {
      var e = this.getFontSize(),
          t = this.getTextMetrics();

      if (t) {
        var _i20 = 1 / t.unitsPerEm * e,
            _r15 = t.ascender * _i20,
            _o30 = t.descender * _i20;

        return _r15 + Math.abs(_o30);
      }

      return e * this.getLineHeight() * 1.1;
    }
  }, {
    key: "_calculateText",
    value: function _calculateText(e) {
      this._applyTextOptions(e, this._context);

      var t = new Ch(),
          i = this.getText().split("\n"),
          r;
      if (typeof r != "undefined") t.x = r, i = this._buildOutputLines(r);else for (var _n21 = 0; _n21 < i.length; _n21++) {
        var _a16 = i[_n21];
        t.x = Math.max(t.x, this._context.measureText(_a16).width);
      }
      var o = e.lineHeight;
      return t.y = i.length * o, {
        dimensions: t,
        lines: i
      };
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      var e = this.calculateFontStyles(),
          _this$_calculateText4 = this._calculateText(e),
          t = _this$_calculateText4.dimensions;

      return t;
    }
  }, {
    key: "fitMaxHeight",
    value: function fitMaxHeight() {
      this.update();
      var e = this.getDimensions(),
          t = this.getText().split("\n"),
          i = this.getMaxHeight() / e.y;
    }
  }, {
    key: "fitMaxWidth",
    value: function fitMaxWidth() {
      var e = this.getDimensions().x,
          t = this.getMaxWidth() / e;
      this.setFontSize(this.getFontSize() * t), this._textOptions.fontSize = this.getFontSize();
    }
  }, {
    key: "fitInFrame",
    value: function fitInFrame(e) {
      this.setMaxWidth(e.width), this.setMaxHeight(e.height), this.fitMaxWidth(), this.fitMaxHeight();
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var e = this.getDimensions();
      return new pe(e.x, e.y);
    }
  }]);

  return zs;
}(V);

zs.prototype.availableOptions = {
  text: {
    type: m.STRING,
    default: ""
  },
  fontIdentifier: {
    type: m.STRING,
    default: "imgly_font_open_sans_bold"
  },
  fontVariation: {
    type: m.OBJECT,
    default: null
  },
  lineHeight: {
    type: m.NUMBER,
    default: 1
  },
  fontSize: {
    type: m.NUMBER,
    default: 22
  },
  textColor: {
    type: m.STRING,
    default: "black"
  },
  strokeStyle: {
    type: m.STRING,
    default: "black"
  },
  outlineWidth: {
    type: m.NUMBER,
    default: 0
  },
  textBaseline: {
    type: m.STRING,
    default: "alphabetic"
  },
  excludeAccents: {
    type: m.BOOLEAN,
    default: !0
  },
  maxWidth: {
    type: m.NUMBER,
    default: 100
  },
  maxHeight: {
    type: m.NUMBER,
    default: 0
  },
  alignment: {
    type: m.STRING,
    default: "left",
    available: ["left", "center", "right"]
  }
};

var hi =
/*#__PURE__*/
function (_Xt) {
  _inherits(hi, _Xt);

  function hi() {
    _classCallCheck(this, hi);

    return _possibleConstructorReturn(this, _getPrototypeOf(hi).apply(this, arguments));
  }

  _createClass(hi, [{
    key: "_calculateLayoutElements",
    value: function _calculateLayoutElements() {
      var e = this.getWords(),
          t = this._getTextFrame(),
          r = this.getAttributes().getFontIdentifier(),
          o = this.getImageInsets(),
          n = new Ye({
        text: e.getWord(0),
        fontIdentifier: r
      });

      n.fitWidth(t.width);
      var a = new qe({
        text: e.getWord(0),
        frame: t,
        font: n
      });
      a.setFrame(this._getTextFrameForElement(a));
      var l = this.getSize();
      return (this.getSizeToFitContent() || l.height <= 1) && (l.height = o.top + a.getFrame().height + o.bottom), l.height = Math.max(l.height, this.getMinimumHeight()), [a];
    }
  }, {
    key: "_getTextFrameForElement",
    value: function _getTextFrameForElement(e) {
      var i = this.getWords().getWord(0),
          r = this.getAttributes(),
          o = r.getFontIdentifier(),
          n = this.getImageInsets(),
          a = this.getImageInsets().applyToRectangle(this._getFrame()).scale(this.getTextScaleFactor()),
          l = new zs({
        text: i,
        fontIdentifier: o,
        alignment: r.getAlignment(),
        lineHeight: 1
      });
      l.fitInFrame(a);
      var c = l.getSize();
      a.height = c.height;
      var u = c.height * this.getRowScaleFactor();
      this.getSizeToFitContent() && (u += n.top + n.bottom);

      var p = this._getFrame(),
          h = r.getAlignment();

      if (this.getCenteredVertically()) a.y = p.height / 2 - u / 2 + n.top;else switch (h) {
        case "left":
          a.y = p.height - u - n.bottom;
          break;

        case "center":
          a.y = p.height / 2 - u / 2 + u * this.getCenterOffset(), a.x = (p.width - a.width) / 2;
          break;

        case "right":
          a.x = p.width - a.width - n.right;
          break;

        default:
          break;
      }
      return a;
    }
  }, {
    key: "render",
    value: function render(e) {
      var _this175 = this;

      e.save(), this._getLayoutElements().forEach(function (t) {
        var _t$serializeOptions2 = t.serializeOptions(),
            i = _t$serializeOptions2.text,
            r = _t$serializeOptions2.frame,
            o = _this175.getAttributes(),
            n = o.getFontIdentifier(),
            a = new zs({
          text: i,
          fontIdentifier: n,
          alignment: o.getAlignment(),
          lineHeight: 1,
          textColor: o.getTextColor().toRGBA()
        });

        r = _this175._getTextFrameForElement(t), a.fitInFrame(r), a.draw(e, r.x, r.y);
      }), e.restore();
    }
  }]);

  return hi;
}(Xt);

hi.prototype.availableOptions = C(C({}, Xt.prototype.availableOptions), {
  centerOffset: {
    type: m.NUMBER,
    default: 0
  },
  sizeToFitContent: {
    type: m.BOOLEAN,
    default: !1
  },
  textScaleFactor: {
    type: m.NUMBER,
    default: .95
  },
  rowScaleFactor: {
    type: m.NUMBER,
    default: 1
  },
  minimumHeight: {
    type: m.NUMBER,
    default: 0
  },
  centeredVertically: {
    type: m.BOOLEAN,
    default: !1
  }
});

var Tr =
/*#__PURE__*/
function (_Fe3) {
  _inherits(Tr, _Fe3);

  function Tr() {
    var _getPrototypeOf81;

    var _this176;

    _classCallCheck(this, Tr);

    for (var _len90 = arguments.length, e = new Array(_len90), _key90 = 0; _key90 < _len90; _key90++) {
      e[_key90] = arguments[_key90];
    }

    _this176 = _possibleConstructorReturn(this, (_getPrototypeOf81 = _getPrototypeOf(Tr)).call.apply(_getPrototypeOf81, [this].concat(e)));
    _this176._rowType = H.Box, _this176._alignmentRandomizer = new Z(0), _this176._isMaskedRandomizer = new Z(0), _this176._seedPool.push(_this176._alignmentRandomizer), _this176._seedPool.push(_this176._isMaskedRandomizer);
    return _this176;
  }

  _createClass(Tr, [{
    key: "getImagePaths",
    value: function getImagePaths() {
      return [H.Box.getImagePath()];
    }
  }, {
    key: "_modifiedText",
    value: function _modifiedText(e) {
      return _get(_getPrototypeOf(Tr.prototype), "_modifiedText", this).call(this, e).toLowerCase();
    }
  }, {
    key: "_modifiedLines",
    value: function _modifiedLines(e) {
      var t = new Be();
      return t.set([e.reduce(function (i, r) {
        return "".concat(i).concat(i === "" ? "" : "\n").concat(r.joined(1)[0]);
      }, "")]), [t];
    }
  }, {
    key: "_layoutRows",
    value: function _layoutRows(e, t) {
      var i = _get(_getPrototypeOf(Tr.prototype), "_layoutRows", this).call(this, e, t),
          r = i[0];

      if (r && this.getSquareLayout()) {
        var _o31 = r.getSize();

        _o31.height = _o31.width;
      }

      return i;
    }
  }, {
    key: "getAlignment",
    value: function getAlignment() {
      return this._alignmentRandomizer.pickNext(this.constructor.ValidAlignments || Tr.ValidAlignments);
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      var o = this.getAlignment(),
          n = this._rowType,
          a = re.getImage(n.getImagePath());
      r.setAlignment(o);
      var l = new hi({
        words: e,
        width: i,
        attributes: r,
        image: a,
        imageInsets: n.insetsForWidth(i),
        capInsets: n.getCapInsets(),
        backgroundColor: R.WHITE,
        centerOffset: 0,
        textScaleFactor: .7,
        isMasked: this._isMaskedRandomizer.nextBool()
      });
      this._rowType === H.Box && (l.serverImageSmoothingFix = !0);
      var c = l.getSize();
      return this.getSquareLayout() ? c.height = c.width : c.height = Math.max(c.height, c.width * n.getMinimumHeightRatio()), l;
    }
  }]);

  return Tr;
}(Fe),
    ve = Tr;

S(ve, "defaultFontIdentifiers", ["imgly_font_galano_grotesque_bold"]), S(ve, "Alignment", {
  Left: "left",
  Center: "center",
  Right: "right"
}), S(ve, "ValidAlignments", [Tr.Alignment.Left, Tr.Alignment.Center, Tr.Alignment.Right]), S(ve, "identifier", "imgly_text_design_masked");
ve.prototype.availableOptions = C(C({}, Fe.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: ve.defaultFontIdentifiers
  },
  squareLayout: {
    type: m.BOOLEAN,
    default: !0
  }
});

var pi =
/*#__PURE__*/
function (_ve) {
  _inherits(pi, _ve);

  function pi() {
    var _getPrototypeOf82;

    var _this177;

    _classCallCheck(this, pi);

    for (var _len91 = arguments.length, e = new Array(_len91), _key91 = 0; _key91 < _len91; _key91++) {
      e[_key91] = arguments[_key91];
    }

    _this177 = _possibleConstructorReturn(this, (_getPrototypeOf82 = _getPrototypeOf(pi)).call.apply(_getPrototypeOf82, [this].concat(e)));
    _this177._possibleRowTypes = [H.Badge1, H.Badge2, H.Badge3, H.Badge4], _this177._rowTypesRandomizer = new Z(0), _this177._isMaskedRandomizer = new Z(0), _this177._seedPool.push(_this177._rowTypesRandomizer), _this177._seedPool.push(_this177._isMaskedRandomizer);
    return _this177;
  }

  _createClass(pi, [{
    key: "getImagePaths",
    value: function getImagePaths() {
      return this._possibleRowTypes.map(function (e) {
        return e.getImagePath();
      });
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      this._rowType = this._rowTypesRandomizer.pickNext(this._possibleRowTypes), r.setLineSpacing(.9);

      var o = _get(_getPrototypeOf(pi.prototype), "_randomLayoutRow", this).call(this, e, t, i, r);

      return o.set({
        textScaleFactor: .9
      }), o;
    }
  }]);

  return pi;
}(ve);

S(pi, "defaultFontIdentifiers", ["imgly_font_campton_bold"]), S(pi, "identifier", "imgly_text_design_masked_badge"), S(pi, "ValidAlignments", [ve.Alignment.Center]);
pi.prototype.availableOptions = C(C({}, ve.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: pi.defaultFontIdentifiers
  }
});

var ut =
/*#__PURE__*/
function (_ve2) {
  _inherits(ut, _ve2);

  function ut() {
    var _getPrototypeOf83;

    var _this178;

    _classCallCheck(this, ut);

    for (var _len92 = arguments.length, e = new Array(_len92), _key92 = 0; _key92 < _len92; _key92++) {
      e[_key92] = arguments[_key92];
    }

    _this178 = _possibleConstructorReturn(this, (_getPrototypeOf83 = _getPrototypeOf(ut)).call.apply(_getPrototypeOf83, [this].concat(e)));
    _this178._possibleRowTypes = [H.SpeechBubble1, H.SpeechBubble3], _this178._rowTypesRandomizer = new Z(0), _this178._isMaskedRandomizer = new Z(0), _this178._seedPool.push(_this178._rowTypesRandomizer), _this178._seedPool.push(_this178._isMaskedRandomizer);
    return _this178;
  }

  _createClass(ut, [{
    key: "getImagePaths",
    value: function getImagePaths() {
      return this._possibleRowTypes.map(function (e) {
        return e.getImagePath();
      });
    }
  }, {
    key: "_rowTypes",
    value: function _rowTypes(e) {
      return this._possibleRowTypes;
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      this._rowType = this._rowTypesRandomizer.pickNext(this._rowTypes(e)), r.setLineSpacing(.9);

      var o = _get(_getPrototypeOf(ut.prototype), "_randomLayoutRow", this).call(this, e, t, i, r);

      return o.set({
        textScaleFactor: 1,
        minimumHeight: i * this._rowType.getMinimumHeightRatio(),
        sizeToFitContent: this._rowType.getSizeToFitContent(),
        centeredVertically: !0
      }), o;
    }
  }]);

  return ut;
}(ve);

S(ut, "defaultFontIdentifiers", ["imgly_font_roboto_black_italic", "imgly_font_roboto_light_italic", "imgly_font_roboto_black", "imgly_font_roboto_light"]), S(ut, "identifier", "imgly_text_design_masked_speech_bubble");
ut.prototype.availableOptions = C(C({}, ve.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: ut.defaultFontIdentifiers
  },
  squareLayout: {
    type: m.BOOLEAN,
    default: !1
  },
  alignment: {
    type: m.STRING,
    default: "left",
    available: ve.ValidAlignments
  }
});

var Hi =
/*#__PURE__*/
function (_ut) {
  _inherits(Hi, _ut);

  function Hi() {
    var _getPrototypeOf84;

    var _this179;

    _classCallCheck(this, Hi);

    for (var _len93 = arguments.length, e = new Array(_len93), _key93 = 0; _key93 < _len93; _key93++) {
      e[_key93] = arguments[_key93];
    }

    _this179 = _possibleConstructorReturn(this, (_getPrototypeOf84 = _getPrototypeOf(Hi)).call.apply(_getPrototypeOf84, [this].concat(e)));
    _this179._possibleRowTypes = [H.SpeechBubble2, H.SpeechBubble4, H.SpeechBubble2, H.SpeechBubble4, H.SpeechBubble5], _this179._possibleRowTypesForMin15 = _this179._possibleRowTypes.slice(0, 2), _this179._possibleRowTypesForMax14 = _this179._possibleRowTypes.slice(2);
    return _this179;
  }

  _createClass(Hi, [{
    key: "_rowTypes",
    value: function _rowTypes(e) {
      return e.countNumberOfCharacters() < 15 ? this._possibleRowTypesForMax14 : this._possibleRowTypesForMin15;
    }
  }]);

  return Hi;
}(ut);

S(Hi, "defaultFontIdentifiers", ["imgly_font_permanent_marker"]), S(Hi, "identifier", "imgly_text_design_masked_speech_bubble_comic");
Hi.prototype.availableOptions = C(C({}, ut.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Hi.defaultFontIdentifiers
  }
});

var ji =
/*#__PURE__*/
function (_ve3) {
  _inherits(ji, _ve3);

  function ji() {
    _classCallCheck(this, ji);

    return _possibleConstructorReturn(this, _getPrototypeOf(ji).apply(this, arguments));
  }

  _createClass(ji, [{
    key: "_modifiedText",
    value: function _modifiedText(e) {
      return _get(_getPrototypeOf(ji.prototype), "_modifiedText", this).call(this, e).toUpperCase();
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      var o = this._alignmentRandomizer.pickNext(ve.ValidAlignments);

      return r.setAlignment(o), new hi({
        words: e,
        width: i,
        attributes: r,
        image: null,
        backgroundColor: R.WHITE,
        centerOffset: 0,
        sizeToFitContent: !0,
        isMasked: !1,
        autoAdjustTextColor: !1
      });
    }
  }]);

  return ji;
}(ve);

S(ji, "defaultFontIdentifiers", ["imgly_font_abril_fatface_regular"]), S(ji, "identifier", "imgly_text_design_multiline");
ji.prototype.availableOptions = C(C({}, ve.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: ji.defaultFontIdentifiers
  }
});

var V_ = I.Rectangle,
    rn =
/*#__PURE__*/
function (_V20) {
  _inherits(rn, _V20);

  function rn() {
    _classCallCheck(this, rn);

    return _possibleConstructorReturn(this, _getPrototypeOf(rn).apply(this, arguments));
  }

  _createClass(rn, [{
    key: "getContentFrame",
    value: function getContentFrame() {
      var e = this.getFrame().clone(),
          t = e.width * .1;
      return e.insetBy(t, t);
    }
  }, {
    key: "intersects",
    value: function intersects(e) {
      return this.getFrame().intersects(e.getFrame());
    }
  }]);

  return rn;
}(V);

rn.prototype.availableOptions = {
  frame: {
    type: m.OBJECT,
    default: new V_()
  }
};

var wh = I.Rectangle,
    Dt =
/*#__PURE__*/
function (_Wi2) {
  _inherits(Dt, _Wi2);

  function Dt() {
    var _getPrototypeOf85;

    var _this180;

    _classCallCheck(this, Dt);

    for (var _len94 = arguments.length, e = new Array(_len94), _key94 = 0; _key94 < _len94; _key94++) {
      e[_key94] = arguments[_key94];
    }

    _this180 = _possibleConstructorReturn(this, (_getPrototypeOf85 = _getPrototypeOf(Dt)).call.apply(_getPrototypeOf85, [this].concat(e)));
    _this180._MAX_TRIES = 1e3, _this180._PRECISION = 1e3;
    return _this180;
  }

  _createClass(Dt, [{
    key: "render",
    value: function render(e, t, i, r, o) {
      var _this$_options29 = this._options,
          n = _this$_options29.imagePaths,
          a = _this$_options29.relativeParticleSize;
      if (n.length <= 0) return;
      var l = t.width / t.height,
          c = new wh(Math.round(i.left * this._PRECISION), Math.round(i.top * this._PRECISION * l), this._PRECISION, this._PRECISION);
      c.width -= c.x + Math.round(i.right * this._PRECISION), c.height -= c.y + Math.round(i.bottom * this._PRECISION * l);
      var u = [],
          p = 0,
          h = 0;

      for (; p < this.getParticleCount() && h < this._MAX_TRIES;) {
        var _d35 = a / 2,
            _g22 = Math.round(_d35 * this._PRECISION),
            _y16 = Math.round(_d35 * this._PRECISION * l),
            _21 = Math.floor(this._PRECISION) - _g22,
            _f18 = Math.floor(this._PRECISION) - _y16,
            _v11 = o.nextInRange(_g22, _21),
            _b10 = o.nextInRange(_y16, _f18),
            _D3 = new wh(_v11 - _g22, _b10 - _y16, 2 * _g22, 2 * _y16);

        !_D3.intersects(c) && !this.hasCollision(u, _D3) && (u.push(new rn({
          frame: _D3
        })), p += 1), h += 1;
      }

      for (var _d36 = 0; _d36 < u.length; _d36++) {
        var _g23 = u[_d36],
            _y17 = o.pickNext(n),
            _22 = re.getImage(_y17),
            _f19 = o.nextInRange(140, 230) / 255,
            _v12 = t.width / this._PRECISION,
            _b11 = t.height / this._PRECISION,
            _D4 = _g23.getContentFrame();

        _D4.x *= _v12, _D4.y *= _b11, _D4.width *= _v12, _D4.height *= _b11;

        var _O3 = r.clone();

        _O3.a = _f19, Kt(e, _22, _D4, _O3, "source-atop");
      }
    }
  }, {
    key: "hasCollision",
    value: function hasCollision(e, t) {
      for (var _i21 = 0; _i21 < e.length; _i21++) {
        if (t.intersects(e[_i21].getFrame())) return !0;
      }

      return !1;
    }
  }]);

  return Dt;
}(Wi);

Dt.prototype.availableOptions = C(C({}, Wi.prototype.availableOptions), {
  particleCount: {
    type: m.NUMBER,
    default: 50
  },
  relativeParticleSize: {
    type: m.NUMBER,
    default: .08
  },
  imagePaths: {
    type: m.ARRAY,
    default: []
  }
});

var Rr =
/*#__PURE__*/
function (_Dt) {
  _inherits(Rr, _Dt);

  function Rr() {
    _classCallCheck(this, Rr);

    return _possibleConstructorReturn(this, _getPrototypeOf(Rr).apply(this, arguments));
  }

  return Rr;
}(Dt);

S(Rr, "Images", ["text-design/images/imgly_text_design_particle_brush_01.png", "text-design/images/imgly_text_design_particle_brush_02.png", "text-design/images/imgly_text_design_particle_brush_03.png", "text-design/images/imgly_text_design_particle_brush_04.png", "text-design/images/imgly_text_design_particle_brush_05.png", "text-design/images/imgly_text_design_particle_brush_06.png", "text-design/images/imgly_text_design_particle_brush_07.png", "text-design/images/imgly_text_design_particle_brush_08.png", "text-design/images/imgly_text_design_particle_brush_09.png", "text-design/images/imgly_text_design_particle_brush_10.png"]);
Rr.prototype.availableOptions = C(C({}, Dt.prototype.availableOptions), {
  imagePaths: {
    type: m.ARRAY,
    default: _toConsumableArray(Rr.Images)
  },
  relativeParticleSize: {
    type: m.NUMBER,
    default: .12
  }
});

var Fr =
/*#__PURE__*/
function (_Dt2) {
  _inherits(Fr, _Dt2);

  function Fr() {
    _classCallCheck(this, Fr);

    return _possibleConstructorReturn(this, _getPrototypeOf(Fr).apply(this, arguments));
  }

  return Fr;
}(Dt);

S(Fr, "Images", ["text-design/images/imgly_text_design_particle_circle_01.png", "text-design/images/imgly_text_design_particle_circle_02.png", "text-design/images/imgly_text_design_particle_circle_03.png", "text-design/images/imgly_text_design_particle_circle_04.png", "text-design/images/imgly_text_design_particle_circle_05.png", "text-design/images/imgly_text_design_particle_circle_06.png", "text-design/images/imgly_text_design_particle_circle_07.png", "text-design/images/imgly_text_design_particle_circle_08.png", "text-design/images/imgly_text_design_particle_circle_09.png", "text-design/images/imgly_text_design_particle_circle_10.png"]);
Fr.prototype.availableOptions = C(C({}, Dt.prototype.availableOptions), {
  imagePaths: {
    type: m.ARRAY,
    default: _toConsumableArray(Fr.Images)
  },
  relativeParticleSize: {
    type: m.NUMBER,
    default: .12
  }
});

var Er =
/*#__PURE__*/
function (_Dt3) {
  _inherits(Er, _Dt3);

  function Er() {
    _classCallCheck(this, Er);

    return _possibleConstructorReturn(this, _getPrototypeOf(Er).apply(this, arguments));
  }

  return Er;
}(Dt);

S(Er, "Images", ["text-design/images/imgly_text_design_particle_triangle_01.png", "text-design/images/imgly_text_design_particle_triangle_02.png", "text-design/images/imgly_text_design_particle_triangle_03.png", "text-design/images/imgly_text_design_particle_triangle_04.png", "text-design/images/imgly_text_design_particle_triangle_05.png", "text-design/images/imgly_text_design_particle_triangle_06.png", "text-design/images/imgly_text_design_particle_triangle_07.png", "text-design/images/imgly_text_design_particle_triangle_08.png", "text-design/images/imgly_text_design_particle_triangle_09.png", "text-design/images/imgly_text_design_particle_triangle_10.png"]);
Er.prototype.availableOptions = C(C({}, Dt.prototype.availableOptions), {
  imagePaths: {
    type: m.ARRAY,
    default: _toConsumableArray(Er.Images)
  }
});

var gi =
/*#__PURE__*/
function (_Fe4) {
  _inherits(gi, _Fe4);

  function gi() {
    var _getPrototypeOf86;

    var _this181;

    _classCallCheck(this, gi);

    for (var _len95 = arguments.length, e = new Array(_len95), _key95 = 0; _key95 < _len95; _key95++) {
      e[_key95] = arguments[_key95];
    }

    _this181 = _possibleConstructorReturn(this, (_getPrototypeOf86 = _getPrototypeOf(gi)).call.apply(_getPrototypeOf86, [this].concat(e)));
    _this181._relativeInsets = new Y(0, 0, 0, 0), _this181._INVALID_FONTS_IF_LESS_THEN_5_CHARS = ["imgly_font_montserrat_light"], _this181._INVALID_FONTS_IF_LESS_THEN_4_CHARS = ["imgly_font_montserrat_light", "imgly_font_wolesbro"], _this181._lineCount = 0, _this181._decorativeRowCreated = !1, _this181._useImageRowRandomizer = new Z(0), _this181._rowTypeRandomizer = new Z(0), _this181._lineDecorativeTypeRandomizer = new Z(0), _this181._seedPool.push(_this181._useImageRowRandomizer), _this181._seedPool.push(_this181._rowTypeRandomizer), _this181._seedPool.push(_this181._lineDecorativeTypeRandomizer);
    return _this181;
  }

  _createClass(gi, [{
    key: "getImagePaths",
    value: function getImagePaths() {
      return [].concat(_toConsumableArray(gi.DecoratorImages), _toConsumableArray(gi.RowImages));
    }
  }, {
    key: "_fontForRow",
    value: function _fontForRow(e, t) {
      var _this182 = this;

      var i = t.countNumberOfCharacters(),
          r = this.getFontIdentifiers();
      return i < 4 ? r = r.filter(function (o) {
        return _this182._INVALID_FONTS_IF_LESS_THEN_4_CHARS.indexOf(o) < 0;
      }) : i < 5 && (r = r.filter(function (o) {
        return _this182._INVALID_FONTS_IF_LESS_THEN_5_CHARS.indexOf(o) < 0;
      })), r[e % r.length];
    }
  }, {
    key: "_modifiedText",
    value: function _modifiedText(e) {
      return _get(_getPrototypeOf(gi.prototype), "_modifiedText", this).call(this, e).toUpperCase();
    }
  }, {
    key: "_modifiedLines",
    value: function _modifiedLines(e) {
      return this._lineCount = e.length, e;
    }
  }, {
    key: "generateLayoutData",
    value: function generateLayoutData(e, t) {
      return this._decorativeRowCreated = !1, _get(_getPrototypeOf(gi.prototype), "generateLayoutData", this).call(this, e, t);
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      var o = r.getFontIdentifier(),
          n = e;

      switch (o) {
        case "imgly_font_wolesbro":
          n = new Be().set(e.getLowerCase());
          break;

        case "imgly_font_permanent_marker":
          n = new Be().set(e.getUpperCase());
          break;

        default:
          break;
      }

      var a = this.getDecorativeRowsInTheMiddleOnly() && (t === 0 || t === this._lineCount - 1);
      if (this._useImageRowRandomizer.nextBool() || this._decorativeRowCreated || a) return new ye({
        words: n,
        width: i,
        attributes: r
      });
      this._decorativeRowCreated = !0;

      var _this$_randomDecorato = this._randomDecoratorImages(),
          _this$_randomDecorato2 = _slicedToArray(_this$_randomDecorato, 2),
          l = _this$_randomDecorato2[0],
          c = _this$_randomDecorato2[1];

      return new Bt({
        words: e,
        width: i,
        attributes: r,
        leftImage: l,
        rightImage: c
      });
    }
  }, {
    key: "_layoutRows",
    value: function _layoutRows(e, t) {
      var i = _get(_getPrototypeOf(gi.prototype), "_layoutRows", this).call(this, e, t);

      if (!this.getDecorationsVisible()) return i;
      var r = .0625 * t,
          o = new Ee({
        width: t,
        height: r,
        image: re.getImage(this._rowTypeRandomizer.pickNext(gi.RowImages))
      }).layout(),
          n = new Ee({
        width: t,
        height: r,
        image: re.getImage(this._rowTypeRandomizer.pickNext(gi.RowImages))
      }).layout();
      return [o].concat(_toConsumableArray(i), [n]);
    }
  }, {
    key: "_randomDecoratorImages",
    value: function _randomDecoratorImages() {
      return this._lineDecorativeTypeRandomizer.nextInRange(0, 1) ? gi.DecoratorImages.slice(0, 2).map(function (e) {
        return re.getImage(e);
      }) : gi.DecoratorImages.slice(2).map(function (e) {
        return re.getImage(e);
      });
    }
  }]);

  return gi;
}(Fe),
    Me = gi;

S(Me, "defaultFontIdentifiers", ["imgly_font_permanent_marker", "imgly_font_wolesbro", "imgly_font_wolesbro", "imgly_font_montserrat_light"]), S(Me, "identifier", "imgly_text_design_sunshine"), S(Me, "RowImages", [Ee.RowImages.decorative1, Ee.RowImages.decorative2, Ee.RowImages.decorative3, Ee.RowImages.decorative4]), S(Me, "DecoratorImages", ["text-design/images/imgly_text_design_asset_decorative_03.png", "text-design/images/imgly_text_design_asset_decorative_04.png", "text-design/images/imgly_text_design_asset_decorative_07.png", "text-design/images/imgly_text_design_asset_decorative_08.png"]);
Me.prototype.availableOptions = C(C({}, Fe.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Me.defaultFontIdentifiers
  },
  relativeLineSpacing: {
    type: m.NUMBER,
    default: .025 / 3 * 4
  },
  decorationsVisible: {
    type: m.BOOLEAN,
    default: !0
  },
  decorativeRowsInTheMiddleOnly: {
    type: m.BOOLEAN,
    default: !1
  }
});

var fi =
/*#__PURE__*/
function (_Me) {
  _inherits(fi, _Me);

  function fi() {
    var _getPrototypeOf87;

    var _this183;

    _classCallCheck(this, fi);

    for (var _len96 = arguments.length, e = new Array(_len96), _key96 = 0; _key96 < _len96; _key96++) {
      e[_key96] = arguments[_key96];
    }

    _this183 = _possibleConstructorReturn(this, (_getPrototypeOf87 = _getPrototypeOf(fi)).call.apply(_getPrototypeOf87, [this].concat(e)));
    _this183._relativeInsets = new Y(.3, .3, .3, .3), _this183._backgroundRandomizer = new Z(0), _this183._decoTypeRandomizer = new Z(0), _this183._seedPool.push(_this183._backgroundRandomizer), _this183._seedPool.push(_this183._decoTypeRandomizer);
    return _this183;
  }

  _createClass(fi, [{
    key: "getImagePaths",
    value: function getImagePaths() {
      return [].concat(_toConsumableArray(Me.RowImages), _toConsumableArray(T.Array.flatten(fi.Backgrounds.map(function (e) {
        return e.getImagePaths();
      }))), _toConsumableArray(fi.DecoratorImages));
    }
  }, {
    key: "_getBackground",
    value: function _getBackground() {
      return this._backgroundRandomizer.pickNext(fi.Backgrounds);
    }
  }, {
    key: "_randomDecoratorImages",
    value: function _randomDecoratorImages() {
      switch (this._decoTypeRandomizer.nextInRange(0, 2)) {
        case 0:
          return fi.DecoratorImages.slice(0, 2).map(function (e) {
            return re.getImage(e);
          });

        case 1:
        case 2:
          return fi.DecoratorImages.slice(2).map(function (e) {
            return re.getImage(e);
          });

        default:
          return A.warn("TextDesignParticles#_randomDecoratorImages: Number generated not in valid range."), fi.DecoratorImages.slice(2).map(function (e) {
            return re.getImage(e);
          });
      }
    }
  }]);

  return fi;
}(Me),
    Qt = fi;

S(Qt, "defaultFontIdentifiers", ["imgly_font_permanent_marker", "imgly_font_wolesbro", "imgly_font_wolesbro", "imgly_font_montserrat_light"]), S(Qt, "identifier", "imgly_text_design_particles"), S(Qt, "Backgrounds", [new Rr(), new Fr(), new Er()]), S(Qt, "DecoratorImages", ["text-design/images/imgly_text_design_particle_holder_01.png", "text-design/images/imgly_text_design_particle_holder_02.png", "text-design/images/imgly_text_design_particle_holder_03.png", "text-design/images/imgly_text_design_particle_holder_04.png"]);
Qt.prototype.availableOptions = C(C({}, Me.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Qt.defaultFontIdentifiers
  },
  decorationsVisible: {
    type: m.BOOLEAN,
    default: !1
  },
  decorativeRowsInTheMiddleOnly: {
    type: m.BOOLEAN,
    default: !0
  }
});

var Yi =
/*#__PURE__*/
function (_Fe5) {
  _inherits(Yi, _Fe5);

  function Yi() {
    var _getPrototypeOf88;

    var _this184;

    _classCallCheck(this, Yi);

    for (var _len97 = arguments.length, e = new Array(_len97), _key97 = 0; _key97 < _len97; _key97++) {
      e[_key97] = arguments[_key97];
    }

    _this184 = _possibleConstructorReturn(this, (_getPrototypeOf88 = _getPrototypeOf(Yi)).call.apply(_getPrototypeOf88, [this].concat(e)));
    _this184._relativeInsets = new Y(.1, 0, 0, 0), _this184._rowTypeRandomizer = new Z(0), _this184._seedPool.push(_this184._rowTypeRandomizer);
    return _this184;
  }

  _createClass(Yi, [{
    key: "_modifiedText",
    value: function _modifiedText(e) {
      return _get(_getPrototypeOf(Yi.prototype), "_modifiedText", this).call(this, e).toUpperCase();
    }
  }, {
    key: "_randomLayoutRow",
    value: function _randomLayoutRow(e, t, i, r) {
      var o = _get(_getPrototypeOf(Yi.prototype), "_randomLayoutRow", this).call(this, e, t, i, r);

      return o.setShearingAngle(this.getShearingAngle()), o;
    }
  }, {
    key: "_layoutRows",
    value: function _layoutRows(e, t) {
      var i = _get(_getPrototypeOf(Yi.prototype), "_layoutRows", this).call(this, e, t),
          r = T.values(rt.FormType),
          o = 30,
          n = new rt({
        width: t,
        height: o,
        type: this._rowTypeRandomizer.pickNext(r),
        shearingAngle: this.getShearingAngle()
      }).layout(),
          a = new rt({
        width: t,
        height: o,
        type: this._rowTypeRandomizer.pickNext(r),
        shearingAngle: this.getShearingAngle()
      }).layout();

      return [n].concat(_toConsumableArray(i), [a]);
    }
  }]);

  return Yi;
}(Fe);

S(Yi, "defaultFontIdentifiers", ["imgly_font_campton_bold"]), S(Yi, "identifier", "imgly_text_design_rotated");
Yi.prototype.availableOptions = C(C({}, Fe.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: Yi.defaultFontIdentifiers
  },
  relativeLineSpacing: {
    type: m.NUMBER,
    default: .025 / 3
  },
  shearingAngle: {
    type: m.NUMBER,
    default: -.1
  }
});

var sn =
/*#__PURE__*/
function (_Me2) {
  _inherits(sn, _Me2);

  function sn() {
    var _getPrototypeOf89;

    var _this185;

    _classCallCheck(this, sn);

    for (var _len98 = arguments.length, e = new Array(_len98), _key98 = 0; _key98 < _len98; _key98++) {
      e[_key98] = arguments[_key98];
    }

    _this185 = _possibleConstructorReturn(this, (_getPrototypeOf89 = _getPrototypeOf(sn)).call.apply(_getPrototypeOf89, [this].concat(e)));
    _this185._relativeInsets = new Y(0, .3, 0, .3);
    return _this185;
  }

  _createClass(sn, [{
    key: "_layoutRows",
    value: function _layoutRows(e, t) {
      var i = _get(_getPrototypeOf(sn.prototype), "_layoutRows", this).call(this, e, t);

      if (!this.getDecorationsVisible()) return i;
      var r = 25,
          o = new Ee({
        width: t,
        height: r,
        image: re.getImage(this._rowTypeRandomizer.pickNext(Me.RowImages))
      }).layout(),
          n = new Ee({
        width: t,
        height: r,
        image: re.getImage(this._rowTypeRandomizer.pickNext(Me.RowImages))
      }).layout();
      return [o].concat(_toConsumableArray(i), [n]);
    }
  }]);

  return sn;
}(Me);

S(sn, "identifier", "imgly_text_design_sunshine-v3_1_0");

var qi =
/*#__PURE__*/
function (_ut2) {
  _inherits(qi, _ut2);

  function qi() {
    var _getPrototypeOf90;

    var _this186;

    _classCallCheck(this, qi);

    for (var _len99 = arguments.length, e = new Array(_len99), _key99 = 0; _key99 < _len99; _key99++) {
      e[_key99] = arguments[_key99];
    }

    _this186 = _possibleConstructorReturn(this, (_getPrototypeOf90 = _getPrototypeOf(qi)).call.apply(_getPrototypeOf90, [this].concat(e)));
    _this186._possibleRowTypes = [H.Watercolor1, H.Watercolor2, H.Watercolor3];
    return _this186;
  }

  return qi;
}(ut);

S(qi, "defaultFontIdentifiers", ["imgly_font_permanent_marker", "imgly_font_wolesbro", "imgly_font_wolesbro"]), S(qi, "identifier", "imgly_text_design_watercolor");
qi.prototype.availableOptions = C(C({}, ut.prototype.availableOptions), {
  fontIdentifiers: {
    type: m.ARRAY,
    default: qi.defaultFontIdentifiers
  },
  alignment: {
    type: m.STRING,
    default: ve.Alignment.Center,
    available: ve.ValidAlignments
  }
});

var H_ = I.Rectangle,
    on = 1e3,
    Ec =
/*#__PURE__*/
function () {
  function Ec() {
    _classCallCheck(this, Ec);

    this._layoutData = null, this._layout = null, this._text = "", this._seed = 0, this._debugMode = !1, this.randomizer = new Z();
  }

  _createClass(Ec, [{
    key: "createLayout",
    value: function createLayout(e, t, i) {
      this._layout = e, this._text = t, this._seed = i, e.seed(i), this._layoutData = e.generateLayoutData(t, on);
    }
  }, {
    key: "calculateAspect",
    value: function calculateAspect() {
      return this._layoutData ? this._layoutData.getSize().aspect() : (A.warn("TextDesignRenderer#calculateAspect: No layout data"), 1);
    }
  }, {
    key: "draw",
    value: function draw(e, t, i, r) {
      var _this187 = this;

      var o = this._layoutData;

      if (this._layoutData) {
        var _n22 = new pe(on, on / t.aspect()),
            _a17 = t.width / on,
            _l20 = o.getRelativeInsets().clone().scale(_n22.width),
            _c26 = o.getRelativeLineSpacing() * _n22.width,
            _u22 = _l20.top;

        e.save(), this.randomizer.seed(this._seed);

        var _p21 = o.getBackground();

        _p21 && _p21.render(e, t, o.getRelativeInsets(), r ? R.WHITE : i, this.randomizer), e.scale(_a17, _a17), o.getRows().forEach(function (h) {
          e.save();
          var d = h.getAttributes();

          if (e.transform(1, h.getShearingAngle(), 0, 1, _l20.left, _u22), d.setTextColor(r ? R.WHITE : i.clone()), d.setTintColor(r ? R.WHITE : i.clone()), (h instanceof Xt || h instanceof hi) && (h.setBackgroundColor(r ? R.WHITE : i.clone()), h.setIsUsedInInvertedLayout(r)), _this187._debugMode && (h._debugMode = !0), h.willRender(e), h.render(e), h.didRender(e), _this187._debugMode) {
            var _g24 = h._getFrame(),
                _y18 = h._getTextFrame();

            kr(e, _g24, R.GREEN), kr(e, _y18, R.BLUE), h._getLayoutElements().forEach(function (_) {
              var f = _.getFrame(),
                  v = h._getTextFrameForElement(_);

              kr(e, f, new R(1, 1, 0)), kr(e, v, new R(0, 1, 1));
            });
          }

          _u22 += h.getSize().height + _c26, e.restore();
        }), this._debugMode && kr(e, new H_(0, 0, _n22.width, _n22.height), R.RED), e.restore();
      }
    }
  }]);

  return Ec;
}();

var _i = I.Vector2,
    Sr =
/*#__PURE__*/
function (_It3) {
  _inherits(Sr, _It3);

  function Sr(e, t) {
    var _this188;

    _classCallCheck(this, Sr);

    _this188 = _possibleConstructorReturn(this, _getPrototypeOf(Sr).call(this, e, t));
    _this188._isDisposed = !1, _this188._renderer = new Ec(), _this188._canvas = T.createCanvas(), _this188._context = _this188._canvas.getContext("2d"), _this188._texture = k.Texture.fromCanvas(_this188._canvas), _this188._sprite.setTexture(_this188._texture), _this188._aspect = 1, _this188._isLayoutDirty = !0, _this188.getSeed() < 0 && _this188.setSeed(Z.TimeSeed());
    return _this188;
  }

  _createClass(Sr, [{
    key: "seed",
    value: function seed(e) {
      this.setSeed(e || Z.TimeSeed()), this._isLayoutDirty = !0;
    }
  }, {
    key: "_updateLayout",
    value: function _updateLayout() {
      var e = this.getLayout();
      return e ? (this._renderer.createLayout(e, this.getText(), this.getSeed()), this._aspect = this._renderer.calculateAspect(), this._isLayoutDirty = !1, !0) : null;
    }
  }, {
    key: "applyTransform",
    value: function applyTransform(e) {
      _get(_getPrototypeOf(Sr.prototype), "applyTransform", this).call(this, e);

      var t = {};
      this._options.dimensions && (t.width = e.applyToRelativeSize(this.getWidth())), this.set(t, !1);
    }
  }, {
    key: "applyFlip",
    value: function applyFlip(e) {
      _get(_getPrototypeOf(Sr.prototype), "applyFlip", this).call(this, e);

      var t = this._options.rotation;

      switch (e) {
        case "horizontal":
          t += (Math.PI - t) * 2, this.setRotation(t);
          break;

        case "vertical":
          t += (Math.PI / 2 - t) * 2, this.setRotation(t);
          break;
      }
    }
  }, {
    key: "update",
    value: function update(e, t) {
      var i = this._isLayoutDirty;
      if (this._isDisposed || i && !this._updateLayout()) return;
      var r = this.getWidth() * t.min() / e.getTextureScale(),
          o = r / this._aspect,
          n = new _i(r, o),
          a = new _i(Math.round(r * 2), Math.round(o * 2)).clamp(new _i(1, 1), new _i(Infinity, Infinity)),
          l = e.getRenderer(),
          c = l.getMaxDimensions() || Infinity;
      a.x > c && (a.x = c, a.y = Math.round(a.x / this._aspect)), a.y > c && (a.y = c, a.x = Math.round(a.y * this._aspect));
      var u = T.ensureCanvasDimensions(this._canvas, a);
      (i || u) && (this._context.clearRect(0, 0, this._canvas.width, this._canvas.height), this._renderer.draw(this._context, new pe(a.x, a.y), this.getColor(), this.getInverted()), this.setDimensions(n), this._texture.getBaseTexture().update(), l.isOfType(U.WEBGL) && l.updateTexture(this._texture.getBaseTexture())), _get(_getPrototypeOf(Sr.prototype), "update", this).call(this, e, t), this._applyFlip();
    }
  }, {
    key: "_applyFlip",
    value: function _applyFlip() {
      var e = this._sprite.getScale(),
          _this$_options30 = this._options,
          t = _this$_options30.flipHorizontally,
          i = _this$_options30.flipVertically;

      (t && e.x > 0 || !t && e.x < 0) && (e.x *= -1), (i && e.y > 0 || !i && e.y < 0) && (e.y *= -1), this._sprite.setScale(e);
    }
  }, {
    key: "_optionEquals",
    value: function _optionEquals(e, t) {
      if (e === "layout") {
        var _i22 = this._options.layout;
        return !(!_i22 && t || !t && _i22 || !t.constructor || !_i22.constructor || _i22.constructor.identifier !== t.constructor.identifier);
      }

      return _get(_getPrototypeOf(Sr.prototype), "_optionEquals", this).call(this, e, t);
    }
  }, {
    key: "serializeOptions",
    value: function serializeOptions(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      if (e && this.getPadding() < 0) {
        var _r16 = e.indexOf("padding");

        _r16 > -1 && e.splice(_r16, 1);
      }

      var i = _get(_getPrototypeOf(Sr.prototype), "serializeOptions", this).call(this, e, t);

      return e || (i.type = "textdesign"), i;
    }
  }, {
    key: "_getTexture",
    value: function _getTexture() {
      return this._texture;
    }
  }, {
    key: "canBeFlippedHorizontally",
    value: function canBeFlippedHorizontally() {
      return !1;
    }
  }, {
    key: "canBeDuplicated",
    value: function canBeDuplicated() {
      return !0;
    }
  }, {
    key: "canMaskCanvas",
    value: function canMaskCanvas() {
      return !0;
    }
  }, {
    key: "canAdjustPadding",
    value: function canAdjustPadding() {
      return !0;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._isDisposed = !0, this._texture.dispose(), this._sprite.dispose();
    }
  }]);

  return Sr;
}(It);

Sr.Layouts = {
  TextDesignBlocks: Ie,
  TextDesignBlocksCondensed: Ui,
  TextDesignBlocksLight: Pt,
  TextDesignCelebrate: ct,
  TextDesignCelebrateSimple: Gi,
  TextDesignEqualWidth: Lt,
  TextDesignEqualWidthFat: Vi,
  TextDesignMasked: ve,
  TextDesignMaskedBadge: pi,
  TextDesignMaskedSpeechBubble: ut,
  TextDesignMaskedSpeechBubbleComic: Hi,
  TextDesignMultiline: ji,
  TextDesignWatercolor: qi,
  TextDesignSunshine: Me,
  TextDesignParticles: Qt,
  TextDesignRotated: Yi
};
Sr.LegacyLayouts = {
  TextDesignBlocksLightV310: Ni,
  TextDesignSunshineV310: sn
};
Sr.AssetManager = re;
Sr.prototype.availableOptions = {
  id: {
    type: m.STRING,
    default: function _default() {
      return T.getUUID();
    }
  },
  position: {
    type: m.VECTOR2,
    default: new _i(.5, .5)
  },
  dimensions: {
    type: m.VECTOR2,
    default: _i.NULL
  },
  anchor: {
    type: m.VECTOR2,
    default: new _i(0, 0)
  },
  pivot: {
    type: m.VECTOR2,
    default: new _i(.5, .5)
  },
  rotation: {
    type: m.NUMBER,
    default: 0
  },
  flipHorizontally: {
    type: m.BOOLEAN,
    default: !1
  },
  flipVertically: {
    type: m.BOOLEAN,
    default: !1
  },
  layout: {
    type: m.OBJECT,
    default: null,
    setter: function setter(s) {
      return this._isLayoutDirty = !0, s;
    }
  },
  text: {
    type: m.STRING,
    default: "",
    setter: function setter(s) {
      return this._isLayoutDirty = !0, s;
    }
  },
  color: {
    type: m.COLOR,
    default: R.BLACK,
    setter: function setter(s) {
      return this._isLayoutDirty = !0, s;
    }
  },
  padding: {
    type: m.NUMBER,
    default: .01,
    minValue: .01
  },
  width: {
    type: m.NUMBER,
    default: .8
  },
  inverted: {
    type: m.BOOLEAN,
    default: !1,
    setter: function setter(s) {
      return this._isLayoutDirty = !0, s;
    }
  },
  seed: {
    type: m.NUMBER,
    default: -1
  }
};
var nn = Sr;

var Sc = I.Vector2,
    an =
/*#__PURE__*/
function (_It4) {
  _inherits(an, _It4);

  function an() {
    var _getPrototypeOf91;

    var _this189;

    _classCallCheck(this, an);

    for (var _len100 = arguments.length, e = new Array(_len100), _key100 = 0; _key100 < _len100; _key100++) {
      e[_key100] = arguments[_key100];
    }

    _this189 = _possibleConstructorReturn(this, (_getPrototypeOf91 = _getPrototypeOf(an)).call.apply(_getPrototypeOf91, [this].concat(e)));
    _this189._textRenderer = new vh(_assertThisInitialized(_assertThisInitialized(_this189)), _this189._operation), _this189._textRenderer.rotation = _this189.getRotation(), _this189._sprite.setTexture(_this189._textRenderer.getFinalTexture()), _this189._hitTestSprite.setTexture(_this189._textRenderer.getTexture());
    return _this189;
  }

  _createClass(an, [{
    key: "serializeOptions",
    value: function serializeOptions(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      var i = _get(_getPrototypeOf(an.prototype), "serializeOptions", this).call(this, e, t);

      return e || (i.type = "text"), i;
    }
  }, {
    key: "getDOMStyle",
    value: function getDOMStyle(e, t) {
      var i = this.getFontSize() * t.y;
      return {
        fontWeight: this._options.fontWeight,
        fontSize: "".concat(i, "px"),
        fontStyle: this._options.fontStyle,
        fontFamily: this._options.fontFamily,
        lineHeight: "".concat(this.getAbsoluteTextHeight(t) * this.getLineHeight(), "px"),
        color: this._options.color.toRGBA(),
        backgroundColor: this._options.backgroundColor.toRGBA(),
        textAlign: this._options.alignment
      };
    }
  }, {
    key: "getAbsoluteTextHeight",
    value: function getAbsoluteTextHeight(e) {
      var t = this.getFontSize() * e.y,
          i = this.getTextMetrics();

      if (i) {
        var _r17 = 1 / i.unitsPerEm * t,
            _o32 = i.ascender * _r17,
            _n23 = i.descender * _r17;

        return _o32 + Math.abs(_n23);
      }

      return t * this.getLineHeight() * 1.1;
    }
  }, {
    key: "getDimensions",
    value: function getDimensions(e, t) {
      return this._textRenderer.getDimensions(e, t);
    }
  }, {
    key: "applyFlip",
    value: function applyFlip(e) {
      _get(_getPrototypeOf(an.prototype), "applyFlip", this).call(this, e);

      var t = this._options.rotation;

      switch (e) {
        case "horizontal":
          t += (Math.PI - t) * 2, this.setRotation(t);
          break;

        case "vertical":
          t += (Math.PI / 2 - t) * 2, this.setRotation(t);
          break;
      }
    }
  }, {
    key: "applyTransform",
    value: function applyTransform(e) {
      _get(_getPrototypeOf(an.prototype), "applyTransform", this).call(this, e), this.set({
        fontSize: e.scaleSize(this.getFontSize(), "y"),
        maxWidth: e.scaleSize(this.getMaxWidth(), "x")
      }, !1);
    }
  }, {
    key: "applyRotation",
    value: function applyRotation(e) {
      _get(_getPrototypeOf(an.prototype), "applyRotation", this).call(this, e);

      var t = (e + 360) % 360,
          i = this._operation.getInputDimensions();

      (t === 90 || t === 270) && (this.setMaxWidth(this.getMaxWidth() / i.x * i.y), this.setFontSize(this.getFontSize() / i.y * i.x));
    }
  }, {
    key: "setOption",
    value: function setOption(e, t) {
      var _this$_options31 = this._options,
          i = _this$_options31.flipHorizontally,
          r = _this$_options31.flipVertically;

      if (e === "rotation") {
        var _o33 = t;
        i && (_o33 = Math.PI * 2 - _o33), r && (_o33 = Math.PI * 2 - _o33), this._options.rotation = _o33, this._textRenderer && (this._textRenderer.rotation = _o33), this._rotation = _o33, this.emit("update");
        return;
      }

      _get(_getPrototypeOf(an.prototype), "setOption", this).call(this, e, t);
    }
  }, {
    key: "getOption",
    value: function getOption(e) {
      return e === "rotation" ? this._rotation : _get(_getPrototypeOf(an.prototype), "getOption", this).call(this, e);
    }
  }, {
    key: "getHitTestDisplayObject",
    value: function getHitTestDisplayObject() {
      return this._hitTestSprite;
    }
  }, {
    key: "update",
    value: function update(e, t) {
      if (this._sprite.setVisible(this._options.visible), !this._options.visible) return;

      this._textRenderer.update(e, t);

      var i = this._textRenderer.getFinalTexture();

      i.getBaseTexture().update();
      var o = e.getRenderer();
      o.isOfType(U.WEBGL) && o.updateTexture(i.getBaseTexture()), _get(_getPrototypeOf(an.prototype), "update", this).call(this, e, t), this._sprite.setRotation(0), this._textRenderer.getTexture().getBaseTexture().update(), this._hitTestSprite.setRotation(this._rotation), this._hitTestSprite.updateTransform(), this._applyFlip();
    }
  }, {
    key: "_applyFlip",
    value: function _applyFlip() {
      var e = this._sprite.getScale(),
          _this$_options32 = this._options,
          t = _this$_options32.flipHorizontally,
          i = _this$_options32.flipVertically;

      (t && e.x > 0 || !t && e.x < 0) && (e.x *= -1, this.setRotation(this._rotation)), (i && e.y > 0 || !i && e.y < 0) && (e.y *= -1, this.setRotation(this._rotation)), this._sprite.setScale(e);
    }
  }, {
    key: "_getTexture",
    value: function _getTexture() {
      return this._textRenderer.getFinalTexture();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(an.prototype), "dispose", this).call(this), this._textRenderer.dispose(), this._hitTestSprite.dispose(), this._sprite.dispose();
    }
  }, {
    key: "canBeFlippedHorizontally",
    value: function canBeFlippedHorizontally() {
      return !1;
    }
  }, {
    key: "canAdjustPadding",
    value: function canAdjustPadding() {
      return !1;
    }
  }]);

  return an;
}(It);

an.prototype.availableOptions = {
  id: {
    type: m.STRING,
    default: function _default() {
      return T.getUUID();
    }
  },
  fontSize: {
    type: m.NUMBER,
    default: .1
  },
  characterSpacing: {
    type: m.NUMBER,
    default: 0
  },
  lineHeight: {
    type: m.NUMBER,
    default: 1.1
  },
  fontIdentifier: {
    type: m.STRING
  },
  fontFamily: {
    type: m.STRING,
    default: "Times New Roman"
  },
  fontWeight: {
    type: m.ALL,
    default: "normal"
  },
  fontStyle: {
    type: m.STRING,
    default: "normal"
  },
  textMetrics: {
    type: m.OBJECT,
    default: null
  },
  outlineWidth: {
    type: m.NUMBER,
    default: 0
  },
  outlineColor: {
    type: m.COLOR,
    default: R.BLACK
  },
  alignment: {
    type: m.STRING,
    default: "left",
    available: ["left", "center", "right"]
  },
  verticalAlignment: {
    type: m.STRING,
    default: "top",
    available: ["top", "center", "bottom"]
  },
  color: {
    type: m.COLOR,
    default: new R(1, 0, 0, 1)
  },
  backgroundColor: {
    type: m.COLOR,
    default: R.TRANSPARENT
  },
  position: {
    type: m.VECTOR2,
    default: new Sc(.5, .5)
  },
  anchor: {
    type: m.VECTOR2,
    default: new Sc(0, 0)
  },
  pivot: {
    type: m.VECTOR2,
    default: new Sc(.5, .5)
  },
  rotation: {
    type: m.NUMBER,
    default: 0
  },
  text: {
    type: m.STRING,
    required: !0
  },
  maxWidth: {
    type: m.NUMBER,
    default: .5
  },
  maxHeight: {
    type: m.NUMBER,
    default: 0
  },
  visible: {
    type: m.BOOLEAN,
    default: !0
  },
  flipHorizontally: {
    type: m.BOOLEAN,
    default: !1
  },
  flipVertically: {
    type: m.BOOLEAN,
    default: !1
  }
};
an.type = "text";
var ln = an;

var Ac = I.Vector2,
    Zt =
/*#__PURE__*/
function (_ee15) {
  _inherits(Zt, _ee15);

  function Zt() {
    var _getPrototypeOf92;

    var _this190;

    _classCallCheck(this, Zt);

    for (var _len101 = arguments.length, e = new Array(_len101), _key101 = 0; _key101 < _len101; _key101++) {
      e[_key101] = arguments[_key101];
    }

    _this190 = _possibleConstructorReturn(this, (_getPrototypeOf92 = _getPrototypeOf(Zt)).call.apply(_getPrototypeOf92, [this].concat(e)));
    _this190.setSmoothDownscaling(_this190._sdk.getOptions().smoothDownscaling), _this190._onSpriteUpdate = _this190._onSpriteUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this190))), _this190._maskCanvas = T.createCanvas(), _this190._options.sprites.slice().forEach(function (i) {
      _this190.removeSprite(i), _this190.addSprite(i);
    });
    return _this190;
  }

  _createClass(Zt, [{
    key: "getSpritesOfType",
    value: function getSpritesOfType(e) {
      return this._options.sprites.filter(function (t) {
        return t instanceof e;
      });
    }
  }, {
    key: "rotate",
    value: function rotate(e) {
      this._options.sprites.forEach(function (t) {
        t.applyRotation(e);
      });
    }
  }, {
    key: "flip",
    value: function flip(e) {
      this._options.sprites.forEach(function (t) {
        t.applyFlip(e);
      });
    }
  }, {
    key: "_onSpriteUpdate",
    value: function _onSpriteUpdate(e, t) {
      this.emit("update", this), this.setDirty(!0);
    }
  }, {
    key: "_applyRotation",
    value: function _applyRotation(e, t) {
      this._options.sprites.forEach(function (i) {
        return i.applyRotation(e, t);
      });
    }
  }, {
    key: "transform",
    value: function transform(e) {
      this._options.sprites.forEach(function (t) {
        return t.applyTransform(e);
      });
    }
  }, {
    key: "scale",
    value: function scale(e) {
      this._options.sprites.forEach(function (t) {
        return t.applyScale(e);
      });
    }
  }, {
    key: "serializeOption",
    value: function serializeOption(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return e === "sprites" ? this._options.sprites.map(function (i) {
        return i.serializeOptions(void 0, t);
      }) : _get(_getPrototypeOf(Zt.prototype), "serializeOption", this).call(this, e, t);
    }
  }, {
    key: "createSticker",
    value: function createSticker(e) {
      return new Qo(this, e);
    }
  }, {
    key: "createText",
    value: function createText(e) {
      return new ln(this, e);
    }
  }, {
    key: "createBrush",
    value: function createBrush(e) {
      return new Li(this, e);
    }
  }, {
    key: "createTextDesign",
    value: function createTextDesign(e) {
      return new nn(this, e);
    }
  }, {
    key: "addSprite",
    value: function addSprite(e) {
      this._options.sprites.push(e);

      var t = this.getSmoothDownscaling();
      e.setSmoothDownscaling && e.setSmoothDownscaling(t), this._container.addChild(e.getDisplayObject()), this.setDirty(!0), e.on("update", this._onSpriteUpdate), this.emit("update", this, this._options.sprites);
    }
  }, {
    key: "removeSprite",
    value: function removeSprite(e) {
      var t = this._options.sprites,
          i = t.indexOf(e);
      return i !== -1 ? (e.off("update", this._onSpriteUpdate), this._container.removeChild(e.getDisplayObject()), t.splice(i, 1), this.setDirty(!0), !0) : !1;
    }
  }, {
    key: "_getOrientatedStageSize",
    value: function _getOrientatedStageSize() {
      var e = this._sdk.getSprite().getTexture().getFrame(),
          t = this._sdk.getOperationsStack().getByIdentifier("orientation");

      if (t) {
        var _r18 = t ? t.getRotation() : 0;

        return _r18 === 270 || _r18 === 90 ? new Ac(e.height, e.width) : new Ac(e.width, e.height);
      }

      var i = this._sdk.getOperationsStack().getByIdentifier("output");

      return i ? i.getOutputResolution() : new Ac(e.width, e.height);
    }
  }, {
    key: "_render",
    value: function _render(e) {
      var _this191 = this;

      var t = this._container,
          i = this._options.sprites,
          r = e.getDimensions().clone().floor(),
          o = new k.Container();
      return o.addChild(this._sprite), Promise.all(i.map(function (n) {
        return n.validateSettings();
      })).then(function () {
        i.forEach(function (n) {
          return n.update(_this191._sdk, r);
        });
      }).then(function () {
        _this191._renderTexture.clear(), i.forEach(function (n) {
          n.getInverted && n.getInverted() ? (_this191._renderTexture.render(o), _this191._renderTexture.render(_this191._renderMaskedSprite(n.getDisplayObject(), n.getColor ? n.getColor() : R.WHITE, n.getPadding ? n.getPadding() : -1)), o = new k.Container()) : o.addChild(n.getDisplayObject());
        }), _this191._renderTexture.render(o), t.addChild(_this191._sprite), i.forEach(function (n) {
          return t.addChild(n.getDisplayObject());
        });
      });
    }
  }, {
    key: "_renderMaskedSprite",
    value: function _renderMaskedSprite(e, t, i) {
      var r = this._maskCanvas,
          o = e.getWorldTransform(),
          n = this._getOrientatedStageSize();

      T.ensureCanvasDimensions(r, n);
      var a = r.getContext("2d");
      if (a.clearRect(0, 0, r.width, r.height), a.save(), a.fillStyle = t.toRGBA(), i < 0) a.fillRect(0, 0, n.x, n.y);else {
        var _u23 = Math.abs(e.getWidth() / e.getScale().x),
            _p22 = Math.abs(e.getHeight() / e.getScale().y),
            _h24 = _u23 * i;

        a.transform(o.a, o.b, o.c, o.d, o.tx, o.ty), a.fillRect(-_h24, -_h24, _u23 + _h24 * 2, _p22 + _h24 * 2);
      }
      a.restore(), a.save(), a.globalCompositeOperation = "destination-out", e._renderCanvas({
        getCurrentRenderTarget: function getCurrentRenderTarget() {
          return {
            getPixelRatio: function getPixelRatio() {
              return 1;
            }
          };
        },
        beforeDraw: function beforeDraw(u) {
          var p = e.getWidth(),
              h = e.getHeight(),
              d = e.getScale(),
              g = d.x < 0,
              y = d.y < 0;
          u.translate(p, h), u.scale(g ? -1 : 1, y ? -1 : 1), u.translate(-p, -h);
        },
        getContext: function getContext() {
          return a;
        }
      }), a.restore();
      var l = new k.Container(),
          c = new k.Sprite(k.Texture.fromCanvas(r));
      return l.addChild(c), l;
    }
  }, {
    key: "takeSpriteToFront",
    value: function takeSpriteToFront(e) {
      var t = this._options.sprites,
          i = t.indexOf(e);
      if (i === -1) return;
      T.moveArrayItem(t, i, t.length - 1);
      var r = e.getDisplayObject();
      this._container.removeChild(r), this._container.addChild(r), this.setDirty(!0);
    }
  }, {
    key: "getSpritesAtPosition",
    value: function getSpritesAtPosition(e, t) {
      var _this192 = this;

      var i = [];

      this._options.sprites.forEach(function (u) {
        return u.update(_this192._sdk, t);
      });

      var r = this._sdk.getSprite(),
          o = r.getWorldTransform().applyInverseToVector(e),
          _r$getTexture$getFram = r.getTexture().getFrame(),
          n = _r$getTexture$getFram.width,
          a = _r$getTexture$getFram.height,
          l = r.getAnchor().clone().multiply(-n, -a);

      o.subtract(l);

      var c = this._options.sprites.slice(0).reverse();

      for (var _u24 = 0, _p23 = c.length; _u24 < _p23; _u24++) {
        var _h25 = c[_u24];
        _h25.getHitTestDisplayObject().isAtPosition(o) && i.push(_h25);
      }

      return i;
    }
  }, {
    key: "setDirtyForRenderer",
    value: function setDirtyForRenderer(e, t, i) {
      _get(_getPrototypeOf(Zt.prototype), "setDirtyForRenderer", this).call(this, e, t, i), this._options.sprites.forEach(function (r) {
        r.setDirtyForRenderer(e, t, i);
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Zt.prototype), "dispose", this).call(this), this._options.sprites.forEach(function (e) {
        e.dispose();
      });
    }
  }]);

  return Zt;
}(ee);

Zt.StickerSprite = Qo;
Zt.TextSprite = ln;
Zt.BrushSprite = Li;
Zt.TextDesignSprite = nn;
Zt.identifier = "sprite";
Zt.prototype.availableOptions = {
  sprites: {
    type: m.ARRAY,
    default: [],
    setter: function setter(s, e) {
      var _this193 = this;

      return s = s.map(function (t, i) {
        if (t instanceof It) return t;
        var r = C({}, t);

        switch (delete r.type, t.type) {
          case "text":
            return new ln(_this193, r);

          case "sticker":
            return new Qo(_this193, r);

          case "brush":
            return new Li(_this193, r);

          case "textdesign":
            return new nn(_this193, r);

          default:
            return A.error(_this193.constructor.name, "Invalid sprite type: ".concat(t.type)), null;
        }
      }), e || (this._options.sprites && this._options.sprites.slice().forEach(function (i) {
        i.dispose(), _this193.removeSprite(i);
      }), s.forEach(function (t) {
        _this193.addSprite(t);
      })), s;
    }
  },
  smoothDownscaling: {
    type: m.BOOLEAN,
    default: !1
  }
};
N.Operations.SpriteOperation = Zt;
var Dh = Zt;

var kh = I.Vector2,
    Th =
/*#__PURE__*/
function () {
  function Th(e, t) {
    _classCallCheck(this, Th);

    this._options = t, this._oldOptions = {
      start: e.getStart().clone(),
      end: e.getEnd().clone(),
      rotation: e.getRotation(),
      textureScale: e.getTextureScale()
    }, this._inputDimensions = e.getInputDimensions(!1), this._rotationDelta = t.rotation - e.getRotation(), this._deltaCos = Math.cos(this._rotationDelta), this._deltaSin = Math.sin(this._rotationDelta), this._oldAbsoluteSize = this._oldOptions.end.clone().subtract(this._oldOptions.start).multiply(this._inputDimensions), this._newAbsoluteSize = t.end.clone().subtract(t.start).multiply(this._inputDimensions), this._absoluteStartDiff = this._oldOptions.start.clone().subtract(t.start).multiply(this._inputDimensions), this._scaleRatio = e.calculateScale(t.rotation) / e.calculateScale(), this._sizeFactor = this._newAbsoluteSize.clone().divide(this._oldAbsoluteSize), this._textureScaleFactor = this._options.textureScale / e.getTextureScale();
  }

  _createClass(Th, [{
    key: "applyToRelativePoint",
    value: function applyToRelativePoint(e) {
      var t = this._oldOptions.start,
          i = this._oldOptions.end,
          o = t.clone().add(i.clone().subtract(t).divide(2)).multiply(this._inputDimensions),
          n = e.clone().multiply(this._oldAbsoluteSize).subtract(this._oldAbsoluteSize.clone().divide(2)),
          l = o.clone().add(n).clone().subtract(this._inputDimensions.clone().divide(2)),
          c = new kh(l.x * this._deltaCos - l.y * this._deltaSin, l.x * this._deltaSin + l.y * this._deltaCos),
          u = this._inputDimensions.clone().divide(2).add(c),
          p = this._options.start.clone().multiply(this._inputDimensions);

      return u.clone().subtract(p).divide(this._newAbsoluteSize);
    }
  }, {
    key: "applyToRelativeSize",
    value: function applyToRelativeSize(e) {
      return e * this._oldAbsoluteSize.min() / this._newAbsoluteSize.min();
    }
  }, {
    key: "applyToDimensions",
    value: function applyToDimensions(e) {
      return e = e.clone().multiply(this._scaleRatio), this._options.textureScale && e.multiply(this._textureScaleFactor), e;
    }
  }, {
    key: "scaleSize",
    value: function scaleSize(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "y";
      return e / this._sizeFactor[t];
    }
  }, {
    key: "applyToRotation",
    value: function applyToRotation(e) {
      return (e + this._rotationDelta) % (Math.PI * 2);
    }
  }, {
    key: "invert",
    value: function invert() {
      var e = this._options.start.clone(),
          t = this._options.end.clone(),
          i = this._inputDimensions,
          r = -this._rotationDelta,
          o = Math.cos(r),
          n = Math.sin(r),
          a = this._oldAbsoluteSize,
          l = this._newAbsoluteSize,
          c = e.clone().subtract(t).multiply(i),
          u = 1 / this._scaleRatio,
          p = new kh(1 / this._sizeFactor.x, 1 / this._sizeFactor.y),
          h = 1 / this._textureScaleFactor,
          d = this._oldOptions;

      return this._oldOptions = this._options, this._options = d, this._inputDimensions = i, this._rotationDelta = r, this._deltaCos = o, this._deltaSin = n, this._oldAbsoluteSize = l, this._newAbsoluteSize = a, this._absoluteStartDiff = c, this._scaleRatio = u, this._sizeFactor = p, this._textureScaleFactor = h, this;
    }
  }]);

  return Th;
}(),
    Rh = Th;

var Ic = I.Vector2,
    Ar =
/*#__PURE__*/
function (_ee16) {
  _inherits(Ar, _ee16);

  function Ar() {
    _classCallCheck(this, Ar);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ar).apply(this, arguments));
  }

  _createClass(Ar, [{
    key: "_render",
    value: function _render(e) {
      this._sprite.setRotation(0);

      var t = e.getDimensions(),
          _this$_options33 = this._options,
          i = _this$_options33.start,
          r = _this$_options33.end,
          o = _this$_options33.rotation,
          n = _this$_options33.textureScale,
          l = r.clone().subtract(i).clone().divide(2),
          c = i.clone().add(l),
          p = this.calculateScale() * n,
          h = t.clone().multiply(p).multiply(l);
      return this._sprite.setAnchor(c), this._sprite.setRotation(o), this._sprite.setScale(p, p), this._sprite.setPosition(h), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "calculateScale",
    value: function calculateScale() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._options.rotation;
      var t = this.getInputDimensions(!1),
          i = new Ic(Math.abs(t.x * Math.cos(e)) + Math.abs(t.y * Math.sin(e)), Math.abs(t.x * Math.sin(e)) + Math.abs(t.y * Math.cos(e))),
          r = t.clone().subtract(i.clone()).divide(2).abs(),
          o = 1;
      return r.y > r.x ? o = r.y * 2 / t.y + 1 : o = r.x * 2 / t.x + 1, o;
    }
  }, {
    key: "getNewDimensions",
    value: function getNewDimensions(e) {
      var _this$_options34 = this._options,
          t = _this$_options34.start,
          i = _this$_options34.end,
          r = _this$_options34.textureScale,
          o = this.calculateScale();
      return e.clone().multiply(r * o).multiply(i.clone().subtract(t)).round();
    }
  }, {
    key: "flip",
    value: function flip(e) {
      var _this$_options35 = this._options,
          t = _this$_options35.start,
          i = _this$_options35.end,
          r = t.clone();
      e === "horizontal" ? (t.set(1 - i.x, t.y), i.set(1 - r.x, i.y)) : e === "vertical" && (t.set(t.x, 1 - i.y), i.set(i.x, 1 - r.y));
    }
  }, {
    key: "rotate",
    value: function rotate(e) {
      var _this$_options36 = this._options,
          t = _this$_options36.start,
          i = _this$_options36.end,
          r = (e + 360) % 360,
          o = Math.floor(r / 90);

      for (var _n24 = 0; _n24 < o; _n24++) {
        var _a18 = t.clone();

        t.set(1 - i.y, _a18.x), i.set(1 - _a18.y, i.x);
      }
    }
  }, {
    key: "_onBeforeExport",
    value: function _onBeforeExport() {
      this._wasEnabledBeforeExport = this.getEnabled(), this.setEnabled(!0);
    }
  }, {
    key: "_onAfterExport",
    value: function _onAfterExport() {
      this.setEnabled(this._wasEnabledBeforeExport, !0);
    }
  }]);

  return Ar;
}(ee);

Ar.identifier = "transform";
Ar.prototype.availableOptions = {
  start: {
    type: m.VECTOR2,
    default: new Ic(0, 0)
  },
  end: {
    type: m.VECTOR2,
    default: new Ic(1, 1)
  },
  textureScale: {
    type: m.NUMBER,
    default: 1
  },
  rotation: {
    type: m.NUMBER,
    default: 0
  }
};
Ar.TransformChange = Rh;
N.Operations.TransformOperation = Ar;
var Fh = Ar;

var j_ = I.Vector2,
    Us =
/*#__PURE__*/
function (_ee17) {
  _inherits(Us, _ee17);

  function Us() {
    var _getPrototypeOf93;

    var _this194;

    _classCallCheck(this, Us);

    for (var _len102 = arguments.length, e = new Array(_len102), _key102 = 0; _key102 < _len102; _key102++) {
      e[_key102] = arguments[_key102];
    }

    _this194 = _possibleConstructorReturn(this, (_getPrototypeOf93 = _getPrototypeOf(Us)).call.apply(_getPrototypeOf93, [this].concat(e)));
    _this194._watermarkSprite = new k.Sprite(), _this194._watermarkSprite.setAnchor(.5, .5), _this194._container.addChild(_this194._watermarkSprite);
    return _this194;
  }

  _createClass(Us, [{
    key: "_render",
    value: function _render(e) {
      this._watermarkTexture || (this._watermarkTexture = k.Texture.fromImage(this._options.image), this._watermarkSprite.setTexture(this._watermarkTexture));
      var t = e.getDimensions(),
          _this$_options$image2 = this._options.image,
          i = _this$_options$image2.width,
          r = _this$_options$image2.height,
          o = T.resizeVectorToFit(new j_(i, r), t);
      return this._watermarkSprite.setPosition(t.clone().divide(2)), this._watermarkSprite.setWidth(o.x), this._watermarkSprite.setHeight(o.y), this._renderTexture.render(this._container), Promise.resolve();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Us.prototype), "dispose", this).call(this), this._watermarkSprite.dispose();
    }
  }]);

  return Us;
}(ee);

Us.identifier = "watermark";
Us.prototype.availableOptions = {
  image: {
    type: m.OBJECT,
    required: !0
  }
};
N.Operations.WatermarkOperation = Us;
var Eh = Us;
var Y_ = [Rm, Sm, zd, Nd, Hd, Yd, Kd, Xd, $d, eh, ah, Dh, Fh, Eh, Qd, Ud];
N.AllOperations = Y_;
var Sh = [{
  fontFamily: "Open Sans",
  variations: [{
    identifier: "imgly_font_open_sans_bold",
    fontWeight: "bold",
    provider: "file",
    filePath: "fonts/imgly_font_open_sans_bold.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 2189,
      descender: -600
    }
  }]
}, {
  fontFamily: "Aleo",
  variations: [{
    identifier: "imgly_font_aleo_bold",
    fontWeight: "bold",
    provider: "file",
    filePath: "fonts/imgly_font_aleo_bold.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 805,
      descender: -195
    }
  }]
}, {
  fontFamily: "Amatic SC",
  variations: [{
    identifier: "imgly_font_amaticsc",
    fontWeight: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_amaticsc.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 1016,
      descender: -245
    }
  }]
}, {
  fontFamily: "Archivo",
  variations: [{
    identifier: "imgly_font_archivo_black",
    fontWeight: "normal",
    filePath: "fonts/imgly_font_archivo_black.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 878,
      descender: -210
    }
  }]
}, {
  fontFamily: "Bungee Inline",
  variations: [{
    identifier: "imgly_font_bungee_inline",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_bungee_inline.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 860,
      descender: -140
    }
  }]
}, {
  fontFamily: "Campton Book",
  variations: [{
    identifier: "imgly_font_campton_bold",
    fontWeight: "bold",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_campton_bold.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 770,
      descender: -294
    }
  }]
}, {
  fontFamily: "Carter",
  variations: [{
    identifier: "imgly_font_carter_one",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_carter_one.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 2264,
      descender: -890
    }
  }]
}, {
  fontFamily: "Codystar",
  variations: [{
    identifier: "imgly_font_codystar",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_codystar.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1024,
      ascender: 953,
      descender: -255
    }
  }]
}, {
  fontFamily: "Fira Sans",
  variations: [{
    identifier: "imgly_font_fira_sans_regular",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_fira_sans_regular.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 935,
      descender: -265
    }
  }]
}, {
  fontFamily: "Galano Grotesque",
  variations: [{
    identifier: "imgly_font_galano_grotesque_bold",
    fontWeight: "bold",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_galano_grotesque_bold.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 800,
      descender: -200
    }
  }]
}, {
  fontFamily: "Krona One",
  variations: [{
    identifier: "imgly_font_krona_one",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_krona_one.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 2030,
      descender: -530
    }
  }]
}, {
  fontFamily: "Kumar One Outline",
  variations: [{
    identifier: "imgly_font_kumar_one_outline",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_kumar_one_outline.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 1137,
      descender: -642
    }
  }]
}, {
  fontFamily: "Lobster",
  variations: [{
    identifier: "imgly_font_lobster",
    fontWeight: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_lobster.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 1e3,
      descender: -250
    }
  }]
}, {
  fontFamily: "Molle",
  variations: [{
    identifier: "imgly_font_molle",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_molle.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 1852,
      descender: -701
    }
  }]
}, {
  fontFamily: "Monoton",
  variations: [{
    identifier: "imgly_font_monoton",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_monoton.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 2366,
      descender: -822
    }
  }]
}, {
  fontFamily: "Nixie One",
  variations: [{
    identifier: "imgly_font_nixie_one",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_nixie_one.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 926,
      descender: -210
    }
  }]
}, {
  fontFamily: "Notable",
  variations: [{
    identifier: "imgly_font_notable",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_notable.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 1143,
      descender: -157
    }
  }]
}, {
  fontFamily: "Ostrich",
  variations: [{
    identifier: "imgly_font_ostrich_sans_black",
    fontWeight: 800,
    provider: "file",
    filePath: "fonts/imgly_font_ostrich_sans_black.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 950,
      descender: -250
    }
  }, {
    identifier: "imgly_font_ostrich_sans_bold",
    fontWeight: "bold",
    provider: "file",
    filePath: "fonts/imgly_font_ostrich_sans_bold.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 950,
      descender: -250
    }
  }]
}, {
  fontFamily: "Oswald SemiBold",
  variations: [{
    identifier: "imgly_font_oswald_semi_bold",
    fontWeight: 600,
    fontStyle: "normal",
    filePath: "fonts/imgly_font_oswald_semi_bold.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 1193,
      descender: -289
    }
  }]
}, {
  fontFamily: "Palanquin Dark SemiBold",
  variations: [{
    identifier: "imgly_font_palanquin_dark_semi_bold",
    fontWeight: "bold",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_palanquin_dark_semi_bold.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 1320,
      descender: -491
    }
  }]
}, {
  fontFamily: "Poppins",
  variations: [{
    identifier: "imgly_font_poppins",
    fontWeight: "bold",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_poppins.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 1050,
      descender: -350
    }
  }]
}, {
  fontFamily: "Permanent Marker",
  variations: [{
    identifier: "imgly_font_permanent_marker",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_permanent_marker.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1024,
      ascender: 1136,
      descender: -325
    }
  }]
}, {
  fontFamily: "Roboto Black",
  variations: [{
    identifier: "imgly_font_roboto_black_italic",
    fontWeight: "normal",
    fontStyle: "italic",
    filePath: "fonts/imgly_font_roboto_black_italic.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 1900,
      descender: -500
    }
  }]
}, {
  fontFamily: "Roboto Light",
  variations: [{
    identifier: "imgly_font_roboto_light_italic",
    fontWeight: "normal",
    fontStyle: "italic",
    filePath: "fonts/imgly_font_roboto_light_italic.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 1900,
      descender: -500
    }
  }]
}, {
  fontFamily: "Sancreek",
  variations: [{
    identifier: "imgly_font_sancreek",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_sancreek.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 2104,
      descender: -738
    }
  }]
}, {
  fontFamily: "Stint Ultra Expanded",
  variations: [{
    identifier: "imgly_font_stint_ultra_expanded",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_stint_ultra_expanded.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 1853,
      descender: -483
    }
  }]
}, {
  fontFamily: "Trashhand",
  variations: [{
    identifier: "imgly_font_trash_hand",
    fontWeight: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_trash_hand.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 759,
      descender: -304
    }
  }]
}, {
  fontFamily: "VT323",
  variations: [{
    identifier: "imgly_font_vt323",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_vt323.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 800,
      descender: -200
    }
  }]
}, {
  fontFamily: "Yeseva One",
  variations: [{
    identifier: "imgly_font_yeseva_one",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_yeseva_one.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 915,
      descender: -240
    }
  }]
}];
var Ah = [{
  fontFamily: "Open Sans",
  variations: [{
    identifier: "imgly_font_open_sans_bold",
    fontWeight: "bold",
    provider: "file",
    filePath: "fonts/imgly_font_open_sans_bold.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 2189,
      descender: -600
    }
  }]
}, {
  fontFamily: "Abril Fatface",
  variations: [{
    identifier: "imgly_font_abril_fatface_regular",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_abril_fatface_regular.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 1058,
      descender: -291
    }
  }]
}, {
  fontFamily: "Amberlight",
  variations: [{
    identifier: "imgly_font_amberlight",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_amberlight.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 750,
      descender: -250
    }
  }]
}, {
  fontFamily: "Bungee Inline",
  variations: [{
    identifier: "imgly_font_bungee_inline",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_bungee_inline.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 860,
      descender: -140
    }
  }]
}, {
  fontFamily: "Campton Book",
  variations: [{
    identifier: "imgly_font_campton_bold",
    fontWeight: "bold",
    provider: "file",
    filePath: "fonts/imgly_font_campton_bold.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 770,
      descender: -294
    }
  }]
}, {
  fontFamily: "Galano Grotesque",
  variations: [{
    identifier: "imgly_font_galano_grotesque_bold",
    fontWeight: "bold",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_galano_grotesque_bold.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 800,
      descender: -200
    }
  }]
}, {
  fontFamily: "Handycheera",
  variations: [{
    identifier: "imgly_font_handycheera_regular",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_handycheera_regular.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 2199,
      descender: -808
    }
  }]
}, {
  fontFamily: "Montserrat Light",
  variations: [{
    identifier: "imgly_font_montserrat_light",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_montserrat_light.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 968,
      descender: -251
    }
  }]
}, {
  fontFamily: "Ostrich",
  variations: [{
    identifier: "imgly_font_ostrich_sans_black",
    fontWeight: 800,
    provider: "file",
    filePath: "fonts/imgly_font_ostrich_sans_black.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 950,
      descender: -250
    }
  }, {
    identifier: "imgly_font_ostrich_sans_bold",
    fontWeight: "bold",
    provider: "file",
    filePath: "fonts/imgly_font_ostrich_sans_bold.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 950,
      descender: -250
    }
  }, {
    identifier: "imgly_font_ostrich_sans_heavy",
    fontWeight: 900,
    provider: "file",
    filePath: "fonts/imgly_font_ostrich_sans_heavy.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 674,
      descender: 0
    }
  }]
}, {
  fontFamily: "Permanent Marker",
  variations: [{
    identifier: "imgly_font_permanent_marker",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_permanent_marker.woff",
    textMetrics: {
      unitsPerEm: 1024,
      ascender: 1136,
      descender: -325
    }
  }]
}, {
  fontFamily: "Petit Formal Script",
  variations: [{
    identifier: "imgly_font_petit_formal_script",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_petit_formal_script.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 2033,
      descender: -527
    }
  }]
}, {
  fontFamily: "Rasa",
  variations: [{
    identifier: "imgly_font_rasa_regular",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_rasa_regular.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 2750,
      ascender: 2300,
      descender: -1050
    }
  }, {
    identifier: "imgly_font_rasa_500",
    fontWeight: 500,
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_rasa_500.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 2750,
      ascender: 2300,
      descender: -1050
    }
  }]
}, {
  fontFamily: "Roboto Black",
  variations: [{
    identifier: "imgly_font_roboto_black",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_roboto_black.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 1900,
      descender: -500
    }
  }, {
    identifier: "imgly_font_roboto_black_italic",
    fontWeight: "normal",
    fontStyle: "italic",
    filePath: "fonts/imgly_font_roboto_black_italic.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 1900,
      descender: -500
    }
  }]
}, {
  fontFamily: "Roboto Light",
  variations: [{
    identifier: "imgly_font_roboto_light",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_roboto_light.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 1900,
      descender: -500
    }
  }, {
    identifier: "imgly_font_roboto_light_italic",
    fontWeight: "normal",
    fontStyle: "italic",
    filePath: "fonts/imgly_font_roboto_light_italic.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 1900,
      descender: -500
    }
  }]
}, {
  fontFamily: "Sue Ellen Francisco",
  variations: [{
    identifier: "imgly_font_sue_ellen_francisco",
    fontWeight: "normal",
    fontStyle: "normal",
    filePath: "fonts/imgly_font_sue_ellen_francisco.woff",
    provider: "file",
    textMetrics: {
      unitsPerEm: 1024,
      ascender: 1362,
      descender: -634
    }
  }]
}, {
  fontFamily: "Ultra",
  variations: [{
    identifier: "imgly_font_ultra",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_ultra.woff",
    default: !0,
    textMetrics: {
      unitsPerEm: 2048,
      ascender: 2066,
      descender: -561
    }
  }]
}, {
  fontFamily: "Wolesbro",
  variations: [{
    identifier: "imgly_font_wolesbro",
    fontWeight: "normal",
    fontStyle: "normal",
    provider: "file",
    filePath: "fonts/imgly_font_wolesbro.woff",
    textMetrics: {
      unitsPerEm: 1e3,
      ascender: 925,
      descender: -575
    }
  }]
}];
var Ih = [{
  identifier: "imgly_transforms_common",
  defaultName: "Common Ratios",
  ratios: [{
    identifier: "imgly_transform_common_custom",
    defaultName: "Custom",
    ratio: "*",
    selected: !0
  }, {
    identifier: "imgly_transform_common_square",
    defaultName: "Square",
    ratio: 1
  }, {
    identifier: "imgly_transform_common_4-3",
    defaultName: "4:3",
    ratio: 4 / 3
  }, {
    identifier: "imgly_transform_common_16-9",
    defaultName: "16:9",
    ratio: 16 / 9
  }]
}, {
  identifier: "imgly_transforms_facebook",
  defaultName: "Facebook",
  ratios: [{
    identifier: "imgly_transform_facebook_profile",
    defaultName: "Profile Pic",
    dimensions: {
      x: 300,
      y: 300
    },
    forceDimensions: !1,
    lockDimensions: !0
  }, {
    identifier: "imgly_transform_facebook_ad",
    defaultName: "Ad",
    dimensions: {
      x: 1200,
      y: 627
    }
  }, {
    identifier: "imgly_transform_facebook_post",
    defaultName: "Post",
    dimensions: {
      x: 940,
      y: 788
    }
  }, {
    identifier: "imgly_transform_facebook_cover",
    defaultName: "Cover",
    dimensions: {
      x: 851,
      y: 315
    }
  }]
}];
var Oh = [];
typeof N.Operations.SpriteOperation != "undefined" && Oh.push(N.Operations.SpriteOperation.BrushSprite.Brushes.RadialBrush);
var Ph = {
  TRANSFORM_RATIO_CATEGORIES: Ih,
  FONTS: Sh,
  TEXT_DESIGN_FONTS: Ah,
  BRUSHES: Oh
};
var q_ = C(C({}, lr), {
  LOAD: "load",
  SAVE: "save",
  EDITOR_RESIZE: "editor:resize",
  ZOOM: "editor:zoom",
  ZOOM_CHANGED: "editor:zoom_changed",
  HISTORY_REDO: "history:redo",
  HISTORY_BEFORE_REDO: "history:before-redo",
  TEXT_SCALED: "editor:text:scaled",
  TRANSFORM_RESIZE: "transform:resize",
  TRANSFORM_AFTER_EDIT: "transform:after-edit",
  ADDED_STICKER: "sticker:added-sticker",
  SPRITES_DESELECTED: "editor:sprite:deselected-all",
  CANVAS_FOCUS: "canvas:focus"
}),
    Bh = q_;
var de = {
  EVENTS: Bh,
  DEFAULTS: Ph
};

function K_() {
  var _navigator = navigator,
      s = _navigator.userAgent,
      e = _navigator.appVersion;
  return e.indexOf("MSIE") !== -1 ? e.match(/MSIE\s+?([0-9]+)/i)[1] : s.indexOf("Trident") !== -1 ? s.match(/rv:([0-9]+)/i)[1] : !1;
}

var Mh = {
  getIEVersion: K_
};
var X_ = N.Utils,
    cn = N.Math.Vector2,
    Q_ = {
  getInnerDimensionsForElement: function getInnerDimensionsForElement(s) {
    var e = new cn(s.offsetWidth, s.offsetHeight),
        t = window.getComputedStyle(s, null);
    return e.x -= parseInt(t.getPropertyValue("padding-left"), 10), e.x -= parseInt(t.getPropertyValue("padding-right"), 10), e.y -= parseInt(t.getPropertyValue("padding-top"), 10), e.y -= parseInt(t.getPropertyValue("padding-bottom"), 10), e;
  },
  getEventPosition: function getEventPosition(s) {
    var e = s.clientX,
        t = s.clientY;

    if (s.type.indexOf("touch") !== -1) {
      if (!s.touches.length) return;
      e = s.touches[0].clientX, t = s.touches[0].clientY;
    }

    return new cn(e, t);
  },
  createTransparentPatternCanvas: function createTransparentPatternCanvas() {
    var s = document.createElement("canvas"),
        e = s.getContext("2d");
    return s.width = 10, s.height = 10, e.fillStyle = "white", e.fillRect(0, 0, s.width, s.height), e.fillStyle = "#cccccc", e.fillRect(0, 0, s.width / 2, s.height / 2), e.fillRect(s.width / 2, s.height / 2, s.width, s.height), s;
  },
  supportsMSBlob: function supportsMSBlob() {
    return typeof document.createElement("canvas").msToBlob != "undefined";
  },
  translate: function translate(s, e) {
    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i = this.fetch(s, e);
    if (!i) return A.info("Utils#translate", "Unable to translate `".concat(e, "`")), null;

    for (var _r19 in t) {
      i = i.replace("${".concat(_r19, "}"), t[_r19]);
    }

    return i;
  },
  fetch: function fetch(s, e, t) {
    e = e.replace(/\[(\w+)]/g, ".$1"), e = e.replace(/^\./, "");
    var i = e.split(".");

    for (var _r20 = 0; _r20 < i.length; _r20++) {
      var _o34 = i[_r20];
      if (s = s[_o34], !s) break;
    }

    return typeof s == "undefined" ? !1 : s;
  },
  isMobile: function isMobile() {
    var s = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(s) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(s.substr(0, 4));
  },
  select: function select(s, e) {
    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    t || (t = function t(r) {
      return r;
    });
    var i = [];
    return e.forEach(function (r) {
      s.forEach(function (o) {
        t(o) === r && i.push(o);
      });
    }), i;
  },
  getJSONP: function getJSONP(s) {
    return new Rt(s).load();
  },
  cloneCategories: function cloneCategories(s, e) {
    return s.map(function (t) {
      return t = X_.clone(t), t[e] = t[e].slice(0), t;
    });
  },
  mergeCategories: function mergeCategories(s, e, t) {
    s = this.cloneCategories(s, t);
    var i = null;
    return e.forEach(function (r) {
      s.forEach(function (o) {
        r.identifier === o.identifier && (i = o);
      }), i ? i[t] = i[t].concat(r[t]) : s.push(r);
    }), s;
  },
  wrapFiltersInCategories: function wrapFiltersInCategories(s, e) {
    return s.map(function (t) {
      var i = t;
      return e in i || (i = _defineProperty({
        identifier: "imgly_filters_wrapped-".concat(t.identifier),
        displayFlat: !0
      }, e, [t])), i;
    });
  },
  getStyleObject: function getStyleObject(s) {
    var e = window.getComputedStyle(s),
        t = {};

    for (var _i24 in e) {
      var _r21 = e.getPropertyValue(_i24),
          _o35 = _i24.replace(/-([a-z])/g, function (n, a) {
        return a.toUpperCase();
      });

      _r21 !== "" && (t[_o35] = _r21);
    }

    return t;
  },
  styleElement: function styleElement(s, e) {
    for (var _t27 in e) {
      s.style[_t27] = e[_t27];
    }
  },
  debounce: function debounce(s, e, t) {
    var i;
    return function () {
      var _this195 = this;

      for (var _len103 = arguments.length, r = new Array(_len103), _key103 = 0; _key103 < _len103; _key103++) {
        r[_key103] = arguments[_key103];
      }

      var o = function o() {
        i = null, t || s.apply(_this195, r);
      },
          n = t && !i;

      clearTimeout(i), i = setTimeout(o, e), n && s.apply(this, r);
    };
  },
  getScrollbarWidth: function getScrollbarWidth() {
    var s = document.createElement("div");
    s.style.visibility = "hidden", s.style.width = "100px", s.style.msOverflowStyle = "scrollbar", document.body.appendChild(s);
    var e = s.offsetWidth;
    s.style.overflow = "scroll";
    var t = document.createElement("div");
    t.style.width = "100%", s.appendChild(t);
    var i = t.offsetWidth;
    return s.parentNode.removeChild(s), e - i;
  },
  findIntegerFraction: function findIntegerFraction(s) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var t = Number.MAX_VALUE,
        i = 0,
        r = 0,
        o = 1,
        n = 1;

    for (var _a19 = 0; _a19 < e; _a19++) {
      var _l21 = o / n - s;

      if (_l21 < 0) o++;else if (_l21 > 0) n++;else return new cn(o, n);

      var _c27 = Math.abs(o / n - s);

      _c27 < t && (t = _c27, i = o, r = n);
    }

    return new cn(i, r);
  },
  toFixed: function toFixed(s) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var t = s.toFixed(e);
    return parseFloat(t);
  },
  capitalize: function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  },
  flipObject: function flipObject(s) {
    var e = {};

    for (var _t28 in s) {
      e[s[_t28]] = _t28;
    }

    return e;
  },
  Browser: Mh
},
    Ke = Q_;
var un = N.Base64,
    ie = N.Color,
    C3 = N.Math.ColorMatrix,
    Ns = N.EventEmitter;
var oe = N.Utils,
    yi = N.RenderType,
    Oc = N.ImageFormat,
    W = N;
var $ = N.Math.Vector2,
    w3 = N.Math.Rectangle,
    D3 = N.Math.Range,
    k3 = typeof window != "undefined" && window.performance && window.performance.now ? window.performance.now.bind(window.performance) : ke();

var Ir =
/*#__PURE__*/
function () {
  function Ir(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

    _classCallCheck(this, Ir);

    this._ui = e, this._options = t, this._categoriesById = {}, this._filtersByIdentifier = {
      identity: W.Operations.FilterOperation.Filters.IdentityFilter
    }, this._categories = Ke.wrapFiltersInCategories(Vt.DEFAULTS.FILTERS.slice(0), Ir.CATEGORY_ITEMS_PROPERTY), this._customAssetsAllowed = i || e.getEditor().getSDK()._l.areCustomAssetsAllowed(), this._customAssetsAllowed && this._options.categories && (this._options.categories = Ke.wrapFiltersInCategories(this._options.categories, Ir.CATEGORY_ITEMS_PROPERTY)), this._initCategories();
  }

  _createClass(Ir, [{
    key: "instantiateFilterWithIdentifier",
    value: function instantiateFilterWithIdentifier(e) {
      var _this196 = this;

      var t = {
        value: this._ui._options.crossOrigin,
        cors: !0
      },
          i = this.getFilterByIdentifier(e);
      if (!i) return Promise.reject(new Error("Unknown filter with identifier `".concat(e, "`!")));

      if (!(i.prototype instanceof W.Operations.FilterOperation.Filter)) {
        var _r22 = i.lutImage,
            _o36 = i.resolution,
            _n25 = i.horizontalTileCount,
            _a20 = i.verticalTileCount,
            _l22 = i.lightColor,
            _c28 = i.darkColor;
        if (_l22 && _c28) return _l22 = ie.fromHex(_l22), _c28 = ie.fromHex(_c28), Promise.resolve(new W.Operations.FilterOperation.Filters.DuoToneFilter({
          lightColor: _l22,
          darkColor: _c28
        }));

        var _u25;

        this._ui.getPreloader && (_u25 = this._ui.getPreloader().getAsset(_r22));

        var _p24;

        return _u25 ? _p24 = Promise.resolve(_u25) : _p24 = at.loadImage(this._ui.getAssetPath(_r22), t), _p24.then(function () {
          return at.loadImage(_this196._ui.getAssetPath(_r22), t).then(function (h) {
            return new W.Operations.FilterOperation.Filters.ThreeDLUTFilter({
              image: h,
              resolution: _o36,
              horizontalTileCount: _n25,
              verticalTileCount: _a20
            });
          });
        });
      }

      return Promise.resolve(new i());
    }
  }, {
    key: "_initCategories",
    value: function _initCategories() {
      var _this197 = this;

      if (this._customAssetsAllowed && this._options.categories && (this._options.replaceCategories ? this._categories = Ke.wrapFiltersInCategories(this._options.categories, Ir.CATEGORY_ITEMS_PROPERTY) : this._categories = Ke.mergeCategories(this._categories, this._options.categories, Ir.CATEGORY_ITEMS_PROPERTY)), this._customAssetsAllowed && this._options.availableFilters) {
        var _t29 = [];
        this._categories.forEach(function (i) {
          var r = i.filters.filter(function (o) {
            return _this197._options.availableFilters.indexOf(o.identifier) !== -1;
          });
          r.length > 0 && _t29.push({
            identifier: i.identifier,
            defaultName: i.defaultName,
            filters: r
          });
        }), this._categories = _t29;
      }

      var e = {
        identifier: "all",
        defaultName: "All",
        visible: !1,
        filters: this._categories.length <= 0 ? [] : this._categories.map(function (t) {
          return t.filters;
        }).reduce(function (t, i) {
          return t.concat(i);
        })
      };
      this._categories.unshift(e), this._categoriesById.all = e, this._categories.forEach(function (t) {
        _this197._categoriesById[t.identifier] = t;
      }), e.filters.forEach(function (t) {
        _this197._filtersByIdentifier[t.identifier] = t;
      });
    }
  }, {
    key: "getFiltersForCategory",
    value: function getFiltersForCategory(e) {
      if (!this._categoriesById[e]) throw new Error("Unknown filter category '".concat(e, "'"));
      return this._categoriesById[e].filters;
    }
  }, {
    key: "getItemsByCategory",
    value: function getItemsByCategory(e) {
      return this.getFiltersForCategory(e);
    }
  }, {
    key: "getFilterByIdentifier",
    value: function getFilterByIdentifier(e) {
      return this._filtersByIdentifier[e];
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      return this._categories;
    }
  }, {
    key: "getCategoryByIdentifier",
    value: function getCategoryByIdentifier(e) {
      return this._categoriesById[e];
    }
  }]);

  return Ir;
}(),
    mn = Ir;

S(mn, "CATEGORY_ITEMS_PROPERTY", "filters");
var dn = mn;

var hn =
/*#__PURE__*/
function (_V21) {
  _inherits(hn, _V21);

  function hn() {
    _classCallCheck(this, hn);

    return _possibleConstructorReturn(this, _getPrototypeOf(hn).apply(this, arguments));
  }

  return hn;
}(V),
    Lh = hn;

hn.prototype.availableOptions = {
  fontFamily: {
    type: m.STRING,
    required: !0
  },
  variations: {
    type: m.ARRAY,
    required: !0
  }
};

var Z_ = {
  100: "Extra Light",
  200: "Light",
  300: "Book",
  400: "Regular",
  500: "Medium",
  600: "Semibold",
  700: "Bold",
  800: "Black",
  900: "Extra Black",
  bold: "Bold",
  normal: "Regular"
},
    pn =
/*#__PURE__*/
function (_V22) {
  _inherits(pn, _V22);

  function pn() {
    _classCallCheck(this, pn);

    return _possibleConstructorReturn(this, _getPrototypeOf(pn).apply(this, arguments));
  }

  _createClass(pn, [{
    key: "getLabel",
    value: function getLabel() {
      var e = Z_[this._options.fontWeight];

      switch (this._options.fontStyle) {
        case "italic":
          e += " Italic";
          break;
      }

      return e;
    }
  }]);

  return pn;
}(V),
    gn = pn;

pn.prototype.availableOptions = {
  identifier: {
    type: m.STRING,
    required: !0
  },
  fontFamily: {
    type: m.STRING,
    required: !0
  },
  fontWeight: {
    type: m.ALL,
    default: 400
  },
  fontStyle: {
    type: m.STRING,
    default: "normal"
  },
  textMetrics: {
    type: m.OBJECT,
    default: null
  },
  provider: {
    type: m.STRING,
    available: ["google", "file"]
  },
  filePath: {
    type: m.STRING
  },
  default: {
    type: m.BOOLEAN,
    default: !1
  },
  font: {
    type: m.OBJECT
  }
};

var Pc =
/*#__PURE__*/
function () {
  function Pc(e, t) {
    _classCallCheck(this, Pc);

    this._ui = e, this._options = t, this._fonts = [], this._variationsByIdentifier = {}, this._fontsByFontFamily = {}, this._initFonts();
  }

  _createClass(Pc, [{
    key: "_initFonts",
    value: function _initFonts() {
      var _this198 = this,
          _n$0$getVariations,
          _n$0$getVariations2;

      var _this$_options37 = this._options,
          e = _this$_options37.fonts,
          t = _this$_options37.replaceFonts,
          i = _this$_options37.availableVariations,
          r = _this$_options37.isTextDesign,
          o = !0;
      o = this._ui.getEditor().getSDK()._l.areCustomAssetsAllowed(), e && o && e.forEach(function (_ref44, c) {
        var l = _ref44.variations;
        l && l.forEach(function (u, p) {
          if (Ci[u.identifier]) {
            var _h26 = es(u.identifier, !0);

            e[c].variations[p].identifier = _h26;

            var _de$DEFAULTS$FONTS$fi = de.DEFAULTS.FONTS.find(function (g) {
              return g.variations.some(function (y) {
                return y.identifier === _h26;
              });
            }),
                _d37 = _de$DEFAULTS$FONTS$fi.fontFamily;

            e[c].fontFamily = _d37;
          }
        });
      });
      var n = r ? de.DEFAULTS.TEXT_DESIGN_FONTS : de.DEFAULTS.FONTS;
      o && (t ? n = e : n = n.concat(e || []));
      var a;
      n = n.map(function (l) {
        var c = l.fontFamily,
            u = l.variations;
        if (o && i && (u = u.filter(function (h) {
          return i.indexOf(h.identifier) !== -1;
        })), u.length === 0) return null;
        var p = new Lh({
          fontFamily: c
        });
        return u = u.map(function (h) {
          var d = new gn(h);
          return d.setFontFamily(c), d.setFont(p), h.default && !a && (a = d), d.getTextMetrics() == null && A.warn("Missing font metrics for ".concat(d.getIdentifier(), ". The SDK will fall back to basic font rendering, which may lead to layout issues. Please provide font metrics for your custom fonts. See https://docs.photoeditorsdk.com/guides/html5/ for more details.")), _this198._variationsByIdentifier[d.getIdentifier()] = d, d;
        }), p.setVariations(u), _this198._fontsByFontFamily[c] = p, p;
      }).filter(function (l) {
        return l;
      }), a || (_n$0$getVariations = n[0].getVariations(), _n$0$getVariations2 = _slicedToArray(_n$0$getVariations, 1), a = _n$0$getVariations2[0], _n$0$getVariations), this._defaultVariation = a, this._fonts = n;
    }
  }, {
    key: "getFonts",
    value: function getFonts() {
      return this._fonts;
    }
  }, {
    key: "getFontByFontFamily",
    value: function getFontByFontFamily(e) {
      return this._fontsByFontFamily[e];
    }
  }, {
    key: "getVariationByIdentifier",
    value: function getVariationByIdentifier(e) {
      return this._variationsByIdentifier[es(e)];
    }
  }, {
    key: "getVariationsByIdentifier",
    value: function getVariationsByIdentifier() {
      return C({}, this._variationsByIdentifier);
    }
  }, {
    key: "getDefaultVariation",
    value: function getDefaultVariation() {
      return this._defaultVariation;
    }
  }]);

  return Pc;
}(),
    st = Pc;

var Bc =
/*#__PURE__*/
function () {
  function Bc(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Bc);

    this._ui = e, this._options = t, this._defaultLayouts = W.Operations.SpriteOperation.TextDesignSprite.Layouts, this._legacyLayouts = W.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts, this._layouts = [], this._init();
  }

  _createClass(Bc, [{
    key: "_init",
    value: function _init() {
      var e = this._options.availableLayouts,
          t = C(C({}, this._defaultLayouts), this._legacyLayouts);
      this._layouts = Object.keys(t).map(function (i) {
        return {
          identifier: t[i].identifier,
          layout: t[i]
        };
      }), e && (e.push.apply(e, _toConsumableArray(Object.values(this._legacyLayouts).map(function (i) {
        return i.identifier;
      }))), this._layouts = this._layouts.filter(function (i) {
        return e.indexOf(i.identifier) >= 0;
      }));
    }
  }, {
    key: "getLayoutByIdentifier",
    value: function getLayoutByIdentifier(e) {
      var t = oe.Array.find(this._layouts, function (i) {
        return i.identifier === e;
      });
      return t && t.layout;
    }
  }, {
    key: "getLayouts",
    value: function getLayouts() {
      return _toConsumableArray(this._layouts);
    }
  }, {
    key: "getDefaultLayout",
    value: function getDefaultLayout() {
      return this.getLayouts()[0];
    }
  }]);

  return Bc;
}(),
    zt = Bc;

var Mc =
/*#__PURE__*/
function () {
  function Mc() {
    _classCallCheck(this, Mc);
  }

  _createClass(Mc, null, [{
    key: "downloadDataURL",
    value: function downloadDataURL(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "photoeditorsdk-export";
      var i = this.createBlobURLFromDataURL(e),
          r = this.getExtensionFromDataURL(e),
          o = document.createElement("a");
      o.download = "".concat(t, ".").concat(r), o.href = i, document.body.appendChild(o), o.click(), document.body.removeChild(o);
    }
  }, {
    key: "downloadMSBlob",
    value: function downloadMSBlob(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "photoeditorsdk-export";
      navigator.msSaveBlob && navigator.msSaveBlob(e, "".concat(t, ".png"));
    }
  }, {
    key: "getExtensionFromDataURL",
    value: function getExtensionFromDataURL(e) {
      return e.split(",")[0].split(":")[1].split(";")[0].split("/").pop();
    }
  }, {
    key: "createBlobURLFromDataURL",
    value: function createBlobURLFromDataURL(e) {
      if (!window.Blob || !window.URL || !ArrayBuffer || !Uint8Array) return e;
      var t = un.decode(e.split(",")[1]),
          i = e.split(",")[0].split(":")[1].split(";")[0],
          r = new ArrayBuffer(t.length),
          o = new Uint8Array(r);

      for (var _a21 = 0; _a21 < t.length; _a21++) {
        o[_a21] = t[_a21];
      }

      var n = new window.Blob([r], {
        type: i
      });
      return window.URL.createObjectURL(n);
    }
  }]);

  return Mc;
}(),
    Gs = Mc;

var Lc =
/*#__PURE__*/
function () {
  function Lc(e, t, i) {
    _classCallCheck(this, Lc);

    this._sdk = e, this._options = t, this._download = i;
  }

  _createClass(Lc, [{
    key: "export",
    value: function _export() {
      var _this199 = this;

      var e = this._getRenderType();

      return this._sdk.export(e, this._options.format, this._options.quality).then(function (t) {
        return _this199._download && _this199._downloadData(e, t), t;
      });
    }
  }, {
    key: "_downloadData",
    value: function _downloadData(e, t) {
      switch (e) {
        case yi.DATAURL:
          Gs.downloadDataURL(t, this._options.fileBasename);
          break;

        case yi.MSBLOB:
          Gs.downloadMSBlob(t, this._options.fileBasename);
          break;
      }
    }
  }, {
    key: "_getRenderType",
    value: function _getRenderType() {
      var e = this._options;
      return e.type !== yi.IMAGE || !this._download ? e.type : Ke.supportsMSBlob() ? yi.MSBLOB : yi.DATAURL;
    }
  }]);

  return Lc;
}(),
    zh = Lc;

var zc =
/*#__PURE__*/
function () {
  function zc(e, t, i) {
    _classCallCheck(this, zc);

    this._editor = e, this._sdk = t, this._mediator = i, this._available = this._sdk.getOperations(), this._map = {}, this._stack = this._sdk.getOperationsStack(), this._preferredOrder = this._editor.getOptions().editor.operationsOrder, this._fixStack();
  }

  _createClass(zc, [{
    key: "exists",
    value: function exists(e) {
      return !!this._map[e];
    }
  }, {
    key: "add",
    value: function add(e) {
      var _this200 = this;

      var t = e.constructor.identifier;
      e.on("update", function () {
        _this200._mediator.emit(de.EVENTS.OPERATION_UPDATED, e);
      });

      var i = this._preferredOrder.indexOf(t);

      if (i === -1) throw new Error("EditorOperations#add: `".concat(t, "` does not appear in `operationsOrder`"));
      this._stack.set(i, e), this._map[t] = e, this._mediator.emit(de.EVENTS.OPERATION_CREATED, e);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;

      var i = typeof e == "object" ? e.constructor.identifier : e,
          r = this._stack.getStack();

      e = this.get(i), delete this._map[i];
      var o = r.map(function (n) {
        return n.constructor.identifier;
      }).indexOf(i);

      if (o !== -1) {
        this._stack.removeAt(o);

        for (var _n26 = o + 1; _n26 < r.length; _n26++) {
          var _a22 = r[_n26];
          !_a22 || _a22.setDirty(!0);
        }

        t && this._mediator.emit(de.EVENTS.OPERATION_REMOVED, e);
      }
    }
  }, {
    key: "get",
    value: function get(e) {
      return this._map[e];
    }
  }, {
    key: "getOrCreate",
    value: function getOrCreate(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this._map[e]) {
        var _o37 = this._map[e];
        return _o37.set(t, !1), _o37;
      }

      var i = this._available[e],
          r = new i(this._sdk, t);
      return this.add(r), r;
    }
  }, {
    key: "getStack",
    value: function getStack() {
      return this._stack;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._map = {};
    }
  }, {
    key: "_fixStack",
    value: function _fixStack() {
      var _this201 = this;

      var e = this._stack.getStack().slice();

      this._stack.clear(), e.forEach(function (t) {
        _this201.add(t);
      });
    }
  }]);

  return zc;
}(),
    Uh = zc;

var Uc =
/*#__PURE__*/
function () {
  function Uc(e, t, i) {
    _classCallCheck(this, Uc);

    this._image = e, this._maxPixels = t, this._maxDimensions = i;
  }

  _createClass(Uc, [{
    key: "needsResize",
    value: function needsResize() {
      var e = new $(this._image.width, this._image.height),
          i = e.x * e.y > this._maxPixels,
          r = this._maxDimensions !== null && (e.x > this._maxDimensions || e.y > this._maxDimensions);
      return i || r;
    }
  }, {
    key: "resize",
    value: function resize() {
      var _this202 = this;

      var e = null,
          t = null,
          i = this._maxDimensions;
      return new Promise(function (r, o) {
        window.setTimeout(function () {
          var a = new $(_this202._image.width, _this202._image.height).clone();

          if (a.x * a.y > _this202._maxPixels && (a.copy(_this202._getDimensionsByMaxPixels()), e = "maxMegaPixels"), i !== null && (a.x > i || a.y > i)) {
            var _l23 = Math.min(i / a.x, i / a.y);

            a.multiply(_l23), e = "maxDimensions";
          }

          a.floor(), t = _this202._createResizedImageCanvas(a), r({
            canvas: t,
            dimensions: a,
            reason: e
          });
        }, 1e3);
      });
    }
  }, {
    key: "_createResizedImageCanvas",
    value: function _createResizedImageCanvas(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
      var i = this._image,
          r = document.createElement("canvas");
      r.width = e.x, r.height = e.y;
      var o = e.clone().subtract(t).divide(2);
      return r.getContext("2d").drawImage(i, 0, 0, i.width, i.height, o.x, o.y, t.x, t.y), r;
    }
  }, {
    key: "_getDimensionsByMaxPixels",
    value: function _getDimensionsByMaxPixels() {
      var e = this._image,
          t = this._maxPixels,
          i = e.width / e.height,
          r = e.height / e.width;
      return new $(Math.sqrt(t * i), Math.sqrt(t * r)).floor();
    }
  }]);

  return Uc;
}(),
    Nh = Uc;

var $_ = 30,
    J_ = "abcdefghijklmnopqrstuvwxzy",
    Nc =
/*#__PURE__*/
function () {
  function Nc(e) {
    _classCallCheck(this, Nc);

    this._fontVariation = e || new gn({
      fontFamily: "Times New Roman",
      fontWeight: "normal",
      fontStyle: "normal"
    }), this._createRuler();
  }

  _createClass(Nc, [{
    key: "_createRuler",
    value: function _createRuler() {
      this._ruler = document.createElement("div"), this._ruler.innerText = J_, document.body.appendChild(this._ruler), this._setRulerStyle();
    }
  }, {
    key: "_setRulerStyle",
    value: function _setRulerStyle() {
      this._ruler.style.cssText = "\n      position: absolute;\n      top: -9999px;\n      left: -9999px;\n      opacity: 0;\n      display: inline-block;\n      font: ".concat(this._fontVariation.getFontStyle(), " ").concat(this._fontVariation.getFontWeight(), " ").concat($_, "px ").concat(this._fontVariation.getFontFamily(), ";\n    ");
    }
  }, {
    key: "setFontVariation",
    value: function setFontVariation(e) {
      this._fontVariation = e, this._setRulerStyle();
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this._ruler ? this._ruler.offsetWidth : -1;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._ruler && (this._ruler.parentNode.removeChild(this._ruler), this._ruler = null);
    }
  }]);

  return Nc;
}(),
    Gc = Nc;

var Gh = typeof window != "undefined" && window.performance && window.performance.now ? window.performance.now.bind(window.performance) : ke(),
    ey = 50,
    ty = 5e3,
    Wc =
/*#__PURE__*/
function () {
  function Wc(e) {
    _classCallCheck(this, Wc);

    this._fontVariation = e, this._defaultFontRuler = new Gc(), this._customFontRuler = new Gc(this._fontVariation);
  }

  _createClass(Wc, [{
    key: "observe",
    value: function observe() {
      var _this203 = this;

      var e = Gh();
      return new Promise(function (t, i) {
        var r = window.setInterval(function () {
          if (_this203._defaultFontRuler.getWidth() !== _this203._customFontRuler.getWidth()) return window.clearInterval(r), t();

          if (Gh() - e >= ty) {
            var _n27 = new Error("Failed to load font ".concat(_this203._fontVariation.getFontFamily(), "."));

            return _n27.font = _this203._fontVariation, i(_n27);
          }
        }, ey);
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._defaultFontRuler.dispose(), this._customFontRuler.dispose();
    }
  }]);

  return Wc;
}(),
    Wh = Wc;

var Vc =
/*#__PURE__*/
function () {
  function Vc(e) {
    _classCallCheck(this, Vc);

    this._ui = e, this._fonts = [], this._observers = [];
  }

  _createClass(Vc, [{
    key: "add",
    value: function add(e) {
      this._fonts.push(e);
    }
  }, {
    key: "load",
    value: function load() {
      var _this204 = this;

      return this._fonts.length === 0 ? Promise.resolve() : (this._observers = [], this._fonts.forEach(function (e) {
        _this204._observers.push(new Wh(e));
      }), T.executePromises(this._observers.map(function (e) {
        return e.observe();
      })));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._observers.forEach(function (e) {
        return e.dispose();
      });
    }
  }]);

  return Vc;
}(),
    fn = Vc;

var Hc =
/*#__PURE__*/
function (_fn) {
  _inherits(Hc, _fn);

  function Hc() {
    _classCallCheck(this, Hc);

    return _possibleConstructorReturn(this, _getPrototypeOf(Hc).apply(this, arguments));
  }

  _createClass(Hc, [{
    key: "load",
    value: function load() {
      return Promise.resolve();
    }
  }]);

  return Hc;
}(fn),
    Vh = Hc;

var iy = {
  italic: "i"
},
    jc =
/*#__PURE__*/
function (_fn2) {
  _inherits(jc, _fn2);

  function jc() {
    _classCallCheck(this, jc);

    return _possibleConstructorReturn(this, _getPrototypeOf(jc).apply(this, arguments));
  }

  _createClass(jc, [{
    key: "load",
    value: function load() {
      return this._fonts.length && this._addStylesheetTag(), _get(_getPrototypeOf(jc.prototype), "load", this).call(this);
    }
  }, {
    key: "_addStylesheetTag",
    value: function _addStylesheetTag() {
      var e = this._getFamiliesString(),
          t = document.createElement("link");

      t.rel = "stylesheet", t.href = "https://fonts.googleapis.com/css?family=".concat(e), document.getElementsByTagName("head")[0].appendChild(t);
    }
  }, {
    key: "_getFamiliesString",
    value: function _getFamiliesString() {
      var e = {};

      this._fonts.forEach(function (i) {
        var r = i.getFontFamily(),
            o = i.getFontStyle(),
            n = i.getFontWeight();
        e[r] = e[r] || [], typeof n != "undefined" ? e[r].push("".concat(n).concat(iy[o] || "")) : e[r].push(400);
      });

      var t = [];

      for (var _i25 in e) {
        var _r23 = e[_i25],
            _o38 = _r23.length ? ":".concat(_r23.join(",")) : "",
            _n28 = _i25.replace(" ", "+") + _o38;

        t.push(_n28);
      }

      return t.join("|");
    }
  }]);

  return jc;
}(fn),
    Hh = jc;

var Yc =
/*#__PURE__*/
function () {
  function Yc(e, t) {
    _classCallCheck(this, Yc);

    this._ui = e, this._fonts = t, this._loadedFonts = [];
  }

  _createClass(Yc, [{
    key: "setFonts",
    value: function setFonts(e) {
      this._fonts = e;
    }
  }, {
    key: "needsToLoad",
    value: function needsToLoad() {
      var _this205 = this;

      var _loop5 = function _loop5(_e22) {
        var t = void 0;
        if (_this205._fonts[_e22].getVariations().forEach(function (i) {
          t = t || i.getProvider();
        }), !!t) return {
          v: !0
        };
      };

      for (var _e22 = 0; _e22 < this._fonts.length; _e22++) {
        var _ret = _loop5(_e22);

        if (typeof _ret === "object") return _ret.v;
      }
    }
  }, {
    key: "fontLoaded",
    value: function fontLoaded(e) {
      var t = e.getFontFamily();
      return this._loadedFonts.indexOf(t) !== -1;
    }
  }, {
    key: "setFontLoaded",
    value: function setFontLoaded(e) {
      if (!this.fontLoaded(e)) {
        var _t30 = e.getFontFamily();

        this._loadedFonts.push(_t30);
      }
    }
  }, {
    key: "load",
    value: function load() {
      var _this206 = this;

      var e = this._fonts,
          t = {
        google: new Hh(this._ui),
        file: new Vh(this._ui)
      },
          i = function i() {
        for (var _o39 in t) {
          t[_o39].dispose();
        }
      };

      e.filter(function (o) {
        return !_this206.fontLoaded(o);
      }).forEach(function (o) {
        o.getVariations().forEach(function (n) {
          var a = n.getProvider();
          if (!a) return;
          t[a].add(n);
        });
      });
      var r = [];

      for (var _o40 in t) {
        r.push(t[_o40].load());
      }

      return Promise.all(r).then(function () {
        i(), e.forEach(function (o) {
          _this206.setFontLoaded(o);
        });
      }).catch(function (o) {
        throw i(), o;
      });
    }
  }]);

  return Yc;
}(),
    Or = Yc;

var qc =
/*#__PURE__*/
function () {
  function qc(e, t) {
    _classCallCheck(this, qc);

    this._ui = e, this._options = t, this._brushes = [], this._brushesById = {}, this._addBrushes(de.DEFAULTS.BRUSHES);
    var _this$_options38 = this._options,
        i = _this$_options38.brushes,
        r = _this$_options38.replaceBrushes,
        o = _this$_options38.availableBrushes;
    this._options.brushes && this._addBrushes(i, r), o && (this._brushes = this._brushes.filter(function (n) {
      return o.indexOf(n.identifier) !== -1;
    }));
  }

  _createClass(qc, [{
    key: "_addBrushes",
    value: function _addBrushes(e, t) {
      var _this207 = this;

      t && (this._brushes = [], this._brushesById = {}), e.forEach(function (i) {
        _this207._brushes.push(i), _this207._brushesById[i.identifier] = i;
      });
    }
  }, {
    key: "getBrushByIdentifier",
    value: function getBrushByIdentifier(e) {
      return this._brushesById[e];
    }
  }, {
    key: "getBrushes",
    value: function getBrushes() {
      return this._brushes;
    }
  }, {
    key: "getFirstBrush",
    value: function getFirstBrush() {
      return this._brushes[0];
    }
  }]);

  return qc;
}(),
    jh = qc;

var Yh =
/*#__PURE__*/
function () {
  function Yh() {
    _classCallCheck(this, Yh);

    this._assetsByGroupId = {};
  }

  _createClass(Yh, [{
    key: "addAsset",
    value: function addAsset(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      this._assetsByGroupId[e] ? i ? this._assetsByGroupId[e].unshift(t) : this._assetsByGroupId[e].push(t) : this._assetsByGroupId[e] = [t];
    }
  }, {
    key: "setAssets",
    value: function setAssets(e, t) {
      this._assetsByGroupId[e] = t;
    }
  }, {
    key: "getAssets",
    value: function getAssets(e) {
      return this._assetsByGroupId[e] = this._assetsByGroupId[e] || [], this._assetsByGroupId[e];
    }
  }]);

  return Yh;
}(),
    qh = Yh;

var Kc = "imgly_sticker_custom",
    Xc =
/*#__PURE__*/
function () {
  function Xc(e, t, i) {
    _classCallCheck(this, Xc);

    this._ui = e, this._options = t, this._dynamicAssetsLibrary = i || this._ui.getEditor().getDynamicAssetsLibrary() || new qh(), this._categoriesById = {}, this._categories = [], this._stickersById = {}, this._customStickerCanvas = T.createCanvas(), this.reload();
  }

  _createClass(Xc, [{
    key: "reload",
    value: function reload() {
      this._categoriesById = {}, this._categories = [], this._stickersById = {};

      var e = this._ui.getEditor().getSDK()._l.areCustomAssetsAllowed();

      this._addCategories(Vt.DEFAULTS.STICKER_CATEGORIES);

      var _this$_options39 = this._options,
          t = _this$_options39.categories,
          i = _this$_options39.replaceCategories;

      if (e && this._options.categories ? this._addCategories(t, i) : (this._updateCategoriesMap(), this._updateAllCategory()), e) {
        var _r24 = this._dynamicAssetsLibrary.getAssets("sticker");

        if (_r24.length > 0) {
          var _o41 = this._createCustomStickerCategory(_r24);

          this._addCategories([_o41], !1, !0);
        }
      }
    }
  }, {
    key: "loadExternal",
    value: function loadExternal(e) {
      var _this208 = this;

      return new Rt(e).load().then(function (i) {
        _this208._addCategories(i.categories, _this208._options.replaceCategories);
      });
    }
  }, {
    key: "_addCategories",
    value: function _addCategories(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      t ? this._categories = e.slice(0) : i ? this._categories = this._mergeCategories(e, this._categories) : this._categories = this._mergeCategories(this._categories, e), this._updateCategoriesMap(), this._updateAllCategory();
    }
  }, {
    key: "_mergeCategories",
    value: function _mergeCategories(e, t) {
      e = Ke.cloneCategories(e, "stickers");
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = t[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _i26 = _step3.value;

          var _r25 = !1;

          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = e[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _o42 = _step4.value;

              if (_i26.identifier === _o42.identifier) {
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                  for (var _iterator5 = _i26.stickers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var _n29 = _step5.value;

                    var _a23 = !1;

                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                      for (var _iterator6 = _o42.stickers[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var _l24 = _step6.value;

                        if (_n29.identifier === _l24.identifier) {
                          Object.assign(_l24, _n29), _a23 = !0;
                          break;
                        }
                      }
                    } catch (err) {
                      _didIteratorError6 = true;
                      _iteratorError6 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                          _iterator6.return();
                        }
                      } finally {
                        if (_didIteratorError6) {
                          throw _iteratorError6;
                        }
                      }
                    }

                    _a23 || _o42.stickers.push(_n29);
                  }
                } catch (err) {
                  _didIteratorError5 = true;
                  _iteratorError5 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                      _iterator5.return();
                    }
                  } finally {
                    if (_didIteratorError5) {
                      throw _iteratorError5;
                    }
                  }
                }

                _r25 = !0;
                break;
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          _r25 || e.push(_i26);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return e;
    }
  }, {
    key: "_updateCategoriesMap",
    value: function _updateCategoriesMap() {
      var _this209 = this;

      this._categoriesById = {}, this._categories.forEach(function (e) {
        _this209._categoriesById[e.identifier] = e;
      }), this._categories.forEach(function (e) {
        e.stickers.forEach(function (t) {
          _this209._stickersById[t.identifier] = t;
        });
      }), typeof this._options.availableStickers != "undefined" && this._options.availableStickers !== null && (this._categories.forEach(function (e) {
        e.identifier !== Kc && (e.stickers = e.stickers.filter(function (t) {
          return _this209._options.availableStickers.indexOf(t.identifier) !== -1;
        }));
      }), this._categories = this._categories.filter(function (e) {
        return e.stickers.length > 0;
      })), this._updateAllCategory();
    }
  }, {
    key: "_updateAllCategory",
    value: function _updateAllCategory() {
      this._allCategory = {
        identifier: "all",
        defaultName: "All",
        stickers: this._categories.map(function (e) {
          return e.stickers;
        }).reduce(function (e, t) {
          return e.concat(t);
        }, [])
      }, this._categoriesById.all = this._allCategory;
    }
  }, {
    key: "renderStickerThumbnailFromImage",
    value: function renderStickerThumbnailFromImage(e) {
      var t = this._customStickerCanvas,
          i = t.getContext("2d");
      i.save();
      var r = 62,
          o = r / e.width,
          n = o * e.height;
      t.width = r, t.height = r, i.clearRect(0, 0, e.width, e.height), i.translate(0, .5 * (t.height - n)), i.scale(o, o), i.drawImage(e, 0, 0);
      var a = t.toDataURL("image/png");
      return i.restore(), {
        data: a,
        width: r,
        height: n
      };
    }
  }, {
    key: "addCustomStickerFromImage",
    value: function addCustomStickerFromImage(e, t) {
      var _this210 = this;

      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "none";

      var r = function r(f) {
        var b = _this210._ui.getEditor().getSDK().getRenderer(),
            D = new $(f.width, f.height),
            O = _this210._ui.getEditor().getMaxMegapixels() * 1e6,
            x = b.getMaxDimensions(),
            w = D.x * D.y > O,
            z = x !== null && (D.x > x || D.y > x);

        if (w) {
          var _j = f.width / f.height,
              _X = f.height / f.width;

          x = new $(Math.sqrt(O * _j), Math.sqrt(O * _X)).floor().max();
        }

        var L = D.clone();
        return (w || z) && (D.x / D.y > 1 ? (L.x = x, L.y = x / D.x * D.y) : (L.x = x / D.y * D.x, L.y = x)), L;
      },
          o = function o(f, v) {
        var b = f.x / f.y;
        return b > 1 ? new $(v, v / b) : new $(v * b, v);
      },
          n = e.src.substring(0, 14) === "data:image/svg";

      e = this._ui.getEditor().getSDK().correctExifOrientation(e);
      var l = o(new $(e.width, e.height), 2048),
          c = n ? l : r(e),
          u = this._customStickerCanvas,
          p = u.getContext("2d");
      p.save();
      var h = this.renderStickerThumbnailFromImage(e);
      n ? (e.width > e.height ? (u.width = 2048, u.height = 2048 / e.width * e.height) : (u.height = 2048, u.width = 2048 / e.height * e.width), e.width = u.width, e.height = u.height) : (u.width = c.x, u.height = c.y, p.scale(c.x / e.width, c.y / e.height)), p.drawImage(e, 0, 0, e.width, e.height);
      var d = u.toDataURL();
      p.restore();
      var g = {
        identifier: T.generateUUID(),
        defaultName: t || "",
        tintMode: i,
        images: {
          mediaThumb: {
            uris: [h.data],
            rawData: !0,
            width: h.width,
            height: h.height
          },
          mediaBase: {
            uris: n ? [d, e.src] : [d],
            rawData: !0,
            isSVG: n,
            width: c.x,
            height: c.y
          }
        }
      },
          y = this._dynamicAssetsLibrary;
      y.addAsset("sticker", g, !0);

      var _ = y.getAssets("sticker");

      if (_.length === 1) {
        var _f20 = this._createCustomStickerCategory(_);

        this._addCategories([_f20], !1, !0);
      } else this.getCategory(Kc).stickers = _, this._updateAllCategory();

      this._updateCategoriesMap();
    }
  }, {
    key: "_createCustomStickerCategory",
    value: function _createCustomStickerCategory(e) {
      return {
        identifier: Kc,
        defaultName: "Custom",
        metaData: {
          backgroundImage: e[e.length - 1].images.mediaBase.uris[0],
          rawData: !0
        },
        stickers: e
      };
    }
  }, {
    key: "getStickersForCategory",
    value: function getStickersForCategory(e) {
      if (!this._categoriesById[e]) throw new Error("Unknown sticker category '".concat(e, "'"));
      return this._categoriesById[e].stickers;
    }
  }, {
    key: "getStickerByIdentifier",
    value: function getStickerByIdentifier(e) {
      return this._stickersById[e];
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return e ? [this._allCategory].concat(this._categories) : this._categories;
    }
  }, {
    key: "getCategory",
    value: function getCategory(e) {
      return this._categoriesById[e];
    }
  }], [{
    key: "getURLForSticker",
    value: function getURLForSticker(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "base";
      var i = e.images,
          r = t === "base" && i.mediaBase || i.mediaThumb,
          o = r.uris || [r.uri];

      if (!Ke.Browser.getIEVersion()) {
        var _a24 = o.filter(function (l) {
          return /\.svg$/i.test(l);
        });

        return _a24.length ? _a24[0] : o[0];
      }

      var n = o.filter(function (a) {
        return !/\.svg$/i.test(a);
      });
      return n.length ? n[0] : o[0];
    }
  }]);

  return Xc;
}(),
    Pr = Xc;

var Kh = Te(Ct()),
    Qc;
typeof W.Operations.SpriteOperation != "undefined" && (Qc = W.Operations.SpriteOperation.BrushSprite);

var _n =
/*#__PURE__*/
function () {
  function _n(e, t) {
    _classCallCheck(this, _n);

    this._editor = e, this._ui = this._editor.getUI(), this._data = t, this._filterManager = new dn(this._ui, this._getOptions("filter")), this._stickerManager = new Pr(this._ui, this._getOptions("sticker")), this._brushManager = new jh(this._ui, this._getOptions("brush")), this._fontManager = new st(this._ui, this._getOptions("text"));
  }

  _createClass(_n, [{
    key: "_getOptions",
    value: function _getOptions(e) {
      var t = this._editor.controls,
          i = {};
      t && t.get(e) && (i = t.get(e).defaultOptions);

      var r = this._editor.getOptions();

      return oe.deepDefaults({}, r.editor.controlsOptions[e] || {}, i);
    }
  }, {
    key: "deserialize",
    value: function deserialize() {
      var _this211 = this;

      return this._validateVersion().then(function () {
        return _this211._deserializeInputImage();
      }).then(function () {
        return _this211._deserializeOperations();
      });
    }
  }, {
    key: "_validateVersion",
    value: function _validateVersion() {
      return this._data.version !== this.constructor.version ? Promise.reject(new Error("Invalid version ".concat(this._data.version, ", expected ").concat(this.constructor.version))) : Promise.resolve();
    }
  }, {
    key: "_deserializeInputImage",
    value: function _deserializeInputImage() {
      var _this212 = this;

      return new Promise(function (e, t) {
        var _this212$_data$inputI = _this212._data.inputImage,
            i = _this212$_data$inputI.data,
            r = _this212$_data$inputI.type;

        if (i && r) {
          var _o43 = new window.Image();

          _o43.addEventListener("load", function () {
            _this212._editor.setImage(_o43), e();
          }), _o43.src = "data:".concat(r, ";base64,").concat(i);
        } else e();
      });
    }
  }, {
    key: "_deserializeOperations",
    value: function _deserializeOperations() {
      return mt(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this213 = this;

        var e;
        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                e = this._data.operations;
                return _context7.abrupt("return", Kh.default(e, function (t) {
                  return mt(_this213, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee5() {
                    return _regeneratorRuntime.wrap(function _callee5$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            return _context6.abrupt("return", this._deserializeOperation(t));

                          case 1:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee5, this);
                  }));
                }));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "_deserializeOperation",
    value: function _deserializeOperation(e) {
      switch (e.type) {
        case "crop":
          return this._deserializeCropOperation(e);

        case "orientation":
          return this._deserializeOrientationOperation(e);

        case "filter":
          return this._deserializeFilterOperation(e);

        case "adjustments":
          return this._deserializeAdjustmentsOperation(e);

        case "sprite":
          return this._deserializeSpriteOperation(e);

        case "focus":
          return this._deserializeFocusOperation(e);
      }
    }
  }, {
    key: "_deserializeCropOperation",
    value: function _deserializeCropOperation(e) {
      var t = e.options,
          i = t.rotation,
          r = $.fromObject(t.start),
          o = $.fromObject(t.end);
      i > Math.PI && (i -= Math.PI * 2);
      var n = {
        start: r,
        end: o
      };
      typeof i != "undefined" && (n.rotation = i);

      var a = this._editor.operations.getOrCreate("transform");

      return this._editor.broadcastTransform(a, n), a.set(n), Promise.resolve(a);
    }
  }, {
    key: "_deserializeOrientationOperation",
    value: function _deserializeOrientationOperation(e) {
      var t = e.options,
          i = this._editor.operations.getOrCreate("orientation");

      return i ? (i.set(t), Promise.resolve(i)) : Promise.resolve();
    }
  }, {
    key: "_deserializeFilterOperation",
    value: function _deserializeFilterOperation(e) {
      var _this214 = this;

      var t = e.options;
      return this._filterManager.getFilterByIdentifier(t.name) ? this._filterManager.instantiateFilterWithIdentifier(t.name).then(function (i) {
        var r = _this214._editor.operations.getOrCreate("filter");

        return r.set({
          identifier: t.name,
          filter: i,
          intensity: t.intensity
        }), r;
      }) : (A.warn("Deserializer", "Unknown filter `".concat(t.name, "`")), Promise.resolve());
    }
  }, {
    key: "_deserializeAdjustmentsOperation",
    value: function _deserializeAdjustmentsOperation(e) {
      var t = W.Operations.AdjustmentsOperation,
          i = e.options,
          r = ["brightness", "saturation", "contrast", "exposure", "shadows", "highlights", "clarity"],
          o = {};
      return r.forEach(function (n) {
        if (typeof i[n] == "undefined") return;
        var _t$prototype$availabl = t.prototype.availableOptions[n],
            a = _t$prototype$availabl.minValue,
            l = _t$prototype$availabl.midValue,
            c = _t$prototype$availabl.maxValue,
            u = i[n];
        u = u < 0 ? l + (l - a) * u : l + (c - l) * u, o[n] = u;
      }), Promise.resolve(this._editor.operations.getOrCreate("adjustments", o));
    }
  }, {
    key: "_deserializeSpriteOperation",
    value: function _deserializeSpriteOperation(e) {
      var _this215 = this;

      var t = e.options,
          i = this._editor.operations.getOrCreate("sprite");

      if (!i) return Promise.resolve();
      var r = t.sprites.map(function (o) {
        return _this215._deserializeSprite(i, o);
      }).filter(function (o) {
        return o;
      });
      return Promise.all(r).then(function (o) {
        return i.setSprites(o.filter(function (n) {
          return n;
        })), i;
      });
    }
  }, {
    key: "_deserializeSprite",
    value: function _deserializeSprite(e, t) {
      switch (t.type) {
        case "sticker":
          return this._deserializeSticker(e, t);

        case "text":
          return this._deserializeText(e, t);

        case "brush":
          return this._deserializeBrush(e, t);

        case "textdesign":
          return this._deserializeTextDesign && this._deserializeTextDesign(e, t);
      }
    }
  }, {
    key: "_deserializeSticker",
    value: function _deserializeSticker(e, t) {
      var _this216 = this;

      var i = W.Operations.SpriteOperation,
          r = t.options,
          o = this._stickerManager.getStickerByIdentifier(r.name),
          n = this._stickerManager.getURLForSticker(o);

      return o ? new Promise(function (a, l) {
        var c = new window.Image();
        c.addEventListener("load", function () {
          var u = i.StickerSprite.prototype.availableOptions.adjustments.structure,
              p = r.rotation,
              h = r.flipHorizontally,
              d = r.flipVertically,
              g = {
            identifier: r.name,
            image: c,
            position: $.fromObject(r.position),
            dimensions: $.fromObject(r.dimensions),
            rotation: p,
            flipHorizontally: h,
            flipVertically: d,
            adjustments: {}
          };
          typeof r.adjustments != "undefined" && ["brightness", "contrast", "saturation"].forEach(function (y) {
            typeof r.adjustments[y] != "undefined" && (g.adjustments[y] = r.adjustments[y] + u[y].default);
          }), a(e.createSticker(g));
        }), c.crossOrigin = _this216._editor.getCrossOrigin(), c.src = _this216._editor.getUI().getAssetPath(n);
      }) : (A.warn("Deserializer", "Unknown sticker '".concat(r.name, "'. Skipping sprite.")), Promise.resolve());
    }
  }, {
    key: "_deserializeText",
    value: function _deserializeText(e, t) {
      var i = t.options,
          r = i.fontSize,
          o = i.lineHeight,
          n = i.fontFamily,
          a = i.fontWeight,
          l = i.alignment,
          c = i.rotation,
          u = i.maxWidth,
          p = i.color,
          h = i.backgroundColor,
          d = new Or(this._ui),
          g = this._fontManager.getFontByFontFamily(n);

      return g || (g = this._fontManager.getDefaultFont()), d.setFonts([g]), d.load().then(function () {
        var y = e.createText({
          fontSize: r,
          lineHeight: o,
          fontFamily: n,
          fontWeight: a,
          alignment: l,
          rotation: c,
          maxWidth: u,
          text: i.text,
          color: ie.fromArray(p),
          backgroundColor: ie.fromArray(h),
          position: $.fromObject(i.position)
        });
        return y._edited = !0, y;
      });
    }
  }, {
    key: "_deserializeBrush",
    value: function _deserializeBrush(e, t) {
      var _this217 = this;

      var i = t.options,
          r = i.paths,
          o = e.createBrush();
      return r.forEach(function (n) {
        _this217._deserializeBrushPath(o, n);
      }), Promise.resolve(o);
    }
  }, {
    key: "_deserializeBrushPath",
    value: function _deserializeBrushPath(e, t) {
      var i = t.points,
          r = this._createBrushForPath(t),
          o = e.createPath(r);

      o.setClosed(!0), i.forEach(function (n) {
        o.addControlPoint($.fromObject(n));
      });
    }
  }, {
    key: "_createBrushForPath",
    value: function _createBrushForPath(e) {
      var t = e.color,
          i = e.size,
          o = {
        color: ie.fromArray(t),
        size: i
      },
          n = this._brushManager.getFirstBrush();

      if (n.prototype && n.prototype instanceof Qc) {
        var _c29 = n;
        return new _c29(o);
      }

      var a = C({}, n);
      delete a.image;

      var l =
      /*#__PURE__*/
      function (_Qc) {
        _inherits(l, _Qc);

        function l() {
          _classCallCheck(this, l);

          return _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments));
        }

        return l;
      }(Qc);

      return l.identifier = n.identifier, new l(C(C({}, a), o));
    }
  }, {
    key: "_deserializeFocusOperation",
    value: function _deserializeFocusOperation(e) {
      var t = e.options.options;

      switch (e.options.type) {
        case "radial":
          {
            var _i27 = t.position,
                _r26 = t.radius,
                _o44 = t.gradientRadius,
                _n30 = t.blurRadius;
            return Promise.resolve(this._editor.operations.getOrCreate("radial-focus", {
              position: $.fromObject(_i27),
              radius: _r26,
              gradientRadius: _o44,
              blurRadius: _n30
            }));
          }

        case "linear":
          {
            var _i28 = t.start,
                _r27 = t.end,
                _o45 = t.size,
                _n31 = t.gradientSize,
                _a25 = t.blurRadius;
            return Promise.resolve(this._editor.operations.getOrCreate("mirrored-focus", {
              start: $.fromObject(_i28),
              end: $.fromObject(_r27),
              size: _o45,
              gradientSize: _n31,
              blurRadius: _a25
            }));
          }
      }
    }
  }, {
    key: "_getInputDimensionsForOperation",
    value: function _getInputDimensionsForOperation(e) {
      var t = !1,
          i = this._editor.getInputDimensions();

      return this._editor.operations.getStack().forEach(function (r) {
        r === e && (t = !0), !t && (i = r.getNewDimensions(i));
      }), i;
    }
  }]);

  return _n;
}(),
    yn = _n;

_n.version = "1.0.0";

var Br = Math.PI * 2,
    bn =
/*#__PURE__*/
function () {
  function bn(e) {
    _classCallCheck(this, bn);

    this._editor = e, this._serializeOperations = this._serializeOperations.bind(this);
  }

  _createClass(bn, [{
    key: "serialize",
    value: function serialize() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._options = C(C({}, e), {
        image: !0
      });
      var t = {
        version: this.constructor.version
      };
      return this._serializeInputImage(t).then(this._serializeOperations);
    }
  }, {
    key: "_serializeInputImage",
    value: function _serializeInputImage(e) {
      var t = this._editor.getImage(),
          i = t.width,
          r = t.height;

      if (!this._options.image) return e.inputImage = {
        width: i,
        height: r
      }, Promise.resolve(e);
      var o = oe.createCanvas();
      o.width = t.width, o.height = t.height, o.getContext("2d").drawImage(t, 0, 0);
      var a = o.toDataURL(Oc.PNG);
      return e.inputImage = {
        type: Oc.PNG,
        data: a.replace(/^data:image\/(.*?);base64,/, ""),
        width: i,
        height: r
      }, Promise.resolve(e);
    }
  }, {
    key: "_serializeOperations",
    value: function _serializeOperations(e) {
      var _this218 = this;

      var t = [];
      return this._editor.operations.getStack().forEach(function (r) {
        var o = _this218._serializeOperation(r, t);

        o && t.push(o);
      }), e.operations = t.filter(function (r) {
        return r;
      }), Promise.resolve(e);
    }
  }, {
    key: "_serializeOperation",
    value: function _serializeOperation(e, t) {
      switch (e.constructor.identifier) {
        case "transform":
          return this._serializeTransformOperation(e);

        case "orientation":
          return this._serializeOrientationOperation(e);

        case "filter":
          return this._serializeFilterOperation(e);

        case "adjustments":
          return this._serializeAdjustmentsOperation(e);

        case "sprite":
          return this._serializeSpriteOperation(e, t);

        case "radial-focus":
          return this._serializeRadialFocusOperation(e);

        case "mirrored-focus":
          return this._serializeLinearFocusOperation(e);

        default:
          A.warn("Unable to serialize operation of type ".concat(e.constructor.identifier));
      }
    }
  }, {
    key: "_serializeTransformOperation",
    value: function _serializeTransformOperation(e) {
      var t = e.serializeOptions(["start", "end", "rotation"], !0);
      return t.rotation = (t.rotation + Br) % Br, {
        type: "crop",
        options: t
      };
    }
  }, {
    key: "_serializeOrientationOperation",
    value: function _serializeOrientationOperation(e) {
      return {
        type: "orientation",
        options: e.serializeOptions(["flipVertically", "flipHorizontally", "rotation"], !0)
      };
    }
  }, {
    key: "_serializeFilterOperation",
    value: function _serializeFilterOperation(e) {
      return e.getIdentifier() === "identity" ? null : {
        type: "filter",
        options: {
          intensity: e.getIntensity(),
          name: e.getIdentifier()
        }
      };
    }
  }, {
    key: "_serializeAdjustmentsOperation",
    value: function _serializeAdjustmentsOperation(e) {
      var t = e.availableOptions,
          i = ["brightness", "saturation", "contrast", "exposure", "shadows", "highlights", "clarity"],
          r = {};
      return i.forEach(function (o) {
        var n = t[o],
            a = e.getOption(o),
            l = n.minValue,
            c = n.midValue,
            u = n.maxValue;
        r[o] = a <= c ? (a - l) / (c - l) - 1 : (a - c) / (u - c);
      }), {
        type: "adjustments",
        options: r
      };
    }
  }, {
    key: "_serializeSpriteOperation",
    value: function _serializeSpriteOperation(e, t) {
      var _this219 = this;

      var i = t.filter(function (n) {
        return n.type === "sprite";
      }),
          r,
          o = !0;
      if (i.length ? (r = i.pop(), o = !1) : r = {
        type: "sprite",
        options: {
          sprites: []
        }
      }, e.getSprites().forEach(function (n) {
        var a = null;
        n instanceof e.constructor.StickerSprite ? a = _this219._serializeSticker(e, n) : n instanceof e.constructor.TextSprite ? a = _this219._serializeText(e, n) : n instanceof e.constructor.BrushSprite ? a = _this219._serializeBrush(e, n) : n instanceof e.constructor.TextDesignSprite && (a = _this219._serializeTextDesign && _this219._serializeTextDesign(e, n)), a && r.options.sprites.push(a);
      }), o) return r;
    }
  }, {
    key: "_serializeSticker",
    value: function _serializeSticker(e, t) {
      var i = t.getAdjustments(),
          r = t.serializeOptions(["identifier", "position", "dimensions", "flipVertically", "flipHorizontally", "rotation"], !0);
      r.name = r.identifier, delete r.identifier, r.rotation = (r.rotation + Br) % Br;
      var o = i.availableOptions;
      return r.adjustments = {
        brightness: i.getBrightness() - o.brightness.default,
        saturation: i.getSaturation() - o.saturation.default,
        contrast: i.getContrast() - o.contrast.default
      }, {
        type: "sticker",
        options: r
      };
    }
  }, {
    key: "_serializeText",
    value: function _serializeText(e, t) {
      var i = t.serializeOptions(["fontSize", "lineHeight", "fontFamily", "fontWeight", "alignment", "color", "backgroundColor", "position", "rotation", "text", "maxWidth"], !0);
      return i.rotation = (i.rotation + Br) % Br, {
        type: "text",
        options: i
      };
    }
  }, {
    key: "_serializeBrush",
    value: function _serializeBrush(e, t) {
      var _this220 = this;

      return {
        type: "brush",
        options: {
          paths: t.getPaths().map(function (i) {
            return _this220._serializePath(i);
          })
        }
      };
    }
  }, {
    key: "_serializePath",
    value: function _serializePath(e) {
      var t = e.getBrush().serializeOptions(["color", "size"], !0);
      return t.points = e.getControlPoints().map(function (i) {
        return i.getPosition().toObject();
      }), t;
    }
  }, {
    key: "_serializeRadialFocusOperation",
    value: function _serializeRadialFocusOperation(e) {
      return {
        type: "focus",
        options: {
          type: "radial",
          options: e.serializeOptions(["position", "radius", "gradientRadius", "blurRadius"], !0)
        }
      };
    }
  }, {
    key: "_serializeLinearFocusOperation",
    value: function _serializeLinearFocusOperation(e) {
      return {
        type: "focus",
        options: {
          type: "linear",
          options: e.serializeOptions(["start", "end", "blurRadius", "size", "gradientSize"], !0)
        }
      };
    }
  }, {
    key: "_getInputDimensionsForOperation",
    value: function _getInputDimensionsForOperation(e) {
      var t = !1,
          i = this._editor.getInputDimensions();

      return this._editor.operations.getStack().forEach(function (r) {
        r === e && (t = !0), !t && (i = r.getNewDimensions(i));
      }), i;
    }
  }]);

  return bn;
}(),
    xn = bn;

bn.version = "1.0.0";

var Cn =
/*#__PURE__*/
function (_yn) {
  _inherits(Cn, _yn);

  function Cn() {
    _classCallCheck(this, Cn);

    return _possibleConstructorReturn(this, _getPrototypeOf(Cn).apply(this, arguments));
  }

  _createClass(Cn, [{
    key: "_deserializeOperation",
    value: function _deserializeOperation(e) {
      return e.type === "selective-blur" ? this._deserializeSelectiveBlurOperation(e) : _get(_getPrototypeOf(Cn.prototype), "_deserializeOperation", this).call(this, e);
    }
  }, {
    key: "_deserializeCropOperation",
    value: function _deserializeCropOperation(e) {
      var t = e.options,
          i = t.rotation,
          r = $.fromObject(t.start),
          o = $.fromObject(t.end),
          n = t.dimensions ? $.fromObject(t.dimensions) : null;
      if (o.x - r.x <= 0 || o.y - r.y <= 0) throw new Error("A crop should not result in negative or zero dimensions - start: ".concat(r, " - end: ").concat(o));
      i > Math.PI && (i -= Math.PI * 2);
      var a = {
        start: r,
        end: o
      };
      typeof i != "undefined" && (a.rotation = i);

      var l = this._editor.operations.getOrCreate("transform");

      if (!l) return Promise.resolve();

      if (this._editor.broadcastTransform(l, a), l.set(a), n) {
        var _c30 = o.clone().subtract(r),
            _u26 = l.getInputDimensions(!1).multiply(_c30);

        l.setTextureScale(n.x / _u26.x);
      }

      return Promise.resolve(l);
    }
  }]);

  return Cn;
}(yn),
    wn = Cn;

Cn.version = "1.0.1";

var Xh = Math.PI * 2,
    Dn =
/*#__PURE__*/
function (_xn) {
  _inherits(Dn, _xn);

  function Dn() {
    _classCallCheck(this, Dn);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dn).apply(this, arguments));
  }

  _createClass(Dn, [{
    key: "_serializeTransformOperation",
    value: function _serializeTransformOperation(e) {
      var t = e.serializeOptions(["start", "end", "rotation", "textureScale"], !0);
      return t.rotation = (t.rotation + Xh) % Xh, t.textureScale !== 1 && (t.dimensions = e.getNewDimensions(e.getInputDimensions(!1))), delete t.textureScale, {
        type: "crop",
        options: t
      };
    }
  }]);

  return Dn;
}(xn),
    kn = Dn;

Dn.version = "1.0.1";

var zr = W.OptionType,
    Rn =
/*#__PURE__*/
function (_W$Configurable) {
  _inherits(Rn, _W$Configurable);

  function Rn(e) {
    var _this221;

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Rn);

    _this221 = _possibleConstructorReturn(this, _getPrototypeOf(Rn).call(this, t));
    _this221._loaded = !1, _this221._loading = !1, _this221._ui = e, _this221._frame = W.Utils.deepClone(_this221._options);
    return _this221;
  }

  _createClass(Rn, [{
    key: "load",
    value: function load() {
      var _this222 = this;

      if (this._loaded) return Promise.resolve();
      if (this._loading) return Promise.reject(new Error("Called Frame#load while it's already loading"));
      this._loading = !0;
      var e = this._frame.imageGroups,
          t = [];
      return ["top", "left", "right", "bottom"].forEach(function (i) {
        if (!(i in e)) return;
        var r = e[i];
        ["start", "mid", "end"].forEach(function (o) {
          o in r && t.push(_this222._loadPart(i, o));
        });
      }), Promise.all(t).then(function () {
        _this222._loaded = !0, _this222._loading = !1;
      }).catch(function (i) {
        _this222._loaded = !1, _this222._loading = !1;
      });
    }
  }, {
    key: "_loadPart",
    value: function _loadPart(e, t) {
      var _this223 = this;

      var i = this._frame.imageGroups,
          r = i[e][t],
          o = r;
      return typeof r != "string" && "image" in r && (o = r.image), at.load(this._ui.getAssetPath(o)).then(function (n) {
        return typeof r != "string" ? _this223._frame.imageGroups[e][t].image = n : _this223._frame.imageGroups[e][t] = n, n;
      });
    }
  }, {
    key: "getFrame",
    value: function getFrame() {
      return this._frame;
    }
  }]);

  return Rn;
}(W.Configurable),
    Qh = Rn;

Rn.prototype.availableOptions = {
  identifier: {
    type: zr.STRING,
    required: !0
  },
  defaultName: {
    type: zr.STRING
  },
  thumbnail: {
    type: zr.STRING
  },
  tintable: {
    type: zr.BOOLEAN,
    default: !1
  },
  layoutMode: {
    type: zr.STRING,
    default: "horizontal-inside",
    available: ["horizontal-inside", "vertical-inside"]
  },
  imageGroups: {
    type: zr.OBJECT,
    required: !0
  }
};

var Zc =
/*#__PURE__*/
function () {
  function Zc(e, t) {
    _classCallCheck(this, Zc);

    this._ui = e, this._options = t, this._categoriesById = {}, this._categories = [], this._framesById = {}, this._addCategories(Vt.DEFAULTS.FRAME_CATEGORIES), this._customAssetsAllowed = e.getEditor().getSDK()._l.areCustomAssetsAllowed();
    var _this$_options40 = this._options,
        i = _this$_options40.categories,
        r = _this$_options40.replaceCategories;
    this._customAssetsAllowed && this._options.categories ? this._addCategories(i, r) : this._updateAllCategory();
  }

  _createClass(Zc, [{
    key: "_addCategories",
    value: function _addCategories(e) {
      var _this224 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      t ? this._categories = e.slice(0) : this._categories = Ke.mergeCategories(this._categories, e, "frames"), this._categoriesById = {}, this._categories.forEach(function (r) {
        _this224._categoriesById[r.identifier] = r;
      });
      var i = this._options.availableFrames;
      this._customAssetsAllowed && i && this._categories.forEach(function (r) {
        r.frames = r.frames.filter(function (o) {
          return i.indexOf(o.identifier) !== -1;
        });
      }), this._categories.forEach(function (r) {
        r.frames.forEach(function (o) {
          _this224._framesById[o.identifier] = o;
        });
      }), this._updateAllCategory();
    }
  }, {
    key: "_updateAllCategory",
    value: function _updateAllCategory() {
      this._allCategory = {
        identifier: "all",
        defaultName: "All",
        frames: this._categories.map(function (e) {
          return e.frames;
        }).reduce(function (e, t) {
          return e.concat(t);
        }, [])
      }, this._categoriesById.all = this._allCategory;
    }
  }, {
    key: "getFramesForCategory",
    value: function getFramesForCategory(e) {
      if (!this._categoriesById[e]) throw new Error("Unknown frame category '".concat(e, "'"));
      return this._categoriesById[e].frames;
    }
  }, {
    key: "getFrameByIdentifier",
    value: function getFrameByIdentifier(e) {
      return this._framesById[e];
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      return this._categories;
    }
  }, {
    key: "getCategory",
    value: function getCategory(e) {
      return this._categoriesById[e];
    }
  }]);

  return Zc;
}(),
    Zh = Zc;

var $c =
/*#__PURE__*/
function () {
  function $c(e, t) {
    var _this225 = this;

    _classCallCheck(this, $c);

    this._ui = e, this._options = t, this._overlays = Vt.DEFAULTS.OVERLAYS.slice(0), this._overlaysByIdentifier = {};

    var i = e.getEditor().getSDK()._l.areCustomAssetsAllowed();

    i && t.overlays && (t.replaceOverlays ? this._overlays = t.overlays : this._overlays = this._overlays.concat(t.overlays)), i && t.availableOverlays && (this._overlays = this._overlays.filter(function (r) {
      return t.availableOverlays.indexOf(r.identifier) !== -1;
    })), this._overlays.forEach(function (r) {
      _this225._overlaysByIdentifier[r.identifier] = r;
    });
  }

  _createClass($c, [{
    key: "getOverlays",
    value: function getOverlays() {
      return this._overlays;
    }
  }, {
    key: "getOverlayByIdentifier",
    value: function getOverlayByIdentifier(e) {
      return this._overlaysByIdentifier[e];
    }
  }]);

  return $c;
}(),
    $h = $c;

var $t = W.Engine.Filters.OverlayFilter,
    Ur = (_Ur = {}, _defineProperty(_Ur, $t.BLEND_MODES.NORMAL, "normal"), _defineProperty(_Ur, $t.BLEND_MODES.OVERLAY, "overlay"), _defineProperty(_Ur, $t.BLEND_MODES.HARD_LIGHT, "hard light"), _defineProperty(_Ur, $t.BLEND_MODES.SOFT_LIGHT, "soft light"), _defineProperty(_Ur, $t.BLEND_MODES.MULTIPLY, "multiply"), _defineProperty(_Ur, $t.BLEND_MODES.DARKEN, "darken"), _defineProperty(_Ur, $t.BLEND_MODES.LIGHTEN, "lighten"), _defineProperty(_Ur, $t.BLEND_MODES.SCREEN, "screen"), _defineProperty(_Ur, $t.BLEND_MODES.COLOR_BURN, "color burn"), _Ur);

var ay = oe.flipObject(Ur),
    Fn =
/*#__PURE__*/
function (_wn) {
  _inherits(Fn, _wn);

  function Fn() {
    var _getPrototypeOf94;

    var _this226;

    _classCallCheck(this, Fn);

    for (var _len104 = arguments.length, e = new Array(_len104), _key104 = 0; _key104 < _len104; _key104++) {
      e[_key104] = arguments[_key104];
    }

    _this226 = _possibleConstructorReturn(this, (_getPrototypeOf94 = _getPrototypeOf(Fn)).call.apply(_getPrototypeOf94, [this].concat(e)));
    _this226._frameManager = new Zh(_this226._ui, _this226._getOptions("frame"));

    var t = _this226._getOptions("overlay");

    t && (_this226._overlayManager = new $h(_this226._ui, t));
    return _this226;
  }

  _createClass(Fn, [{
    key: "_deserializeSprite",
    value: function _deserializeSprite(e, t) {
      return t.type === "frame" ? this._deserializeFrame(e, t) : t.type === "overlay" ? this._deserializeOverlay(e, t) : _get(_getPrototypeOf(Fn.prototype), "_deserializeSprite", this).call(this, e, t);
    }
  }, {
    key: "_deserializeOperation",
    value: function _deserializeOperation(e) {
      return e.type === "transform" ? this._deserializeTransformOperation(e) : _get(_getPrototypeOf(Fn.prototype), "_deserializeOperation", this).call(this, e);
    }
  }, {
    key: "_deserializeOrientationOperation",
    value: function _deserializeOrientationOperation(e) {
      if (this._data.meta && this._data.meta.platform !== "html5") return _get(_getPrototypeOf(Fn.prototype), "_deserializeOrientationOperation", this).call(this, e);
      var _e$options = e.options,
          t = _e$options.rotation,
          i = _e$options.flipHorizontally,
          r = _e$options.flipVertically,
          o = t === 90 && !i && !r;
      return o |= t === 90 && i && r, o |= t === 270 && !i && !r, o |= t === 270 && i && r, o && (e.options.flipHorizontally = !e.options.flipHorizontally, e.options.flipVertically = !e.options.flipVertically), _get(_getPrototypeOf(Fn.prototype), "_deserializeOrientationOperation", this).call(this, e);
    }
  }, {
    key: "_deserializeTransformOperation",
    value: function _deserializeTransformOperation(e) {
      var _this227 = this;

      return _get(_getPrototypeOf(Fn.prototype), "_deserializeCropOperation", this).call(this, e).then(function (t) {
        if (!t) return;
        var i = oe.Array.find(_this227._data.operations, function (r) {
          return r.type === "orientation";
        });

        if (i) {
          var _r28 = i.options,
              _o46 = _r28.rotation,
              _n32 = _r28.flipHorizontally,
              _a26 = _r28.flipVertically;
          (_o46 === 90 || _o46 === 270) && (!_n32 && _a26 || _n32 && !_a26) && (_n32 = !_n32, _a26 = !_a26), t.rotate(_r28.rotation), _n32 && (t.flip("horizontal"), t.setRotation(t.getRotation() * -1)), _a26 && (t.flip("vertical"), t.setRotation(t.getRotation() * -1));
        }

        return t;
      });
    }
  }, {
    key: "_deserializeFrame",
    value: function _deserializeFrame(e, t) {
      var _this228 = this;

      var i = t.options.identifier,
          r = this._frameManager.getFrameByIdentifier(i);

      if (!r) return A.warn("Deserializer", "Unknown frame `".concat(i, "`. Skipping frame.")), Promise.resolve();
      var o = new Qh(this._ui, r);
      return o.load().then(function () {
        _this228._editor.operations.getOrCreate("frame", {
          frame: o.getFrame()
        });
      });
    }
  }, {
    key: "_deserializeOverlay",
    value: function _deserializeOverlay(e, t) {
      var _this229 = this;

      var _t$options = t.options,
          i = _t$options.blendMode,
          r = _t$options.intensity,
          o = _t$options.identifier,
          n = this._overlayManager.getOverlayByIdentifier(o);

      if (!n) return A.warn("Deserializer", "Unknown overlay `".concat(o, "`. Skipping overlay.")), Promise.resolve();

      var a = this._editor.getUI().getAssetPath(n.image);

      return at.load(a).then(function (l) {
        _this229._editor.operations.getOrCreate("overlay", {
          alpha: r,
          identifier: o,
          blendMode: parseInt(ay[i || n.blendMode], 10),
          image: l
        });
      });
    }
  }, {
    key: "_createBrushForPath",
    value: function _createBrushForPath(e) {
      var t = _get(_getPrototypeOf(Fn.prototype), "_createBrushForPath", this).call(this, e);

      return typeof e.hardness != "undefined" && t.hasOption("hardness") && t.setHardness(e.hardness), t;
    }
  }, {
    key: "_deserializeSticker",
    value: function _deserializeSticker(e, t) {
      var _this230 = this;

      var i = W.Operations.SpriteOperation,
          r = t.options,
          o = this._stickerManager.getStickerByIdentifier(r.identifier),
          n = Pr.getURLForSticker(o, "base");

      if (!o) return A.warn("Deserializer", "Unknown sticker `".concat(r.identifier, "`. Skipping sprite.")), Promise.resolve();
      var a = e.getInputDimensions(!1);
      return new Promise(function (l, c) {
        var u = new window.Image();
        u.addEventListener("load", function () {
          var p = i.StickerSprite.prototype.availableOptions.adjustments.structure,
              h = r.rotation,
              d = r.flipHorizontally,
              g = r.flipVertically,
              y = {
            identifier: r.identifier,
            image: u,
            position: $.fromObject(r.position),
            dimensions: $.fromObject(r.dimensions).multiply(a.min()),
            rotation: h,
            flipHorizontally: d,
            flipVertically: g,
            adjustments: {}
          };
          typeof r.adjustments != "undefined" && ["brightness", "contrast", "saturation"].forEach(function (_) {
            typeof r.adjustments[_] != "undefined" && (y.adjustments[_] = r.adjustments[_] + p[_].default);
          }), typeof r.tintColor != "undefined" && typeof o.tintMode != "undefined" && (y.tintColor = ie.fromArray(r.tintColor), y.tintMode = o.tintMode), l(e.createSticker(y));
        }), u.crossOrigin = _this230._editor.getCrossOrigin(), u.src = _this230._editor.getUI().getAssetPath(n);
      });
    }
  }, {
    key: "_deserializeFilterOperation",
    value: function _deserializeFilterOperation(e) {
      var _this231 = this;

      var t = e.options;
      return this._filterManager.getFilterByIdentifier(t.identifier) ? this._filterManager.instantiateFilterWithIdentifier(t.identifier).then(function (i) {
        var r = _this231._editor.operations.getOrCreate("filter");

        if (!!r) return r.set({
          identifier: t.identifier,
          filter: i,
          intensity: t.intensity
        }), r;
      }) : (A.warn("Deserializer", "Unknown filter `".concat(t.identifier, "`")), Promise.resolve());
    }
  }, {
    key: "_deserializeFocusOperation",
    value: function _deserializeFocusOperation(e) {
      var _e$options2 = e.options,
          t = _e$options2.options,
          i = _e$options2.type;
      if (i !== "radial") return _get(_getPrototypeOf(Fn.prototype), "_deserializeFocusOperation", this).call(this, e);

      var r = this._editor.getImage(),
          o = r.width / r.height,
          n = t.start,
          a = t.end,
          l = t.gradientRadius,
          c = t.blurRadius,
          u = $.fromObject(a).subtract($.fromObject(n)).multiply(o, 1).len();

      return Promise.resolve(this._editor.operations.getOrCreate("radial-focus", {
        position: $.fromObject(n),
        radius: u,
        gradientRadius: l,
        blurRadius: c
      }));
    }
  }, {
    key: "_deserializeText",
    value: function _deserializeText(e, t) {
      var i = t.options,
          r = i.fontSize,
          o = i.lineHeight,
          n = i.fontIdentifier,
          a = i.alignment,
          l = i.rotation,
          c = i.maxWidth,
          u = i.color,
          p = i.backgroundColor,
          h = new Or(this._ui),
          d = this._fontManager.getVariationByIdentifier(n);

      return d ? h.setFonts([d.getFont()]) : d = this._fontManager.getDefaultFont(), h.load().then(function () {
        var g = e.getInputDimensions(!1),
            y = c * g.min() / g.x,
            _ = e.createText({
          fontSize: r,
          lineHeight: o,
          fontFamily: d.getFontFamily(),
          fontWeight: d.getFontWeight(),
          fontIdentifier: d.getIdentifier(),
          alignment: a,
          rotation: l,
          maxWidth: y,
          text: i.text,
          color: ie.fromArray(u),
          backgroundColor: ie.fromArray(p),
          position: $.fromObject(i.position)
        });

        return _._edited = !0, _;
      });
    }
  }]);

  return Fn;
}(wn),
    En = Fn;

Fn.version = "2.0.0";

var Sn =
/*#__PURE__*/
function (_kn) {
  _inherits(Sn, _kn);

  function Sn() {
    _classCallCheck(this, Sn);

    return _possibleConstructorReturn(this, _getPrototypeOf(Sn).apply(this, arguments));
  }

  _createClass(Sn, [{
    key: "_serializeSticker",
    value: function _serializeSticker(e, t) {
      var i = e.getInputDimensions(!1),
          r = _get(_getPrototypeOf(Sn.prototype), "_serializeSticker", this).call(this, e, t);

      return t.getTintMode() !== "none" && (r.options.tintColor = t.serializeOption("tintColor", !0)), r.options.dimensions = t.getDimensions().clone().divide(i.min()).toObject(), r.options.identifier = r.options.name, delete r.options.name, r;
    }
  }, {
    key: "_serializePath",
    value: function _serializePath(e) {
      var t = _get(_getPrototypeOf(Sn.prototype), "_serializePath", this).call(this, e),
          i = e.getBrush();

      return i.hasOption("hardness") && (t.hardness = i.getOption("hardness")), t;
    }
  }, {
    key: "_serializeOperation",
    value: function _serializeOperation(e, t) {
      return e.constructor.identifier === "frame" ? (this._serializeFrameOperation(e, t), null) : e.constructor.identifier === "overlay" ? (this._serializeOverlayOperation(e, t), null) : _get(_getPrototypeOf(Sn.prototype), "_serializeOperation", this).call(this, e, t);
    }
  }, {
    key: "_serializeFrameOperation",
    value: function _serializeFrameOperation(e, t) {
      var i = t.filter(function (o) {
        return o.type === "sprite";
      }),
          r;
      i.length ? r = i.pop() : (r = {
        type: "sprite",
        options: {
          sprites: []
        }
      }, t.push(r)), r.options.sprites.push({
        type: "frame",
        options: this._getFrameOptions(e)
      });
    }
  }, {
    key: "_serializeOverlayOperation",
    value: function _serializeOverlayOperation(e, t) {
      if (!e.getIdentifier()) return;
      var i = t.filter(function (o) {
        return o.type === "sprite";
      }),
          r;
      i.length ? r = i.pop() : (r = {
        type: "sprite",
        options: {
          sprites: []
        }
      }, t.push(r)), r.options.sprites.push({
        type: "overlay",
        options: {
          identifier: e.getIdentifier(),
          intensity: e.getAlpha(),
          blendMode: Ur[e.getBlendMode()]
        }
      });
    }
  }, {
    key: "_getFrameOptions",
    value: function _getFrameOptions(e) {
      return {
        identifier: e.getFrame().identifier
      };
    }
  }, {
    key: "_serializeOrientationOperation",
    value: function _serializeOrientationOperation(e) {
      var t = _get(_getPrototypeOf(Sn.prototype), "_serializeOrientationOperation", this).call(this, e);

      return (t.options.rotation === 90 || t.options.rotation === 270) && (t.options.flipHorizontally = !t.options.flipHorizontally, t.options.flipVertically = !t.options.flipVertically), t;
    }
  }, {
    key: "_serializeTransformOperation",
    value: function _serializeTransformOperation(e) {
      var t = this._editor.operations;

      if (t.exists("orientation")) {
        e = e.clone();

        var _r29 = t.get("orientation");

        e.rotate(-_r29.getRotation()), _r29.getFlipVertically() && (e.flip("vertical"), e.setRotation(e.getRotation() * -1)), _r29.getFlipHorizontally() && (e.flip("horizontal"), e.setRotation(e.getRotation() * -1));
      }

      var i = _get(_getPrototypeOf(Sn.prototype), "_serializeTransformOperation", this).call(this, e);

      return i.type = "transform", i;
    }
  }, {
    key: "_serializeText",
    value: function _serializeText(e, t) {
      var i = _get(_getPrototypeOf(Sn.prototype), "_serializeText", this).call(this, e, t),
          r = e.getInputDimensions(!1);

      return i.options.fontIdentifier = t.getFontIdentifier(), i.options.maxWidth = i.options.maxWidth * r.x / r.min(), delete i.options.fontFamily, i;
    }
  }, {
    key: "_serializeFilterOperation",
    value: function _serializeFilterOperation(e) {
      var t = _get(_getPrototypeOf(Sn.prototype), "_serializeFilterOperation", this).call(this, e);

      return t ? (t.options.identifier = t.options.name, delete t.options.name, t) : null;
    }
  }, {
    key: "_serializeRadialFocusOperation",
    value: function _serializeRadialFocusOperation(e) {
      var t = _get(_getPrototypeOf(Sn.prototype), "_serializeRadialFocusOperation", this).call(this, e),
          i = t.options.options;

      return i.start = i.position, delete i.position, i.end = {
        x: i.start.x + i.radius,
        y: i.start.y
      }, delete i.radius, t;
    }
  }]);

  return Sn;
}(kn),
    An = Sn;

Sn.version = "2.0.0";
var Jc;
typeof W.Operations.SpriteOperation != "undefined" && (Jc = W.Operations.SpriteOperation.BrushSprite.Brush);

var On =
/*#__PURE__*/
function (_En) {
  _inherits(On, _En);

  function On() {
    _classCallCheck(this, On);

    return _possibleConstructorReturn(this, _getPrototypeOf(On).apply(this, arguments));
  }

  _createClass(On, [{
    key: "_deserializeSticker",
    value: function _deserializeSticker(e, t) {
      var i = W.Operations.SpriteOperation,
          r = t.options,
          o = this._stickerManager.getStickerByIdentifier(r.identifier);

      if (!o) return A.warn("Deserializer", "Unknown sticker `".concat(r.identifier, "`. Skipping sprite.")), Promise.resolve();
      var n = o.images.mediaBase,
          a = Pr.getURLForSticker(o, "base"),
          l = n.rawData ? n.uris[0] : this._editor.getUI().getAssetPath(a),
          c = e.getInputDimensions(!1);
      return at.load(l).then(function (u) {
        var p = i.StickerSprite.prototype.availableOptions.adjustments.structure,
            h = r.rotation,
            d = r.flipHorizontally,
            g = r.flipVertically,
            y = {
          identifier: r.identifier,
          image: u,
          position: $.fromObject(r.position),
          dimensions: $.fromObject(r.dimensions).multiply(c.min()),
          rotation: h || 0,
          flipHorizontally: d,
          flipVertically: g,
          resizeMode: o.resizeMode || "keepAspect",
          adjustments: {}
        };
        return typeof r.adjustments != "undefined" && ["brightness", "contrast", "saturation"].forEach(function (_) {
          typeof r.adjustments[_] != "undefined" && (y.adjustments[_] = r.adjustments[_] + p[_].default);
        }), typeof r.tintMode != "undefined" && typeof r.tintColor != "undefined" ? (y.tintColor = ie.fromArray(r.tintColor.rgba), y.tintMode = r.tintMode) : typeof r.tintColor != "undefined" && typeof o.tintMode != "undefined" && (y.tintColor = ie.fromArray(r.tintColor.rgba), y.tintMode = o.tintMode), typeof r.alpha != "undefined" && (y.alpha = r.alpha), e.createSticker(y);
      });
    }
  }, {
    key: "_deserializeTransformOperation",
    value: function _deserializeTransformOperation(e) {
      return _get(_getPrototypeOf(On.prototype), "_deserializeTransformOperation", this).call(this, e).then(function (t) {
        if (!!t) return t._ratio = null, t;
      });
    }
  }, {
    key: "_deserializeInputImage",
    value: function _deserializeInputImage() {
      var _this232 = this;

      var _this$_data$image = this._data.image,
          e = _this$_data$image.data,
          t = _this$_data$image.type,
          i = _this$_data$image.uri;
      return e && t && (i = "data:".concat(t, ";base64,").concat(e)), i ? at.load(i).then(function (r) {
        _this232._editor.setImage(r);
      }) : Promise.resolve();
    }
  }, {
    key: "_deserializeAdjustmentsOperation",
    value: function _deserializeAdjustmentsOperation(e) {
      var t = W.Operations.AdjustmentsOperation;
      return _get(_getPrototypeOf(On.prototype), "_deserializeAdjustmentsOperation", this).call(this, e).then(function (i) {
        if (!i) return null;
        var r = e.options,
            o = ["gamma", "whites", "blacks", "temperature"],
            n = {};
        return o.forEach(function (a) {
          if (typeof r[a] == "undefined") return;
          var _t$prototype$availabl2 = t.prototype.availableOptions[a],
              l = _t$prototype$availabl2.minValue,
              c = _t$prototype$availabl2.midValue,
              u = _t$prototype$availabl2.maxValue,
              p = r[a];
          p = p < 0 ? c + (c - l) * p : c + (u - c) * p, n[a] = p;
        }), i.set(n), i;
      });
    }
  }, {
    key: "_deserializeFocusOperation",
    value: function _deserializeFocusOperation(e) {
      var t = e.options.options;

      switch (e.options.type) {
        case "radial":
          return _get(_getPrototypeOf(On.prototype), "_deserializeFocusOperation", this).call(this, e);

        case "linear":
          {
            var _i29 = t.start,
                _r30 = t.end,
                _o47 = t.blurRadius;
            return Promise.resolve(this._editor.operations.getOrCreate("linear-focus", {
              controlPoint1: $.fromObject(_i29),
              controlPoint2: $.fromObject(_r30),
              blurRadius: _o47
            }));
          }

        case "mirrored":
          {
            var _i30 = t.start,
                _r31 = t.end,
                _o48 = t.size,
                _n33 = t.gradientSize,
                _a27 = t.blurRadius;
            return Promise.resolve(this._editor.operations.getOrCreate("mirrored-focus", {
              start: $.fromObject(_i30),
              end: $.fromObject(_r31),
              size: _o48,
              gradientSize: _n33,
              blurRadius: _a27
            }));
          }

        case "gaussian":
          {
            var _i31 = t.blurRadius;
            return Promise.resolve(this._editor.operations.getOrCreate("blur", {
              blurRadius: _i31
            }));
          }
      }
    }
  }, {
    key: "_deserializeText",
    value: function _deserializeText(e, t) {
      var i = t.options,
          r = i.fontSize,
          o = i.lineHeight,
          n = i.fontIdentifier,
          a = i.alignment,
          l = i.rotation,
          c = i.maxWidth,
          u = i.color,
          p = i.backgroundColor,
          h = this._ui.getFontLoader(),
          d = this._fontManager.getVariationByIdentifier(n);

      return d ? h.setFonts([d.getFont()]) : d = this._fontManager.getDefaultVariation(), h.load().then(function () {
        var g = e.getInputDimensions(!1),
            y = c * g.min() / g.x,
            _ = e.createText({
          fontSize: r,
          lineHeight: o,
          fontFamily: d.getFontFamily(),
          fontWeight: d.getFontWeight(),
          fontIdentifier: d.getIdentifier(),
          textMetrics: d.getTextMetrics(),
          alignment: a,
          rotation: l,
          maxWidth: y,
          text: i.text,
          color: ie.fromArray(u.rgba),
          backgroundColor: ie.fromArray(p.rgba),
          position: $.fromObject(i.position)
        });

        return _._edited = !0, _;
      });
    }
  }, {
    key: "_createBrushForPath",
    value: function _createBrushForPath(e) {
      var _e$brush = e.brush,
          t = _e$brush.identifier,
          i = _e$brush.color,
          r = _e$brush.size,
          o = _e$brush.hardness,
          a = {
        color: ie.fromArray(i.rgba),
        size: r
      };
      typeof o != "undefined" && (a.hardness = o);

      var l = this._brushManager.getBrushByIdentifier(t);

      if (l || (l = this._brushManager.getFirstBrush()), l.prototype && l.prototype instanceof Jc) {
        var _p25 = l;
        return new _p25(a);
      }

      var c = C({}, l);
      delete c.image;

      var u =
      /*#__PURE__*/
      function (_Jc) {
        _inherits(u, _Jc);

        function u() {
          _classCallCheck(this, u);

          return _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments));
        }

        return u;
      }(Jc);

      return u.identifier = l.identifier, new u(C(C({}, c), a));
    }
  }, {
    key: "_deserializeFrame",
    value: function _deserializeFrame(e, t) {
      var _this233 = this;

      return _get(_getPrototypeOf(On.prototype), "_deserializeFrame", this).call(this, e, t).then(function () {
        var i = _this233._editor.operations.get("frame"),
            _t$options2 = t.options,
            r = _t$options2.size,
            o = _t$options2.alpha,
            n = _t$options2.tintColor,
            a = {};

        typeof r != "undefined" && (a.scale = r), typeof o != "undefined" && (a.alpha = o), typeof n != "undefined" && (a.tintColor = ie.fromArray(n.rgba)), i.set(a);
      });
    }
  }, {
    key: "_deserializeTextDesign",
    value: function _deserializeTextDesign(e, t) {
      var _this234 = this;

      var i = t.options,
          r = i.position,
          o = i.rotation,
          n = i.flipHorizontally,
          a = i.flipVertically,
          l = i.text,
          c = i.color,
          u = i.width,
          p = i.seed,
          h = i.inverted,
          d = i.identifier;
      d === W.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignBlocksLight.identifier ? d = W.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignBlocksLightV310.identifier : d === W.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignSunshine.identifier && (d = W.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignSunshineV310.identifier);

      var g = new zt(this._ui, this._getOptions("textdesign")),
          y = new st(this._ui, {
        fonts: de.DEFAULTS.TEXT_DESIGN_FONTS,
        replaceFonts: !0
      }),
          _ = e.constructor.TextDesignSprite.AssetManager,
          f = this._ui.getFontLoader(),
          v = g.getLayoutByIdentifier(d),
          b = new v();

      return f.setFonts(y.getFonts()), _.setFonts(C(C({}, _.getFonts()), y.getVariationsByIdentifier())), f.load().then(function () {
        var D = b.getImagePaths().map(function (O) {
          return {
            path: O,
            fullPath: _this234._ui.getAssetPath(O),
            image: null
          };
        });
        return _.loadImages(D).then(function () {
          return b.onImagesLoaded(), e.createTextDesign({
            position: r,
            rotation: o,
            flipHorizontally: n,
            flipVertically: a,
            text: l,
            color: ie.fromArray(c.rgba),
            width: u,
            seed: p,
            inverted: h,
            layout: b
          });
        });
      });
    }
  }]);

  return On;
}(En),
    Pn = On;

On.version = "3.0.0";

var Bn =
/*#__PURE__*/
function (_V23) {
  _inherits(Bn, _V23);

  function Bn() {
    _classCallCheck(this, Bn);

    return _possibleConstructorReturn(this, _getPrototypeOf(Bn).apply(this, arguments));
  }

  return Bn;
}(V),
    Mn = Bn;

Bn.prototype.availableOptions = {
  identifier: {
    type: m.STRING,
    required: !0
  },
  defaultName: {
    type: m.STRING,
    required: !0
  },
  ratio: {
    type: m.ALL,
    required: !1,
    default: null
  },
  selected: {
    type: m.BOOLEAN,
    required: !1
  },
  dimensions: {
    type: m.VECTOR2,
    required: !1
  },
  lockDimensions: {
    type: m.BOOLEAN,
    required: !1,
    default: null
  },
  forceDimensions: {
    type: m.BOOLEAN,
    required: !1,
    default: null
  }
};

var Ln =
/*#__PURE__*/
function (_An) {
  _inherits(Ln, _An);

  function Ln() {
    _classCallCheck(this, Ln);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ln).apply(this, arguments));
  }

  _createClass(Ln, [{
    key: "serialize",
    value: function serialize() {
      var _this235 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _get(_getPrototypeOf(Ln.prototype), "serialize", this).call(this, e).then(function (t) {
        return t.meta = {
          platform: "html5",
          version: _this235._editor.getSDK().version,
          createdAt: oe.ISODateString(new Date())
        }, t.image = t.inputImage, delete t.inputImage, t;
      });
    }
  }, {
    key: "_serializeSticker",
    value: function _serializeSticker(e, t) {
      var i = _get(_getPrototypeOf(Ln.prototype), "_serializeSticker", this).call(this, e, t);

      return i.options.alpha = t.getAlpha(), i.options.tintColor && (i.options.tintColor = {
        rgba: i.options.tintColor
      }), i;
    }
  }, {
    key: "_serializeText",
    value: function _serializeText(e, t) {
      var i = _get(_getPrototypeOf(Ln.prototype), "_serializeText", this).call(this, e, t);

      return i.options.color = {
        rgba: i.options.color
      }, i.options.backgroundColor = {
        rgba: i.options.backgroundColor
      }, i.options.flipHorizontally = !1, i.options.flipVertically = !1, delete i.options.fontWeight, i;
    }
  }, {
    key: "_serializePath",
    value: function _serializePath(e) {
      var t = _get(_getPrototypeOf(Ln.prototype), "_serializePath", this).call(this, e);

      delete t.hardness, delete t.size, delete t.color;
      var i = e.getBrush();
      t.brush = i.serializeOptions(["identifier", "size", "color"], !0), typeof t.brush.identifier == "undefined" && delete t.brush.identifier, t.brush.color = {
        rgba: t.brush.color
      };
      var r = i.getOption("hardness");
      return r !== "undefined" && (t.brush.hardness = r), t;
    }
  }, {
    key: "_serializeFrameOperation",
    value: function _serializeFrameOperation(e, t) {
      _get(_getPrototypeOf(Ln.prototype), "_serializeFrameOperation", this).call(this, e, t);

      var i = t.filter(function (o) {
        return o.type === "sprite";
      }),
          r;

      if (i.length) {
        r = i.pop();
        var _o49 = r.options.sprites.filter(function (l) {
          return l.type === "frame";
        })[0];
        e.getTintColor().equals(new ie(1, 1, 1, 0)) || (_o49.options.tintColor = {
          rgba: e.serializeOption("tintColor", !0)
        });

        var _a28 = e.serializeOptions(["scale", "alpha"], !0);

        _o49.options = C(C({}, _o49.options), _a28), _o49.options.size = _o49.options.scale, delete _o49.options.scale;
      }
    }
  }, {
    key: "_serializeTransformOperation",
    value: function _serializeTransformOperation(e) {
      var t = _get(_getPrototypeOf(Ln.prototype), "_serializeTransformOperation", this).call(this, e);

      if (e._ratio) {
        var _i32;

        e._ratio instanceof Mn ? _i32 = e._ratio.getIdentifier() : _i32 = e._ratio.identifier, t.options.meta = {
          identifier: _i32
        };
      }

      return delete t.options.scale, t;
    }
  }, {
    key: "_serializeAdjustmentsOperation",
    value: function _serializeAdjustmentsOperation(e) {
      var t = _get(_getPrototypeOf(Ln.prototype), "_serializeAdjustmentsOperation", this).call(this, e),
          i = ["gamma", "whites", "blacks", "temperature"],
          r = e.availableOptions,
          o = {};

      return i.forEach(function (n) {
        var a = r[n],
            l = e.getOption(n),
            c = a.minValue,
            u = a.midValue,
            p = a.maxValue;
        o[n] = l <= u ? (l - c) / (u - c) - 1 : (l - u) / (p - u);
      }), t.options = C(C({}, t.options), o), t;
    }
  }, {
    key: "_serializeOperation",
    value: function _serializeOperation(e, t) {
      switch (e.constructor.identifier) {
        case "mirrored-focus":
          return this._serializeMirroredFocusOperation(e);

        case "linear-focus":
          return this._serializeLinearFocusOperation(e);

        case "blur":
          return this._serializeBlurOperation(e);

        default:
          return _get(_getPrototypeOf(Ln.prototype), "_serializeOperation", this).call(this, e, t);
      }
    }
  }, {
    key: "_serializeMirroredFocusOperation",
    value: function _serializeMirroredFocusOperation(e) {
      return {
        type: "focus",
        options: {
          type: "mirrored",
          options: e.serializeOptions(["start", "end", "blurRadius", "size", "gradientSize"], !0)
        }
      };
    }
  }, {
    key: "_serializeLinearFocusOperation",
    value: function _serializeLinearFocusOperation(e) {
      var t = e.serializeOptions(["controlPoint1", "controlPoint2", "blurRadius"], !0);
      return t.start = t.controlPoint1, delete t.controlPoint1, t.end = t.controlPoint2, delete t.controlPoint2, {
        type: "focus",
        options: {
          type: "linear",
          options: t
        }
      };
    }
  }, {
    key: "_serializeBlurOperation",
    value: function _serializeBlurOperation(e) {
      return {
        type: "focus",
        options: {
          type: "gaussian",
          options: e.serializeOptions(["blurRadius"], !0)
        }
      };
    }
  }]);

  return Ln;
}(An),
    zn = Ln;

Ln.version = "3.0.0";

var Nn =
/*#__PURE__*/
function (_Pn) {
  _inherits(Nn, _Pn);

  function Nn() {
    _classCallCheck(this, Nn);

    return _possibleConstructorReturn(this, _getPrototypeOf(Nn).apply(this, arguments));
  }

  _createClass(Nn, [{
    key: "_deserializeTextDesign",
    value: function _deserializeTextDesign(e, t) {
      var _this236 = this;

      var i = t.options,
          r = i.position,
          o = i.rotation,
          n = i.flipHorizontally,
          a = i.flipVertically,
          l = i.text,
          c = i.color,
          u = i.width,
          p = i.seed,
          h = i.inverted,
          d = i.identifier;
      d === W.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignBlocksLight.identifier ? d = W.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignBlocksLightV310.identifier : d === W.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignSunshine.identifier && (d = W.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignSunshineV310.identifier);

      var g = new zt(this._ui, this._getOptions("textdesign")),
          y = new st(this._ui, {
        fonts: de.DEFAULTS.TEXT_DESIGN_FONTS,
        replaceFonts: !0
      }),
          _ = e.constructor.TextDesignSprite.AssetManager,
          f = this._ui.getFontLoader(),
          v = g.getLayoutByIdentifier(d),
          b = new v();

      return f.setFonts(y.getFonts()), _.setFonts(C(C({}, _.getFonts()), y.getVariationsByIdentifier())), f.load().then(function () {
        var D = b.getImagePaths().map(function (O) {
          return {
            path: O,
            fullPath: _this236._ui.getAssetPath(O),
            image: null
          };
        });
        return _.loadImages(D).then(function () {
          return b.onImagesLoaded(), e.createTextDesign({
            position: r,
            rotation: o,
            flipHorizontally: n,
            flipVertically: a,
            text: l,
            color: ie.fromArray(c.rgba),
            width: u,
            seed: p,
            inverted: h,
            layout: b
          });
        });
      });
    }
  }]);

  return Nn;
}(Pn),
    Gn = Nn;

Nn.version = "3.1.0";

var Wn =
/*#__PURE__*/
function (_zn) {
  _inherits(Wn, _zn);

  function Wn() {
    _classCallCheck(this, Wn);

    return _possibleConstructorReturn(this, _getPrototypeOf(Wn).apply(this, arguments));
  }

  _createClass(Wn, [{
    key: "_serializeTextDesign",
    value: function _serializeTextDesign(e, t) {
      var i = t.serializeOptions(["position", "rotation", "flipHorizontally", "flipVertically", "text", "color", "width", "seed", "inverted"], !0);
      i.color = {
        rgba: i.color
      };
      var r = t.getLayout();
      return r && (i.identifier = r.constructor.identifier), {
        type: "textdesign",
        options: i
      };
    }
  }]);

  return Wn;
}(zn),
    Vn = Wn;

Wn.version = "3.1.0";

var jn =
/*#__PURE__*/
function (_Gn) {
  _inherits(jn, _Gn);

  function jn() {
    _classCallCheck(this, jn);

    return _possibleConstructorReturn(this, _getPrototypeOf(jn).apply(this, arguments));
  }

  _createClass(jn, [{
    key: "_deserializeTextDesign",
    value: function _deserializeTextDesign(e, t) {
      var _this237 = this;

      var i = t.options,
          r = i.position,
          o = i.rotation,
          n = i.flipHorizontally,
          a = i.flipVertically,
          l = i.text,
          c = i.color,
          u = i.width,
          p = i.seed,
          h = i.inverted,
          d = i.identifier;
      d === W.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignBlocksLight.identifier ? d = W.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignBlocksLightV310.identifier : d === W.Operations.SpriteOperation.TextDesignSprite.Layouts.TextDesignSunshine.identifier && (d = W.Operations.SpriteOperation.TextDesignSprite.LegacyLayouts.TextDesignSunshineV310.identifier);

      var g = "padding" in i ? i.padding / u : -1,
          y = new zt(this._ui, this._getOptions("textdesign")),
          _ = new st(this._ui, {
        fonts: de.DEFAULTS.TEXT_DESIGN_FONTS,
        replaceFonts: !0
      }),
          f = e.constructor.TextDesignSprite.AssetManager,
          v = this._ui.getFontLoader(),
          b = y.getLayoutByIdentifier(d),
          D = new b();

      return v.setFonts(_.getFonts()), f.setFonts(C(C({}, f.getFonts()), _.getVariationsByIdentifier())), v.load().then(function () {
        var O = D.getImagePaths().map(function (x) {
          return {
            path: x,
            fullPath: _this237._ui.getAssetPath(x),
            image: null
          };
        });
        return f.loadImages(O).then(function () {
          return D.onImagesLoaded(), e.createTextDesign({
            position: r,
            rotation: o,
            flipHorizontally: n,
            flipVertically: a,
            text: l,
            color: ie.fromArray(c.rgba),
            width: u,
            seed: p,
            inverted: h,
            layout: D,
            padding: g
          });
        });
      });
    }
  }]);

  return jn;
}(Gn),
    Yn = jn;

jn.version = "3.2.0";

var qn =
/*#__PURE__*/
function (_Vn) {
  _inherits(qn, _Vn);

  function qn() {
    _classCallCheck(this, qn);

    return _possibleConstructorReturn(this, _getPrototypeOf(qn).apply(this, arguments));
  }

  _createClass(qn, [{
    key: "_serializeTextDesign",
    value: function _serializeTextDesign(e, t) {
      var i = t.serializeOptions(["position", "rotation", "flipHorizontally", "flipVertically", "text", "color", "width", "seed", "inverted", "padding"], !0);
      i.color = {
        rgba: i.color
      };
      var r = t.getLayout();
      return r && (i.identifier = r.constructor.identifier), i.padding *= i.width, {
        type: "textdesign",
        options: i
      };
    }
  }]);

  return qn;
}(Vn),
    Kn = qn;

qn.version = "3.2.0";

var Qn =
/*#__PURE__*/
function (_Yn) {
  _inherits(Qn, _Yn);

  function Qn() {
    _classCallCheck(this, Qn);

    return _possibleConstructorReturn(this, _getPrototypeOf(Qn).apply(this, arguments));
  }

  _createClass(Qn, [{
    key: "_deserializeOperation",
    value: function _deserializeOperation(e) {
      return _get(_getPrototypeOf(Qn.prototype), "_deserializeOperation", this).call(this, e);
    }
  }, {
    key: "_deserializeOrientationOperation",
    value: function _deserializeOrientationOperation(e) {
      var t = e.options,
          i = this._editor.operations.getOrCreate("orientation");

      return i ? (i.set(t), Promise.resolve(i)) : Promise.resolve();
    }
  }]);

  return Qn;
}(Yn),
    Zn = Qn;

Qn.version = "3.4.0";

var $n =
/*#__PURE__*/
function (_Kn) {
  _inherits($n, _Kn);

  function $n() {
    _classCallCheck(this, $n);

    return _possibleConstructorReturn(this, _getPrototypeOf($n).apply(this, arguments));
  }

  _createClass($n, [{
    key: "_serializeOperation",
    value: function _serializeOperation(e, t) {
      switch (e.constructor.identifier) {
        case "artfilter":
          return this._serializeStyle(e);

        default:
          return _get(_getPrototypeOf($n.prototype), "_serializeOperation", this).call(this, e, t);
      }
    }
  }, {
    key: "_serializeOrientationOperation",
    value: function _serializeOrientationOperation(e) {
      return {
        type: "orientation",
        options: e.serializeOptions(["flipVertically", "flipHorizontally", "rotation"], !0)
      };
    }
  }, {
    key: "_serializeStyle",
    value: function _serializeStyle(e) {
      var _e$getOptions = e.getOptions(),
          t = _e$getOptions.identifier,
          i = _e$getOptions.intensity,
          r = _e$getOptions.blendMode,
          _e$getStyleTransferMo = e.getStyleTransferModel().getOptions(),
          o = _e$getStyleTransferMo.tileEdgeLength,
          n = _e$getStyleTransferMo.overlappingFactor;

      return {
        type: "artFilter",
        options: {
          identifier: t,
          intensity: i,
          blendMode: Ur[r],
          tileEdgeLength: o,
          overlappingFactor: n
        }
      };
    }
  }]);

  return $n;
}(Kn),
    Jn = $n;

$n.version = "3.4.0";

var ta =
/*#__PURE__*/
function (_Zn) {
  _inherits(ta, _Zn);

  function ta() {
    _classCallCheck(this, ta);

    return _possibleConstructorReturn(this, _getPrototypeOf(ta).apply(this, arguments));
  }

  _createClass(ta, [{
    key: "_deserializeTextDesign",
    value: function _deserializeTextDesign(e, t) {
      var _this238 = this;

      var i = t.options,
          r = i.position,
          o = i.rotation,
          n = i.flipHorizontally,
          a = i.flipVertically,
          l = i.text,
          c = i.color,
          u = i.width,
          p = i.seed,
          h = i.inverted,
          d = i.identifier,
          g = "padding" in i ? i.padding / u : -1,
          y = new zt(this._ui, this._getOptions("textdesign")),
          _ = new st(this._ui, {
        fonts: de.DEFAULTS.TEXT_DESIGN_FONTS,
        replaceFonts: !0
      }),
          f = e.constructor.TextDesignSprite.AssetManager,
          v = this._ui.getFontLoader(),
          b = y.getLayoutByIdentifier(d),
          D = new b();

      return v.setFonts(_.getFonts()), f.setFonts(C(C({}, f.getFonts()), _.getVariationsByIdentifier())), v.load().then(function () {
        var O = D.getImagePaths().map(function (x) {
          return {
            path: x,
            fullPath: _this238._ui.getAssetPath(x),
            image: null
          };
        });
        return f.loadImages(O).then(function () {
          return D.onImagesLoaded(), e.createTextDesign({
            position: r,
            rotation: o,
            flipHorizontally: n,
            flipVertically: a,
            text: l,
            color: ie.fromArray(c.rgba),
            width: u,
            seed: p,
            inverted: h,
            layout: D,
            padding: g
          });
        });
      });
    }
  }]);

  return ta;
}(Zn),
    ia = ta;

ta.version = "3.5.0";

var ra =
/*#__PURE__*/
function (_Jn) {
  _inherits(ra, _Jn);

  function ra() {
    _classCallCheck(this, ra);

    return _possibleConstructorReturn(this, _getPrototypeOf(ra).apply(this, arguments));
  }

  return ra;
}(Jn),
    sa = ra;

ra.version = "3.5.0";

var na =
/*#__PURE__*/
function (_ia) {
  _inherits(na, _ia);

  function na() {
    _classCallCheck(this, na);

    return _possibleConstructorReturn(this, _getPrototypeOf(na).apply(this, arguments));
  }

  _createClass(na, [{
    key: "_deserializeAdjustmentsOperation",
    value: function _deserializeAdjustmentsOperation(e) {
      var t = W.Operations.AdjustmentsOperation;
      return _get(_getPrototypeOf(na.prototype), "_deserializeAdjustmentsOperation", this).call(this, e).then(function (i) {
        if (!i) return null;
        var r = e.options,
            o = "sharpness",
            n = {};
        if (typeof r[o] == "undefined") return;
        var _t$prototype$availabl3 = t.prototype.availableOptions[o],
            a = _t$prototype$availabl3.minValue,
            l = _t$prototype$availabl3.midValue,
            c = _t$prototype$availabl3.maxValue,
            u = r[o];
        return u = u < 0 ? l + (l - a) * u : l + (c - l) * u, n[o] = u, i.set(n), i;
      });
    }
  }]);

  return na;
}(ia),
    aa = na;

na.version = "3.6.0";

var la =
/*#__PURE__*/
function (_sa) {
  _inherits(la, _sa);

  function la() {
    _classCallCheck(this, la);

    return _possibleConstructorReturn(this, _getPrototypeOf(la).apply(this, arguments));
  }

  _createClass(la, [{
    key: "_serializeAdjustmentsOperation",
    value: function _serializeAdjustmentsOperation(e) {
      var t = _get(_getPrototypeOf(la.prototype), "_serializeAdjustmentsOperation", this).call(this, e),
          i = "sharpness",
          r = e.availableOptions,
          o = {},
          n = r[i],
          a = e.getOption(i),
          l = n.minValue,
          c = n.midValue,
          u = n.maxValue;

      return o[i] = a <= c ? (a - l) / (c - l) - 1 : (a - c) / (u - c), t.options = C(C({}, t.options), o), t;
    }
  }]);

  return la;
}(sa),
    ca = la;

la.version = "3.6.0";

var ma =
/*#__PURE__*/
function (_aa) {
  _inherits(ma, _aa);

  function ma() {
    _classCallCheck(this, ma);

    return _possibleConstructorReturn(this, _getPrototypeOf(ma).apply(this, arguments));
  }

  _createClass(ma, [{
    key: "deserialize",
    value: function deserialize() {
      var _this239 = this;

      return this._validateVersion().then(function () {
        return _this239._deserializeAssetLibrary();
      }).then(function () {
        return _this239._deserializeInputImage();
      }).then(function () {
        return _this239._deserializeOperations();
      });
    }
  }, {
    key: "_deserializeAssetLibrary",
    value: function _deserializeAssetLibrary() {
      var _this240 = this;

      return new Promise(function (e, t) {
        var i = _this240._data;

        if (!i.assetLibrary) {
          e();
          return;
        }

        var r = i.assetLibrary.assets,
            o = [];

        for (var _n34 in r) {
          o.push(_this240._deserializeCustomAssets(_n34, r[_n34]));
        }

        return Promise.all(o).then(function () {
          e();
        }).catch(function (n) {
          console.error(n), t(n);
        });
      });
    }
  }, {
    key: "_deserializeCustomAssets",
    value: function _deserializeCustomAssets(e, t) {
      switch (e) {
        case "stickers":
          return this._deserializeCustomStickerAssets(t);

        default:
          return Promise.reject(new Error("Unknown asset type: ".concat(e)));
      }
    }
  }, {
    key: "_deserializeCustomStickerAssets",
    value: function _deserializeCustomStickerAssets(e) {
      var _this241 = this;

      var t = "none",
          i = this._editor.getOptions().editor;

      i && i.controlsOptions && i.controlsOptions.sticker && (t = i.controlsOptions.sticker.customStickerTintMode || "none");
      var r = e.map(function (o) {
        return new Promise(function (n, a) {
          var l = o.identifier,
              c = o.raster,
              u = o.svg !== void 0,
              p = "data:".concat(c.type, ";base64,").concat(c.data),
              h = new $e();
          h.onload = function () {
            h = _this241._editor.getSDK().correctExifOrientation(h), h.toDataURL && (p = h.toDataURL());
            var g = {
              data: "",
              width: 1,
              height: 1
            };
            g = _this241._stickerManager.renderStickerThumbnailFromImage(h);
            var y = {
              identifier: l,
              defaultName: o.name || "",
              tintMode: t,
              images: {
                mediaBase: {
                  uris: [p],
                  rawData: !0,
                  isSVG: u,
                  width: h.width,
                  height: h.height
                },
                mediaThumb: {
                  uris: [g.data],
                  rawData: !0,
                  width: g.width,
                  height: g.height
                }
              }
            };

            if (u) {
              var _23 = "data:image/svg+xml;base64,".concat(o.svg.data);

              y.images.mediaBase.uris.push(_23);
            }

            n(y);
          }, h.onerror = function () {
            a(new Error("Invalid base64 data: ".concat(p)));
          }, h.src = p;
        });
      });
      return Promise.all(r).then(function (o) {
        _this241._editor.getDynamicAssetsLibrary().setAssets("sticker", o), _this241._stickerManager.reload();
      });
    }
  }]);

  return ma;
}(aa),
    da = ma;

ma.version = "3.7.0";

var ha =
/*#__PURE__*/
function (_ca) {
  _inherits(ha, _ca);

  function ha() {
    _classCallCheck(this, ha);

    return _possibleConstructorReturn(this, _getPrototypeOf(ha).apply(this, arguments));
  }

  _createClass(ha, [{
    key: "serialize",
    value: function serialize() {
      var _this242 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _get(_getPrototypeOf(ha.prototype), "serialize", this).call(this, e).then(function (t) {
        return _this242._serializeAssetLibrary(t).then(function (i) {
          return i;
        });
      });
    }
  }, {
    key: "_serializeAssetLibrary",
    value: function _serializeAssetLibrary(e) {
      if (!this._editor.getDynamicAssetsLibrary) return Promise.resolve(e);

      var t = this._editor.getDynamicAssetsLibrary(),
          i = this._serializeCustomStickerAssets(e, t);

      return i.length === 0 || (e.assetLibrary = {
        assets: {
          stickers: i
        }
      }), Promise.resolve(e);
    }
  }, {
    key: "_serializeCustomStickerAssets",
    value: function _serializeCustomStickerAssets(e, t) {
      var i = t.getAssets("sticker");
      if (i.length === 0) return [];
      var r = e.operations.filter(function (a) {
        return a.type === "sprite";
      }).flatMap(function (a) {
        return a.options.sprites;
      }).filter(function (a) {
        return a.type === "sticker";
      }).map(function (a) {
        return a.options.identifier;
      }),
          o = {};
      return r.forEach(function (a) {
        o[a] = !0;
      }), i.filter(function (a) {
        return o[a.identifier];
      }).map(function (a) {
        var l = a.identifier,
            c = a.defaultName,
            u = a.images,
            p = u.mediaBase.uris[0],
            h = u.mediaBase.isSVG,
            g = /^data:(image\/(jpeg|png));base64,(.*)$/g.exec(p),
            y = g[1],
            _ = g[3],
            f = {
          identifier: l,
          name: c,
          raster: {
            type: y,
            data: _
          }
        };
        return c && (f.name = c), h && (f.svg = {
          data: u.mediaBase.uris[1].replace(/^data:image\/svg\+xml;base64,/g, "")
        }), f;
      });
    }
  }]);

  return ha;
}(ca),
    pa = ha;

ha.version = "3.7.0";

var fa =
/*#__PURE__*/
function (_da) {
  _inherits(fa, _da);

  function fa() {
    _classCallCheck(this, fa);

    return _possibleConstructorReturn(this, _getPrototypeOf(fa).apply(this, arguments));
  }

  return fa;
}(da),
    _a = fa;

fa.version = "3.8.0";

var ya =
/*#__PURE__*/
function (_pa) {
  _inherits(ya, _pa);

  function ya() {
    _classCallCheck(this, ya);

    return _possibleConstructorReturn(this, _getPrototypeOf(ya).apply(this, arguments));
  }

  _createClass(ya, [{
    key: "_serializeSticker",
    value: function _serializeSticker(e, t) {
      var i = _get(_getPrototypeOf(ya.prototype), "_serializeSticker", this).call(this, e, t);

      return i.options.tintMode = t.getTintMode(), i;
    }
  }]);

  return ya;
}(pa),
    ba = ya;

ya.version = "3.8.0";

var va =
/*#__PURE__*/
function (_a29) {
  _inherits(va, _a29);

  function va() {
    _classCallCheck(this, va);

    return _possibleConstructorReturn(this, _getPrototypeOf(va).apply(this, arguments));
  }

  _createClass(va, [{
    key: "_deserializeTransformOperation",
    value: function _deserializeTransformOperation(e) {
      var _this243 = this;

      return _get(_getPrototypeOf(va.prototype), "_deserializeCropOperation", this).call(this, e).then(function (t) {
        if (!t) return;
        var i = oe.Array.find(_this243._data.operations, function (r) {
          return r.type === "orientation";
        });

        if (i) {
          var _r32 = i.options;
          t.rotate(_r32.rotation), _r32.flipHorizontally && (t.flip("horizontal"), t.setRotation(t.getRotation() * -1)), _r32.flipVertically && (t.flip("vertical"), t.setRotation(t.getRotation() * -1));
        }

        return t._ratio = null, t;
      });
    }
  }, {
    key: "_deserializeText",
    value: function _deserializeText(e, t) {
      var i = t.options,
          r = i.fontSize,
          o = i.lineHeight,
          n = i.fontIdentifier,
          a = i.alignment,
          l = i.rotation,
          c = i.maxWidth,
          u = i.color,
          p = i.backgroundColor,
          h = this._ui.getFontLoader(),
          d = this._fontManager.getVariationByIdentifier(n);

      return d ? h.setFonts([d.getFont()]) : d = this._fontManager.getDefaultVariation(), h.load().then(function () {
        var g = e.getInputDimensions(!1),
            y = g.min(),
            _ = g.x,
            f = g.y,
            v = c * y / _,
            b = r * y / f,
            D = e.createText({
          fontSize: b,
          lineHeight: o,
          fontFamily: d.getFontFamily(),
          fontWeight: d.getFontWeight(),
          fontIdentifier: d.getIdentifier(),
          textMetrics: d.getTextMetrics(),
          alignment: a,
          rotation: l,
          maxWidth: v,
          text: i.text,
          color: ie.fromArray(u.rgba),
          backgroundColor: ie.fromArray(p.rgba),
          position: $.fromObject(i.position)
        });
        return D._edited = !0, D;
      });
    }
  }]);

  return va;
}(_a),
    Jh = va;

va.version = "3.9.0";

var ep = Math.PI * 2,
    Ca =
/*#__PURE__*/
function (_ba) {
  _inherits(Ca, _ba);

  function Ca() {
    _classCallCheck(this, Ca);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ca).apply(this, arguments));
  }

  _createClass(Ca, [{
    key: "_serializeTransformOperation",
    value: function _serializeTransformOperation(e) {
      var t = this._editor.operations;

      if (t.exists("orientation")) {
        e = e.clone();

        var _o50 = t.get("orientation");

        _o50.getFlipVertically() && (e.flip("vertical"), e.setRotation(e.getRotation() * -1)), _o50.getFlipHorizontally() && (e.flip("horizontal"), e.setRotation(e.getRotation() * -1)), e.rotate(-_o50.getRotation());
      }

      var i = e.serializeOptions(["start", "end", "rotation", "textureScale"], !0);
      i.rotation = (i.rotation + ep) % ep, i.textureScale !== 1 && (i.dimensions = e.getNewDimensions(e.getInputDimensions(!1))), delete i.textureScale;
      var r = {
        type: "transform",
        options: i
      };

      if (e._ratio) {
        var _o51;

        e._ratio instanceof Mn ? _o51 = e._ratio.getIdentifier() : _o51 = e._ratio.identifier, r.options.meta = {
          identifier: _o51
        };
      }

      return delete r.options.scale, r;
    }
  }, {
    key: "_serializeText",
    value: function _serializeText(e, t) {
      var i = e.getInputDimensions(!1),
          r = _get(_getPrototypeOf(Ca.prototype), "_serializeText", this).call(this, e, t);

      return r.options.fontSize = r.options.fontSize * i.y / i.min(), r;
    }
  }]);

  return Ca;
}(ba),
    tp = Ca;

Ca.version = "3.9.0";

var ip =
/*#__PURE__*/
function (_Ns) {
  _inherits(ip, _Ns);

  function ip(e, t, i) {
    var _this244;

    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

    _classCallCheck(this, ip);

    _this244 = _possibleConstructorReturn(this, _getPrototypeOf(ip).call(this));
    _this244._ui = e, _this244._options = t, _this244._mediator = i, _this244._shallow = r, r || (_this244._initSDK(), _this244.operations = new Uh(_assertThisInitialized(_assertThisInitialized(_this244)), _this244._sdk, _this244._mediator));
    return _this244;
  }

  _createClass(ip, [{
    key: "_initFonts",
    value: function _initFonts() {
      var e = oe.defaults(this._options.editor.controlsOptions.text, {
        additionalFonts: [],
        replaceFonts: !1,
        availableVariations: null
      });
      this._fontManager = new st(this._ui, e);

      var t = this._fontManager.getFonts(),
          i = this._ui.getFontLoader();

      i.setFonts(t), i.load();
    }
  }, {
    key: "setImage",
    value: function setImage() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._options.editor.image;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      t && this.reset();
      var i = null;
      i = this._sdk.parseExif(e), this._setImage(e, i), this._initWatermark();
    }
  }, {
    key: "_initWatermark",
    value: function _initWatermark() {
      this._options.editor.watermarkImage && (this._watermarkOperation = this.operations.getOrCreate("watermark", {
        image: this._options.editor.watermarkImage
      }));
    }
  }, {
    key: "_initSDK",
    value: function _initSDK() {
      var _this$_options41 = this._options,
          e = _this$_options41.logLevel,
          t = _this$_options41.displayWelcomeMessage,
          i = _this$_options41.debug,
          r = _this$_options41.license,
          o = _this$_options41.crossOrigin,
          _this$_options$editor = this._options.editor,
          n = _this$_options$editor.smoothDownscaling,
          a = _this$_options$editor.smoothUpscaling,
          l = _this$_options$editor.preferredRenderer,
          c = _this$_options$editor.pixelRatio,
          u = _this$_options$editor.transparent,
          p = _this$_options$editor.clearColor,
          h;
      Array.isArray(p) ? h = ie.fromArray(p) : typeof p == "string" ? h = ie.fromHex(p) : p instanceof ie && (h = p.clone());
      var d = {
        logLevel: e,
        debug: i,
        displayWelcomeMessage: t,
        pixelRatio: c,
        smoothDownscaling: n,
        smoothUpscaling: a,
        transparent: u,
        crossOrigin: o,
        clearColor: h,
        license: r
      };
      this._sdk = new W(l, d);
    }
  }, {
    key: "getMaxMegapixels",
    value: function getMaxMegapixels() {
      var e = this._options.editor.maxMegaPixels;
      return e;
    }
  }, {
    key: "getCrossOrigin",
    value: function getCrossOrigin() {
      return oe.getCrossOriginValue(this._options.crossOrigin || "anonymous");
    }
  }, {
    key: "getOutputDimensions",
    value: function getOutputDimensions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this._sdk.getOutputDimensions(e);
    }
  }, {
    key: "getOutputTextureDimensions",
    value: function getOutputTextureDimensions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this._sdk.getOutputTextureDimensions(e);
    }
  }, {
    key: "getFinalDimensions",
    value: function getFinalDimensions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this._sdk.getFinalDimensions(e);
    }
  }, {
    key: "_setImage",
    value: function _setImage() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._options.editor.image;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this._sdk.setAllOperationsToDirty(), this._options.editor.image = e, this._sdk.setImage(e, t);
    }
  }, {
    key: "_ensureImageIsResized",
    value: function _ensureImageIsResized() {
      var _this245 = this;

      var e = this._sdk.getImage(),
          t = this._sdk.getRenderer(),
          i = this.getMaxMegapixels(),
          r = i ? i * 1e6 : null,
          o = t.getMaxDimensions(),
          n = new Nh(e, r, o);

      return !this._resizedImage && n.needsResize() ? n.resize().then(function (_ref45) {
        var a = _ref45.canvas,
            l = _ref45.dimensions,
            c = _ref45.reason;
        return _this245._resizedImage = a, _this245._sdk.setImage(a), a;
      }) : Promise.resolve(e);
    }
  }, {
    key: "export",
    value: function _export() {
      var _this246 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this._watermarkOperation && this._watermarkOperation.setEnabled(!1), this._sdk.setAllOperationsToDirty(), this._ensureImageIsResized().then(function (t) {
        var i = _this246._options.editor.export;
        return new zh(_this246._sdk, i, e).export().then(function (o) {
          return _this246.emit("export", o), _this246._mediator.emit(de.EVENTS.EXPORT, o, _this246), _this246._watermarkOperation && (_this246._watermarkOperation.setEnabled(!0), _this246._sdk.render()), _this246._sdk.setAllOperationsToDirty(), o;
        });
      });
    }
  }, {
    key: "broadcastTransform",
    value: function broadcastTransform(e, t) {
      var _this247 = this;

      var i = new W.Operations.TransformOperation.TransformChange(e, t);
      ["sprite", "selective-blur", "radial-focus", "mirrored-focus", "linear-focus", "blur"].forEach(function (o) {
        var n = _this247.operations.get(o);

        !n || n.transform(i);
      });
    }
  }, {
    key: "broadcastFlip",
    value: function broadcastFlip(e) {
      var _this248 = this;

      ["mirrored-focus", "radial-focus", "linear-focus", "sprite", "selective-blur"].forEach(function (i) {
        var r = _this248.operations.get(i);

        !r || r.flip(e);
      });
    }
  }, {
    key: "broadcastRotate",
    value: function broadcastRotate(e) {
      var _this249 = this;

      ["transform", "mirrored-focus", "linear-focus", "radial-focus", "sprite", "selective-blur"].forEach(function (i) {
        var r = _this249.operations.get(i);

        !r || r.rotate(e);
      });
    }
  }, {
    key: "_initSerializers",
    value: function _initSerializers() {
      this._serializers = {
        "1.0.0": Mr().default,
        "1.0.1": Lr().default,
        "2.0.0": Nr().default,
        "3.0.0": Gr().default,
        "3.1.0": Wr().default,
        "3.2.0": Vr().default,
        "3.4.0": Hr().default,
        "3.5.0": jr().default,
        "3.6.0": Yr().default,
        "3.7.0": qr().default,
        "3.8.0": Kr().default,
        "3.9.0": Xr().default
      };
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "3.9.0";
      var i = this._serializers[t];
      return i ? new i(this).serialize(e) : Promise.reject(new Error("No serializer for version ".concat(t, " found.")));
    }
  }, {
    key: "deserialize",
    value: function deserialize(e) {
      var t = this._serializers[e.version];
      return t ? new t(this).deserialize(e) : Promise.reject(new Error("No serializer for version ".concat(e.version, " found.")));
    }
  }, {
    key: "save",
    value: function save() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = this._options.editor.save;
      return this.serialize({
        image: t
      }).then(function (r) {
        var o = JSON.stringify(r, null, 2);

        if (e) {
          var _n35 = "data:text/json;charset=utf-8;base64,".concat(window.encodeURI(window.btoa(o)));

          Gs.downloadDataURL(_n35, i.fileBasename);
        }

        return o;
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this._sdk.reset(), this.operations.reset();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.stop(), this._sdk.dispose();
    }
  }, {
    key: "getRenderer",
    value: function getRenderer() {
      return this._sdk.getRenderer();
    }
  }, {
    key: "getSDK",
    value: function getSDK() {
      return this._sdk;
    }
  }, {
    key: "getInputDimensions",
    value: function getInputDimensions() {
      return this._sdk.getInputDimensions();
    }
  }, {
    key: "getImage",
    value: function getImage() {
      return this._sdk.getImage();
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this._options;
    }
  }, {
    key: "getUI",
    value: function getUI() {
      return this._ui;
    }
  }, {
    key: "getMediator",
    value: function getMediator() {
      return this._mediator;
    }
  }]);

  return ip;
}(Ns),
    rp = ip;

var Qr = function Qr(s) {
  return oe.byteArrayToString(un.decode(s));
},
    bi =
/*#__PURE__*/
function (_Ns2) {
  _inherits(bi, _Ns2);

  function bi() {
    var _this250;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, bi);

    _this250 = _possibleConstructorReturn(this, _getPrototypeOf(bi).call(this));
    _this250._mediator = new Ns(), _this250._fontLoader = new Or(_assertThisInitialized(_assertThisInitialized(_this250))), _this250._options = e, _this250._initOptions(), _this250._initEvents(), _this250._disposed = !1, _this250._isReady = !1, _this250._editor = new rp(_assertThisInitialized(_assertThisInitialized(_this250)), _this250._options, _this250._mediator), _this250._options.editor.image && _this250._editor.setImage(_this250._options.editor.image), _this250._mediator.once(de.EVENTS.EDITOR_READY, function () {
      _this250._isReady = !0;
    }), A.setLevel(_this250._options.logLevel), _this250._v();
    return _this250;
  }

  _createClass(bi, [{
    key: "export",
    value: function _export() {
      var _this$_editor;

      return (_this$_editor = this._editor).export.apply(_this$_editor, arguments);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var _this$_editor2;

      return (_this$_editor2 = this._editor).serialize.apply(_this$_editor2, arguments);
    }
  }, {
    key: "deserialize",
    value: function deserialize(e) {
      return this._editor.deserialize(e);
    }
  }, {
    key: "getEditor",
    value: function getEditor() {
      return this._editor;
    }
  }, {
    key: "isReady",
    value: function isReady() {
      return this._isReady;
    }
  }, {
    key: "onReady",
    value: function onReady(e) {
      this._isReady ? e() : this._mediator.once(de.EVENTS.EDITOR_READY, e);
    }
  }, {
    key: "createFilter",
    value: function createFilter(e) {
      return new dn(this, this._getOptions("filter")).instantiateFilterWithIdentifier(e);
    }
  }, {
    key: "getTextDesignLayoutByID",
    value: function getTextDesignLayoutByID(e) {
      var t = new zt(this, this._getOptions("textDesign"));
      return new (t.getLayoutByIdentifier(e))();
    }
  }, {
    key: "getTextDesignAssetManager",
    value: function getTextDesignAssetManager() {
      return W.Operations.SpriteOperation.TextDesignSprite.AssetManager;
    }
  }, {
    key: "getTextDesignFontManager",
    value: function getTextDesignFontManager() {
      return new st(this, {
        fonts: de.DEFAULTS.TEXT_DESIGN_FONTS,
        replaceFonts: !0,
        isTextDesign: !0
      });
    }
  }, {
    key: "_getOptions",
    value: function _getOptions(e) {
      var t = this.getEditor(),
          i = t.controls,
          r = {};
      i && i.get(e) && (r = i.get(e).defaultOptions);
      var o = t.getOptions();
      return oe.deepDefaults({}, o.editor.controlsOptions[e] || {}, r);
    }
  }, {
    key: "_initOptions",
    value: function _initOptions() {
      if (this._options = oe.defaults(this._options, {
        language: "en",
        logLevel: "warn",
        crossOrigin: "anonymous",
        editor: {},
        assets: {},
        responsive: !1,
        preloader: !0,
        autoRun: !0
      }), this._options.editor = oe.defaults(this._options.editor || {}, {
        enableZoom: !0,
        enableDrag: !0,
        enableExport: !0,
        enableKeyboardControls: !0,
        enablePositionSnapping: !0,
        enableRotationSnapping: !0,
        enableSave: !1,
        enableLoad: !1,
        pixelRatio: typeof window != "undefined" && window.devicePixelRatio || 1,
        preferredRenderer: "webgl",
        transparent: !0,
        clearColor: [0, 0, 0, 0],
        displayResizeMessage: !0,
        maxMegaPixels: {},
        displayCloseButton: !1,
        undoMode: "global",
        defaultControl: "filter",
        forceCrop: !1,
        snappingOptions: {},
        tools: ["transform", "filter", "adjustments", "focus", "text", "textdesign", "sticker", "brush", "frame", "overlay", "library", "artfilter"],
        controlsOrder: [["library"], ["artfilter", "transform", "filter", "adjustments", "focus"], ["text", "textdesign", "sticker", "brush", "frame", "overlay"]],
        operationsOrder: ["exif-orientation", "artfilter", "orientation", "transform", "filter", "adjustments", "radial-focus", "mirrored-focus", "linear-focus", "blur", "selective-blur", "overlay", "sprite", "frame", "watermark"],
        controlsOptions: {
          focus: {
            highQualityCanvasBlur: !1
          }
        }
      }), this._options.editor.snappingOptions = oe.defaults(this._options.editor.snappingOptions, {
        position: {},
        rotation: {}
      }), this._options.editor.snappingOptions.position = oe.defaults(this._options.editor.snappingOptions.position, {
        padding: {},
        threshold: 20
      }), this._options.editor.snappingOptions.position.padding = oe.defaults(this._options.editor.snappingOptions.position.padding, {
        left: .1,
        right: .1,
        top: .1,
        bottom: .1
      }), this._options.editor.snappingOptions.rotation = oe.defaults(this._options.editor.snappingOptions.rotation, {
        angles: [0, 45, 90, 135, 180, 225, 270, 315],
        threshold: 20
      }), this._options.editor.controlsOptions.focus = oe.defaults(this._options.editor.controlsOptions.focus, {
        highQualityCanvasBlur: !1
      }), this._options.editor.maxMegaPixels = oe.defaults(this._options.editor.maxMegaPixels, {
        mobile: 5,
        desktop: 10
      }), this._options.editor.export = oe.defaults(this._options.editor.export || {}, {
        format: "image/png",
        type: yi.IMAGE,
        download: !0,
        fileBasename: "photoeditorsdk-export",
        quality: .8
      }), this._options.editor.save = oe.defaults(this._options.editor.save || {}, {
        format: "text/json",
        download: !0,
        fileBasename: "photoeditorsdk-save"
      }), this._options.extensions = oe.defaults(this._options.extensions || {}, {
        languages: {},
        operations: [],
        controls: []
      }), this._options.assets = oe.defaults(this._options.assets || {}, {
        baseUrl: "assets",
        resolver: null
      }), !(this._options.editor.image instanceof window.Image)) {
        var _e23 = new window.Image();

        this._options.editor.image && (_e23.src = this._options.editor.image, this._options.editor.image = _e23);
      }
    }
  }, {
    key: "_v",
    value: function _v() {
      return this[Qr("X29wdGlvbnM=")][Qr("bGljZW5zZQ==")] ? !0 : (A.error(Qr("TGljZW5zaW5n"), Qr("Tm8gYGxpY2Vuc2VgIG9wdGlvbiBnaXZlbg==")), A.error(Qr("TGljZW5zaW5n"), Qr("SW4gY2FzZSB5b3UgZG9uJ3QgaGF2ZSBhIGxpY2Vuc2UgeWV0LCBwbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tIHRvIG9idGFpbiBhIGxpY2Vuc2Ugb3IgbG9nIGluIHRvIHlvdXIgY3VzdG9tZXIgZGFzaGJvYXJkLg==")), !1);
    }
  }, {
    key: "_initEvents",
    value: function _initEvents() {
      this._mediator.pipeEvents(this);
    }
  }, {
    key: "_disposeEvents",
    value: function _disposeEvents() {
      this._mediator.unpipeEvents(this);
    }
  }, {
    key: "setImage",
    value: function setImage(e) {
      this._editor.setImage(e);
    }
  }, {
    key: "getAssetPath",
    value: function getAssetPath(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var _this$_options$assets = this._options.assets,
          r = _this$_options$assets.baseUrl,
          o = _this$_options$assets.resolver,
          n = "".concat(r, "/").concat(e);
      o = o || function (u) {
        return u;
      }, e.match(/(ftp|http|https):\/\//) && (n = e);
      var a = e.replace(/assets\//, "").split("/"),
          l = a[0],
          c = {};

      switch (l) {
        case "art-filters":
          return c = {
            identifier: a[1],
            type: a[2].split(".")[0]
          }, o("art-filter", c);

        case "filters":
          return c = {
            identifier: a[1].replace(/\.png$/g, "")
          }, o("filter", c);

        case "fonts":
          return c = {
            identifier: a[1].replace(/\.(woff|otf|ttf)$/g, "")
          }, o("font", c);

        case "frames":
          return c = {
            identifier: a[1],
            filename: a[2]
          }, o("frame", c);

        case "overlays":
          return c = {
            identifier: a[1].replace(/\.(png|jpg|jpeg)$/g, "")
          }, o("overlay", c);

        case "stickers":
          {
            var _u27 = a[3].endsWith(".svg"),
                _p26 = a[3] === "thumbs";

            return c = {
              category: a[1],
              identifier: (_u27 ? a[3] : a[4]).replace(/\.(png|svg)$/g, ""),
              variant: _u27 ? "svg" : _p26 ? "thumb" : "base"
            }, o("sticker", c);
          }

        case "text-design":
          return c = {
            type: a[1] === "fonts" ? "font" : "image",
            identifier: a[2].replace(/\.(png|otf|ttf|woff2?)$/g, "")
          }, o("text-design", c);
      }

      return typeof o != "undefined" && o !== null && (n = o(n)), n;
    }
  }, {
    key: "getFontLoader",
    value: function getFontLoader() {
      return this._fontLoader;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._disposed) throw new Error("This instance of PhotoEditorSDK is already disposed.");
      this._disposed = !0, this._disposeEvents();
    }
  }, {
    key: "render",
    value: function render(e) {
      var _this251 = this;

      return this.deserialize(e).then(function () {
        return _this251.export();
      });
    }
  }]);

  return bi;
}(Ns);

bi.prototype.identifier = "engine-wrapper";
bi.Constants = de;
bi.Events = de.EVENTS;
bi.Utils = Ke;
bi.JSONLoader = Rt;
bi.SDK = W;
var eu;

(function (s) {
  s.BEGAN_IMAGE_DOWNSCALING = "beganImageDownscaling", s.IMAGE_DOWNSCALED = "imageDownscaled";
})(eu || (eu = {}));

var eV = W.Operations.OverlayOperation.BLEND_MODES;
export { Ci as a, Jr as b, Ki as c, Ge as d, Hs as e, js as f, ou as g, au as h, ze as i, P as j, vi as k, De as l, Re as m, nu as n, eu as o, g0 as p, es as q, $r as r, ru as s, G0 as t, Se as u, wi as v, v0 as w, E0 as x, yt as y, ue as z, np as A, su as B, iu as C, k0 as D, M0 as E, lu as F, lp as G, ka as H, C as I, Ky as J, W as K, Ce as L, bi as M, we as N, Ct as O, Te as P, up as Q, dp as R, Tt as S, mt as T, eV as U, ot as V };
/*
 * Based on https://github.com/exif-js/exif-js by Jacob Seidelin
 * Licensed under MIT
 * @license
 */

/*
 * Extracted from MinifyJpeg (Copyright (c) 2014 Hiroaki Matoba, MIT License):
 * https://github.com/hMatoba/MinifyJpeg
 * @license
 */

/*
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 * MIT license
 * @license
 */

/*!
 *  Secure Hash Algorithm (SHA256)
 *  http://www.webtoolkit.info/
 *
 *  Original code by Angel Marin, Paul Johnston.
 */

/*!
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */

/*!
StackBlur - a fast almost Gaussian Blur For Canvas

Version:  0.5
Author:   Mario Klingemann
Contact:  mario@quasimondo.com
Website:  http://www.quasimondo.com/StackBlurForCanvas
Twitter:  @quasimondo

In case you find this class useful - especially in commercial projects -
I am not totally unhappy for a small donation to my PayPal account
mario@quasimondo.de

Or support me on flattr:
https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript

Copyright (c) 2010 Mario Klingemann

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.
@license
*/